
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree126"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree126"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2sN1e", function(module, exports) {

$parcel$export(module.exports, "ADDRESS", function () { return $68aec2772563966a$export$13e35b21ad6ab4fe; }, function (v) { return $68aec2772563966a$export$13e35b21ad6ab4fe = v; });
$parcel$export(module.exports, "AI_CITATIONS", function () { return $68aec2772563966a$export$b60c5e9f9b7b58bd; }, function (v) { return $68aec2772563966a$export$b60c5e9f9b7b58bd = v; });
$parcel$export(module.exports, "AI_COMPLETION_TOKENS_USED", function () { return $68aec2772563966a$export$cc06afd6de7f2c10; }, function (v) { return $68aec2772563966a$export$cc06afd6de7f2c10 = v; });
$parcel$export(module.exports, "AI_DOCUMENTS", function () { return $68aec2772563966a$export$ced6746028fe2cc; }, function (v) { return $68aec2772563966a$export$ced6746028fe2cc = v; });
$parcel$export(module.exports, "AI_FINISH_REASON", function () { return $68aec2772563966a$export$e6f4aa4f4fcb6da8; }, function (v) { return $68aec2772563966a$export$e6f4aa4f4fcb6da8 = v; });
$parcel$export(module.exports, "AI_FREQUENCY_PENALTY", function () { return $68aec2772563966a$export$f02d892201cd8d36; }, function (v) { return $68aec2772563966a$export$f02d892201cd8d36 = v; });
$parcel$export(module.exports, "AI_FUNCTION_CALL", function () { return $68aec2772563966a$export$f277a7ef9e273960; }, function (v) { return $68aec2772563966a$export$f277a7ef9e273960 = v; });
$parcel$export(module.exports, "AI_GENERATION_ID", function () { return $68aec2772563966a$export$1a8c212c3becaa80; }, function (v) { return $68aec2772563966a$export$1a8c212c3becaa80 = v; });
$parcel$export(module.exports, "AI_INPUT_MESSAGES", function () { return $68aec2772563966a$export$721b137086c68a47; }, function (v) { return $68aec2772563966a$export$721b137086c68a47 = v; });
$parcel$export(module.exports, "AI_IS_SEARCH_REQUIRED", function () { return $68aec2772563966a$export$6afde2bb69d9aa86; }, function (v) { return $68aec2772563966a$export$6afde2bb69d9aa86 = v; });
$parcel$export(module.exports, "AI_METADATA", function () { return $68aec2772563966a$export$eadb4b562c974031; }, function (v) { return $68aec2772563966a$export$eadb4b562c974031 = v; });
$parcel$export(module.exports, "AI_MODEL_ID", function () { return $68aec2772563966a$export$22a90f0ac1eee843; }, function (v) { return $68aec2772563966a$export$22a90f0ac1eee843 = v; });
$parcel$export(module.exports, "AI_MODEL_PROVIDER", function () { return $68aec2772563966a$export$a727f215a0be1dad; }, function (v) { return $68aec2772563966a$export$a727f215a0be1dad = v; });
$parcel$export(module.exports, "AI_PIPELINE_NAME", function () { return $68aec2772563966a$export$536bc61b34d995e5; }, function (v) { return $68aec2772563966a$export$536bc61b34d995e5 = v; });
$parcel$export(module.exports, "AI_PREAMBLE", function () { return $68aec2772563966a$export$c43ea6115b380e62; }, function (v) { return $68aec2772563966a$export$c43ea6115b380e62 = v; });
$parcel$export(module.exports, "AI_PRESENCE_PENALTY", function () { return $68aec2772563966a$export$d2a16e26bada7cf1; }, function (v) { return $68aec2772563966a$export$d2a16e26bada7cf1 = v; });
$parcel$export(module.exports, "AI_PROMPT", function () { return $68aec2772563966a$export$877414c19c336240; }, function (v) { return $68aec2772563966a$export$877414c19c336240 = v; });
$parcel$export(module.exports, "AI_PROMPT_MESSAGES", function () { return $68aec2772563966a$export$1498f8372e4fee19; }, function (v) { return $68aec2772563966a$export$1498f8372e4fee19 = v; });
$parcel$export(module.exports, "AI_PROMPT_TOKENS_USED", function () { return $68aec2772563966a$export$604eb1bd2278163b; }, function (v) { return $68aec2772563966a$export$604eb1bd2278163b = v; });
$parcel$export(module.exports, "AI_PROMPT_TOOLS", function () { return $68aec2772563966a$export$c6fb15d10a4d52fb; }, function (v) { return $68aec2772563966a$export$c6fb15d10a4d52fb = v; });
$parcel$export(module.exports, "AI_RAW_PROMPTING", function () { return $68aec2772563966a$export$2f8568696c5aa352; }, function (v) { return $68aec2772563966a$export$2f8568696c5aa352 = v; });
$parcel$export(module.exports, "AI_RESPONSES", function () { return $68aec2772563966a$export$ccc8efd7dd31d3a9; }, function (v) { return $68aec2772563966a$export$ccc8efd7dd31d3a9 = v; });
$parcel$export(module.exports, "AI_RESPONSE_FORMAT", function () { return $68aec2772563966a$export$e176bf5dc45e40df; }, function (v) { return $68aec2772563966a$export$e176bf5dc45e40df = v; });
$parcel$export(module.exports, "AI_RESPONSE_ID", function () { return $68aec2772563966a$export$2d16fe6a423eac16; }, function (v) { return $68aec2772563966a$export$2d16fe6a423eac16 = v; });
$parcel$export(module.exports, "AI_RESPONSE_MODEL", function () { return $68aec2772563966a$export$40c10cc901ec8391; }, function (v) { return $68aec2772563966a$export$40c10cc901ec8391 = v; });
$parcel$export(module.exports, "AI_RESPONSE_OBJECT", function () { return $68aec2772563966a$export$e1b5b90d002f47d3; }, function (v) { return $68aec2772563966a$export$e1b5b90d002f47d3 = v; });
$parcel$export(module.exports, "AI_RESPONSE_TEXT", function () { return $68aec2772563966a$export$8028cf93afd5c238; }, function (v) { return $68aec2772563966a$export$8028cf93afd5c238 = v; });
$parcel$export(module.exports, "AI_RESPONSE_TIMESTAMP", function () { return $68aec2772563966a$export$5cd566e59be6c821; }, function (v) { return $68aec2772563966a$export$5cd566e59be6c821 = v; });
$parcel$export(module.exports, "AI_RESPONSE_TOOLCALLS", function () { return $68aec2772563966a$export$388cc595db1f932c; }, function (v) { return $68aec2772563966a$export$388cc595db1f932c = v; });
$parcel$export(module.exports, "AI_SCHEMA", function () { return $68aec2772563966a$export$a936650e1567c02b; }, function (v) { return $68aec2772563966a$export$a936650e1567c02b = v; });
$parcel$export(module.exports, "AI_SEARCH_QUERIES", function () { return $68aec2772563966a$export$c4ea01fd53f64e16; }, function (v) { return $68aec2772563966a$export$c4ea01fd53f64e16 = v; });
$parcel$export(module.exports, "AI_SEARCH_RESULTS", function () { return $68aec2772563966a$export$bb5e6f2f31a15da9; }, function (v) { return $68aec2772563966a$export$bb5e6f2f31a15da9 = v; });
$parcel$export(module.exports, "AI_SEED", function () { return $68aec2772563966a$export$1762c11b666b026a; }, function (v) { return $68aec2772563966a$export$1762c11b666b026a = v; });
$parcel$export(module.exports, "AI_STREAMING", function () { return $68aec2772563966a$export$14ddd4b729910100; }, function (v) { return $68aec2772563966a$export$14ddd4b729910100 = v; });
$parcel$export(module.exports, "AI_TAGS", function () { return $68aec2772563966a$export$5311d7c8e1f8eabb; }, function (v) { return $68aec2772563966a$export$5311d7c8e1f8eabb = v; });
$parcel$export(module.exports, "AI_TEMPERATURE", function () { return $68aec2772563966a$export$2b748b9eca00828b; }, function (v) { return $68aec2772563966a$export$2b748b9eca00828b = v; });
$parcel$export(module.exports, "AI_TEXTS", function () { return $68aec2772563966a$export$5af25308c11addea; }, function (v) { return $68aec2772563966a$export$5af25308c11addea = v; });
$parcel$export(module.exports, "AI_TOOLCALL_ARGS", function () { return $68aec2772563966a$export$a51938f8e97cb2e; }, function (v) { return $68aec2772563966a$export$a51938f8e97cb2e = v; });
$parcel$export(module.exports, "AI_TOOLCALL_RESULT", function () { return $68aec2772563966a$export$6fe9e1ed3c313f24; }, function (v) { return $68aec2772563966a$export$6fe9e1ed3c313f24 = v; });
$parcel$export(module.exports, "AI_TOOLS", function () { return $68aec2772563966a$export$28f78b3b1663cb92; }, function (v) { return $68aec2772563966a$export$28f78b3b1663cb92 = v; });
$parcel$export(module.exports, "AI_TOOL_CALLS", function () { return $68aec2772563966a$export$a1d3f09f0f1f066f; }, function (v) { return $68aec2772563966a$export$a1d3f09f0f1f066f = v; });
$parcel$export(module.exports, "AI_TOP_K", function () { return $68aec2772563966a$export$322bd4ea9f163663; }, function (v) { return $68aec2772563966a$export$322bd4ea9f163663 = v; });
$parcel$export(module.exports, "AI_TOP_P", function () { return $68aec2772563966a$export$95711b9e669edad8; }, function (v) { return $68aec2772563966a$export$95711b9e669edad8 = v; });
$parcel$export(module.exports, "AI_TOTAL_COST", function () { return $68aec2772563966a$export$5924d7d72384626a; }, function (v) { return $68aec2772563966a$export$5924d7d72384626a = v; });
$parcel$export(module.exports, "AI_TOTAL_TOKENS_USED", function () { return $68aec2772563966a$export$db3b1b877a4ce4db; }, function (v) { return $68aec2772563966a$export$db3b1b877a4ce4db = v; });
$parcel$export(module.exports, "AI_USAGE_TOKENS", function () { return $68aec2772563966a$export$8fbf006bb94d3322; }, function (v) { return $68aec2772563966a$export$8fbf006bb94d3322 = v; });
$parcel$export(module.exports, "AI_VALUES", function () { return $68aec2772563966a$export$32ce2b08edad22f; }, function (v) { return $68aec2772563966a$export$32ce2b08edad22f = v; });
$parcel$export(module.exports, "AI_WARNINGS", function () { return $68aec2772563966a$export$a434a3e8afec2879; }, function (v) { return $68aec2772563966a$export$a434a3e8afec2879 = v; });
$parcel$export(module.exports, "ANGULAR_VERSION", function () { return $68aec2772563966a$export$fe00bb20636d42af; }, function (v) { return $68aec2772563966a$export$fe00bb20636d42af = v; });
$parcel$export(module.exports, "APP_APP_BUILD", function () { return $68aec2772563966a$export$712aa698b7ee271e; }, function (v) { return $68aec2772563966a$export$712aa698b7ee271e = v; });
$parcel$export(module.exports, "APP_APP_IDENTIFIER", function () { return $68aec2772563966a$export$1fac638b11ec16d9; }, function (v) { return $68aec2772563966a$export$1fac638b11ec16d9 = v; });
$parcel$export(module.exports, "APP_APP_NAME", function () { return $68aec2772563966a$export$d132016ea64058e3; }, function (v) { return $68aec2772563966a$export$d132016ea64058e3 = v; });
$parcel$export(module.exports, "APP_APP_START_TIME", function () { return $68aec2772563966a$export$53f2f47ec3b2f9ed; }, function (v) { return $68aec2772563966a$export$53f2f47ec3b2f9ed = v; });
$parcel$export(module.exports, "APP_APP_VERSION", function () { return $68aec2772563966a$export$9f80c4b11053cef1; }, function (v) { return $68aec2772563966a$export$9f80c4b11053cef1 = v; });
$parcel$export(module.exports, "APP_BUILD", function () { return $68aec2772563966a$export$5f7a08466d84e877; }, function (v) { return $68aec2772563966a$export$5f7a08466d84e877 = v; });
$parcel$export(module.exports, "APP_IDENTIFIER", function () { return $68aec2772563966a$export$2cea7f14750b8c19; }, function (v) { return $68aec2772563966a$export$2cea7f14750b8c19 = v; });
$parcel$export(module.exports, "APP_IN_FOREGROUND", function () { return $68aec2772563966a$export$34c59270f032a6c6; }, function (v) { return $68aec2772563966a$export$34c59270f032a6c6 = v; });
$parcel$export(module.exports, "APP_NAME", function () { return $68aec2772563966a$export$5b6c28c7dca07ad7; }, function (v) { return $68aec2772563966a$export$5b6c28c7dca07ad7 = v; });
$parcel$export(module.exports, "APP_START_COLD", function () { return $68aec2772563966a$export$1dc8ae58b58d6c50; }, function (v) { return $68aec2772563966a$export$1dc8ae58b58d6c50 = v; });
$parcel$export(module.exports, "APP_START_TIME", function () { return $68aec2772563966a$export$ba267414e3c0d822; }, function (v) { return $68aec2772563966a$export$ba267414e3c0d822 = v; });
$parcel$export(module.exports, "APP_START_TYPE", function () { return $68aec2772563966a$export$71b176005902b99e; }, function (v) { return $68aec2772563966a$export$71b176005902b99e = v; });
$parcel$export(module.exports, "APP_START_WARM", function () { return $68aec2772563966a$export$5c5b5a3c245a0079; }, function (v) { return $68aec2772563966a$export$5c5b5a3c245a0079 = v; });
$parcel$export(module.exports, "APP_VERSION", function () { return $68aec2772563966a$export$8ee1df3c6367a60; }, function (v) { return $68aec2772563966a$export$8ee1df3c6367a60 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_DELAY_VALUE", function () { return $68aec2772563966a$export$e8c7802ae95beccf; }, function (v) { return $68aec2772563966a$export$e8c7802ae95beccf = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_FROZEN_COUNT", function () { return $68aec2772563966a$export$bb237734da4d464; }, function (v) { return $68aec2772563966a$export$bb237734da4d464 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_FROZEN_RATE", function () { return $68aec2772563966a$export$e8f43f7d235efa53; }, function (v) { return $68aec2772563966a$export$e8f43f7d235efa53 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_SLOW_COUNT", function () { return $68aec2772563966a$export$cdaaf6d1fdcba0b6; }, function (v) { return $68aec2772563966a$export$cdaaf6d1fdcba0b6 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_SLOW_RATE", function () { return $68aec2772563966a$export$be392f76344cb225; }, function (v) { return $68aec2772563966a$export$be392f76344cb225 = v; });
$parcel$export(module.exports, "APP_VITALS_FRAMES_TOTAL_COUNT", function () { return $68aec2772563966a$export$36223ebd4a30e9f5; }, function (v) { return $68aec2772563966a$export$36223ebd4a30e9f5 = v; });
$parcel$export(module.exports, "APP_VITALS_STALL_DURATION", function () { return $68aec2772563966a$export$d4496a3605a4ce4a; }, function (v) { return $68aec2772563966a$export$d4496a3605a4ce4a = v; });
$parcel$export(module.exports, "APP_VITALS_STALL_PERCENTAGE", function () { return $68aec2772563966a$export$daee97894fa9844; }, function (v) { return $68aec2772563966a$export$daee97894fa9844 = v; });
$parcel$export(module.exports, "APP_VITALS_START_COLD_VALUE", function () { return $68aec2772563966a$export$8feaa177bb7941e2; }, function (v) { return $68aec2772563966a$export$8feaa177bb7941e2 = v; });
$parcel$export(module.exports, "APP_VITALS_START_PREWARMED", function () { return $68aec2772563966a$export$e1ca25240db91d68; }, function (v) { return $68aec2772563966a$export$e1ca25240db91d68 = v; });
$parcel$export(module.exports, "APP_VITALS_START_REASON", function () { return $68aec2772563966a$export$404a223fd1ada08b; }, function (v) { return $68aec2772563966a$export$404a223fd1ada08b = v; });
$parcel$export(module.exports, "APP_VITALS_START_SCREEN", function () { return $68aec2772563966a$export$53362079310c68; }, function (v) { return $68aec2772563966a$export$53362079310c68 = v; });
$parcel$export(module.exports, "APP_VITALS_START_TYPE", function () { return $68aec2772563966a$export$3efb5af0ac379f77; }, function (v) { return $68aec2772563966a$export$3efb5af0ac379f77 = v; });
$parcel$export(module.exports, "APP_VITALS_START_WARM_VALUE", function () { return $68aec2772563966a$export$2c10c1ca0612c46d; }, function (v) { return $68aec2772563966a$export$2c10c1ca0612c46d = v; });
$parcel$export(module.exports, "APP_VITALS_TTFD_VALUE", function () { return $68aec2772563966a$export$bbb86ad4d6654da6; }, function (v) { return $68aec2772563966a$export$bbb86ad4d6654da6 = v; });
$parcel$export(module.exports, "APP_VITALS_TTID_VALUE", function () { return $68aec2772563966a$export$ad6896f00a2b1076; }, function (v) { return $68aec2772563966a$export$ad6896f00a2b1076 = v; });
$parcel$export(module.exports, "ART_GC_BLOCKING_COUNT", function () { return $68aec2772563966a$export$300f39d8506a273d; }, function (v) { return $68aec2772563966a$export$300f39d8506a273d = v; });
$parcel$export(module.exports, "ART_GC_BLOCKING_TIME", function () { return $68aec2772563966a$export$ecaa0e7f4773ddc7; }, function (v) { return $68aec2772563966a$export$ecaa0e7f4773ddc7 = v; });
$parcel$export(module.exports, "ART_GC_PRE_OOME_COUNT", function () { return $68aec2772563966a$export$74b78acb4c54c06b; }, function (v) { return $68aec2772563966a$export$74b78acb4c54c06b = v; });
$parcel$export(module.exports, "ART_GC_TOTAL_COUNT", function () { return $68aec2772563966a$export$b15b2c133bc50e33; }, function (v) { return $68aec2772563966a$export$b15b2c133bc50e33 = v; });
$parcel$export(module.exports, "ART_GC_TOTAL_TIME", function () { return $68aec2772563966a$export$5f1381d9ae1b1c95; }, function (v) { return $68aec2772563966a$export$5f1381d9ae1b1c95 = v; });
$parcel$export(module.exports, "ART_GC_WAITING_TIME", function () { return $68aec2772563966a$export$c170b7ff277132ea; }, function (v) { return $68aec2772563966a$export$c170b7ff277132ea = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE", function () { return $68aec2772563966a$export$9459a5df93695e45; }, function (v) { return $68aec2772563966a$export$9459a5df93695e45 = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_GC", function () { return $68aec2772563966a$export$a7902bd57492ebe8; }, function (v) { return $68aec2772563966a$export$a7902bd57492ebe8 = v; });
$parcel$export(module.exports, "ART_MEMORY_FREE_UNTIL_OOME", function () { return $68aec2772563966a$export$d2ace0da59da09b7; }, function (v) { return $68aec2772563966a$export$d2ace0da59da09b7 = v; });
$parcel$export(module.exports, "ART_MEMORY_MAX", function () { return $68aec2772563966a$export$c15dd8d2461e0aeb; }, function (v) { return $68aec2772563966a$export$c15dd8d2461e0aeb = v; });
$parcel$export(module.exports, "ART_MEMORY_TOTAL", function () { return $68aec2772563966a$export$5405b0a98e00e538; }, function (v) { return $68aec2772563966a$export$5405b0a98e00e538 = v; });
$parcel$export(module.exports, "ATTRIBUTE_METADATA", function () { return $68aec2772563966a$export$bd393bbb84b309d3; }, function (v) { return $68aec2772563966a$export$bd393bbb84b309d3 = v; });
$parcel$export(module.exports, "ATTRIBUTE_TYPE", function () { return $68aec2772563966a$export$96f586f8837b86ae; }, function (v) { return $68aec2772563966a$export$96f586f8837b86ae = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_GROUP", function () { return $68aec2772563966a$export$5d9f28f388f552d2; }, function (v) { return $68aec2772563966a$export$5d9f28f388f552d2 = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_LOG_STREAM", function () { return $68aec2772563966a$export$b3d2f68e0e769504; }, function (v) { return $68aec2772563966a$export$b3d2f68e0e769504 = v; });
$parcel$export(module.exports, "AWS_CLOUDWATCH_LOGS_URL", function () { return $68aec2772563966a$export$2c98412ed43013e8; }, function (v) { return $68aec2772563966a$export$2c98412ed43013e8 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS", function () { return $68aec2772563966a$export$a7bd794d11c19f1b; }, function (v) { return $68aec2772563966a$export$a7bd794d11c19f1b = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_CONSISTENT_READ", function () { return $68aec2772563966a$export$df4227832b83fdd0; }, function (v) { return $68aec2772563966a$export$df4227832b83fdd0 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_CONSUMED_CAPACITY", function () { return $68aec2772563966a$export$f131a6d8fbc0534f; }, function (v) { return $68aec2772563966a$export$f131a6d8fbc0534f = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_COUNT", function () { return $68aec2772563966a$export$9bdc66d4a70e7e3a; }, function (v) { return $68aec2772563966a$export$9bdc66d4a70e7e3a = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_EXCLUSIVE_START_TABLE", function () { return $68aec2772563966a$export$bfbbc3cbcaa90e98; }, function (v) { return $68aec2772563966a$export$bfbbc3cbcaa90e98 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES", function () { return $68aec2772563966a$export$3565fa72459aa4d6; }, function (v) { return $68aec2772563966a$export$3565fa72459aa4d6 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES", function () { return $68aec2772563966a$export$bb67a834ae4bffdc; }, function (v) { return $68aec2772563966a$export$bb67a834ae4bffdc = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_INDEX_NAME", function () { return $68aec2772563966a$export$4a06c859a283f06; }, function (v) { return $68aec2772563966a$export$4a06c859a283f06 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_ITEM_COLLECTION_METRICS", function () { return $68aec2772563966a$export$68324fac2038d0f2; }, function (v) { return $68aec2772563966a$export$68324fac2038d0f2 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_LIMIT", function () { return $68aec2772563966a$export$5e1bd62ffd2786fb; }, function (v) { return $68aec2772563966a$export$5e1bd62ffd2786fb = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES", function () { return $68aec2772563966a$export$bfdf2261058f56b; }, function (v) { return $68aec2772563966a$export$bfdf2261058f56b = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROJECTION", function () { return $68aec2772563966a$export$23bf57842d9d53df; }, function (v) { return $68aec2772563966a$export$23bf57842d9d53df = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_READ_CAPACITY", function () { return $68aec2772563966a$export$bfbd7e060eeb4d35; }, function (v) { return $68aec2772563966a$export$bfbd7e060eeb4d35 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY", function () { return $68aec2772563966a$export$82eb6cccda27c3ff; }, function (v) { return $68aec2772563966a$export$82eb6cccda27c3ff = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SCANNED_COUNT", function () { return $68aec2772563966a$export$8ea68734d455808f; }, function (v) { return $68aec2772563966a$export$8ea68734d455808f = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SCAN_FORWARD", function () { return $68aec2772563966a$export$40050e29324d44ee; }, function (v) { return $68aec2772563966a$export$40050e29324d44ee = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SEGMENT", function () { return $68aec2772563966a$export$5cd7541006d9f467; }, function (v) { return $68aec2772563966a$export$5cd7541006d9f467 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_SELECT", function () { return $68aec2772563966a$export$81c017edd95d692e; }, function (v) { return $68aec2772563966a$export$81c017edd95d692e = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_COUNT", function () { return $68aec2772563966a$export$120b3897a58cf903; }, function (v) { return $68aec2772563966a$export$120b3897a58cf903 = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TABLE_NAMES", function () { return $68aec2772563966a$export$d4a9de43b4b1076c; }, function (v) { return $68aec2772563966a$export$d4a9de43b4b1076c = v; });
$parcel$export(module.exports, "AWS_DYNAMODB_TOTAL_SEGMENTS", function () { return $68aec2772563966a$export$f37f4f9022f1ab17; }, function (v) { return $68aec2772563966a$export$f37f4f9022f1ab17 = v; });
$parcel$export(module.exports, "AWS_EXTENDED_REQUEST_ID", function () { return $68aec2772563966a$export$66ac18da14747cfb; }, function (v) { return $68aec2772563966a$export$66ac18da14747cfb = v; });
$parcel$export(module.exports, "AWS_KINESIS_STREAM_NAME", function () { return $68aec2772563966a$export$9e49b833525ca49d; }, function (v) { return $68aec2772563966a$export$9e49b833525ca49d = v; });
$parcel$export(module.exports, "AWS_LAMBDA_AWS_REQUEST_ID", function () { return $68aec2772563966a$export$b084fea5b3097227; }, function (v) { return $68aec2772563966a$export$b084fea5b3097227 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS", function () { return $68aec2772563966a$export$e09cd8615652e8d0; }, function (v) { return $68aec2772563966a$export$e09cd8615652e8d0 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_NAME", function () { return $68aec2772563966a$export$a43a60ec723a90ee; }, function (v) { return $68aec2772563966a$export$a43a60ec723a90ee = v; });
$parcel$export(module.exports, "AWS_LAMBDA_FUNCTION_VERSION", function () { return $68aec2772563966a$export$34cc955357266287; }, function (v) { return $68aec2772563966a$export$34cc955357266287 = v; });
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_ARN", function () { return $68aec2772563966a$export$d9dd218693ea9bba; }, function (v) { return $68aec2772563966a$export$d9dd218693ea9bba = v; });
$parcel$export(module.exports, "AWS_LAMBDA_INVOKED_FUNCTION_ARN", function () { return $68aec2772563966a$export$c9649b7156282a2f; }, function (v) { return $68aec2772563966a$export$c9649b7156282a2f = v; });
$parcel$export(module.exports, "AWS_LAMBDA_REMAINING_TIME_IN_MILLIS", function () { return $68aec2772563966a$export$daa8ce1f8adc553e; }, function (v) { return $68aec2772563966a$export$daa8ce1f8adc553e = v; });
$parcel$export(module.exports, "AWS_LOG_GROUP_NAMES", function () { return $68aec2772563966a$export$cb93c7b05db202cf; }, function (v) { return $68aec2772563966a$export$cb93c7b05db202cf = v; });
$parcel$export(module.exports, "AWS_LOG_STREAM_NAMES", function () { return $68aec2772563966a$export$930f9bd3cc2e5b3d; }, function (v) { return $68aec2772563966a$export$930f9bd3cc2e5b3d = v; });
$parcel$export(module.exports, "AWS_OPERATION_NAME", function () { return $68aec2772563966a$export$510ec6f90a56eedb; }, function (v) { return $68aec2772563966a$export$510ec6f90a56eedb = v; });
$parcel$export(module.exports, "AWS_REGION", function () { return $68aec2772563966a$export$e3cc872f2ecbbd04; }, function (v) { return $68aec2772563966a$export$e3cc872f2ecbbd04 = v; });
$parcel$export(module.exports, "AWS_REQUEST_EXTENDED_ID", function () { return $68aec2772563966a$export$48c6d4c44afdc0b; }, function (v) { return $68aec2772563966a$export$48c6d4c44afdc0b = v; });
$parcel$export(module.exports, "AWS_REQUEST_ID", function () { return $68aec2772563966a$export$c78d41789fe4b1e4; }, function (v) { return $68aec2772563966a$export$c78d41789fe4b1e4 = v; });
$parcel$export(module.exports, "AWS_REQUEST_URL", function () { return $68aec2772563966a$export$953d105334798b18; }, function (v) { return $68aec2772563966a$export$953d105334798b18 = v; });
$parcel$export(module.exports, "AWS_S3_BUCKET", function () { return $68aec2772563966a$export$f462d9921f1f7332; }, function (v) { return $68aec2772563966a$export$f462d9921f1f7332 = v; });
$parcel$export(module.exports, "AWS_SECRETSMANAGER_SECRET_ARN", function () { return $68aec2772563966a$export$bc71f8df9a45e243; }, function (v) { return $68aec2772563966a$export$bc71f8df9a45e243 = v; });
$parcel$export(module.exports, "AWS_SNS_TOPIC_ARN", function () { return $68aec2772563966a$export$ed840ec4a5f5d053; }, function (v) { return $68aec2772563966a$export$ed840ec4a5f5d053 = v; });
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_ACTIVITY_ARN", function () { return $68aec2772563966a$export$c1a559a4f74a5e8e; }, function (v) { return $68aec2772563966a$export$c1a559a4f74a5e8e = v; });
$parcel$export(module.exports, "AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN", function () { return $68aec2772563966a$export$d1c007424092e3f5; }, function (v) { return $68aec2772563966a$export$d1c007424092e3f5 = v; });
$parcel$export(module.exports, "BLOCKED_MAIN_THREAD", function () { return $68aec2772563966a$export$9ebb466ce954c49c; }, function (v) { return $68aec2772563966a$export$9ebb466ce954c49c = v; });
$parcel$export(module.exports, "BROWSER_BFCACHE_FRAME", function () { return $68aec2772563966a$export$d117453007717d8f; }, function (v) { return $68aec2772563966a$export$d117453007717d8f = v; });
$parcel$export(module.exports, "BROWSER_BFCACHE_NOT_RESTORED_REASON_COUNT", function () { return $68aec2772563966a$export$19cec2ad2bf22a37; }, function (v) { return $68aec2772563966a$export$19cec2ad2bf22a37 = v; });
$parcel$export(module.exports, "BROWSER_BFCACHE_OUTCOME", function () { return $68aec2772563966a$export$dc6e464b9f2085c2; }, function (v) { return $68aec2772563966a$export$dc6e464b9f2085c2 = v; });
$parcel$export(module.exports, "BROWSER_BFCACHE_REASON", function () { return $68aec2772563966a$export$316882140da7c633; }, function (v) { return $68aec2772563966a$export$316882140da7c633 = v; });
$parcel$export(module.exports, "BROWSER_NAME", function () { return $68aec2772563966a$export$e9aafc7348984403; }, function (v) { return $68aec2772563966a$export$e9aafc7348984403 = v; });
$parcel$export(module.exports, "BROWSER_NAVIGATION_ID", function () { return $68aec2772563966a$export$40f2351e1d598630; }, function (v) { return $68aec2772563966a$export$40f2351e1d598630 = v; });
$parcel$export(module.exports, "BROWSER_NAVIGATION_TYPE", function () { return $68aec2772563966a$export$ccbaf9e1e7d48f46; }, function (v) { return $68aec2772563966a$export$ccbaf9e1e7d48f46 = v; });
$parcel$export(module.exports, "BROWSER_PAINT_TYPE", function () { return $68aec2772563966a$export$5655f37b28bcd3e; }, function (v) { return $68aec2772563966a$export$5655f37b28bcd3e = v; });
$parcel$export(module.exports, "BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START", function () { return $68aec2772563966a$export$faaa46964f075237; }, function (v) { return $68aec2772563966a$export$faaa46964f075237 = v; });
$parcel$export(module.exports, "BROWSER_PERFORMANCE_TIME_ORIGIN", function () { return $68aec2772563966a$export$d28c4b3cc4431a87; }, function (v) { return $68aec2772563966a$export$d28c4b3cc4431a87 = v; });
$parcel$export(module.exports, "BROWSER_REPORT_TYPE", function () { return $68aec2772563966a$export$734b017b330c8fe6; }, function (v) { return $68aec2772563966a$export$734b017b330c8fe6 = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER", function () { return $68aec2772563966a$export$683ebdc48ba3758d; }, function (v) { return $68aec2772563966a$export$683ebdc48ba3758d = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_INVOKER_TYPE", function () { return $68aec2772563966a$export$be0263971250ef44; }, function (v) { return $68aec2772563966a$export$be0263971250ef44 = v; });
$parcel$export(module.exports, "BROWSER_SCRIPT_SOURCE_CHAR_POSITION", function () { return $68aec2772563966a$export$36a0cbc35c405232; }, function (v) { return $68aec2772563966a$export$36a0cbc35c405232 = v; });
$parcel$export(module.exports, "BROWSER_VERSION", function () { return $68aec2772563966a$export$469f7765ba335497; }, function (v) { return $68aec2772563966a$export$469f7765ba335497 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_REPORT_EVENT", function () { return $68aec2772563966a$export$fe6fe2b7af051610; }, function (v) { return $68aec2772563966a$export$fe6fe2b7af051610 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY", function () { return $68aec2772563966a$export$8345821877c4dfad; }, function (v) { return $68aec2772563966a$export$8345821877c4dfad = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE", function () { return $68aec2772563966a$export$f6c188a7e02335cf; }, function (v) { return $68aec2772563966a$export$f6c188a7e02335cf = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_CLS_VALUE", function () { return $68aec2772563966a$export$aaf709a8971e825f; }, function (v) { return $68aec2772563966a$export$aaf709a8971e825f = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FCP_VALUE", function () { return $68aec2772563966a$export$def01b82f8c092f7; }, function (v) { return $68aec2772563966a$export$def01b82f8c092f7 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_FP_VALUE", function () { return $68aec2772563966a$export$23d4264c606a73a6; }, function (v) { return $68aec2772563966a$export$23d4264c606a73a6 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_INP_INTERACTION_TYPE", function () { return $68aec2772563966a$export$269a5d262a851975; }, function (v) { return $68aec2772563966a$export$269a5d262a851975 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_INP_TARGET", function () { return $68aec2772563966a$export$4635c18f8b9bf9fa; }, function (v) { return $68aec2772563966a$export$4635c18f8b9bf9fa = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_INP_VALUE", function () { return $68aec2772563966a$export$af9ece53bb92f66b; }, function (v) { return $68aec2772563966a$export$af9ece53bb92f66b = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ELEMENT", function () { return $68aec2772563966a$export$25421625a565b69; }, function (v) { return $68aec2772563966a$export$25421625a565b69 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_ID", function () { return $68aec2772563966a$export$ab0c90d873e69ccb; }, function (v) { return $68aec2772563966a$export$ab0c90d873e69ccb = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_LOAD_TIME", function () { return $68aec2772563966a$export$538c05cc8cb2a2bb; }, function (v) { return $68aec2772563966a$export$538c05cc8cb2a2bb = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_RENDER_TIME", function () { return $68aec2772563966a$export$f86df4de196e1a7c; }, function (v) { return $68aec2772563966a$export$f86df4de196e1a7c = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_REPORT_EVENT", function () { return $68aec2772563966a$export$51e8aa8c0d65e7b8; }, function (v) { return $68aec2772563966a$export$51e8aa8c0d65e7b8 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_SIZE", function () { return $68aec2772563966a$export$99023486ecc470bd; }, function (v) { return $68aec2772563966a$export$99023486ecc470bd = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_URL", function () { return $68aec2772563966a$export$2f6c85eaf382e81; }, function (v) { return $68aec2772563966a$export$2f6c85eaf382e81 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_LCP_VALUE", function () { return $68aec2772563966a$export$1158d57c0aed42be; }, function (v) { return $68aec2772563966a$export$1158d57c0aed42be = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_REQUEST_TIME", function () { return $68aec2772563966a$export$d85c4f947ab776e3; }, function (v) { return $68aec2772563966a$export$d85c4f947ab776e3 = v; });
$parcel$export(module.exports, "BROWSER_WEB_VITAL_TTFB_VALUE", function () { return $68aec2772563966a$export$813ef8386d874918; }, function (v) { return $68aec2772563966a$export$813ef8386d874918 = v; });
$parcel$export(module.exports, "CACHE_HIT", function () { return $68aec2772563966a$export$7c2f74ff9251f64; }, function (v) { return $68aec2772563966a$export$7c2f74ff9251f64 = v; });
$parcel$export(module.exports, "CACHE_ITEM_AGE", function () { return $68aec2772563966a$export$85d6623900ff3afa; }, function (v) { return $68aec2772563966a$export$85d6623900ff3afa = v; });
$parcel$export(module.exports, "CACHE_ITEM_SIZE", function () { return $68aec2772563966a$export$993f84dab107b880; }, function (v) { return $68aec2772563966a$export$993f84dab107b880 = v; });
$parcel$export(module.exports, "CACHE_KEY", function () { return $68aec2772563966a$export$7b9c2315e94d8d2f; }, function (v) { return $68aec2772563966a$export$7b9c2315e94d8d2f = v; });
$parcel$export(module.exports, "CACHE_OPERATION", function () { return $68aec2772563966a$export$f01e5cd42b9ec146; }, function (v) { return $68aec2772563966a$export$f01e5cd42b9ec146 = v; });
$parcel$export(module.exports, "CACHE_TAGS", function () { return $68aec2772563966a$export$edfab5e0feeeee5a; }, function (v) { return $68aec2772563966a$export$edfab5e0feeeee5a = v; });
$parcel$export(module.exports, "CACHE_TTL", function () { return $68aec2772563966a$export$987f6b4367434b55; }, function (v) { return $68aec2772563966a$export$987f6b4367434b55 = v; });
$parcel$export(module.exports, "CACHE_WRITE", function () { return $68aec2772563966a$export$d9d145585d5022bb; }, function (v) { return $68aec2772563966a$export$d9d145585d5022bb = v; });
$parcel$export(module.exports, "CHANNEL", function () { return $68aec2772563966a$export$44ffba16bd48dac6; }, function (v) { return $68aec2772563966a$export$44ffba16bd48dac6 = v; });
$parcel$export(module.exports, "CLIENT_ADDRESS", function () { return $68aec2772563966a$export$3134892c5d2e251a; }, function (v) { return $68aec2772563966a$export$3134892c5d2e251a = v; });
$parcel$export(module.exports, "CLIENT_PORT", function () { return $68aec2772563966a$export$8495028d10296058; }, function (v) { return $68aec2772563966a$export$8495028d10296058 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_DURATION", function () { return $68aec2772563966a$export$d6d0e4fcf46d490c; }, function (v) { return $68aec2772563966a$export$d6d0e4fcf46d490c = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_QUERY_TYPE", function () { return $68aec2772563966a$export$658dced473c19301; }, function (v) { return $68aec2772563966a$export$658dced473c19301 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_READ", function () { return $68aec2772563966a$export$97b0f9c3fbe64076; }, function (v) { return $68aec2772563966a$export$97b0f9c3fbe64076 = v; });
$parcel$export(module.exports, "CLOUDFLARE_D1_ROWS_WRITTEN", function () { return $68aec2772563966a$export$cf2c95ed5efbe9eb; }, function (v) { return $68aec2772563966a$export$cf2c95ed5efbe9eb = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS", function () { return $68aec2772563966a$export$880007904f61a388; }, function (v) { return $68aec2772563966a$export$880007904f61a388 = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ", function () { return $68aec2772563966a$export$3e903b72d4d9e07d; }, function (v) { return $68aec2772563966a$export$3e903b72d4d9e07d = v; });
$parcel$export(module.exports, "CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN", function () { return $68aec2772563966a$export$34da07180e0e56af; }, function (v) { return $68aec2772563966a$export$34da07180e0e56af = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_BUCKET", function () { return $68aec2772563966a$export$c49aafdaeb061953; }, function (v) { return $68aec2772563966a$export$c49aafdaeb061953 = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_OPERATION", function () { return $68aec2772563966a$export$ceb762c61de2f17f; }, function (v) { return $68aec2772563966a$export$ceb762c61de2f17f = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_DELIMITER", function () { return $68aec2772563966a$export$a5f54ccfb28c0caf; }, function (v) { return $68aec2772563966a$export$a5f54ccfb28c0caf = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_KEY", function () { return $68aec2772563966a$export$1c86a56857b024db; }, function (v) { return $68aec2772563966a$export$1c86a56857b024db = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PART_NUMBER", function () { return $68aec2772563966a$export$7598f3464be47440; }, function (v) { return $68aec2772563966a$export$7598f3464be47440 = v; });
$parcel$export(module.exports, "CLOUDFLARE_R2_REQUEST_PREFIX", function () { return $68aec2772563966a$export$b673289c971fc0ae; }, function (v) { return $68aec2772563966a$export$b673289c971fc0ae = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_ATTEMPT", function () { return $68aec2772563966a$export$98b23f3e6f0c2a6f; }, function (v) { return $68aec2772563966a$export$98b23f3e6f0c2a6f = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF", function () { return $68aec2772563966a$export$6ddeaf0498614ebb; }, function (v) { return $68aec2772563966a$export$6ddeaf0498614ebb = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_DELAY", function () { return $68aec2772563966a$export$97b78f78d64a7232; }, function (v) { return $68aec2772563966a$export$97b78f78d64a7232 = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_RETRIES_LIMIT", function () { return $68aec2772563966a$export$5147715be870fff7; }, function (v) { return $68aec2772563966a$export$5147715be870fff7 = v; });
$parcel$export(module.exports, "CLOUDFLARE_WORKFLOW_TIMEOUT", function () { return $68aec2772563966a$export$5276bb46e6096fba; }, function (v) { return $68aec2772563966a$export$5276bb46e6096fba = v; });
$parcel$export(module.exports, "CLOUD_ACCOUNT_ID", function () { return $68aec2772563966a$export$cbcbc1f67a937cf3; }, function (v) { return $68aec2772563966a$export$cbcbc1f67a937cf3 = v; });
$parcel$export(module.exports, "CLOUD_AVAILABILITY_ZONE", function () { return $68aec2772563966a$export$226a2381b8f0cf78; }, function (v) { return $68aec2772563966a$export$226a2381b8f0cf78 = v; });
$parcel$export(module.exports, "CLOUD_PLATFORM", function () { return $68aec2772563966a$export$fd35512cae286064; }, function (v) { return $68aec2772563966a$export$fd35512cae286064 = v; });
$parcel$export(module.exports, "CLOUD_PROVIDER", function () { return $68aec2772563966a$export$de9bbf95ab1d81e; }, function (v) { return $68aec2772563966a$export$de9bbf95ab1d81e = v; });
$parcel$export(module.exports, "CLOUD_REGION", function () { return $68aec2772563966a$export$47fb20e8d18d7d15; }, function (v) { return $68aec2772563966a$export$47fb20e8d18d7d15 = v; });
$parcel$export(module.exports, "CLOUD_RESOURCE_ID", function () { return $68aec2772563966a$export$9db7964e4b8cb849; }, function (v) { return $68aec2772563966a$export$9db7964e4b8cb849 = v; });
$parcel$export(module.exports, "CLS", function () { return $68aec2772563966a$export$7139adf9d3bace41; }, function (v) { return $68aec2772563966a$export$7139adf9d3bace41 = v; });
$parcel$export(module.exports, "CLS_SOURCE_KEY", function () { return $68aec2772563966a$export$8ac3d09060e7f25d; }, function (v) { return $68aec2772563966a$export$8ac3d09060e7f25d = v; });
$parcel$export(module.exports, "CLS_SOURCE_KEY_BASE", function () { return $68aec2772563966a$export$dad0e4778ea23971; }, function (v) { return $68aec2772563966a$export$dad0e4778ea23971 = v; });
$parcel$export(module.exports, "CODE", function () { return $68aec2772563966a$export$ec5856072852bd7f; }, function (v) { return $68aec2772563966a$export$ec5856072852bd7f = v; });
$parcel$export(module.exports, "CODE_FILEPATH", function () { return $68aec2772563966a$export$c14d903ccf9385a8; }, function (v) { return $68aec2772563966a$export$c14d903ccf9385a8 = v; });
$parcel$export(module.exports, "CODE_FILE_PATH", function () { return $68aec2772563966a$export$934cded0041affd7; }, function (v) { return $68aec2772563966a$export$934cded0041affd7 = v; });
$parcel$export(module.exports, "CODE_FUNCTION", function () { return $68aec2772563966a$export$6386da1dcba88c9d; }, function (v) { return $68aec2772563966a$export$6386da1dcba88c9d = v; });
$parcel$export(module.exports, "CODE_FUNCTION_NAME", function () { return $68aec2772563966a$export$a3371797e606e2; }, function (v) { return $68aec2772563966a$export$a3371797e606e2 = v; });
$parcel$export(module.exports, "CODE_LINENO", function () { return $68aec2772563966a$export$a5bbef0af83b23e5; }, function (v) { return $68aec2772563966a$export$a5bbef0af83b23e5 = v; });
$parcel$export(module.exports, "CODE_LINE_NUMBER", function () { return $68aec2772563966a$export$91ed1f55874222a6; }, function (v) { return $68aec2772563966a$export$91ed1f55874222a6 = v; });
$parcel$export(module.exports, "CODE_NAMESPACE", function () { return $68aec2772563966a$export$23de81068d2aed1b; }, function (v) { return $68aec2772563966a$export$23de81068d2aed1b = v; });
$parcel$export(module.exports, "CONNECTIONTYPE", function () { return $68aec2772563966a$export$d738320e1fba9e9d; }, function (v) { return $68aec2772563966a$export$d738320e1fba9e9d = v; });
$parcel$export(module.exports, "CONNECTION_RTT", function () { return $68aec2772563966a$export$2eacdea75497e8a5; }, function (v) { return $68aec2772563966a$export$2eacdea75497e8a5 = v; });
$parcel$export(module.exports, "CULTURE_CALENDAR", function () { return $68aec2772563966a$export$2bc3ea101f86c1d2; }, function (v) { return $68aec2772563966a$export$2bc3ea101f86c1d2 = v; });
$parcel$export(module.exports, "CULTURE_DISPLAY_NAME", function () { return $68aec2772563966a$export$c54e27e8d90ee081; }, function (v) { return $68aec2772563966a$export$c54e27e8d90ee081 = v; });
$parcel$export(module.exports, "CULTURE_IS_24_HOUR_FORMAT", function () { return $68aec2772563966a$export$4943adcec371c2a6; }, function (v) { return $68aec2772563966a$export$4943adcec371c2a6 = v; });
$parcel$export(module.exports, "CULTURE_LOCALE", function () { return $68aec2772563966a$export$f000a5900d0480c2; }, function (v) { return $68aec2772563966a$export$f000a5900d0480c2 = v; });
$parcel$export(module.exports, "CULTURE_TIMEZONE", function () { return $68aec2772563966a$export$8f5234893868273b; }, function (v) { return $68aec2772563966a$export$8f5234893868273b = v; });
$parcel$export(module.exports, "DB_COLLECTION_NAME", function () { return $68aec2772563966a$export$1a35518f6e81e8c7; }, function (v) { return $68aec2772563966a$export$1a35518f6e81e8c7 = v; });
$parcel$export(module.exports, "DB_CONNECTION_STRING", function () { return $68aec2772563966a$export$5ee62d9d393aab9d; }, function (v) { return $68aec2772563966a$export$5ee62d9d393aab9d = v; });
$parcel$export(module.exports, "DB_DRIVER_NAME", function () { return $68aec2772563966a$export$a2d90911eaae60fc; }, function (v) { return $68aec2772563966a$export$a2d90911eaae60fc = v; });
$parcel$export(module.exports, "DB_MONGODB_COLLECTION", function () { return $68aec2772563966a$export$879058fdeee47603; }, function (v) { return $68aec2772563966a$export$879058fdeee47603 = v; });
$parcel$export(module.exports, "DB_NAME", function () { return $68aec2772563966a$export$3c22ff8b64b8f565; }, function (v) { return $68aec2772563966a$export$3c22ff8b64b8f565 = v; });
$parcel$export(module.exports, "DB_NAMESPACE", function () { return $68aec2772563966a$export$b8019c0e2a5b5f0f; }, function (v) { return $68aec2772563966a$export$b8019c0e2a5b5f0f = v; });
$parcel$export(module.exports, "DB_OPERATION", function () { return $68aec2772563966a$export$8c11477e471467c8; }, function (v) { return $68aec2772563966a$export$8c11477e471467c8 = v; });
$parcel$export(module.exports, "DB_OPERATION_BATCH_SIZE", function () { return $68aec2772563966a$export$92a96f6363488aee; }, function (v) { return $68aec2772563966a$export$92a96f6363488aee = v; });
$parcel$export(module.exports, "DB_OPERATION_NAME", function () { return $68aec2772563966a$export$f91beb6088f9ded9; }, function (v) { return $68aec2772563966a$export$f91beb6088f9ded9 = v; });
$parcel$export(module.exports, "DB_PARAMS", function () { return $68aec2772563966a$export$24bf9bb5ba9c544; }, function (v) { return $68aec2772563966a$export$24bf9bb5ba9c544 = v; });
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY", function () { return $68aec2772563966a$export$78bc7224576bf289; }, function (v) { return $68aec2772563966a$export$78bc7224576bf289 = v; });
$parcel$export(module.exports, "DB_QUERY_PARAMETER_KEY_BASE", function () { return $68aec2772563966a$export$a8027e0ea0d93ca; }, function (v) { return $68aec2772563966a$export$a8027e0ea0d93ca = v; });
$parcel$export(module.exports, "DB_QUERY_SUMMARY", function () { return $68aec2772563966a$export$5e59d3aea52e5037; }, function (v) { return $68aec2772563966a$export$5e59d3aea52e5037 = v; });
$parcel$export(module.exports, "DB_QUERY_TEXT", function () { return $68aec2772563966a$export$47e408be0da7933f; }, function (v) { return $68aec2772563966a$export$47e408be0da7933f = v; });
$parcel$export(module.exports, "DB_REDIS_CONNECTION", function () { return $68aec2772563966a$export$d5772b934ca13e57; }, function (v) { return $68aec2772563966a$export$d5772b934ca13e57 = v; });
$parcel$export(module.exports, "DB_REDIS_KEY", function () { return $68aec2772563966a$export$36e47f6a5777561d; }, function (v) { return $68aec2772563966a$export$36e47f6a5777561d = v; });
$parcel$export(module.exports, "DB_REDIS_PARAMETERS", function () { return $68aec2772563966a$export$e768cbc99cd68acf; }, function (v) { return $68aec2772563966a$export$e768cbc99cd68acf = v; });
$parcel$export(module.exports, "DB_RESPONSE_STATUS_CODE", function () { return $68aec2772563966a$export$dfcc6c69df1343f2; }, function (v) { return $68aec2772563966a$export$dfcc6c69df1343f2 = v; });
$parcel$export(module.exports, "DB_SQL_BINDINGS", function () { return $68aec2772563966a$export$69b0a5d9226b5211; }, function (v) { return $68aec2772563966a$export$69b0a5d9226b5211 = v; });
$parcel$export(module.exports, "DB_STATEMENT", function () { return $68aec2772563966a$export$da010a4f4fc971ae; }, function (v) { return $68aec2772563966a$export$da010a4f4fc971ae = v; });
$parcel$export(module.exports, "DB_STORED_PROCEDURE_NAME", function () { return $68aec2772563966a$export$5d515b35be0601a0; }, function (v) { return $68aec2772563966a$export$5d515b35be0601a0 = v; });
$parcel$export(module.exports, "DB_SYSTEM", function () { return $68aec2772563966a$export$3e1b1037a315c5ca; }, function (v) { return $68aec2772563966a$export$3e1b1037a315c5ca = v; });
$parcel$export(module.exports, "DB_SYSTEM_NAME", function () { return $68aec2772563966a$export$847fdd494825f0fb; }, function (v) { return $68aec2772563966a$export$847fdd494825f0fb = v; });
$parcel$export(module.exports, "DB_USER", function () { return $68aec2772563966a$export$a9d76f26c6c730a9; }, function (v) { return $68aec2772563966a$export$a9d76f26c6c730a9 = v; });
$parcel$export(module.exports, "DEVICEMEMORY", function () { return $68aec2772563966a$export$de03f86d1c9866ca; }, function (v) { return $68aec2772563966a$export$de03f86d1c9866ca = v; });
$parcel$export(module.exports, "DEVICE_ARCHS", function () { return $68aec2772563966a$export$65798ecab7eef8c; }, function (v) { return $68aec2772563966a$export$65798ecab7eef8c = v; });
$parcel$export(module.exports, "DEVICE_BATTERY_LEVEL", function () { return $68aec2772563966a$export$22aa61f48b9c79a0; }, function (v) { return $68aec2772563966a$export$22aa61f48b9c79a0 = v; });
$parcel$export(module.exports, "DEVICE_BATTERY_TEMPERATURE", function () { return $68aec2772563966a$export$69f5fb98f5aed812; }, function (v) { return $68aec2772563966a$export$69f5fb98f5aed812 = v; });
$parcel$export(module.exports, "DEVICE_BOOT_TIME", function () { return $68aec2772563966a$export$bdea5d1006fd280a; }, function (v) { return $68aec2772563966a$export$bdea5d1006fd280a = v; });
$parcel$export(module.exports, "DEVICE_BRAND", function () { return $68aec2772563966a$export$f63a7230c5b1d609; }, function (v) { return $68aec2772563966a$export$f63a7230c5b1d609 = v; });
$parcel$export(module.exports, "DEVICE_CHARGING", function () { return $68aec2772563966a$export$6f25e59b05bb8e17; }, function (v) { return $68aec2772563966a$export$6f25e59b05bb8e17 = v; });
$parcel$export(module.exports, "DEVICE_CHIPSET", function () { return $68aec2772563966a$export$a56ad13c4afc7421; }, function (v) { return $68aec2772563966a$export$a56ad13c4afc7421 = v; });
$parcel$export(module.exports, "DEVICE_CLASS", function () { return $68aec2772563966a$export$d9ce89ce8912bf12; }, function (v) { return $68aec2772563966a$export$d9ce89ce8912bf12 = v; });
$parcel$export(module.exports, "DEVICE_CONNECTION_TYPE", function () { return $68aec2772563966a$export$17094e5f380e4162; }, function (v) { return $68aec2772563966a$export$17094e5f380e4162 = v; });
$parcel$export(module.exports, "DEVICE_CPU_DESCRIPTION", function () { return $68aec2772563966a$export$28a0ffdf747973a0; }, function (v) { return $68aec2772563966a$export$28a0ffdf747973a0 = v; });
$parcel$export(module.exports, "DEVICE_EXTERNAL_FREE_STORAGE", function () { return $68aec2772563966a$export$5480ae1ba5d50bb9; }, function (v) { return $68aec2772563966a$export$5480ae1ba5d50bb9 = v; });
$parcel$export(module.exports, "DEVICE_EXTERNAL_STORAGE_SIZE", function () { return $68aec2772563966a$export$edc72ee4a17f5152; }, function (v) { return $68aec2772563966a$export$edc72ee4a17f5152 = v; });
$parcel$export(module.exports, "DEVICE_FAMILY", function () { return $68aec2772563966a$export$19e4df138d354f8b; }, function (v) { return $68aec2772563966a$export$19e4df138d354f8b = v; });
$parcel$export(module.exports, "DEVICE_FREE_MEMORY", function () { return $68aec2772563966a$export$92b0d20fa482b4b2; }, function (v) { return $68aec2772563966a$export$92b0d20fa482b4b2 = v; });
$parcel$export(module.exports, "DEVICE_FREE_STORAGE", function () { return $68aec2772563966a$export$3f638a793d61933f; }, function (v) { return $68aec2772563966a$export$3f638a793d61933f = v; });
$parcel$export(module.exports, "DEVICE_ID", function () { return $68aec2772563966a$export$3f511731cc3687d4; }, function (v) { return $68aec2772563966a$export$3f511731cc3687d4 = v; });
$parcel$export(module.exports, "DEVICE_LOCALE", function () { return $68aec2772563966a$export$692b08741d6b6265; }, function (v) { return $68aec2772563966a$export$692b08741d6b6265 = v; });
$parcel$export(module.exports, "DEVICE_LOW_MEMORY", function () { return $68aec2772563966a$export$cf67f8cb2324428e; }, function (v) { return $68aec2772563966a$export$cf67f8cb2324428e = v; });
$parcel$export(module.exports, "DEVICE_LOW_POWER_MODE", function () { return $68aec2772563966a$export$9d4197c1ffc5f359; }, function (v) { return $68aec2772563966a$export$9d4197c1ffc5f359 = v; });
$parcel$export(module.exports, "DEVICE_MANUFACTURER", function () { return $68aec2772563966a$export$509634fbff540e75; }, function (v) { return $68aec2772563966a$export$509634fbff540e75 = v; });
$parcel$export(module.exports, "DEVICE_MEMORY_ESTIMATED_CAPACITY", function () { return $68aec2772563966a$export$ccbc4fdff4b5eff5; }, function (v) { return $68aec2772563966a$export$ccbc4fdff4b5eff5 = v; });
$parcel$export(module.exports, "DEVICE_MEMORY_SIZE", function () { return $68aec2772563966a$export$e0cb371ca548b1d6; }, function (v) { return $68aec2772563966a$export$e0cb371ca548b1d6 = v; });
$parcel$export(module.exports, "DEVICE_MODEL", function () { return $68aec2772563966a$export$3c39026d09026bc2; }, function (v) { return $68aec2772563966a$export$3c39026d09026bc2 = v; });
$parcel$export(module.exports, "DEVICE_MODEL_ID", function () { return $68aec2772563966a$export$bf9e8248cb72cf00; }, function (v) { return $68aec2772563966a$export$bf9e8248cb72cf00 = v; });
$parcel$export(module.exports, "DEVICE_NAME", function () { return $68aec2772563966a$export$1054f22a72121d0f; }, function (v) { return $68aec2772563966a$export$1054f22a72121d0f = v; });
$parcel$export(module.exports, "DEVICE_ONLINE", function () { return $68aec2772563966a$export$723b8a59dad2e467; }, function (v) { return $68aec2772563966a$export$723b8a59dad2e467 = v; });
$parcel$export(module.exports, "DEVICE_ORIENTATION", function () { return $68aec2772563966a$export$160081ff141bac8e; }, function (v) { return $68aec2772563966a$export$160081ff141bac8e = v; });
$parcel$export(module.exports, "DEVICE_PROCESSOR_COUNT", function () { return $68aec2772563966a$export$194f62c84d27310; }, function (v) { return $68aec2772563966a$export$194f62c84d27310 = v; });
$parcel$export(module.exports, "DEVICE_PROCESSOR_FREQUENCY", function () { return $68aec2772563966a$export$7ed866d57b018d09; }, function (v) { return $68aec2772563966a$export$7ed866d57b018d09 = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_DENSITY", function () { return $68aec2772563966a$export$d50bae4562e03e5; }, function (v) { return $68aec2772563966a$export$d50bae4562e03e5 = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_DPI", function () { return $68aec2772563966a$export$649ea67a18fe8e8b; }, function (v) { return $68aec2772563966a$export$649ea67a18fe8e8b = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_HEIGHT_PIXELS", function () { return $68aec2772563966a$export$136a5c1b43caaccd; }, function (v) { return $68aec2772563966a$export$136a5c1b43caaccd = v; });
$parcel$export(module.exports, "DEVICE_SCREEN_WIDTH_PIXELS", function () { return $68aec2772563966a$export$e33a28ea554b6ddc; }, function (v) { return $68aec2772563966a$export$e33a28ea554b6ddc = v; });
$parcel$export(module.exports, "DEVICE_SIMULATOR", function () { return $68aec2772563966a$export$acbe2d25ac76ea64; }, function (v) { return $68aec2772563966a$export$acbe2d25ac76ea64 = v; });
$parcel$export(module.exports, "DEVICE_STORAGE_SIZE", function () { return $68aec2772563966a$export$793c13e17d7e5e2b; }, function (v) { return $68aec2772563966a$export$793c13e17d7e5e2b = v; });
$parcel$export(module.exports, "DEVICE_THERMAL_STATE", function () { return $68aec2772563966a$export$a5617e33b89fd956; }, function (v) { return $68aec2772563966a$export$a5617e33b89fd956 = v; });
$parcel$export(module.exports, "DEVICE_TIMEZONE", function () { return $68aec2772563966a$export$b51f82164fa31e07; }, function (v) { return $68aec2772563966a$export$b51f82164fa31e07 = v; });
$parcel$export(module.exports, "DEVICE_USABLE_MEMORY", function () { return $68aec2772563966a$export$f2ef55183c04d202; }, function (v) { return $68aec2772563966a$export$f2ef55183c04d202 = v; });
$parcel$export(module.exports, "DIST", function () { return $68aec2772563966a$export$7c98fc0c48a16b1c; }, function (v) { return $68aec2772563966a$export$7c98fc0c48a16b1c = v; });
$parcel$export(module.exports, "DJANGO_FUNCTION_NAME", function () { return $68aec2772563966a$export$f5ebee1eec7be08f; }, function (v) { return $68aec2772563966a$export$f5ebee1eec7be08f = v; });
$parcel$export(module.exports, "DJANGO_MIDDLEWARE_NAME", function () { return $68aec2772563966a$export$9ba827a5872de47f; }, function (v) { return $68aec2772563966a$export$9ba827a5872de47f = v; });
$parcel$export(module.exports, "EFFECTIVECONNECTIONTYPE", function () { return $68aec2772563966a$export$f0511e328234ae83; }, function (v) { return $68aec2772563966a$export$f0511e328234ae83 = v; });
$parcel$export(module.exports, "ENVIRONMENT", function () { return $68aec2772563966a$export$be46596bc6608f3b; }, function (v) { return $68aec2772563966a$export$be46596bc6608f3b = v; });
$parcel$export(module.exports, "ERROR_TYPE", function () { return $68aec2772563966a$export$f215947b3d76a6b7; }, function (v) { return $68aec2772563966a$export$f215947b3d76a6b7 = v; });
$parcel$export(module.exports, "EVENT_ID", function () { return $68aec2772563966a$export$89bbc91416db6670; }, function (v) { return $68aec2772563966a$export$89bbc91416db6670 = v; });
$parcel$export(module.exports, "EVENT_NAME", function () { return $68aec2772563966a$export$b4b5eff8a8712c89; }, function (v) { return $68aec2772563966a$export$b4b5eff8a8712c89 = v; });
$parcel$export(module.exports, "EXCEPTION_ESCAPED", function () { return $68aec2772563966a$export$f455969a57ab8a03; }, function (v) { return $68aec2772563966a$export$f455969a57ab8a03 = v; });
$parcel$export(module.exports, "EXCEPTION_MESSAGE", function () { return $68aec2772563966a$export$13f2f8f42af49cec; }, function (v) { return $68aec2772563966a$export$13f2f8f42af49cec = v; });
$parcel$export(module.exports, "EXCEPTION_STACKTRACE", function () { return $68aec2772563966a$export$cd357afe2ffdd2c3; }, function (v) { return $68aec2772563966a$export$cd357afe2ffdd2c3 = v; });
$parcel$export(module.exports, "EXCEPTION_TYPE", function () { return $68aec2772563966a$export$d9ca2a279a11be5e; }, function (v) { return $68aec2772563966a$export$d9ca2a279a11be5e = v; });
$parcel$export(module.exports, "FAAS_COLDSTART", function () { return $68aec2772563966a$export$bbd59a8c7efad4c9; }, function (v) { return $68aec2772563966a$export$bbd59a8c7efad4c9 = v; });
$parcel$export(module.exports, "FAAS_CRON", function () { return $68aec2772563966a$export$8413282a17f1cda5; }, function (v) { return $68aec2772563966a$export$8413282a17f1cda5 = v; });
$parcel$export(module.exports, "FAAS_DURATION_IN_MS", function () { return $68aec2772563966a$export$30d19ddc7705e7e8; }, function (v) { return $68aec2772563966a$export$30d19ddc7705e7e8 = v; });
$parcel$export(module.exports, "FAAS_ENTRY_POINT", function () { return $68aec2772563966a$export$64a4f09e2444b3d; }, function (v) { return $68aec2772563966a$export$64a4f09e2444b3d = v; });
$parcel$export(module.exports, "FAAS_EXECUTION", function () { return $68aec2772563966a$export$645b039fe163809e; }, function (v) { return $68aec2772563966a$export$645b039fe163809e = v; });
$parcel$export(module.exports, "FAAS_ID", function () { return $68aec2772563966a$export$b23ef8b8ffa607e1; }, function (v) { return $68aec2772563966a$export$b23ef8b8ffa607e1 = v; });
$parcel$export(module.exports, "FAAS_IDENTITY", function () { return $68aec2772563966a$export$8bf64516740c1369; }, function (v) { return $68aec2772563966a$export$8bf64516740c1369 = v; });
$parcel$export(module.exports, "FAAS_INVOCATION_ID", function () { return $68aec2772563966a$export$9a0dc8e612f3e10b; }, function (v) { return $68aec2772563966a$export$9a0dc8e612f3e10b = v; });
$parcel$export(module.exports, "FAAS_INVOKED_NAME", function () { return $68aec2772563966a$export$abe90fedb3dddda2; }, function (v) { return $68aec2772563966a$export$abe90fedb3dddda2 = v; });
$parcel$export(module.exports, "FAAS_INVOKED_PROVIDER", function () { return $68aec2772563966a$export$4a19da9c85ed2ade; }, function (v) { return $68aec2772563966a$export$4a19da9c85ed2ade = v; });
$parcel$export(module.exports, "FAAS_INVOKED_REGION", function () { return $68aec2772563966a$export$5e091479f094bdbc; }, function (v) { return $68aec2772563966a$export$5e091479f094bdbc = v; });
$parcel$export(module.exports, "FAAS_NAME", function () { return $68aec2772563966a$export$d70909b5aa96a79a; }, function (v) { return $68aec2772563966a$export$d70909b5aa96a79a = v; });
$parcel$export(module.exports, "FAAS_TIME", function () { return $68aec2772563966a$export$651d142a8017d83d; }, function (v) { return $68aec2772563966a$export$651d142a8017d83d = v; });
$parcel$export(module.exports, "FAAS_TRIGGER", function () { return $68aec2772563966a$export$44382a010a9f7fcf; }, function (v) { return $68aec2772563966a$export$44382a010a9f7fcf = v; });
$parcel$export(module.exports, "FAAS_VERSION", function () { return $68aec2772563966a$export$807abfdc6b7b9338; }, function (v) { return $68aec2772563966a$export$807abfdc6b7b9338 = v; });
$parcel$export(module.exports, "FCP", function () { return $68aec2772563966a$export$31881d07f2569218; }, function (v) { return $68aec2772563966a$export$31881d07f2569218 = v; });
$parcel$export(module.exports, "FILE_PATH", function () { return $68aec2772563966a$export$510aede74636c2c4; }, function (v) { return $68aec2772563966a$export$510aede74636c2c4 = v; });
$parcel$export(module.exports, "FILE_SIZE", function () { return $68aec2772563966a$export$c347ed9cee998637; }, function (v) { return $68aec2772563966a$export$c347ed9cee998637 = v; });
$parcel$export(module.exports, "FLAG_EVALUATION_KEY", function () { return $68aec2772563966a$export$e5bbf306deb709a6; }, function (v) { return $68aec2772563966a$export$e5bbf306deb709a6 = v; });
$parcel$export(module.exports, "FLAG_EVALUATION_KEY_BASE", function () { return $68aec2772563966a$export$aa8721167c5c8d2d; }, function (v) { return $68aec2772563966a$export$aa8721167c5c8d2d = v; });
$parcel$export(module.exports, "FP", function () { return $68aec2772563966a$export$757b93e5b3adc7cb; }, function (v) { return $68aec2772563966a$export$757b93e5b3adc7cb = v; });
$parcel$export(module.exports, "FRAMES_DELAY", function () { return $68aec2772563966a$export$f869eaa92db1dc9b; }, function (v) { return $68aec2772563966a$export$f869eaa92db1dc9b = v; });
$parcel$export(module.exports, "FRAMES_FROZEN", function () { return $68aec2772563966a$export$5d1d761e41c32d9e; }, function (v) { return $68aec2772563966a$export$5d1d761e41c32d9e = v; });
$parcel$export(module.exports, "FRAMES_FROZEN_RATE", function () { return $68aec2772563966a$export$8aec72d9491f9399; }, function (v) { return $68aec2772563966a$export$8aec72d9491f9399 = v; });
$parcel$export(module.exports, "FRAMES_SLOW", function () { return $68aec2772563966a$export$5562635d2be2ab25; }, function (v) { return $68aec2772563966a$export$5562635d2be2ab25 = v; });
$parcel$export(module.exports, "FRAMES_SLOW_RATE", function () { return $68aec2772563966a$export$2dc31837ce6f7a3d; }, function (v) { return $68aec2772563966a$export$2dc31837ce6f7a3d = v; });
$parcel$export(module.exports, "FRAMES_TOTAL", function () { return $68aec2772563966a$export$b561df15f64d32e3; }, function (v) { return $68aec2772563966a$export$b561df15f64d32e3 = v; });
$parcel$export(module.exports, "FS_ERROR", function () { return $68aec2772563966a$export$181f78b28f2ffa57; }, function (v) { return $68aec2772563966a$export$181f78b28f2ffa57 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_ID", function () { return $68aec2772563966a$export$6c97c77b89571c75; }, function (v) { return $68aec2772563966a$export$6c97c77b89571c75 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_EVENT_TYPE", function () { return $68aec2772563966a$export$51e431eaf1f9bf58; }, function (v) { return $68aec2772563966a$export$51e431eaf1f9bf58 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_ID", function () { return $68aec2772563966a$export$71429c7ef7cb7063; }, function (v) { return $68aec2772563966a$export$71429c7ef7cb7063 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_RESOURCE", function () { return $68aec2772563966a$export$99905d7583a6e8ac; }, function (v) { return $68aec2772563966a$export$99905d7583a6e8ac = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SOURCE", function () { return $68aec2772563966a$export$b6c4be74fd0c06bd; }, function (v) { return $68aec2772563966a$export$b6c4be74fd0c06bd = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_SPECVERSION", function () { return $68aec2772563966a$export$fd23e5b8d261a89; }, function (v) { return $68aec2772563966a$export$fd23e5b8d261a89 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIME", function () { return $68aec2772563966a$export$25fabc9b3d1dd567; }, function (v) { return $68aec2772563966a$export$25fabc9b3d1dd567 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TIMESTAMP", function () { return $68aec2772563966a$export$41507f7b07dad151; }, function (v) { return $68aec2772563966a$export$41507f7b07dad151 = v; });
$parcel$export(module.exports, "GCP_FUNCTION_CONTEXT_TYPE", function () { return $68aec2772563966a$export$1352f3699c35dd73; }, function (v) { return $68aec2772563966a$export$1352f3699c35dd73 = v; });
$parcel$export(module.exports, "GCP_PROJECT_ID", function () { return $68aec2772563966a$export$fd6c9d5c74d943ac; }, function (v) { return $68aec2772563966a$export$fd6c9d5c74d943ac = v; });
$parcel$export(module.exports, "GCP_REGION", function () { return $68aec2772563966a$export$895d41bed174c591; }, function (v) { return $68aec2772563966a$export$895d41bed174c591 = v; });
$parcel$export(module.exports, "GEN_AI_AGENT_NAME", function () { return $68aec2772563966a$export$c29634e3cf41e479; }, function (v) { return $68aec2772563966a$export$c29634e3cf41e479 = v; });
$parcel$export(module.exports, "GEN_AI_CONTEXT_UTILIZATION", function () { return $68aec2772563966a$export$e6a60882cce7a085; }, function (v) { return $68aec2772563966a$export$e6a60882cce7a085 = v; });
$parcel$export(module.exports, "GEN_AI_CONTEXT_WINDOW_SIZE", function () { return $68aec2772563966a$export$6773c9098ba5e194; }, function (v) { return $68aec2772563966a$export$6773c9098ba5e194 = v; });
$parcel$export(module.exports, "GEN_AI_CONVERSATION_ID", function () { return $68aec2772563966a$export$6ee6b62f50047686; }, function (v) { return $68aec2772563966a$export$6ee6b62f50047686 = v; });
$parcel$export(module.exports, "GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS", function () { return $68aec2772563966a$export$efac052bb3661242; }, function (v) { return $68aec2772563966a$export$efac052bb3661242 = v; });
$parcel$export(module.exports, "GEN_AI_COST_CACHE_READ_INPUT_TOKENS", function () { return $68aec2772563966a$export$7ccd63b9ca955862; }, function (v) { return $68aec2772563966a$export$7ccd63b9ca955862 = v; });
$parcel$export(module.exports, "GEN_AI_COST_INPUT_TOKENS", function () { return $68aec2772563966a$export$50921df5a58cb3ef; }, function (v) { return $68aec2772563966a$export$50921df5a58cb3ef = v; });
$parcel$export(module.exports, "GEN_AI_COST_OUTPUT_TOKENS", function () { return $68aec2772563966a$export$8e48efc7acb57a97; }, function (v) { return $68aec2772563966a$export$8e48efc7acb57a97 = v; });
$parcel$export(module.exports, "GEN_AI_COST_REASONING_OUTPUT_TOKENS", function () { return $68aec2772563966a$export$cea9121727113f77; }, function (v) { return $68aec2772563966a$export$cea9121727113f77 = v; });
$parcel$export(module.exports, "GEN_AI_COST_TOTAL_TOKENS", function () { return $68aec2772563966a$export$bed35ff7f9af3aaa; }, function (v) { return $68aec2772563966a$export$bed35ff7f9af3aaa = v; });
$parcel$export(module.exports, "GEN_AI_EMBEDDINGS_INPUT", function () { return $68aec2772563966a$export$6b729e898b9067ce; }, function (v) { return $68aec2772563966a$export$6b729e898b9067ce = v; });
$parcel$export(module.exports, "GEN_AI_FUNCTION_ID", function () { return $68aec2772563966a$export$984fbab9b52f7e24; }, function (v) { return $68aec2772563966a$export$984fbab9b52f7e24 = v; });
$parcel$export(module.exports, "GEN_AI_INPUT_MESSAGES", function () { return $68aec2772563966a$export$9ea17906a87ada6f; }, function (v) { return $68aec2772563966a$export$9ea17906a87ada6f = v; });
$parcel$export(module.exports, "GEN_AI_OPERATION_NAME", function () { return $68aec2772563966a$export$394b443aaff3ef92; }, function (v) { return $68aec2772563966a$export$394b443aaff3ef92 = v; });
$parcel$export(module.exports, "GEN_AI_OPERATION_TYPE", function () { return $68aec2772563966a$export$6ddc374adbc06720; }, function (v) { return $68aec2772563966a$export$6ddc374adbc06720 = v; });
$parcel$export(module.exports, "GEN_AI_OUTPUT_MESSAGES", function () { return $68aec2772563966a$export$ab8c7ebc9add56b2; }, function (v) { return $68aec2772563966a$export$ab8c7ebc9add56b2 = v; });
$parcel$export(module.exports, "GEN_AI_PIPELINE_NAME", function () { return $68aec2772563966a$export$40ecc5bcd633d1ee; }, function (v) { return $68aec2772563966a$export$40ecc5bcd633d1ee = v; });
$parcel$export(module.exports, "GEN_AI_PROMPT", function () { return $68aec2772563966a$export$86a8df7fff52fc69; }, function (v) { return $68aec2772563966a$export$86a8df7fff52fc69 = v; });
$parcel$export(module.exports, "GEN_AI_PROMPT_NAME", function () { return $68aec2772563966a$export$cf2115d46768f4c5; }, function (v) { return $68aec2772563966a$export$cf2115d46768f4c5 = v; });
$parcel$export(module.exports, "GEN_AI_PROVIDER_NAME", function () { return $68aec2772563966a$export$3d7e036e195764db; }, function (v) { return $68aec2772563966a$export$3d7e036e195764db = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_AVAILABLE_TOOLS", function () { return $68aec2772563966a$export$60c1d11221608cee; }, function (v) { return $68aec2772563966a$export$60c1d11221608cee = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_FREQUENCY_PENALTY", function () { return $68aec2772563966a$export$bc3cef164abbc42c; }, function (v) { return $68aec2772563966a$export$bc3cef164abbc42c = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MAX_TOKENS", function () { return $68aec2772563966a$export$43f9afb62cd79dec; }, function (v) { return $68aec2772563966a$export$43f9afb62cd79dec = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MESSAGES", function () { return $68aec2772563966a$export$a5ab4ffc4765f75f; }, function (v) { return $68aec2772563966a$export$a5ab4ffc4765f75f = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_MODEL", function () { return $68aec2772563966a$export$ccf46db9ab1743ec; }, function (v) { return $68aec2772563966a$export$ccf46db9ab1743ec = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_PRESENCE_PENALTY", function () { return $68aec2772563966a$export$76c1c247342d776; }, function (v) { return $68aec2772563966a$export$76c1c247342d776 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_REASONING_LEVEL", function () { return $68aec2772563966a$export$3457b85c8f1a517d; }, function (v) { return $68aec2772563966a$export$3457b85c8f1a517d = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_SCHEMA", function () { return $68aec2772563966a$export$2a1d912384377602; }, function (v) { return $68aec2772563966a$export$2a1d912384377602 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_SEED", function () { return $68aec2772563966a$export$867eeefcb1c95b27; }, function (v) { return $68aec2772563966a$export$867eeefcb1c95b27 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_STOP_SEQUENCES", function () { return $68aec2772563966a$export$5ada4697ae6aa17e; }, function (v) { return $68aec2772563966a$export$5ada4697ae6aa17e = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TEMPERATURE", function () { return $68aec2772563966a$export$427122300e8d54d0; }, function (v) { return $68aec2772563966a$export$427122300e8d54d0 = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_K", function () { return $68aec2772563966a$export$bcea8881375c352f; }, function (v) { return $68aec2772563966a$export$bcea8881375c352f = v; });
$parcel$export(module.exports, "GEN_AI_REQUEST_TOP_P", function () { return $68aec2772563966a$export$b867715f9a0c04e9; }, function (v) { return $68aec2772563966a$export$b867715f9a0c04e9 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_FINISH_REASON", function () { return $68aec2772563966a$export$2046c054eed58818; }, function (v) { return $68aec2772563966a$export$2046c054eed58818 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_FINISH_REASONS", function () { return $68aec2772563966a$export$69878a39cbdbe097; }, function (v) { return $68aec2772563966a$export$69878a39cbdbe097 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_ID", function () { return $68aec2772563966a$export$584c61a1b769552d; }, function (v) { return $68aec2772563966a$export$584c61a1b769552d = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_MODEL", function () { return $68aec2772563966a$export$8169ebcb0b0331dd; }, function (v) { return $68aec2772563966a$export$8169ebcb0b0331dd = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_OBJECT", function () { return $68aec2772563966a$export$ef5889590e2b6760; }, function (v) { return $68aec2772563966a$export$ef5889590e2b6760 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_STREAMING", function () { return $68aec2772563966a$export$2c9713b624877853; }, function (v) { return $68aec2772563966a$export$2c9713b624877853 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TEXT", function () { return $68aec2772563966a$export$45942692aeb454e0; }, function (v) { return $68aec2772563966a$export$45942692aeb454e0 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK", function () { return $68aec2772563966a$export$8e5efeaa031210cd; }, function (v) { return $68aec2772563966a$export$8e5efeaa031210cd = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN", function () { return $68aec2772563966a$export$35a62769ee05a05a; }, function (v) { return $68aec2772563966a$export$35a62769ee05a05a = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOKENS_PER_SECOND", function () { return $68aec2772563966a$export$8ea4f7e986ca4b06; }, function (v) { return $68aec2772563966a$export$8ea4f7e986ca4b06 = v; });
$parcel$export(module.exports, "GEN_AI_RESPONSE_TOOL_CALLS", function () { return $68aec2772563966a$export$d2fd9ecaff0285a4; }, function (v) { return $68aec2772563966a$export$d2fd9ecaff0285a4 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM", function () { return $68aec2772563966a$export$a6c8e656a4f9bb67; }, function (v) { return $68aec2772563966a$export$a6c8e656a4f9bb67 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM_INSTRUCTIONS", function () { return $68aec2772563966a$export$352a8075b163d53; }, function (v) { return $68aec2772563966a$export$352a8075b163d53 = v; });
$parcel$export(module.exports, "GEN_AI_SYSTEM_MESSAGE", function () { return $68aec2772563966a$export$426d7b90ba5d79db; }, function (v) { return $68aec2772563966a$export$426d7b90ba5d79db = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_ARGUMENTS", function () { return $68aec2772563966a$export$f5a1ee40934d19ce; }, function (v) { return $68aec2772563966a$export$f5a1ee40934d19ce = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_CALL_RESULT", function () { return $68aec2772563966a$export$1ba812a9756622ce; }, function (v) { return $68aec2772563966a$export$1ba812a9756622ce = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_DEFINITIONS", function () { return $68aec2772563966a$export$351120039c36e03; }, function (v) { return $68aec2772563966a$export$351120039c36e03 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_DESCRIPTION", function () { return $68aec2772563966a$export$d42aa25ca09e17c4; }, function (v) { return $68aec2772563966a$export$d42aa25ca09e17c4 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_INPUT", function () { return $68aec2772563966a$export$d268db29b88a4286; }, function (v) { return $68aec2772563966a$export$d268db29b88a4286 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_MESSAGE", function () { return $68aec2772563966a$export$c5deb6018f2d6251; }, function (v) { return $68aec2772563966a$export$c5deb6018f2d6251 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_NAME", function () { return $68aec2772563966a$export$e06baa3034409453; }, function (v) { return $68aec2772563966a$export$e06baa3034409453 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_OUTPUT", function () { return $68aec2772563966a$export$646fdb5910ce3931; }, function (v) { return $68aec2772563966a$export$646fdb5910ce3931 = v; });
$parcel$export(module.exports, "GEN_AI_TOOL_TYPE", function () { return $68aec2772563966a$export$662e3d2d4361e29b; }, function (v) { return $68aec2772563966a$export$662e3d2d4361e29b = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS", function () { return $68aec2772563966a$export$1de3962f221ba441; }, function (v) { return $68aec2772563966a$export$1de3962f221ba441 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS", function () { return $68aec2772563966a$export$a4b3f0f5499c8738; }, function (v) { return $68aec2772563966a$export$a4b3f0f5499c8738 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_COMPLETION_TOKENS", function () { return $68aec2772563966a$export$1aecdac6cecbdc5b; }, function (v) { return $68aec2772563966a$export$1aecdac6cecbdc5b = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS", function () { return $68aec2772563966a$export$2eb2ab35b317a103; }, function (v) { return $68aec2772563966a$export$2eb2ab35b317a103 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHED", function () { return $68aec2772563966a$export$c7e14ea195ede241; }, function (v) { return $68aec2772563966a$export$c7e14ea195ede241 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE", function () { return $68aec2772563966a$export$41ac034e7b9725a2; }, function (v) { return $68aec2772563966a$export$41ac034e7b9725a2 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS", function () { return $68aec2772563966a$export$9e521119d7751e37; }, function (v) { return $68aec2772563966a$export$9e521119d7751e37 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_OUTPUT_TOKENS_REASONING", function () { return $68aec2772563966a$export$cbac8f541a64a150; }, function (v) { return $68aec2772563966a$export$cbac8f541a64a150 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_PROMPT_TOKENS", function () { return $68aec2772563966a$export$93dd08efa94c9dd4; }, function (v) { return $68aec2772563966a$export$93dd08efa94c9dd4 = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_REASONING_OUTPUT_TOKENS", function () { return $68aec2772563966a$export$183e3523dac20bca; }, function (v) { return $68aec2772563966a$export$183e3523dac20bca = v; });
$parcel$export(module.exports, "GEN_AI_USAGE_TOTAL_TOKENS", function () { return $68aec2772563966a$export$3867ca1d8381d4e3; }, function (v) { return $68aec2772563966a$export$3867ca1d8381d4e3 = v; });
$parcel$export(module.exports, "GRAPHQL_DOCUMENT", function () { return $68aec2772563966a$export$11febcf9917c0057; }, function (v) { return $68aec2772563966a$export$11febcf9917c0057 = v; });
$parcel$export(module.exports, "GRAPHQL_OPERATION_NAME", function () { return $68aec2772563966a$export$88ae1ee0c0a63398; }, function (v) { return $68aec2772563966a$export$88ae1ee0c0a63398 = v; });
$parcel$export(module.exports, "GRAPHQL_OPERATION_TYPE", function () { return $68aec2772563966a$export$d5bd986d1f283f29; }, function (v) { return $68aec2772563966a$export$d5bd986d1f283f29 = v; });
$parcel$export(module.exports, "GRAPHQL_PROCESSING_TYPE", function () { return $68aec2772563966a$export$d10568582907d32c; }, function (v) { return $68aec2772563966a$export$d10568582907d32c = v; });
$parcel$export(module.exports, "GRAPHQL_SOURCE", function () { return $68aec2772563966a$export$f306d94737657647; }, function (v) { return $68aec2772563966a$export$f306d94737657647 = v; });
$parcel$export(module.exports, "GRPC_ERROR_BAD_REQUEST_FIELD_VIOLATIONS", function () { return $68aec2772563966a$export$5e55cad605e5c9d3; }, function (v) { return $68aec2772563966a$export$5e55cad605e5c9d3 = v; });
$parcel$export(module.exports, "GRPC_ERROR_DEBUG_INFO_DETAIL", function () { return $68aec2772563966a$export$1a214c5a0346737a; }, function (v) { return $68aec2772563966a$export$1a214c5a0346737a = v; });
$parcel$export(module.exports, "GRPC_ERROR_DEBUG_INFO_STACK_ENTRIES", function () { return $68aec2772563966a$export$1ecae877f91f3d38; }, function (v) { return $68aec2772563966a$export$1ecae877f91f3d38 = v; });
$parcel$export(module.exports, "GRPC_ERROR_ERROR_INFO_DOMAIN", function () { return $68aec2772563966a$export$a27521f0d3067ccc; }, function (v) { return $68aec2772563966a$export$a27521f0d3067ccc = v; });
$parcel$export(module.exports, "GRPC_ERROR_ERROR_INFO_METADATA_KEY", function () { return $68aec2772563966a$export$ac46bca5cbddbad1; }, function (v) { return $68aec2772563966a$export$ac46bca5cbddbad1 = v; });
$parcel$export(module.exports, "GRPC_ERROR_ERROR_INFO_METADATA_KEY_BASE", function () { return $68aec2772563966a$export$11b038c76920b660; }, function (v) { return $68aec2772563966a$export$11b038c76920b660 = v; });
$parcel$export(module.exports, "GRPC_ERROR_ERROR_INFO_REASON", function () { return $68aec2772563966a$export$671c5889f3e8218e; }, function (v) { return $68aec2772563966a$export$671c5889f3e8218e = v; });
$parcel$export(module.exports, "GRPC_ERROR_PRECONDITION_FAILURE_VIOLATIONS", function () { return $68aec2772563966a$export$726fdf83f7b4fcc8; }, function (v) { return $68aec2772563966a$export$726fdf83f7b4fcc8 = v; });
$parcel$export(module.exports, "GRPC_ERROR_QUOTA_FAILURE_VIOLATIONS", function () { return $68aec2772563966a$export$2400f140f6ca38e0; }, function (v) { return $68aec2772563966a$export$2400f140f6ca38e0 = v; });
$parcel$export(module.exports, "GRPC_ERROR_RESOURCE_INFO_DESCRIPTION", function () { return $68aec2772563966a$export$a6c909cc1981ed53; }, function (v) { return $68aec2772563966a$export$a6c909cc1981ed53 = v; });
$parcel$export(module.exports, "GRPC_ERROR_RESOURCE_INFO_OWNER", function () { return $68aec2772563966a$export$2a0ab3b6818597b1; }, function (v) { return $68aec2772563966a$export$2a0ab3b6818597b1 = v; });
$parcel$export(module.exports, "GRPC_ERROR_RESOURCE_INFO_RESOURCE_NAME", function () { return $68aec2772563966a$export$fc9dbcf37c263217; }, function (v) { return $68aec2772563966a$export$fc9dbcf37c263217 = v; });
$parcel$export(module.exports, "GRPC_ERROR_RESOURCE_INFO_RESOURCE_TYPE", function () { return $68aec2772563966a$export$dfbfbd03169bd3bd; }, function (v) { return $68aec2772563966a$export$dfbfbd03169bd3bd = v; });
$parcel$export(module.exports, "GRPC_ERROR_RETRY_INFO_RETRY_DELAY_MS", function () { return $68aec2772563966a$export$e36e93a941cb8163; }, function (v) { return $68aec2772563966a$export$e36e93a941cb8163 = v; });
$parcel$export(module.exports, "HARDWARECONCURRENCY", function () { return $68aec2772563966a$export$fc4a2d238535d998; }, function (v) { return $68aec2772563966a$export$fc4a2d238535d998 = v; });
$parcel$export(module.exports, "HTTP_CLIENT_IP", function () { return $68aec2772563966a$export$57e53a60bf563f41; }, function (v) { return $68aec2772563966a$export$57e53a60bf563f41 = v; });
$parcel$export(module.exports, "HTTP_DECODED_RESPONSE_CONTENT_LENGTH", function () { return $68aec2772563966a$export$ffdb1464deb0eedb; }, function (v) { return $68aec2772563966a$export$ffdb1464deb0eedb = v; });
$parcel$export(module.exports, "HTTP_FLAVOR", function () { return $68aec2772563966a$export$b52670c950fd640; }, function (v) { return $68aec2772563966a$export$b52670c950fd640 = v; });
$parcel$export(module.exports, "HTTP_FRAGMENT", function () { return $68aec2772563966a$export$c499fd8f1db3d18e; }, function (v) { return $68aec2772563966a$export$c499fd8f1db3d18e = v; });
$parcel$export(module.exports, "HTTP_HOST", function () { return $68aec2772563966a$export$b2ee2242301eff05; }, function (v) { return $68aec2772563966a$export$b2ee2242301eff05 = v; });
$parcel$export(module.exports, "HTTP_METHOD", function () { return $68aec2772563966a$export$2ebf9f7586f16841; }, function (v) { return $68aec2772563966a$export$2ebf9f7586f16841 = v; });
$parcel$export(module.exports, "HTTP_QUERY", function () { return $68aec2772563966a$export$6e9ffd608b3e828b; }, function (v) { return $68aec2772563966a$export$6e9ffd608b3e828b = v; });
$parcel$export(module.exports, "HTTP_REQUEST_BODY_DATA", function () { return $68aec2772563966a$export$b960c5a73a722e6c; }, function (v) { return $68aec2772563966a$export$b960c5a73a722e6c = v; });
$parcel$export(module.exports, "HTTP_REQUEST_BODY_DECODED_SIZE", function () { return $68aec2772563966a$export$d0bc6823da166f19; }, function (v) { return $68aec2772563966a$export$d0bc6823da166f19 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_BODY_SIZE", function () { return $68aec2772563966a$export$d7a5fcd63410985d; }, function (v) { return $68aec2772563966a$export$d7a5fcd63410985d = v; });
$parcel$export(module.exports, "HTTP_REQUEST_CONNECTION_END", function () { return $68aec2772563966a$export$a7a850351369c77e; }, function (v) { return $68aec2772563966a$export$a7a850351369c77e = v; });
$parcel$export(module.exports, "HTTP_REQUEST_CONNECT_START", function () { return $68aec2772563966a$export$b18bca78f4736a94; }, function (v) { return $68aec2772563966a$export$b18bca78f4736a94 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_CONTENT_LENGTH", function () { return $68aec2772563966a$export$dc4aa1d1f29d5e34; }, function (v) { return $68aec2772563966a$export$dc4aa1d1f29d5e34 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED", function () { return $68aec2772563966a$export$d66b1fd3d23a853e; }, function (v) { return $68aec2772563966a$export$d66b1fd3d23a853e = v; });
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_END", function () { return $68aec2772563966a$export$61a0059f562fb6c2; }, function (v) { return $68aec2772563966a$export$61a0059f562fb6c2 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_DOMAIN_LOOKUP_START", function () { return $68aec2772563966a$export$7dc0d5aefb816d91; }, function (v) { return $68aec2772563966a$export$7dc0d5aefb816d91 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_FETCH_START", function () { return $68aec2772563966a$export$58f6db56c841bef6; }, function (v) { return $68aec2772563966a$export$58f6db56c841bef6 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY", function () { return $68aec2772563966a$export$97a3da679f509d5; }, function (v) { return $68aec2772563966a$export$97a3da679f509d5 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_HEADER_KEY_BASE", function () { return $68aec2772563966a$export$c387ec65fd1c2638; }, function (v) { return $68aec2772563966a$export$c387ec65fd1c2638 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_METHOD", function () { return $68aec2772563966a$export$4d9db82211f308a4; }, function (v) { return $68aec2772563966a$export$4d9db82211f308a4 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_END", function () { return $68aec2772563966a$export$ee4948a3be025123; }, function (v) { return $68aec2772563966a$export$ee4948a3be025123 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REDIRECT_START", function () { return $68aec2772563966a$export$e0021eb2979cddaa; }, function (v) { return $68aec2772563966a$export$e0021eb2979cddaa = v; });
$parcel$export(module.exports, "HTTP_REQUEST_REQUEST_START", function () { return $68aec2772563966a$export$7c0ac0c19a45beac; }, function (v) { return $68aec2772563966a$export$7c0ac0c19a45beac = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESEND_COUNT", function () { return $68aec2772563966a$export$6c32e9d84f534ee; }, function (v) { return $68aec2772563966a$export$6c32e9d84f534ee = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_END", function () { return $68aec2772563966a$export$d1f9fbdb211dd29b; }, function (v) { return $68aec2772563966a$export$d1f9fbdb211dd29b = v; });
$parcel$export(module.exports, "HTTP_REQUEST_RESPONSE_START", function () { return $68aec2772563966a$export$45e7eea99a17d6e4; }, function (v) { return $68aec2772563966a$export$45e7eea99a17d6e4 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_SAME_ORIGIN", function () { return $68aec2772563966a$export$20ea34e16c0aa64f; }, function (v) { return $68aec2772563966a$export$20ea34e16c0aa64f = v; });
$parcel$export(module.exports, "HTTP_REQUEST_SECURE_CONNECTION_START", function () { return $68aec2772563966a$export$8365b0f03557fae9; }, function (v) { return $68aec2772563966a$export$8365b0f03557fae9 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_TIME_TO_FIRST_BYTE", function () { return $68aec2772563966a$export$49ebbb9621675650; }, function (v) { return $68aec2772563966a$export$49ebbb9621675650 = v; });
$parcel$export(module.exports, "HTTP_REQUEST_WORKER_START", function () { return $68aec2772563966a$export$842be66a901f093; }, function (v) { return $68aec2772563966a$export$842be66a901f093 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_BODY_DECODED_SIZE", function () { return $68aec2772563966a$export$3142c82fef74558f; }, function (v) { return $68aec2772563966a$export$3142c82fef74558f = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_BODY_SIZE", function () { return $68aec2772563966a$export$a9f5a6cb28adccb1; }, function (v) { return $68aec2772563966a$export$a9f5a6cb28adccb1 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_CONTENT_LENGTH", function () { return $68aec2772563966a$export$57b055d4bc586d67; }, function (v) { return $68aec2772563966a$export$57b055d4bc586d67 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED", function () { return $68aec2772563966a$export$13d631b1be16538f; }, function (v) { return $68aec2772563966a$export$13d631b1be16538f = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_CONTENT_LENGTH", function () { return $68aec2772563966a$export$3ddfd660caa7bf7a; }, function (v) { return $68aec2772563966a$export$3ddfd660caa7bf7a = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY", function () { return $68aec2772563966a$export$fa7e1f5305153b3d; }, function (v) { return $68aec2772563966a$export$fa7e1f5305153b3d = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_HEADER_KEY_BASE", function () { return $68aec2772563966a$export$5674ce9d013eb7bd; }, function (v) { return $68aec2772563966a$export$5674ce9d013eb7bd = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_SIZE", function () { return $68aec2772563966a$export$6e8dc14cff6ccf72; }, function (v) { return $68aec2772563966a$export$6e8dc14cff6ccf72 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_STATUS_CODE", function () { return $68aec2772563966a$export$afd59480458e1b57; }, function (v) { return $68aec2772563966a$export$afd59480458e1b57 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_STATUS_TEXT", function () { return $68aec2772563966a$export$97952cf4731766f5; }, function (v) { return $68aec2772563966a$export$97952cf4731766f5 = v; });
$parcel$export(module.exports, "HTTP_RESPONSE_TRANSFER_SIZE", function () { return $68aec2772563966a$export$48e61fb9bccccba9; }, function (v) { return $68aec2772563966a$export$48e61fb9bccccba9 = v; });
$parcel$export(module.exports, "HTTP_ROUTE", function () { return $68aec2772563966a$export$d3e674514dd3a3e1; }, function (v) { return $68aec2772563966a$export$d3e674514dd3a3e1 = v; });
$parcel$export(module.exports, "HTTP_SCHEME", function () { return $68aec2772563966a$export$97ad02b50c60ef68; }, function (v) { return $68aec2772563966a$export$97ad02b50c60ef68 = v; });
$parcel$export(module.exports, "HTTP_SERVER_NAME", function () { return $68aec2772563966a$export$61d053b1b63e82c4; }, function (v) { return $68aec2772563966a$export$61d053b1b63e82c4 = v; });
$parcel$export(module.exports, "HTTP_SERVER_REQUEST_TIME_IN_QUEUE", function () { return $68aec2772563966a$export$54256cce0d674dea; }, function (v) { return $68aec2772563966a$export$54256cce0d674dea = v; });
$parcel$export(module.exports, "HTTP_STATUS_CODE", function () { return $68aec2772563966a$export$8c01f0f407bcc5ca; }, function (v) { return $68aec2772563966a$export$8c01f0f407bcc5ca = v; });
$parcel$export(module.exports, "HTTP_STATUS_TEXT", function () { return $68aec2772563966a$export$97cccd427e0a295b; }, function (v) { return $68aec2772563966a$export$97cccd427e0a295b = v; });
$parcel$export(module.exports, "HTTP_TARGET", function () { return $68aec2772563966a$export$be3f46982f6c7160; }, function (v) { return $68aec2772563966a$export$be3f46982f6c7160 = v; });
$parcel$export(module.exports, "HTTP_URL", function () { return $68aec2772563966a$export$778e4213e2788579; }, function (v) { return $68aec2772563966a$export$778e4213e2788579 = v; });
$parcel$export(module.exports, "HTTP_USER_AGENT", function () { return $68aec2772563966a$export$8b48ca3594d2b172; }, function (v) { return $68aec2772563966a$export$8b48ca3594d2b172 = v; });
$parcel$export(module.exports, "ID", function () { return $68aec2772563966a$export$8be180ec26319f9f; }, function (v) { return $68aec2772563966a$export$8be180ec26319f9f = v; });
$parcel$export(module.exports, "INP", function () { return $68aec2772563966a$export$60eccaddefa8fc1c; }, function (v) { return $68aec2772563966a$export$60eccaddefa8fc1c = v; });
$parcel$export(module.exports, "JSONRPC_PROTOCOL_VERSION", function () { return $68aec2772563966a$export$c99ce4fe37484d84; }, function (v) { return $68aec2772563966a$export$c99ce4fe37484d84 = v; });
$parcel$export(module.exports, "JSONRPC_REQUEST_ID", function () { return $68aec2772563966a$export$fdf432fcac7d8f37; }, function (v) { return $68aec2772563966a$export$fdf432fcac7d8f37 = v; });
$parcel$export(module.exports, "JVM_GC_ACTION", function () { return $68aec2772563966a$export$4c21cc9cdf2f5dbd; }, function (v) { return $68aec2772563966a$export$4c21cc9cdf2f5dbd = v; });
$parcel$export(module.exports, "JVM_GC_NAME", function () { return $68aec2772563966a$export$dcc1eab7f3f31816; }, function (v) { return $68aec2772563966a$export$dcc1eab7f3f31816 = v; });
$parcel$export(module.exports, "JVM_MEMORY_POOL_NAME", function () { return $68aec2772563966a$export$dcb7f1379b2b8f86; }, function (v) { return $68aec2772563966a$export$dcb7f1379b2b8f86 = v; });
$parcel$export(module.exports, "JVM_MEMORY_TYPE", function () { return $68aec2772563966a$export$53416edeea4c2d74; }, function (v) { return $68aec2772563966a$export$53416edeea4c2d74 = v; });
$parcel$export(module.exports, "JVM_THREAD_DAEMON", function () { return $68aec2772563966a$export$69f7e5d2b74c5c9e; }, function (v) { return $68aec2772563966a$export$69f7e5d2b74c5c9e = v; });
$parcel$export(module.exports, "JVM_THREAD_STATE", function () { return $68aec2772563966a$export$8e104aed582a26bc; }, function (v) { return $68aec2772563966a$export$8e104aed582a26bc = v; });
$parcel$export(module.exports, "KOA_NAME", function () { return $68aec2772563966a$export$577047501949be9; }, function (v) { return $68aec2772563966a$export$577047501949be9 = v; });
$parcel$export(module.exports, "KOA_TYPE", function () { return $68aec2772563966a$export$c4c45b599a2c15e; }, function (v) { return $68aec2772563966a$export$c4c45b599a2c15e = v; });
$parcel$export(module.exports, "LANGCHAIN_CHAIN_NAME", function () { return $68aec2772563966a$export$8caf7173a3020ef1; }, function (v) { return $68aec2772563966a$export$8caf7173a3020ef1 = v; });
$parcel$export(module.exports, "LCP", function () { return $68aec2772563966a$export$361cb541700d648e; }, function (v) { return $68aec2772563966a$export$361cb541700d648e = v; });
$parcel$export(module.exports, "LCP_ELEMENT", function () { return $68aec2772563966a$export$974f160e11f25731; }, function (v) { return $68aec2772563966a$export$974f160e11f25731 = v; });
$parcel$export(module.exports, "LCP_ID", function () { return $68aec2772563966a$export$7162f5c702b95903; }, function (v) { return $68aec2772563966a$export$7162f5c702b95903 = v; });
$parcel$export(module.exports, "LCP_LOADTIME", function () { return $68aec2772563966a$export$a034d066a9090500; }, function (v) { return $68aec2772563966a$export$a034d066a9090500 = v; });
$parcel$export(module.exports, "LCP_RENDERTIME", function () { return $68aec2772563966a$export$70938021e43e047c; }, function (v) { return $68aec2772563966a$export$70938021e43e047c = v; });
$parcel$export(module.exports, "LCP_SIZE", function () { return $68aec2772563966a$export$5f6ac460012a73bb; }, function (v) { return $68aec2772563966a$export$5f6ac460012a73bb = v; });
$parcel$export(module.exports, "LCP_URL", function () { return $68aec2772563966a$export$d8e498c1c670bcbf; }, function (v) { return $68aec2772563966a$export$d8e498c1c670bcbf = v; });
$parcel$export(module.exports, "LITESTAR_MIDDLEWARE_NAME", function () { return $68aec2772563966a$export$a46886a44f756f1e; }, function (v) { return $68aec2772563966a$export$a46886a44f756f1e = v; });
$parcel$export(module.exports, "LOGGER_NAME", function () { return $68aec2772563966a$export$cc1a78a24d947903; }, function (v) { return $68aec2772563966a$export$cc1a78a24d947903 = v; });
$parcel$export(module.exports, "MCP_CANCELLED_REASON", function () { return $68aec2772563966a$export$d29b927e0bb0ffea; }, function (v) { return $68aec2772563966a$export$d29b927e0bb0ffea = v; });
$parcel$export(module.exports, "MCP_CANCELLED_REQUEST_ID", function () { return $68aec2772563966a$export$b3999cacef245779; }, function (v) { return $68aec2772563966a$export$b3999cacef245779 = v; });
$parcel$export(module.exports, "MCP_CLIENT_NAME", function () { return $68aec2772563966a$export$ff168b5f9cf9dcf6; }, function (v) { return $68aec2772563966a$export$ff168b5f9cf9dcf6 = v; });
$parcel$export(module.exports, "MCP_CLIENT_TITLE", function () { return $68aec2772563966a$export$2ab876a45bd6e64; }, function (v) { return $68aec2772563966a$export$2ab876a45bd6e64 = v; });
$parcel$export(module.exports, "MCP_CLIENT_VERSION", function () { return $68aec2772563966a$export$cb8027e4395c6c0e; }, function (v) { return $68aec2772563966a$export$cb8027e4395c6c0e = v; });
$parcel$export(module.exports, "MCP_LIFECYCLE_PHASE", function () { return $68aec2772563966a$export$f5303d1bac3c2660; }, function (v) { return $68aec2772563966a$export$f5303d1bac3c2660 = v; });
$parcel$export(module.exports, "MCP_LOGGING_DATA_TYPE", function () { return $68aec2772563966a$export$6c463c5f3b00f64; }, function (v) { return $68aec2772563966a$export$6c463c5f3b00f64 = v; });
$parcel$export(module.exports, "MCP_LOGGING_LEVEL", function () { return $68aec2772563966a$export$e25d553065457cab; }, function (v) { return $68aec2772563966a$export$e25d553065457cab = v; });
$parcel$export(module.exports, "MCP_LOGGING_LOGGER", function () { return $68aec2772563966a$export$15d24c154ea8a56f; }, function (v) { return $68aec2772563966a$export$15d24c154ea8a56f = v; });
$parcel$export(module.exports, "MCP_LOGGING_MESSAGE", function () { return $68aec2772563966a$export$e5065789a6c415d0; }, function (v) { return $68aec2772563966a$export$e5065789a6c415d0 = v; });
$parcel$export(module.exports, "MCP_METHOD_NAME", function () { return $68aec2772563966a$export$62662c561d7c7835; }, function (v) { return $68aec2772563966a$export$62662c561d7c7835 = v; });
$parcel$export(module.exports, "MCP_PROGRESS_CURRENT", function () { return $68aec2772563966a$export$218f394557fb0a5a; }, function (v) { return $68aec2772563966a$export$218f394557fb0a5a = v; });
$parcel$export(module.exports, "MCP_PROGRESS_MESSAGE", function () { return $68aec2772563966a$export$2a5ff6de5448ecdf; }, function (v) { return $68aec2772563966a$export$2a5ff6de5448ecdf = v; });
$parcel$export(module.exports, "MCP_PROGRESS_PERCENTAGE", function () { return $68aec2772563966a$export$9d23f3030ed2597e; }, function (v) { return $68aec2772563966a$export$9d23f3030ed2597e = v; });
$parcel$export(module.exports, "MCP_PROGRESS_TOKEN", function () { return $68aec2772563966a$export$a26ff217a6124160; }, function (v) { return $68aec2772563966a$export$a26ff217a6124160 = v; });
$parcel$export(module.exports, "MCP_PROGRESS_TOTAL", function () { return $68aec2772563966a$export$c8072f5fcfdb5b77; }, function (v) { return $68aec2772563966a$export$c8072f5fcfdb5b77 = v; });
$parcel$export(module.exports, "MCP_PROMPT_NAME", function () { return $68aec2772563966a$export$c4e4b74f1ccf3d96; }, function (v) { return $68aec2772563966a$export$c4e4b74f1ccf3d96 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_DESCRIPTION", function () { return $68aec2772563966a$export$328519d02a26ac41; }, function (v) { return $68aec2772563966a$export$328519d02a26ac41 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_CONTENT", function () { return $68aec2772563966a$export$d2061b291c43d045; }, function (v) { return $68aec2772563966a$export$d2061b291c43d045 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_COUNT", function () { return $68aec2772563966a$export$d1f04dfd3d695286; }, function (v) { return $68aec2772563966a$export$d1f04dfd3d695286 = v; });
$parcel$export(module.exports, "MCP_PROMPT_RESULT_MESSAGE_ROLE", function () { return $68aec2772563966a$export$234fbd86ea0f0bd8; }, function (v) { return $68aec2772563966a$export$234fbd86ea0f0bd8 = v; });
$parcel$export(module.exports, "MCP_PROTOCOL_READY", function () { return $68aec2772563966a$export$e795000978a75b12; }, function (v) { return $68aec2772563966a$export$e795000978a75b12 = v; });
$parcel$export(module.exports, "MCP_PROTOCOL_VERSION", function () { return $68aec2772563966a$export$9f4683b4d1018ace; }, function (v) { return $68aec2772563966a$export$9f4683b4d1018ace = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY", function () { return $68aec2772563966a$export$e431b042fcdb1d63; }, function (v) { return $68aec2772563966a$export$e431b042fcdb1d63 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_KEY_BASE", function () { return $68aec2772563966a$export$a453239171ac9a23; }, function (v) { return $68aec2772563966a$export$a453239171ac9a23 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_NAME", function () { return $68aec2772563966a$export$3a7726a976c18d5f; }, function (v) { return $68aec2772563966a$export$3a7726a976c18d5f = v; });
$parcel$export(module.exports, "MCP_REQUEST_ARGUMENT_URI", function () { return $68aec2772563966a$export$7eca7a6c06843b93; }, function (v) { return $68aec2772563966a$export$7eca7a6c06843b93 = v; });
$parcel$export(module.exports, "MCP_REQUEST_ID", function () { return $68aec2772563966a$export$f25c55f83e5b0672; }, function (v) { return $68aec2772563966a$export$f25c55f83e5b0672 = v; });
$parcel$export(module.exports, "MCP_RESOURCE_PROTOCOL", function () { return $68aec2772563966a$export$9562bfac4eb079cb; }, function (v) { return $68aec2772563966a$export$9562bfac4eb079cb = v; });
$parcel$export(module.exports, "MCP_RESOURCE_URI", function () { return $68aec2772563966a$export$c276d164ff91d2f7; }, function (v) { return $68aec2772563966a$export$c276d164ff91d2f7 = v; });
$parcel$export(module.exports, "MCP_SERVER_NAME", function () { return $68aec2772563966a$export$2f3e0574f1a99754; }, function (v) { return $68aec2772563966a$export$2f3e0574f1a99754 = v; });
$parcel$export(module.exports, "MCP_SERVER_TITLE", function () { return $68aec2772563966a$export$15eecaab68167880; }, function (v) { return $68aec2772563966a$export$15eecaab68167880 = v; });
$parcel$export(module.exports, "MCP_SERVER_VERSION", function () { return $68aec2772563966a$export$513c47f6e194086a; }, function (v) { return $68aec2772563966a$export$513c47f6e194086a = v; });
$parcel$export(module.exports, "MCP_SESSION_ID", function () { return $68aec2772563966a$export$a3f464c4d5cd9096; }, function (v) { return $68aec2772563966a$export$a3f464c4d5cd9096 = v; });
$parcel$export(module.exports, "MCP_TOOL_NAME", function () { return $68aec2772563966a$export$ed366a03a2330b03; }, function (v) { return $68aec2772563966a$export$ed366a03a2330b03 = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT", function () { return $68aec2772563966a$export$9b802c784f235e1d; }, function (v) { return $68aec2772563966a$export$9b802c784f235e1d = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_CONTENT_COUNT", function () { return $68aec2772563966a$export$add0fc8b8c5726a4; }, function (v) { return $68aec2772563966a$export$add0fc8b8c5726a4 = v; });
$parcel$export(module.exports, "MCP_TOOL_RESULT_IS_ERROR", function () { return $68aec2772563966a$export$e7f32463f5bfd554; }, function (v) { return $68aec2772563966a$export$e7f32463f5bfd554 = v; });
$parcel$export(module.exports, "MCP_TRANSPORT", function () { return $68aec2772563966a$export$f9346f394edf26a; }, function (v) { return $68aec2772563966a$export$f9346f394edf26a = v; });
$parcel$export(module.exports, "MDC_KEY", function () { return $68aec2772563966a$export$16b917774e73ef92; }, function (v) { return $68aec2772563966a$export$16b917774e73ef92 = v; });
$parcel$export(module.exports, "MDC_KEY_BASE", function () { return $68aec2772563966a$export$15d2b60bf3b65454; }, function (v) { return $68aec2772563966a$export$15d2b60bf3b65454 = v; });
$parcel$export(module.exports, "MESSAGING_BATCH_MESSAGE_COUNT", function () { return $68aec2772563966a$export$db55eca5af256142; }, function (v) { return $68aec2772563966a$export$db55eca5af256142 = v; });
$parcel$export(module.exports, "MESSAGING_CONVERSATION_ID", function () { return $68aec2772563966a$export$59329ea9f3dc6610; }, function (v) { return $68aec2772563966a$export$59329ea9f3dc6610 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION", function () { return $68aec2772563966a$export$967c74f8b1f3d35; }, function (v) { return $68aec2772563966a$export$967c74f8b1f3d35 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION_CONNECTION", function () { return $68aec2772563966a$export$7c33ae67962515d1; }, function (v) { return $68aec2772563966a$export$7c33ae67962515d1 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION_KIND", function () { return $68aec2772563966a$export$730c61462081bd77; }, function (v) { return $68aec2772563966a$export$730c61462081bd77 = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION_NAME", function () { return $68aec2772563966a$export$9c69839b2d93489b; }, function (v) { return $68aec2772563966a$export$9c69839b2d93489b = v; });
$parcel$export(module.exports, "MESSAGING_DESTINATION_PARTITION_ID", function () { return $68aec2772563966a$export$f38631e70fb37f7c; }, function (v) { return $68aec2772563966a$export$f38631e70fb37f7c = v; });
$parcel$export(module.exports, "MESSAGING_KAFKA_MESSAGE_KEY", function () { return $68aec2772563966a$export$7001e6237c0936f7; }, function (v) { return $68aec2772563966a$export$7001e6237c0936f7 = v; });
$parcel$export(module.exports, "MESSAGING_KAFKA_MESSAGE_TOMBSTONE", function () { return $68aec2772563966a$export$c2190d261e83de8b; }, function (v) { return $68aec2772563966a$export$c2190d261e83de8b = v; });
$parcel$export(module.exports, "MESSAGING_KAFKA_OFFSET", function () { return $68aec2772563966a$export$5a958d07aea838e0; }, function (v) { return $68aec2772563966a$export$5a958d07aea838e0 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_BODY_SIZE", function () { return $68aec2772563966a$export$be22d22d4b6cf5d8; }, function (v) { return $68aec2772563966a$export$be22d22d4b6cf5d8 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_CONVERSATION_ID", function () { return $68aec2772563966a$export$c529961b911626ac; }, function (v) { return $68aec2772563966a$export$c529961b911626ac = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_ENVELOPE_SIZE", function () { return $68aec2772563966a$export$e39c4b15d2881f5; }, function (v) { return $68aec2772563966a$export$e39c4b15d2881f5 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_ID", function () { return $68aec2772563966a$export$a8ca145161313e7; }, function (v) { return $68aec2772563966a$export$a8ca145161313e7 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_RECEIVE_LATENCY", function () { return $68aec2772563966a$export$3c1204d03918d076; }, function (v) { return $68aec2772563966a$export$3c1204d03918d076 = v; });
$parcel$export(module.exports, "MESSAGING_MESSAGE_RETRY_COUNT", function () { return $68aec2772563966a$export$eaac3f141165e288; }, function (v) { return $68aec2772563966a$export$eaac3f141165e288 = v; });
$parcel$export(module.exports, "MESSAGING_OPERATION", function () { return $68aec2772563966a$export$691d17eaa731c6a8; }, function (v) { return $68aec2772563966a$export$691d17eaa731c6a8 = v; });
$parcel$export(module.exports, "MESSAGING_OPERATION_NAME", function () { return $68aec2772563966a$export$4c7e6934714150e6; }, function (v) { return $68aec2772563966a$export$4c7e6934714150e6 = v; });
$parcel$export(module.exports, "MESSAGING_OPERATION_TYPE", function () { return $68aec2772563966a$export$6f71f9711d666eb4; }, function (v) { return $68aec2772563966a$export$6f71f9711d666eb4 = v; });
$parcel$export(module.exports, "MESSAGING_PROTOCOL", function () { return $68aec2772563966a$export$2e2181bea33963d2; }, function (v) { return $68aec2772563966a$export$2e2181bea33963d2 = v; });
$parcel$export(module.exports, "MESSAGING_PROTOCOL_VERSION", function () { return $68aec2772563966a$export$77b390a335f31601; }, function (v) { return $68aec2772563966a$export$77b390a335f31601 = v; });
$parcel$export(module.exports, "MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY", function () { return $68aec2772563966a$export$2a3cd2bb71fb63a4; }, function (v) { return $68aec2772563966a$export$2a3cd2bb71fb63a4 = v; });
$parcel$export(module.exports, "MESSAGING_RABBITMQ_ROUTING_KEY", function () { return $68aec2772563966a$export$4696f9a8a1b6f07c; }, function (v) { return $68aec2772563966a$export$4696f9a8a1b6f07c = v; });
$parcel$export(module.exports, "MESSAGING_SYSTEM", function () { return $68aec2772563966a$export$55478a0b7d2ae98f; }, function (v) { return $68aec2772563966a$export$55478a0b7d2ae98f = v; });
$parcel$export(module.exports, "MESSAGING_URL", function () { return $68aec2772563966a$export$536e79776026daed; }, function (v) { return $68aec2772563966a$export$536e79776026daed = v; });
$parcel$export(module.exports, "METHOD", function () { return $68aec2772563966a$export$bed10c4da9b8eb0a; }, function (v) { return $68aec2772563966a$export$bed10c4da9b8eb0a = v; });
$parcel$export(module.exports, "MIDDLEWARE_NAME", function () { return $68aec2772563966a$export$a82607b6424c06c8; }, function (v) { return $68aec2772563966a$export$a82607b6424c06c8 = v; });
$parcel$export(module.exports, "NAVIGATION_ORIGIN", function () { return $68aec2772563966a$export$6b081f3484c7f4e5; }, function (v) { return $68aec2772563966a$export$6b081f3484c7f4e5 = v; });
$parcel$export(module.exports, "NAVIGATION_ROUTE_ID", function () { return $68aec2772563966a$export$b7754d85fd39406c; }, function (v) { return $68aec2772563966a$export$b7754d85fd39406c = v; });
$parcel$export(module.exports, "NAVIGATION_TYPE", function () { return $68aec2772563966a$export$492856c046eb4728; }, function (v) { return $68aec2772563966a$export$492856c046eb4728 = v; });
$parcel$export(module.exports, "NEL_ELAPSED_TIME", function () { return $68aec2772563966a$export$c1678a2059fbe906; }, function (v) { return $68aec2772563966a$export$c1678a2059fbe906 = v; });
$parcel$export(module.exports, "NEL_PHASE", function () { return $68aec2772563966a$export$6d384a0bc1011c34; }, function (v) { return $68aec2772563966a$export$6d384a0bc1011c34 = v; });
$parcel$export(module.exports, "NEL_REFERRER", function () { return $68aec2772563966a$export$1499a7dbfc01e7d4; }, function (v) { return $68aec2772563966a$export$1499a7dbfc01e7d4 = v; });
$parcel$export(module.exports, "NEL_SAMPLING_FUNCTION", function () { return $68aec2772563966a$export$cfcbff40019f0ff1; }, function (v) { return $68aec2772563966a$export$cfcbff40019f0ff1 = v; });
$parcel$export(module.exports, "NEL_TYPE", function () { return $68aec2772563966a$export$27157b5f68e583af; }, function (v) { return $68aec2772563966a$export$27157b5f68e583af = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_EFFECTIVE_TYPE", function () { return $68aec2772563966a$export$54bf5ed61532925d; }, function (v) { return $68aec2772563966a$export$54bf5ed61532925d = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_RTT", function () { return $68aec2772563966a$export$60ed0786292ace08; }, function (v) { return $68aec2772563966a$export$60ed0786292ace08 = v; });
$parcel$export(module.exports, "NETWORK_CONNECTION_TYPE", function () { return $68aec2772563966a$export$d770bfb8345e146; }, function (v) { return $68aec2772563966a$export$d770bfb8345e146 = v; });
$parcel$export(module.exports, "NETWORK_LOCAL_ADDRESS", function () { return $68aec2772563966a$export$bb73817f1290ad28; }, function (v) { return $68aec2772563966a$export$bb73817f1290ad28 = v; });
$parcel$export(module.exports, "NETWORK_LOCAL_PORT", function () { return $68aec2772563966a$export$f201c980f2b75802; }, function (v) { return $68aec2772563966a$export$f201c980f2b75802 = v; });
$parcel$export(module.exports, "NETWORK_PEER_ADDRESS", function () { return $68aec2772563966a$export$b40e970572afd0ee; }, function (v) { return $68aec2772563966a$export$b40e970572afd0ee = v; });
$parcel$export(module.exports, "NETWORK_PEER_PORT", function () { return $68aec2772563966a$export$8850630a3d343488; }, function (v) { return $68aec2772563966a$export$8850630a3d343488 = v; });
$parcel$export(module.exports, "NETWORK_PROTOCOL_NAME", function () { return $68aec2772563966a$export$fd0a39a918d6516f; }, function (v) { return $68aec2772563966a$export$fd0a39a918d6516f = v; });
$parcel$export(module.exports, "NETWORK_PROTOCOL_VERSION", function () { return $68aec2772563966a$export$e68ef41f8e0335bf; }, function (v) { return $68aec2772563966a$export$e68ef41f8e0335bf = v; });
$parcel$export(module.exports, "NETWORK_TRANSPORT", function () { return $68aec2772563966a$export$5bff09650e762829; }, function (v) { return $68aec2772563966a$export$5bff09650e762829 = v; });
$parcel$export(module.exports, "NETWORK_TYPE", function () { return $68aec2772563966a$export$21c1adce0e067f37; }, function (v) { return $68aec2772563966a$export$21c1adce0e067f37 = v; });
$parcel$export(module.exports, "NET_HOST_IP", function () { return $68aec2772563966a$export$fed6ce86f48c84bc; }, function (v) { return $68aec2772563966a$export$fed6ce86f48c84bc = v; });
$parcel$export(module.exports, "NET_HOST_NAME", function () { return $68aec2772563966a$export$500c2675137ac16e; }, function (v) { return $68aec2772563966a$export$500c2675137ac16e = v; });
$parcel$export(module.exports, "NET_HOST_PORT", function () { return $68aec2772563966a$export$402c7728623fd8df; }, function (v) { return $68aec2772563966a$export$402c7728623fd8df = v; });
$parcel$export(module.exports, "NET_PEER_IP", function () { return $68aec2772563966a$export$15417259f4c0fe6b; }, function (v) { return $68aec2772563966a$export$15417259f4c0fe6b = v; });
$parcel$export(module.exports, "NET_PEER_NAME", function () { return $68aec2772563966a$export$2b3b7f579a727f45; }, function (v) { return $68aec2772563966a$export$2b3b7f579a727f45 = v; });
$parcel$export(module.exports, "NET_PEER_PORT", function () { return $68aec2772563966a$export$514832a0b029734b; }, function (v) { return $68aec2772563966a$export$514832a0b029734b = v; });
$parcel$export(module.exports, "NET_PROTOCOL_NAME", function () { return $68aec2772563966a$export$b0522e6a14dec1a4; }, function (v) { return $68aec2772563966a$export$b0522e6a14dec1a4 = v; });
$parcel$export(module.exports, "NET_PROTOCOL_VERSION", function () { return $68aec2772563966a$export$659ea19f71a7ee0b; }, function (v) { return $68aec2772563966a$export$659ea19f71a7ee0b = v; });
$parcel$export(module.exports, "NET_SOCK_FAMILY", function () { return $68aec2772563966a$export$1b61d972db315e73; }, function (v) { return $68aec2772563966a$export$1b61d972db315e73 = v; });
$parcel$export(module.exports, "NET_SOCK_HOST_ADDR", function () { return $68aec2772563966a$export$fb2970ee11a479ee; }, function (v) { return $68aec2772563966a$export$fb2970ee11a479ee = v; });
$parcel$export(module.exports, "NET_SOCK_HOST_PORT", function () { return $68aec2772563966a$export$920aceb2a8fad77e; }, function (v) { return $68aec2772563966a$export$920aceb2a8fad77e = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_ADDR", function () { return $68aec2772563966a$export$48f8f6fbc999d187; }, function (v) { return $68aec2772563966a$export$48f8f6fbc999d187 = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_NAME", function () { return $68aec2772563966a$export$eed590fa00a8223b; }, function (v) { return $68aec2772563966a$export$eed590fa00a8223b = v; });
$parcel$export(module.exports, "NET_SOCK_PEER_PORT", function () { return $68aec2772563966a$export$f2e5bb5cd4a130da; }, function (v) { return $68aec2772563966a$export$f2e5bb5cd4a130da = v; });
$parcel$export(module.exports, "NET_TRANSPORT", function () { return $68aec2772563966a$export$779ef03d633a9086; }, function (v) { return $68aec2772563966a$export$779ef03d633a9086 = v; });
$parcel$export(module.exports, "OS_BUILD", function () { return $68aec2772563966a$export$d98b87c8d53d0dbc; }, function (v) { return $68aec2772563966a$export$d98b87c8d53d0dbc = v; });
$parcel$export(module.exports, "OS_BUILD_ID", function () { return $68aec2772563966a$export$ca719aa57653a0a7; }, function (v) { return $68aec2772563966a$export$ca719aa57653a0a7 = v; });
$parcel$export(module.exports, "OS_DESCRIPTION", function () { return $68aec2772563966a$export$74b19c5f48270c05; }, function (v) { return $68aec2772563966a$export$74b19c5f48270c05 = v; });
$parcel$export(module.exports, "OS_KERNEL_VERSION", function () { return $68aec2772563966a$export$c351affe7e8098cb; }, function (v) { return $68aec2772563966a$export$c351affe7e8098cb = v; });
$parcel$export(module.exports, "OS_NAME", function () { return $68aec2772563966a$export$be7cd6b3ae3ae765; }, function (v) { return $68aec2772563966a$export$be7cd6b3ae3ae765 = v; });
$parcel$export(module.exports, "OS_RAW_DESCRIPTION", function () { return $68aec2772563966a$export$ec182524c4c57275; }, function (v) { return $68aec2772563966a$export$ec182524c4c57275 = v; });
$parcel$export(module.exports, "OS_ROOTED", function () { return $68aec2772563966a$export$9e45758246a85b07; }, function (v) { return $68aec2772563966a$export$9e45758246a85b07 = v; });
$parcel$export(module.exports, "OS_THEME", function () { return $68aec2772563966a$export$9fa5d5f0144954cb; }, function (v) { return $68aec2772563966a$export$9fa5d5f0144954cb = v; });
$parcel$export(module.exports, "OS_TYPE", function () { return $68aec2772563966a$export$e66ba5bc4b978023; }, function (v) { return $68aec2772563966a$export$e66ba5bc4b978023 = v; });
$parcel$export(module.exports, "OS_VERSION", function () { return $68aec2772563966a$export$2306e23cc611a36d; }, function (v) { return $68aec2772563966a$export$2306e23cc611a36d = v; });
$parcel$export(module.exports, "OTEL_KIND", function () { return $68aec2772563966a$export$144f8c1fe01428db; }, function (v) { return $68aec2772563966a$export$144f8c1fe01428db = v; });
$parcel$export(module.exports, "OTEL_SCOPE_NAME", function () { return $68aec2772563966a$export$f303b2744d52121c; }, function (v) { return $68aec2772563966a$export$f303b2744d52121c = v; });
$parcel$export(module.exports, "OTEL_SCOPE_VERSION", function () { return $68aec2772563966a$export$866b2dbc7bf18ce6; }, function (v) { return $68aec2772563966a$export$866b2dbc7bf18ce6 = v; });
$parcel$export(module.exports, "OTEL_STATUS_CODE", function () { return $68aec2772563966a$export$b4c85774878b4841; }, function (v) { return $68aec2772563966a$export$b4c85774878b4841 = v; });
$parcel$export(module.exports, "OTEL_STATUS_DESCRIPTION", function () { return $68aec2772563966a$export$1c967a71bc9a3077; }, function (v) { return $68aec2772563966a$export$1c967a71bc9a3077 = v; });
$parcel$export(module.exports, "PARAMS_KEY", function () { return $68aec2772563966a$export$5e3884a35a19eb90; }, function (v) { return $68aec2772563966a$export$5e3884a35a19eb90 = v; });
$parcel$export(module.exports, "PARAMS_KEY_BASE", function () { return $68aec2772563966a$export$6e7ff99bb3259573; }, function (v) { return $68aec2772563966a$export$6e7ff99bb3259573 = v; });
$parcel$export(module.exports, "PERFORMANCE_ACTIVATIONSTART", function () { return $68aec2772563966a$export$7c932cba2d9e7a7; }, function (v) { return $68aec2772563966a$export$7c932cba2d9e7a7 = v; });
$parcel$export(module.exports, "PERFORMANCE_TIMEORIGIN", function () { return $68aec2772563966a$export$94091942edce0667; }, function (v) { return $68aec2772563966a$export$94091942edce0667 = v; });
$parcel$export(module.exports, "PORT", function () { return $68aec2772563966a$export$a08202ba4c331865; }, function (v) { return $68aec2772563966a$export$a08202ba4c331865 = v; });
$parcel$export(module.exports, "PREVIOUS_ROUTE", function () { return $68aec2772563966a$export$3671a8a524706a9d; }, function (v) { return $68aec2772563966a$export$3671a8a524706a9d = v; });
$parcel$export(module.exports, "PROCESS_COMMAND_ARGS", function () { return $68aec2772563966a$export$c288888dc82d233f; }, function (v) { return $68aec2772563966a$export$c288888dc82d233f = v; });
$parcel$export(module.exports, "PROCESS_EXECUTABLE_NAME", function () { return $68aec2772563966a$export$8ff188536cebc35; }, function (v) { return $68aec2772563966a$export$8ff188536cebc35 = v; });
$parcel$export(module.exports, "PROCESS_PID", function () { return $68aec2772563966a$export$6407d78968c0eabe; }, function (v) { return $68aec2772563966a$export$6407d78968c0eabe = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_DESCRIPTION", function () { return $68aec2772563966a$export$43e9fb9ec28d9743; }, function (v) { return $68aec2772563966a$export$43e9fb9ec28d9743 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_NAME", function () { return $68aec2772563966a$export$26f31d5c5c201739; }, function (v) { return $68aec2772563966a$export$26f31d5c5c201739 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_ENGINE_VERSION", function () { return $68aec2772563966a$export$bff85124d2d35b93; }, function (v) { return $68aec2772563966a$export$bff85124d2d35b93 = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_NAME", function () { return $68aec2772563966a$export$495c671ed5a6408c; }, function (v) { return $68aec2772563966a$export$495c671ed5a6408c = v; });
$parcel$export(module.exports, "PROCESS_RUNTIME_VERSION", function () { return $68aec2772563966a$export$54b3d4d5548c35c3; }, function (v) { return $68aec2772563966a$export$54b3d4d5548c35c3 = v; });
$parcel$export(module.exports, "PROFILE_ID", function () { return $68aec2772563966a$export$71aa6d7b25b5b4be; }, function (v) { return $68aec2772563966a$export$71aa6d7b25b5b4be = v; });
$parcel$export(module.exports, "QUERY", function () { return $68aec2772563966a$export$2b91517d6d5b4365; }, function (v) { return $68aec2772563966a$export$2b91517d6d5b4365 = v; });
$parcel$export(module.exports, "QUERY_KEY", function () { return $68aec2772563966a$export$2954db6444fe1fa8; }, function (v) { return $68aec2772563966a$export$2954db6444fe1fa8 = v; });
$parcel$export(module.exports, "QUERY_KEY_BASE", function () { return $68aec2772563966a$export$15c1c974d16dd678; }, function (v) { return $68aec2772563966a$export$15c1c974d16dd678 = v; });
$parcel$export(module.exports, "REACT_NATIVE_ARCHITECTURE", function () { return $68aec2772563966a$export$81c87eb7885d0bfe; }, function (v) { return $68aec2772563966a$export$81c87eb7885d0bfe = v; });
$parcel$export(module.exports, "REACT_NATIVE_MODULE_CALL_COUNT", function () { return $68aec2772563966a$export$da39a8d77ac07c5b; }, function (v) { return $68aec2772563966a$export$da39a8d77ac07c5b = v; });
$parcel$export(module.exports, "REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT", function () { return $68aec2772563966a$export$8e637b1057fe6fb6; }, function (v) { return $68aec2772563966a$export$8e637b1057fe6fb6 = v; });
$parcel$export(module.exports, "REACT_NATIVE_MODULE_DURATION_MAX", function () { return $68aec2772563966a$export$b9218817a14d08d5; }, function (v) { return $68aec2772563966a$export$b9218817a14d08d5 = v; });
$parcel$export(module.exports, "REACT_NATIVE_MODULE_DURATION_TOTAL", function () { return $68aec2772563966a$export$96066c6fa0d06464; }, function (v) { return $68aec2772563966a$export$96066c6fa0d06464 = v; });
$parcel$export(module.exports, "REACT_NATIVE_MODULE_ERROR_COUNT", function () { return $68aec2772563966a$export$a78cfb50aa50bca4; }, function (v) { return $68aec2772563966a$export$a78cfb50aa50bca4 = v; });
$parcel$export(module.exports, "REACT_NATIVE_MODULE_KIND", function () { return $68aec2772563966a$export$79b15960e18053b9; }, function (v) { return $68aec2772563966a$export$79b15960e18053b9 = v; });
$parcel$export(module.exports, "REACT_NATIVE_MODULE_METHOD", function () { return $68aec2772563966a$export$8e8a40d1629c4be; }, function (v) { return $68aec2772563966a$export$8e8a40d1629c4be = v; });
$parcel$export(module.exports, "REACT_NATIVE_MODULE_NAME", function () { return $68aec2772563966a$export$668dbefe39a14e9; }, function (v) { return $68aec2772563966a$export$668dbefe39a14e9 = v; });
$parcel$export(module.exports, "REACT_NATIVE_MODULE_TOP_DURATION", function () { return $68aec2772563966a$export$ee766f53806dcc0a; }, function (v) { return $68aec2772563966a$export$ee766f53806dcc0a = v; });
$parcel$export(module.exports, "REACT_NATIVE_MODULE_TOP_NAME", function () { return $68aec2772563966a$export$6670b5eb4860054b; }, function (v) { return $68aec2772563966a$export$6670b5eb4860054b = v; });
$parcel$export(module.exports, "REACT_VERSION", function () { return $68aec2772563966a$export$9be2ae89a1eac217; }, function (v) { return $68aec2772563966a$export$9be2ae89a1eac217 = v; });
$parcel$export(module.exports, "REDIS_COMMAND", function () { return $68aec2772563966a$export$51231929dd279b6d; }, function (v) { return $68aec2772563966a$export$51231929dd279b6d = v; });
$parcel$export(module.exports, "REDIS_KEY", function () { return $68aec2772563966a$export$5c83e6b57d4562ef; }, function (v) { return $68aec2772563966a$export$5c83e6b57d4562ef = v; });
$parcel$export(module.exports, "RELEASE", function () { return $68aec2772563966a$export$5c698591c0e586a2; }, function (v) { return $68aec2772563966a$export$5c698591c0e586a2 = v; });
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY", function () { return $68aec2772563966a$export$b711f2bb9c9a848a; }, function (v) { return $68aec2772563966a$export$b711f2bb9c9a848a = v; });
$parcel$export(module.exports, "REMIX_ACTION_FORM_DATA_KEY_BASE", function () { return $68aec2772563966a$export$1d3a8501efd30213; }, function (v) { return $68aec2772563966a$export$1d3a8501efd30213 = v; });
$parcel$export(module.exports, "REPLAYID", function () { return $68aec2772563966a$export$e0df0d58e945a144; }, function (v) { return $68aec2772563966a$export$e0df0d58e945a144 = v; });
$parcel$export(module.exports, "REPLAY_ID", function () { return $68aec2772563966a$export$cebaf684ced5a2c9; }, function (v) { return $68aec2772563966a$export$cebaf684ced5a2c9 = v; });
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT", function () { return $68aec2772563966a$export$d4c658ecdcb7c78c; }, function (v) { return $68aec2772563966a$export$d4c658ecdcb7c78c = v; });
$parcel$export(module.exports, "RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME", function () { return $68aec2772563966a$export$b1b162b01baeb044; }, function (v) { return $68aec2772563966a$export$b1b162b01baeb044 = v; });
$parcel$export(module.exports, "RESOURCE_RENDER_BLOCKING_STATUS", function () { return $68aec2772563966a$export$8be2d593d7f88ed8; }, function (v) { return $68aec2772563966a$export$8be2d593d7f88ed8 = v; });
$parcel$export(module.exports, "ROUTE", function () { return $68aec2772563966a$export$dbd0a3528a97ccc0; }, function (v) { return $68aec2772563966a$export$dbd0a3528a97ccc0 = v; });
$parcel$export(module.exports, "ROUTER_NAVIGATION_ORIGIN", function () { return $68aec2772563966a$export$b506afe31324afa3; }, function (v) { return $68aec2772563966a$export$b506afe31324afa3 = v; });
$parcel$export(module.exports, "ROUTER_NAVIGATION_ROUTE_ID", function () { return $68aec2772563966a$export$953df8d049a11237; }, function (v) { return $68aec2772563966a$export$953df8d049a11237 = v; });
$parcel$export(module.exports, "ROUTER_NAVIGATION_TYPE", function () { return $68aec2772563966a$export$db0d98a58164f739; }, function (v) { return $68aec2772563966a$export$db0d98a58164f739 = v; });
$parcel$export(module.exports, "RPC_GRPC_STATUS_CODE", function () { return $68aec2772563966a$export$66581dc6d3d083d1; }, function (v) { return $68aec2772563966a$export$66581dc6d3d083d1 = v; });
$parcel$export(module.exports, "RPC_METHOD", function () { return $68aec2772563966a$export$e545f99e7abcc499; }, function (v) { return $68aec2772563966a$export$e545f99e7abcc499 = v; });
$parcel$export(module.exports, "RPC_RESPONSE_STATUS_CODE", function () { return $68aec2772563966a$export$7e1af5787f8c4aaa; }, function (v) { return $68aec2772563966a$export$7e1af5787f8c4aaa = v; });
$parcel$export(module.exports, "RPC_SERVICE", function () { return $68aec2772563966a$export$186c94c351c54768; }, function (v) { return $68aec2772563966a$export$186c94c351c54768 = v; });
$parcel$export(module.exports, "RPC_SYSTEM", function () { return $68aec2772563966a$export$2e3fd8dfcb16fe0c; }, function (v) { return $68aec2772563966a$export$2e3fd8dfcb16fe0c = v; });
$parcel$export(module.exports, "RPC_SYSTEM_NAME", function () { return $68aec2772563966a$export$7eeeceaa1dbd7cd5; }, function (v) { return $68aec2772563966a$export$7eeeceaa1dbd7cd5 = v; });
$parcel$export(module.exports, "RUNTIME_BUILD", function () { return $68aec2772563966a$export$9d5bffdff936d554; }, function (v) { return $68aec2772563966a$export$9d5bffdff936d554 = v; });
$parcel$export(module.exports, "RUNTIME_NAME", function () { return $68aec2772563966a$export$dc3a801c9a2c5b79; }, function (v) { return $68aec2772563966a$export$dc3a801c9a2c5b79 = v; });
$parcel$export(module.exports, "RUNTIME_RAW_DESCRIPTION", function () { return $68aec2772563966a$export$27933a9557f87e98; }, function (v) { return $68aec2772563966a$export$27933a9557f87e98 = v; });
$parcel$export(module.exports, "RUNTIME_VERSION", function () { return $68aec2772563966a$export$eefa737b40a0d535; }, function (v) { return $68aec2772563966a$export$eefa737b40a0d535 = v; });
$parcel$export(module.exports, "SCORE_KEY", function () { return $68aec2772563966a$export$92740ffbcb02553b; }, function (v) { return $68aec2772563966a$export$92740ffbcb02553b = v; });
$parcel$export(module.exports, "SCORE_KEY_BASE", function () { return $68aec2772563966a$export$500e89753f9f1008; }, function (v) { return $68aec2772563966a$export$500e89753f9f1008 = v; });
$parcel$export(module.exports, "SCORE_RATIO_KEY", function () { return $68aec2772563966a$export$d91a18e47fdddefd; }, function (v) { return $68aec2772563966a$export$d91a18e47fdddefd = v; });
$parcel$export(module.exports, "SCORE_RATIO_KEY_BASE", function () { return $68aec2772563966a$export$eccbe6f20884ea7f; }, function (v) { return $68aec2772563966a$export$eccbe6f20884ea7f = v; });
$parcel$export(module.exports, "SCORE_TOTAL", function () { return $68aec2772563966a$export$9e24f11d79141afb; }, function (v) { return $68aec2772563966a$export$9e24f11d79141afb = v; });
$parcel$export(module.exports, "SCORE_WEIGHT_KEY", function () { return $68aec2772563966a$export$f0b96ad9586f8887; }, function (v) { return $68aec2772563966a$export$f0b96ad9586f8887 = v; });
$parcel$export(module.exports, "SCORE_WEIGHT_KEY_BASE", function () { return $68aec2772563966a$export$8a92ed5d436a85c6; }, function (v) { return $68aec2772563966a$export$8a92ed5d436a85c6 = v; });
$parcel$export(module.exports, "SENTRY_ACTION", function () { return $68aec2772563966a$export$edd59acdf7e86a71; }, function (v) { return $68aec2772563966a$export$edd59acdf7e86a71 = v; });
$parcel$export(module.exports, "SENTRY_BROWSER_NAME", function () { return $68aec2772563966a$export$ae81a1ae71952d50; }, function (v) { return $68aec2772563966a$export$ae81a1ae71952d50 = v; });
$parcel$export(module.exports, "SENTRY_BROWSER_VERSION", function () { return $68aec2772563966a$export$6101470cd57eac1b; }, function (v) { return $68aec2772563966a$export$6101470cd57eac1b = v; });
$parcel$export(module.exports, "SENTRY_CANCELLATION_REASON", function () { return $68aec2772563966a$export$452c0aee9673fe67; }, function (v) { return $68aec2772563966a$export$452c0aee9673fe67 = v; });
$parcel$export(module.exports, "SENTRY_CATEGORY", function () { return $68aec2772563966a$export$773dddd1e8667756; }, function (v) { return $68aec2772563966a$export$773dddd1e8667756 = v; });
$parcel$export(module.exports, "SENTRY_CLIENT_SAMPLE_RATE", function () { return $68aec2772563966a$export$98815f8579a64a90; }, function (v) { return $68aec2772563966a$export$98815f8579a64a90 = v; });
$parcel$export(module.exports, "SENTRY_DESCRIPTION", function () { return $68aec2772563966a$export$7bc4e27428665019; }, function (v) { return $68aec2772563966a$export$7bc4e27428665019 = v; });
$parcel$export(module.exports, "SENTRY_DIST", function () { return $68aec2772563966a$export$e7d7477fa9057ee2; }, function (v) { return $68aec2772563966a$export$e7d7477fa9057ee2 = v; });
$parcel$export(module.exports, "SENTRY_DOMAIN", function () { return $68aec2772563966a$export$1f4267a3fc018448; }, function (v) { return $68aec2772563966a$export$1f4267a3fc018448 = v; });
$parcel$export(module.exports, "SENTRY_DSC_ENVIRONMENT", function () { return $68aec2772563966a$export$c171cae150389952; }, function (v) { return $68aec2772563966a$export$c171cae150389952 = v; });
$parcel$export(module.exports, "SENTRY_DSC_PROJECT_ID", function () { return $68aec2772563966a$export$d9bb35e957b22c72; }, function (v) { return $68aec2772563966a$export$d9bb35e957b22c72 = v; });
$parcel$export(module.exports, "SENTRY_DSC_PUBLIC_KEY", function () { return $68aec2772563966a$export$b3508a2c95f74e3d; }, function (v) { return $68aec2772563966a$export$b3508a2c95f74e3d = v; });
$parcel$export(module.exports, "SENTRY_DSC_RELEASE", function () { return $68aec2772563966a$export$20bb272f4d21532d; }, function (v) { return $68aec2772563966a$export$20bb272f4d21532d = v; });
$parcel$export(module.exports, "SENTRY_DSC_SAMPLED", function () { return $68aec2772563966a$export$d7e64fbd0102ce90; }, function (v) { return $68aec2772563966a$export$d7e64fbd0102ce90 = v; });
$parcel$export(module.exports, "SENTRY_DSC_SAMPLE_RATE", function () { return $68aec2772563966a$export$c17eae7e86dbba3c; }, function (v) { return $68aec2772563966a$export$c17eae7e86dbba3c = v; });
$parcel$export(module.exports, "SENTRY_DSC_TRACE_ID", function () { return $68aec2772563966a$export$349603c0a9165744; }, function (v) { return $68aec2772563966a$export$349603c0a9165744 = v; });
$parcel$export(module.exports, "SENTRY_DSC_TRANSACTION", function () { return $68aec2772563966a$export$4dadf693741f0283; }, function (v) { return $68aec2772563966a$export$4dadf693741f0283 = v; });
$parcel$export(module.exports, "SENTRY_ENVIRONMENT", function () { return $68aec2772563966a$export$6377864d12f7eeb3; }, function (v) { return $68aec2772563966a$export$6377864d12f7eeb3 = v; });
$parcel$export(module.exports, "SENTRY_EVENT_SERIALIZED_BREADCRUMBS", function () { return $68aec2772563966a$export$6b892e5faf9c65ec; }, function (v) { return $68aec2772563966a$export$6b892e5faf9c65ec = v; });
$parcel$export(module.exports, "SENTRY_EVENT_SERIALIZED_CONTEXTS", function () { return $68aec2772563966a$export$b93169be52dcfc1; }, function (v) { return $68aec2772563966a$export$b93169be52dcfc1 = v; });
$parcel$export(module.exports, "SENTRY_EVENT_SERIALIZED_EXTRA", function () { return $68aec2772563966a$export$69ffc9f31c260bb4; }, function (v) { return $68aec2772563966a$export$69ffc9f31c260bb4 = v; });
$parcel$export(module.exports, "SENTRY_EVENT_SERIALIZED_META", function () { return $68aec2772563966a$export$1679f9582e34ea8d; }, function (v) { return $68aec2772563966a$export$1679f9582e34ea8d = v; });
$parcel$export(module.exports, "SENTRY_EXCLUSIVE_TIME", function () { return $68aec2772563966a$export$ba081af9585ed4; }, function (v) { return $68aec2772563966a$export$ba081af9585ed4 = v; });
$parcel$export(module.exports, "SENTRY_FRAMES_FROZEN", function () { return $68aec2772563966a$export$13514311f5ad8904; }, function (v) { return $68aec2772563966a$export$13514311f5ad8904 = v; });
$parcel$export(module.exports, "SENTRY_FRAMES_SLOW", function () { return $68aec2772563966a$export$eaca45a91e334bc3; }, function (v) { return $68aec2772563966a$export$eaca45a91e334bc3 = v; });
$parcel$export(module.exports, "SENTRY_FRAMES_TOTAL", function () { return $68aec2772563966a$export$6d155392d40c193e; }, function (v) { return $68aec2772563966a$export$6d155392d40c193e = v; });
$parcel$export(module.exports, "SENTRY_GRAPHQL_OPERATION", function () { return $68aec2772563966a$export$7841dacb241485d0; }, function (v) { return $68aec2772563966a$export$7841dacb241485d0 = v; });
$parcel$export(module.exports, "SENTRY_GROUP", function () { return $68aec2772563966a$export$52c7044cf6301362; }, function (v) { return $68aec2772563966a$export$52c7044cf6301362 = v; });
$parcel$export(module.exports, "SENTRY_HTTP_PREFETCH", function () { return $68aec2772563966a$export$56ea1c9e44590e20; }, function (v) { return $68aec2772563966a$export$56ea1c9e44590e20 = v; });
$parcel$export(module.exports, "SENTRY_IDLE_SPAN_FINISH_REASON", function () { return $68aec2772563966a$export$7626e389d05f4c36; }, function (v) { return $68aec2772563966a$export$7626e389d05f4c36 = v; });
$parcel$export(module.exports, "SENTRY_IS_LOCALHOST", function () { return $68aec2772563966a$export$fd6d8217c43d52a0; }, function (v) { return $68aec2772563966a$export$fd6d8217c43d52a0 = v; });
$parcel$export(module.exports, "SENTRY_IS_REMOTE", function () { return $68aec2772563966a$export$5e0a48187329b2e7; }, function (v) { return $68aec2772563966a$export$5e0a48187329b2e7 = v; });
$parcel$export(module.exports, "SENTRY_KIND", function () { return $68aec2772563966a$export$c322b150d7667841; }, function (v) { return $68aec2772563966a$export$c322b150d7667841 = v; });
$parcel$export(module.exports, "SENTRY_LINK_TYPE", function () { return $68aec2772563966a$export$79ef102ff6c2276c; }, function (v) { return $68aec2772563966a$export$79ef102ff6c2276c = v; });
$parcel$export(module.exports, "SENTRY_MAIN_THREAD", function () { return $68aec2772563966a$export$4a4797d3c962f753; }, function (v) { return $68aec2772563966a$export$4a4797d3c962f753 = v; });
$parcel$export(module.exports, "SENTRY_MESSAGE_PARAMETER_KEY", function () { return $68aec2772563966a$export$767524d5e72e2645; }, function (v) { return $68aec2772563966a$export$767524d5e72e2645 = v; });
$parcel$export(module.exports, "SENTRY_MESSAGE_TEMPLATE", function () { return $68aec2772563966a$export$497354ca7b0ee666; }, function (v) { return $68aec2772563966a$export$497354ca7b0ee666 = v; });
$parcel$export(module.exports, "SENTRY_METRIC_SOURCE", function () { return $68aec2772563966a$export$cbdc4ad11118116a; }, function (v) { return $68aec2772563966a$export$cbdc4ad11118116a = v; });
$parcel$export(module.exports, "SENTRY_MOBILE", function () { return $68aec2772563966a$export$5b890de778c4c2fe; }, function (v) { return $68aec2772563966a$export$5b890de778c4c2fe = v; });
$parcel$export(module.exports, "SENTRY_MODULE_KEY", function () { return $68aec2772563966a$export$a78d9803b5e0a83e; }, function (v) { return $68aec2772563966a$export$a78d9803b5e0a83e = v; });
$parcel$export(module.exports, "SENTRY_MODULE_KEY_BASE", function () { return $68aec2772563966a$export$df1b536467b3992a; }, function (v) { return $68aec2772563966a$export$df1b536467b3992a = v; });
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_ROUTE", function () { return $68aec2772563966a$export$73104a329e205998; }, function (v) { return $68aec2772563966a$export$73104a329e205998 = v; });
$parcel$export(module.exports, "SENTRY_NEXTJS_SSR_FUNCTION_TYPE", function () { return $68aec2772563966a$export$5740e3da55330b0a; }, function (v) { return $68aec2772563966a$export$5740e3da55330b0a = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY", function () { return $68aec2772563966a$export$8dcc2d92ff6d65da; }, function (v) { return $68aec2772563966a$export$8dcc2d92ff6d65da = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DB_QUERY_HASH", function () { return $68aec2772563966a$export$e5f1321e53e24810; }, function (v) { return $68aec2772563966a$export$e5f1321e53e24810 = v; });
$parcel$export(module.exports, "SENTRY_NORMALIZED_DESCRIPTION", function () { return $68aec2772563966a$export$56dd3098cbca7c8a; }, function (v) { return $68aec2772563966a$export$56dd3098cbca7c8a = v; });
$parcel$export(module.exports, "SENTRY_OBSERVED_TIMESTAMP_NANOS", function () { return $68aec2772563966a$export$aa7aff70e4380665; }, function (v) { return $68aec2772563966a$export$aa7aff70e4380665 = v; });
$parcel$export(module.exports, "SENTRY_OP", function () { return $68aec2772563966a$export$dacb7d452aa6bcaf; }, function (v) { return $68aec2772563966a$export$dacb7d452aa6bcaf = v; });
$parcel$export(module.exports, "SENTRY_ORIGIN", function () { return $68aec2772563966a$export$15dfc6c5e8f9baf6; }, function (v) { return $68aec2772563966a$export$15dfc6c5e8f9baf6 = v; });
$parcel$export(module.exports, "SENTRY_PAGELOAD_SPAN_ID", function () { return $68aec2772563966a$export$e9a5de183fd08f2d; }, function (v) { return $68aec2772563966a$export$e9a5de183fd08f2d = v; });
$parcel$export(module.exports, "SENTRY_PLATFORM", function () { return $68aec2772563966a$export$91ad03bba7909fb5; }, function (v) { return $68aec2772563966a$export$91ad03bba7909fb5 = v; });
$parcel$export(module.exports, "SENTRY_PROFILER_ID", function () { return $68aec2772563966a$export$86128e6c0ab71d64; }, function (v) { return $68aec2772563966a$export$86128e6c0ab71d64 = v; });
$parcel$export(module.exports, "SENTRY_PROFILE_ID", function () { return $68aec2772563966a$export$745b60c4819aec1d; }, function (v) { return $68aec2772563966a$export$745b60c4819aec1d = v; });
$parcel$export(module.exports, "SENTRY_RELAY_INGRESS", function () { return $68aec2772563966a$export$f83a3ef33e3015f5; }, function (v) { return $68aec2772563966a$export$f83a3ef33e3015f5 = v; });
$parcel$export(module.exports, "SENTRY_RELAY_PIPELINE", function () { return $68aec2772563966a$export$4f324e8aab67771d; }, function (v) { return $68aec2772563966a$export$4f324e8aab67771d = v; });
$parcel$export(module.exports, "SENTRY_RELEASE", function () { return $68aec2772563966a$export$d2c893bfac1da9a1; }, function (v) { return $68aec2772563966a$export$d2c893bfac1da9a1 = v; });
$parcel$export(module.exports, "SENTRY_REPLAY_ID", function () { return $68aec2772563966a$export$1c14ad02f9534b19; }, function (v) { return $68aec2772563966a$export$1c14ad02f9534b19 = v; });
$parcel$export(module.exports, "SENTRY_REPLAY_IS_BUFFERING", function () { return $68aec2772563966a$export$db3cb63e0594d014; }, function (v) { return $68aec2772563966a$export$db3cb63e0594d014 = v; });
$parcel$export(module.exports, "SENTRY_REPORT_EVENT", function () { return $68aec2772563966a$export$a65c9a0eba2c222d; }, function (v) { return $68aec2772563966a$export$a65c9a0eba2c222d = v; });
$parcel$export(module.exports, "SENTRY_SDK_INTEGRATIONS", function () { return $68aec2772563966a$export$68dbcca9c0e339ec; }, function (v) { return $68aec2772563966a$export$68dbcca9c0e339ec = v; });
$parcel$export(module.exports, "SENTRY_SDK_NAME", function () { return $68aec2772563966a$export$d59b669d4bb3f006; }, function (v) { return $68aec2772563966a$export$d59b669d4bb3f006 = v; });
$parcel$export(module.exports, "SENTRY_SDK_VERSION", function () { return $68aec2772563966a$export$4d88d347aa9667fc; }, function (v) { return $68aec2772563966a$export$4d88d347aa9667fc = v; });
$parcel$export(module.exports, "SENTRY_SEGMENT_ID", function () { return $68aec2772563966a$export$9943ffdcaa4bc506; }, function (v) { return $68aec2772563966a$export$9943ffdcaa4bc506 = v; });
$parcel$export(module.exports, "SENTRY_SEGMENT_NAME", function () { return $68aec2772563966a$export$d4f25b923533dbba; }, function (v) { return $68aec2772563966a$export$d4f25b923533dbba = v; });
$parcel$export(module.exports, "SENTRY_SEGMENT_NAME_SOURCE", function () { return $68aec2772563966a$export$221a33f26f7c0739; }, function (v) { return $68aec2772563966a$export$221a33f26f7c0739 = v; });
$parcel$export(module.exports, "SENTRY_SERVER_SAMPLE_RATE", function () { return $68aec2772563966a$export$35f3396a1cdeea45; }, function (v) { return $68aec2772563966a$export$35f3396a1cdeea45 = v; });
$parcel$export(module.exports, "SENTRY_SOURCE", function () { return $68aec2772563966a$export$80e399da474bc98d; }, function (v) { return $68aec2772563966a$export$80e399da474bc98d = v; });
$parcel$export(module.exports, "SENTRY_SPAN_SOURCE", function () { return $68aec2772563966a$export$e01809e2dbceac35; }, function (v) { return $68aec2772563966a$export$e01809e2dbceac35 = v; });
$parcel$export(module.exports, "SENTRY_STATUS", function () { return $68aec2772563966a$export$41900d5c4e8a9c68; }, function (v) { return $68aec2772563966a$export$41900d5c4e8a9c68 = v; });
$parcel$export(module.exports, "SENTRY_STATUS_CODE", function () { return $68aec2772563966a$export$362bb1cb0bb5ca03; }, function (v) { return $68aec2772563966a$export$362bb1cb0bb5ca03 = v; });
$parcel$export(module.exports, "SENTRY_STATUS_MESSAGE", function () { return $68aec2772563966a$export$6803ac54f919d9cc; }, function (v) { return $68aec2772563966a$export$6803ac54f919d9cc = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_FROM", function () { return $68aec2772563966a$export$72f5b47540331169; }, function (v) { return $68aec2772563966a$export$72f5b47540331169 = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TO", function () { return $68aec2772563966a$export$6c61a8c9aa5305cb; }, function (v) { return $68aec2772563966a$export$6c61a8c9aa5305cb = v; });
$parcel$export(module.exports, "SENTRY_SVELTEKIT_NAVIGATION_TYPE", function () { return $68aec2772563966a$export$6b5244c457b68e65; }, function (v) { return $68aec2772563966a$export$6b5244c457b68e65 = v; });
$parcel$export(module.exports, "SENTRY_THREAD_ID", function () { return $68aec2772563966a$export$b7bd0c9a886f3414; }, function (v) { return $68aec2772563966a$export$b7bd0c9a886f3414 = v; });
$parcel$export(module.exports, "SENTRY_TIMESTAMP_SEQUENCE", function () { return $68aec2772563966a$export$6b77f2bacac7c93d; }, function (v) { return $68aec2772563966a$export$6b77f2bacac7c93d = v; });
$parcel$export(module.exports, "SENTRY_TRACE_LIFECYCLE", function () { return $68aec2772563966a$export$ddbc15c0e8e8a7ea; }, function (v) { return $68aec2772563966a$export$ddbc15c0e8e8a7ea = v; });
$parcel$export(module.exports, "SENTRY_TRACE_PARENT_SPAN_ID", function () { return $68aec2772563966a$export$feb4fe753df28a82; }, function (v) { return $68aec2772563966a$export$feb4fe753df28a82 = v; });
$parcel$export(module.exports, "SENTRY_TRACE_STATUS", function () { return $68aec2772563966a$export$d6267756132e2175; }, function (v) { return $68aec2772563966a$export$d6267756132e2175 = v; });
$parcel$export(module.exports, "SENTRY_TRANSACTION", function () { return $68aec2772563966a$export$570ac5a3fd7e6cc6; }, function (v) { return $68aec2772563966a$export$570ac5a3fd7e6cc6 = v; });
$parcel$export(module.exports, "SENTRY_USER_EMAIL", function () { return $68aec2772563966a$export$5b9a0015e1c530ed; }, function (v) { return $68aec2772563966a$export$5b9a0015e1c530ed = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_CITY", function () { return $68aec2772563966a$export$8bbff71c84508218; }, function (v) { return $68aec2772563966a$export$8bbff71c84508218 = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_COUNTRY_CODE", function () { return $68aec2772563966a$export$b55aa07a514a2430; }, function (v) { return $68aec2772563966a$export$b55aa07a514a2430 = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_REGION", function () { return $68aec2772563966a$export$9927ad09f7c084dc; }, function (v) { return $68aec2772563966a$export$9927ad09f7c084dc = v; });
$parcel$export(module.exports, "SENTRY_USER_GEO_SUBDIVISION", function () { return $68aec2772563966a$export$52a07a35ff8ec6b6; }, function (v) { return $68aec2772563966a$export$52a07a35ff8ec6b6 = v; });
$parcel$export(module.exports, "SENTRY_USER_ID", function () { return $68aec2772563966a$export$a10d277c42e6cae3; }, function (v) { return $68aec2772563966a$export$a10d277c42e6cae3 = v; });
$parcel$export(module.exports, "SENTRY_USER_IP", function () { return $68aec2772563966a$export$cdc0ce5c66182801; }, function (v) { return $68aec2772563966a$export$cdc0ce5c66182801 = v; });
$parcel$export(module.exports, "SENTRY_USER_USERNAME", function () { return $68aec2772563966a$export$2504d4bd698dd962; }, function (v) { return $68aec2772563966a$export$2504d4bd698dd962 = v; });
$parcel$export(module.exports, "SERVER_ADDRESS", function () { return $68aec2772563966a$export$9dc86f3b876e96ef; }, function (v) { return $68aec2772563966a$export$9dc86f3b876e96ef = v; });
$parcel$export(module.exports, "SERVER_NAME", function () { return $68aec2772563966a$export$70ff7865f52549ae; }, function (v) { return $68aec2772563966a$export$70ff7865f52549ae = v; });
$parcel$export(module.exports, "SERVER_PORT", function () { return $68aec2772563966a$export$f77b53a42be6e6fd; }, function (v) { return $68aec2772563966a$export$f77b53a42be6e6fd = v; });
$parcel$export(module.exports, "SERVICE_NAME", function () { return $68aec2772563966a$export$818eb7ab11414506; }, function (v) { return $68aec2772563966a$export$818eb7ab11414506 = v; });
$parcel$export(module.exports, "SERVICE_VERSION", function () { return $68aec2772563966a$export$829ef6b2e59d984d; }, function (v) { return $68aec2772563966a$export$829ef6b2e59d984d = v; });
$parcel$export(module.exports, "SESSION_ID", function () { return $68aec2772563966a$export$b30f4cb52c088a26; }, function (v) { return $68aec2772563966a$export$b30f4cb52c088a26 = v; });
$parcel$export(module.exports, "STALL_PERCENTAGE", function () { return $68aec2772563966a$export$335eace0ff1771cd; }, function (v) { return $68aec2772563966a$export$335eace0ff1771cd = v; });
$parcel$export(module.exports, "STALL_TOTAL_TIME", function () { return $68aec2772563966a$export$374d88a2025416ac; }, function (v) { return $68aec2772563966a$export$374d88a2025416ac = v; });
$parcel$export(module.exports, "STARLETTE_MIDDLEWARE_NAME", function () { return $68aec2772563966a$export$8c1c09aad940c209; }, function (v) { return $68aec2772563966a$export$8c1c09aad940c209 = v; });
$parcel$export(module.exports, "STARLITE_MIDDLEWARE_NAME", function () { return $68aec2772563966a$export$73086897ee87592; }, function (v) { return $68aec2772563966a$export$73086897ee87592 = v; });
$parcel$export(module.exports, "STATE_TYPE", function () { return $68aec2772563966a$export$bb7a91303551eb37; }, function (v) { return $68aec2772563966a$export$bb7a91303551eb37 = v; });
$parcel$export(module.exports, "SUBPROCESS_PID", function () { return $68aec2772563966a$export$d7c235242f462725; }, function (v) { return $68aec2772563966a$export$d7c235242f462725 = v; });
$parcel$export(module.exports, "SVELTEKIT_LOAD_ENVIRONMENT", function () { return $68aec2772563966a$export$66bace8969e2e3d5; }, function (v) { return $68aec2772563966a$export$66bace8969e2e3d5 = v; });
$parcel$export(module.exports, "SVELTEKIT_LOAD_NODE_ID", function () { return $68aec2772563966a$export$ace44ef9ab757803; }, function (v) { return $68aec2772563966a$export$ace44ef9ab757803 = v; });
$parcel$export(module.exports, "SVELTEKIT_LOAD_NODE_TYPE", function () { return $68aec2772563966a$export$73e8c5f1140c4791; }, function (v) { return $68aec2772563966a$export$73e8c5f1140c4791 = v; });
$parcel$export(module.exports, "SVELTEKIT_TRACING_ORIGINAL_NAME", function () { return $68aec2772563966a$export$77af2faf6df02a72; }, function (v) { return $68aec2772563966a$export$77af2faf6df02a72 = v; });
$parcel$export(module.exports, "THREAD_ID", function () { return $68aec2772563966a$export$f132ea291a7db56b; }, function (v) { return $68aec2772563966a$export$f132ea291a7db56b = v; });
$parcel$export(module.exports, "THREAD_NAME", function () { return $68aec2772563966a$export$f0abd4170bbd2468; }, function (v) { return $68aec2772563966a$export$f0abd4170bbd2468 = v; });
$parcel$export(module.exports, "TIMBER_TAG", function () { return $68aec2772563966a$export$50d00a157dc08581; }, function (v) { return $68aec2772563966a$export$50d00a157dc08581 = v; });
$parcel$export(module.exports, "TIME_TO_FULL_DISPLAY", function () { return $68aec2772563966a$export$484576567a98833f; }, function (v) { return $68aec2772563966a$export$484576567a98833f = v; });
$parcel$export(module.exports, "TIME_TO_INITIAL_DISPLAY", function () { return $68aec2772563966a$export$ec9e491e475d0c97; }, function (v) { return $68aec2772563966a$export$ec9e491e475d0c97 = v; });
$parcel$export(module.exports, "TRANSACTION", function () { return $68aec2772563966a$export$a86c59c10992220f; }, function (v) { return $68aec2772563966a$export$a86c59c10992220f = v; });
$parcel$export(module.exports, "TRPC_PROCEDURE_PATH", function () { return $68aec2772563966a$export$e12f06597e992fde; }, function (v) { return $68aec2772563966a$export$e12f06597e992fde = v; });
$parcel$export(module.exports, "TRPC_PROCEDURE_TYPE", function () { return $68aec2772563966a$export$7ec54678ba28ea59; }, function (v) { return $68aec2772563966a$export$7ec54678ba28ea59 = v; });
$parcel$export(module.exports, "TTFB", function () { return $68aec2772563966a$export$433ba14c16717110; }, function (v) { return $68aec2772563966a$export$433ba14c16717110 = v; });
$parcel$export(module.exports, "TTFB_REQUESTTIME", function () { return $68aec2772563966a$export$309ee349b8a537f; }, function (v) { return $68aec2772563966a$export$309ee349b8a537f = v; });
$parcel$export(module.exports, "TURBO_MODULES_TOTAL_CALL_COUNT", function () { return $68aec2772563966a$export$a344421384e4626b; }, function (v) { return $68aec2772563966a$export$a344421384e4626b = v; });
$parcel$export(module.exports, "TURBO_MODULES_TOTAL_DURATION_MS", function () { return $68aec2772563966a$export$e43f29da852027e9; }, function (v) { return $68aec2772563966a$export$e43f29da852027e9 = v; });
$parcel$export(module.exports, "TURBO_MODULES_TOTAL_ERROR_COUNT", function () { return $68aec2772563966a$export$f4e00a7a768abc8; }, function (v) { return $68aec2772563966a$export$f4e00a7a768abc8 = v; });
$parcel$export(module.exports, "TURBO_MODULES_UNIQUE_METHODS", function () { return $68aec2772563966a$export$7a5e4e7104ab3b9a; }, function (v) { return $68aec2772563966a$export$7a5e4e7104ab3b9a = v; });
$parcel$export(module.exports, "TURBO_MODULE_ARCH", function () { return $68aec2772563966a$export$905bea62c04473b4; }, function (v) { return $68aec2772563966a$export$905bea62c04473b4 = v; });
$parcel$export(module.exports, "TURBO_MODULE_METHOD", function () { return $68aec2772563966a$export$94549a3d156ca6e3; }, function (v) { return $68aec2772563966a$export$94549a3d156ca6e3 = v; });
$parcel$export(module.exports, "TURBO_MODULE_NAME", function () { return $68aec2772563966a$export$c64c67f496c0a458; }, function (v) { return $68aec2772563966a$export$c64c67f496c0a458 = v; });
$parcel$export(module.exports, "TURBO_MODULE_TOP_MODULE", function () { return $68aec2772563966a$export$9559a80e6d3976cf; }, function (v) { return $68aec2772563966a$export$9559a80e6d3976cf = v; });
$parcel$export(module.exports, "TURBO_MODULE_TOP_MODULE_DURATION_MS", function () { return $68aec2772563966a$export$ad5635d1786f4dce; }, function (v) { return $68aec2772563966a$export$ad5635d1786f4dce = v; });
$parcel$export(module.exports, "TURBO_MODULE_TOTAL_CALL_COUNT", function () { return $68aec2772563966a$export$281536c6742b39c8; }, function (v) { return $68aec2772563966a$export$281536c6742b39c8 = v; });
$parcel$export(module.exports, "TURBO_MODULE_TOTAL_DURATION_MS", function () { return $68aec2772563966a$export$e28d8f7876943c30; }, function (v) { return $68aec2772563966a$export$e28d8f7876943c30 = v; });
$parcel$export(module.exports, "TURBO_MODULE_TOTAL_ERROR_COUNT", function () { return $68aec2772563966a$export$ff74fcec9c21ca2b; }, function (v) { return $68aec2772563966a$export$ff74fcec9c21ca2b = v; });
$parcel$export(module.exports, "TURBO_MODULE_UNIQUE_METHODS", function () { return $68aec2772563966a$export$190fe5bf513bf32b; }, function (v) { return $68aec2772563966a$export$190fe5bf513bf32b = v; });
$parcel$export(module.exports, "TYPE", function () { return $68aec2772563966a$export$b87f371cbc396fcf; }, function (v) { return $68aec2772563966a$export$b87f371cbc396fcf = v; });
$parcel$export(module.exports, "UI_COMPONENT_NAME", function () { return $68aec2772563966a$export$60050fc49fe0e7e2; }, function (v) { return $68aec2772563966a$export$60050fc49fe0e7e2 = v; });
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTFD", function () { return $68aec2772563966a$export$348c8e2b37f276cd; }, function (v) { return $68aec2772563966a$export$348c8e2b37f276cd = v; });
$parcel$export(module.exports, "UI_CONTRIBUTES_TO_TTID", function () { return $68aec2772563966a$export$7f47e8a8b2d97cb2; }, function (v) { return $68aec2772563966a$export$7f47e8a8b2d97cb2 = v; });
$parcel$export(module.exports, "UI_ELEMENT_HEIGHT", function () { return $68aec2772563966a$export$50d5adc4b543ce95; }, function (v) { return $68aec2772563966a$export$50d5adc4b543ce95 = v; });
$parcel$export(module.exports, "UI_ELEMENT_ID", function () { return $68aec2772563966a$export$9221f1d2c934d9f; }, function (v) { return $68aec2772563966a$export$9221f1d2c934d9f = v; });
$parcel$export(module.exports, "UI_ELEMENT_IDENTIFIER", function () { return $68aec2772563966a$export$3a56578b3ae09a02; }, function (v) { return $68aec2772563966a$export$3a56578b3ae09a02 = v; });
$parcel$export(module.exports, "UI_ELEMENT_LOAD_TIME", function () { return $68aec2772563966a$export$e47b8dab9466c895; }, function (v) { return $68aec2772563966a$export$e47b8dab9466c895 = v; });
$parcel$export(module.exports, "UI_ELEMENT_PAINT_TYPE", function () { return $68aec2772563966a$export$4ca52f75cf4889c5; }, function (v) { return $68aec2772563966a$export$4ca52f75cf4889c5 = v; });
$parcel$export(module.exports, "UI_ELEMENT_RENDER_TIME", function () { return $68aec2772563966a$export$7343d7d72195067f; }, function (v) { return $68aec2772563966a$export$7343d7d72195067f = v; });
$parcel$export(module.exports, "UI_ELEMENT_TYPE", function () { return $68aec2772563966a$export$f334f32f8d4d8063; }, function (v) { return $68aec2772563966a$export$f334f32f8d4d8063 = v; });
$parcel$export(module.exports, "UI_ELEMENT_URL", function () { return $68aec2772563966a$export$c7bf2089e89a217c; }, function (v) { return $68aec2772563966a$export$c7bf2089e89a217c = v; });
$parcel$export(module.exports, "UI_ELEMENT_WIDTH", function () { return $68aec2772563966a$export$f514f97553a434b2; }, function (v) { return $68aec2772563966a$export$f514f97553a434b2 = v; });
$parcel$export(module.exports, "URL", function () { return $68aec2772563966a$export$61abde59b50deb8e; }, function (v) { return $68aec2772563966a$export$61abde59b50deb8e = v; });
$parcel$export(module.exports, "URL_DOMAIN", function () { return $68aec2772563966a$export$5a5ce44f9fb51f93; }, function (v) { return $68aec2772563966a$export$5a5ce44f9fb51f93 = v; });
$parcel$export(module.exports, "URL_FRAGMENT", function () { return $68aec2772563966a$export$7044ea8d89b6f59d; }, function (v) { return $68aec2772563966a$export$7044ea8d89b6f59d = v; });
$parcel$export(module.exports, "URL_FULL", function () { return $68aec2772563966a$export$40eacf1a072c9dbd; }, function (v) { return $68aec2772563966a$export$40eacf1a072c9dbd = v; });
$parcel$export(module.exports, "URL_PATH", function () { return $68aec2772563966a$export$4c1fa0ac0eff2ac; }, function (v) { return $68aec2772563966a$export$4c1fa0ac0eff2ac = v; });
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY", function () { return $68aec2772563966a$export$5bee9450fe31dde1; }, function (v) { return $68aec2772563966a$export$5bee9450fe31dde1 = v; });
$parcel$export(module.exports, "URL_PATH_PARAMETER_KEY_BASE", function () { return $68aec2772563966a$export$d0b571fb4406d953; }, function (v) { return $68aec2772563966a$export$d0b571fb4406d953 = v; });
$parcel$export(module.exports, "URL_PATH_PARAMS_KEY", function () { return $68aec2772563966a$export$d51317816423085d; }, function (v) { return $68aec2772563966a$export$d51317816423085d = v; });
$parcel$export(module.exports, "URL_PATH_PARAMS_KEY_BASE", function () { return $68aec2772563966a$export$96a83d41c14e5647; }, function (v) { return $68aec2772563966a$export$96a83d41c14e5647 = v; });
$parcel$export(module.exports, "URL_PORT", function () { return $68aec2772563966a$export$258b370e6c2b85d5; }, function (v) { return $68aec2772563966a$export$258b370e6c2b85d5 = v; });
$parcel$export(module.exports, "URL_QUERY", function () { return $68aec2772563966a$export$dc5e5523da291a4b; }, function (v) { return $68aec2772563966a$export$dc5e5523da291a4b = v; });
$parcel$export(module.exports, "URL_SAME_ORIGIN", function () { return $68aec2772563966a$export$fd5a8904ab5abfe0; }, function (v) { return $68aec2772563966a$export$fd5a8904ab5abfe0 = v; });
$parcel$export(module.exports, "URL_SCHEME", function () { return $68aec2772563966a$export$1350d8937b0f26fb; }, function (v) { return $68aec2772563966a$export$1350d8937b0f26fb = v; });
$parcel$export(module.exports, "URL_TEMPLATE", function () { return $68aec2772563966a$export$2a045f777fb349a8; }, function (v) { return $68aec2772563966a$export$2a045f777fb349a8 = v; });
$parcel$export(module.exports, "USER_AGENT_ORIGINAL", function () { return $68aec2772563966a$export$8bb874585539a88f; }, function (v) { return $68aec2772563966a$export$8bb874585539a88f = v; });
$parcel$export(module.exports, "USER_EMAIL", function () { return $68aec2772563966a$export$17d3a50785727199; }, function (v) { return $68aec2772563966a$export$17d3a50785727199 = v; });
$parcel$export(module.exports, "USER_FULL_NAME", function () { return $68aec2772563966a$export$2931c570009689e; }, function (v) { return $68aec2772563966a$export$2931c570009689e = v; });
$parcel$export(module.exports, "USER_GEO_CITY", function () { return $68aec2772563966a$export$199cbcedee735a43; }, function (v) { return $68aec2772563966a$export$199cbcedee735a43 = v; });
$parcel$export(module.exports, "USER_GEO_COUNTRY_CODE", function () { return $68aec2772563966a$export$4ba5bf9d4e3ed862; }, function (v) { return $68aec2772563966a$export$4ba5bf9d4e3ed862 = v; });
$parcel$export(module.exports, "USER_GEO_REGION", function () { return $68aec2772563966a$export$674c01ec2f0b89c3; }, function (v) { return $68aec2772563966a$export$674c01ec2f0b89c3 = v; });
$parcel$export(module.exports, "USER_GEO_SUBDIVISION", function () { return $68aec2772563966a$export$bda1686739fd61c7; }, function (v) { return $68aec2772563966a$export$bda1686739fd61c7 = v; });
$parcel$export(module.exports, "USER_HASH", function () { return $68aec2772563966a$export$8d804148f485d54c; }, function (v) { return $68aec2772563966a$export$8d804148f485d54c = v; });
$parcel$export(module.exports, "USER_ID", function () { return $68aec2772563966a$export$212a8f1ea37518bd; }, function (v) { return $68aec2772563966a$export$212a8f1ea37518bd = v; });
$parcel$export(module.exports, "USER_IP_ADDRESS", function () { return $68aec2772563966a$export$c9ac0fee28245883; }, function (v) { return $68aec2772563966a$export$c9ac0fee28245883 = v; });
$parcel$export(module.exports, "USER_NAME", function () { return $68aec2772563966a$export$77078610759fe5f6; }, function (v) { return $68aec2772563966a$export$77078610759fe5f6 = v; });
$parcel$export(module.exports, "USER_ROLES", function () { return $68aec2772563966a$export$7c6317deeec7a6c1; }, function (v) { return $68aec2772563966a$export$7c6317deeec7a6c1 = v; });
$parcel$export(module.exports, "VERCEL_BRANCH", function () { return $68aec2772563966a$export$877ebf2e4ad81f03; }, function (v) { return $68aec2772563966a$export$877ebf2e4ad81f03 = v; });
$parcel$export(module.exports, "VERCEL_BUILD_ID", function () { return $68aec2772563966a$export$70b2343945496e1f; }, function (v) { return $68aec2772563966a$export$70b2343945496e1f = v; });
$parcel$export(module.exports, "VERCEL_DEPLOYMENT_ID", function () { return $68aec2772563966a$export$8415b56d2c6d2b1d; }, function (v) { return $68aec2772563966a$export$8415b56d2c6d2b1d = v; });
$parcel$export(module.exports, "VERCEL_DESTINATION", function () { return $68aec2772563966a$export$cc81114a03caab18; }, function (v) { return $68aec2772563966a$export$cc81114a03caab18 = v; });
$parcel$export(module.exports, "VERCEL_EDGE_TYPE", function () { return $68aec2772563966a$export$bc14eb892daceb23; }, function (v) { return $68aec2772563966a$export$bc14eb892daceb23 = v; });
$parcel$export(module.exports, "VERCEL_ENTRYPOINT", function () { return $68aec2772563966a$export$3c973217450c3e9d; }, function (v) { return $68aec2772563966a$export$3c973217450c3e9d = v; });
$parcel$export(module.exports, "VERCEL_EXECUTION_REGION", function () { return $68aec2772563966a$export$582c0b730ff1ddb9; }, function (v) { return $68aec2772563966a$export$582c0b730ff1ddb9 = v; });
$parcel$export(module.exports, "VERCEL_ID", function () { return $68aec2772563966a$export$b3edfb545b65f1c5; }, function (v) { return $68aec2772563966a$export$b3edfb545b65f1c5 = v; });
$parcel$export(module.exports, "VERCEL_JA3_DIGEST", function () { return $68aec2772563966a$export$2593317d8731841c; }, function (v) { return $68aec2772563966a$export$2593317d8731841c = v; });
$parcel$export(module.exports, "VERCEL_JA4_DIGEST", function () { return $68aec2772563966a$export$8bb5bc1732aa41f; }, function (v) { return $68aec2772563966a$export$8bb5bc1732aa41f = v; });
$parcel$export(module.exports, "VERCEL_LOG_TYPE", function () { return $68aec2772563966a$export$74a79c98b110b5b9; }, function (v) { return $68aec2772563966a$export$74a79c98b110b5b9 = v; });
$parcel$export(module.exports, "VERCEL_PATH", function () { return $68aec2772563966a$export$26461b03281b4db4; }, function (v) { return $68aec2772563966a$export$26461b03281b4db4 = v; });
$parcel$export(module.exports, "VERCEL_PROJECT_ID", function () { return $68aec2772563966a$export$eaea590d6d3dd93c; }, function (v) { return $68aec2772563966a$export$eaea590d6d3dd93c = v; });
$parcel$export(module.exports, "VERCEL_PROJECT_NAME", function () { return $68aec2772563966a$export$af45365f70099379; }, function (v) { return $68aec2772563966a$export$af45365f70099379 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_CACHE_ID", function () { return $68aec2772563966a$export$a49e732d34d5ba9b; }, function (v) { return $68aec2772563966a$export$a49e732d34d5ba9b = v; });
$parcel$export(module.exports, "VERCEL_PROXY_CLIENT_IP", function () { return $68aec2772563966a$export$7c147fe246bc8bd3; }, function (v) { return $68aec2772563966a$export$7c147fe246bc8bd3 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_HOST", function () { return $68aec2772563966a$export$e5111b6070e1ee9e; }, function (v) { return $68aec2772563966a$export$e5111b6070e1ee9e = v; });
$parcel$export(module.exports, "VERCEL_PROXY_LAMBDA_REGION", function () { return $68aec2772563966a$export$591cbfd403f8c8d; }, function (v) { return $68aec2772563966a$export$591cbfd403f8c8d = v; });
$parcel$export(module.exports, "VERCEL_PROXY_METHOD", function () { return $68aec2772563966a$export$b1388db955bbb885; }, function (v) { return $68aec2772563966a$export$b1388db955bbb885 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH", function () { return $68aec2772563966a$export$e898d0e9e211abd9; }, function (v) { return $68aec2772563966a$export$e898d0e9e211abd9 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE", function () { return $68aec2772563966a$export$ab6fee0e8a6ee069; }, function (v) { return $68aec2772563966a$export$ab6fee0e8a6ee069 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_PATH_TYPE_VARIANT", function () { return $68aec2772563966a$export$9786ad94c199ffbb; }, function (v) { return $68aec2772563966a$export$9786ad94c199ffbb = v; });
$parcel$export(module.exports, "VERCEL_PROXY_REFERER", function () { return $68aec2772563966a$export$269890524eed693b; }, function (v) { return $68aec2772563966a$export$269890524eed693b = v; });
$parcel$export(module.exports, "VERCEL_PROXY_REGION", function () { return $68aec2772563966a$export$2ec623a8212d6b64; }, function (v) { return $68aec2772563966a$export$2ec623a8212d6b64 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_RESPONSE_BYTE_SIZE", function () { return $68aec2772563966a$export$30e7673b01ff994e; }, function (v) { return $68aec2772563966a$export$30e7673b01ff994e = v; });
$parcel$export(module.exports, "VERCEL_PROXY_SCHEME", function () { return $68aec2772563966a$export$9ea93477840812bf; }, function (v) { return $68aec2772563966a$export$9ea93477840812bf = v; });
$parcel$export(module.exports, "VERCEL_PROXY_STATUS_CODE", function () { return $68aec2772563966a$export$a6da0c365670c430; }, function (v) { return $68aec2772563966a$export$a6da0c365670c430 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_TIMESTAMP", function () { return $68aec2772563966a$export$7986b22da43f2885; }, function (v) { return $68aec2772563966a$export$7986b22da43f2885 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_USER_AGENT", function () { return $68aec2772563966a$export$a9f943c7ceb3b42f; }, function (v) { return $68aec2772563966a$export$a9f943c7ceb3b42f = v; });
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_CACHE", function () { return $68aec2772563966a$export$dfe49501efcdffce; }, function (v) { return $68aec2772563966a$export$dfe49501efcdffce = v; });
$parcel$export(module.exports, "VERCEL_PROXY_VERCEL_ID", function () { return $68aec2772563966a$export$be465f50c92eb01d; }, function (v) { return $68aec2772563966a$export$be465f50c92eb01d = v; });
$parcel$export(module.exports, "VERCEL_PROXY_WAF_ACTION", function () { return $68aec2772563966a$export$c138d1796bb34999; }, function (v) { return $68aec2772563966a$export$c138d1796bb34999 = v; });
$parcel$export(module.exports, "VERCEL_PROXY_WAF_RULE_ID", function () { return $68aec2772563966a$export$85a0016690a0ccf2; }, function (v) { return $68aec2772563966a$export$85a0016690a0ccf2 = v; });
$parcel$export(module.exports, "VERCEL_REQUEST_ID", function () { return $68aec2772563966a$export$883acab36ede4bfa; }, function (v) { return $68aec2772563966a$export$883acab36ede4bfa = v; });
$parcel$export(module.exports, "VERCEL_SOURCE", function () { return $68aec2772563966a$export$9cfc88d203f9cdf1; }, function (v) { return $68aec2772563966a$export$9cfc88d203f9cdf1 = v; });
$parcel$export(module.exports, "VERCEL_STATUS_CODE", function () { return $68aec2772563966a$export$b3c6c599110d7bab; }, function (v) { return $68aec2772563966a$export$b3c6c599110d7bab = v; });
$parcel$export(module.exports, "_AI_MODEL_ID", function () { return $68aec2772563966a$export$700a3f96cb39930; }, function (v) { return $68aec2772563966a$export$700a3f96cb39930 = v; });
$parcel$export(module.exports, "_AWS_KINESIS_STREAM_NAME", function () { return $68aec2772563966a$export$247839c65766758; }, function (v) { return $68aec2772563966a$export$247839c65766758 = v; });
$parcel$export(module.exports, "_AWS_REQUEST_ID", function () { return $68aec2772563966a$export$f4d52b02df927d54; }, function (v) { return $68aec2772563966a$export$f4d52b02df927d54 = v; });
$parcel$export(module.exports, "_GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS", function () { return $68aec2772563966a$export$8baf9330c244c0ee; }, function (v) { return $68aec2772563966a$export$8baf9330c244c0ee = v; });
$parcel$export(module.exports, "_GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS", function () { return $68aec2772563966a$export$7d0cb6c474a8d8dd; }, function (v) { return $68aec2772563966a$export$7d0cb6c474a8d8dd = v; });
$parcel$export(module.exports, "_HTTP_REQUEST_METHOD", function () { return $68aec2772563966a$export$df30ee8c5b5f1989; }, function (v) { return $68aec2772563966a$export$df30ee8c5b5f1989 = v; });
$parcel$export(module.exports, "_MESSAGING_MESSAGE_ID", function () { return $68aec2772563966a$export$ae4fc52420ecd4bc; }, function (v) { return $68aec2772563966a$export$ae4fc52420ecd4bc = v; });
$parcel$export(module.exports, "_SENTRY_SEGMENT_ID", function () { return $68aec2772563966a$export$268a117c860fca6d; }, function (v) { return $68aec2772563966a$export$268a117c860fca6d = v; });
var $68aec2772563966a$export$13e35b21ad6ab4fe;
var $68aec2772563966a$export$b60c5e9f9b7b58bd;
var $68aec2772563966a$export$cc06afd6de7f2c10;
var $68aec2772563966a$export$ced6746028fe2cc;
var $68aec2772563966a$export$e6f4aa4f4fcb6da8;
var $68aec2772563966a$export$f02d892201cd8d36;
var $68aec2772563966a$export$f277a7ef9e273960;
var $68aec2772563966a$export$1a8c212c3becaa80;
var $68aec2772563966a$export$721b137086c68a47;
var $68aec2772563966a$export$6afde2bb69d9aa86;
var $68aec2772563966a$export$eadb4b562c974031;
var $68aec2772563966a$export$22a90f0ac1eee843;
var $68aec2772563966a$export$a727f215a0be1dad;
var $68aec2772563966a$export$536bc61b34d995e5;
var $68aec2772563966a$export$c43ea6115b380e62;
var $68aec2772563966a$export$d2a16e26bada7cf1;
var $68aec2772563966a$export$877414c19c336240;
var $68aec2772563966a$export$1498f8372e4fee19;
var $68aec2772563966a$export$604eb1bd2278163b;
var $68aec2772563966a$export$c6fb15d10a4d52fb;
var $68aec2772563966a$export$2f8568696c5aa352;
var $68aec2772563966a$export$ccc8efd7dd31d3a9;
var $68aec2772563966a$export$e176bf5dc45e40df;
var $68aec2772563966a$export$2d16fe6a423eac16;
var $68aec2772563966a$export$40c10cc901ec8391;
var $68aec2772563966a$export$e1b5b90d002f47d3;
var $68aec2772563966a$export$8028cf93afd5c238;
var $68aec2772563966a$export$5cd566e59be6c821;
var $68aec2772563966a$export$388cc595db1f932c;
var $68aec2772563966a$export$a936650e1567c02b;
var $68aec2772563966a$export$c4ea01fd53f64e16;
var $68aec2772563966a$export$bb5e6f2f31a15da9;
var $68aec2772563966a$export$1762c11b666b026a;
var $68aec2772563966a$export$14ddd4b729910100;
var $68aec2772563966a$export$5311d7c8e1f8eabb;
var $68aec2772563966a$export$2b748b9eca00828b;
var $68aec2772563966a$export$5af25308c11addea;
var $68aec2772563966a$export$a51938f8e97cb2e;
var $68aec2772563966a$export$6fe9e1ed3c313f24;
var $68aec2772563966a$export$28f78b3b1663cb92;
var $68aec2772563966a$export$a1d3f09f0f1f066f;
var $68aec2772563966a$export$322bd4ea9f163663;
var $68aec2772563966a$export$95711b9e669edad8;
var $68aec2772563966a$export$5924d7d72384626a;
var $68aec2772563966a$export$db3b1b877a4ce4db;
var $68aec2772563966a$export$8fbf006bb94d3322;
var $68aec2772563966a$export$32ce2b08edad22f;
var $68aec2772563966a$export$a434a3e8afec2879;
var $68aec2772563966a$export$fe00bb20636d42af;
var $68aec2772563966a$export$712aa698b7ee271e;
var $68aec2772563966a$export$1fac638b11ec16d9;
var $68aec2772563966a$export$d132016ea64058e3;
var $68aec2772563966a$export$53f2f47ec3b2f9ed;
var $68aec2772563966a$export$9f80c4b11053cef1;
var $68aec2772563966a$export$5f7a08466d84e877;
var $68aec2772563966a$export$2cea7f14750b8c19;
var $68aec2772563966a$export$34c59270f032a6c6;
var $68aec2772563966a$export$5b6c28c7dca07ad7;
var $68aec2772563966a$export$1dc8ae58b58d6c50;
var $68aec2772563966a$export$ba267414e3c0d822;
var $68aec2772563966a$export$71b176005902b99e;
var $68aec2772563966a$export$5c5b5a3c245a0079;
var $68aec2772563966a$export$8ee1df3c6367a60;
var $68aec2772563966a$export$e8c7802ae95beccf;
var $68aec2772563966a$export$bb237734da4d464;
var $68aec2772563966a$export$e8f43f7d235efa53;
var $68aec2772563966a$export$cdaaf6d1fdcba0b6;
var $68aec2772563966a$export$be392f76344cb225;
var $68aec2772563966a$export$36223ebd4a30e9f5;
var $68aec2772563966a$export$d4496a3605a4ce4a;
var $68aec2772563966a$export$daee97894fa9844;
var $68aec2772563966a$export$8feaa177bb7941e2;
var $68aec2772563966a$export$e1ca25240db91d68;
var $68aec2772563966a$export$404a223fd1ada08b;
var $68aec2772563966a$export$53362079310c68;
var $68aec2772563966a$export$3efb5af0ac379f77;
var $68aec2772563966a$export$2c10c1ca0612c46d;
var $68aec2772563966a$export$bbb86ad4d6654da6;
var $68aec2772563966a$export$ad6896f00a2b1076;
var $68aec2772563966a$export$300f39d8506a273d;
var $68aec2772563966a$export$ecaa0e7f4773ddc7;
var $68aec2772563966a$export$74b78acb4c54c06b;
var $68aec2772563966a$export$b15b2c133bc50e33;
var $68aec2772563966a$export$5f1381d9ae1b1c95;
var $68aec2772563966a$export$c170b7ff277132ea;
var $68aec2772563966a$export$9459a5df93695e45;
var $68aec2772563966a$export$a7902bd57492ebe8;
var $68aec2772563966a$export$d2ace0da59da09b7;
var $68aec2772563966a$export$c15dd8d2461e0aeb;
var $68aec2772563966a$export$5405b0a98e00e538;
var $68aec2772563966a$export$bd393bbb84b309d3;
var $68aec2772563966a$export$96f586f8837b86ae;
var $68aec2772563966a$export$5d9f28f388f552d2;
var $68aec2772563966a$export$b3d2f68e0e769504;
var $68aec2772563966a$export$2c98412ed43013e8;
var $68aec2772563966a$export$a7bd794d11c19f1b;
var $68aec2772563966a$export$df4227832b83fdd0;
var $68aec2772563966a$export$f131a6d8fbc0534f;
var $68aec2772563966a$export$9bdc66d4a70e7e3a;
var $68aec2772563966a$export$bfbbc3cbcaa90e98;
var $68aec2772563966a$export$3565fa72459aa4d6;
var $68aec2772563966a$export$bb67a834ae4bffdc;
var $68aec2772563966a$export$4a06c859a283f06;
var $68aec2772563966a$export$68324fac2038d0f2;
var $68aec2772563966a$export$5e1bd62ffd2786fb;
var $68aec2772563966a$export$bfdf2261058f56b;
var $68aec2772563966a$export$23bf57842d9d53df;
var $68aec2772563966a$export$bfbd7e060eeb4d35;
var $68aec2772563966a$export$82eb6cccda27c3ff;
var $68aec2772563966a$export$8ea68734d455808f;
var $68aec2772563966a$export$40050e29324d44ee;
var $68aec2772563966a$export$5cd7541006d9f467;
var $68aec2772563966a$export$81c017edd95d692e;
var $68aec2772563966a$export$120b3897a58cf903;
var $68aec2772563966a$export$d4a9de43b4b1076c;
var $68aec2772563966a$export$f37f4f9022f1ab17;
var $68aec2772563966a$export$66ac18da14747cfb;
var $68aec2772563966a$export$9e49b833525ca49d;
var $68aec2772563966a$export$b084fea5b3097227;
var $68aec2772563966a$export$e09cd8615652e8d0;
var $68aec2772563966a$export$a43a60ec723a90ee;
var $68aec2772563966a$export$34cc955357266287;
var $68aec2772563966a$export$d9dd218693ea9bba;
var $68aec2772563966a$export$c9649b7156282a2f;
var $68aec2772563966a$export$daa8ce1f8adc553e;
var $68aec2772563966a$export$cb93c7b05db202cf;
var $68aec2772563966a$export$930f9bd3cc2e5b3d;
var $68aec2772563966a$export$510ec6f90a56eedb;
var $68aec2772563966a$export$e3cc872f2ecbbd04;
var $68aec2772563966a$export$48c6d4c44afdc0b;
var $68aec2772563966a$export$c78d41789fe4b1e4;
var $68aec2772563966a$export$953d105334798b18;
var $68aec2772563966a$export$f462d9921f1f7332;
var $68aec2772563966a$export$bc71f8df9a45e243;
var $68aec2772563966a$export$ed840ec4a5f5d053;
var $68aec2772563966a$export$c1a559a4f74a5e8e;
var $68aec2772563966a$export$d1c007424092e3f5;
var $68aec2772563966a$export$9ebb466ce954c49c;
var $68aec2772563966a$export$d117453007717d8f;
var $68aec2772563966a$export$19cec2ad2bf22a37;
var $68aec2772563966a$export$dc6e464b9f2085c2;
var $68aec2772563966a$export$316882140da7c633;
var $68aec2772563966a$export$e9aafc7348984403;
var $68aec2772563966a$export$40f2351e1d598630;
var $68aec2772563966a$export$ccbaf9e1e7d48f46;
var $68aec2772563966a$export$5655f37b28bcd3e;
var $68aec2772563966a$export$faaa46964f075237;
var $68aec2772563966a$export$d28c4b3cc4431a87;
var $68aec2772563966a$export$734b017b330c8fe6;
var $68aec2772563966a$export$683ebdc48ba3758d;
var $68aec2772563966a$export$be0263971250ef44;
var $68aec2772563966a$export$36a0cbc35c405232;
var $68aec2772563966a$export$469f7765ba335497;
var $68aec2772563966a$export$fe6fe2b7af051610;
var $68aec2772563966a$export$8345821877c4dfad;
var $68aec2772563966a$export$f6c188a7e02335cf;
var $68aec2772563966a$export$aaf709a8971e825f;
var $68aec2772563966a$export$def01b82f8c092f7;
var $68aec2772563966a$export$23d4264c606a73a6;
var $68aec2772563966a$export$269a5d262a851975;
var $68aec2772563966a$export$4635c18f8b9bf9fa;
var $68aec2772563966a$export$af9ece53bb92f66b;
var $68aec2772563966a$export$25421625a565b69;
var $68aec2772563966a$export$ab0c90d873e69ccb;
var $68aec2772563966a$export$538c05cc8cb2a2bb;
var $68aec2772563966a$export$f86df4de196e1a7c;
var $68aec2772563966a$export$51e8aa8c0d65e7b8;
var $68aec2772563966a$export$99023486ecc470bd;
var $68aec2772563966a$export$2f6c85eaf382e81;
var $68aec2772563966a$export$1158d57c0aed42be;
var $68aec2772563966a$export$d85c4f947ab776e3;
var $68aec2772563966a$export$813ef8386d874918;
var $68aec2772563966a$export$7c2f74ff9251f64;
var $68aec2772563966a$export$85d6623900ff3afa;
var $68aec2772563966a$export$993f84dab107b880;
var $68aec2772563966a$export$7b9c2315e94d8d2f;
var $68aec2772563966a$export$f01e5cd42b9ec146;
var $68aec2772563966a$export$edfab5e0feeeee5a;
var $68aec2772563966a$export$987f6b4367434b55;
var $68aec2772563966a$export$d9d145585d5022bb;
var $68aec2772563966a$export$44ffba16bd48dac6;
var $68aec2772563966a$export$3134892c5d2e251a;
var $68aec2772563966a$export$8495028d10296058;
var $68aec2772563966a$export$d6d0e4fcf46d490c;
var $68aec2772563966a$export$658dced473c19301;
var $68aec2772563966a$export$97b0f9c3fbe64076;
var $68aec2772563966a$export$cf2c95ed5efbe9eb;
var $68aec2772563966a$export$880007904f61a388;
var $68aec2772563966a$export$3e903b72d4d9e07d;
var $68aec2772563966a$export$34da07180e0e56af;
var $68aec2772563966a$export$c49aafdaeb061953;
var $68aec2772563966a$export$ceb762c61de2f17f;
var $68aec2772563966a$export$a5f54ccfb28c0caf;
var $68aec2772563966a$export$1c86a56857b024db;
var $68aec2772563966a$export$7598f3464be47440;
var $68aec2772563966a$export$b673289c971fc0ae;
var $68aec2772563966a$export$98b23f3e6f0c2a6f;
var $68aec2772563966a$export$6ddeaf0498614ebb;
var $68aec2772563966a$export$97b78f78d64a7232;
var $68aec2772563966a$export$5147715be870fff7;
var $68aec2772563966a$export$5276bb46e6096fba;
var $68aec2772563966a$export$cbcbc1f67a937cf3;
var $68aec2772563966a$export$226a2381b8f0cf78;
var $68aec2772563966a$export$fd35512cae286064;
var $68aec2772563966a$export$de9bbf95ab1d81e;
var $68aec2772563966a$export$47fb20e8d18d7d15;
var $68aec2772563966a$export$9db7964e4b8cb849;
var $68aec2772563966a$export$7139adf9d3bace41;
var $68aec2772563966a$export$8ac3d09060e7f25d;
var $68aec2772563966a$export$dad0e4778ea23971;
var $68aec2772563966a$export$ec5856072852bd7f;
var $68aec2772563966a$export$c14d903ccf9385a8;
var $68aec2772563966a$export$934cded0041affd7;
var $68aec2772563966a$export$6386da1dcba88c9d;
var $68aec2772563966a$export$a3371797e606e2;
var $68aec2772563966a$export$a5bbef0af83b23e5;
var $68aec2772563966a$export$91ed1f55874222a6;
var $68aec2772563966a$export$23de81068d2aed1b;
var $68aec2772563966a$export$d738320e1fba9e9d;
var $68aec2772563966a$export$2eacdea75497e8a5;
var $68aec2772563966a$export$2bc3ea101f86c1d2;
var $68aec2772563966a$export$c54e27e8d90ee081;
var $68aec2772563966a$export$4943adcec371c2a6;
var $68aec2772563966a$export$f000a5900d0480c2;
var $68aec2772563966a$export$8f5234893868273b;
var $68aec2772563966a$export$1a35518f6e81e8c7;
var $68aec2772563966a$export$5ee62d9d393aab9d;
var $68aec2772563966a$export$a2d90911eaae60fc;
var $68aec2772563966a$export$879058fdeee47603;
var $68aec2772563966a$export$3c22ff8b64b8f565;
var $68aec2772563966a$export$b8019c0e2a5b5f0f;
var $68aec2772563966a$export$8c11477e471467c8;
var $68aec2772563966a$export$92a96f6363488aee;
var $68aec2772563966a$export$f91beb6088f9ded9;
var $68aec2772563966a$export$24bf9bb5ba9c544;
var $68aec2772563966a$export$78bc7224576bf289;
var $68aec2772563966a$export$a8027e0ea0d93ca;
var $68aec2772563966a$export$5e59d3aea52e5037;
var $68aec2772563966a$export$47e408be0da7933f;
var $68aec2772563966a$export$d5772b934ca13e57;
var $68aec2772563966a$export$36e47f6a5777561d;
var $68aec2772563966a$export$e768cbc99cd68acf;
var $68aec2772563966a$export$dfcc6c69df1343f2;
var $68aec2772563966a$export$69b0a5d9226b5211;
var $68aec2772563966a$export$da010a4f4fc971ae;
var $68aec2772563966a$export$5d515b35be0601a0;
var $68aec2772563966a$export$3e1b1037a315c5ca;
var $68aec2772563966a$export$847fdd494825f0fb;
var $68aec2772563966a$export$a9d76f26c6c730a9;
var $68aec2772563966a$export$de03f86d1c9866ca;
var $68aec2772563966a$export$65798ecab7eef8c;
var $68aec2772563966a$export$22aa61f48b9c79a0;
var $68aec2772563966a$export$69f5fb98f5aed812;
var $68aec2772563966a$export$bdea5d1006fd280a;
var $68aec2772563966a$export$f63a7230c5b1d609;
var $68aec2772563966a$export$6f25e59b05bb8e17;
var $68aec2772563966a$export$a56ad13c4afc7421;
var $68aec2772563966a$export$d9ce89ce8912bf12;
var $68aec2772563966a$export$17094e5f380e4162;
var $68aec2772563966a$export$28a0ffdf747973a0;
var $68aec2772563966a$export$5480ae1ba5d50bb9;
var $68aec2772563966a$export$edc72ee4a17f5152;
var $68aec2772563966a$export$19e4df138d354f8b;
var $68aec2772563966a$export$92b0d20fa482b4b2;
var $68aec2772563966a$export$3f638a793d61933f;
var $68aec2772563966a$export$3f511731cc3687d4;
var $68aec2772563966a$export$692b08741d6b6265;
var $68aec2772563966a$export$cf67f8cb2324428e;
var $68aec2772563966a$export$9d4197c1ffc5f359;
var $68aec2772563966a$export$509634fbff540e75;
var $68aec2772563966a$export$ccbc4fdff4b5eff5;
var $68aec2772563966a$export$e0cb371ca548b1d6;
var $68aec2772563966a$export$3c39026d09026bc2;
var $68aec2772563966a$export$bf9e8248cb72cf00;
var $68aec2772563966a$export$1054f22a72121d0f;
var $68aec2772563966a$export$723b8a59dad2e467;
var $68aec2772563966a$export$160081ff141bac8e;
var $68aec2772563966a$export$194f62c84d27310;
var $68aec2772563966a$export$7ed866d57b018d09;
var $68aec2772563966a$export$d50bae4562e03e5;
var $68aec2772563966a$export$649ea67a18fe8e8b;
var $68aec2772563966a$export$136a5c1b43caaccd;
var $68aec2772563966a$export$e33a28ea554b6ddc;
var $68aec2772563966a$export$acbe2d25ac76ea64;
var $68aec2772563966a$export$793c13e17d7e5e2b;
var $68aec2772563966a$export$a5617e33b89fd956;
var $68aec2772563966a$export$b51f82164fa31e07;
var $68aec2772563966a$export$f2ef55183c04d202;
var $68aec2772563966a$export$7c98fc0c48a16b1c;
var $68aec2772563966a$export$f5ebee1eec7be08f;
var $68aec2772563966a$export$9ba827a5872de47f;
var $68aec2772563966a$export$f0511e328234ae83;
var $68aec2772563966a$export$be46596bc6608f3b;
var $68aec2772563966a$export$f215947b3d76a6b7;
var $68aec2772563966a$export$89bbc91416db6670;
var $68aec2772563966a$export$b4b5eff8a8712c89;
var $68aec2772563966a$export$f455969a57ab8a03;
var $68aec2772563966a$export$13f2f8f42af49cec;
var $68aec2772563966a$export$cd357afe2ffdd2c3;
var $68aec2772563966a$export$d9ca2a279a11be5e;
var $68aec2772563966a$export$bbd59a8c7efad4c9;
var $68aec2772563966a$export$8413282a17f1cda5;
var $68aec2772563966a$export$30d19ddc7705e7e8;
var $68aec2772563966a$export$64a4f09e2444b3d;
var $68aec2772563966a$export$645b039fe163809e;
var $68aec2772563966a$export$b23ef8b8ffa607e1;
var $68aec2772563966a$export$8bf64516740c1369;
var $68aec2772563966a$export$9a0dc8e612f3e10b;
var $68aec2772563966a$export$abe90fedb3dddda2;
var $68aec2772563966a$export$4a19da9c85ed2ade;
var $68aec2772563966a$export$5e091479f094bdbc;
var $68aec2772563966a$export$d70909b5aa96a79a;
var $68aec2772563966a$export$651d142a8017d83d;
var $68aec2772563966a$export$44382a010a9f7fcf;
var $68aec2772563966a$export$807abfdc6b7b9338;
var $68aec2772563966a$export$31881d07f2569218;
var $68aec2772563966a$export$510aede74636c2c4;
var $68aec2772563966a$export$c347ed9cee998637;
var $68aec2772563966a$export$e5bbf306deb709a6;
var $68aec2772563966a$export$aa8721167c5c8d2d;
var $68aec2772563966a$export$757b93e5b3adc7cb;
var $68aec2772563966a$export$f869eaa92db1dc9b;
var $68aec2772563966a$export$5d1d761e41c32d9e;
var $68aec2772563966a$export$8aec72d9491f9399;
var $68aec2772563966a$export$5562635d2be2ab25;
var $68aec2772563966a$export$2dc31837ce6f7a3d;
var $68aec2772563966a$export$b561df15f64d32e3;
var $68aec2772563966a$export$181f78b28f2ffa57;
var $68aec2772563966a$export$6c97c77b89571c75;
var $68aec2772563966a$export$51e431eaf1f9bf58;
var $68aec2772563966a$export$71429c7ef7cb7063;
var $68aec2772563966a$export$99905d7583a6e8ac;
var $68aec2772563966a$export$b6c4be74fd0c06bd;
var $68aec2772563966a$export$fd23e5b8d261a89;
var $68aec2772563966a$export$25fabc9b3d1dd567;
var $68aec2772563966a$export$41507f7b07dad151;
var $68aec2772563966a$export$1352f3699c35dd73;
var $68aec2772563966a$export$fd6c9d5c74d943ac;
var $68aec2772563966a$export$895d41bed174c591;
var $68aec2772563966a$export$c29634e3cf41e479;
var $68aec2772563966a$export$e6a60882cce7a085;
var $68aec2772563966a$export$6773c9098ba5e194;
var $68aec2772563966a$export$6ee6b62f50047686;
var $68aec2772563966a$export$efac052bb3661242;
var $68aec2772563966a$export$7ccd63b9ca955862;
var $68aec2772563966a$export$50921df5a58cb3ef;
var $68aec2772563966a$export$8e48efc7acb57a97;
var $68aec2772563966a$export$cea9121727113f77;
var $68aec2772563966a$export$bed35ff7f9af3aaa;
var $68aec2772563966a$export$6b729e898b9067ce;
var $68aec2772563966a$export$984fbab9b52f7e24;
var $68aec2772563966a$export$9ea17906a87ada6f;
var $68aec2772563966a$export$394b443aaff3ef92;
var $68aec2772563966a$export$6ddc374adbc06720;
var $68aec2772563966a$export$ab8c7ebc9add56b2;
var $68aec2772563966a$export$40ecc5bcd633d1ee;
var $68aec2772563966a$export$86a8df7fff52fc69;
var $68aec2772563966a$export$cf2115d46768f4c5;
var $68aec2772563966a$export$3d7e036e195764db;
var $68aec2772563966a$export$60c1d11221608cee;
var $68aec2772563966a$export$bc3cef164abbc42c;
var $68aec2772563966a$export$43f9afb62cd79dec;
var $68aec2772563966a$export$a5ab4ffc4765f75f;
var $68aec2772563966a$export$ccf46db9ab1743ec;
var $68aec2772563966a$export$76c1c247342d776;
var $68aec2772563966a$export$3457b85c8f1a517d;
var $68aec2772563966a$export$2a1d912384377602;
var $68aec2772563966a$export$867eeefcb1c95b27;
var $68aec2772563966a$export$5ada4697ae6aa17e;
var $68aec2772563966a$export$427122300e8d54d0;
var $68aec2772563966a$export$bcea8881375c352f;
var $68aec2772563966a$export$b867715f9a0c04e9;
var $68aec2772563966a$export$2046c054eed58818;
var $68aec2772563966a$export$69878a39cbdbe097;
var $68aec2772563966a$export$584c61a1b769552d;
var $68aec2772563966a$export$8169ebcb0b0331dd;
var $68aec2772563966a$export$ef5889590e2b6760;
var $68aec2772563966a$export$2c9713b624877853;
var $68aec2772563966a$export$45942692aeb454e0;
var $68aec2772563966a$export$8e5efeaa031210cd;
var $68aec2772563966a$export$35a62769ee05a05a;
var $68aec2772563966a$export$8ea4f7e986ca4b06;
var $68aec2772563966a$export$d2fd9ecaff0285a4;
var $68aec2772563966a$export$a6c8e656a4f9bb67;
var $68aec2772563966a$export$352a8075b163d53;
var $68aec2772563966a$export$426d7b90ba5d79db;
var $68aec2772563966a$export$f5a1ee40934d19ce;
var $68aec2772563966a$export$1ba812a9756622ce;
var $68aec2772563966a$export$351120039c36e03;
var $68aec2772563966a$export$d42aa25ca09e17c4;
var $68aec2772563966a$export$d268db29b88a4286;
var $68aec2772563966a$export$c5deb6018f2d6251;
var $68aec2772563966a$export$e06baa3034409453;
var $68aec2772563966a$export$646fdb5910ce3931;
var $68aec2772563966a$export$662e3d2d4361e29b;
var $68aec2772563966a$export$1de3962f221ba441;
var $68aec2772563966a$export$a4b3f0f5499c8738;
var $68aec2772563966a$export$1aecdac6cecbdc5b;
var $68aec2772563966a$export$2eb2ab35b317a103;
var $68aec2772563966a$export$c7e14ea195ede241;
var $68aec2772563966a$export$41ac034e7b9725a2;
var $68aec2772563966a$export$9e521119d7751e37;
var $68aec2772563966a$export$cbac8f541a64a150;
var $68aec2772563966a$export$93dd08efa94c9dd4;
var $68aec2772563966a$export$183e3523dac20bca;
var $68aec2772563966a$export$3867ca1d8381d4e3;
var $68aec2772563966a$export$11febcf9917c0057;
var $68aec2772563966a$export$88ae1ee0c0a63398;
var $68aec2772563966a$export$d5bd986d1f283f29;
var $68aec2772563966a$export$d10568582907d32c;
var $68aec2772563966a$export$f306d94737657647;
var $68aec2772563966a$export$5e55cad605e5c9d3;
var $68aec2772563966a$export$1a214c5a0346737a;
var $68aec2772563966a$export$1ecae877f91f3d38;
var $68aec2772563966a$export$a27521f0d3067ccc;
var $68aec2772563966a$export$ac46bca5cbddbad1;
var $68aec2772563966a$export$11b038c76920b660;
var $68aec2772563966a$export$671c5889f3e8218e;
var $68aec2772563966a$export$726fdf83f7b4fcc8;
var $68aec2772563966a$export$2400f140f6ca38e0;
var $68aec2772563966a$export$a6c909cc1981ed53;
var $68aec2772563966a$export$2a0ab3b6818597b1;
var $68aec2772563966a$export$fc9dbcf37c263217;
var $68aec2772563966a$export$dfbfbd03169bd3bd;
var $68aec2772563966a$export$e36e93a941cb8163;
var $68aec2772563966a$export$fc4a2d238535d998;
var $68aec2772563966a$export$57e53a60bf563f41;
var $68aec2772563966a$export$ffdb1464deb0eedb;
var $68aec2772563966a$export$b52670c950fd640;
var $68aec2772563966a$export$c499fd8f1db3d18e;
var $68aec2772563966a$export$b2ee2242301eff05;
var $68aec2772563966a$export$2ebf9f7586f16841;
var $68aec2772563966a$export$6e9ffd608b3e828b;
var $68aec2772563966a$export$b960c5a73a722e6c;
var $68aec2772563966a$export$d0bc6823da166f19;
var $68aec2772563966a$export$d7a5fcd63410985d;
var $68aec2772563966a$export$a7a850351369c77e;
var $68aec2772563966a$export$b18bca78f4736a94;
var $68aec2772563966a$export$dc4aa1d1f29d5e34;
var $68aec2772563966a$export$d66b1fd3d23a853e;
var $68aec2772563966a$export$61a0059f562fb6c2;
var $68aec2772563966a$export$7dc0d5aefb816d91;
var $68aec2772563966a$export$58f6db56c841bef6;
var $68aec2772563966a$export$97a3da679f509d5;
var $68aec2772563966a$export$c387ec65fd1c2638;
var $68aec2772563966a$export$4d9db82211f308a4;
var $68aec2772563966a$export$ee4948a3be025123;
var $68aec2772563966a$export$e0021eb2979cddaa;
var $68aec2772563966a$export$7c0ac0c19a45beac;
var $68aec2772563966a$export$6c32e9d84f534ee;
var $68aec2772563966a$export$d1f9fbdb211dd29b;
var $68aec2772563966a$export$45e7eea99a17d6e4;
var $68aec2772563966a$export$20ea34e16c0aa64f;
var $68aec2772563966a$export$8365b0f03557fae9;
var $68aec2772563966a$export$49ebbb9621675650;
var $68aec2772563966a$export$842be66a901f093;
var $68aec2772563966a$export$3142c82fef74558f;
var $68aec2772563966a$export$a9f5a6cb28adccb1;
var $68aec2772563966a$export$57b055d4bc586d67;
var $68aec2772563966a$export$13d631b1be16538f;
var $68aec2772563966a$export$3ddfd660caa7bf7a;
var $68aec2772563966a$export$fa7e1f5305153b3d;
var $68aec2772563966a$export$5674ce9d013eb7bd;
var $68aec2772563966a$export$6e8dc14cff6ccf72;
var $68aec2772563966a$export$afd59480458e1b57;
var $68aec2772563966a$export$97952cf4731766f5;
var $68aec2772563966a$export$48e61fb9bccccba9;
var $68aec2772563966a$export$d3e674514dd3a3e1;
var $68aec2772563966a$export$97ad02b50c60ef68;
var $68aec2772563966a$export$61d053b1b63e82c4;
var $68aec2772563966a$export$54256cce0d674dea;
var $68aec2772563966a$export$8c01f0f407bcc5ca;
var $68aec2772563966a$export$97cccd427e0a295b;
var $68aec2772563966a$export$be3f46982f6c7160;
var $68aec2772563966a$export$778e4213e2788579;
var $68aec2772563966a$export$8b48ca3594d2b172;
var $68aec2772563966a$export$8be180ec26319f9f;
var $68aec2772563966a$export$60eccaddefa8fc1c;
var $68aec2772563966a$export$c99ce4fe37484d84;
var $68aec2772563966a$export$fdf432fcac7d8f37;
var $68aec2772563966a$export$4c21cc9cdf2f5dbd;
var $68aec2772563966a$export$dcc1eab7f3f31816;
var $68aec2772563966a$export$dcb7f1379b2b8f86;
var $68aec2772563966a$export$53416edeea4c2d74;
var $68aec2772563966a$export$69f7e5d2b74c5c9e;
var $68aec2772563966a$export$8e104aed582a26bc;
var $68aec2772563966a$export$577047501949be9;
var $68aec2772563966a$export$c4c45b599a2c15e;
var $68aec2772563966a$export$8caf7173a3020ef1;
var $68aec2772563966a$export$361cb541700d648e;
var $68aec2772563966a$export$974f160e11f25731;
var $68aec2772563966a$export$7162f5c702b95903;
var $68aec2772563966a$export$a034d066a9090500;
var $68aec2772563966a$export$70938021e43e047c;
var $68aec2772563966a$export$5f6ac460012a73bb;
var $68aec2772563966a$export$d8e498c1c670bcbf;
var $68aec2772563966a$export$a46886a44f756f1e;
var $68aec2772563966a$export$cc1a78a24d947903;
var $68aec2772563966a$export$d29b927e0bb0ffea;
var $68aec2772563966a$export$b3999cacef245779;
var $68aec2772563966a$export$ff168b5f9cf9dcf6;
var $68aec2772563966a$export$2ab876a45bd6e64;
var $68aec2772563966a$export$cb8027e4395c6c0e;
var $68aec2772563966a$export$f5303d1bac3c2660;
var $68aec2772563966a$export$6c463c5f3b00f64;
var $68aec2772563966a$export$e25d553065457cab;
var $68aec2772563966a$export$15d24c154ea8a56f;
var $68aec2772563966a$export$e5065789a6c415d0;
var $68aec2772563966a$export$62662c561d7c7835;
var $68aec2772563966a$export$218f394557fb0a5a;
var $68aec2772563966a$export$2a5ff6de5448ecdf;
var $68aec2772563966a$export$9d23f3030ed2597e;
var $68aec2772563966a$export$a26ff217a6124160;
var $68aec2772563966a$export$c8072f5fcfdb5b77;
var $68aec2772563966a$export$c4e4b74f1ccf3d96;
var $68aec2772563966a$export$328519d02a26ac41;
var $68aec2772563966a$export$d2061b291c43d045;
var $68aec2772563966a$export$d1f04dfd3d695286;
var $68aec2772563966a$export$234fbd86ea0f0bd8;
var $68aec2772563966a$export$e795000978a75b12;
var $68aec2772563966a$export$9f4683b4d1018ace;
var $68aec2772563966a$export$e431b042fcdb1d63;
var $68aec2772563966a$export$a453239171ac9a23;
var $68aec2772563966a$export$3a7726a976c18d5f;
var $68aec2772563966a$export$7eca7a6c06843b93;
var $68aec2772563966a$export$f25c55f83e5b0672;
var $68aec2772563966a$export$9562bfac4eb079cb;
var $68aec2772563966a$export$c276d164ff91d2f7;
var $68aec2772563966a$export$2f3e0574f1a99754;
var $68aec2772563966a$export$15eecaab68167880;
var $68aec2772563966a$export$513c47f6e194086a;
var $68aec2772563966a$export$a3f464c4d5cd9096;
var $68aec2772563966a$export$ed366a03a2330b03;
var $68aec2772563966a$export$9b802c784f235e1d;
var $68aec2772563966a$export$add0fc8b8c5726a4;
var $68aec2772563966a$export$e7f32463f5bfd554;
var $68aec2772563966a$export$f9346f394edf26a;
var $68aec2772563966a$export$16b917774e73ef92;
var $68aec2772563966a$export$15d2b60bf3b65454;
var $68aec2772563966a$export$db55eca5af256142;
var $68aec2772563966a$export$59329ea9f3dc6610;
var $68aec2772563966a$export$967c74f8b1f3d35;
var $68aec2772563966a$export$7c33ae67962515d1;
var $68aec2772563966a$export$730c61462081bd77;
var $68aec2772563966a$export$9c69839b2d93489b;
var $68aec2772563966a$export$f38631e70fb37f7c;
var $68aec2772563966a$export$7001e6237c0936f7;
var $68aec2772563966a$export$c2190d261e83de8b;
var $68aec2772563966a$export$5a958d07aea838e0;
var $68aec2772563966a$export$be22d22d4b6cf5d8;
var $68aec2772563966a$export$c529961b911626ac;
var $68aec2772563966a$export$e39c4b15d2881f5;
var $68aec2772563966a$export$a8ca145161313e7;
var $68aec2772563966a$export$3c1204d03918d076;
var $68aec2772563966a$export$eaac3f141165e288;
var $68aec2772563966a$export$691d17eaa731c6a8;
var $68aec2772563966a$export$4c7e6934714150e6;
var $68aec2772563966a$export$6f71f9711d666eb4;
var $68aec2772563966a$export$2e2181bea33963d2;
var $68aec2772563966a$export$77b390a335f31601;
var $68aec2772563966a$export$2a3cd2bb71fb63a4;
var $68aec2772563966a$export$4696f9a8a1b6f07c;
var $68aec2772563966a$export$55478a0b7d2ae98f;
var $68aec2772563966a$export$536e79776026daed;
var $68aec2772563966a$export$bed10c4da9b8eb0a;
var $68aec2772563966a$export$a82607b6424c06c8;
var $68aec2772563966a$export$6b081f3484c7f4e5;
var $68aec2772563966a$export$b7754d85fd39406c;
var $68aec2772563966a$export$492856c046eb4728;
var $68aec2772563966a$export$c1678a2059fbe906;
var $68aec2772563966a$export$6d384a0bc1011c34;
var $68aec2772563966a$export$1499a7dbfc01e7d4;
var $68aec2772563966a$export$cfcbff40019f0ff1;
var $68aec2772563966a$export$27157b5f68e583af;
var $68aec2772563966a$export$54bf5ed61532925d;
var $68aec2772563966a$export$60ed0786292ace08;
var $68aec2772563966a$export$d770bfb8345e146;
var $68aec2772563966a$export$bb73817f1290ad28;
var $68aec2772563966a$export$f201c980f2b75802;
var $68aec2772563966a$export$b40e970572afd0ee;
var $68aec2772563966a$export$8850630a3d343488;
var $68aec2772563966a$export$fd0a39a918d6516f;
var $68aec2772563966a$export$e68ef41f8e0335bf;
var $68aec2772563966a$export$5bff09650e762829;
var $68aec2772563966a$export$21c1adce0e067f37;
var $68aec2772563966a$export$fed6ce86f48c84bc;
var $68aec2772563966a$export$500c2675137ac16e;
var $68aec2772563966a$export$402c7728623fd8df;
var $68aec2772563966a$export$15417259f4c0fe6b;
var $68aec2772563966a$export$2b3b7f579a727f45;
var $68aec2772563966a$export$514832a0b029734b;
var $68aec2772563966a$export$b0522e6a14dec1a4;
var $68aec2772563966a$export$659ea19f71a7ee0b;
var $68aec2772563966a$export$1b61d972db315e73;
var $68aec2772563966a$export$fb2970ee11a479ee;
var $68aec2772563966a$export$920aceb2a8fad77e;
var $68aec2772563966a$export$48f8f6fbc999d187;
var $68aec2772563966a$export$eed590fa00a8223b;
var $68aec2772563966a$export$f2e5bb5cd4a130da;
var $68aec2772563966a$export$779ef03d633a9086;
var $68aec2772563966a$export$d98b87c8d53d0dbc;
var $68aec2772563966a$export$ca719aa57653a0a7;
var $68aec2772563966a$export$74b19c5f48270c05;
var $68aec2772563966a$export$c351affe7e8098cb;
var $68aec2772563966a$export$be7cd6b3ae3ae765;
var $68aec2772563966a$export$ec182524c4c57275;
var $68aec2772563966a$export$9e45758246a85b07;
var $68aec2772563966a$export$9fa5d5f0144954cb;
var $68aec2772563966a$export$e66ba5bc4b978023;
var $68aec2772563966a$export$2306e23cc611a36d;
var $68aec2772563966a$export$144f8c1fe01428db;
var $68aec2772563966a$export$f303b2744d52121c;
var $68aec2772563966a$export$866b2dbc7bf18ce6;
var $68aec2772563966a$export$b4c85774878b4841;
var $68aec2772563966a$export$1c967a71bc9a3077;
var $68aec2772563966a$export$5e3884a35a19eb90;
var $68aec2772563966a$export$6e7ff99bb3259573;
var $68aec2772563966a$export$7c932cba2d9e7a7;
var $68aec2772563966a$export$94091942edce0667;
var $68aec2772563966a$export$a08202ba4c331865;
var $68aec2772563966a$export$3671a8a524706a9d;
var $68aec2772563966a$export$c288888dc82d233f;
var $68aec2772563966a$export$8ff188536cebc35;
var $68aec2772563966a$export$6407d78968c0eabe;
var $68aec2772563966a$export$43e9fb9ec28d9743;
var $68aec2772563966a$export$26f31d5c5c201739;
var $68aec2772563966a$export$bff85124d2d35b93;
var $68aec2772563966a$export$495c671ed5a6408c;
var $68aec2772563966a$export$54b3d4d5548c35c3;
var $68aec2772563966a$export$71aa6d7b25b5b4be;
var $68aec2772563966a$export$2b91517d6d5b4365;
var $68aec2772563966a$export$2954db6444fe1fa8;
var $68aec2772563966a$export$15c1c974d16dd678;
var $68aec2772563966a$export$81c87eb7885d0bfe;
var $68aec2772563966a$export$da39a8d77ac07c5b;
var $68aec2772563966a$export$8e637b1057fe6fb6;
var $68aec2772563966a$export$b9218817a14d08d5;
var $68aec2772563966a$export$96066c6fa0d06464;
var $68aec2772563966a$export$a78cfb50aa50bca4;
var $68aec2772563966a$export$79b15960e18053b9;
var $68aec2772563966a$export$8e8a40d1629c4be;
var $68aec2772563966a$export$668dbefe39a14e9;
var $68aec2772563966a$export$ee766f53806dcc0a;
var $68aec2772563966a$export$6670b5eb4860054b;
var $68aec2772563966a$export$9be2ae89a1eac217;
var $68aec2772563966a$export$51231929dd279b6d;
var $68aec2772563966a$export$5c83e6b57d4562ef;
var $68aec2772563966a$export$5c698591c0e586a2;
var $68aec2772563966a$export$b711f2bb9c9a848a;
var $68aec2772563966a$export$1d3a8501efd30213;
var $68aec2772563966a$export$e0df0d58e945a144;
var $68aec2772563966a$export$cebaf684ced5a2c9;
var $68aec2772563966a$export$d4c658ecdcb7c78c;
var $68aec2772563966a$export$b1b162b01baeb044;
var $68aec2772563966a$export$8be2d593d7f88ed8;
var $68aec2772563966a$export$dbd0a3528a97ccc0;
var $68aec2772563966a$export$b506afe31324afa3;
var $68aec2772563966a$export$953df8d049a11237;
var $68aec2772563966a$export$db0d98a58164f739;
var $68aec2772563966a$export$66581dc6d3d083d1;
var $68aec2772563966a$export$e545f99e7abcc499;
var $68aec2772563966a$export$7e1af5787f8c4aaa;
var $68aec2772563966a$export$186c94c351c54768;
var $68aec2772563966a$export$2e3fd8dfcb16fe0c;
var $68aec2772563966a$export$7eeeceaa1dbd7cd5;
var $68aec2772563966a$export$9d5bffdff936d554;
var $68aec2772563966a$export$dc3a801c9a2c5b79;
var $68aec2772563966a$export$27933a9557f87e98;
var $68aec2772563966a$export$eefa737b40a0d535;
var $68aec2772563966a$export$92740ffbcb02553b;
var $68aec2772563966a$export$500e89753f9f1008;
var $68aec2772563966a$export$d91a18e47fdddefd;
var $68aec2772563966a$export$eccbe6f20884ea7f;
var $68aec2772563966a$export$9e24f11d79141afb;
var $68aec2772563966a$export$f0b96ad9586f8887;
var $68aec2772563966a$export$8a92ed5d436a85c6;
var $68aec2772563966a$export$edd59acdf7e86a71;
var $68aec2772563966a$export$ae81a1ae71952d50;
var $68aec2772563966a$export$6101470cd57eac1b;
var $68aec2772563966a$export$452c0aee9673fe67;
var $68aec2772563966a$export$773dddd1e8667756;
var $68aec2772563966a$export$98815f8579a64a90;
var $68aec2772563966a$export$7bc4e27428665019;
var $68aec2772563966a$export$e7d7477fa9057ee2;
var $68aec2772563966a$export$1f4267a3fc018448;
var $68aec2772563966a$export$c171cae150389952;
var $68aec2772563966a$export$d9bb35e957b22c72;
var $68aec2772563966a$export$b3508a2c95f74e3d;
var $68aec2772563966a$export$20bb272f4d21532d;
var $68aec2772563966a$export$d7e64fbd0102ce90;
var $68aec2772563966a$export$c17eae7e86dbba3c;
var $68aec2772563966a$export$349603c0a9165744;
var $68aec2772563966a$export$4dadf693741f0283;
var $68aec2772563966a$export$6377864d12f7eeb3;
var $68aec2772563966a$export$6b892e5faf9c65ec;
var $68aec2772563966a$export$b93169be52dcfc1;
var $68aec2772563966a$export$69ffc9f31c260bb4;
var $68aec2772563966a$export$1679f9582e34ea8d;
var $68aec2772563966a$export$ba081af9585ed4;
var $68aec2772563966a$export$13514311f5ad8904;
var $68aec2772563966a$export$eaca45a91e334bc3;
var $68aec2772563966a$export$6d155392d40c193e;
var $68aec2772563966a$export$7841dacb241485d0;
var $68aec2772563966a$export$52c7044cf6301362;
var $68aec2772563966a$export$56ea1c9e44590e20;
var $68aec2772563966a$export$7626e389d05f4c36;
var $68aec2772563966a$export$fd6d8217c43d52a0;
var $68aec2772563966a$export$5e0a48187329b2e7;
var $68aec2772563966a$export$c322b150d7667841;
var $68aec2772563966a$export$79ef102ff6c2276c;
var $68aec2772563966a$export$4a4797d3c962f753;
var $68aec2772563966a$export$767524d5e72e2645;
var $68aec2772563966a$export$497354ca7b0ee666;
var $68aec2772563966a$export$cbdc4ad11118116a;
var $68aec2772563966a$export$5b890de778c4c2fe;
var $68aec2772563966a$export$a78d9803b5e0a83e;
var $68aec2772563966a$export$df1b536467b3992a;
var $68aec2772563966a$export$73104a329e205998;
var $68aec2772563966a$export$5740e3da55330b0a;
var $68aec2772563966a$export$8dcc2d92ff6d65da;
var $68aec2772563966a$export$e5f1321e53e24810;
var $68aec2772563966a$export$56dd3098cbca7c8a;
var $68aec2772563966a$export$aa7aff70e4380665;
var $68aec2772563966a$export$dacb7d452aa6bcaf;
var $68aec2772563966a$export$15dfc6c5e8f9baf6;
var $68aec2772563966a$export$e9a5de183fd08f2d;
var $68aec2772563966a$export$91ad03bba7909fb5;
var $68aec2772563966a$export$86128e6c0ab71d64;
var $68aec2772563966a$export$745b60c4819aec1d;
var $68aec2772563966a$export$f83a3ef33e3015f5;
var $68aec2772563966a$export$4f324e8aab67771d;
var $68aec2772563966a$export$d2c893bfac1da9a1;
var $68aec2772563966a$export$1c14ad02f9534b19;
var $68aec2772563966a$export$db3cb63e0594d014;
var $68aec2772563966a$export$a65c9a0eba2c222d;
var $68aec2772563966a$export$68dbcca9c0e339ec;
var $68aec2772563966a$export$d59b669d4bb3f006;
var $68aec2772563966a$export$4d88d347aa9667fc;
var $68aec2772563966a$export$9943ffdcaa4bc506;
var $68aec2772563966a$export$d4f25b923533dbba;
var $68aec2772563966a$export$221a33f26f7c0739;
var $68aec2772563966a$export$35f3396a1cdeea45;
var $68aec2772563966a$export$80e399da474bc98d;
var $68aec2772563966a$export$e01809e2dbceac35;
var $68aec2772563966a$export$41900d5c4e8a9c68;
var $68aec2772563966a$export$362bb1cb0bb5ca03;
var $68aec2772563966a$export$6803ac54f919d9cc;
var $68aec2772563966a$export$72f5b47540331169;
var $68aec2772563966a$export$6c61a8c9aa5305cb;
var $68aec2772563966a$export$6b5244c457b68e65;
var $68aec2772563966a$export$b7bd0c9a886f3414;
var $68aec2772563966a$export$6b77f2bacac7c93d;
var $68aec2772563966a$export$ddbc15c0e8e8a7ea;
var $68aec2772563966a$export$feb4fe753df28a82;
var $68aec2772563966a$export$d6267756132e2175;
var $68aec2772563966a$export$570ac5a3fd7e6cc6;
var $68aec2772563966a$export$5b9a0015e1c530ed;
var $68aec2772563966a$export$8bbff71c84508218;
var $68aec2772563966a$export$b55aa07a514a2430;
var $68aec2772563966a$export$9927ad09f7c084dc;
var $68aec2772563966a$export$52a07a35ff8ec6b6;
var $68aec2772563966a$export$a10d277c42e6cae3;
var $68aec2772563966a$export$cdc0ce5c66182801;
var $68aec2772563966a$export$2504d4bd698dd962;
var $68aec2772563966a$export$9dc86f3b876e96ef;
var $68aec2772563966a$export$70ff7865f52549ae;
var $68aec2772563966a$export$f77b53a42be6e6fd;
var $68aec2772563966a$export$818eb7ab11414506;
var $68aec2772563966a$export$829ef6b2e59d984d;
var $68aec2772563966a$export$b30f4cb52c088a26;
var $68aec2772563966a$export$335eace0ff1771cd;
var $68aec2772563966a$export$374d88a2025416ac;
var $68aec2772563966a$export$8c1c09aad940c209;
var $68aec2772563966a$export$73086897ee87592;
var $68aec2772563966a$export$bb7a91303551eb37;
var $68aec2772563966a$export$d7c235242f462725;
var $68aec2772563966a$export$66bace8969e2e3d5;
var $68aec2772563966a$export$ace44ef9ab757803;
var $68aec2772563966a$export$73e8c5f1140c4791;
var $68aec2772563966a$export$77af2faf6df02a72;
var $68aec2772563966a$export$f132ea291a7db56b;
var $68aec2772563966a$export$f0abd4170bbd2468;
var $68aec2772563966a$export$50d00a157dc08581;
var $68aec2772563966a$export$484576567a98833f;
var $68aec2772563966a$export$ec9e491e475d0c97;
var $68aec2772563966a$export$a86c59c10992220f;
var $68aec2772563966a$export$e12f06597e992fde;
var $68aec2772563966a$export$7ec54678ba28ea59;
var $68aec2772563966a$export$433ba14c16717110;
var $68aec2772563966a$export$309ee349b8a537f;
var $68aec2772563966a$export$a344421384e4626b;
var $68aec2772563966a$export$e43f29da852027e9;
var $68aec2772563966a$export$f4e00a7a768abc8;
var $68aec2772563966a$export$7a5e4e7104ab3b9a;
var $68aec2772563966a$export$905bea62c04473b4;
var $68aec2772563966a$export$94549a3d156ca6e3;
var $68aec2772563966a$export$c64c67f496c0a458;
var $68aec2772563966a$export$9559a80e6d3976cf;
var $68aec2772563966a$export$ad5635d1786f4dce;
var $68aec2772563966a$export$281536c6742b39c8;
var $68aec2772563966a$export$e28d8f7876943c30;
var $68aec2772563966a$export$ff74fcec9c21ca2b;
var $68aec2772563966a$export$190fe5bf513bf32b;
var $68aec2772563966a$export$b87f371cbc396fcf;
var $68aec2772563966a$export$60050fc49fe0e7e2;
var $68aec2772563966a$export$348c8e2b37f276cd;
var $68aec2772563966a$export$7f47e8a8b2d97cb2;
var $68aec2772563966a$export$50d5adc4b543ce95;
var $68aec2772563966a$export$9221f1d2c934d9f;
var $68aec2772563966a$export$3a56578b3ae09a02;
var $68aec2772563966a$export$e47b8dab9466c895;
var $68aec2772563966a$export$4ca52f75cf4889c5;
var $68aec2772563966a$export$7343d7d72195067f;
var $68aec2772563966a$export$f334f32f8d4d8063;
var $68aec2772563966a$export$c7bf2089e89a217c;
var $68aec2772563966a$export$f514f97553a434b2;
var $68aec2772563966a$export$61abde59b50deb8e;
var $68aec2772563966a$export$5a5ce44f9fb51f93;
var $68aec2772563966a$export$7044ea8d89b6f59d;
var $68aec2772563966a$export$40eacf1a072c9dbd;
var $68aec2772563966a$export$4c1fa0ac0eff2ac;
var $68aec2772563966a$export$5bee9450fe31dde1;
var $68aec2772563966a$export$d0b571fb4406d953;
var $68aec2772563966a$export$d51317816423085d;
var $68aec2772563966a$export$96a83d41c14e5647;
var $68aec2772563966a$export$258b370e6c2b85d5;
var $68aec2772563966a$export$dc5e5523da291a4b;
var $68aec2772563966a$export$fd5a8904ab5abfe0;
var $68aec2772563966a$export$1350d8937b0f26fb;
var $68aec2772563966a$export$2a045f777fb349a8;
var $68aec2772563966a$export$8bb874585539a88f;
var $68aec2772563966a$export$17d3a50785727199;
var $68aec2772563966a$export$2931c570009689e;
var $68aec2772563966a$export$199cbcedee735a43;
var $68aec2772563966a$export$4ba5bf9d4e3ed862;
var $68aec2772563966a$export$674c01ec2f0b89c3;
var $68aec2772563966a$export$bda1686739fd61c7;
var $68aec2772563966a$export$8d804148f485d54c;
var $68aec2772563966a$export$212a8f1ea37518bd;
var $68aec2772563966a$export$c9ac0fee28245883;
var $68aec2772563966a$export$77078610759fe5f6;
var $68aec2772563966a$export$7c6317deeec7a6c1;
var $68aec2772563966a$export$877ebf2e4ad81f03;
var $68aec2772563966a$export$70b2343945496e1f;
var $68aec2772563966a$export$8415b56d2c6d2b1d;
var $68aec2772563966a$export$cc81114a03caab18;
var $68aec2772563966a$export$bc14eb892daceb23;
var $68aec2772563966a$export$3c973217450c3e9d;
var $68aec2772563966a$export$582c0b730ff1ddb9;
var $68aec2772563966a$export$b3edfb545b65f1c5;
var $68aec2772563966a$export$2593317d8731841c;
var $68aec2772563966a$export$8bb5bc1732aa41f;
var $68aec2772563966a$export$74a79c98b110b5b9;
var $68aec2772563966a$export$26461b03281b4db4;
var $68aec2772563966a$export$eaea590d6d3dd93c;
var $68aec2772563966a$export$af45365f70099379;
var $68aec2772563966a$export$a49e732d34d5ba9b;
var $68aec2772563966a$export$7c147fe246bc8bd3;
var $68aec2772563966a$export$e5111b6070e1ee9e;
var $68aec2772563966a$export$591cbfd403f8c8d;
var $68aec2772563966a$export$b1388db955bbb885;
var $68aec2772563966a$export$e898d0e9e211abd9;
var $68aec2772563966a$export$ab6fee0e8a6ee069;
var $68aec2772563966a$export$9786ad94c199ffbb;
var $68aec2772563966a$export$269890524eed693b;
var $68aec2772563966a$export$2ec623a8212d6b64;
var $68aec2772563966a$export$30e7673b01ff994e;
var $68aec2772563966a$export$9ea93477840812bf;
var $68aec2772563966a$export$a6da0c365670c430;
var $68aec2772563966a$export$7986b22da43f2885;
var $68aec2772563966a$export$a9f943c7ceb3b42f;
var $68aec2772563966a$export$dfe49501efcdffce;
var $68aec2772563966a$export$be465f50c92eb01d;
var $68aec2772563966a$export$c138d1796bb34999;
var $68aec2772563966a$export$85a0016690a0ccf2;
var $68aec2772563966a$export$883acab36ede4bfa;
var $68aec2772563966a$export$9cfc88d203f9cdf1;
var $68aec2772563966a$export$b3c6c599110d7bab;
var $68aec2772563966a$export$700a3f96cb39930;
var $68aec2772563966a$export$247839c65766758;
var $68aec2772563966a$export$f4d52b02df927d54;
var $68aec2772563966a$export$8baf9330c244c0ee;
var $68aec2772563966a$export$7d0cb6c474a8d8dd;
var $68aec2772563966a$export$df30ee8c5b5f1989;
var $68aec2772563966a$export$ae4fc52420ecd4bc;
var $68aec2772563966a$export$268a117c860fca6d;
"use strict";
const $68aec2772563966a$var$ADDRESS = "address", $68aec2772563966a$var$AI_CITATIONS = "ai.citations", $68aec2772563966a$var$AI_COMPLETION_TOKENS_USED = "ai.completion_tokens.used", $68aec2772563966a$var$AI_DOCUMENTS = "ai.documents", $68aec2772563966a$var$AI_FINISH_REASON = "ai.finish_reason", $68aec2772563966a$var$AI_FREQUENCY_PENALTY = "ai.frequency_penalty", $68aec2772563966a$var$AI_FUNCTION_CALL = "ai.function_call", $68aec2772563966a$var$AI_GENERATION_ID = "ai.generation_id", $68aec2772563966a$var$AI_INPUT_MESSAGES = "ai.input_messages", $68aec2772563966a$var$AI_IS_SEARCH_REQUIRED = "ai.is_search_required", $68aec2772563966a$var$AI_METADATA = "ai.metadata", $68aec2772563966a$var$AI_MODEL_ID = "ai.model.id", $68aec2772563966a$var$_AI_MODEL_ID = "ai.model_id", $68aec2772563966a$var$AI_MODEL_PROVIDER = "ai.model.provider", $68aec2772563966a$var$AI_PIPELINE_NAME = "ai.pipeline.name", $68aec2772563966a$var$AI_PREAMBLE = "ai.preamble", $68aec2772563966a$var$AI_PRESENCE_PENALTY = "ai.presence_penalty", $68aec2772563966a$var$AI_PROMPT = "ai.prompt", $68aec2772563966a$var$AI_PROMPT_MESSAGES = "ai.prompt.messages", $68aec2772563966a$var$AI_PROMPT_TOKENS_USED = "ai.prompt_tokens.used", $68aec2772563966a$var$AI_PROMPT_TOOLS = "ai.prompt.tools", $68aec2772563966a$var$AI_RAW_PROMPTING = "ai.raw_prompting", $68aec2772563966a$var$AI_RESPONSES = "ai.responses", $68aec2772563966a$var$AI_RESPONSE_FORMAT = "ai.response_format", $68aec2772563966a$var$AI_RESPONSE_ID = "ai.response.id", $68aec2772563966a$var$AI_RESPONSE_MODEL = "ai.response.model", $68aec2772563966a$var$AI_RESPONSE_OBJECT = "ai.response.object", $68aec2772563966a$var$AI_RESPONSE_TEXT = "ai.response.text", $68aec2772563966a$var$AI_RESPONSE_TIMESTAMP = "ai.response.timestamp", $68aec2772563966a$var$AI_RESPONSE_TOOLCALLS = "ai.response.toolCalls", $68aec2772563966a$var$AI_SCHEMA = "ai.schema", $68aec2772563966a$var$AI_SEARCH_QUERIES = "ai.search_queries", $68aec2772563966a$var$AI_SEARCH_RESULTS = "ai.search_results", $68aec2772563966a$var$AI_SEED = "ai.seed", $68aec2772563966a$var$AI_STREAMING = "ai.streaming", $68aec2772563966a$var$AI_TAGS = "ai.tags", $68aec2772563966a$var$AI_TEMPERATURE = "ai.temperature", $68aec2772563966a$var$AI_TEXTS = "ai.texts", $68aec2772563966a$var$AI_TOOLCALL_ARGS = "ai.toolCall.args", $68aec2772563966a$var$AI_TOOLCALL_RESULT = "ai.toolCall.result", $68aec2772563966a$var$AI_TOOLS = "ai.tools", $68aec2772563966a$var$AI_TOOL_CALLS = "ai.tool_calls", $68aec2772563966a$var$AI_TOP_K = "ai.top_k", $68aec2772563966a$var$AI_TOP_P = "ai.top_p", $68aec2772563966a$var$AI_TOTAL_COST = "ai.total_cost", $68aec2772563966a$var$AI_TOTAL_TOKENS_USED = "ai.total_tokens.used", $68aec2772563966a$var$AI_USAGE_TOKENS = "ai.usage.tokens", $68aec2772563966a$var$AI_VALUES = "ai.values", $68aec2772563966a$var$AI_WARNINGS = "ai.warnings", $68aec2772563966a$var$ANGULAR_VERSION = "angular.version", $68aec2772563966a$var$APP_APP_BUILD = "app.app_build", $68aec2772563966a$var$APP_APP_IDENTIFIER = "app.app_identifier", $68aec2772563966a$var$APP_APP_NAME = "app.app_name", $68aec2772563966a$var$APP_APP_START_TIME = "app.app_start_time", $68aec2772563966a$var$APP_APP_VERSION = "app.app_version", $68aec2772563966a$var$APP_BUILD = "app.build", $68aec2772563966a$var$APP_IDENTIFIER = "app.identifier", $68aec2772563966a$var$APP_IN_FOREGROUND = "app.in_foreground", $68aec2772563966a$var$APP_NAME = "app.name", $68aec2772563966a$var$APP_START_COLD = "app_start_cold", $68aec2772563966a$var$APP_START_TIME = "app.start_time", $68aec2772563966a$var$APP_START_TYPE = "app_start_type", $68aec2772563966a$var$APP_START_WARM = "app_start_warm", $68aec2772563966a$var$APP_VERSION = "app.version", $68aec2772563966a$var$APP_VITALS_FRAMES_DELAY_VALUE = "app.vitals.frames.delay.value", $68aec2772563966a$var$APP_VITALS_FRAMES_FROZEN_COUNT = "app.vitals.frames.frozen.count", $68aec2772563966a$var$APP_VITALS_FRAMES_FROZEN_RATE = "app.vitals.frames.frozen.rate", $68aec2772563966a$var$APP_VITALS_FRAMES_SLOW_COUNT = "app.vitals.frames.slow.count", $68aec2772563966a$var$APP_VITALS_FRAMES_SLOW_RATE = "app.vitals.frames.slow.rate", $68aec2772563966a$var$APP_VITALS_FRAMES_TOTAL_COUNT = "app.vitals.frames.total.count", $68aec2772563966a$var$APP_VITALS_STALL_DURATION = "app.vitals.stall.duration", $68aec2772563966a$var$APP_VITALS_STALL_PERCENTAGE = "app.vitals.stall.percentage", $68aec2772563966a$var$APP_VITALS_START_COLD_VALUE = "app.vitals.start.cold.value", $68aec2772563966a$var$APP_VITALS_START_PREWARMED = "app.vitals.start.prewarmed", $68aec2772563966a$var$APP_VITALS_START_REASON = "app.vitals.start.reason", $68aec2772563966a$var$APP_VITALS_START_SCREEN = "app.vitals.start.screen", $68aec2772563966a$var$APP_VITALS_START_TYPE = "app.vitals.start.type", $68aec2772563966a$var$APP_VITALS_START_WARM_VALUE = "app.vitals.start.warm.value", $68aec2772563966a$var$APP_VITALS_TTFD_VALUE = "app.vitals.ttfd.value", $68aec2772563966a$var$APP_VITALS_TTID_VALUE = "app.vitals.ttid.value", $68aec2772563966a$var$ART_GC_BLOCKING_COUNT = "art.gc.blocking_count", $68aec2772563966a$var$ART_GC_BLOCKING_TIME = "art.gc.blocking_time", $68aec2772563966a$var$ART_GC_PRE_OOME_COUNT = "art.gc.pre_oome_count", $68aec2772563966a$var$ART_GC_TOTAL_COUNT = "art.gc.total_count", $68aec2772563966a$var$ART_GC_TOTAL_TIME = "art.gc.total_time", $68aec2772563966a$var$ART_GC_WAITING_TIME = "art.gc.waiting_time", $68aec2772563966a$var$ART_MEMORY_FREE = "art.memory.free", $68aec2772563966a$var$ART_MEMORY_FREE_UNTIL_GC = "art.memory.free_until_gc", $68aec2772563966a$var$ART_MEMORY_FREE_UNTIL_OOME = "art.memory.free_until_oome", $68aec2772563966a$var$ART_MEMORY_MAX = "art.memory.max", $68aec2772563966a$var$ART_MEMORY_TOTAL = "art.memory.total", $68aec2772563966a$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP = "aws.cloudwatch.logs.log_group", $68aec2772563966a$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM = "aws.cloudwatch.logs.log_stream", $68aec2772563966a$var$AWS_CLOUDWATCH_LOGS_URL = "aws.cloudwatch.logs.url", $68aec2772563966a$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = "aws.dynamodb.attribute_definitions", $68aec2772563966a$var$AWS_DYNAMODB_CONSISTENT_READ = "aws.dynamodb.consistent_read", $68aec2772563966a$var$AWS_DYNAMODB_CONSUMED_CAPACITY = "aws.dynamodb.consumed_capacity", $68aec2772563966a$var$AWS_DYNAMODB_COUNT = "aws.dynamodb.count", $68aec2772563966a$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE = "aws.dynamodb.exclusive_start_table", $68aec2772563966a$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = "aws.dynamodb.global_secondary_indexes", $68aec2772563966a$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = "aws.dynamodb.global_secondary_index_updates", $68aec2772563966a$var$AWS_DYNAMODB_INDEX_NAME = "aws.dynamodb.index_name", $68aec2772563966a$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS = "aws.dynamodb.item_collection_metrics", $68aec2772563966a$var$AWS_DYNAMODB_LIMIT = "aws.dynamodb.limit", $68aec2772563966a$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = "aws.dynamodb.local_secondary_indexes", $68aec2772563966a$var$AWS_DYNAMODB_PROJECTION = "aws.dynamodb.projection", $68aec2772563966a$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = "aws.dynamodb.provisioned_read_capacity", $68aec2772563966a$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = "aws.dynamodb.provisioned_write_capacity", $68aec2772563966a$var$AWS_DYNAMODB_SCANNED_COUNT = "aws.dynamodb.scanned_count", $68aec2772563966a$var$AWS_DYNAMODB_SCAN_FORWARD = "aws.dynamodb.scan_forward", $68aec2772563966a$var$AWS_DYNAMODB_SEGMENT = "aws.dynamodb.segment", $68aec2772563966a$var$AWS_DYNAMODB_SELECT = "aws.dynamodb.select", $68aec2772563966a$var$AWS_DYNAMODB_TABLE_COUNT = "aws.dynamodb.table_count", $68aec2772563966a$var$AWS_DYNAMODB_TABLE_NAMES = "aws.dynamodb.table_names", $68aec2772563966a$var$AWS_DYNAMODB_TOTAL_SEGMENTS = "aws.dynamodb.total_segments", $68aec2772563966a$var$AWS_EXTENDED_REQUEST_ID = "aws.extended_request_id", $68aec2772563966a$var$AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream_name", $68aec2772563966a$var$_AWS_KINESIS_STREAM_NAME = "aws.kinesis.stream.name", $68aec2772563966a$var$AWS_LAMBDA_AWS_REQUEST_ID = "aws.lambda.aws_request_id", $68aec2772563966a$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS = "aws.lambda.execution_duration_in_millis", $68aec2772563966a$var$AWS_LAMBDA_FUNCTION_NAME = "aws.lambda.function_name", $68aec2772563966a$var$AWS_LAMBDA_FUNCTION_VERSION = "aws.lambda.function_version", $68aec2772563966a$var$AWS_LAMBDA_INVOKED_ARN = "aws.lambda.invoked_arn", $68aec2772563966a$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN = "aws.lambda.invoked_function_arn", $68aec2772563966a$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS = "aws.lambda.remaining_time_in_millis", $68aec2772563966a$var$AWS_LOG_GROUP_NAMES = "aws.log.group.names", $68aec2772563966a$var$AWS_LOG_STREAM_NAMES = "aws.log.stream.names", $68aec2772563966a$var$AWS_OPERATION_NAME = "aws.operation_name", $68aec2772563966a$var$AWS_REGION = "aws_region", $68aec2772563966a$var$AWS_REQUEST_EXTENDED_ID = "aws.request.extended_id", $68aec2772563966a$var$AWS_REQUEST_ID = "aws.request_id", $68aec2772563966a$var$_AWS_REQUEST_ID = "aws.request.id", $68aec2772563966a$var$AWS_REQUEST_URL = "aws.request.url", $68aec2772563966a$var$AWS_S3_BUCKET = "aws.s3.bucket", $68aec2772563966a$var$AWS_SECRETSMANAGER_SECRET_ARN = "aws.secretsmanager.secret.arn", $68aec2772563966a$var$AWS_SNS_TOPIC_ARN = "aws.sns.topic.arn", $68aec2772563966a$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN = "aws.step_functions.activity.arn", $68aec2772563966a$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN = "aws.step_functions.state_machine.arn", $68aec2772563966a$var$BLOCKED_MAIN_THREAD = "blocked_main_thread", $68aec2772563966a$var$BROWSER_BFCACHE_FRAME = "browser.bfcache.frame", $68aec2772563966a$var$BROWSER_BFCACHE_NOT_RESTORED_REASON_COUNT = "browser.bfcache.not_restored_reason_count", $68aec2772563966a$var$BROWSER_BFCACHE_OUTCOME = "browser.bfcache.outcome", $68aec2772563966a$var$BROWSER_BFCACHE_REASON = "browser.bfcache.reason", $68aec2772563966a$var$BROWSER_NAME = "browser.name", $68aec2772563966a$var$BROWSER_NAVIGATION_ID = "browser.navigation.id", $68aec2772563966a$var$BROWSER_NAVIGATION_TYPE = "browser.navigation.type", $68aec2772563966a$var$BROWSER_PAINT_TYPE = "browser.paint.type", $68aec2772563966a$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START = "browser.performance.navigation.activation_start", $68aec2772563966a$var$BROWSER_PERFORMANCE_TIME_ORIGIN = "browser.performance.time_origin", $68aec2772563966a$var$BROWSER_REPORT_TYPE = "browser.report.type", $68aec2772563966a$var$BROWSER_SCRIPT_INVOKER = "browser.script.invoker", $68aec2772563966a$var$BROWSER_SCRIPT_INVOKER_TYPE = "browser.script.invoker_type", $68aec2772563966a$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION = "browser.script.source_char_position", $68aec2772563966a$var$BROWSER_VERSION = "browser.version", $68aec2772563966a$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT = "browser.web_vital.cls.report_event", $68aec2772563966a$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY = "browser.web_vital.cls.source.<key>", $68aec2772563966a$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE = "browser.web_vital.cls.source", $68aec2772563966a$var$BROWSER_WEB_VITAL_CLS_VALUE = "browser.web_vital.cls.value", $68aec2772563966a$var$BROWSER_WEB_VITAL_FCP_VALUE = "browser.web_vital.fcp.value", $68aec2772563966a$var$BROWSER_WEB_VITAL_FP_VALUE = "browser.web_vital.fp.value", $68aec2772563966a$var$BROWSER_WEB_VITAL_INP_INTERACTION_TYPE = "browser.web_vital.inp.interaction_type", $68aec2772563966a$var$BROWSER_WEB_VITAL_INP_TARGET = "browser.web_vital.inp.target", $68aec2772563966a$var$BROWSER_WEB_VITAL_INP_VALUE = "browser.web_vital.inp.value", $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_ELEMENT = "browser.web_vital.lcp.element", $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_ID = "browser.web_vital.lcp.id", $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME = "browser.web_vital.lcp.load_time", $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME = "browser.web_vital.lcp.render_time", $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT = "browser.web_vital.lcp.report_event", $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_SIZE = "browser.web_vital.lcp.size", $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_URL = "browser.web_vital.lcp.url", $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_VALUE = "browser.web_vital.lcp.value", $68aec2772563966a$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME = "browser.web_vital.ttfb.request_time", $68aec2772563966a$var$BROWSER_WEB_VITAL_TTFB_VALUE = "browser.web_vital.ttfb.value", $68aec2772563966a$var$CACHE_HIT = "cache.hit", $68aec2772563966a$var$CACHE_ITEM_AGE = "cache.item_age", $68aec2772563966a$var$CACHE_ITEM_SIZE = "cache.item_size", $68aec2772563966a$var$CACHE_KEY = "cache.key", $68aec2772563966a$var$CACHE_OPERATION = "cache.operation", $68aec2772563966a$var$CACHE_TAGS = "cache.tags", $68aec2772563966a$var$CACHE_TTL = "cache.ttl", $68aec2772563966a$var$CACHE_WRITE = "cache.write", $68aec2772563966a$var$CHANNEL = "channel", $68aec2772563966a$var$CLIENT_ADDRESS = "client.address", $68aec2772563966a$var$CLIENT_PORT = "client.port", $68aec2772563966a$var$CLOUDFLARE_D1_DURATION = "cloudflare.d1.duration", $68aec2772563966a$var$CLOUDFLARE_D1_QUERY_TYPE = "cloudflare.d1.query_type", $68aec2772563966a$var$CLOUDFLARE_D1_ROWS_READ = "cloudflare.d1.rows_read", $68aec2772563966a$var$CLOUDFLARE_D1_ROWS_WRITTEN = "cloudflare.d1.rows_written", $68aec2772563966a$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS = "cloudflare.durable_object.query.bindings", $68aec2772563966a$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ = "cloudflare.durable_object.response.rows_read", $68aec2772563966a$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN = "cloudflare.durable_object.response.rows_written", $68aec2772563966a$var$CLOUDFLARE_R2_BUCKET = "cloudflare.r2.bucket", $68aec2772563966a$var$CLOUDFLARE_R2_OPERATION = "cloudflare.r2.operation", $68aec2772563966a$var$CLOUDFLARE_R2_REQUEST_DELIMITER = "cloudflare.r2.request.delimiter", $68aec2772563966a$var$CLOUDFLARE_R2_REQUEST_KEY = "cloudflare.r2.request.key", $68aec2772563966a$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER = "cloudflare.r2.request.part_number", $68aec2772563966a$var$CLOUDFLARE_R2_REQUEST_PREFIX = "cloudflare.r2.request.prefix", $68aec2772563966a$var$CLOUDFLARE_WORKFLOW_ATTEMPT = "cloudflare.workflow.attempt", $68aec2772563966a$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF = "cloudflare.workflow.retries.backoff", $68aec2772563966a$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY = "cloudflare.workflow.retries.delay", $68aec2772563966a$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT = "cloudflare.workflow.retries.limit", $68aec2772563966a$var$CLOUDFLARE_WORKFLOW_TIMEOUT = "cloudflare.workflow.timeout", $68aec2772563966a$var$CLOUD_ACCOUNT_ID = "cloud.account.id", $68aec2772563966a$var$CLOUD_AVAILABILITY_ZONE = "cloud.availability_zone", $68aec2772563966a$var$CLOUD_PLATFORM = "cloud.platform", $68aec2772563966a$var$CLOUD_PROVIDER = "cloud.provider", $68aec2772563966a$var$CLOUD_REGION = "cloud.region", $68aec2772563966a$var$CLOUD_RESOURCE_ID = "cloud.resource_id", $68aec2772563966a$var$CLS = "cls", $68aec2772563966a$var$CLS_SOURCE_KEY = "cls.source.<key>", $68aec2772563966a$var$CLS_SOURCE_KEY_BASE = "cls.source", $68aec2772563966a$var$CODE = "code", $68aec2772563966a$var$CODE_FILEPATH = "code.filepath", $68aec2772563966a$var$CODE_FILE_PATH = "code.file.path", $68aec2772563966a$var$CODE_FUNCTION = "code.function", $68aec2772563966a$var$CODE_FUNCTION_NAME = "code.function.name", $68aec2772563966a$var$CODE_LINENO = "code.lineno", $68aec2772563966a$var$CODE_LINE_NUMBER = "code.line.number", $68aec2772563966a$var$CODE_NAMESPACE = "code.namespace", $68aec2772563966a$var$CONNECTIONTYPE = "connectionType", $68aec2772563966a$var$CONNECTION_RTT = "connection.rtt", $68aec2772563966a$var$CULTURE_CALENDAR = "culture.calendar", $68aec2772563966a$var$CULTURE_DISPLAY_NAME = "culture.display_name", $68aec2772563966a$var$CULTURE_IS_24_HOUR_FORMAT = "culture.is_24_hour_format", $68aec2772563966a$var$CULTURE_LOCALE = "culture.locale", $68aec2772563966a$var$CULTURE_TIMEZONE = "culture.timezone", $68aec2772563966a$var$DB_COLLECTION_NAME = "db.collection.name", $68aec2772563966a$var$DB_CONNECTION_STRING = "db.connection_string", $68aec2772563966a$var$DB_DRIVER_NAME = "db.driver.name", $68aec2772563966a$var$DB_MONGODB_COLLECTION = "db.mongodb.collection", $68aec2772563966a$var$DB_NAME = "db.name", $68aec2772563966a$var$DB_NAMESPACE = "db.namespace", $68aec2772563966a$var$DB_OPERATION = "db.operation", $68aec2772563966a$var$DB_OPERATION_BATCH_SIZE = "db.operation.batch.size", $68aec2772563966a$var$DB_OPERATION_NAME = "db.operation.name", $68aec2772563966a$var$DB_PARAMS = "db.params", $68aec2772563966a$var$DB_QUERY_PARAMETER_KEY = "db.query.parameter.<key>", $68aec2772563966a$var$DB_QUERY_PARAMETER_KEY_BASE = "db.query.parameter", $68aec2772563966a$var$DB_QUERY_SUMMARY = "db.query.summary", $68aec2772563966a$var$DB_QUERY_TEXT = "db.query.text", $68aec2772563966a$var$DB_REDIS_CONNECTION = "db.redis.connection", $68aec2772563966a$var$DB_REDIS_KEY = "db.redis.key", $68aec2772563966a$var$DB_REDIS_PARAMETERS = "db.redis.parameters", $68aec2772563966a$var$DB_RESPONSE_STATUS_CODE = "db.response.status_code", $68aec2772563966a$var$DB_SQL_BINDINGS = "db.sql.bindings", $68aec2772563966a$var$DB_STATEMENT = "db.statement", $68aec2772563966a$var$DB_STORED_PROCEDURE_NAME = "db.stored_procedure.name", $68aec2772563966a$var$DB_SYSTEM = "db.system", $68aec2772563966a$var$DB_SYSTEM_NAME = "db.system.name", $68aec2772563966a$var$DB_USER = "db.user", $68aec2772563966a$var$DEVICEMEMORY = "deviceMemory", $68aec2772563966a$var$DEVICE_ARCHS = "device.archs", $68aec2772563966a$var$DEVICE_BATTERY_LEVEL = "device.battery_level", $68aec2772563966a$var$DEVICE_BATTERY_TEMPERATURE = "device.battery_temperature", $68aec2772563966a$var$DEVICE_BOOT_TIME = "device.boot_time", $68aec2772563966a$var$DEVICE_BRAND = "device.brand", $68aec2772563966a$var$DEVICE_CHARGING = "device.charging", $68aec2772563966a$var$DEVICE_CHIPSET = "device.chipset", $68aec2772563966a$var$DEVICE_CLASS = "device.class", $68aec2772563966a$var$DEVICE_CONNECTION_TYPE = "device.connection_type", $68aec2772563966a$var$DEVICE_CPU_DESCRIPTION = "device.cpu_description", $68aec2772563966a$var$DEVICE_EXTERNAL_FREE_STORAGE = "device.external_free_storage", $68aec2772563966a$var$DEVICE_EXTERNAL_STORAGE_SIZE = "device.external_storage_size", $68aec2772563966a$var$DEVICE_FAMILY = "device.family", $68aec2772563966a$var$DEVICE_FREE_MEMORY = "device.free_memory", $68aec2772563966a$var$DEVICE_FREE_STORAGE = "device.free_storage", $68aec2772563966a$var$DEVICE_ID = "device.id", $68aec2772563966a$var$DEVICE_LOCALE = "device.locale", $68aec2772563966a$var$DEVICE_LOW_MEMORY = "device.low_memory", $68aec2772563966a$var$DEVICE_LOW_POWER_MODE = "device.low_power_mode", $68aec2772563966a$var$DEVICE_MANUFACTURER = "device.manufacturer", $68aec2772563966a$var$DEVICE_MEMORY_ESTIMATED_CAPACITY = "device.memory.estimated_capacity", $68aec2772563966a$var$DEVICE_MEMORY_SIZE = "device.memory_size", $68aec2772563966a$var$DEVICE_MODEL = "device.model", $68aec2772563966a$var$DEVICE_MODEL_ID = "device.model_id", $68aec2772563966a$var$DEVICE_NAME = "device.name", $68aec2772563966a$var$DEVICE_ONLINE = "device.online", $68aec2772563966a$var$DEVICE_ORIENTATION = "device.orientation", $68aec2772563966a$var$DEVICE_PROCESSOR_COUNT = "device.processor_count", $68aec2772563966a$var$DEVICE_PROCESSOR_FREQUENCY = "device.processor_frequency", $68aec2772563966a$var$DEVICE_SCREEN_DENSITY = "device.screen_density", $68aec2772563966a$var$DEVICE_SCREEN_DPI = "device.screen_dpi", $68aec2772563966a$var$DEVICE_SCREEN_HEIGHT_PIXELS = "device.screen_height_pixels", $68aec2772563966a$var$DEVICE_SCREEN_WIDTH_PIXELS = "device.screen_width_pixels", $68aec2772563966a$var$DEVICE_SIMULATOR = "device.simulator", $68aec2772563966a$var$DEVICE_STORAGE_SIZE = "device.storage_size", $68aec2772563966a$var$DEVICE_THERMAL_STATE = "device.thermal_state", $68aec2772563966a$var$DEVICE_TIMEZONE = "device.timezone", $68aec2772563966a$var$DEVICE_USABLE_MEMORY = "device.usable_memory", $68aec2772563966a$var$DIST = "dist", $68aec2772563966a$var$DJANGO_FUNCTION_NAME = "django.function_name", $68aec2772563966a$var$DJANGO_MIDDLEWARE_NAME = "django.middleware_name", $68aec2772563966a$var$EFFECTIVECONNECTIONTYPE = "effectiveConnectionType", $68aec2772563966a$var$ENVIRONMENT = "environment", $68aec2772563966a$var$ERROR_TYPE = "error.type", $68aec2772563966a$var$EVENT_ID = "event.id", $68aec2772563966a$var$EVENT_NAME = "event.name", $68aec2772563966a$var$EXCEPTION_ESCAPED = "exception.escaped", $68aec2772563966a$var$EXCEPTION_MESSAGE = "exception.message", $68aec2772563966a$var$EXCEPTION_STACKTRACE = "exception.stacktrace", $68aec2772563966a$var$EXCEPTION_TYPE = "exception.type", $68aec2772563966a$var$FAAS_COLDSTART = "faas.coldstart", $68aec2772563966a$var$FAAS_CRON = "faas.cron", $68aec2772563966a$var$FAAS_DURATION_IN_MS = "faas.duration_in_ms", $68aec2772563966a$var$FAAS_ENTRY_POINT = "faas.entry_point", $68aec2772563966a$var$FAAS_EXECUTION = "faas.execution", $68aec2772563966a$var$FAAS_ID = "faas.id", $68aec2772563966a$var$FAAS_IDENTITY = "faas.identity", $68aec2772563966a$var$FAAS_INVOCATION_ID = "faas.invocation_id", $68aec2772563966a$var$FAAS_INVOKED_NAME = "faas.invoked_name", $68aec2772563966a$var$FAAS_INVOKED_PROVIDER = "faas.invoked_provider", $68aec2772563966a$var$FAAS_INVOKED_REGION = "faas.invoked_region", $68aec2772563966a$var$FAAS_NAME = "faas.name", $68aec2772563966a$var$FAAS_TIME = "faas.time", $68aec2772563966a$var$FAAS_TRIGGER = "faas.trigger", $68aec2772563966a$var$FAAS_VERSION = "faas.version", $68aec2772563966a$var$FCP = "fcp", $68aec2772563966a$var$FILE_PATH = "file.path", $68aec2772563966a$var$FILE_SIZE = "file.size", $68aec2772563966a$var$FLAG_EVALUATION_KEY = "flag.evaluation.<key>", $68aec2772563966a$var$FLAG_EVALUATION_KEY_BASE = "flag.evaluation", $68aec2772563966a$var$FP = "fp", $68aec2772563966a$var$FRAMES_DELAY = "frames.delay", $68aec2772563966a$var$FRAMES_FROZEN = "frames.frozen", $68aec2772563966a$var$FRAMES_FROZEN_RATE = "frames_frozen_rate", $68aec2772563966a$var$FRAMES_SLOW = "frames.slow", $68aec2772563966a$var$FRAMES_SLOW_RATE = "frames_slow_rate", $68aec2772563966a$var$FRAMES_TOTAL = "frames.total", $68aec2772563966a$var$FS_ERROR = "fs_error", $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_EVENT_ID = "gcp.function.context.event_id", $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE = "gcp.function.context.event_type", $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_ID = "gcp.function.context.id", $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_RESOURCE = "gcp.function.context.resource", $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_SOURCE = "gcp.function.context.source", $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_SPECVERSION = "gcp.function.context.specversion", $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_TIME = "gcp.function.context.time", $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_TIMESTAMP = "gcp.function.context.timestamp", $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_TYPE = "gcp.function.context.type", $68aec2772563966a$var$GCP_PROJECT_ID = "gcp.project.id", $68aec2772563966a$var$GCP_REGION = "gcp_region", $68aec2772563966a$var$GEN_AI_AGENT_NAME = "gen_ai.agent.name", $68aec2772563966a$var$GEN_AI_CONTEXT_UTILIZATION = "gen_ai.context.utilization", $68aec2772563966a$var$GEN_AI_CONTEXT_WINDOW_SIZE = "gen_ai.context.window_size", $68aec2772563966a$var$GEN_AI_CONVERSATION_ID = "gen_ai.conversation.id", $68aec2772563966a$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS = "gen_ai.cost.cache_creation.input_tokens", $68aec2772563966a$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS = "gen_ai.cost.cache_read.input_tokens", $68aec2772563966a$var$GEN_AI_COST_INPUT_TOKENS = "gen_ai.cost.input_tokens", $68aec2772563966a$var$GEN_AI_COST_OUTPUT_TOKENS = "gen_ai.cost.output_tokens", $68aec2772563966a$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS = "gen_ai.cost.reasoning.output_tokens", $68aec2772563966a$var$GEN_AI_COST_TOTAL_TOKENS = "gen_ai.cost.total_tokens", $68aec2772563966a$var$GEN_AI_EMBEDDINGS_INPUT = "gen_ai.embeddings.input", $68aec2772563966a$var$GEN_AI_FUNCTION_ID = "gen_ai.function_id", $68aec2772563966a$var$GEN_AI_INPUT_MESSAGES = "gen_ai.input.messages", $68aec2772563966a$var$GEN_AI_OPERATION_NAME = "gen_ai.operation.name", $68aec2772563966a$var$GEN_AI_OPERATION_TYPE = "gen_ai.operation.type", $68aec2772563966a$var$GEN_AI_OUTPUT_MESSAGES = "gen_ai.output.messages", $68aec2772563966a$var$GEN_AI_PIPELINE_NAME = "gen_ai.pipeline.name", $68aec2772563966a$var$GEN_AI_PROMPT = "gen_ai.prompt", $68aec2772563966a$var$GEN_AI_PROMPT_NAME = "gen_ai.prompt.name", $68aec2772563966a$var$GEN_AI_PROVIDER_NAME = "gen_ai.provider.name", $68aec2772563966a$var$GEN_AI_REQUEST_AVAILABLE_TOOLS = "gen_ai.request.available_tools", $68aec2772563966a$var$GEN_AI_REQUEST_FREQUENCY_PENALTY = "gen_ai.request.frequency_penalty", $68aec2772563966a$var$GEN_AI_REQUEST_MAX_TOKENS = "gen_ai.request.max_tokens", $68aec2772563966a$var$GEN_AI_REQUEST_MESSAGES = "gen_ai.request.messages", $68aec2772563966a$var$GEN_AI_REQUEST_MODEL = "gen_ai.request.model", $68aec2772563966a$var$GEN_AI_REQUEST_PRESENCE_PENALTY = "gen_ai.request.presence_penalty", $68aec2772563966a$var$GEN_AI_REQUEST_REASONING_LEVEL = "gen_ai.request.reasoning.level", $68aec2772563966a$var$GEN_AI_REQUEST_SCHEMA = "gen_ai.request.schema", $68aec2772563966a$var$GEN_AI_REQUEST_SEED = "gen_ai.request.seed", $68aec2772563966a$var$GEN_AI_REQUEST_STOP_SEQUENCES = "gen_ai.request.stop_sequences", $68aec2772563966a$var$GEN_AI_REQUEST_TEMPERATURE = "gen_ai.request.temperature", $68aec2772563966a$var$GEN_AI_REQUEST_TOP_K = "gen_ai.request.top_k", $68aec2772563966a$var$GEN_AI_REQUEST_TOP_P = "gen_ai.request.top_p", $68aec2772563966a$var$GEN_AI_RESPONSE_FINISH_REASON = "gen_ai.response.finish_reason", $68aec2772563966a$var$GEN_AI_RESPONSE_FINISH_REASONS = "gen_ai.response.finish_reasons", $68aec2772563966a$var$GEN_AI_RESPONSE_ID = "gen_ai.response.id", $68aec2772563966a$var$GEN_AI_RESPONSE_MODEL = "gen_ai.response.model", $68aec2772563966a$var$GEN_AI_RESPONSE_OBJECT = "gen_ai.response.object", $68aec2772563966a$var$GEN_AI_RESPONSE_STREAMING = "gen_ai.response.streaming", $68aec2772563966a$var$GEN_AI_RESPONSE_TEXT = "gen_ai.response.text", $68aec2772563966a$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK = "gen_ai.response.time_to_first_chunk", $68aec2772563966a$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN = "gen_ai.response.time_to_first_token", $68aec2772563966a$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND = "gen_ai.response.tokens_per_second", $68aec2772563966a$var$GEN_AI_RESPONSE_TOOL_CALLS = "gen_ai.response.tool_calls", $68aec2772563966a$var$GEN_AI_SYSTEM = "gen_ai.system", $68aec2772563966a$var$GEN_AI_SYSTEM_INSTRUCTIONS = "gen_ai.system_instructions", $68aec2772563966a$var$GEN_AI_SYSTEM_MESSAGE = "gen_ai.system.message", $68aec2772563966a$var$GEN_AI_TOOL_CALL_ARGUMENTS = "gen_ai.tool.call.arguments", $68aec2772563966a$var$GEN_AI_TOOL_CALL_RESULT = "gen_ai.tool.call.result", $68aec2772563966a$var$GEN_AI_TOOL_DEFINITIONS = "gen_ai.tool.definitions", $68aec2772563966a$var$GEN_AI_TOOL_DESCRIPTION = "gen_ai.tool.description", $68aec2772563966a$var$GEN_AI_TOOL_INPUT = "gen_ai.tool.input", $68aec2772563966a$var$GEN_AI_TOOL_MESSAGE = "gen_ai.tool.message", $68aec2772563966a$var$GEN_AI_TOOL_NAME = "gen_ai.tool.name", $68aec2772563966a$var$GEN_AI_TOOL_OUTPUT = "gen_ai.tool.output", $68aec2772563966a$var$GEN_AI_TOOL_TYPE = "gen_ai.tool.type", $68aec2772563966a$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS = "gen_ai.usage.cache_creation.input_tokens", $68aec2772563966a$var$_GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS = "gen_ai.usage.cache_creation_input_tokens", $68aec2772563966a$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS = "gen_ai.usage.cache_read.input_tokens", $68aec2772563966a$var$_GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS = "gen_ai.usage.cache_read_input_tokens", $68aec2772563966a$var$GEN_AI_USAGE_COMPLETION_TOKENS = "gen_ai.usage.completion_tokens", $68aec2772563966a$var$GEN_AI_USAGE_INPUT_TOKENS = "gen_ai.usage.input_tokens", $68aec2772563966a$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED = "gen_ai.usage.input_tokens.cached", $68aec2772563966a$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE = "gen_ai.usage.input_tokens.cache_write", $68aec2772563966a$var$GEN_AI_USAGE_OUTPUT_TOKENS = "gen_ai.usage.output_tokens", $68aec2772563966a$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING = "gen_ai.usage.output_tokens.reasoning", $68aec2772563966a$var$GEN_AI_USAGE_PROMPT_TOKENS = "gen_ai.usage.prompt_tokens", $68aec2772563966a$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS = "gen_ai.usage.reasoning.output_tokens", $68aec2772563966a$var$GEN_AI_USAGE_TOTAL_TOKENS = "gen_ai.usage.total_tokens", $68aec2772563966a$var$GRAPHQL_DOCUMENT = "graphql.document", $68aec2772563966a$var$GRAPHQL_OPERATION_NAME = "graphql.operation.name", $68aec2772563966a$var$GRAPHQL_OPERATION_TYPE = "graphql.operation.type", $68aec2772563966a$var$GRAPHQL_PROCESSING_TYPE = "graphql.processing.type", $68aec2772563966a$var$GRAPHQL_SOURCE = "graphql.source", $68aec2772563966a$var$GRPC_ERROR_BAD_REQUEST_FIELD_VIOLATIONS = "grpc.error.bad_request.field_violations", $68aec2772563966a$var$GRPC_ERROR_DEBUG_INFO_DETAIL = "grpc.error.debug_info.detail", $68aec2772563966a$var$GRPC_ERROR_DEBUG_INFO_STACK_ENTRIES = "grpc.error.debug_info.stack_entries", $68aec2772563966a$var$GRPC_ERROR_ERROR_INFO_DOMAIN = "grpc.error.error_info.domain", $68aec2772563966a$var$GRPC_ERROR_ERROR_INFO_METADATA_KEY = "grpc.error.error_info.metadata.<key>", $68aec2772563966a$var$GRPC_ERROR_ERROR_INFO_METADATA_KEY_BASE = "grpc.error.error_info.metadata", $68aec2772563966a$var$GRPC_ERROR_ERROR_INFO_REASON = "grpc.error.error_info.reason", $68aec2772563966a$var$GRPC_ERROR_PRECONDITION_FAILURE_VIOLATIONS = "grpc.error.precondition_failure.violations", $68aec2772563966a$var$GRPC_ERROR_QUOTA_FAILURE_VIOLATIONS = "grpc.error.quota_failure.violations", $68aec2772563966a$var$GRPC_ERROR_RESOURCE_INFO_DESCRIPTION = "grpc.error.resource_info.description", $68aec2772563966a$var$GRPC_ERROR_RESOURCE_INFO_OWNER = "grpc.error.resource_info.owner", $68aec2772563966a$var$GRPC_ERROR_RESOURCE_INFO_RESOURCE_NAME = "grpc.error.resource_info.resource_name", $68aec2772563966a$var$GRPC_ERROR_RESOURCE_INFO_RESOURCE_TYPE = "grpc.error.resource_info.resource_type", $68aec2772563966a$var$GRPC_ERROR_RETRY_INFO_RETRY_DELAY_MS = "grpc.error.retry_info.retry_delay_ms", $68aec2772563966a$var$HARDWARECONCURRENCY = "hardwareConcurrency", $68aec2772563966a$var$HTTP_CLIENT_IP = "http.client_ip", $68aec2772563966a$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH = "http.decoded_response_content_length", $68aec2772563966a$var$HTTP_FLAVOR = "http.flavor", $68aec2772563966a$var$HTTP_FRAGMENT = "http.fragment", $68aec2772563966a$var$HTTP_HOST = "http.host", $68aec2772563966a$var$HTTP_METHOD = "http.method", $68aec2772563966a$var$HTTP_QUERY = "http.query", $68aec2772563966a$var$HTTP_REQUEST_BODY_DATA = "http.request.body.data", $68aec2772563966a$var$HTTP_REQUEST_BODY_DECODED_SIZE = "http.request.body.decoded_size", $68aec2772563966a$var$HTTP_REQUEST_BODY_SIZE = "http.request.body.size", $68aec2772563966a$var$HTTP_REQUEST_CONNECTION_END = "http.request.connection_end", $68aec2772563966a$var$HTTP_REQUEST_CONNECT_START = "http.request.connect_start", $68aec2772563966a$var$HTTP_REQUEST_CONTENT_LENGTH = "http.request_content_length", $68aec2772563966a$var$HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = "http.request_content_length_uncompressed", $68aec2772563966a$var$HTTP_REQUEST_DOMAIN_LOOKUP_END = "http.request.domain_lookup_end", $68aec2772563966a$var$HTTP_REQUEST_DOMAIN_LOOKUP_START = "http.request.domain_lookup_start", $68aec2772563966a$var$HTTP_REQUEST_FETCH_START = "http.request.fetch_start", $68aec2772563966a$var$HTTP_REQUEST_HEADER_KEY = "http.request.header.<key>", $68aec2772563966a$var$HTTP_REQUEST_HEADER_KEY_BASE = "http.request.header", $68aec2772563966a$var$HTTP_REQUEST_METHOD = "http.request.method", $68aec2772563966a$var$_HTTP_REQUEST_METHOD = "http.request_method", $68aec2772563966a$var$HTTP_REQUEST_REDIRECT_END = "http.request.redirect_end", $68aec2772563966a$var$HTTP_REQUEST_REDIRECT_START = "http.request.redirect_start", $68aec2772563966a$var$HTTP_REQUEST_REQUEST_START = "http.request.request_start", $68aec2772563966a$var$HTTP_REQUEST_RESEND_COUNT = "http.request.resend_count", $68aec2772563966a$var$HTTP_REQUEST_RESPONSE_END = "http.request.response_end", $68aec2772563966a$var$HTTP_REQUEST_RESPONSE_START = "http.request.response_start", $68aec2772563966a$var$HTTP_REQUEST_SAME_ORIGIN = "http.request.same_origin", $68aec2772563966a$var$HTTP_REQUEST_SECURE_CONNECTION_START = "http.request.secure_connection_start", $68aec2772563966a$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE = "http.request.time_to_first_byte", $68aec2772563966a$var$HTTP_REQUEST_WORKER_START = "http.request.worker_start", $68aec2772563966a$var$HTTP_RESPONSE_BODY_DECODED_SIZE = "http.response.body.decoded_size", $68aec2772563966a$var$HTTP_RESPONSE_BODY_SIZE = "http.response.body.size", $68aec2772563966a$var$HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length", $68aec2772563966a$var$HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = "http.response_content_length_uncompressed", $68aec2772563966a$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH = "http.response.header.content-length", $68aec2772563966a$var$HTTP_RESPONSE_HEADER_KEY = "http.response.header.<key>", $68aec2772563966a$var$HTTP_RESPONSE_HEADER_KEY_BASE = "http.response.header", $68aec2772563966a$var$HTTP_RESPONSE_SIZE = "http.response.size", $68aec2772563966a$var$HTTP_RESPONSE_STATUS_CODE = "http.response.status_code", $68aec2772563966a$var$HTTP_RESPONSE_STATUS_TEXT = "http.response.status_text", $68aec2772563966a$var$HTTP_RESPONSE_TRANSFER_SIZE = "http.response_transfer_size", $68aec2772563966a$var$HTTP_ROUTE = "http.route", $68aec2772563966a$var$HTTP_SCHEME = "http.scheme", $68aec2772563966a$var$HTTP_SERVER_NAME = "http.server_name", $68aec2772563966a$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE = "http.server.request.time_in_queue", $68aec2772563966a$var$HTTP_STATUS_CODE = "http.status_code", $68aec2772563966a$var$HTTP_STATUS_TEXT = "http.status_text", $68aec2772563966a$var$HTTP_TARGET = "http.target", $68aec2772563966a$var$HTTP_URL = "http.url", $68aec2772563966a$var$HTTP_USER_AGENT = "http.user_agent", $68aec2772563966a$var$ID = "id", $68aec2772563966a$var$INP = "inp", $68aec2772563966a$var$JSONRPC_PROTOCOL_VERSION = "jsonrpc.protocol.version", $68aec2772563966a$var$JSONRPC_REQUEST_ID = "jsonrpc.request.id", $68aec2772563966a$var$JVM_GC_ACTION = "jvm.gc.action", $68aec2772563966a$var$JVM_GC_NAME = "jvm.gc.name", $68aec2772563966a$var$JVM_MEMORY_POOL_NAME = "jvm.memory.pool.name", $68aec2772563966a$var$JVM_MEMORY_TYPE = "jvm.memory.type", $68aec2772563966a$var$JVM_THREAD_DAEMON = "jvm.thread.daemon", $68aec2772563966a$var$JVM_THREAD_STATE = "jvm.thread.state", $68aec2772563966a$var$KOA_NAME = "koa.name", $68aec2772563966a$var$KOA_TYPE = "koa.type", $68aec2772563966a$var$LANGCHAIN_CHAIN_NAME = "langchain.chain.name", $68aec2772563966a$var$LCP = "lcp", $68aec2772563966a$var$LCP_ELEMENT = "lcp.element", $68aec2772563966a$var$LCP_ID = "lcp.id", $68aec2772563966a$var$LCP_LOADTIME = "lcp.loadTime", $68aec2772563966a$var$LCP_RENDERTIME = "lcp.renderTime", $68aec2772563966a$var$LCP_SIZE = "lcp.size", $68aec2772563966a$var$LCP_URL = "lcp.url", $68aec2772563966a$var$LITESTAR_MIDDLEWARE_NAME = "litestar.middleware_name", $68aec2772563966a$var$LOGGER_NAME = "logger.name", $68aec2772563966a$var$MCP_CANCELLED_REASON = "mcp.cancelled.reason", $68aec2772563966a$var$MCP_CANCELLED_REQUEST_ID = "mcp.cancelled.request_id", $68aec2772563966a$var$MCP_CLIENT_NAME = "mcp.client.name", $68aec2772563966a$var$MCP_CLIENT_TITLE = "mcp.client.title", $68aec2772563966a$var$MCP_CLIENT_VERSION = "mcp.client.version", $68aec2772563966a$var$MCP_LIFECYCLE_PHASE = "mcp.lifecycle.phase", $68aec2772563966a$var$MCP_LOGGING_DATA_TYPE = "mcp.logging.data_type", $68aec2772563966a$var$MCP_LOGGING_LEVEL = "mcp.logging.level", $68aec2772563966a$var$MCP_LOGGING_LOGGER = "mcp.logging.logger", $68aec2772563966a$var$MCP_LOGGING_MESSAGE = "mcp.logging.message", $68aec2772563966a$var$MCP_METHOD_NAME = "mcp.method.name", $68aec2772563966a$var$MCP_PROGRESS_CURRENT = "mcp.progress.current", $68aec2772563966a$var$MCP_PROGRESS_MESSAGE = "mcp.progress.message", $68aec2772563966a$var$MCP_PROGRESS_PERCENTAGE = "mcp.progress.percentage", $68aec2772563966a$var$MCP_PROGRESS_TOKEN = "mcp.progress.token", $68aec2772563966a$var$MCP_PROGRESS_TOTAL = "mcp.progress.total", $68aec2772563966a$var$MCP_PROMPT_NAME = "mcp.prompt.name", $68aec2772563966a$var$MCP_PROMPT_RESULT_DESCRIPTION = "mcp.prompt.result.description", $68aec2772563966a$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT = "mcp.prompt.result.message_content", $68aec2772563966a$var$MCP_PROMPT_RESULT_MESSAGE_COUNT = "mcp.prompt.result.message_count", $68aec2772563966a$var$MCP_PROMPT_RESULT_MESSAGE_ROLE = "mcp.prompt.result.message_role", $68aec2772563966a$var$MCP_PROTOCOL_READY = "mcp.protocol.ready", $68aec2772563966a$var$MCP_PROTOCOL_VERSION = "mcp.protocol.version", $68aec2772563966a$var$MCP_REQUEST_ARGUMENT_KEY = "mcp.request.argument.<key>", $68aec2772563966a$var$MCP_REQUEST_ARGUMENT_KEY_BASE = "mcp.request.argument", $68aec2772563966a$var$MCP_REQUEST_ARGUMENT_NAME = "mcp.request.argument.name", $68aec2772563966a$var$MCP_REQUEST_ARGUMENT_URI = "mcp.request.argument.uri", $68aec2772563966a$var$MCP_REQUEST_ID = "mcp.request.id", $68aec2772563966a$var$MCP_RESOURCE_PROTOCOL = "mcp.resource.protocol", $68aec2772563966a$var$MCP_RESOURCE_URI = "mcp.resource.uri", $68aec2772563966a$var$MCP_SERVER_NAME = "mcp.server.name", $68aec2772563966a$var$MCP_SERVER_TITLE = "mcp.server.title", $68aec2772563966a$var$MCP_SERVER_VERSION = "mcp.server.version", $68aec2772563966a$var$MCP_SESSION_ID = "mcp.session.id", $68aec2772563966a$var$MCP_TOOL_NAME = "mcp.tool.name", $68aec2772563966a$var$MCP_TOOL_RESULT_CONTENT = "mcp.tool.result.content", $68aec2772563966a$var$MCP_TOOL_RESULT_CONTENT_COUNT = "mcp.tool.result.content_count", $68aec2772563966a$var$MCP_TOOL_RESULT_IS_ERROR = "mcp.tool.result.is_error", $68aec2772563966a$var$MCP_TRANSPORT = "mcp.transport", $68aec2772563966a$var$MDC_KEY = "mdc.<key>", $68aec2772563966a$var$MDC_KEY_BASE = "mdc", $68aec2772563966a$var$MESSAGING_BATCH_MESSAGE_COUNT = "messaging.batch.message_count", $68aec2772563966a$var$MESSAGING_CONVERSATION_ID = "messaging.conversation_id", $68aec2772563966a$var$MESSAGING_DESTINATION = "messaging.destination", $68aec2772563966a$var$MESSAGING_DESTINATION_CONNECTION = "messaging.destination.connection", $68aec2772563966a$var$MESSAGING_DESTINATION_KIND = "messaging.destination_kind", $68aec2772563966a$var$MESSAGING_DESTINATION_NAME = "messaging.destination.name", $68aec2772563966a$var$MESSAGING_DESTINATION_PARTITION_ID = "messaging.destination.partition.id", $68aec2772563966a$var$MESSAGING_KAFKA_MESSAGE_KEY = "messaging.kafka.message.key", $68aec2772563966a$var$MESSAGING_KAFKA_MESSAGE_TOMBSTONE = "messaging.kafka.message.tombstone", $68aec2772563966a$var$MESSAGING_KAFKA_OFFSET = "messaging.kafka.offset", $68aec2772563966a$var$MESSAGING_MESSAGE_BODY_SIZE = "messaging.message.body.size", $68aec2772563966a$var$MESSAGING_MESSAGE_CONVERSATION_ID = "messaging.message.conversation_id", $68aec2772563966a$var$MESSAGING_MESSAGE_ENVELOPE_SIZE = "messaging.message.envelope.size", $68aec2772563966a$var$MESSAGING_MESSAGE_ID = "messaging.message.id", $68aec2772563966a$var$_MESSAGING_MESSAGE_ID = "messaging.message_id", $68aec2772563966a$var$MESSAGING_MESSAGE_RECEIVE_LATENCY = "messaging.message.receive.latency", $68aec2772563966a$var$MESSAGING_MESSAGE_RETRY_COUNT = "messaging.message.retry.count", $68aec2772563966a$var$MESSAGING_OPERATION = "messaging.operation", $68aec2772563966a$var$MESSAGING_OPERATION_NAME = "messaging.operation.name", $68aec2772563966a$var$MESSAGING_OPERATION_TYPE = "messaging.operation.type", $68aec2772563966a$var$MESSAGING_PROTOCOL = "messaging.protocol", $68aec2772563966a$var$MESSAGING_PROTOCOL_VERSION = "messaging.protocol_version", $68aec2772563966a$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY = "messaging.rabbitmq.destination.routing_key", $68aec2772563966a$var$MESSAGING_RABBITMQ_ROUTING_KEY = "messaging.rabbitmq.routing_key", $68aec2772563966a$var$MESSAGING_SYSTEM = "messaging.system", $68aec2772563966a$var$MESSAGING_URL = "messaging.url", $68aec2772563966a$var$METHOD = "method", $68aec2772563966a$var$MIDDLEWARE_NAME = "middleware.name", $68aec2772563966a$var$NAVIGATION_ORIGIN = "navigation.origin", $68aec2772563966a$var$NAVIGATION_ROUTE_ID = "navigation.route.id", $68aec2772563966a$var$NAVIGATION_TYPE = "navigation.type", $68aec2772563966a$var$NEL_ELAPSED_TIME = "nel.elapsed_time", $68aec2772563966a$var$NEL_PHASE = "nel.phase", $68aec2772563966a$var$NEL_REFERRER = "nel.referrer", $68aec2772563966a$var$NEL_SAMPLING_FUNCTION = "nel.sampling_function", $68aec2772563966a$var$NEL_TYPE = "nel.type", $68aec2772563966a$var$NETWORK_CONNECTION_EFFECTIVE_TYPE = "network.connection.effective_type", $68aec2772563966a$var$NETWORK_CONNECTION_RTT = "network.connection.rtt", $68aec2772563966a$var$NETWORK_CONNECTION_TYPE = "network.connection.type", $68aec2772563966a$var$NETWORK_LOCAL_ADDRESS = "network.local.address", $68aec2772563966a$var$NETWORK_LOCAL_PORT = "network.local.port", $68aec2772563966a$var$NETWORK_PEER_ADDRESS = "network.peer.address", $68aec2772563966a$var$NETWORK_PEER_PORT = "network.peer.port", $68aec2772563966a$var$NETWORK_PROTOCOL_NAME = "network.protocol.name", $68aec2772563966a$var$NETWORK_PROTOCOL_VERSION = "network.protocol.version", $68aec2772563966a$var$NETWORK_TRANSPORT = "network.transport", $68aec2772563966a$var$NETWORK_TYPE = "network.type", $68aec2772563966a$var$NET_HOST_IP = "net.host.ip", $68aec2772563966a$var$NET_HOST_NAME = "net.host.name", $68aec2772563966a$var$NET_HOST_PORT = "net.host.port", $68aec2772563966a$var$NET_PEER_IP = "net.peer.ip", $68aec2772563966a$var$NET_PEER_NAME = "net.peer.name", $68aec2772563966a$var$NET_PEER_PORT = "net.peer.port", $68aec2772563966a$var$NET_PROTOCOL_NAME = "net.protocol.name", $68aec2772563966a$var$NET_PROTOCOL_VERSION = "net.protocol.version", $68aec2772563966a$var$NET_SOCK_FAMILY = "net.sock.family", $68aec2772563966a$var$NET_SOCK_HOST_ADDR = "net.sock.host.addr", $68aec2772563966a$var$NET_SOCK_HOST_PORT = "net.sock.host.port", $68aec2772563966a$var$NET_SOCK_PEER_ADDR = "net.sock.peer.addr", $68aec2772563966a$var$NET_SOCK_PEER_NAME = "net.sock.peer.name", $68aec2772563966a$var$NET_SOCK_PEER_PORT = "net.sock.peer.port", $68aec2772563966a$var$NET_TRANSPORT = "net.transport", $68aec2772563966a$var$OS_BUILD = "os.build", $68aec2772563966a$var$OS_BUILD_ID = "os.build_id", $68aec2772563966a$var$OS_DESCRIPTION = "os.description", $68aec2772563966a$var$OS_KERNEL_VERSION = "os.kernel_version", $68aec2772563966a$var$OS_NAME = "os.name", $68aec2772563966a$var$OS_RAW_DESCRIPTION = "os.raw_description", $68aec2772563966a$var$OS_ROOTED = "os.rooted", $68aec2772563966a$var$OS_THEME = "os.theme", $68aec2772563966a$var$OS_TYPE = "os.type", $68aec2772563966a$var$OS_VERSION = "os.version", $68aec2772563966a$var$OTEL_KIND = "otel.kind", $68aec2772563966a$var$OTEL_SCOPE_NAME = "otel.scope.name", $68aec2772563966a$var$OTEL_SCOPE_VERSION = "otel.scope.version", $68aec2772563966a$var$OTEL_STATUS_CODE = "otel.status_code", $68aec2772563966a$var$OTEL_STATUS_DESCRIPTION = "otel.status_description", $68aec2772563966a$var$PARAMS_KEY = "params.<key>", $68aec2772563966a$var$PARAMS_KEY_BASE = "params", $68aec2772563966a$var$PERFORMANCE_ACTIVATIONSTART = "performance.activationStart", $68aec2772563966a$var$PERFORMANCE_TIMEORIGIN = "performance.timeOrigin", $68aec2772563966a$var$PORT = "port", $68aec2772563966a$var$PREVIOUS_ROUTE = "previous_route", $68aec2772563966a$var$PROCESS_COMMAND_ARGS = "process.command_args", $68aec2772563966a$var$PROCESS_EXECUTABLE_NAME = "process.executable.name", $68aec2772563966a$var$PROCESS_PID = "process.pid", $68aec2772563966a$var$PROCESS_RUNTIME_DESCRIPTION = "process.runtime.description", $68aec2772563966a$var$PROCESS_RUNTIME_ENGINE_NAME = "process.runtime.engine.name", $68aec2772563966a$var$PROCESS_RUNTIME_ENGINE_VERSION = "process.runtime.engine.version", $68aec2772563966a$var$PROCESS_RUNTIME_NAME = "process.runtime.name", $68aec2772563966a$var$PROCESS_RUNTIME_VERSION = "process.runtime.version", $68aec2772563966a$var$PROFILE_ID = "profile_id", $68aec2772563966a$var$QUERY = "query", $68aec2772563966a$var$QUERY_KEY = "query.<key>", $68aec2772563966a$var$QUERY_KEY_BASE = "query", $68aec2772563966a$var$REACT_NATIVE_ARCHITECTURE = "react_native.architecture", $68aec2772563966a$var$REACT_NATIVE_MODULE_CALL_COUNT = "react_native.module.call.count", $68aec2772563966a$var$REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT = "react_native.module.call.distinct_count", $68aec2772563966a$var$REACT_NATIVE_MODULE_DURATION_MAX = "react_native.module.duration.max", $68aec2772563966a$var$REACT_NATIVE_MODULE_DURATION_TOTAL = "react_native.module.duration.total", $68aec2772563966a$var$REACT_NATIVE_MODULE_ERROR_COUNT = "react_native.module.error.count", $68aec2772563966a$var$REACT_NATIVE_MODULE_KIND = "react_native.module.kind", $68aec2772563966a$var$REACT_NATIVE_MODULE_METHOD = "react_native.module.method", $68aec2772563966a$var$REACT_NATIVE_MODULE_NAME = "react_native.module.name", $68aec2772563966a$var$REACT_NATIVE_MODULE_TOP_DURATION = "react_native.module.top.duration", $68aec2772563966a$var$REACT_NATIVE_MODULE_TOP_NAME = "react_native.module.top.name", $68aec2772563966a$var$REACT_VERSION = "react.version", $68aec2772563966a$var$REDIS_COMMAND = "redis.command", $68aec2772563966a$var$REDIS_KEY = "redis.key", $68aec2772563966a$var$RELEASE = "release", $68aec2772563966a$var$REMIX_ACTION_FORM_DATA_KEY = "remix.action_form_data.<key>", $68aec2772563966a$var$REMIX_ACTION_FORM_DATA_KEY_BASE = "remix.action_form_data", $68aec2772563966a$var$REPLAYID = "replayId", $68aec2772563966a$var$REPLAY_ID = "replay_id", $68aec2772563966a$var$RESOURCE_DEPLOYMENT_ENVIRONMENT = "resource.deployment.environment", $68aec2772563966a$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME = "resource.deployment.environment.name", $68aec2772563966a$var$RESOURCE_RENDER_BLOCKING_STATUS = "resource.render_blocking_status", $68aec2772563966a$var$ROUTE = "route", $68aec2772563966a$var$ROUTER_NAVIGATION_ORIGIN = "router.navigation.origin", $68aec2772563966a$var$ROUTER_NAVIGATION_ROUTE_ID = "router.navigation.route.id", $68aec2772563966a$var$ROUTER_NAVIGATION_TYPE = "router.navigation.type", $68aec2772563966a$var$RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code", $68aec2772563966a$var$RPC_METHOD = "rpc.method", $68aec2772563966a$var$RPC_RESPONSE_STATUS_CODE = "rpc.response.status_code", $68aec2772563966a$var$RPC_SERVICE = "rpc.service", $68aec2772563966a$var$RPC_SYSTEM = "rpc.system", $68aec2772563966a$var$RPC_SYSTEM_NAME = "rpc.system.name", $68aec2772563966a$var$RUNTIME_BUILD = "runtime.build", $68aec2772563966a$var$RUNTIME_NAME = "runtime.name", $68aec2772563966a$var$RUNTIME_RAW_DESCRIPTION = "runtime.raw_description", $68aec2772563966a$var$RUNTIME_VERSION = "runtime.version", $68aec2772563966a$var$SCORE_KEY = "score.<key>", $68aec2772563966a$var$SCORE_KEY_BASE = "score", $68aec2772563966a$var$SCORE_RATIO_KEY = "score.ratio.<key>", $68aec2772563966a$var$SCORE_RATIO_KEY_BASE = "score.ratio", $68aec2772563966a$var$SCORE_TOTAL = "score.total", $68aec2772563966a$var$SCORE_WEIGHT_KEY = "score.weight.<key>", $68aec2772563966a$var$SCORE_WEIGHT_KEY_BASE = "score.weight", $68aec2772563966a$var$SENTRY_ACTION = "sentry.action", $68aec2772563966a$var$SENTRY_BROWSER_NAME = "sentry.browser.name", $68aec2772563966a$var$SENTRY_BROWSER_VERSION = "sentry.browser.version", $68aec2772563966a$var$SENTRY_CANCELLATION_REASON = "sentry.cancellation_reason", $68aec2772563966a$var$SENTRY_CATEGORY = "sentry.category", $68aec2772563966a$var$SENTRY_CLIENT_SAMPLE_RATE = "sentry.client_sample_rate", $68aec2772563966a$var$SENTRY_DESCRIPTION = "sentry.description", $68aec2772563966a$var$SENTRY_DIST = "sentry.dist", $68aec2772563966a$var$SENTRY_DOMAIN = "sentry.domain", $68aec2772563966a$var$SENTRY_DSC_ENVIRONMENT = "sentry.dsc.environment", $68aec2772563966a$var$SENTRY_DSC_PROJECT_ID = "sentry.dsc.project_id", $68aec2772563966a$var$SENTRY_DSC_PUBLIC_KEY = "sentry.dsc.public_key", $68aec2772563966a$var$SENTRY_DSC_RELEASE = "sentry.dsc.release", $68aec2772563966a$var$SENTRY_DSC_SAMPLED = "sentry.dsc.sampled", $68aec2772563966a$var$SENTRY_DSC_SAMPLE_RATE = "sentry.dsc.sample_rate", $68aec2772563966a$var$SENTRY_DSC_TRACE_ID = "sentry.dsc.trace_id", $68aec2772563966a$var$SENTRY_DSC_TRANSACTION = "sentry.dsc.transaction", $68aec2772563966a$var$SENTRY_ENVIRONMENT = "sentry.environment", $68aec2772563966a$var$SENTRY_EVENT_SERIALIZED_BREADCRUMBS = "sentry.event.serialized_breadcrumbs", $68aec2772563966a$var$SENTRY_EVENT_SERIALIZED_CONTEXTS = "sentry.event.serialized_contexts", $68aec2772563966a$var$SENTRY_EVENT_SERIALIZED_EXTRA = "sentry.event.serialized_extra", $68aec2772563966a$var$SENTRY_EVENT_SERIALIZED_META = "sentry.event.serialized_meta", $68aec2772563966a$var$SENTRY_EXCLUSIVE_TIME = "sentry.exclusive_time", $68aec2772563966a$var$SENTRY_FRAMES_FROZEN = "sentry.frames.frozen", $68aec2772563966a$var$SENTRY_FRAMES_SLOW = "sentry.frames.slow", $68aec2772563966a$var$SENTRY_FRAMES_TOTAL = "sentry.frames.total", $68aec2772563966a$var$SENTRY_GRAPHQL_OPERATION = "sentry.graphql.operation", $68aec2772563966a$var$SENTRY_GROUP = "sentry.group", $68aec2772563966a$var$SENTRY_HTTP_PREFETCH = "sentry.http.prefetch", $68aec2772563966a$var$SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason", $68aec2772563966a$var$SENTRY_IS_LOCALHOST = "sentry.is_localhost", $68aec2772563966a$var$SENTRY_IS_REMOTE = "sentry.is_remote", $68aec2772563966a$var$SENTRY_KIND = "sentry.kind", $68aec2772563966a$var$SENTRY_LINK_TYPE = "sentry.link.type", $68aec2772563966a$var$SENTRY_MAIN_THREAD = "sentry.main_thread", $68aec2772563966a$var$SENTRY_MESSAGE_PARAMETER_KEY = "sentry.message.parameter.<key>", $68aec2772563966a$var$SENTRY_MESSAGE_TEMPLATE = "sentry.message.template", $68aec2772563966a$var$SENTRY_METRIC_SOURCE = "sentry.metric.source", $68aec2772563966a$var$SENTRY_MOBILE = "sentry.mobile", $68aec2772563966a$var$SENTRY_MODULE_KEY = "sentry.module.<key>", $68aec2772563966a$var$SENTRY_MODULE_KEY_BASE = "sentry.module", $68aec2772563966a$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE = "sentry.nextjs.ssr.function.route", $68aec2772563966a$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE = "sentry.nextjs.ssr.function.type", $68aec2772563966a$var$SENTRY_NORMALIZED_DB_QUERY = "sentry.normalized_db_query", $68aec2772563966a$var$SENTRY_NORMALIZED_DB_QUERY_HASH = "sentry.normalized_db_query.hash", $68aec2772563966a$var$SENTRY_NORMALIZED_DESCRIPTION = "sentry.normalized_description", $68aec2772563966a$var$SENTRY_OBSERVED_TIMESTAMP_NANOS = "sentry.observed_timestamp_nanos", $68aec2772563966a$var$SENTRY_OP = "sentry.op", $68aec2772563966a$var$SENTRY_ORIGIN = "sentry.origin", $68aec2772563966a$var$SENTRY_PAGELOAD_SPAN_ID = "sentry.pageload.span_id", $68aec2772563966a$var$SENTRY_PLATFORM = "sentry.platform", $68aec2772563966a$var$SENTRY_PROFILER_ID = "sentry.profiler_id", $68aec2772563966a$var$SENTRY_PROFILE_ID = "sentry.profile_id", $68aec2772563966a$var$SENTRY_RELAY_INGRESS = "sentry.relay.ingress", $68aec2772563966a$var$SENTRY_RELAY_PIPELINE = "sentry.relay.pipeline", $68aec2772563966a$var$SENTRY_RELEASE = "sentry.release", $68aec2772563966a$var$SENTRY_REPLAY_ID = "sentry.replay_id", $68aec2772563966a$var$SENTRY_REPLAY_IS_BUFFERING = "sentry.replay_is_buffering", $68aec2772563966a$var$SENTRY_REPORT_EVENT = "sentry.report_event", $68aec2772563966a$var$SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations", $68aec2772563966a$var$SENTRY_SDK_NAME = "sentry.sdk.name", $68aec2772563966a$var$SENTRY_SDK_VERSION = "sentry.sdk.version", $68aec2772563966a$var$SENTRY_SEGMENT_ID = "sentry.segment.id", $68aec2772563966a$var$_SENTRY_SEGMENT_ID = "sentry.segment_id", $68aec2772563966a$var$SENTRY_SEGMENT_NAME = "sentry.segment.name", $68aec2772563966a$var$SENTRY_SEGMENT_NAME_SOURCE = "sentry.segment.name.source", $68aec2772563966a$var$SENTRY_SERVER_SAMPLE_RATE = "sentry.server_sample_rate", $68aec2772563966a$var$SENTRY_SOURCE = "sentry.source", $68aec2772563966a$var$SENTRY_SPAN_SOURCE = "sentry.span.source", $68aec2772563966a$var$SENTRY_STATUS = "sentry.status", $68aec2772563966a$var$SENTRY_STATUS_CODE = "sentry.status_code", $68aec2772563966a$var$SENTRY_STATUS_MESSAGE = "sentry.status.message", $68aec2772563966a$var$SENTRY_SVELTEKIT_NAVIGATION_FROM = "sentry.sveltekit.navigation.from", $68aec2772563966a$var$SENTRY_SVELTEKIT_NAVIGATION_TO = "sentry.sveltekit.navigation.to", $68aec2772563966a$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE = "sentry.sveltekit.navigation.type", $68aec2772563966a$var$SENTRY_THREAD_ID = "sentry.thread.id", $68aec2772563966a$var$SENTRY_TIMESTAMP_SEQUENCE = "sentry.timestamp.sequence", $68aec2772563966a$var$SENTRY_TRACE_LIFECYCLE = "sentry.trace_lifecycle", $68aec2772563966a$var$SENTRY_TRACE_PARENT_SPAN_ID = "sentry.trace.parent_span_id", $68aec2772563966a$var$SENTRY_TRACE_STATUS = "sentry.trace.status", $68aec2772563966a$var$SENTRY_TRANSACTION = "sentry.transaction", $68aec2772563966a$var$SENTRY_USER_EMAIL = "sentry.user.email", $68aec2772563966a$var$SENTRY_USER_GEO_CITY = "sentry.user.geo.city", $68aec2772563966a$var$SENTRY_USER_GEO_COUNTRY_CODE = "sentry.user.geo.country_code", $68aec2772563966a$var$SENTRY_USER_GEO_REGION = "sentry.user.geo.region", $68aec2772563966a$var$SENTRY_USER_GEO_SUBDIVISION = "sentry.user.geo.subdivision", $68aec2772563966a$var$SENTRY_USER_ID = "sentry.user.id", $68aec2772563966a$var$SENTRY_USER_IP = "sentry.user.ip", $68aec2772563966a$var$SENTRY_USER_USERNAME = "sentry.user.username", $68aec2772563966a$var$SERVER_ADDRESS = "server.address", $68aec2772563966a$var$SERVER_NAME = "server_name", $68aec2772563966a$var$SERVER_PORT = "server.port", $68aec2772563966a$var$SERVICE_NAME = "service.name", $68aec2772563966a$var$SERVICE_VERSION = "service.version", $68aec2772563966a$var$SESSION_ID = "session.id", $68aec2772563966a$var$STALL_PERCENTAGE = "stall_percentage", $68aec2772563966a$var$STALL_TOTAL_TIME = "stall_total_time", $68aec2772563966a$var$STARLETTE_MIDDLEWARE_NAME = "starlette.middleware_name", $68aec2772563966a$var$STARLITE_MIDDLEWARE_NAME = "starlite.middleware_name", $68aec2772563966a$var$STATE_TYPE = "state.type", $68aec2772563966a$var$SUBPROCESS_PID = "subprocess.pid", $68aec2772563966a$var$SVELTEKIT_LOAD_ENVIRONMENT = "sveltekit.load.environment", $68aec2772563966a$var$SVELTEKIT_LOAD_NODE_ID = "sveltekit.load.node_id", $68aec2772563966a$var$SVELTEKIT_LOAD_NODE_TYPE = "sveltekit.load.node_type", $68aec2772563966a$var$SVELTEKIT_TRACING_ORIGINAL_NAME = "sveltekit.tracing.original_name", $68aec2772563966a$var$THREAD_ID = "thread.id", $68aec2772563966a$var$THREAD_NAME = "thread.name", $68aec2772563966a$var$TIMBER_TAG = "timber.tag", $68aec2772563966a$var$TIME_TO_FULL_DISPLAY = "time_to_full_display", $68aec2772563966a$var$TIME_TO_INITIAL_DISPLAY = "time_to_initial_display", $68aec2772563966a$var$TRANSACTION = "transaction", $68aec2772563966a$var$TRPC_PROCEDURE_PATH = "trpc.procedure_path", $68aec2772563966a$var$TRPC_PROCEDURE_TYPE = "trpc.procedure_type", $68aec2772563966a$var$TTFB = "ttfb", $68aec2772563966a$var$TTFB_REQUESTTIME = "ttfb.requestTime", $68aec2772563966a$var$TURBO_MODULES_TOTAL_CALL_COUNT = "turbo_modules.total_call_count", $68aec2772563966a$var$TURBO_MODULES_TOTAL_DURATION_MS = "turbo_modules.total_duration_ms", $68aec2772563966a$var$TURBO_MODULES_TOTAL_ERROR_COUNT = "turbo_modules.total_error_count", $68aec2772563966a$var$TURBO_MODULES_UNIQUE_METHODS = "turbo_modules.unique_methods", $68aec2772563966a$var$TURBO_MODULE_ARCH = "turbo_module.arch", $68aec2772563966a$var$TURBO_MODULE_METHOD = "turbo_module.method", $68aec2772563966a$var$TURBO_MODULE_NAME = "turbo_module.name", $68aec2772563966a$var$TURBO_MODULE_TOP_MODULE = "turbo_module.top_module", $68aec2772563966a$var$TURBO_MODULE_TOP_MODULE_DURATION_MS = "turbo_module.top_module_duration_ms", $68aec2772563966a$var$TURBO_MODULE_TOTAL_CALL_COUNT = "turbo_module.total_call_count", $68aec2772563966a$var$TURBO_MODULE_TOTAL_DURATION_MS = "turbo_module.total_duration_ms", $68aec2772563966a$var$TURBO_MODULE_TOTAL_ERROR_COUNT = "turbo_module.total_error_count", $68aec2772563966a$var$TURBO_MODULE_UNIQUE_METHODS = "turbo_module.unique_methods", $68aec2772563966a$var$TYPE = "type", $68aec2772563966a$var$UI_COMPONENT_NAME = "ui.component_name", $68aec2772563966a$var$UI_CONTRIBUTES_TO_TTFD = "ui.contributes_to_ttfd", $68aec2772563966a$var$UI_CONTRIBUTES_TO_TTID = "ui.contributes_to_ttid", $68aec2772563966a$var$UI_ELEMENT_HEIGHT = "ui.element.height", $68aec2772563966a$var$UI_ELEMENT_ID = "ui.element.id", $68aec2772563966a$var$UI_ELEMENT_IDENTIFIER = "ui.element.identifier", $68aec2772563966a$var$UI_ELEMENT_LOAD_TIME = "ui.element.load_time", $68aec2772563966a$var$UI_ELEMENT_PAINT_TYPE = "ui.element.paint_type", $68aec2772563966a$var$UI_ELEMENT_RENDER_TIME = "ui.element.render_time", $68aec2772563966a$var$UI_ELEMENT_TYPE = "ui.element.type", $68aec2772563966a$var$UI_ELEMENT_URL = "ui.element.url", $68aec2772563966a$var$UI_ELEMENT_WIDTH = "ui.element.width", $68aec2772563966a$var$URL = "url", $68aec2772563966a$var$URL_DOMAIN = "url.domain", $68aec2772563966a$var$URL_FRAGMENT = "url.fragment", $68aec2772563966a$var$URL_FULL = "url.full", $68aec2772563966a$var$URL_PATH = "url.path", $68aec2772563966a$var$URL_PATH_PARAMETER_KEY = "url.path.parameter.<key>", $68aec2772563966a$var$URL_PATH_PARAMETER_KEY_BASE = "url.path.parameter", $68aec2772563966a$var$URL_PATH_PARAMS_KEY = "url.path.params.<key>", $68aec2772563966a$var$URL_PATH_PARAMS_KEY_BASE = "url.path.params", $68aec2772563966a$var$URL_PORT = "url.port", $68aec2772563966a$var$URL_QUERY = "url.query", $68aec2772563966a$var$URL_SAME_ORIGIN = "url.same_origin", $68aec2772563966a$var$URL_SCHEME = "url.scheme", $68aec2772563966a$var$URL_TEMPLATE = "url.template", $68aec2772563966a$var$USER_AGENT_ORIGINAL = "user_agent.original", $68aec2772563966a$var$USER_EMAIL = "user.email", $68aec2772563966a$var$USER_FULL_NAME = "user.full_name", $68aec2772563966a$var$USER_GEO_CITY = "user.geo.city", $68aec2772563966a$var$USER_GEO_COUNTRY_CODE = "user.geo.country_code", $68aec2772563966a$var$USER_GEO_REGION = "user.geo.region", $68aec2772563966a$var$USER_GEO_SUBDIVISION = "user.geo.subdivision", $68aec2772563966a$var$USER_HASH = "user.hash", $68aec2772563966a$var$USER_ID = "user.id", $68aec2772563966a$var$USER_IP_ADDRESS = "user.ip_address", $68aec2772563966a$var$USER_NAME = "user.name", $68aec2772563966a$var$USER_ROLES = "user.roles", $68aec2772563966a$var$VERCEL_BRANCH = "vercel.branch", $68aec2772563966a$var$VERCEL_BUILD_ID = "vercel.build_id", $68aec2772563966a$var$VERCEL_DEPLOYMENT_ID = "vercel.deployment_id", $68aec2772563966a$var$VERCEL_DESTINATION = "vercel.destination", $68aec2772563966a$var$VERCEL_EDGE_TYPE = "vercel.edge_type", $68aec2772563966a$var$VERCEL_ENTRYPOINT = "vercel.entrypoint", $68aec2772563966a$var$VERCEL_EXECUTION_REGION = "vercel.execution_region", $68aec2772563966a$var$VERCEL_ID = "vercel.id", $68aec2772563966a$var$VERCEL_JA3_DIGEST = "vercel.ja3_digest", $68aec2772563966a$var$VERCEL_JA4_DIGEST = "vercel.ja4_digest", $68aec2772563966a$var$VERCEL_LOG_TYPE = "vercel.log_type", $68aec2772563966a$var$VERCEL_PATH = "vercel.path", $68aec2772563966a$var$VERCEL_PROJECT_ID = "vercel.project_id", $68aec2772563966a$var$VERCEL_PROJECT_NAME = "vercel.project_name", $68aec2772563966a$var$VERCEL_PROXY_CACHE_ID = "vercel.proxy.cache_id", $68aec2772563966a$var$VERCEL_PROXY_CLIENT_IP = "vercel.proxy.client_ip", $68aec2772563966a$var$VERCEL_PROXY_HOST = "vercel.proxy.host", $68aec2772563966a$var$VERCEL_PROXY_LAMBDA_REGION = "vercel.proxy.lambda_region", $68aec2772563966a$var$VERCEL_PROXY_METHOD = "vercel.proxy.method", $68aec2772563966a$var$VERCEL_PROXY_PATH = "vercel.proxy.path", $68aec2772563966a$var$VERCEL_PROXY_PATH_TYPE = "vercel.proxy.path_type", $68aec2772563966a$var$VERCEL_PROXY_PATH_TYPE_VARIANT = "vercel.proxy.path_type_variant", $68aec2772563966a$var$VERCEL_PROXY_REFERER = "vercel.proxy.referer", $68aec2772563966a$var$VERCEL_PROXY_REGION = "vercel.proxy.region", $68aec2772563966a$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE = "vercel.proxy.response_byte_size", $68aec2772563966a$var$VERCEL_PROXY_SCHEME = "vercel.proxy.scheme", $68aec2772563966a$var$VERCEL_PROXY_STATUS_CODE = "vercel.proxy.status_code", $68aec2772563966a$var$VERCEL_PROXY_TIMESTAMP = "vercel.proxy.timestamp", $68aec2772563966a$var$VERCEL_PROXY_USER_AGENT = "vercel.proxy.user_agent", $68aec2772563966a$var$VERCEL_PROXY_VERCEL_CACHE = "vercel.proxy.vercel_cache", $68aec2772563966a$var$VERCEL_PROXY_VERCEL_ID = "vercel.proxy.vercel_id", $68aec2772563966a$var$VERCEL_PROXY_WAF_ACTION = "vercel.proxy.waf_action", $68aec2772563966a$var$VERCEL_PROXY_WAF_RULE_ID = "vercel.proxy.waf_rule_id", $68aec2772563966a$var$VERCEL_REQUEST_ID = "vercel.request_id", $68aec2772563966a$var$VERCEL_SOURCE = "vercel.source", $68aec2772563966a$var$VERCEL_STATUS_CODE = "vercel.status_code", $68aec2772563966a$var$ATTRIBUTE_TYPE = {
    address: "string",
    "ai.citations": "string[]",
    "ai.completion_tokens.used": "integer",
    "ai.documents": "string[]",
    "ai.finish_reason": "string",
    "ai.frequency_penalty": "double",
    "ai.function_call": "string",
    "ai.generation_id": "string",
    "ai.input_messages": "string",
    "ai.is_search_required": "boolean",
    "ai.metadata": "string",
    "ai.model.id": "string",
    "ai.model_id": "string",
    "ai.model.provider": "string",
    "ai.pipeline.name": "string",
    "ai.preamble": "string",
    "ai.presence_penalty": "double",
    "ai.prompt": "string",
    "ai.prompt.messages": "string",
    "ai.prompt_tokens.used": "integer",
    "ai.prompt.tools": "string[]",
    "ai.raw_prompting": "boolean",
    "ai.responses": "string[]",
    "ai.response_format": "string",
    "ai.response.id": "string",
    "ai.response.model": "string",
    "ai.response.object": "string",
    "ai.response.text": "string",
    "ai.response.timestamp": "string",
    "ai.response.toolCalls": "string",
    "ai.schema": "string",
    "ai.search_queries": "string[]",
    "ai.search_results": "string[]",
    "ai.seed": "string",
    "ai.streaming": "boolean",
    "ai.tags": "string",
    "ai.temperature": "double",
    "ai.texts": "string[]",
    "ai.toolCall.args": "string",
    "ai.toolCall.result": "string",
    "ai.tools": "string[]",
    "ai.tool_calls": "string[]",
    "ai.top_k": "integer",
    "ai.top_p": "double",
    "ai.total_cost": "double",
    "ai.total_tokens.used": "integer",
    "ai.usage.tokens": "integer",
    "ai.values": "string",
    "ai.warnings": "string[]",
    "angular.version": "string",
    "app.app_build": "string",
    "app.app_identifier": "string",
    "app.app_name": "string",
    "app.app_start_time": "string",
    "app.app_version": "string",
    "app.build": "string",
    "app.identifier": "string",
    "app.in_foreground": "boolean",
    "app.name": "string",
    app_start_cold: "double",
    "app.start_time": "string",
    app_start_type: "string",
    app_start_warm: "double",
    "app.version": "string",
    "app.vitals.frames.delay.value": "integer",
    "app.vitals.frames.frozen.count": "integer",
    "app.vitals.frames.frozen.rate": "double",
    "app.vitals.frames.slow.count": "integer",
    "app.vitals.frames.slow.rate": "double",
    "app.vitals.frames.total.count": "integer",
    "app.vitals.stall.duration": "double",
    "app.vitals.stall.percentage": "double",
    "app.vitals.start.cold.value": "double",
    "app.vitals.start.prewarmed": "boolean",
    "app.vitals.start.reason": "string",
    "app.vitals.start.screen": "string",
    "app.vitals.start.type": "string",
    "app.vitals.start.warm.value": "double",
    "app.vitals.ttfd.value": "double",
    "app.vitals.ttid.value": "double",
    "art.gc.blocking_count": "integer",
    "art.gc.blocking_time": "double",
    "art.gc.pre_oome_count": "integer",
    "art.gc.total_count": "integer",
    "art.gc.total_time": "double",
    "art.gc.waiting_time": "double",
    "art.memory.free": "integer",
    "art.memory.free_until_gc": "integer",
    "art.memory.free_until_oome": "integer",
    "art.memory.max": "integer",
    "art.memory.total": "integer",
    "aws.cloudwatch.logs.log_group": "string",
    "aws.cloudwatch.logs.log_stream": "string",
    "aws.cloudwatch.logs.url": "string",
    "aws.dynamodb.attribute_definitions": "string[]",
    "aws.dynamodb.consistent_read": "boolean",
    "aws.dynamodb.consumed_capacity": "string[]",
    "aws.dynamodb.count": "integer",
    "aws.dynamodb.exclusive_start_table": "string",
    "aws.dynamodb.global_secondary_indexes": "string[]",
    "aws.dynamodb.global_secondary_index_updates": "string[]",
    "aws.dynamodb.index_name": "string",
    "aws.dynamodb.item_collection_metrics": "string",
    "aws.dynamodb.limit": "integer",
    "aws.dynamodb.local_secondary_indexes": "string[]",
    "aws.dynamodb.projection": "string",
    "aws.dynamodb.provisioned_read_capacity": "double",
    "aws.dynamodb.provisioned_write_capacity": "double",
    "aws.dynamodb.scanned_count": "integer",
    "aws.dynamodb.scan_forward": "boolean",
    "aws.dynamodb.segment": "integer",
    "aws.dynamodb.select": "string",
    "aws.dynamodb.table_count": "integer",
    "aws.dynamodb.table_names": "string[]",
    "aws.dynamodb.total_segments": "integer",
    "aws.extended_request_id": "string",
    "aws.kinesis.stream_name": "string",
    "aws.kinesis.stream.name": "string",
    "aws.lambda.aws_request_id": "string",
    "aws.lambda.execution_duration_in_millis": "double",
    "aws.lambda.function_name": "string",
    "aws.lambda.function_version": "string",
    "aws.lambda.invoked_arn": "string",
    "aws.lambda.invoked_function_arn": "string",
    "aws.lambda.remaining_time_in_millis": "double",
    "aws.log.group.names": "string[]",
    "aws.log.stream.names": "string[]",
    "aws.operation_name": "string",
    aws_region: "string",
    "aws.request.extended_id": "string",
    "aws.request_id": "string",
    "aws.request.id": "string",
    "aws.request.url": "string",
    "aws.s3.bucket": "string",
    "aws.secretsmanager.secret.arn": "string",
    "aws.sns.topic.arn": "string",
    "aws.step_functions.activity.arn": "string",
    "aws.step_functions.state_machine.arn": "string",
    blocked_main_thread: "boolean",
    "browser.bfcache.frame": "string",
    "browser.bfcache.not_restored_reason_count": "integer",
    "browser.bfcache.outcome": "string",
    "browser.bfcache.reason": "string",
    "browser.name": "string",
    "browser.navigation.id": "integer",
    "browser.navigation.type": "string",
    "browser.paint.type": "string",
    "browser.performance.navigation.activation_start": "double",
    "browser.performance.time_origin": "double",
    "browser.report.type": "string",
    "browser.script.invoker": "string",
    "browser.script.invoker_type": "string",
    "browser.script.source_char_position": "integer",
    "browser.version": "string",
    "browser.web_vital.cls.report_event": "string",
    "browser.web_vital.cls.source.<key>": "string",
    "browser.web_vital.cls.value": "double",
    "browser.web_vital.fcp.value": "double",
    "browser.web_vital.fp.value": "double",
    "browser.web_vital.inp.interaction_type": "string",
    "browser.web_vital.inp.target": "string",
    "browser.web_vital.inp.value": "double",
    "browser.web_vital.lcp.element": "string",
    "browser.web_vital.lcp.id": "string",
    "browser.web_vital.lcp.load_time": "integer",
    "browser.web_vital.lcp.render_time": "integer",
    "browser.web_vital.lcp.report_event": "string",
    "browser.web_vital.lcp.size": "integer",
    "browser.web_vital.lcp.url": "string",
    "browser.web_vital.lcp.value": "double",
    "browser.web_vital.ttfb.request_time": "double",
    "browser.web_vital.ttfb.value": "double",
    "cache.hit": "boolean",
    "cache.item_age": "integer",
    "cache.item_size": "integer",
    "cache.key": "string[]",
    "cache.operation": "string",
    "cache.tags": "string[]",
    "cache.ttl": "integer",
    "cache.write": "boolean",
    channel: "string",
    "client.address": "string",
    "client.port": "integer",
    "cloudflare.d1.duration": "integer",
    "cloudflare.d1.query_type": "string",
    "cloudflare.d1.rows_read": "integer",
    "cloudflare.d1.rows_written": "integer",
    "cloudflare.durable_object.query.bindings": "integer",
    "cloudflare.durable_object.response.rows_read": "integer",
    "cloudflare.durable_object.response.rows_written": "integer",
    "cloudflare.r2.bucket": "string",
    "cloudflare.r2.operation": "string",
    "cloudflare.r2.request.delimiter": "string",
    "cloudflare.r2.request.key": "string",
    "cloudflare.r2.request.part_number": "integer",
    "cloudflare.r2.request.prefix": "string",
    "cloudflare.workflow.attempt": "integer",
    "cloudflare.workflow.retries.backoff": "string",
    "cloudflare.workflow.retries.delay": "string",
    "cloudflare.workflow.retries.limit": "integer",
    "cloudflare.workflow.timeout": "string",
    "cloud.account.id": "string",
    "cloud.availability_zone": "string",
    "cloud.platform": "string",
    "cloud.provider": "string",
    "cloud.region": "string",
    "cloud.resource_id": "string",
    cls: "double",
    "cls.source.<key>": "string",
    code: "string",
    "code.filepath": "string",
    "code.file.path": "string",
    "code.function": "string",
    "code.function.name": "string",
    "code.lineno": "integer",
    "code.line.number": "integer",
    "code.namespace": "string",
    connectionType: "string",
    "connection.rtt": "integer",
    "culture.calendar": "string",
    "culture.display_name": "string",
    "culture.is_24_hour_format": "boolean",
    "culture.locale": "string",
    "culture.timezone": "string",
    "db.collection.name": "string",
    "db.connection_string": "string",
    "db.driver.name": "string",
    "db.mongodb.collection": "string",
    "db.name": "string",
    "db.namespace": "string",
    "db.operation": "string",
    "db.operation.batch.size": "integer",
    "db.operation.name": "string",
    "db.params": "string",
    "db.query.parameter.<key>": "string",
    "db.query.summary": "string",
    "db.query.text": "string",
    "db.redis.connection": "string",
    "db.redis.key": "string",
    "db.redis.parameters": "string[]",
    "db.response.status_code": "string",
    "db.sql.bindings": "string[]",
    "db.statement": "string",
    "db.stored_procedure.name": "string",
    "db.system": "string",
    "db.system.name": "string",
    "db.user": "string",
    deviceMemory: "string",
    "device.archs": "string[]",
    "device.battery_level": "double",
    "device.battery_temperature": "double",
    "device.boot_time": "string",
    "device.brand": "string",
    "device.charging": "boolean",
    "device.chipset": "string",
    "device.class": "string",
    "device.connection_type": "string",
    "device.cpu_description": "string",
    "device.external_free_storage": "integer",
    "device.external_storage_size": "integer",
    "device.family": "string",
    "device.free_memory": "integer",
    "device.free_storage": "integer",
    "device.id": "string",
    "device.locale": "string",
    "device.low_memory": "boolean",
    "device.low_power_mode": "boolean",
    "device.manufacturer": "string",
    "device.memory.estimated_capacity": "integer",
    "device.memory_size": "integer",
    "device.model": "string",
    "device.model_id": "string",
    "device.name": "string",
    "device.online": "boolean",
    "device.orientation": "string",
    "device.processor_count": "integer",
    "device.processor_frequency": "double",
    "device.screen_density": "double",
    "device.screen_dpi": "integer",
    "device.screen_height_pixels": "integer",
    "device.screen_width_pixels": "integer",
    "device.simulator": "boolean",
    "device.storage_size": "integer",
    "device.thermal_state": "string",
    "device.timezone": "string",
    "device.usable_memory": "integer",
    dist: "string",
    "django.function_name": "string",
    "django.middleware_name": "string",
    effectiveConnectionType: "string",
    environment: "string",
    "error.type": "string",
    "event.id": "integer",
    "event.name": "string",
    "exception.escaped": "boolean",
    "exception.message": "string",
    "exception.stacktrace": "string",
    "exception.type": "string",
    "faas.coldstart": "boolean",
    "faas.cron": "string",
    "faas.duration_in_ms": "integer",
    "faas.entry_point": "string",
    "faas.execution": "string",
    "faas.id": "string",
    "faas.identity": "string",
    "faas.invocation_id": "string",
    "faas.invoked_name": "string",
    "faas.invoked_provider": "string",
    "faas.invoked_region": "string",
    "faas.name": "string",
    "faas.time": "string",
    "faas.trigger": "string",
    "faas.version": "string",
    fcp: "double",
    "file.path": "string",
    "file.size": "integer",
    "flag.evaluation.<key>": "boolean",
    fp: "double",
    "frames.delay": "integer",
    "frames.frozen": "integer",
    frames_frozen_rate: "double",
    "frames.slow": "integer",
    frames_slow_rate: "double",
    "frames.total": "integer",
    fs_error: "string",
    "gcp.function.context.event_id": "string",
    "gcp.function.context.event_type": "string",
    "gcp.function.context.id": "string",
    "gcp.function.context.resource": "string",
    "gcp.function.context.source": "string",
    "gcp.function.context.specversion": "string",
    "gcp.function.context.time": "string",
    "gcp.function.context.timestamp": "string",
    "gcp.function.context.type": "string",
    "gcp.project.id": "string",
    gcp_region: "string",
    "gen_ai.agent.name": "string",
    "gen_ai.context.utilization": "double",
    "gen_ai.context.window_size": "integer",
    "gen_ai.conversation.id": "string",
    "gen_ai.cost.cache_creation.input_tokens": "double",
    "gen_ai.cost.cache_read.input_tokens": "double",
    "gen_ai.cost.input_tokens": "double",
    "gen_ai.cost.output_tokens": "double",
    "gen_ai.cost.reasoning.output_tokens": "double",
    "gen_ai.cost.total_tokens": "double",
    "gen_ai.embeddings.input": "string",
    "gen_ai.function_id": "string",
    "gen_ai.input.messages": "string",
    "gen_ai.operation.name": "string",
    "gen_ai.operation.type": "string",
    "gen_ai.output.messages": "string",
    "gen_ai.pipeline.name": "string",
    "gen_ai.prompt": "string",
    "gen_ai.prompt.name": "string",
    "gen_ai.provider.name": "string",
    "gen_ai.request.available_tools": "string",
    "gen_ai.request.frequency_penalty": "double",
    "gen_ai.request.max_tokens": "integer",
    "gen_ai.request.messages": "string",
    "gen_ai.request.model": "string",
    "gen_ai.request.presence_penalty": "double",
    "gen_ai.request.reasoning.level": "string",
    "gen_ai.request.schema": "string",
    "gen_ai.request.seed": "string",
    "gen_ai.request.stop_sequences": "string[]",
    "gen_ai.request.temperature": "double",
    "gen_ai.request.top_k": "integer",
    "gen_ai.request.top_p": "double",
    "gen_ai.response.finish_reason": "string",
    "gen_ai.response.finish_reasons": "string",
    "gen_ai.response.id": "string",
    "gen_ai.response.model": "string",
    "gen_ai.response.object": "string",
    "gen_ai.response.streaming": "boolean",
    "gen_ai.response.text": "string",
    "gen_ai.response.time_to_first_chunk": "double",
    "gen_ai.response.time_to_first_token": "double",
    "gen_ai.response.tokens_per_second": "double",
    "gen_ai.response.tool_calls": "string",
    "gen_ai.system": "string",
    "gen_ai.system_instructions": "string",
    "gen_ai.system.message": "string",
    "gen_ai.tool.call.arguments": "string",
    "gen_ai.tool.call.result": "string",
    "gen_ai.tool.definitions": "string",
    "gen_ai.tool.description": "string",
    "gen_ai.tool.input": "string",
    "gen_ai.tool.message": "string",
    "gen_ai.tool.name": "string",
    "gen_ai.tool.output": "string",
    "gen_ai.tool.type": "string",
    "gen_ai.usage.cache_creation.input_tokens": "integer",
    "gen_ai.usage.cache_creation_input_tokens": "integer",
    "gen_ai.usage.cache_read.input_tokens": "integer",
    "gen_ai.usage.cache_read_input_tokens": "integer",
    "gen_ai.usage.completion_tokens": "integer",
    "gen_ai.usage.input_tokens": "integer",
    "gen_ai.usage.input_tokens.cached": "integer",
    "gen_ai.usage.input_tokens.cache_write": "integer",
    "gen_ai.usage.output_tokens": "integer",
    "gen_ai.usage.output_tokens.reasoning": "integer",
    "gen_ai.usage.prompt_tokens": "integer",
    "gen_ai.usage.reasoning.output_tokens": "integer",
    "gen_ai.usage.total_tokens": "integer",
    "graphql.document": "string",
    "graphql.operation.name": "string",
    "graphql.operation.type": "string",
    "graphql.processing.type": "string",
    "graphql.source": "string",
    "grpc.error.bad_request.field_violations": "string[]",
    "grpc.error.debug_info.detail": "string",
    "grpc.error.debug_info.stack_entries": "string[]",
    "grpc.error.error_info.domain": "string",
    "grpc.error.error_info.metadata.<key>": "string",
    "grpc.error.error_info.reason": "string",
    "grpc.error.precondition_failure.violations": "string[]",
    "grpc.error.quota_failure.violations": "string[]",
    "grpc.error.resource_info.description": "string",
    "grpc.error.resource_info.owner": "string",
    "grpc.error.resource_info.resource_name": "string",
    "grpc.error.resource_info.resource_type": "string",
    "grpc.error.retry_info.retry_delay_ms": "integer",
    hardwareConcurrency: "string",
    "http.client_ip": "string",
    "http.decoded_response_content_length": "integer",
    "http.flavor": "string",
    "http.fragment": "string",
    "http.host": "string",
    "http.method": "string",
    "http.query": "string",
    "http.request.body.data": "string",
    "http.request.body.decoded_size": "integer",
    "http.request.body.size": "integer",
    "http.request.connection_end": "double",
    "http.request.connect_start": "double",
    "http.request_content_length": "integer",
    "http.request_content_length_uncompressed": "integer",
    "http.request.domain_lookup_end": "double",
    "http.request.domain_lookup_start": "double",
    "http.request.fetch_start": "double",
    "http.request.header.<key>": "string[]",
    "http.request.method": "string",
    "http.request_method": "string",
    "http.request.redirect_end": "double",
    "http.request.redirect_start": "double",
    "http.request.request_start": "double",
    "http.request.resend_count": "integer",
    "http.request.response_end": "double",
    "http.request.response_start": "double",
    "http.request.same_origin": "boolean",
    "http.request.secure_connection_start": "double",
    "http.request.time_to_first_byte": "double",
    "http.request.worker_start": "double",
    "http.response.body.decoded_size": "integer",
    "http.response.body.size": "integer",
    "http.response_content_length": "integer",
    "http.response_content_length_uncompressed": "integer",
    "http.response.header.content-length": "string",
    "http.response.header.<key>": "string[]",
    "http.response.size": "integer",
    "http.response.status_code": "integer",
    "http.response.status_text": "string",
    "http.response_transfer_size": "integer",
    "http.route": "string",
    "http.scheme": "string",
    "http.server_name": "string",
    "http.server.request.time_in_queue": "double",
    "http.status_code": "integer",
    "http.status_text": "string",
    "http.target": "string",
    "http.url": "string",
    "http.user_agent": "string",
    id: "string",
    inp: "double",
    "jsonrpc.protocol.version": "string",
    "jsonrpc.request.id": "string",
    "jvm.gc.action": "string",
    "jvm.gc.name": "string",
    "jvm.memory.pool.name": "string",
    "jvm.memory.type": "string",
    "jvm.thread.daemon": "boolean",
    "jvm.thread.state": "string",
    "koa.name": "string",
    "koa.type": "string",
    "langchain.chain.name": "string",
    lcp: "double",
    "lcp.element": "string",
    "lcp.id": "string",
    "lcp.loadTime": "integer",
    "lcp.renderTime": "integer",
    "lcp.size": "integer",
    "lcp.url": "string",
    "litestar.middleware_name": "string",
    "logger.name": "string",
    "mcp.cancelled.reason": "string",
    "mcp.cancelled.request_id": "string",
    "mcp.client.name": "string",
    "mcp.client.title": "string",
    "mcp.client.version": "string",
    "mcp.lifecycle.phase": "string",
    "mcp.logging.data_type": "string",
    "mcp.logging.level": "string",
    "mcp.logging.logger": "string",
    "mcp.logging.message": "string",
    "mcp.method.name": "string",
    "mcp.progress.current": "integer",
    "mcp.progress.message": "string",
    "mcp.progress.percentage": "double",
    "mcp.progress.token": "string",
    "mcp.progress.total": "integer",
    "mcp.prompt.name": "string",
    "mcp.prompt.result.description": "string",
    "mcp.prompt.result.message_content": "string",
    "mcp.prompt.result.message_count": "integer",
    "mcp.prompt.result.message_role": "string",
    "mcp.protocol.ready": "integer",
    "mcp.protocol.version": "string",
    "mcp.request.argument.<key>": "string",
    "mcp.request.argument.name": "string",
    "mcp.request.argument.uri": "string",
    "mcp.request.id": "string",
    "mcp.resource.protocol": "string",
    "mcp.resource.uri": "string",
    "mcp.server.name": "string",
    "mcp.server.title": "string",
    "mcp.server.version": "string",
    "mcp.session.id": "string",
    "mcp.tool.name": "string",
    "mcp.tool.result.content": "string",
    "mcp.tool.result.content_count": "integer",
    "mcp.tool.result.is_error": "boolean",
    "mcp.transport": "string",
    "mdc.<key>": "string",
    "messaging.batch.message_count": "integer",
    "messaging.conversation_id": "string",
    "messaging.destination": "string",
    "messaging.destination.connection": "string",
    "messaging.destination_kind": "string",
    "messaging.destination.name": "string",
    "messaging.destination.partition.id": "string",
    "messaging.kafka.message.key": "string",
    "messaging.kafka.message.tombstone": "boolean",
    "messaging.kafka.offset": "integer",
    "messaging.message.body.size": "integer",
    "messaging.message.conversation_id": "string",
    "messaging.message.envelope.size": "integer",
    "messaging.message.id": "string",
    "messaging.message_id": "string",
    "messaging.message.receive.latency": "integer",
    "messaging.message.retry.count": "integer",
    "messaging.operation": "string",
    "messaging.operation.name": "string",
    "messaging.operation.type": "string",
    "messaging.protocol": "string",
    "messaging.protocol_version": "string",
    "messaging.rabbitmq.destination.routing_key": "string",
    "messaging.rabbitmq.routing_key": "string",
    "messaging.system": "string",
    "messaging.url": "string",
    method: "string",
    "middleware.name": "string",
    "navigation.origin": "string",
    "navigation.route.id": "string",
    "navigation.type": "string",
    "nel.elapsed_time": "integer",
    "nel.phase": "string",
    "nel.referrer": "string",
    "nel.sampling_function": "double",
    "nel.type": "string",
    "network.connection.effective_type": "string",
    "network.connection.rtt": "integer",
    "network.connection.type": "string",
    "network.local.address": "string",
    "network.local.port": "integer",
    "network.peer.address": "string",
    "network.peer.port": "integer",
    "network.protocol.name": "string",
    "network.protocol.version": "string",
    "network.transport": "string",
    "network.type": "string",
    "net.host.ip": "string",
    "net.host.name": "string",
    "net.host.port": "integer",
    "net.peer.ip": "string",
    "net.peer.name": "string",
    "net.peer.port": "integer",
    "net.protocol.name": "string",
    "net.protocol.version": "string",
    "net.sock.family": "string",
    "net.sock.host.addr": "string",
    "net.sock.host.port": "integer",
    "net.sock.peer.addr": "string",
    "net.sock.peer.name": "string",
    "net.sock.peer.port": "integer",
    "net.transport": "string",
    "os.build": "string",
    "os.build_id": "string",
    "os.description": "string",
    "os.kernel_version": "string",
    "os.name": "string",
    "os.raw_description": "string",
    "os.rooted": "boolean",
    "os.theme": "string",
    "os.type": "string",
    "os.version": "string",
    "otel.kind": "string",
    "otel.scope.name": "string",
    "otel.scope.version": "string",
    "otel.status_code": "string",
    "otel.status_description": "string",
    "params.<key>": "string",
    "performance.activationStart": "double",
    "performance.timeOrigin": "double",
    port: "integer",
    previous_route: "string",
    "process.command_args": "string[]",
    "process.executable.name": "string",
    "process.pid": "integer",
    "process.runtime.description": "string",
    "process.runtime.engine.name": "string",
    "process.runtime.engine.version": "string",
    "process.runtime.name": "string",
    "process.runtime.version": "string",
    profile_id: "string",
    query: "string",
    "query.<key>": "string",
    "react_native.architecture": "string",
    "react_native.module.call.count": "integer",
    "react_native.module.call.distinct_count": "integer",
    "react_native.module.duration.max": "double",
    "react_native.module.duration.total": "double",
    "react_native.module.error.count": "integer",
    "react_native.module.kind": "string",
    "react_native.module.method": "string",
    "react_native.module.name": "string",
    "react_native.module.top.duration": "double",
    "react_native.module.top.name": "string",
    "react.version": "string",
    "redis.command": "string",
    "redis.key": "string",
    release: "string",
    "remix.action_form_data.<key>": "string",
    replayId: "string",
    replay_id: "string",
    "resource.deployment.environment": "string",
    "resource.deployment.environment.name": "string",
    "resource.render_blocking_status": "string",
    route: "string",
    "router.navigation.origin": "string",
    "router.navigation.route.id": "string",
    "router.navigation.type": "string",
    "rpc.grpc.status_code": "integer",
    "rpc.method": "string",
    "rpc.response.status_code": "string",
    "rpc.service": "string",
    "rpc.system": "string",
    "rpc.system.name": "string",
    "runtime.build": "string",
    "runtime.name": "string",
    "runtime.raw_description": "string",
    "runtime.version": "string",
    "score.<key>": "double",
    "score.ratio.<key>": "double",
    "score.total": "double",
    "score.weight.<key>": "double",
    "sentry.action": "string",
    "sentry.browser.name": "string",
    "sentry.browser.version": "string",
    "sentry.cancellation_reason": "string",
    "sentry.category": "string",
    "sentry.client_sample_rate": "double",
    "sentry.description": "string",
    "sentry.dist": "string",
    "sentry.domain": "string",
    "sentry.dsc.environment": "string",
    "sentry.dsc.project_id": "string",
    "sentry.dsc.public_key": "string",
    "sentry.dsc.release": "string",
    "sentry.dsc.sampled": "boolean",
    "sentry.dsc.sample_rate": "string",
    "sentry.dsc.trace_id": "string",
    "sentry.dsc.transaction": "string",
    "sentry.environment": "string",
    "sentry.event.serialized_breadcrumbs": "string",
    "sentry.event.serialized_contexts": "string",
    "sentry.event.serialized_extra": "string",
    "sentry.event.serialized_meta": "string",
    "sentry.exclusive_time": "double",
    "sentry.frames.frozen": "integer",
    "sentry.frames.slow": "integer",
    "sentry.frames.total": "integer",
    "sentry.graphql.operation": "string",
    "sentry.group": "string",
    "sentry.http.prefetch": "boolean",
    "sentry.idle_span_finish_reason": "string",
    "sentry.is_localhost": "boolean",
    "sentry.is_remote": "boolean",
    "sentry.kind": "string",
    "sentry.link.type": "string",
    "sentry.main_thread": "boolean",
    "sentry.message.parameter.<key>": "string",
    "sentry.message.template": "string",
    "sentry.metric.source": "string",
    "sentry.mobile": "boolean",
    "sentry.module.<key>": "string",
    "sentry.nextjs.ssr.function.route": "string",
    "sentry.nextjs.ssr.function.type": "string",
    "sentry.normalized_db_query": "string",
    "sentry.normalized_db_query.hash": "string",
    "sentry.normalized_description": "string",
    "sentry.observed_timestamp_nanos": "string",
    "sentry.op": "string",
    "sentry.origin": "string",
    "sentry.pageload.span_id": "string",
    "sentry.platform": "string",
    "sentry.profiler_id": "string",
    "sentry.profile_id": "string",
    "sentry.relay.ingress": "string",
    "sentry.relay.pipeline": "string",
    "sentry.release": "string",
    "sentry.replay_id": "string",
    "sentry.replay_is_buffering": "boolean",
    "sentry.report_event": "string",
    "sentry.sdk.integrations": "string[]",
    "sentry.sdk.name": "string",
    "sentry.sdk.version": "string",
    "sentry.segment.id": "string",
    "sentry.segment_id": "string",
    "sentry.segment.name": "string",
    "sentry.segment.name.source": "string",
    "sentry.server_sample_rate": "double",
    "sentry.source": "string",
    "sentry.span.source": "string",
    "sentry.status": "string",
    "sentry.status_code": "integer",
    "sentry.status.message": "string",
    "sentry.sveltekit.navigation.from": "string",
    "sentry.sveltekit.navigation.to": "string",
    "sentry.sveltekit.navigation.type": "string",
    "sentry.thread.id": "integer",
    "sentry.timestamp.sequence": "integer",
    "sentry.trace_lifecycle": "string",
    "sentry.trace.parent_span_id": "string",
    "sentry.trace.status": "string",
    "sentry.transaction": "string",
    "sentry.user.email": "string",
    "sentry.user.geo.city": "string",
    "sentry.user.geo.country_code": "string",
    "sentry.user.geo.region": "string",
    "sentry.user.geo.subdivision": "string",
    "sentry.user.id": "string",
    "sentry.user.ip": "string",
    "sentry.user.username": "string",
    "server.address": "string",
    server_name: "string",
    "server.port": "integer",
    "service.name": "string",
    "service.version": "string",
    "session.id": "string",
    stall_percentage: "double",
    stall_total_time: "double",
    "starlette.middleware_name": "string",
    "starlite.middleware_name": "string",
    "state.type": "string",
    "subprocess.pid": "integer",
    "sveltekit.load.environment": "string",
    "sveltekit.load.node_id": "string",
    "sveltekit.load.node_type": "string",
    "sveltekit.tracing.original_name": "string",
    "thread.id": "integer",
    "thread.name": "string",
    "timber.tag": "string",
    time_to_full_display: "double",
    time_to_initial_display: "double",
    transaction: "string",
    "trpc.procedure_path": "string",
    "trpc.procedure_type": "string",
    ttfb: "double",
    "ttfb.requestTime": "double",
    "turbo_modules.total_call_count": "integer",
    "turbo_modules.total_duration_ms": "double",
    "turbo_modules.total_error_count": "integer",
    "turbo_modules.unique_methods": "integer",
    "turbo_module.arch": "string",
    "turbo_module.method": "string",
    "turbo_module.name": "string",
    "turbo_module.top_module": "string",
    "turbo_module.top_module_duration_ms": "double",
    "turbo_module.total_call_count": "integer",
    "turbo_module.total_duration_ms": "double",
    "turbo_module.total_error_count": "integer",
    "turbo_module.unique_methods": "integer",
    type: "string",
    "ui.component_name": "string",
    "ui.contributes_to_ttfd": "boolean",
    "ui.contributes_to_ttid": "boolean",
    "ui.element.height": "integer",
    "ui.element.id": "string",
    "ui.element.identifier": "string",
    "ui.element.load_time": "double",
    "ui.element.paint_type": "string",
    "ui.element.render_time": "double",
    "ui.element.type": "string",
    "ui.element.url": "string",
    "ui.element.width": "integer",
    url: "string",
    "url.domain": "string",
    "url.fragment": "string",
    "url.full": "string",
    "url.path": "string",
    "url.path.parameter.<key>": "string",
    "url.path.params.<key>": "string",
    "url.port": "integer",
    "url.query": "string",
    "url.same_origin": "boolean",
    "url.scheme": "string",
    "url.template": "string",
    "user_agent.original": "string",
    "user.email": "string",
    "user.full_name": "string",
    "user.geo.city": "string",
    "user.geo.country_code": "string",
    "user.geo.region": "string",
    "user.geo.subdivision": "string",
    "user.hash": "string",
    "user.id": "string",
    "user.ip_address": "string",
    "user.name": "string",
    "user.roles": "string[]",
    "vercel.branch": "string",
    "vercel.build_id": "string",
    "vercel.deployment_id": "string",
    "vercel.destination": "string",
    "vercel.edge_type": "string",
    "vercel.entrypoint": "string",
    "vercel.execution_region": "string",
    "vercel.id": "string",
    "vercel.ja3_digest": "string",
    "vercel.ja4_digest": "string",
    "vercel.log_type": "string",
    "vercel.path": "string",
    "vercel.project_id": "string",
    "vercel.project_name": "string",
    "vercel.proxy.cache_id": "string",
    "vercel.proxy.client_ip": "string",
    "vercel.proxy.host": "string",
    "vercel.proxy.lambda_region": "string",
    "vercel.proxy.method": "string",
    "vercel.proxy.path": "string",
    "vercel.proxy.path_type": "string",
    "vercel.proxy.path_type_variant": "string",
    "vercel.proxy.referer": "string",
    "vercel.proxy.region": "string",
    "vercel.proxy.response_byte_size": "integer",
    "vercel.proxy.scheme": "string",
    "vercel.proxy.status_code": "integer",
    "vercel.proxy.timestamp": "integer",
    "vercel.proxy.user_agent": "string[]",
    "vercel.proxy.vercel_cache": "string",
    "vercel.proxy.vercel_id": "string",
    "vercel.proxy.waf_action": "string",
    "vercel.proxy.waf_rule_id": "string",
    "vercel.request_id": "string",
    "vercel.source": "string",
    "vercel.status_code": "integer"
}, $68aec2772563966a$var$ATTRIBUTE_METADATA = {
    address: {
        brief: "The destination hostname or IP address for a TCP connection.",
        type: "string",
        keys: [
            "server.address",
            "address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        examples: [
            "example.com"
        ],
        deprecation: {
            replacement: "server.address",
            reason: "Old namespace-less attribute, to be replaced with server.address for span-first future",
            status: "backfill"
        },
        aliases: [
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name",
            "net.peer.name"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    647
                ],
                description: "Added server_name as an alias"
            },
            {
                version: "0.21.0",
                prs: [
                    588,
                    602
                ],
                description: "Added net.peer.name as an alias"
            },
            {
                version: "0.19.0",
                prs: [
                    534
                ],
                description: "Added address attribute"
            }
        ]
    },
    "ai.citations": {
        brief: "References or sources cited by the AI model in its response.",
        type: "string[]",
        keys: [
            "ai.citations"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Citation 1",
            "Citation 2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.completion_tokens.used": {
        brief: "The number of tokens used to respond to the message.",
        type: "integer",
        keys: [
            "gen_ai.usage.output_tokens",
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens",
            status: "backfill"
        },
        aliases: [
            "gen_ai.usage.output_tokens",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.documents": {
        brief: "Documents or content chunks used as context for the AI model.",
        type: "string[]",
        keys: [
            "ai.documents"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "document1.txt",
            "document2.pdf"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.finish_reason": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        keys: [
            "gen_ai.response.finish_reasons",
            "ai.finish_reason",
            "gen_ai.response.finish_reason"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons",
            status: "backfill"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        keys: [
            "gen_ai.request.frequency_penalty",
            "ai.frequency_penalty"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.frequency_penalty",
            status: "backfill"
        },
        aliases: [
            "gen_ai.request.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.function_call": {
        brief: "For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls",
        type: "string",
        keys: [
            "gen_ai.tool.name",
            "ai.function_call",
            "mcp.tool.name"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "function_name",
        deprecation: {
            replacement: "gen_ai.tool.name",
            status: "backfill"
        },
        aliases: [
            "gen_ai.tool.name",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.generation_id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        keys: [
            "gen_ai.response.id",
            "ai.generation_id",
            "ai.response.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gen_123abc",
        deprecation: {
            replacement: "gen_ai.response.id",
            status: "backfill"
        },
        aliases: [
            "gen_ai.response.id",
            "ai.response.id"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.response.id as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.input_messages": {
        brief: "The input messages sent to the model",
        type: "string",
        keys: [
            "gen_ai.input.messages",
            "ai.input_messages",
            "ai.prompt",
            "ai.prompt.messages",
            "ai.texts",
            "gen_ai.prompt"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages",
            status: "backfill"
        },
        aliases: [
            "gen_ai.request.messages"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.is_search_required": {
        brief: "Boolean indicating if the model needs to perform a search.",
        type: "boolean",
        keys: [
            "ai.is_search_required"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.metadata": {
        brief: "Extra metadata passed to an AI pipeline step.",
        type: "string",
        keys: [
            "ai.metadata"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"user_id": 123, "session_id": "abc123"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.model.id": {
        brief: "The id of the model used by the Vercel AI SDK.",
        type: "string",
        keys: [
            "gen_ai.request.model",
            "ai.model.id",
            "ai.model_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4o",
        examples: [
            "gpt-4o"
        ],
        deprecation: {
            replacement: "gen_ai.request.model",
            reason: "This attribute is being deprecated in favor of gen_ai.request.model.",
            status: "backfill"
        },
        aliases: [
            "gen_ai.request.model",
            "ai.model_id"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.model.id attribute"
            }
        ]
    },
    "ai.model_id": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        keys: [
            "gen_ai.request.model",
            "ai.model.id",
            "ai.model_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4",
        deprecation: {
            replacement: "gen_ai.request.model",
            status: "backfill"
        },
        aliases: [
            "gen_ai.request.model",
            "ai.model.id"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.model.id as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.model.provider": {
        brief: "The provider of the model.",
        type: "string",
        keys: [
            "gen_ai.provider.name",
            "ai.model.provider",
            "gen_ai.system"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name",
            status: "backfill"
        },
        aliases: [
            "gen_ai.provider.name",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.pipeline.name": {
        brief: "The name of the AI pipeline.",
        type: "string",
        keys: [
            "gen_ai.pipeline.name",
            "ai.pipeline.name",
            "langchain.chain.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        deprecation: {
            replacement: "gen_ai.pipeline.name",
            status: "backfill"
        },
        aliases: [
            "gen_ai.pipeline.name",
            "langchain.chain.name"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    599
                ],
                description: "Added langchain.chain.name as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    53,
                    76,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.preamble": {
        brief: "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
        type: "string",
        keys: [
            "gen_ai.system_instructions",
            "ai.preamble",
            "gen_ai.system.message"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are now a clown.",
        deprecation: {
            replacement: "gen_ai.system_instructions",
            status: "backfill"
        },
        aliases: [
            "gen_ai.system_instructions"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        keys: [
            "gen_ai.request.presence_penalty",
            "ai.presence_penalty"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        deprecation: {
            replacement: "gen_ai.request.presence_penalty",
            status: "backfill"
        },
        aliases: [
            "gen_ai.request.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.prompt": {
        brief: "The prompt passed to the Vercel AI SDK, as a stringified object.",
        type: "string",
        keys: [
            "gen_ai.input.messages",
            "ai.input_messages",
            "ai.prompt",
            "ai.prompt.messages",
            "ai.texts",
            "gen_ai.prompt"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"prompt":"What is the weather in Paris?"}',
        examples: [
            '{"prompt":"What is the weather in Paris?"}'
        ],
        deprecation: {
            replacement: "gen_ai.input.messages",
            reason: "This attribute is being deprecated in favor of gen_ai.input.messages.",
            status: "backfill"
        },
        aliases: [
            "gen_ai.input.messages",
            "ai.texts",
            "ai.prompt.messages",
            "gen_ai.prompt"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.prompt attribute"
            }
        ]
    },
    "ai.prompt.messages": {
        brief: "The input messages sent to the AI model.",
        type: "string",
        keys: [
            "gen_ai.input.messages",
            "ai.input_messages",
            "ai.prompt",
            "ai.prompt.messages",
            "ai.texts",
            "gen_ai.prompt"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages",
            status: "backfill"
        },
        aliases: [
            "gen_ai.input.messages",
            "ai.texts",
            "gen_ai.prompt",
            "ai.prompt"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.prompt as an alias"
            },
            {
                version: "0.19.0",
                prs: [
                    498
                ],
                description: "Added ai.prompt.messages attribute"
            }
        ]
    },
    "ai.prompt_tokens.used": {
        brief: "The number of tokens used to process just the prompt.",
        type: "integer",
        keys: [
            "gen_ai.usage.input_tokens",
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens",
            status: "backfill"
        },
        aliases: [
            "gen_ai.usage.prompt_tokens",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.prompt.tools": {
        brief: "The tools made available to the model, as an array of stringified tool definitions.",
        type: "string[]",
        keys: [
            "gen_ai.tool.definitions",
            "ai.prompt.tools",
            "ai.tools",
            "gen_ai.request.available_tools"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            '{"type":"function","name":"get_weather"}'
        ],
        examples: [
            [
                '{"type":"function","name":"get_weather"}'
            ]
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions",
            reason: "This attribute is being deprecated in favor of gen_ai.tool.definitions.",
            status: "backfill"
        },
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.prompt.tools attribute"
            }
        ]
    },
    "ai.raw_prompting": {
        brief: "When enabled, the user\u2019s prompt will be sent to the model without any pre-processing.",
        type: "boolean",
        keys: [
            "ai.raw_prompting"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.responses": {
        brief: "The response messages sent back by the AI model.",
        type: "string[]",
        keys: [
            "gen_ai.output.messages",
            "ai.response.text",
            "ai.response.toolCalls",
            "ai.responses",
            "ai.tool_calls"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "hello",
            "world"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages",
            status: "backfill"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    65,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.response_format": {
        brief: "For an AI model call, the format of the response",
        type: "string",
        keys: [
            "ai.response_format"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "json_object",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.response.id": {
        brief: "The id of the response returned by the model.",
        type: "string",
        keys: [
            "gen_ai.response.id",
            "ai.generation_id",
            "ai.response.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "chatcmpl-BuKJgVSKAMTUYbBSjHTMUuNGKzOPY",
        examples: [
            "chatcmpl-BuKJgVSKAMTUYbBSjHTMUuNGKzOPY"
        ],
        deprecation: {
            replacement: "gen_ai.response.id",
            reason: "This attribute is being deprecated in favor of gen_ai.response.id.",
            status: "backfill"
        },
        aliases: [
            "gen_ai.response.id",
            "ai.generation_id"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.response.id attribute"
            }
        ]
    },
    "ai.response.model": {
        brief: "The id of the model that produced the response.",
        type: "string",
        keys: [
            "gen_ai.response.model",
            "ai.response.model"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gpt-4o-2024-08-06",
        examples: [
            "gpt-4o-2024-08-06"
        ],
        deprecation: {
            replacement: "gen_ai.response.model",
            reason: "This attribute is being deprecated in favor of gen_ai.response.model.",
            status: "backfill"
        },
        aliases: [
            "gen_ai.response.model"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.response.model attribute"
            }
        ]
    },
    "ai.response.object": {
        brief: "The type of the object returned by the model.",
        type: "string",
        keys: [
            "ai.response.object"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "chat.completion",
        examples: [
            "chat.completion"
        ],
        deprecation: {
            reason: "This attribute is deprecated. The Sentry conventions have no replacement for the raw Vercel AI response object type."
        },
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.response.object attribute"
            }
        ]
    },
    "ai.response.text": {
        brief: "The text response from the AI model.",
        type: "string",
        keys: [
            "gen_ai.output.messages",
            "ai.response.text",
            "ai.response.toolCalls",
            "ai.responses",
            "ai.tool_calls"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "The weather in Paris is currently rainy.",
        deprecation: {
            replacement: "gen_ai.output.messages",
            status: "backfill"
        },
        aliases: [
            "gen_ai.output.messages",
            "ai.response.toolCalls"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    498
                ],
                description: "Added ai.response.text attribute"
            }
        ]
    },
    "ai.response.timestamp": {
        brief: "The ISO 8601 timestamp at which the response was produced.",
        type: "string",
        keys: [
            "ai.response.timestamp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2026-02-19T15:32:11.000Z",
        examples: [
            "2026-02-19T15:32:11.000Z"
        ],
        deprecation: {
            reason: "This attribute is deprecated. The span start and end timestamps carry the same information."
        },
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.response.timestamp attribute"
            }
        ]
    },
    "ai.response.toolCalls": {
        brief: "The tool calls in the AI model response.",
        type: "string",
        keys: [
            "gen_ai.output.messages",
            "ai.response.text",
            "ai.response.toolCalls",
            "ai.responses",
            "ai.tool_calls"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages",
            status: "backfill"
        },
        aliases: [
            "gen_ai.output.messages",
            "ai.response.text"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    498
                ],
                description: "Added ai.response.toolCalls attribute"
            }
        ]
    },
    "ai.schema": {
        brief: "The stringified JSON schema the model output must conform to.",
        type: "string",
        keys: [
            "ai.schema"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"type":"object","properties":{"city":{"type":"string"}}}',
        examples: [
            '{"type":"object","properties":{"city":{"type":"string"}}}'
        ],
        deprecation: {
            reason: "This attribute is deprecated. The Sentry conventions have no replacement for the requested output schema."
        },
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.schema attribute"
            }
        ]
    },
    "ai.search_queries": {
        brief: "Queries used to search for relevant context or documents.",
        type: "string[]",
        keys: [
            "ai.search_queries"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "climate change effects",
            "renewable energy"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.search_results": {
        brief: "Results returned from search queries for context.",
        type: "string[]",
        keys: [
            "ai.search_results"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "search_result_1, search_result_2"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        keys: [
            "gen_ai.request.seed",
            "ai.seed"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "gen_ai.request.seed",
            status: "backfill"
        },
        aliases: [
            "gen_ai.request.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108,
                    127
                ]
            }
        ]
    },
    "ai.streaming": {
        brief: "Whether the request was streamed back.",
        type: "boolean",
        keys: [
            "gen_ai.response.streaming",
            "ai.streaming"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "gen_ai.response.streaming",
            status: "backfill"
        },
        aliases: [
            "gen_ai.response.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.tags": {
        brief: "Tags that describe an AI pipeline step.",
        type: "string",
        keys: [
            "ai.tags"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"executed_function": "add_integers"}',
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    127
                ]
            }
        ]
    },
    "ai.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        keys: [
            "gen_ai.request.temperature",
            "ai.temperature"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .1,
        deprecation: {
            replacement: "gen_ai.request.temperature",
            status: "backfill"
        },
        aliases: [
            "gen_ai.request.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.texts": {
        brief: "Raw text inputs provided to the model.",
        type: "string[]",
        keys: [
            "gen_ai.input.messages",
            "ai.input_messages",
            "ai.prompt",
            "ai.prompt.messages",
            "ai.texts",
            "gen_ai.prompt"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Hello, how are you?",
            "What is the capital of France?"
        ],
        deprecation: {
            replacement: "gen_ai.input.messages",
            status: "backfill"
        },
        aliases: [
            "gen_ai.input.messages",
            "ai.prompt.messages",
            "gen_ai.prompt",
            "ai.prompt"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.prompt as an alias"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "ai.toolCall.args": {
        brief: "The arguments of the tool call.",
        type: "string",
        keys: [
            "gen_ai.tool.call.arguments",
            "ai.toolCall.args",
            "gen_ai.tool.input"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments",
            status: "backfill"
        },
        aliases: [
            "gen_ai.tool.call.arguments",
            "gen_ai.tool.input"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    498
                ],
                description: "Added ai.toolCall.args attribute"
            }
        ]
    },
    "ai.toolCall.result": {
        brief: "The result of the tool call.",
        type: "string",
        keys: [
            "gen_ai.tool.call.result",
            "ai.toolCall.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            status: "backfill"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    498
                ],
                description: "Added ai.toolCall.result attribute"
            }
        ]
    },
    "ai.tools": {
        brief: "For an AI model call, the functions that are available",
        type: "string[]",
        keys: [
            "gen_ai.tool.definitions",
            "ai.prompt.tools",
            "ai.tools",
            "gen_ai.request.available_tools"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "function_1",
            "function_2"
        ],
        deprecation: {
            replacement: "gen_ai.tool.definitions",
            status: "backfill"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65,
                    127
                ]
            }
        ]
    },
    "ai.tool_calls": {
        brief: "For an AI model call, the tool calls that were made.",
        type: "string[]",
        keys: [
            "gen_ai.output.messages",
            "ai.response.text",
            "ai.response.toolCalls",
            "ai.responses",
            "ai.tool_calls"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "tool_call_1",
            "tool_call_2"
        ],
        deprecation: {
            replacement: "gen_ai.output.messages",
            status: "backfill"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    55,
                    65
                ]
            }
        ]
    },
    "ai.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        keys: [
            "gen_ai.request.top_k",
            "ai.top_k"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 35,
        deprecation: {
            replacement: "gen_ai.request.top_k",
            status: "backfill"
        },
        aliases: [
            "gen_ai.request.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        keys: [
            "gen_ai.request.top_p",
            "ai.top_p"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .7,
        deprecation: {
            replacement: "gen_ai.request.top_p",
            status: "backfill"
        },
        aliases: [
            "gen_ai.request.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55,
                    57,
                    61,
                    108
                ]
            }
        ]
    },
    "ai.total_cost": {
        brief: "The total cost for the tokens used.",
        type: "double",
        keys: [
            "gen_ai.cost.total_tokens",
            "ai.total_cost"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        deprecation: {
            replacement: "gen_ai.cost.total_tokens",
            status: "backfill"
        },
        aliases: [
            "gen_ai.cost.total_tokens"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    53
                ]
            }
        ],
        searchAlias: {
            name: "ai.total_cost",
            type: "currency"
        }
    },
    "ai.total_tokens.used": {
        brief: "The total number of tokens used to process the prompt.",
        type: "integer",
        keys: [
            "gen_ai.usage.total_tokens",
            "ai.total_tokens.used",
            "ai.usage.tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 30,
        deprecation: {
            replacement: "gen_ai.usage.total_tokens",
            status: "backfill"
        },
        aliases: [
            "gen_ai.usage.total_tokens",
            "ai.usage.tokens"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.usage.tokens as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ai.usage.tokens": {
        brief: "The total number of tokens used for the request and the response.",
        type: "integer",
        keys: [
            "gen_ai.usage.total_tokens",
            "ai.total_tokens.used",
            "ai.usage.tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 150,
        examples: [
            150
        ],
        deprecation: {
            replacement: "gen_ai.usage.total_tokens",
            reason: "This attribute is being deprecated in favor of gen_ai.usage.total_tokens.",
            status: "backfill"
        },
        aliases: [
            "gen_ai.usage.total_tokens",
            "ai.total_tokens.used"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.usage.tokens attribute"
            }
        ]
    },
    "ai.values": {
        brief: "The stringified values produced by a Vercel AI SDK object or array generation.",
        type: "string",
        keys: [
            "ai.values"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"city":"Paris"}]',
        examples: [
            '[{"city":"Paris"}]'
        ],
        deprecation: {
            reason: "This attribute is deprecated. Use gen_ai.output.messages for model output instead."
        },
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.values attribute"
            }
        ]
    },
    "ai.warnings": {
        brief: "Warning messages generated during model execution.",
        type: "string[]",
        keys: [
            "ai.warnings"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Token limit exceeded"
        ],
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    55
                ]
            }
        ]
    },
    "angular.version": {
        brief: "The version of the Angular framework",
        type: "string",
        keys: [
            "angular.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "17.1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    367
                ],
                description: "Added angular.version attribute"
            }
        ]
    },
    "app.app_build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        keys: [
            "app.build",
            "app.app_build"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "app.build",
            reason: "Deprecated in favor of app.build",
            status: "backfill"
        },
        aliases: [
            "app.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_build in favor of app.build"
            }
        ]
    },
    "app.app_identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        keys: [
            "app.identifier",
            "app.app_identifier"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        deprecation: {
            replacement: "app.identifier",
            reason: "Deprecated in favor of app.identifier",
            status: "backfill"
        },
        aliases: [
            "app.identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_identifier in favor of app.identifier"
            }
        ]
    },
    "app.app_name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        keys: [
            "app.name",
            "app.app_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        deprecation: {
            replacement: "app.name",
            reason: "Deprecated in favor of app.name",
            status: "backfill"
        },
        aliases: [
            "app.name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_name in favor of app.name"
            }
        ]
    },
    "app.app_start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        keys: [
            "app.start_time",
            "app.app_start_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        deprecation: {
            replacement: "app.start_time",
            reason: "Deprecated in favor of app.start_time",
            status: "backfill"
        },
        aliases: [
            "app.start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_start_time in favor of app.start_time"
            }
        ]
    },
    "app.app_version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        keys: [
            "app.version",
            "app.app_version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        deprecation: {
            replacement: "app.version",
            reason: "Deprecated in favor of app.version",
            status: "backfill"
        },
        aliases: [
            "app.version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added and deprecated app.app_version in favor of app.version"
            }
        ]
    },
    "app.build": {
        brief: "Internal build identifier, as it appears on the platform.",
        type: "string",
        keys: [
            "app.build",
            "app.app_build"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        aliases: [
            "app.app_build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.build attribute"
            }
        ]
    },
    "app.identifier": {
        brief: "Version-independent application identifier, often a dotted bundle ID.",
        type: "string",
        keys: [
            "app.identifier",
            "app.app_identifier"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "com.example.myapp",
        aliases: [
            "app.app_identifier"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.identifier attribute"
            }
        ]
    },
    "app.in_foreground": {
        brief: "Whether the application is currently in the foreground.",
        type: "boolean",
        keys: [
            "app.in_foreground"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.in_foreground attribute"
            }
        ]
    },
    "app.name": {
        brief: "Human readable application name, as it appears on the platform.",
        type: "string",
        keys: [
            "app.name",
            "app.app_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "My App",
        aliases: [
            "app.app_name"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.name attribute"
            }
        ]
    },
    app_start_cold: {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        keys: [
            "app.vitals.start.cold.value",
            "app_start_cold"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.cold.value",
            reason: "Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.start.cold.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.cold.value"
            }
        ]
    },
    "app.start_time": {
        brief: "Formatted UTC timestamp when the user started the application.",
        type: "string",
        keys: [
            "app.start_time",
            "app.app_start_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2025-01-01T00:00:00.000Z",
        aliases: [
            "app.app_start_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.start_time attribute"
            }
        ]
    },
    app_start_type: {
        brief: "Mobile app start variant. Either cold or warm.",
        type: "string",
        keys: [
            "app.vitals.start.type",
            "app_start_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        deprecation: {
            replacement: "app.vitals.start.type",
            reason: "Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.start.type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.start.type"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    app_start_warm: {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        keys: [
            "app.vitals.start.warm.value",
            "app_start_warm"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.start.warm.value",
            reason: "Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.start.warm.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    323
                ],
                description: "Added and deprecated in favor of app.vitals.start.warm.value"
            }
        ]
    },
    "app.version": {
        brief: "Human readable application version, as it appears on the platform.",
        type: "string",
        keys: [
            "app.version",
            "app.app_version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        aliases: [
            "app.app_version"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    296
                ],
                description: "Added app.version attribute"
            }
        ]
    },
    "app.vitals.frames.delay.value": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        keys: [
            "app.vitals.frames.delay.value",
            "frames.delay",
            "mobile.frames_delay"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        aliases: [
            "frames.delay"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.delay.value to replace frames.delay"
            }
        ]
    },
    "app.vitals.frames.frozen.count": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        keys: [
            "app.vitals.frames.frozen.count",
            "frames.frozen",
            "mobile.frozen_frames",
            "sentry.frames.frozen"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        aliases: [
            "frames.frozen",
            "sentry.frames.frozen"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    500
                ],
                description: "Added sentry.frames.frozen as an alias"
            },
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.frozen.count to replace frames.frozen"
            }
        ]
    },
    "app.vitals.frames.frozen.rate": {
        brief: "The fraction of rendered frames that were frozen, calculated as `app.vitals.frames.frozen.count` divided by `app.vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        keys: [
            "app.vitals.frames.frozen.rate",
            "frames_frozen_rate"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        aliases: [
            "frames_frozen_rate"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    493
                ],
                description: "Added app.vitals.frames.frozen.rate attribute"
            }
        ]
    },
    "app.vitals.frames.slow.count": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        keys: [
            "app.vitals.frames.slow.count",
            "frames.slow",
            "mobile.slow_frames",
            "sentry.frames.slow"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        aliases: [
            "frames.slow",
            "sentry.frames.slow"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    500
                ],
                description: "Added sentry.frames.slow as an alias"
            },
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.slow.count to replace frames.slow"
            }
        ]
    },
    "app.vitals.frames.slow.rate": {
        brief: "The fraction of rendered frames that were slow, calculated as `app.vitals.frames.slow.count` divided by `app.vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        keys: [
            "app.vitals.frames.slow.rate",
            "frames_slow_rate"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .25,
        aliases: [
            "frames_slow_rate"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    493
                ],
                description: "Added app.vitals.frames.slow.rate attribute"
            }
        ]
    },
    "app.vitals.frames.total.count": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        keys: [
            "app.vitals.frames.total.count",
            "frames.total",
            "mobile.total_frames",
            "sentry.frames.total"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        aliases: [
            "frames.total",
            "sentry.frames.total"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    500
                ],
                description: "Added sentry.frames.total as an alias"
            },
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.frames.total.count to replace frames.total"
            }
        ]
    },
    "app.vitals.stall.duration": {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        keys: [
            "app.vitals.stall.duration",
            "stall_total_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 4e3,
        aliases: [
            "stall_total_time"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    493
                ],
                description: "Added app.vitals.stall.duration attribute"
            }
        ]
    },
    "app.vitals.stall.percentage": {
        brief: "The fraction of transaction duration during which the app was stalled, between 0.0 and 1.0. For example, 0.8 represents 80%. Only applies to React Native. This is computed by Relay.",
        type: "double",
        keys: [
            "app.vitals.stall.percentage",
            "stall_percentage"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .8,
        aliases: [
            "stall_percentage"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    493
                ],
                description: "Added app.vitals.stall.percentage attribute"
            }
        ]
    },
    "app.vitals.start.cold.value": {
        brief: "The duration of a cold app start in milliseconds",
        type: "double",
        keys: [
            "app.vitals.start.cold.value",
            "app_start_cold"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_cold"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.cold.value attribute"
            }
        ]
    },
    "app.vitals.start.prewarmed": {
        brief: "Whether the app start was prewarmed.",
        type: "boolean",
        keys: [
            "app.vitals.start.prewarmed"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    379
                ],
                description: "Added app.vitals.start.prewarmed attribute"
            }
        ]
    },
    "app.vitals.start.reason": {
        brief: "The reason that triggered the app start.",
        type: "string",
        keys: [
            "app.vitals.start.reason"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "push",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.reason attribute"
            }
        ]
    },
    "app.vitals.start.screen": {
        brief: "The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.",
        type: "string",
        keys: [
            "app.vitals.start.screen"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MainActivity",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    353
                ],
                description: "Added app.vitals.start.screen attribute"
            }
        ]
    },
    "app.vitals.start.type": {
        brief: "The type of app start, for example `cold` or `warm`",
        type: "string",
        keys: [
            "app.vitals.start.type",
            "app_start_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cold",
        aliases: [
            "app_start_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.type attribute"
            }
        ]
    },
    "app.vitals.start.warm.value": {
        brief: "The duration of a warm app start in milliseconds",
        type: "double",
        keys: [
            "app.vitals.start.warm.value",
            "app_start_warm"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "app_start_warm"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.start.warm.value attribute"
            }
        ]
    },
    "app.vitals.ttfd.value": {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        keys: [
            "app.vitals.ttfd.value",
            "time_to_full_display"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_full_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttfd.value attribute"
            }
        ]
    },
    "app.vitals.ttid.value": {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        keys: [
            "app.vitals.ttid.value",
            "time_to_initial_display"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        aliases: [
            "time_to_initial_display"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added app.vitals.ttid.value attribute"
            }
        ]
    },
    "art.gc.blocking_count": {
        brief: "Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime",
        type: "integer",
        keys: [
            "art.gc.blocking_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_count attribute"
            }
        ]
    },
    "art.gc.blocking_time": {
        brief: "Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds",
        type: "double",
        keys: [
            "art.gc.blocking_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.873,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.blocking_time attribute"
            }
        ]
    },
    "art.gc.pre_oome_count": {
        brief: "Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime",
        type: "integer",
        keys: [
            "art.gc.pre_oome_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.pre_oome_count attribute"
            }
        ]
    },
    "art.gc.total_count": {
        brief: "Total number of garbage collections performed by the Android Runtime",
        type: "integer",
        keys: [
            "art.gc.total_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_count attribute"
            }
        ]
    },
    "art.gc.total_time": {
        brief: "Total time spent in garbage collection by the Android Runtime, in milliseconds",
        type: "double",
        keys: [
            "art.gc.total_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 11.807,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.total_time attribute"
            }
        ]
    },
    "art.gc.waiting_time": {
        brief: "Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds",
        type: "double",
        keys: [
            "art.gc.waiting_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8.054,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.gc.waiting_time attribute"
            }
        ]
    },
    "art.memory.free": {
        brief: "Free memory available to the process as reported by the Android Runtime, in bytes",
        type: "integer",
        keys: [
            "art.memory.free"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free attribute"
            }
        ]
    },
    "art.memory.free_until_gc": {
        brief: "Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes",
        type: "integer",
        keys: [
            "art.memory.free_until_gc"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3181568,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_gc attribute"
            }
        ]
    },
    "art.memory.free_until_oome": {
        brief: "Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes",
        type: "integer",
        keys: [
            "art.memory.free_until_oome"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 196083712,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.free_until_oome attribute"
            }
        ]
    },
    "art.memory.max": {
        brief: "Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes",
        type: "integer",
        keys: [
            "art.memory.max"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 201326592,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.max attribute"
            }
        ]
    },
    "art.memory.total": {
        brief: "Total memory currently allocated to the process by the Android Runtime, in bytes",
        type: "integer",
        keys: [
            "art.memory.total"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7774208,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    382
                ],
                description: "Added art.memory.total attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_group": {
        brief: "The name of the CloudWatch Logs log group",
        type: "string",
        keys: [
            "aws.cloudwatch.logs.log_group"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/aws/lambda/my-function",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_group attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.log_stream": {
        brief: "The name of the CloudWatch Logs log stream",
        type: "string",
        keys: [
            "aws.cloudwatch.logs.log_stream"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024/01/01/[$LATEST]abcdef1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.log_stream attribute"
            }
        ]
    },
    "aws.cloudwatch.logs.url": {
        brief: "The URL to the CloudWatch Logs log group",
        type: "string",
        keys: [
            "aws.cloudwatch.logs.url"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.cloudwatch.logs.url attribute"
            }
        ]
    },
    "aws.dynamodb.attribute_definitions": {
        brief: "The JSON-serialized value of each item in the `AttributeDefinitions` request field.",
        type: "string[]",
        keys: [
            "aws.dynamodb.attribute_definitions"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "AttributeName": "string", "AttributeType": "string" }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.attribute_definitions attribute"
            }
        ]
    },
    "aws.dynamodb.consistent_read": {
        brief: "The value of the `ConsistentRead` request parameter.",
        type: "boolean",
        keys: [
            "aws.dynamodb.consistent_read"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consistent_read attribute"
            }
        ]
    },
    "aws.dynamodb.consumed_capacity": {
        brief: "The JSON-serialized value of each item in the `ConsumedCapacity` response field.",
        type: "string[]",
        keys: [
            "aws.dynamodb.consumed_capacity"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.consumed_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.count": {
        brief: "The value of the `Count` response parameter.",
        type: "integer",
        keys: [
            "aws.dynamodb.count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.count attribute"
            }
        ]
    },
    "aws.dynamodb.exclusive_start_table": {
        brief: "The value of the `ExclusiveStartTableName` request parameter.",
        type: "string",
        keys: [
            "aws.dynamodb.exclusive_start_table"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Users",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.exclusive_start_table attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.",
        type: "string[]",
        keys: [
            "aws.dynamodb.global_secondary_indexes"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.global_secondary_index_updates": {
        brief: "The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.",
        type: "string[]",
        keys: [
            "aws.dynamodb.global_secondary_index_updates"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.global_secondary_index_updates attribute"
            }
        ]
    },
    "aws.dynamodb.index_name": {
        brief: "The value of the `IndexName` request parameter.",
        type: "string",
        keys: [
            "aws.dynamodb.index_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "name_to_group",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.index_name attribute"
            }
        ]
    },
    "aws.dynamodb.item_collection_metrics": {
        brief: "The JSON-serialized value of the `ItemCollectionMetrics` response field.",
        type: "string",
        keys: [
            "aws.dynamodb.item_collection_metrics"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.item_collection_metrics attribute"
            }
        ]
    },
    "aws.dynamodb.limit": {
        brief: "The value of the `Limit` request parameter.",
        type: "integer",
        keys: [
            "aws.dynamodb.limit"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.limit attribute"
            }
        ]
    },
    "aws.dynamodb.local_secondary_indexes": {
        brief: "The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.",
        type: "string[]",
        keys: [
            "aws.dynamodb.local_secondary_indexes"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }'
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.local_secondary_indexes attribute"
            }
        ]
    },
    "aws.dynamodb.projection": {
        brief: "The value of the `ProjectionExpression` request parameter.",
        type: "string",
        keys: [
            "aws.dynamodb.projection"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Title, Price, Color",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.projection attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_read_capacity": {
        brief: "The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.",
        type: "double",
        keys: [
            "aws.dynamodb.provisioned_read_capacity"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_read_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.provisioned_write_capacity": {
        brief: "The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.",
        type: "double",
        keys: [
            "aws.dynamodb.provisioned_write_capacity"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.provisioned_write_capacity attribute"
            }
        ]
    },
    "aws.dynamodb.scanned_count": {
        brief: "The value of the `ScannedCount` response parameter.",
        type: "integer",
        keys: [
            "aws.dynamodb.scanned_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scanned_count attribute"
            }
        ]
    },
    "aws.dynamodb.scan_forward": {
        brief: "The value of the `ScanIndexForward` request parameter.",
        type: "boolean",
        keys: [
            "aws.dynamodb.scan_forward"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.scan_forward attribute"
            }
        ]
    },
    "aws.dynamodb.segment": {
        brief: "The value of the `Segment` request parameter.",
        type: "integer",
        keys: [
            "aws.dynamodb.segment"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.segment attribute"
            }
        ]
    },
    "aws.dynamodb.select": {
        brief: "The value of the `Select` request parameter.",
        type: "string",
        keys: [
            "aws.dynamodb.select"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ALL_ATTRIBUTES",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.select attribute"
            }
        ]
    },
    "aws.dynamodb.table_count": {
        brief: "The number of items in the `TableNames` response parameter.",
        type: "integer",
        keys: [
            "aws.dynamodb.table_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_count attribute"
            }
        ]
    },
    "aws.dynamodb.table_names": {
        brief: "The keys in the `RequestItems` object field.",
        type: "string[]",
        keys: [
            "aws.dynamodb.table_names"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "Users",
            "Cats"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.table_names attribute"
            }
        ]
    },
    "aws.dynamodb.total_segments": {
        brief: "The value of the `TotalSegments` request parameter.",
        type: "integer",
        keys: [
            "aws.dynamodb.total_segments"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    479
                ],
                description: "Added aws.dynamodb.total_segments attribute"
            }
        ]
    },
    "aws.extended_request_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        keys: [
            "aws.extended_request_id",
            "aws.request.extended_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        aliases: [
            "aws.request.extended_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.extended_request_id attribute"
            }
        ]
    },
    "aws.kinesis.stream_name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        keys: [
            "aws.kinesis.stream_name",
            "aws.kinesis.stream.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "some-stream-name",
        aliases: [
            "aws.kinesis.stream.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream_name attribute"
            }
        ]
    },
    "aws.kinesis.stream.name": {
        brief: "The name of the AWS Kinesis stream the request refers to.",
        type: "string",
        keys: [
            "aws.kinesis.stream_name",
            "aws.kinesis.stream.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "some-stream-name",
        deprecation: {
            replacement: "aws.kinesis.stream_name",
            reason: "This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement.",
            status: "backfill"
        },
        aliases: [
            "aws.kinesis.stream_name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name"
            }
        ]
    },
    "aws.lambda.aws_request_id": {
        brief: "The AWS request ID as received by the Lambda function runtime",
        type: "string",
        keys: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8476a536-e9f4-11e8-9739-2dfe598c3fcd",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id",
            status: "backfill"
        },
        aliases: [
            "faas.invocation_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.aws_request_id attribute"
            }
        ]
    },
    "aws.lambda.execution_duration_in_millis": {
        brief: "The execution duration of the Lambda function invocation in milliseconds",
        type: "double",
        keys: [
            "aws.lambda.execution_duration_in_millis"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.execution_duration_in_millis attribute"
            }
        ]
    },
    "aws.lambda.function_name": {
        brief: "The name of the Lambda function",
        type: "string",
        keys: [
            "faas.name",
            "aws.lambda.function_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-function",
        deprecation: {
            replacement: "faas.name",
            reason: "Use the OTel-aligned faas.name attribute instead",
            status: "backfill"
        },
        aliases: [
            "faas.name"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.function_name in favor of faas.name"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_name attribute"
            }
        ]
    },
    "aws.lambda.function_version": {
        brief: "The version of the Lambda function",
        type: "string",
        keys: [
            "faas.version",
            "aws.lambda.function_version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "$LATEST",
        deprecation: {
            replacement: "faas.version",
            reason: "Use the OTel-aligned faas.version attribute instead",
            status: "backfill"
        },
        aliases: [
            "faas.version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ],
                description: "Deprecated aws.lambda.function_version in favor of faas.version"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.function_version attribute"
            }
        ]
    },
    "aws.lambda.invoked_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        keys: [
            "aws.lambda.invoked_arn",
            "aws.lambda.invoked_function_arn"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        aliases: [
            "aws.lambda.invoked_function_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.lambda.invoked_function_arn": {
        brief: "The full ARN of the Lambda function that was invoked",
        type: "string",
        keys: [
            "aws.lambda.invoked_arn",
            "aws.lambda.invoked_function_arn"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:us-east-1:123456789012:function:my-function",
        deprecation: {
            replacement: "aws.lambda.invoked_arn",
            reason: "This attribute is being deprecated in favor of aws.lambda.invoked_arn",
            status: "backfill"
        },
        aliases: [
            "aws.lambda.invoked_arn"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ],
                description: "Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn"
            },
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.invoked_function_arn attribute"
            }
        ]
    },
    "aws.lambda.remaining_time_in_millis": {
        brief: "The remaining time in milliseconds before the Lambda function times out",
        type: "double",
        keys: [
            "aws.lambda.remaining_time_in_millis"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    369
                ],
                description: "Added aws.lambda.remaining_time_in_millis attribute"
            }
        ]
    },
    "aws.log.group.names": {
        brief: "The name(s) of the AWS log group(s) an application is writing to.",
        type: "string[]",
        keys: [
            "aws.log.group.names"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "/aws/lambda/my-function",
            "opentelemetry-service"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.log.stream.names": {
        brief: "The name(s) of the AWS log stream(s) an application is writing to.",
        type: "string[]",
        keys: [
            "aws.log.stream.names"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ]
    },
    "aws.operation_name": {
        brief: "The name of the API operation invoked on an AWS service.",
        type: "string",
        keys: [
            "rpc.method",
            "aws.operation_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "PutObject",
        examples: [
            "PutObject"
        ],
        deprecation: {
            replacement: "rpc.method",
            reason: "This attribute is being deprecated in favor of rpc.method, which is the framework-agnostic replacement.",
            status: "backfill"
        },
        aliases: [
            "rpc.method"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    536
                ],
                description: "Added aws.operation_name attribute"
            }
        ]
    },
    aws_region: {
        brief: "The geographical region the AWS resource is running",
        type: "string",
        keys: [
            "cloud.region",
            "aws_region",
            "gcp_region"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "us-east-1",
        examples: [
            "us-east-1"
        ],
        deprecation: {
            replacement: "cloud.region",
            status: "backfill"
        },
        aliases: [
            "cloud.region",
            "gcp_region"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    537
                ],
                description: "Added aws_region attribute"
            }
        ]
    },
    "aws.request.extended_id": {
        brief: "The AWS extended request ID as returned in the response headers.",
        type: "string",
        keys: [
            "aws.extended_request_id",
            "aws.request.extended_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=",
        deprecation: {
            replacement: "aws.extended_request_id",
            reason: "This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement.",
            status: "backfill"
        },
        aliases: [
            "aws.extended_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id"
            }
        ]
    },
    "aws.request_id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        keys: [
            "aws.request_id",
            "aws.request.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        aliases: [
            "aws.request.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request_id attribute"
            }
        ]
    },
    "aws.request.id": {
        brief: "The AWS request ID as returned in the response headers.",
        type: "string",
        keys: [
            "aws.request_id",
            "aws.request.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "79b9da39-b7ae-508a-a6bc-864b2829c622",
        deprecation: {
            replacement: "aws.request_id",
            reason: "This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement.",
            status: "backfill"
        },
        aliases: [
            "aws.request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.request.id attribute, deprecated in favor of aws.request_id"
            }
        ]
    },
    "aws.request.url": {
        brief: "The URL of the AWS API request.",
        type: "string",
        keys: [
            "url.full",
            "aws.request.url",
            "http.url",
            "messaging.url",
            "url"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://sqs.us-east-1.amazonaws.com/123456789/my-queue",
        deprecation: {
            replacement: "url.full",
            reason: "This attribute is being deprecated in favor of url.full, which is the OTel-aligned replacement.",
            status: "backfill"
        },
        aliases: [
            "url.full",
            "http.url",
            "url",
            "messaging.url"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.url as an alias"
            },
            {
                version: "0.19.0",
                prs: [
                    488
                ],
                description: "Added aws.request.url attribute, deprecated in favor of url.full"
            }
        ]
    },
    "aws.s3.bucket": {
        brief: "The S3 bucket name the request refers to.",
        type: "string",
        keys: [
            "aws.s3.bucket"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ot-demo-test",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.s3.bucket attribute"
            }
        ]
    },
    "aws.secretsmanager.secret.arn": {
        brief: "The ARN of the Secret stored in Secrets Manager.",
        type: "string",
        keys: [
            "aws.secretsmanager.secret.arn"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.secretsmanager.secret.arn attribute"
            }
        ]
    },
    "aws.sns.topic.arn": {
        brief: "The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.",
        type: "string",
        keys: [
            "aws.sns.topic.arn"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.sns.topic.arn attribute"
            }
        ]
    },
    "aws.step_functions.activity.arn": {
        brief: "The ARN of the AWS Step Functions Activity.",
        type: "string",
        keys: [
            "aws.step_functions.activity.arn"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:activity:get-greeting",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.activity.arn attribute"
            }
        ]
    },
    "aws.step_functions.state_machine.arn": {
        brief: "The ARN of the AWS Step Functions State Machine.",
        type: "string",
        keys: [
            "aws.step_functions.state_machine.arn"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    480
                ],
                description: "Added aws.step_functions.state_machine.arn attribute"
            }
        ]
    },
    blocked_main_thread: {
        brief: "Whether the main thread was blocked by the span.",
        type: "boolean",
        keys: [
            "blocked_main_thread"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.bfcache.frame": {
        brief: "Which frame in the page's frame tree a back/forward cache not-restored reason originated from: the top document or a child frame.",
        type: "string",
        keys: [
            "browser.bfcache.frame"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "top",
        examples: [
            "top",
            "child"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    513
                ],
                description: "Added browser.bfcache.frame attribute"
            }
        ]
    },
    "browser.bfcache.not_restored_reason_count": {
        brief: "The number of reported reasons a page was not restored from the back/forward cache on a back/forward navigation. 0 when the browser reported no reasons (e.g. non-Chromium browsers).",
        type: "integer",
        keys: [
            "browser.bfcache.not_restored_reason_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        examples: [
            2
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    513
                ],
                description: "Added browser.bfcache.not_restored_reason_count attribute"
            }
        ]
    },
    "browser.bfcache.outcome": {
        brief: "Whether a back/forward navigation was restored from the browser's back/forward cache (bfcache). 'hit' means the page was restored; 'miss' means it was reloaded.",
        type: "string",
        keys: [
            "browser.bfcache.outcome"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "hit",
        examples: [
            "hit",
            "miss"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    513
                ],
                description: "Added browser.bfcache.outcome attribute"
            }
        ]
    },
    "browser.bfcache.reason": {
        brief: "A browser-reported reason a page was not restored from the back/forward cache on a back/forward navigation, taken from the notRestoredReasons API. Reported per reason (a single miss can have several). Currently Chromium-only.",
        type: "string",
        keys: [
            "browser.bfcache.reason"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "unload-listener",
        examples: [
            "unload-listener",
            "websocket",
            "idbversionchangeevent",
            "response-cache-control-no-store"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    513
                ],
                description: "Added browser.bfcache.reason attribute"
            }
        ]
    },
    "browser.name": {
        brief: "The name of the browser.",
        type: "string",
        keys: [
            "browser.name",
            "sentry.browser.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        aliases: [
            "sentry.browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127,
                    139
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.navigation.id": {
        brief: "The identifier of the navigation the measurement belongs to, incremented by the browser for each navigation within a page's lifetime.",
        type: "integer",
        keys: [
            "browser.navigation.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        examples: [
            1,
            3,
            0
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    640
                ],
                description: "Document 0 as the fallback value when the browser does not support `navigationId`"
            },
            {
                version: "0.22.0",
                prs: [
                    634
                ],
                description: "Added browser.navigation.id attribute"
            }
        ],
        additionalContext: [
            "Sourced from `PerformanceEntry.navigationId`, defined by the Soft Navigations spec. Despite its origin it is not soft-navigation specific: the field is set on the `PerformanceNavigationTiming` entry of a hard navigation too.",
            "The value starts at 1 for the initial page load and increments for each subsequent navigation. It is only unique within a single page lifetime, not globally.",
            "A value of 0 is a fallback rather than a real navigation id: web-vitals reports 0 when the browser does not expose `PerformanceEntry.navigationId`, so 0 means the id is unknown.",
            "Pairs with `browser.navigation.type`: the type says how the browser arrived at the page, the id says which navigation of that page a measurement belongs to.",
            "Not to be confused with the Navigation API's `NavigationHistoryEntry.id`, which is an opaque string identifying a history entry rather than a counter, and is not interchangeable with this value.",
            "Also distinct from the `router.navigation.*` attributes, which describe the client-side router's own view of a navigation. Those come from the framework, this one comes from the browser, and both can be set on the same span."
        ]
    },
    "browser.navigation.type": {
        brief: "The type of navigation the browser performed to arrive at the page the metrics were measured on.",
        type: "string",
        keys: [
            "browser.navigation.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigate",
        examples: [
            "navigate",
            "reload",
            "back-forward",
            "back-forward-cache",
            "prerender",
            "restore",
            "soft-navigation"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    640
                ],
                description: "Use the web-vitals navigation types as-is: `bfcache` is now `back-forward-cache`, and `back-forward` and `restore` are no longer reported as `navigate`"
            },
            {
                version: "0.22.0",
                prs: [
                    600
                ],
                description: "Added browser.navigation.type attribute"
            }
        ],
        additionalContext: [
            "Carries the `navigationType` value reported by the web-vitals library verbatim. web-vitals hyphenates the Navigation Timing `PerformanceNavigationTiming.type` value (`back_forward` becomes `back-forward`) and adds states that API does not cover: `back-forward-cache` for a restore from the back/forward cache, `prerender`, `restore` for a discarded tab being reloaded, and `soft-navigation`.",
            "`back-forward-cache` is only set when the page was actually restored from the back/forward cache. A back/forward navigation that missed the cache is a full document load and reports `back-forward`. Use the `browser.bfcache.*` attributes to diagnose misses.",
            "`prerender` pages finish painting before activation, so their paint timings are offset by `browser.performance.navigation.activation_start`. Keep them separate when aggregating web vitals.",
            "Not to be confused with `router.navigation.type`, which holds the client-side router's own vocabulary (`link`, `goto`, `router.push`). The two are independent and can both be set on the same span."
        ]
    },
    "browser.paint.type": {
        brief: "The type of paint timing entry reported by the browser.",
        type: "string",
        keys: [
            "browser.paint.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "first-paint",
        examples: [
            "first-paint",
            "first-contentful-paint"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    606
                ],
                description: "Added browser.paint.type attribute"
            }
        ]
    },
    "browser.performance.navigation.activation_start": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        keys: [
            "browser.performance.navigation.activation_start",
            "performance.activationStart"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        aliases: [
            "performance.activationStart"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.navigation.activation_start attribute"
            }
        ]
    },
    "browser.performance.time_origin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        keys: [
            "browser.performance.time_origin",
            "performance.timeOrigin"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        aliases: [
            "performance.timeOrigin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added browser.performance.time_origin attribute attribute"
            }
        ]
    },
    "browser.report.type": {
        brief: "A browser report sent via reporting API..",
        type: "string",
        keys: [
            "browser.report.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "network-error",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "browser.script.invoker": {
        brief: "How a script was called in the browser.",
        type: "string",
        keys: [
            "browser.script.invoker"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Window.requestAnimationFrame",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.invoker_type": {
        brief: "Browser script entry point type.",
        type: "string",
        keys: [
            "browser.script.invoker_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "event-listener",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.script.source_char_position": {
        brief: "A number representing the script character position of the script.",
        type: "integer",
        keys: [
            "browser.script.source_char_position"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 678,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "browser.version": {
        brief: "The version of the browser.",
        type: "string",
        keys: [
            "browser.version",
            "sentry.browser.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        aliases: [
            "sentry.browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    59,
                    127,
                    139
                ]
            }
        ]
    },
    "browser.web_vital.cls.report_event": {
        brief: "The event that caused the SDK to report CLS (pagehide or navigation)",
        type: "string",
        keys: [
            "browser.web_vital.cls.report_event"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "navigation",
        deprecation: {
            reason: "The JavaScript SDK stopped setting this in v11. With per-navigation web vitals, web-vitals decides when the CLS value is final, so there is no report event to record. No replacement."
        },
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    642
                ],
                description: "Deprecated browser.web_vital.cls.report_event, which has no replacement"
            },
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.cls.report_event attribute"
            }
        ]
    },
    "browser.web_vital.cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        keys: [
            "browser.web_vital.cls.source.<key>",
            "cls.source.<key>"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        aliases: [
            "cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    "browser.web_vital.cls.value": {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        keys: [
            "browser.web_vital.cls.value",
            "cls"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        aliases: [
            "cls"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.cls.value attribute"
            }
        ]
    },
    "browser.web_vital.fcp.value": {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        keys: [
            "browser.web_vital.fcp.value",
            "fcp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        aliases: [
            "fcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.fp.value": {
        brief: "The time in milliseconds it takes for the browser to render the first pixel on the screen",
        type: "double",
        keys: [
            "browser.web_vital.fp.value",
            "fp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        aliases: [
            "fp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.inp.interaction_type": {
        brief: "The kind of user interaction INP was reported on",
        type: "string",
        keys: [
            "browser.web_vital.inp.interaction_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "click",
        examples: [
            "click",
            "hover",
            "drag",
            "press"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    641
                ],
                description: "Added browser.web_vital.inp.interaction_type attribute"
            }
        ],
        additionalContext: [
            "One of `click`, `hover`, `drag` or `press`, derived from the DOM event name of the Event Timing entry: pointer, mouse and touch events map to `click`, `mouseover` and similar to `hover`, drag and drop events to `drag`, and keyboard and `input` events to `press`. The same value forms the suffix of the span's `ui.interaction.*` op.",
            "Not to be confused with the `interactionType` of the web-vitals attribution build, which only distinguishes `pointer` and `keyboard`.",
            "Omitted when INP is reported without an interaction to attribute it to, see `browser.web_vital.inp.target`. The op of such a span still falls into `ui.interaction.click` so that it stays within the interaction span family, which makes this attribute, not the op, the way to tell a real click from a value with no interaction."
        ]
    },
    "browser.web_vital.inp.target": {
        brief: "The HTML element selector or component name of the element the user interacted with, for the interaction INP was reported on",
        type: "string",
        keys: [
            "browser.web_vital.inp.target"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > button.submit",
        examples: [
            "body > div#app > button.submit",
            "SubmitButton"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    641
                ],
                description: "Added browser.web_vital.inp.target attribute"
            }
        ],
        additionalContext: [
            "Named after `PerformanceEventTiming.target`, the way `browser.web_vital.lcp.element` is named after `LargestContentfulPaint.element`. The value uses the same format as that attribute.",
            "Omitted when INP is reported without an interaction to attribute it to. web-vitals reports such a value for a soft navigation whose interactions all stayed below the Event Timing duration threshold, so there is no element to name. The span is still named and still carries `browser.web_vital.inp.value`."
        ]
    },
    "browser.web_vital.inp.value": {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        keys: [
            "browser.web_vital.inp.value",
            "inp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        aliases: [
            "inp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.inp.value attribute"
            }
        ]
    },
    "browser.web_vital.lcp.element": {
        brief: "The HTML element selector or component name for which LCP was reported",
        type: "string",
        keys: [
            "browser.web_vital.lcp.element",
            "lcp.element"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "body > div#app > div#container > div",
        aliases: [
            "lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint",
        type: "string",
        keys: [
            "browser.web_vital.lcp.id",
            "lcp.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#gero",
        aliases: [
            "lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.load_time": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        keys: [
            "browser.web_vital.lcp.load_time",
            "lcp.loadTime"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        aliases: [
            "lcp.loadTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.render_time": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        keys: [
            "browser.web_vital.lcp.render_time",
            "lcp.renderTime"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        aliases: [
            "lcp.renderTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.report_event": {
        brief: "The event that caused the SDK to report LCP (pagehide or navigation)",
        type: "string",
        keys: [
            "browser.web_vital.lcp.report_event"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The JavaScript SDK stopped setting this in v11. With per-navigation web vitals, web-vitals decides when the LCP value is final, so there is no report event to record. No replacement."
        },
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    642
                ],
                description: "Deprecated browser.web_vital.lcp.report_event, which has no replacement"
            },
            {
                version: "0.5.0",
                prs: [
                    319
                ],
                description: "Added browser.web_vital.lcp.report_event attribute"
            }
        ]
    },
    "browser.web_vital.lcp.size": {
        brief: "The size of the largest contentful paint element",
        type: "integer",
        keys: [
            "browser.web_vital.lcp.size",
            "lcp.size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        aliases: [
            "lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint",
        type: "string",
        keys: [
            "browser.web_vital.lcp.url",
            "lcp.url"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/static/img.png",
        aliases: [
            "lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "browser.web_vital.lcp.value": {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        keys: [
            "browser.web_vital.lcp.value",
            "lcp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        aliases: [
            "lcp"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added browser.web_vital.lcp.value attribute"
            }
        ]
    },
    "browser.web_vital.ttfb.request_time": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        keys: [
            "browser.web_vital.ttfb.request_time",
            "ttfb.requestTime"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        aliases: [
            "ttfb.requestTime"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "browser.web_vital.ttfb.value": {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds",
        type: "double",
        keys: [
            "browser.web_vital.ttfb.value",
            "ttfb"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194.3322,
        aliases: [
            "ttfb"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "cache.hit": {
        brief: "If the cache was hit during this span.",
        type: "boolean",
        keys: [
            "cache.hit"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.item_age": {
        brief: "The age of the cache entry in seconds, measured at read time.",
        type: "integer",
        keys: [
            "cache.item_age"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        examples: [
            5,
            3600
        ],
        changelog: [
            {
                version: "0.23.0",
                prs: [
                    637
                ],
                description: "Added cache.item_age attribute"
            }
        ],
        additionalContext: [
            "Set on reads that return an entry. Absent on a miss, or when the cache does not report a write time.",
            "Clamped to 0. On a shared cache, the writer's clock and the reader's clock can drift far enough to make the age negative.",
            "Can exceed `cache.ttl`. A cache that discards an expired entry on read still reports the age of that entry, with `cache.hit: false`."
        ],
        searchAlias: {
            name: "cache.item_age",
            type: "second"
        }
    },
    "cache.item_size": {
        brief: "The size of the requested item in the cache. In bytes.",
        type: "integer",
        keys: [
            "cache.item_size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 58,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "cache.item_size",
            type: "byte"
        }
    },
    "cache.key": {
        brief: "The key of the cache accessed.",
        type: "string[]",
        keys: [
            "cache.key"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "my-cache-key",
            "my-other-cache-key"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.operation": {
        brief: "The operation being performed on the cache.",
        type: "string",
        keys: [
            "cache.operation"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "get",
        examples: [
            "get",
            "put",
            "remove"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.tags": {
        brief: "The tags attached to the cache entry. Tags group entries so a cache can invalidate them together.",
        type: "string[]",
        keys: [
            "cache.tags"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "Applications pick tag values freely and often build them from record identifiers such as a user id."
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "blog-posts",
            "post-42"
        ],
        examples: [
            [
                "blog-posts",
                "post-42"
            ],
            [
                "products"
            ]
        ],
        changelog: [
            {
                version: "0.23.0",
                prs: [
                    637
                ],
                description: "Added cache.tags attribute"
            }
        ],
        additionalContext: [
            "Cache library examples that support tags: Next.js `cacheTag()`, Symfony `ItemInterface::tag()`, Laravel `Cache::tags()`.",
            "HTTP caches take tags from a response header. Cloudflare reads `Cache-Tag`, Fastly reads `Surrogate-Key`.",
            "Record only the tags the application declared. Leave out implicit tags that the framework adds itself, for example one tag per route.",
            "The tags describe the entry, not the operation. Take them from the entry the cache returned or stored."
        ]
    },
    "cache.ttl": {
        brief: "The ttl (maximum lifetime) of the cache in seconds",
        type: "integer",
        keys: [
            "cache.ttl"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cache.write": {
        brief: "If the cache operation resulted in a write to the cache.",
        type: "boolean",
        keys: [
            "cache.write"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    channel: {
        brief: "The channel name that is being used.",
        type: "string",
        keys: [
            "channel"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mail",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.address": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        keys: [
            "client.address",
            "http.client_ip"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "http.client_ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "client.port": {
        brief: "Client port number.",
        type: "integer",
        keys: [
            "client.port"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 5432,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.duration": {
        brief: "The duration of a Cloudflare D1 operation.",
        type: "integer",
        keys: [
            "cloudflare.d1.duration"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 543,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.query_type": {
        brief: "The type of query executed in a Cloudflare D1 operation",
        type: "string",
        keys: [
            "db.operation.name",
            "cloudflare.d1.query_type",
            "db.operation",
            "redis.command"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "run",
        deprecation: {
            replacement: "db.operation.name",
            status: "backfill"
        },
        aliases: [
            "db.operation.name",
            "db.operation",
            "redis.command"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    531
                ],
                description: "Added redis.command as an alias"
            },
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.d1.query_type attribute"
            }
        ]
    },
    "cloudflare.d1.rows_read": {
        brief: "The number of rows read in a Cloudflare D1 operation.",
        type: "integer",
        keys: [
            "cloudflare.d1.rows_read"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.d1.rows_written": {
        brief: "The number of rows written in a Cloudflare D1 operation.",
        type: "integer",
        keys: [
            "cloudflare.d1.rows_written"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "cloudflare.durable_object.query.bindings": {
        brief: "The number of bound parameters passed to the SQL exec call.",
        type: "integer",
        keys: [
            "cloudflare.durable_object.query.bindings"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.query.bindings attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_read": {
        brief: "The number of rows read by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        keys: [
            "cloudflare.durable_object.response.rows_read"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_read attribute"
            }
        ]
    },
    "cloudflare.durable_object.response.rows_written": {
        brief: "The number of rows written by a Cloudflare Durable Object SQL operation.",
        type: "integer",
        keys: [
            "cloudflare.durable_object.response.rows_written"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    435
                ],
                description: "Added cloudflare.durable_object.response.rows_written attribute"
            }
        ]
    },
    "cloudflare.r2.bucket": {
        brief: "The name of the Cloudflare R2 bucket binding",
        type: "string",
        keys: [
            "cloudflare.r2.bucket"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MY_BUCKET",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.bucket attribute"
            }
        ]
    },
    "cloudflare.r2.operation": {
        brief: "The R2 API operation being performed",
        type: "string",
        keys: [
            "cloudflare.r2.operation"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GetObject",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.operation attribute"
            }
        ]
    },
    "cloudflare.r2.request.delimiter": {
        brief: "The delimiter used to group objects in an R2 list operation",
        type: "string",
        keys: [
            "cloudflare.r2.request.delimiter"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.delimiter attribute"
            }
        ]
    },
    "cloudflare.r2.request.key": {
        brief: "The object key used in the R2 operation",
        type: "string",
        keys: [
            "cloudflare.r2.request.key"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-file.txt",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.key attribute"
            }
        ]
    },
    "cloudflare.r2.request.part_number": {
        brief: "The part number in a multipart upload operation",
        type: "integer",
        keys: [
            "cloudflare.r2.request.part_number"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.part_number attribute"
            }
        ]
    },
    "cloudflare.r2.request.prefix": {
        brief: "The prefix used to filter objects in an R2 list operation",
        type: "string",
        keys: [
            "cloudflare.r2.request.prefix"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "images/",
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    413
                ],
                description: "Added cloudflare.r2.request.prefix attribute"
            }
        ]
    },
    "cloudflare.workflow.attempt": {
        brief: "The current attempt number for a Cloudflare Workflow step",
        type: "integer",
        keys: [
            "cloudflare.workflow.attempt"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.attempt attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.backoff": {
        brief: "The backoff strategy for Cloudflare Workflow step retries",
        type: "string",
        keys: [
            "cloudflare.workflow.retries.backoff"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "exponential",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.backoff attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.delay": {
        brief: "The delay between Cloudflare Workflow step retries",
        type: "string",
        keys: [
            "cloudflare.workflow.retries.delay"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "5 seconds",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.delay attribute"
            }
        ]
    },
    "cloudflare.workflow.retries.limit": {
        brief: "The maximum number of retries for a Cloudflare Workflow step",
        type: "integer",
        keys: [
            "cloudflare.workflow.retries.limit"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.retries.limit attribute"
            }
        ]
    },
    "cloudflare.workflow.timeout": {
        brief: "The timeout duration for a Cloudflare Workflow step",
        type: "string",
        keys: [
            "cloudflare.workflow.timeout"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1 minute",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added cloudflare.workflow.timeout attribute"
            }
        ]
    },
    "cloud.account.id": {
        brief: "The cloud account ID the resource is assigned to",
        type: "string",
        keys: [
            "cloud.account.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "123456789012",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.account.id attribute"
            }
        ]
    },
    "cloud.availability_zone": {
        brief: "Cloud regions often have multiple, isolated locations known as zones to increase availability",
        type: "string",
        keys: [
            "cloud.availability_zone"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1c",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.availability_zone attribute"
            }
        ]
    },
    "cloud.platform": {
        brief: "The cloud platform in use",
        type: "string",
        keys: [
            "cloud.platform"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws_lambda",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.platform attribute"
            }
        ]
    },
    "cloud.provider": {
        brief: "Name of the cloud provider",
        type: "string",
        keys: [
            "cloud.provider"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.provider attribute"
            }
        ]
    },
    "cloud.region": {
        brief: "The geographical region the resource is running",
        type: "string",
        keys: [
            "cloud.region",
            "aws_region",
            "gcp_region"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "us-east-1",
        aliases: [
            "aws_region",
            "gcp_region"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    535,
                    537
                ],
                description: "Added aws_region and gcp_region as aliases"
            },
            {
                version: "0.7.0",
                prs: [
                    364
                ],
                description: "Added cloud.region attribute"
            }
        ]
    },
    "cloud.resource_id": {
        brief: "Cloud provider-specific native identifier of the monitored cloud resource",
        type: "string",
        keys: [
            "cloud.resource_id",
            "faas.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        aliases: [
            "faas.id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414
                ]
            }
        ],
        additionalContext: [
            "This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other."
        ]
    },
    cls: {
        brief: "The value of the recorded Cumulative Layout Shift (CLS) web vital",
        type: "double",
        keys: [
            "browser.web_vital.cls.value",
            "cls"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .2361,
        deprecation: {
            replacement: "browser.web_vital.cls.value",
            reason: "The CLS web vital is now recorded as a browser.web_vital.cls.value attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.cls.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "cls.source.<key>": {
        brief: "The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N",
        type: "string",
        keys: [
            "browser.web_vital.cls.source.<key>",
            "cls.source.<key>"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "body > div#app",
        deprecation: {
            replacement: "browser.web_vital.cls.source.<key>",
            reason: "The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.cls.source.<key>"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    234
                ]
            }
        ]
    },
    code: {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        keys: [
            "rpc.response.status_code",
            "code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        examples: [
            "DEADLINE_EXCEEDED"
        ],
        deprecation: {
            replacement: "rpc.response.status_code",
            status: "backfill"
        },
        aliases: [
            "rpc.grpc.status_code",
            "rpc.response.status_code"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    533
                ],
                description: "Added code attribute"
            }
        ]
    },
    "code.filepath": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        keys: [
            "code.file.path",
            "sveltekit.load.node_id",
            "code.filepath"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        deprecation: {
            replacement: "code.file.path",
            status: "backfill"
        },
        aliases: [
            "code.file.path",
            "sveltekit.load.node_id"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    611
                ],
                description: "Added sveltekit.load.node_id as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.file.path": {
        brief: "The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).",
        type: "string",
        keys: [
            "code.file.path",
            "sveltekit.load.node_id",
            "code.filepath"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/app/myapplication/http/handler/server.py",
        aliases: [
            "code.filepath",
            "sveltekit.load.node_id"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    611
                ],
                description: "Added sveltekit.load.node_id as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function": {
        brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
        type: "string",
        keys: [
            "code.function",
            "code.function.name",
            "django.function_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function.name",
            "django.function_name"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    538
                ],
                description: "Added django.function_name as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.function.name": {
        brief: "The method or function fully-qualified name without arguments.",
        type: "string",
        keys: [
            "code.function.name",
            "code.function",
            "django.function_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "server_request",
        aliases: [
            "code.function",
            "django.function_name"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    538
                ],
                description: "Added django.function_name as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.lineno": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        keys: [
            "code.line.number",
            "code.lineno"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        deprecation: {
            replacement: "code.line.number",
            status: "backfill"
        },
        aliases: [
            "code.line.number"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.line.number": {
        brief: "The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function",
        type: "integer",
        keys: [
            "code.line.number",
            "code.lineno"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        aliases: [
            "code.lineno"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "code.namespace": {
        brief: "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
        type: "string",
        keys: [
            "code.namespace"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.handler",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    connectionType: {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        keys: [
            "network.connection.type",
            "connectionType",
            "device.connection_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.type for span-first future",
            status: "backfill"
        },
        aliases: [
            "network.connection.type",
            "device.connection_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        keys: [
            "network.connection.rtt",
            "connection.rtt"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "network.connection.rtt",
            reason: "Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future",
            status: "backfill"
        },
        aliases: [
            "network.connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "culture.calendar": {
        brief: "The calendar system used by the culture.",
        type: "string",
        keys: [
            "culture.calendar"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GregorianCalendar",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.display_name": {
        brief: "Human readable name of the culture.",
        type: "string",
        keys: [
            "culture.display_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "English (United States)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.is_24_hour_format": {
        brief: "Whether the culture uses 24-hour time format.",
        type: "boolean",
        keys: [
            "culture.is_24_hour_format"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.locale": {
        brief: "The locale identifier following RFC 4646.",
        type: "string",
        keys: [
            "culture.locale"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "culture.timezone": {
        brief: "The timezone of the culture, as a geographic timezone identifier.",
        type: "string",
        keys: [
            "culture.timezone"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    243
                ]
            }
        ]
    },
    "db.collection.name": {
        brief: "The name of a collection (table, container) within the database.",
        type: "string",
        keys: [
            "db.collection.name",
            "db.mongodb.collection"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "users",
        aliases: [
            "db.mongodb.collection"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    483
                ],
                description: "Added db.mongodb.collection as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.connection_string": {
        brief: "The connection string used to connect to the database.",
        type: "string",
        keys: [
            "db.connection_string"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "redis://localhost:6379",
        examples: [
            "redis://localhost:6379"
        ],
        deprecation: {
            reason: "This attribute is deprecated. The connection is described by server.address and server.port instead, so the value cannot be copied to a single replacement attribute."
        },
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added db.connection_string attribute"
            }
        ]
    },
    "db.driver.name": {
        brief: "The name of the driver used for the database connection.",
        type: "string",
        keys: [
            "db.driver.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "psycopg2",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    297
                ],
                description: "Added db.driver.name attribute"
            }
        ]
    },
    "db.mongodb.collection": {
        brief: "The MongoDB collection being accessed.",
        type: "string",
        keys: [
            "db.collection.name",
            "db.mongodb.collection"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "users",
        deprecation: {
            replacement: "db.collection.name",
            reason: "This attribute is being deprecated in favor of db.collection.name, which is the OTel-aligned replacement.",
            status: "backfill"
        },
        aliases: [
            "db.collection.name"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    483
                ],
                description: "Added db.mongodb.collection attribute, deprecated in favor of db.collection.name"
            }
        ]
    },
    "db.name": {
        brief: "The name of the database being accessed.",
        type: "string",
        keys: [
            "db.namespace",
            "db.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        deprecation: {
            replacement: "db.namespace",
            status: "backfill"
        },
        aliases: [
            "db.namespace"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.namespace": {
        brief: "The name of the database being accessed.",
        type: "string",
        keys: [
            "db.namespace",
            "db.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "customers",
        aliases: [
            "db.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation": {
        brief: "The name of the operation being executed.",
        type: "string",
        keys: [
            "db.operation.name",
            "cloudflare.d1.query_type",
            "db.operation",
            "redis.command"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        deprecation: {
            replacement: "db.operation.name",
            status: "normalize"
        },
        aliases: [
            "db.operation.name",
            "cloudflare.d1.query_type",
            "redis.command"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    531
                ],
                description: "Added redis.command as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.operation.batch.size": {
        brief: "The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.",
        type: "integer",
        keys: [
            "db.operation.batch.size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    407
                ],
                description: "Added db.operation.batch.size attribute"
            }
        ]
    },
    "db.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        keys: [
            "db.operation.name",
            "cloudflare.d1.query_type",
            "db.operation",
            "redis.command"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT",
        aliases: [
            "db.operation",
            "cloudflare.d1.query_type",
            "redis.command"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    531
                ],
                description: "Added redis.command as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.params": {
        brief: "The query bindings for a database request.",
        type: "string",
        keys: [
            "db.params"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"x": 100}]',
        examples: [
            '[{"x": 100}]'
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.params attribute, add them as individual entries with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    529
                ],
                description: "Added db.params attribute"
            }
        ]
    },
    "db.query.parameter.<key>": {
        brief: "A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.",
        type: "string",
        keys: [
            "db.query.parameter.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "db.query.parameter.foo='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103,
                    127
                ]
            }
        ]
    },
    "db.query.summary": {
        brief: "A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.",
        type: "string",
        keys: [
            "db.query.summary"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT users",
        examples: [
            "SELECT users",
            "INSERT products; UPDATE orders"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    505
                ],
                description: "Added multiple examples"
            },
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.query.text": {
        brief: "The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.",
        type: "string",
        keys: [
            "db.query.text",
            "db.statement",
            "query"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        aliases: [
            "db.statement",
            "query"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    530
                ],
                description: "Added query as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    208
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.connection": {
        brief: "The redis connection name.",
        type: "string",
        keys: [
            "db.redis.connection"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-redis-instance",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        keys: [
            "db.redis.key",
            "redis.key"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        aliases: [
            "redis.key"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    484
                ],
                description: "Added redis.key as an alias"
            },
            {
                version: "0.6.0",
                prs: [
                    326
                ],
                description: "Added db.redis.key attribute"
            }
        ]
    },
    "db.redis.parameters": {
        brief: "The array of command parameters given to a redis command.",
        type: "string[]",
        keys: [
            "db.redis.parameters"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "test",
            "*"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "db.response.status_code": {
        brief: "Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.",
        type: "string",
        keys: [
            "db.response.status_code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ORA-17002",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    462
                ],
                description: "Added db.response.status_code attribute"
            }
        ]
    },
    "db.sql.bindings": {
        brief: "The array of query bindings.",
        type: "string[]",
        keys: [
            "db.sql.bindings"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "1",
            "foo"
        ],
        deprecation: {
            replacement: "db.query.parameter.<key>",
            reason: "Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.statement": {
        brief: "The database statement being executed.",
        type: "string",
        keys: [
            "db.query.text",
            "db.statement",
            "query"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        deprecation: {
            replacement: "db.query.text",
            reason: "While this attribute never specifically required parameterization, the replacement, db.query.text, does.",
            status: "normalize"
        },
        aliases: [
            "db.query.text",
            "query"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    501
                ],
                description: "Improved example, added deprecation reason, and added query as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    199
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.stored_procedure.name": {
        brief: "The name of a stored procedure being called.",
        type: "string",
        keys: [
            "db.stored_procedure.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GetUserById",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    398
                ]
            }
        ]
    },
    "db.system": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        keys: [
            "db.system.name",
            "db.system",
            "span.system"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        deprecation: {
            replacement: "db.system.name",
            status: "backfill"
        },
        aliases: [
            "db.system.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    199,
                    224
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "db.system",
            deprecatedAliases: [
                "span.system"
            ]
        }
    },
    "db.system.name": {
        brief: "An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.",
        type: "string",
        keys: [
            "db.system.name",
            "db.system",
            "span.system"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "postgresql",
        aliases: [
            "db.system"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "db.user": {
        brief: "The database user.",
        type: "string",
        keys: [
            "db.user"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "fancy_user",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    deviceMemory: {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes.",
        type: "string",
        keys: [
            "device.memory.estimated_capacity",
            "deviceMemory"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "8 GB",
        deprecation: {
            replacement: "device.memory.estimated_capacity",
            reason: "Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future",
            status: "backfill"
        },
        aliases: [
            "device.memory.estimated_capacity"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "device.archs": {
        brief: "The CPU architectures of the device.",
        type: "string[]",
        keys: [
            "device.archs"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "arm64-v8a",
            "armeabi-v7a",
            "armeabi"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.archs attribute"
            }
        ]
    },
    "device.battery_level": {
        brief: "The battery level of the device as a percentage (0-100).",
        type: "double",
        keys: [
            "device.battery_level"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_level attribute"
            }
        ]
    },
    "device.battery_temperature": {
        brief: "The battery temperature of the device in Celsius.",
        type: "double",
        keys: [
            "device.battery_temperature"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 25,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.battery_temperature attribute"
            }
        ]
    },
    "device.boot_time": {
        brief: "A formatted UTC timestamp when the system was booted.",
        type: "string",
        keys: [
            "device.boot_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2018-02-08T12:52:12Z",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.boot_time attribute"
            }
        ]
    },
    "device.brand": {
        brief: "The brand of the device.",
        type: "string",
        keys: [
            "device.brand"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Apple",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.charging": {
        brief: "Whether the device was charging or not.",
        type: "boolean",
        keys: [
            "device.charging"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.charging attribute"
            }
        ]
    },
    "device.chipset": {
        brief: "The chipset of the device.",
        type: "string",
        keys: [
            "device.chipset"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Qualcomm SM8550",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.chipset attribute"
            }
        ]
    },
    "device.class": {
        brief: "The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.",
        type: "string",
        keys: [
            "device.class"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "medium",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.class attribute"
            }
        ]
    },
    "device.connection_type": {
        brief: "The internet connection type currently being used by the device.",
        type: "string",
        keys: [
            "network.connection.type",
            "connectionType",
            "device.connection_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "wifi",
        deprecation: {
            replacement: "network.connection.type",
            reason: "This attribute is being deprecated in favor of network.connection.type",
            status: "backfill"
        },
        aliases: [
            "network.connection.type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added and deprecated device.connection_type in favor of network.connection.type"
            }
        ]
    },
    "device.cpu_description": {
        brief: "A description of the CPU of the device.",
        type: "string",
        keys: [
            "device.cpu_description"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.cpu_description attribute"
            }
        ]
    },
    "device.external_free_storage": {
        brief: "External storage free size in bytes.",
        type: "integer",
        keys: [
            "device.external_free_storage"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 67108864e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_free_storage attribute"
            }
        ]
    },
    "device.external_storage_size": {
        brief: "External storage total size in bytes.",
        type: "integer",
        keys: [
            "device.external_storage_size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 134217728e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.external_storage_size attribute"
            }
        ]
    },
    "device.family": {
        brief: "The family of the device.",
        type: "string",
        keys: [
            "device.family"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.free_memory": {
        brief: "Free system memory in bytes.",
        type: "integer",
        keys: [
            "device.free_memory"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.free_memory attribute"
            }
        ]
    },
    "device.free_storage": {
        brief: "Free device storage in bytes.",
        type: "integer",
        keys: [
            "device.free_storage"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 107374182400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.free_storage attribute"
            }
        ]
    },
    "device.id": {
        brief: "Unique device identifier.",
        type: "string",
        keys: [
            "device.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.id attribute"
            }
        ]
    },
    "device.locale": {
        brief: "The locale of the device.",
        type: "string",
        keys: [
            "device.locale"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "en-US",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.locale attribute"
            }
        ]
    },
    "device.low_memory": {
        brief: "Whether the device was low on memory.",
        type: "boolean",
        keys: [
            "device.low_memory"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.low_memory attribute"
            }
        ]
    },
    "device.low_power_mode": {
        brief: "Whether the device is in Low Power Mode.",
        type: "boolean",
        keys: [
            "device.low_power_mode"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    314
                ],
                description: "Added device.low_power_mode attribute"
            }
        ]
    },
    "device.manufacturer": {
        brief: "The manufacturer of the device.",
        type: "string",
        keys: [
            "device.manufacturer"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Google",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.manufacturer attribute"
            }
        ]
    },
    "device.memory.estimated_capacity": {
        brief: "The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB",
        type: "integer",
        keys: [
            "device.memory.estimated_capacity",
            "deviceMemory"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "deviceMemory"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281
                ],
                description: "Added attribute device.memory.estimated_capacity to be used instead of deviceMemory"
            }
        ]
    },
    "device.memory_size": {
        brief: "Total system memory available in bytes.",
        type: "integer",
        keys: [
            "device.memory_size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17179869184,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.memory_size attribute"
            }
        ]
    },
    "device.model": {
        brief: "The model of the device.",
        type: "string",
        keys: [
            "device.model"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "iPhone 15 Pro Max",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116,
                    127
                ]
            }
        ]
    },
    "device.model_id": {
        brief: "An internal hardware revision to identify the device exactly.",
        type: "string",
        keys: [
            "device.model_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "N861AP",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.model_id attribute"
            }
        ]
    },
    "device.name": {
        brief: "The user-assigned name of the mobile device.",
        type: "string",
        keys: [
            "device.name"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "localhost",
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    647
                ],
                description: "Limit brief to mobile attributes and remove server_name alias"
            },
            {
                version: "0.21.0",
                prs: [
                    602
                ],
                description: "Added server_name as an alias"
            },
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.name attribute"
            }
        ]
    },
    "device.online": {
        brief: "Whether the device was online or not.",
        type: "boolean",
        keys: [
            "device.online"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.online attribute"
            }
        ]
    },
    "device.orientation": {
        brief: 'The orientation of the device, either "portrait" or "landscape".',
        type: "string",
        keys: [
            "device.orientation"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "portrait",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.orientation attribute"
            }
        ]
    },
    "device.processor_count": {
        brief: 'Number of "logical processors".',
        type: "integer",
        keys: [
            "device.processor_count",
            "hardwareConcurrency"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 8,
        aliases: [
            "hardwareConcurrency"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count"
            }
        ]
    },
    "device.processor_frequency": {
        brief: "Processor frequency in MHz.",
        type: "double",
        keys: [
            "device.processor_frequency"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.processor_frequency attribute"
            }
        ]
    },
    "device.screen_density": {
        brief: "The screen density of the device.",
        type: "double",
        keys: [
            "device.screen_density"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2.625,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_density attribute"
            }
        ]
    },
    "device.screen_dpi": {
        brief: "The screen density in dots-per-inch (DPI) of the device.",
        type: "integer",
        keys: [
            "device.screen_dpi"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 420,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_dpi attribute"
            }
        ]
    },
    "device.screen_height_pixels": {
        brief: "The height of the device screen in pixels.",
        type: "integer",
        keys: [
            "device.screen_height_pixels"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2400,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_height_pixels attribute"
            }
        ]
    },
    "device.screen_width_pixels": {
        brief: "The width of the device screen in pixels.",
        type: "integer",
        keys: [
            "device.screen_width_pixels"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1080,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.screen_width_pixels attribute"
            }
        ]
    },
    "device.simulator": {
        brief: "Whether the device is a simulator or an actual device.",
        type: "boolean",
        keys: [
            "device.simulator"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    300
                ],
                description: "Added device.simulator attribute"
            }
        ]
    },
    "device.storage_size": {
        brief: "Total device storage in bytes.",
        type: "integer",
        keys: [
            "device.storage_size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 274877906944,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.storage_size attribute"
            }
        ]
    },
    "device.thermal_state": {
        brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum: `nominal`, `fair`, `serious`, or `critical`.",
        type: "string",
        keys: [
            "device.thermal_state"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "nominal",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.thermal_state attribute"
            }
        ]
    },
    "device.timezone": {
        brief: "The timezone of the device.",
        type: "string",
        keys: [
            "device.timezone"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Europe/Vienna",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.timezone attribute"
            }
        ]
    },
    "device.usable_memory": {
        brief: "Memory usable for the app in bytes.",
        type: "integer",
        keys: [
            "device.usable_memory"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2147483648,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    303
                ],
                description: "Added device.usable_memory attribute"
            }
        ]
    },
    dist: {
        brief: "The sentry dist.",
        type: "string",
        keys: [
            "sentry.dist",
            "dist"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        deprecation: {
            replacement: "sentry.dist",
            reason: "This attribute is being deprecated in favor of sentry.dist.",
            status: "backfill"
        },
        aliases: [
            "sentry.dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist attribute"
            }
        ]
    },
    "django.function_name": {
        brief: "The fully qualified name of a function used in a Django context.",
        type: "string",
        keys: [
            "code.function.name",
            "code.function",
            "django.function_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "django.contrib.sessions.middleware.SessionMiddleware",
        examples: [
            "django.contrib.sessions.middleware.SessionMiddleware"
        ],
        deprecation: {
            replacement: "code.function.name",
            reason: "This attribute is being deprecated in favor of code.function.name, which is the framework-agnostic replacement.",
            status: "backfill"
        },
        aliases: [
            "code.function.name",
            "code.function"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    538
                ],
                description: "Added django.function_name attribute"
            }
        ]
    },
    "django.middleware_name": {
        brief: "The name of the Django middleware.",
        type: "string",
        keys: [
            "middleware.name",
            "django.middleware_name",
            "litestar.middleware_name",
            "starlette.middleware_name",
            "starlite.middleware_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        examples: [
            "AuthenticationMiddleware"
        ],
        deprecation: {
            replacement: "middleware.name",
            reason: "This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.",
            status: "backfill"
        },
        aliases: [
            "middleware.name"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    520
                ],
                description: "Added django.middleware_name attribute"
            }
        ]
    },
    effectiveConnectionType: {
        brief: "Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        keys: [
            "network.connection.effective_type",
            "effectiveConnectionType"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        deprecation: {
            replacement: "network.connection.effective_type",
            reason: "Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future",
            status: "backfill"
        },
        aliases: [
            "network.connection.effective_type"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    environment: {
        brief: "The sentry environment.",
        type: "string",
        keys: [
            "sentry.environment",
            "environment",
            "resource.deployment.environment",
            "resource.deployment.environment.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment",
            status: "normalize"
        },
        aliases: [
            "sentry.environment"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    427
                ],
                description: "Configured normalization"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "error.type": {
        brief: "Describes a class of error the operation ended with.",
        type: "string",
        keys: [
            "error.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timeout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "event.id": {
        brief: "The unique identifier for this event (log record)",
        type: "integer",
        keys: [
            "event.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234567890,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101
                ]
            }
        ]
    },
    "event.name": {
        brief: "The name that uniquely identifies this event (log record)",
        type: "string",
        keys: [
            "event.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Process Payload",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    101,
                    127
                ]
            }
        ]
    },
    "exception.escaped": {
        brief: "SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.",
        type: "boolean",
        keys: [
            "exception.escaped"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.message": {
        brief: "The error message.",
        type: "string",
        keys: [
            "exception.message"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.stacktrace": {
        brief: "A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.",
        type: "string",
        keys: [
            "exception.stacktrace"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: `Exception in thread "main" java.lang.RuntimeException: Test exception
 at com.example.GenerateTrace.methodB(GenerateTrace.java:13)
 at com.example.GenerateTrace.methodA(GenerateTrace.java:9)
 at com.example.GenerateTrace.main(GenerateTrace.java:5)`,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "exception.type": {
        brief: "The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.",
        type: "string",
        keys: [
            "exception.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OSError",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.coldstart": {
        brief: "A boolean that is true if the serverless function is executed for the first time (aka cold-start).",
        type: "boolean",
        keys: [
            "faas.coldstart"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.cron": {
        brief: "A string containing the schedule period as Cron Expression.",
        type: "string",
        keys: [
            "faas.cron"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "0/5 * * * ? *",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.duration_in_ms": {
        brief: "The duration a function took to run, in milliseconds.",
        type: "integer",
        keys: [
            "faas.duration_in_ms"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 120,
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.entry_point": {
        brief: "The code that's run when the cloud provider invokes your function.",
        type: "string",
        keys: [
            "faas.entry_point"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my_main_function",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.execution": {
        brief: "The execution ID of the current function execution.",
        type: "string",
        keys: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        deprecation: {
            replacement: "faas.invocation_id",
            reason: "This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement.",
            status: "backfill"
        },
        aliases: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution attribute, deprecated in favor of faas.invocation_id"
            }
        ]
    },
    "faas.id": {
        brief: "The unique ID of the single function that this runtime instance executes.",
        type: "string",
        keys: [
            "cloud.resource_id",
            "faas.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function",
        deprecation: {
            replacement: "cloud.resource_id",
            reason: "This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0).",
            status: "backfill"
        },
        aliases: [
            "cloud.resource_id"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    475
                ],
                description: "Added faas.id attribute, deprecated in favor of cloud.resource_id"
            }
        ]
    },
    "faas.identity": {
        brief: "The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services",
        type: "string",
        keys: [
            "faas.identity"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    "faas.invocation_id": {
        brief: "The invocation ID of the current function invocation.",
        type: "string",
        keys: [
            "faas.invocation_id",
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "af9d5aa4-a685-4c5f-a22b-444f80b3cc28",
        aliases: [
            "aws.lambda.aws_request_id",
            "faas.execution"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    473
                ],
                description: "Added faas.execution as an alias"
            },
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    "faas.invoked_name": {
        brief: "The name of the invoked function.",
        type: "string",
        keys: [
            "faas.invoked_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my-function",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_name attribute"
            }
        ]
    },
    "faas.invoked_provider": {
        brief: "The cloud provider of the invoked function.",
        type: "string",
        keys: [
            "faas.invoked_provider"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_provider attribute"
            }
        ]
    },
    "faas.invoked_region": {
        brief: "The cloud region of the invoked function.",
        type: "string",
        keys: [
            "faas.invoked_region"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "eu-central-1",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    481
                ],
                description: "Added faas.invoked_region attribute"
            }
        ]
    },
    "faas.name": {
        brief: "The name of the serverless function",
        type: "string",
        keys: [
            "faas.name",
            "aws.lambda.function_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "my_function",
        aliases: [
            "aws.lambda.function_name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403,
                    415
                ]
            }
        ]
    },
    "faas.time": {
        brief: "A string containing the function invocation time in the ISO 8601 format expressed in UTC.",
        type: "string",
        keys: [
            "faas.time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2020-01-23T13:47:06Z",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.trigger": {
        brief: "Type of the trigger which caused this function invocation.",
        type: "string",
        keys: [
            "faas.trigger"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "timer",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "faas.version": {
        brief: "The version of the function that was invoked",
        type: "string",
        keys: [
            "faas.version",
            "aws.lambda.function_version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "$LATEST",
        aliases: [
            "aws.lambda.function_version"
        ],
        changelog: [
            {
                version: "0.11.1",
                prs: [
                    414,
                    424
                ]
            }
        ]
    },
    fcp: {
        brief: "The time it takes for the browser to render the first piece of meaningful content on the screen",
        type: "double",
        keys: [
            "browser.web_vital.fcp.value",
            "fcp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 547.6951,
        deprecation: {
            replacement: "browser.web_vital.fcp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fcp.value",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.fcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "file.path": {
        brief: "Path to the file.",
        type: "string",
        keys: [
            "file.path"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "File paths can contain end-user paths (e.g. from stack traces) that may be sensitive."
        },
        isInOtel: !0,
        visibility: "public",
        example: "/home/user/example.txt",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    458
                ],
                description: "Added file.path attribute"
            }
        ]
    },
    "file.size": {
        brief: "File size in bytes.",
        type: "integer",
        keys: [
            "file.size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    458
                ],
                description: "Added file.size attribute"
            }
        ]
    },
    "flag.evaluation.<key>": {
        brief: "An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.",
        type: "boolean",
        keys: [
            "flag.evaluation.<key>"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "flag.evaluation.is_new_ui=true",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    fp: {
        brief: "The time it takes for the browser to render the first pixel on the screen",
        type: "double",
        keys: [
            "browser.web_vital.fp.value",
            "fp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 477.1926,
        deprecation: {
            replacement: "browser.web_vital.fp.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.fp.value",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.fp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "frames.delay": {
        brief: "The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).",
        type: "integer",
        keys: [
            "app.vitals.frames.delay.value",
            "frames.delay",
            "mobile.frames_delay"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5,
        deprecation: {
            replacement: "app.vitals.frames.delay.value",
            reason: "Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.frames.delay.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.delay.value"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "mobile.frames_delay",
            type: "second"
        }
    },
    "frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        keys: [
            "app.vitals.frames.frozen.count",
            "frames.frozen",
            "mobile.frozen_frames",
            "sentry.frames.frozen"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.frames.frozen.count",
            "sentry.frames.frozen"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    500
                ],
                description: "Added sentry.frames.frozen as an alias"
            },
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "mobile.frozen_frames"
        }
    },
    frames_frozen_rate: {
        brief: "The rate of frozen frames, or `app.vitals.frames.frozen.count` divided by `app.vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        keys: [
            "app.vitals.frames.frozen.rate",
            "frames_frozen_rate"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "app.vitals.frames.frozen.rate",
            reason: "Replaced by app.vitals.frames.frozen.rate to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.frames.frozen.rate"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    493
                ],
                description: "Deprecated in favor of app.vitals.frames.frozen.rate"
            },
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_frozen_rate attribute"
            }
        ]
    },
    "frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        keys: [
            "app.vitals.frames.slow.count",
            "frames.slow",
            "mobile.slow_frames",
            "sentry.frames.slow"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.frames.slow.count",
            "sentry.frames.slow"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    500
                ],
                description: "Added sentry.frames.slow as an alias"
            },
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "mobile.slow_frames"
        }
    },
    frames_slow_rate: {
        brief: "The rate of slow frames, or `app.vitals.frames.slow.count` divided by `app.vitals.frames.total.count`. This is computed by Relay.",
        type: "double",
        keys: [
            "app.vitals.frames.slow.rate",
            "frames_slow_rate"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "app.vitals.frames.slow.rate",
            reason: "Replaced by app.vitals.frames.slow.rate to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.frames.slow.rate"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    493
                ],
                description: "Deprecated in favor of app.vitals.frames.slow.rate"
            },
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added frames_slow_rate attribute"
            }
        ]
    },
    "frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        keys: [
            "app.vitals.frames.total.count",
            "frames.total",
            "mobile.total_frames",
            "sentry.frames.total"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.frames.total.count",
            "sentry.frames.total"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    500
                ],
                description: "Added sentry.frames.total as an alias"
            },
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Deprecated in favor of app.vitals.frames.total.count"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "mobile.total_frames"
        }
    },
    fs_error: {
        brief: "The error message of a file system error.",
        type: "string",
        keys: [
            "fs_error"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ENOENT: no such file or directory",
        deprecation: {
            replacement: "error.type",
            reason: "This attribute is not part of the OpenTelemetry specification and error.type fits much better. The value changes from the full error message to the syscall error code, so the old value cannot be copied over."
        },
        changelog: [
            {
                version: "0.23.0",
                prs: [
                    638
                ],
                description: "Remove unnecessary transformation and change deprecation status to null."
            },
            {
                version: "0.22.0",
                prs: [
                    589
                ],
                description: "Transform fs_error into error.type"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gcp.function.context.event_id": {
        brief: "The event ID from the legacy GCP Cloud Function context (1st gen)",
        type: "string",
        keys: [
            "gcp.function.context.event_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_id attribute"
            }
        ]
    },
    "gcp.function.context.event_type": {
        brief: "The type of the GCP Cloud Function event",
        type: "string",
        keys: [
            "gcp.function.context.event_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "google.pubsub.topic.publish",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.event_type attribute"
            }
        ]
    },
    "gcp.function.context.id": {
        brief: "The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)",
        type: "string",
        keys: [
            "gcp.function.context.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.id attribute"
            }
        ]
    },
    "gcp.function.context.resource": {
        brief: "The resource that triggered the GCP Cloud Function event",
        type: "string",
        keys: [
            "gcp.function.context.resource"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.resource attribute"
            }
        ]
    },
    "gcp.function.context.source": {
        brief: "The source of the GCP Cloud Function event",
        type: "string",
        keys: [
            "gcp.function.context.source"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "//pubsub.googleapis.com/projects/my-project/topics/my-topic",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.source attribute"
            }
        ]
    },
    "gcp.function.context.specversion": {
        brief: "The CloudEvents specification version of the GCP Cloud Function event",
        type: "string",
        keys: [
            "gcp.function.context.specversion"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.specversion attribute"
            }
        ]
    },
    "gcp.function.context.time": {
        brief: "The timestamp of the GCP Cloud Function event",
        type: "string",
        keys: [
            "gcp.function.context.time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.time attribute"
            }
        ]
    },
    "gcp.function.context.timestamp": {
        brief: "The legacy timestamp of the GCP Cloud Function event",
        type: "string",
        keys: [
            "gcp.function.context.timestamp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "2024-01-01T00:00:00.000Z",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.timestamp attribute"
            }
        ]
    },
    "gcp.function.context.type": {
        brief: "The type of the GCP Cloud Function event context",
        type: "string",
        keys: [
            "gcp.function.context.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "cloud_functions.context",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    371
                ],
                description: "Added gcp.function.context.type attribute"
            }
        ]
    },
    "gcp.project.id": {
        brief: "The ID of the project in GCP that this resource is associated with",
        type: "string",
        keys: [
            "gcp.project.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-project-123",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    403
                ]
            }
        ]
    },
    gcp_region: {
        brief: "The geographical region the GCP resource is running",
        type: "string",
        keys: [
            "cloud.region",
            "aws_region",
            "gcp_region"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "us-east-1",
        examples: [
            "us-east-1"
        ],
        deprecation: {
            replacement: "cloud.region",
            status: "backfill"
        },
        aliases: [
            "cloud.region",
            "aws_region"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    535
                ],
                description: "Added gcp_region attribute"
            }
        ]
    },
    "gen_ai.agent.name": {
        brief: "The name of the agent being used.",
        type: "string",
        keys: [
            "gen_ai.agent.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ResearchAssistant",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.context.utilization": {
        brief: "The fraction of the model context window utilized by this generation.",
        type: "double",
        keys: [
            "gen_ai.context.utilization"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .75,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.utilization attribute"
            }
        ]
    },
    "gen_ai.context.window_size": {
        brief: "The maximum context window size supported by the model for this generation.",
        type: "integer",
        keys: [
            "gen_ai.context.window_size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128e3,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    315
                ],
                description: "Added gen_ai.context.window_size attribute"
            }
        ]
    },
    "gen_ai.conversation.id": {
        brief: "The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.",
        type: "string",
        keys: [
            "gen_ai.conversation.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "conv_5j66UpCpwteGg4YSxUnt7lPY",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    250
                ]
            }
        ]
    },
    "gen_ai.cost.cache_creation.input_tokens": {
        brief: "The cost of input tokens written to cache in USD.",
        type: "double",
        keys: [
            "gen_ai.cost.cache_creation.input_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.cache_read.input_tokens": {
        brief: "The cost of cached input tokens in USD.",
        type: "double",
        keys: [
            "gen_ai.cost.cache_read.input_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
            "This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.input_tokens": {
        brief: "The total cost of all input tokens in USD (includes cached and cache creation tokens).",
        type: "double",
        keys: [
            "gen_ai.cost.input_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
            "This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens."
        ]
    },
    "gen_ai.cost.output_tokens": {
        brief: "The total cost of all output tokens in USD (includes reasoning tokens).",
        type: "double",
        keys: [
            "gen_ai.cost.output_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 123.45,
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
            "This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens."
        ]
    },
    "gen_ai.cost.reasoning.output_tokens": {
        brief: "The cost of reasoning output tokens in USD.",
        type: "double",
        keys: [
            "gen_ai.cost.reasoning.output_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        changelog: [
            {
                version: "0.16.0",
                description: "Added gen_ai.cost.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
            "This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.cost.total_tokens": {
        brief: "The total cost for the tokens used.",
        type: "double",
        keys: [
            "gen_ai.cost.total_tokens",
            "ai.total_cost"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12.34,
        aliases: [
            "ai.total_cost"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    126
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens."
        ]
    },
    "gen_ai.embeddings.input": {
        brief: "The input to the embeddings model.",
        type: "string",
        keys: [
            "gen_ai.embeddings.input"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "What's the weather in Paris?",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    195
                ]
            }
        ]
    },
    "gen_ai.function_id": {
        brief: "Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.",
        type: "string",
        keys: [
            "gen_ai.function_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-awesome-function",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    308
                ],
                description: "Added gen_ai.function_id attribute"
            }
        ]
    },
    "gen_ai.input.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        keys: [
            "gen_ai.input.messages",
            "ai.input_messages",
            "ai.prompt",
            "ai.prompt.messages",
            "ai.texts",
            "gen_ai.prompt"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57\xB0F"}]}]',
        aliases: [
            "ai.texts",
            "ai.prompt.messages",
            "gen_ai.prompt",
            "ai.prompt"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.prompt as an alias"
            },
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.operation.name": {
        brief: "The name of the operation being performed. It has the following list of well-known values: 'chat', 'create_agent', 'embeddings', 'execute_tool', 'generate_content', 'invoke_agent', 'text_completion'. If one of them applies, then that value MUST be used. Otherwise a custom value MAY be used.",
        type: "string",
        keys: [
            "gen_ai.operation.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "chat",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    225
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.operation.type": {
        brief: "The type of AI operation. Must be one of 'agent' (invoke_agent and create_agent spans), 'ai_client' (any LLM call), 'tool' (execute_tool spans), 'handoff' (handoff spans), 'other' (input and output processors, skill loading, guardrails etc.) . Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI",
        type: "string",
        keys: [
            "gen_ai.operation.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "tool",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    257
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    113,
                    127
                ]
            }
        ]
    },
    "gen_ai.output.messages": {
        brief: "The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls.",
        type: "string",
        keys: [
            "gen_ai.output.messages",
            "ai.response.text",
            "ai.response.toolCalls",
            "ai.responses",
            "ai.tool_calls"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57\xB0F."}], "finish_reason": "stop"}]',
        aliases: [
            "ai.response.toolCalls",
            "ai.response.text"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.pipeline.name": {
        brief: "Name of the AI pipeline or chain being executed.",
        type: "string",
        keys: [
            "gen_ai.pipeline.name",
            "ai.pipeline.name",
            "langchain.chain.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Autofix Pipeline",
        aliases: [
            "ai.pipeline.name",
            "langchain.chain.name"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    599
                ],
                description: "Added langchain.chain.name as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    76,
                    127
                ]
            }
        ]
    },
    "gen_ai.prompt": {
        brief: "The input messages sent to the model",
        type: "string",
        keys: [
            "gen_ai.input.messages",
            "ai.input_messages",
            "ai.prompt",
            "ai.prompt.messages",
            "ai.texts",
            "gen_ai.prompt"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        deprecation: {
            replacement: "gen_ai.input.messages",
            reason: "Deprecated from OTEL, use gen_ai.input.messages with the new format instead.",
            status: "backfill"
        },
        aliases: [
            "gen_ai.input.messages",
            "ai.texts",
            "ai.prompt.messages",
            "ai.prompt"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.prompt as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    74,
                    108,
                    119
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.prompt.name": {
        brief: "The name of the prompt that uniquely identifies it.",
        type: "string",
        keys: [
            "gen_ai.prompt.name",
            "mcp.prompt.name"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !0,
        visibility: "public",
        example: "summarize_text",
        aliases: [
            "mcp.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added gen_ai.prompt.name attribute"
            }
        ]
    },
    "gen_ai.provider.name": {
        brief: "The Generative AI provider as identified by the client or server instrumentation.",
        type: "string",
        keys: [
            "gen_ai.provider.name",
            "ai.model.provider",
            "gen_ai.system"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        aliases: [
            "ai.model.provider",
            "gen_ai.system"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            }
        ]
    },
    "gen_ai.request.available_tools": {
        brief: "The available tools for the model. It has to be a stringified version of an array of objects.",
        type: "string",
        keys: [
            "gen_ai.tool.definitions",
            "ai.prompt.tools",
            "ai.tools",
            "gen_ai.request.available_tools"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
        deprecation: {
            replacement: "gen_ai.tool.definitions",
            status: "normalize"
        },
        aliases: [
            "gen_ai.tool.definitions"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    595
                ],
                description: "Added gen_ai.tool.definitions as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.frequency_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.",
        type: "double",
        keys: [
            "gen_ai.request.frequency_penalty",
            "ai.frequency_penalty"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.frequency_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.max_tokens": {
        brief: "The maximum number of tokens to generate in the response.",
        type: "integer",
        keys: [
            "gen_ai.request.max_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2048,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.request.messages": {
        brief: 'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
        type: "string",
        keys: [
            "gen_ai.request.messages"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
        deprecation: {
            replacement: "gen_ai.input.messages",
            status: "transform",
            transformation: "gen_ai_request_messages_to_input_messages"
        },
        aliases: [
            "ai.input_messages"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74,
                    108,
                    119,
                    122
                ]
            }
        ]
    },
    "gen_ai.request.model": {
        brief: "The model identifier being used for the request.",
        type: "string",
        keys: [
            "gen_ai.request.model",
            "ai.model.id",
            "ai.model_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4-turbo-preview",
        aliases: [
            "ai.model_id",
            "ai.model.id"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.model.id as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.presence_penalty": {
        brief: "Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.",
        type: "double",
        keys: [
            "gen_ai.request.presence_penalty",
            "ai.presence_penalty"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .5,
        aliases: [
            "ai.presence_penalty"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.reasoning.level": {
        brief: "The reasoning or thinking effort level requested for a GenAI model.",
        type: "string",
        keys: [
            "gen_ai.request.reasoning.level"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "high",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    502
                ],
                description: "Added gen_ai.request.reasoning.level attribute"
            }
        ]
    },
    "gen_ai.request.schema": {
        brief: "The stringified JSON schema the model output must conform to.",
        type: "string",
        keys: [
            "gen_ai.request.schema"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"type":"object","properties":{"city":{"type":"string"}}}',
        examples: [
            '{"type":"object","properties":{"city":{"type":"string"}}}'
        ],
        deprecation: {
            reason: "This attribute is deprecated. The Sentry conventions have no replacement for the requested output schema."
        },
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added gen_ai.request.schema attribute"
            }
        ]
    },
    "gen_ai.request.seed": {
        brief: "The seed, ideally models given the same seed and same other parameters will produce the exact same output.",
        type: "string",
        keys: [
            "gen_ai.request.seed",
            "ai.seed"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "ai.seed"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.request.stop_sequences": {
        brief: "List of sequences that the model will use to stop generating further tokens.",
        type: "string[]",
        keys: [
            "gen_ai.request.stop_sequences"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "forest",
            "lived"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added gen_ai.request.stop_sequences attribute"
            }
        ]
    },
    "gen_ai.request.temperature": {
        brief: "For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.",
        type: "double",
        keys: [
            "gen_ai.request.temperature",
            "ai.temperature"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .1,
        aliases: [
            "ai.temperature"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_k": {
        brief: "Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).",
        type: "integer",
        keys: [
            "gen_ai.request.top_k",
            "ai.top_k"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 35,
        aliases: [
            "ai.top_k"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.request.top_p": {
        brief: "Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).",
        type: "double",
        keys: [
            "gen_ai.request.top_p",
            "ai.top_p"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .7,
        aliases: [
            "ai.top_p"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ]
    },
    "gen_ai.response.finish_reason": {
        brief: "The reason why the model stopped generating (singular form).",
        type: "string",
        keys: [
            "gen_ai.response.finish_reasons",
            "ai.finish_reason",
            "gen_ai.response.finish_reason"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "COMPLETE",
        deprecation: {
            replacement: "gen_ai.response.finish_reasons",
            status: "normalize"
        },
        aliases: [
            "gen_ai.response.finish_reasons"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    498
                ],
                description: "Added gen_ai.response.finish_reason attribute"
            }
        ]
    },
    "gen_ai.response.finish_reasons": {
        brief: "The reason why the model stopped generating.",
        type: "string",
        keys: [
            "gen_ai.response.finish_reasons",
            "ai.finish_reason",
            "gen_ai.response.finish_reason"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "COMPLETE",
        aliases: [
            "ai.finish_reason",
            "gen_ai.response.finish_reason"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.id": {
        brief: "Unique identifier for the completion.",
        type: "string",
        keys: [
            "gen_ai.response.id",
            "ai.generation_id",
            "ai.response.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gen_123abc",
        aliases: [
            "ai.generation_id",
            "ai.response.id"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.response.id as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.response.model": {
        brief: "The vendor-specific ID of the model used.",
        type: "string",
        keys: [
            "gen_ai.response.model",
            "ai.response.model"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "gpt-4",
        aliases: [
            "ai.response.model"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.response.model as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "gen_ai.response.object": {
        brief: "The type of the object returned by the model.",
        type: "string",
        keys: [
            "gen_ai.response.object"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "chat.completion",
        examples: [
            "chat.completion"
        ],
        deprecation: {
            reason: "This attribute is deprecated. The Sentry conventions have no replacement for the raw response object type."
        },
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added gen_ai.response.object attribute"
            }
        ]
    },
    "gen_ai.response.streaming": {
        brief: "Whether or not the AI model call's response was streamed back asynchronously",
        type: "boolean",
        keys: [
            "gen_ai.response.streaming",
            "ai.streaming"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "ai.streaming"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    76
                ]
            }
        ]
    },
    "gen_ai.response.text": {
        brief: "The model's response text messages. It has to be a stringified version of an array of response text messages.",
        type: "string",
        keys: [
            "gen_ai.response.text"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '["The weather in Paris is rainy and overcast, with temperatures around 57\xB0F", "The weather in London is sunny and warm, with temperatures around 65\xB0F"]',
        deprecation: {
            replacement: "gen_ai.output.messages",
            status: "transform",
            transformation: "gen_ai_response_to_output_messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.response.time_to_first_chunk": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        keys: [
            "gen_ai.response.time_to_first_chunk",
            "gen_ai.response.time_to_first_token"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: .6853435,
        aliases: [
            "gen_ai.response.time_to_first_token"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.response.time_to_first_chunk attribute"
            }
        ]
    },
    "gen_ai.response.time_to_first_token": {
        brief: "Time in seconds when the first response content chunk arrived in streaming responses.",
        type: "double",
        keys: [
            "gen_ai.response.time_to_first_chunk",
            "gen_ai.response.time_to_first_token"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .6853435,
        deprecation: {
            replacement: "gen_ai.response.time_to_first_chunk",
            status: "backfill"
        },
        aliases: [
            "gen_ai.response.time_to_first_chunk"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.response.time_to_first_chunk"
            },
            {
                version: "0.4.0",
                prs: [
                    227
                ]
            }
        ]
    },
    "gen_ai.response.tokens_per_second": {
        brief: "The total output tokens per seconds throughput",
        type: "double",
        keys: [
            "gen_ai.response.tokens_per_second"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345.67,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    66
                ]
            }
        ]
    },
    "gen_ai.response.tool_calls": {
        brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
        type: "string",
        keys: [
            "gen_ai.response.tool_calls"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
        deprecation: {
            replacement: "gen_ai.output.messages",
            status: "transform",
            transformation: "gen_ai_response_to_output_messages"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.system": {
        brief: "The provider of the model.",
        type: "string",
        keys: [
            "gen_ai.provider.name",
            "ai.model.provider",
            "gen_ai.system"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "openai",
        deprecation: {
            replacement: "gen_ai.provider.name",
            status: "normalize"
        },
        aliases: [
            "ai.model.provider",
            "gen_ai.provider.name"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    253
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.system_instructions": {
        brief: "The system instructions passed to the model.",
        type: "string",
        keys: [
            "gen_ai.system_instructions",
            "ai.preamble",
            "gen_ai.system.message"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "You are a helpful assistant",
        aliases: [
            "ai.preamble"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    264
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.system.message": {
        brief: "The system instructions passed to the model.",
        type: "string",
        keys: [
            "gen_ai.system_instructions",
            "ai.preamble",
            "gen_ai.system.message"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "You are a helpful assistant",
        deprecation: {
            replacement: "gen_ai.system_instructions",
            status: "backfill"
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.call.arguments": {
        brief: "The arguments of the tool call. It has to be a stringified version of the arguments to the tool.",
        type: "string",
        keys: [
            "gen_ai.tool.call.arguments",
            "ai.toolCall.args",
            "gen_ai.tool.input"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '{"location": "Paris"}',
        aliases: [
            "gen_ai.tool.input",
            "ai.toolCall.args"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.call.result": {
        brief: "The result of the tool call. It has to be a stringified version of the result of the tool.",
        type: "string",
        keys: [
            "gen_ai.tool.call.result",
            "ai.toolCall.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "rainy, 57\xB0F",
        aliases: [
            "gen_ai.tool.output",
            "gen_ai.tool.message",
            "mcp.tool.result.content",
            "ai.toolCall.result"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.definitions": {
        brief: "The list of source system tool definitions available to the GenAI agent or model.",
        type: "string",
        keys: [
            "gen_ai.tool.definitions",
            "ai.prompt.tools",
            "ai.tools",
            "gen_ai.request.available_tools"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
        aliases: [
            "gen_ai.request.available_tools"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    595
                ],
                description: "Added gen_ai.request.available_tools as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    221
                ]
            }
        ]
    },
    "gen_ai.tool.description": {
        brief: "The description of the tool being used.",
        type: "string",
        keys: [
            "gen_ai.tool.description"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Searches the web for current information about a topic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.input": {
        brief: "The input of the tool being used. It has to be a stringified version of the input to the tool.",
        type: "string",
        keys: [
            "gen_ai.tool.call.arguments",
            "ai.toolCall.args",
            "gen_ai.tool.input"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"location": "Paris"}',
        deprecation: {
            replacement: "gen_ai.tool.call.arguments",
            status: "normalize"
        },
        aliases: [
            "gen_ai.tool.call.arguments",
            "ai.toolCall.args"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.message": {
        brief: "The response from a tool or function call passed to the model.",
        type: "string",
        keys: [
            "gen_ai.tool.call.result",
            "ai.toolCall.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            status: "normalize"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.output",
            "mcp.tool.result.content",
            "ai.toolCall.result"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62
                ]
            }
        ]
    },
    "gen_ai.tool.name": {
        brief: "Name of the tool utilized by the agent.",
        type: "string",
        keys: [
            "gen_ai.tool.name",
            "ai.function_call",
            "mcp.tool.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Flights",
        aliases: [
            "ai.function_call",
            "mcp.tool.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    57,
                    127
                ]
            }
        ]
    },
    "gen_ai.tool.output": {
        brief: "The output of the tool being used. It has to be a stringified version of the output of the tool.",
        type: "string",
        keys: [
            "gen_ai.tool.call.result",
            "ai.toolCall.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rainy, 57\xB0F",
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            status: "normalize"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "mcp.tool.result.content",
            "ai.toolCall.result"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    265
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    63,
                    74
                ]
            }
        ]
    },
    "gen_ai.tool.type": {
        brief: "The type of tool being used.",
        type: "string",
        keys: [
            "gen_ai.tool.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "function",
        deprecation: {
            reason: "The gen_ai.tool.type attribute is deprecated and should no longer be set."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    62,
                    127
                ]
            }
        ]
    },
    "gen_ai.usage.cache_creation.input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        keys: [
            "gen_ai.usage.cache_creation.input_tokens",
            "gen_ai.usage.cache_creation_input_tokens",
            "gen_ai.usage.input_tokens.cache_write"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 100,
        aliases: [
            "gen_ai.usage.input_tokens.cache_write",
            "gen_ai.usage.cache_creation_input_tokens"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    582
                ],
                description: "Added gen_ai.usage.cache_creation_input_tokens as an alias"
            },
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_creation.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.cache_creation_input_tokens": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        keys: [
            "gen_ai.usage.cache_creation.input_tokens",
            "gen_ai.usage.cache_creation_input_tokens",
            "gen_ai.usage.input_tokens.cache_write"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        examples: [
            100
        ],
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens",
            reason: "This attribute is being deprecated in favor of gen_ai.usage.cache_creation.input_tokens.",
            status: "backfill"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens",
            "gen_ai.usage.input_tokens.cache_write"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    582
                ],
                description: "Added gen_ai.usage.cache_creation_input_tokens attribute"
            }
        ]
    },
    "gen_ai.usage.cache_read.input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        keys: [
            "gen_ai.usage.cache_read.input_tokens",
            "gen_ai.usage.cache_read_input_tokens",
            "gen_ai.usage.input_tokens.cached"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 50,
        aliases: [
            "gen_ai.usage.input_tokens.cached",
            "gen_ai.usage.cache_read_input_tokens"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    582
                ],
                description: "Added gen_ai.usage.cache_read_input_tokens as an alias"
            },
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.cache_read.input_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.cache_read_input_tokens": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        keys: [
            "gen_ai.usage.cache_read.input_tokens",
            "gen_ai.usage.cache_read_input_tokens",
            "gen_ai.usage.input_tokens.cached"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        examples: [
            50
        ],
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens",
            reason: "This attribute is being deprecated in favor of gen_ai.usage.cache_read.input_tokens.",
            status: "backfill"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens",
            "gen_ai.usage.input_tokens.cached"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    582
                ],
                description: "Added gen_ai.usage.cache_read_input_tokens attribute"
            }
        ]
    },
    "gen_ai.usage.completion_tokens": {
        brief: "The number of tokens used in the GenAI response (completion).",
        type: "integer",
        keys: [
            "gen_ai.usage.output_tokens",
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        deprecation: {
            replacement: "gen_ai.usage.output_tokens",
            status: "backfill"
        },
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.output_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.input_tokens": {
        brief: "The number of tokens used to process the AI input (prompt) including cached input tokens.",
        type: "integer",
        keys: [
            "gen_ai.usage.input_tokens",
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.input_tokens.cached": {
        brief: "The number of cached tokens used to process the AI input (prompt).",
        type: "integer",
        keys: [
            "gen_ai.usage.cache_read.input_tokens",
            "gen_ai.usage.cache_read_input_tokens",
            "gen_ai.usage.input_tokens.cached"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        deprecation: {
            replacement: "gen_ai.usage.cache_read.input_tokens",
            status: "backfill"
        },
        aliases: [
            "gen_ai.usage.cache_read.input_tokens",
            "gen_ai.usage.cache_read_input_tokens"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    582
                ],
                description: "Added gen_ai.usage.cache_read_input_tokens as an alias"
            },
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_read.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.input_tokens.cache_write": {
        brief: "The number of tokens written to the cache when processing the AI input (prompt).",
        type: "integer",
        keys: [
            "gen_ai.usage.cache_creation.input_tokens",
            "gen_ai.usage.cache_creation_input_tokens",
            "gen_ai.usage.input_tokens.cache_write"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        deprecation: {
            replacement: "gen_ai.usage.cache_creation.input_tokens",
            status: "backfill"
        },
        aliases: [
            "gen_ai.usage.cache_creation.input_tokens",
            "gen_ai.usage.cache_creation_input_tokens"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    582
                ],
                description: "Added gen_ai.usage.cache_creation_input_tokens as an alias"
            },
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.cache_creation.input_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    217,
                    228
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.output_tokens": {
        brief: "The number of tokens used for creating the AI output (including reasoning tokens).",
        type: "integer",
        keys: [
            "gen_ai.usage.output_tokens",
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        aliases: [
            "ai.completion_tokens.used",
            "gen_ai.usage.completion_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Update additional_context to reference gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.5.0",
                prs: [
                    261
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    112
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count \u2014 do not sum them together."
        ]
    },
    "gen_ai.usage.output_tokens.reasoning": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        keys: [
            "gen_ai.usage.reasoning.output_tokens",
            "gen_ai.usage.output_tokens.reasoning"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 75,
        deprecation: {
            replacement: "gen_ai.usage.reasoning.output_tokens",
            status: "backfill"
        },
        aliases: [
            "gen_ai.usage.reasoning.output_tokens"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Deprecate in favor of gen_ai.usage.reasoning.output_tokens"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    62,
                    112
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.prompt_tokens": {
        brief: "The number of tokens used in the GenAI input (prompt).",
        type: "integer",
        keys: [
            "gen_ai.usage.input_tokens",
            "ai.prompt_tokens.used",
            "gen_ai.usage.prompt_tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 20,
        deprecation: {
            replacement: "gen_ai.usage.input_tokens",
            status: "backfill"
        },
        aliases: [
            "ai.prompt_tokens.used",
            "gen_ai.usage.input_tokens"
        ],
        changelog: [
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans."
        ]
    },
    "gen_ai.usage.reasoning.output_tokens": {
        brief: "The number of tokens used for reasoning to create the AI output.",
        type: "integer",
        keys: [
            "gen_ai.usage.reasoning.output_tokens",
            "gen_ai.usage.output_tokens.reasoning"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 75,
        aliases: [
            "gen_ai.usage.output_tokens.reasoning"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    418
                ],
                description: "Added gen_ai.usage.reasoning.output_tokens attribute"
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens \u2014 it is already included."
        ]
    },
    "gen_ai.usage.total_tokens": {
        brief: "The total number of tokens used to process the prompt. (input tokens plus output todkens)",
        type: "integer",
        keys: [
            "gen_ai.usage.total_tokens",
            "ai.total_tokens.used",
            "ai.usage.tokens"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 20,
        aliases: [
            "ai.total_tokens.used",
            "ai.usage.tokens"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    583
                ],
                description: "Added ai.usage.tokens as an alias"
            },
            {
                version: "0.9.0",
                prs: [
                    397
                ],
                description: "Add additional_context"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    57
                ]
            }
        ],
        additionalContext: [
            "This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.",
            "This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them \u2014 they are already included."
        ]
    },
    "graphql.document": {
        brief: "The GraphQL document being executed.",
        type: "string",
        keys: [
            "graphql.document",
            "graphql.source"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible."
        },
        isInOtel: !0,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        aliases: [
            "graphql.source"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    584
                ],
                description: "Added graphql.source as an alias"
            },
            {
                version: "0.7.0",
                description: "Adds the `graphql.document` attribute to track the GraphQL document being executed."
            }
        ]
    },
    "graphql.operation.name": {
        brief: "The name of the operation being executed.",
        type: "string",
        keys: [
            "graphql.operation.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "findBookById",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.operation.type": {
        brief: "The type of the operation being executed.",
        type: "string",
        keys: [
            "graphql.operation.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "graphql.processing.type": {
        brief: "The type of processing represented by this span.",
        type: "string",
        keys: [
            "graphql.processing.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "parse",
        examples: [
            "parse",
            "validate",
            "execute",
            "resolve"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    572
                ],
                description: "Added graphql.processing.type attribute"
            }
        ],
        additionalContext: [
            "Well-known values are request, parse, validate, variable_coercion, plan, execute, subscription_event, step_execute, resolve, dataloader_dispatch, dataloader_batch and _OTHER. Use one of these if it applies, otherwise a custom value.",
            "Not to be confused with graphql.operation.type, which holds the GraphQL operation type (query, mutation, subscription) and only applies to spans that run an operation."
        ]
    },
    "graphql.source": {
        brief: "The GraphQL document being executed.",
        type: "string",
        keys: [
            "graphql.document",
            "graphql.source"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query findBookById { bookById(id: ?) { name } }",
        examples: [
            "query findBookById { bookById(id: ?) { name } }"
        ],
        deprecation: {
            replacement: "graphql.document",
            reason: "This attribute is being deprecated in favor of graphql.document, which is the OpenTelemetry name for the same value.",
            status: "backfill"
        },
        aliases: [
            "graphql.document"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    584
                ],
                description: "Added graphql.source attribute"
            }
        ]
    },
    "grpc.error.bad_request.field_violations": {
        brief: "The individual field violations from a google.rpc.BadRequest error detail. Each entry is a JSON-encoded object with field, description, reason, and (optional) localized_message keys, mirroring google.rpc.BadRequest.FieldViolation.",
        type: "string[]",
        keys: [
            "grpc.error.bad_request.field_violations"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            '{"field":"email","description":"must be a valid email address","reason":"FIELD_INVALID","localized_message":{"locale":"en-US","message":"Must be a valid email address"}}'
        ],
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.bad_request.field_violations attribute"
            }
        ]
    },
    "grpc.error.debug_info.detail": {
        brief: "Additional debugging information, such as a server-side stack trace, from a google.rpc.DebugInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly.",
        type: "string",
        keys: [
            "grpc.error.debug_info.detail"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "at com.example.Service.method(Service.java:42)",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.debug_info.detail attribute"
            }
        ]
    },
    "grpc.error.debug_info.stack_entries": {
        brief: "The server-side stack trace entries from a google.rpc.DebugInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly.",
        type: "string[]",
        keys: [
            "grpc.error.debug_info.stack_entries"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "com.example.Service.method(Service.java:42)",
            "com.example.Server.handle(Server.java:100)"
        ],
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.debug_info.stack_entries attribute"
            }
        ]
    },
    "grpc.error.error_info.domain": {
        brief: "The logical grouping to which the gRPC error reason belongs, from the google.rpc.ErrorInfo error detail.",
        type: "string",
        keys: [
            "grpc.error.error_info.domain"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.sentry.io",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.error_info.domain attribute"
            }
        ]
    },
    "grpc.error.error_info.metadata.<key>": {
        brief: "Additional structured metadata attached to a google.rpc.ErrorInfo error detail, with <key> being the metadata key name. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly.",
        type: "string",
        keys: [
            "grpc.error.error_info.metadata.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "grpc.error.error_info.metadata.user_id='123'",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.error_info.metadata.<key> attribute"
            }
        ]
    },
    "grpc.error.error_info.reason": {
        brief: "The reason for the gRPC error, as defined by the service that generated it, from the google.rpc.ErrorInfo error detail.",
        type: "string",
        keys: [
            "grpc.error.error_info.reason"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "FIELD_INVALID",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.error_info.reason attribute"
            }
        ]
    },
    "grpc.error.precondition_failure.violations": {
        brief: "The individual precondition violations from a google.rpc.PreconditionFailure error detail. Each entry is a JSON-encoded object with type, subject, and description keys. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly, since violation subjects may identify specific resources or users.",
        type: "string[]",
        keys: [
            "grpc.error.precondition_failure.violations"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            '{"type":"TOS","subject":"example.com/user/123","description":"User must accept the terms of service"}'
        ],
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.precondition_failure.violations attribute"
            }
        ]
    },
    "grpc.error.quota_failure.violations": {
        brief: "The individual quota violations from a google.rpc.QuotaFailure error detail. Each entry is a JSON-encoded object with subject, description, api_service, quota_metric, quota_id, quota_dimensions, quota_value, and (optional) future_quota_value keys, mirroring google.rpc.QuotaFailure.Violation. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly, since violation subjects may identify specific resources or users.",
        type: "string[]",
        keys: [
            "grpc.error.quota_failure.violations"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            '{"subject":"clientip:127.0.0.1","description":"Limit checks failed.","api_service":"example.googleapis.com","quota_metric":"example.googleapis.com/read_requests","quota_id":"ReadRequestsPerMinutePerProject","quota_dimensions":{"region":"us-central1"},"quota_value":1000}'
        ],
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.quota_failure.violations attribute"
            }
        ]
    },
    "grpc.error.resource_info.description": {
        brief: "A description of the error that occurred while accessing the resource, from a google.rpc.ResourceInfo error detail.",
        type: "string",
        keys: [
            "grpc.error.resource_info.description"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Instance is not ready for the request.",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.resource_info.description attribute"
            }
        ]
    },
    "grpc.error.resource_info.owner": {
        brief: "The owner of the resource being accessed (e.g. project or account owning it), from a google.rpc.ResourceInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly.",
        type: "string",
        keys: [
            "grpc.error.resource_info.owner"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user@example.com",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.resource_info.owner attribute"
            }
        ]
    },
    "grpc.error.resource_info.resource_name": {
        brief: "The name of the resource being accessed, from a google.rpc.ResourceInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly.",
        type: "string",
        keys: [
            "grpc.error.resource_info.resource_name"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "projects/example/instances/example-instance",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.resource_info.resource_name attribute"
            }
        ]
    },
    "grpc.error.resource_info.resource_type": {
        brief: "The type of resource being accessed, from a google.rpc.ResourceInfo error detail.",
        type: "string",
        keys: [
            "grpc.error.resource_info.resource_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "database",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.resource_info.resource_type attribute"
            }
        ]
    },
    "grpc.error.retry_info.retry_delay_ms": {
        brief: "How long the client should wait before retrying the gRPC call, in milliseconds, from the google.rpc.RetryInfo error detail.",
        type: "integer",
        keys: [
            "grpc.error.retry_info.retry_delay_ms"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 5e3,
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    460
                ],
                description: "Added grpc.error.retry_info.retry_delay_ms attribute"
            }
        ]
    },
    hardwareConcurrency: {
        brief: "The number of logical CPU cores available.",
        type: "string",
        keys: [
            "device.processor_count",
            "hardwareConcurrency"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "14",
        deprecation: {
            replacement: "device.processor_count",
            reason: "Old namespace-less attribute, to be replaced with device.processor_count for span-first future",
            status: "backfill"
        },
        aliases: [
            "device.processor_count"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    281,
                    300
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "http.client_ip": {
        brief: "Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        keys: [
            "client.address",
            "http.client_ip"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "client.address",
            status: "backfill"
        },
        aliases: [
            "client.address"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    106,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.decoded_response_content_length": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        keys: [
            "http.response.body.decoded_size",
            "http.decoded_response_content_length",
            "http.response_content_length_uncompressed"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.body.decoded_size",
            status: "backfill"
        },
        aliases: [
            "http.response.body.decoded_size",
            "http.response_content_length_uncompressed"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    574
                ],
                description: "Deprecated in favor of http.response.body.decoded_size"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "http.decoded_response_content_length",
            type: "byte"
        }
    },
    "http.flavor": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        keys: [
            "network.protocol.version",
            "http.flavor",
            "messaging.protocol_version",
            "net.protocol.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version",
            status: "backfill"
        },
        aliases: [
            "network.protocol.version",
            "net.protocol.version",
            "messaging.protocol_version"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.protocol_version as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.fragment": {
        brief: "The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.",
        type: "string",
        keys: [
            "http.fragment"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.host": {
        brief: "The domain name.",
        type: "string",
        keys: [
            "http.host"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use one of `server.address` or `client.address`, depending on the usage"
        },
        aliases: [
            "address",
            "server.address",
            "client.address",
            "http.server_name",
            "net.host.name",
            "server_name",
            "net.peer.name"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    647
                ],
                description: "Added server_name as an alias"
            },
            {
                version: "0.21.0",
                prs: [
                    588,
                    602
                ],
                description: "Added net.peer.name as an alias"
            },
            {
                version: "0.19.0",
                prs: [
                    534
                ],
                description: "Added address as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.method": {
        brief: "The HTTP method used.",
        type: "string",
        keys: [
            "http.request.method",
            "http.method",
            "http.request_method",
            "method"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method",
            status: "backfill"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.query": {
        brief: "The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.",
        type: "string",
        keys: [
            "http.query"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !1,
        visibility: "public",
        example: "?foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.body.data": {
        brief: "HTTP request body data. Can be given as string or structural data of any format.",
        type: "string",
        keys: [
            "http.request.body.data"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: '[{"role": "user", "message": "hello"}]',
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added http.request.body.data attribute"
            }
        ]
    },
    "http.request.body.decoded_size": {
        brief: "The decoded body size of the request (in bytes).",
        type: "integer",
        keys: [
            "http.request.body.decoded_size",
            "http.request_content_length_uncompressed"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        aliases: [
            "http.request_content_length_uncompressed"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    574
                ],
                description: "Added http.request.body.decoded_size attribute"
            }
        ],
        additionalContext: [
            "This is the size after content decoding. Set it only when the decoded size is actually known, for example by measuring a decompressed request stream.",
            "Do not derive this from the `content-length` header, which always carries the encoded size. Use `http.request.body.size` for that."
        ]
    },
    "http.request.body.size": {
        brief: "The encoded body size of the request (in bytes).",
        type: "integer",
        keys: [
            "http.request.body.size",
            "http.request_content_length"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.request_content_length"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    574
                ],
                description: "Added http.request.body.size attribute"
            }
        ],
        additionalContext: [
            "This is the on-the-wire (encoded) size. The `content-length` header always carries the encoded size, so set this attribute whenever `content-length` is known, regardless of whether `content-encoding` is present."
        ]
    },
    "http.request.connection_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.",
        type: "double",
        keys: [
            "http.request.connection_end"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955515e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.connect_start": {
        brief: "The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.",
        type: "double",
        keys: [
            "http.request.connect_start"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555111e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_content_length": {
        brief: "The encoded body size of the request (in bytes).",
        type: "integer",
        keys: [
            "http.request.body.size",
            "http.request_content_length"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.request.body.size",
            status: "backfill"
        },
        aliases: [
            "http.request.body.size"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    574
                ],
                description: "Added http.request_content_length attribute, deprecated in favor of http.request.body.size"
            }
        ]
    },
    "http.request_content_length_uncompressed": {
        brief: "The decoded body size of the request (in bytes).",
        type: "integer",
        keys: [
            "http.request.body.decoded_size",
            "http.request_content_length_uncompressed"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.request.body.decoded_size",
            status: "backfill"
        },
        aliases: [
            "http.request.body.decoded_size"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    574
                ],
                description: "Added http.request_content_length_uncompressed attribute, deprecated in favor of http.request.body.decoded_size"
            }
        ]
    },
    "http.request.domain_lookup_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.",
        type: "double",
        keys: [
            "http.request.domain_lookup_end"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555201e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.domain_lookup_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.",
        type: "double",
        keys: [
            "http.request.domain_lookup_start"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555322e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.fetch_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.",
        type: "double",
        keys: [
            "http.request.fetch_start"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555389e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.header.<key>": {
        brief: "HTTP request headers, <key> being the lower-cased, but otherwise unchanged HTTP Header name, the value being the header values.",
        type: "string[]",
        keys: [
            "http.request.header.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.request.header.custom-header=['foo', 'bar']",
        examples: [
            "http.request.header.custom-header=['foo', 'bar']",
            "http.request.header.content-length=['123']"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.request.method": {
        brief: "The HTTP method used.",
        type: "string",
        keys: [
            "http.request.method",
            "http.method",
            "http.request_method",
            "method"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "GET",
        aliases: [
            "method",
            "http.method",
            "http.request_method"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request_method": {
        brief: "The HTTP method used.",
        type: "string",
        keys: [
            "http.request.method",
            "http.method",
            "http.request_method",
            "method"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method",
            status: "backfill"
        },
        aliases: [
            "method",
            "http.method",
            "http.request.method"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    343
                ],
                description: "Added http.request_method attribute"
            }
        ]
    },
    "http.request.redirect_end": {
        brief: "The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect",
        type: "double",
        keys: [
            "http.request.redirect_end"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829558502e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.request.redirect_start": {
        brief: "The UNIX timestamp representing the start time of the fetch which that initiates the redirect.",
        type: "double",
        keys: [
            "http.request.redirect_start"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732829555495e-3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.request_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        keys: [
            "http.request.request_start"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955551e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.resend_count": {
        brief: "The ordinal number of request resending attempt (for any reason, including redirects).",
        type: "integer",
        keys: [
            "http.request.resend_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_end": {
        brief: "The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.",
        type: "double",
        keys: [
            "http.request.response_end"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955589e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.response_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.",
        type: "double",
        keys: [
            "http.request.response_start"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 17328295557e-1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        keys: [
            "http.request.same_origin",
            "url.same_origin"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        aliases: [
            "url.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added http.request.same_origin attribute"
            }
        ]
    },
    "http.request.secure_connection_start": {
        brief: "The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.",
        type: "double",
        keys: [
            "http.request.secure_connection_start"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955573e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    134
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.request.time_to_first_byte": {
        brief: "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
        type: "double",
        keys: [
            "http.request.time_to_first_byte"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.032,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    131
                ]
            }
        ]
    },
    "http.request.worker_start": {
        brief: "The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.",
        type: "double",
        keys: [
            "http.request.worker_start"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 173282955368e-2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    130,
                    134
                ]
            }
        ]
    },
    "http.response.body.decoded_size": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        keys: [
            "http.response.body.decoded_size",
            "http.decoded_response_content_length",
            "http.response_content_length_uncompressed"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        aliases: [
            "http.decoded_response_content_length",
            "http.response_content_length_uncompressed"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    574
                ],
                description: "Added http.response.body.decoded_size attribute"
            }
        ],
        additionalContext: [
            "This is the size after content decoding. Set it only when the decoded size is actually known, for example from the browser Resource Timing `decodedBodySize` or by measuring a decompressed response stream.",
            "Do not derive this from the `content-length` header, which always carries the encoded size. Use `http.response.body.size` for that."
        ]
    },
    "http.response.body.size": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        keys: [
            "http.response.body.size",
            "http.response.header.content-length",
            "http.response_content_length"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        aliases: [
            "http.response_content_length",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response_content_length": {
        brief: "The encoded body size of the response (in bytes).",
        type: "integer",
        keys: [
            "http.response.body.size",
            "http.response.header.content-length",
            "http.response_content_length"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 123,
        deprecation: {
            replacement: "http.response.body.size",
            status: "backfill"
        },
        aliases: [
            "http.response.body.size",
            "http.response.header.content-length"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    106
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "http.response_content_length",
            type: "byte"
        }
    },
    "http.response_content_length_uncompressed": {
        brief: "The decoded body size of the response (in bytes).",
        type: "integer",
        keys: [
            "http.response.body.decoded_size",
            "http.decoded_response_content_length",
            "http.response_content_length_uncompressed"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.body.decoded_size",
            status: "backfill"
        },
        aliases: [
            "http.response.body.decoded_size",
            "http.decoded_response_content_length"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    574
                ],
                description: "Added http.response_content_length_uncompressed attribute, deprecated in favor of http.response.body.decoded_size"
            }
        ]
    },
    "http.response.header.content-length": {
        brief: "The size of the message body sent to the recipient (in bytes)",
        type: "string",
        keys: [
            "http.response.header.content-length",
            "http.response.body.size",
            "http.response_content_length"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http.response.header.custom-header=['foo', 'bar']",
        aliases: [
            "http.response_content_length",
            "http.response.body.size"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.header.<key>": {
        brief: "HTTP response headers, <key> being the lower-cased, but otherwise unchanged HTTP Header name, the value being the header values.",
        type: "string[]",
        keys: [
            "http.response.header.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.custom-header=['foo', 'bar']",
        examples: [
            "http.response.header.custom-header=['foo', 'bar']",
            "http.response.header.content-length=['123']"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    201,
                    204
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "http.response.size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        keys: [
            "http.response.size",
            "http.response_transfer_size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 456,
        aliases: [
            "http.response_transfer_size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.response.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        keys: [
            "http.response.status_code",
            "http.response_status_code",
            "http.status_code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        aliases: [
            "http.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "http.response_status_code"
        }
    },
    "http.response.status_text": {
        brief: "The reason phrase of the HTTP response.",
        type: "string",
        keys: [
            "http.response.status_text",
            "http.status_text"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "NOT FOUND",
        aliases: [
            "http.status_text"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    574
                ],
                description: "Added http.response.status_text attribute"
            }
        ],
        additionalContext: [
            "HTTP/2 and HTTP/3 do not carry a reason phrase. Do not set this attribute when the protocol provides none; use `http.response.status_code` instead."
        ]
    },
    "http.response_transfer_size": {
        brief: "The transfer size of the response (in bytes).",
        type: "integer",
        keys: [
            "http.response.size",
            "http.response_transfer_size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 456,
        deprecation: {
            replacement: "http.response.size",
            status: "backfill"
        },
        aliases: [
            "http.response.size"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "http.response_transfer_size",
            type: "byte"
        }
    },
    "http.route": {
        brief: "The matched route, that is, the path template in the format used by the respective server framework.",
        type: "string",
        keys: [
            "http.route"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/:id",
        examples: [
            "/users/:id",
            "my-controller/my-action/{id}",
            "/posts"
        ],
        aliases: [
            "route"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    505,
                    521
                ],
                description: "Added multiple examples, removed alias to `url.template`, added additional context"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute should primarily be set by server-side instrumentation that captures the framework route of an incoming request.",
            "For `http.client` spans and client-side routing, use `url.template` instead."
        ]
    },
    "http.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        keys: [
            "url.scheme",
            "http.scheme"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        deprecation: {
            replacement: "url.scheme",
            status: "backfill"
        },
        aliases: [
            "url.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server_name": {
        brief: "The server domain name",
        type: "string",
        keys: [
            "server.address",
            "address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            status: "backfill"
        },
        aliases: [
            "address",
            "server.address",
            "net.host.name",
            "http.host",
            "server_name",
            "net.peer.name"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    647
                ],
                description: "Added server_name as an alias"
            },
            {
                version: "0.21.0",
                prs: [
                    588,
                    602
                ],
                description: "Added net.peer.name as an alias"
            },
            {
                version: "0.19.0",
                prs: [
                    534
                ],
                description: "Added address as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.server.request.time_in_queue": {
        brief: "The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.",
        type: "double",
        keys: [
            "http.server.request.time_in_queue"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    267
                ]
            }
        ]
    },
    "http.status_code": {
        brief: "The status code of the HTTP response.",
        type: "integer",
        keys: [
            "http.response.status_code",
            "http.response_status_code",
            "http.status_code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 404,
        deprecation: {
            replacement: "http.response.status_code",
            status: "backfill"
        },
        aliases: [
            "http.response.status_code"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.status_text": {
        brief: "The reason phrase of the HTTP response",
        type: "string",
        keys: [
            "http.response.status_text",
            "http.status_text"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "NOT FOUND",
        examples: [
            "NOT FOUND"
        ],
        deprecation: {
            replacement: "http.response.status_text",
            status: "backfill"
        },
        aliases: [
            "http.response.status_text"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    574
                ],
                description: "Added http.status_text attribute, deprecated in favor of http.response.status_text"
            }
        ]
    },
    "http.target": {
        brief: "The pathname and query string of the URL.",
        type: "string",
        keys: [
            "http.target"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/test?foo=bar#buzz",
        deprecation: {
            reason: "This attribute is being deprecated in favor of url.path, url.query and url.fragment. The value holds all three parts at once, so it has no single replacement."
        },
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    587
                ],
                description: "Documented url.path, url.query and url.fragment as the replacements for http.target"
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.url": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        keys: [
            "url.full",
            "aws.request.url",
            "http.url",
            "messaging.url",
            "url"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full",
            status: "backfill"
        },
        aliases: [
            "url.full",
            "url",
            "aws.request.url",
            "messaging.url"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.url as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "http.user_agent": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        keys: [
            "user_agent.original",
            "http.user_agent"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        deprecation: {
            replacement: "user_agent.original",
            status: "backfill"
        },
        aliases: [
            "user_agent.original"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    id: {
        brief: "A unique identifier for the span.",
        type: "string",
        keys: [
            "id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    inp: {
        brief: "The value of the recorded Interaction to Next Paint (INP) web vital",
        type: "double",
        keys: [
            "browser.web_vital.inp.value",
            "inp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        deprecation: {
            replacement: "browser.web_vital.inp.value",
            reason: "The INP web vital is now recorded as a browser.web_vital.inp.value attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.inp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "jsonrpc.protocol.version": {
        brief: "The version of the JSON-RPC protocol used.",
        type: "string",
        keys: [
            "jsonrpc.protocol.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.0",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.protocol.version attribute"
            }
        ]
    },
    "jsonrpc.request.id": {
        brief: "The JSON-RPC request identifier. Unique within the session.",
        type: "string",
        keys: [
            "jsonrpc.request.id",
            "mcp.request.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        aliases: [
            "mcp.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Added jsonrpc.request.id attribute"
            }
        ]
    },
    "jvm.gc.action": {
        brief: "Name of the garbage collector action.",
        type: "string",
        keys: [
            "jvm.gc.action"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "end of minor GC",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.gc.name": {
        brief: "Name of the garbage collector.",
        type: "string",
        keys: [
            "jvm.gc.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Young Generation",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.pool.name": {
        brief: "Name of the memory pool.",
        type: "string",
        keys: [
            "jvm.memory.pool.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.memory.type": {
        brief: "Name of the memory pool.",
        type: "string",
        keys: [
            "jvm.memory.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "G1 Old Gen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.daemon": {
        brief: "Whether the thread is daemon or not.",
        type: "boolean",
        keys: [
            "jvm.thread.daemon"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "jvm.thread.state": {
        brief: "State of the thread.",
        type: "string",
        keys: [
            "jvm.thread.state"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "blocked",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "koa.name": {
        brief: "The name of the Koa middleware or matched route that handled the request.",
        type: "string",
        keys: [
            "koa.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead."
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    490
                ],
                description: "Added koa.name attribute as deprecated"
            }
        ]
    },
    "koa.type": {
        brief: "The type of the Koa layer that handled the request.",
        type: "string",
        keys: [
            "koa.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    471
                ],
                description: "Added koa.type attribute"
            }
        ]
    },
    "langchain.chain.name": {
        brief: "The name of the LangChain chain being executed.",
        type: "string",
        keys: [
            "gen_ai.pipeline.name",
            "ai.pipeline.name",
            "langchain.chain.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "format_prompt",
        examples: [
            "format_prompt",
            "RunnableSequence"
        ],
        deprecation: {
            replacement: "gen_ai.pipeline.name",
            reason: "This attribute is being deprecated in favor of gen_ai.pipeline.name, which is the SDK-agnostic replacement for the name of the AI pipeline or chain being executed.",
            status: "backfill"
        },
        aliases: [
            "gen_ai.pipeline.name",
            "ai.pipeline.name"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    599
                ],
                description: "Added langchain.chain.name attribute"
            }
        ]
    },
    lcp: {
        brief: "The value of the recorded Largest Contentful Paint (LCP) web vital",
        type: "double",
        keys: [
            "browser.web_vital.lcp.value",
            "lcp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2500,
        deprecation: {
            replacement: "browser.web_vital.lcp.value",
            reason: "The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.lcp.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    229
                ],
                description: "Added and deprecated attribute to document JS SDK's current behaviour"
            }
        ]
    },
    "lcp.element": {
        brief: "The dom element responsible for the largest contentful paint.",
        type: "string",
        keys: [
            "browser.web_vital.lcp.element",
            "lcp.element"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        deprecation: {
            replacement: "browser.web_vital.lcp.element",
            reason: "The LCP element is now recorded as a browser.web_vital.lcp.element attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.lcp.element"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.id": {
        brief: "The id of the dom element responsible for the largest contentful paint.",
        type: "string",
        keys: [
            "browser.web_vital.lcp.id",
            "lcp.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "#hero",
        deprecation: {
            replacement: "browser.web_vital.lcp.id",
            reason: "The LCP id is now recorded as a browser.web_vital.lcp.id attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.lcp.id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.loadTime": {
        brief: "The time it took for the LCP element to be loaded",
        type: "integer",
        keys: [
            "browser.web_vital.lcp.load_time",
            "lcp.loadTime"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1402,
        deprecation: {
            replacement: "browser.web_vital.lcp.load_time",
            reason: "The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.lcp.load_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.renderTime": {
        brief: "The time it took for the LCP element to be rendered",
        type: "integer",
        keys: [
            "browser.web_vital.lcp.render_time",
            "lcp.renderTime"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1685,
        deprecation: {
            replacement: "browser.web_vital.lcp.render_time",
            reason: "The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.lcp.render_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            }
        ]
    },
    "lcp.size": {
        brief: "The size of the largest contentful paint element.",
        type: "integer",
        keys: [
            "browser.web_vital.lcp.size",
            "lcp.size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        deprecation: {
            replacement: "browser.web_vital.lcp.size",
            reason: "The LCP size is now recorded as a browser.web_vital.lcp.size attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.lcp.size"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "lcp.url": {
        brief: "The url of the dom element responsible for the largest contentful paint.",
        type: "string",
        keys: [
            "browser.web_vital.lcp.url",
            "lcp.url"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com",
        deprecation: {
            replacement: "browser.web_vital.lcp.url",
            reason: "The LCP url is now recorded as a browser.web_vital.lcp.url attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.lcp.url"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    233
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "litestar.middleware_name": {
        brief: "The name of the Litestar middleware.",
        type: "string",
        keys: [
            "middleware.name",
            "django.middleware_name",
            "litestar.middleware_name",
            "starlette.middleware_name",
            "starlite.middleware_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        deprecation: {
            replacement: "middleware.name",
            reason: "This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.",
            status: "backfill"
        },
        aliases: [
            "middleware.name"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    486
                ],
                description: "Added litestar.middleware_name attribute, deprecated in favor of middleware.name"
            }
        ]
    },
    "logger.name": {
        brief: "The name of the logger that generated this event.",
        type: "string",
        keys: [
            "logger.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myLogger",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "mcp.cancelled.reason": {
        brief: "Reason for the cancellation of an MCP operation.",
        type: "string",
        keys: [
            "mcp.cancelled.reason"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Cancellation reasons may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "User cancelled the request",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.cancelled.request_id": {
        brief: "Request ID of the cancelled MCP operation.",
        type: "string",
        keys: [
            "mcp.cancelled.request_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.name": {
        brief: "Name of the MCP client application.",
        type: "string",
        keys: [
            "mcp.client.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "claude-desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.title": {
        brief: "Display title of the MCP client application.",
        type: "string",
        keys: [
            "mcp.client.title"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Client titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Claude Desktop",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.client.version": {
        brief: "Version of the MCP client application.",
        type: "string",
        keys: [
            "mcp.client.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.lifecycle.phase": {
        brief: "Lifecycle phase indicator for MCP operations.",
        type: "string",
        keys: [
            "mcp.lifecycle.phase"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "initialization_complete",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.data_type": {
        brief: "Data type of the logged message content.",
        type: "string",
        keys: [
            "mcp.logging.data_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "string",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.level": {
        brief: "Log level for MCP logging operations.",
        type: "string",
        keys: [
            "mcp.logging.level"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "info",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.logger": {
        brief: "Logger name for MCP logging operations.",
        type: "string",
        keys: [
            "mcp.logging.logger"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Logger names may be user-defined and could contain sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "mcp_server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.logging.message": {
        brief: "Log message content from MCP logging operations.",
        type: "string",
        keys: [
            "mcp.logging.message"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "Log messages can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Tool execution completed successfully",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.method.name": {
        brief: "The name of the MCP request or notification method being called.",
        type: "string",
        keys: [
            "mcp.method.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tools/call",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.current": {
        brief: "Current progress value of an MCP operation.",
        type: "integer",
        keys: [
            "mcp.progress.current"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.message": {
        brief: "Progress message describing the current state of an MCP operation.",
        type: "string",
        keys: [
            "mcp.progress.message"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Progress messages may contain user-specific or sensitive information"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Processing 50 of 100 items",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.percentage": {
        brief: "Calculated progress percentage of an MCP operation. Computed from current/total * 100.",
        type: "double",
        keys: [
            "mcp.progress.percentage"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 50,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.token": {
        brief: "Token for tracking progress of an MCP operation.",
        type: "string",
        keys: [
            "mcp.progress.token"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "progress-token-123",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.progress.total": {
        brief: "Total progress target value of an MCP operation.",
        type: "integer",
        keys: [
            "mcp.progress.total"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.name": {
        brief: "Name of the MCP prompt template being used.",
        type: "string",
        keys: [
            "gen_ai.prompt.name",
            "mcp.prompt.name"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Prompt names may reveal user behavior patterns or sensitive operations"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        deprecation: {
            replacement: "gen_ai.prompt.name",
            reason: "OTel uses gen_ai.prompt.name for MCP prompt names",
            status: "backfill"
        },
        aliases: [
            "gen_ai.prompt.name"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.prompt.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.description": {
        brief: "Description of the prompt result.",
        type: "string",
        keys: [
            "mcp.prompt.result.description"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "A summary of the requested information",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_content": {
        brief: "Content of the message in the prompt result. Used for single message results only.",
        type: "string",
        keys: [
            "mcp.prompt.result.message_content"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Please provide a summary of the document",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_count": {
        brief: "Number of messages in the prompt result.",
        type: "integer",
        keys: [
            "mcp.prompt.result.message_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.prompt.result.message_role": {
        brief: "Role of the message in the prompt result. Used for single message results only.",
        type: "string",
        keys: [
            "mcp.prompt.result.message_role"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.ready": {
        brief: "Protocol readiness indicator for MCP session. Non-zero value indicates the protocol is ready.",
        type: "integer",
        keys: [
            "mcp.protocol.ready"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.protocol.version": {
        brief: "MCP protocol version used in the session.",
        type: "string",
        keys: [
            "mcp.protocol.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2024-11-05",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.<key>": {
        brief: "MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.",
        type: "string",
        keys: [
            "mcp.request.argument.<key>"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "Arguments contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mcp.request.argument.query='weather in Paris'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "mcp.request.argument.name": {
        brief: "Name argument from prompts/get MCP request.",
        type: "string",
        keys: [
            "mcp.request.argument.name"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "Prompt names can contain user input"
        },
        isInOtel: !1,
        visibility: "public",
        example: "summarize",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.argument.uri": {
        brief: "URI argument from resources/read MCP request.",
        type: "string",
        keys: [
            "mcp.request.argument.uri"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain user file paths"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file:///path/to/resource",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.request.id": {
        brief: "JSON-RPC request identifier for the MCP request. Unique within the MCP session.",
        type: "string",
        keys: [
            "jsonrpc.request.id",
            "mcp.request.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1",
        deprecation: {
            replacement: "jsonrpc.request.id",
            reason: "OTel models MCP as JSON-RPC, uses jsonrpc.request.id",
            status: "backfill"
        },
        aliases: [
            "jsonrpc.request.id"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of jsonrpc.request.id"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.protocol": {
        brief: "Protocol of the resource URI being accessed, extracted from the URI.",
        type: "string",
        keys: [
            "network.protocol.name",
            "mcp.resource.protocol",
            "messaging.protocol",
            "net.protocol.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "file",
        deprecation: {
            replacement: "network.protocol.name",
            reason: "OTel uses the generic network.protocol.name attribute",
            status: "backfill"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name",
            "messaging.protocol"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.protocol as an alias"
            },
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.protocol.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.resource.uri": {
        brief: "The resource URI being accessed in an MCP operation.",
        type: "string",
        keys: [
            "mcp.resource.uri"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "URIs can contain sensitive file paths"
        },
        isInOtel: !0,
        visibility: "public",
        example: "file:///path/to/file.txt",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.name": {
        brief: "Name of the MCP server application.",
        type: "string",
        keys: [
            "mcp.server.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry-mcp-server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.title": {
        brief: "Display title of the MCP server application.",
        type: "string",
        keys: [
            "mcp.server.title"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Server titles may reveal user-specific application configurations or custom setups"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Sentry MCP Server",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.server.version": {
        brief: "Version of the MCP server application.",
        type: "string",
        keys: [
            "mcp.server.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.session.id": {
        brief: "Identifier for the MCP session.",
        type: "string",
        keys: [
            "mcp.session.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "550e8400-e29b-41d4-a716-446655440000",
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Set is_in_otel=true, attribute exists in OTel MCP registry"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.name": {
        brief: "Name of the MCP tool being called.",
        type: "string",
        keys: [
            "gen_ai.tool.name",
            "ai.function_call",
            "mcp.tool.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "calculator",
        deprecation: {
            replacement: "gen_ai.tool.name",
            reason: "OTel uses gen_ai.tool.name for MCP tool names",
            status: "backfill"
        },
        aliases: [
            "gen_ai.tool.name",
            "ai.function_call"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.name"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.content": {
        brief: "The content of the tool result.",
        type: "string",
        keys: [
            "gen_ai.tool.call.result",
            "ai.toolCall.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output",
            "mcp.tool.result.content"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "Tool results can contain user data"
        },
        isInOtel: !1,
        visibility: "public",
        example: '{"output": "rainy", "toolCallId": "1"}',
        deprecation: {
            replacement: "gen_ai.tool.call.result",
            reason: "OTel uses gen_ai.tool.call.result for MCP tool results",
            status: "backfill"
        },
        aliases: [
            "gen_ai.tool.call.result",
            "gen_ai.tool.message",
            "gen_ai.tool.output",
            "ai.toolCall.result"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of gen_ai.tool.call.result"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    164
                ]
            }
        ]
    },
    "mcp.tool.result.content_count": {
        brief: "Number of content items in the tool result.",
        type: "integer",
        keys: [
            "mcp.tool.result.content_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.tool.result.is_error": {
        brief: "Whether a tool execution resulted in an error.",
        type: "boolean",
        keys: [
            "mcp.tool.result.is_error"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !1,
        deprecation: {
            replacement: "error.type",
            reason: "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string)."
        },
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of error.type"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mcp.transport": {
        brief: "Transport method used for MCP communication.",
        type: "string",
        keys: [
            "network.transport",
            "mcp.transport"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdio",
        deprecation: {
            replacement: "network.transport",
            reason: "OTel uses the generic network.transport attribute",
            status: "backfill"
        },
        aliases: [
            "network.transport",
            "net.transport"
        ],
        changelog: [
            {
                version: "0.12.0",
                prs: [
                    420
                ],
                description: "Deprecated in favor of network.transport"
            },
            {
                version: "0.3.0",
                prs: [
                    171
                ]
            }
        ]
    },
    "mdc.<key>": {
        brief: "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
        type: "string",
        keys: [
            "mdc.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "mdc.some_key='some_value'",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    176
                ]
            }
        ]
    },
    "messaging.batch.message_count": {
        brief: "The number of messages sent, received, or processed in the scope of the batching operation.",
        type: "integer",
        keys: [
            "messaging.batch.message_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 10,
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    341
                ],
                description: "Added messaging.batch.message_count attribute"
            }
        ]
    },
    "messaging.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        keys: [
            "messaging.message.conversation_id",
            "messaging.conversation_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyConversationId",
        examples: [
            "MyConversationId"
        ],
        deprecation: {
            replacement: "messaging.message.conversation_id",
            reason: "This attribute is being deprecated in favor of messaging.message.conversation_id.",
            status: "backfill"
        },
        aliases: [
            "messaging.message.conversation_id"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.conversation_id attribute"
            }
        ]
    },
    "messaging.destination": {
        brief: "The message destination name.",
        type: "string",
        keys: [
            "messaging.destination.name",
            "messaging.destination"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        deprecation: {
            replacement: "messaging.destination.name",
            reason: "This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement.",
            status: "backfill"
        },
        aliases: [
            "messaging.destination.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination attribute, deprecated in favor of messaging.destination.name"
            }
        ]
    },
    "messaging.destination.connection": {
        brief: "The message destination connection.",
        type: "string",
        keys: [
            "messaging.destination.connection"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "BestTopic",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination_kind": {
        brief: "The kind of message destination.",
        type: "string",
        keys: [
            "messaging.destination_kind"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "topic",
        deprecation: {
            reason: "Deprecated from OTEL, which now models the destination kind via messaging.operation.type and messaging.destination.name."
        },
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    509
                ],
                description: "Added deprecated messaging.destination_kind attribute for parity with legacy OTel instrumentations."
            }
        ]
    },
    "messaging.destination.name": {
        brief: "The message destination name.",
        type: "string",
        keys: [
            "messaging.destination.name",
            "messaging.destination"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "BestTopic",
        aliases: [
            "messaging.destination"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added messaging.destination as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.destination.partition.id": {
        brief: "The identifier of the partition messages are sent to or received from, unique within the messaging.destination.name.",
        type: "string",
        keys: [
            "messaging.destination.partition.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1",
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    474
                ],
                description: "Added messaging.destination.partition.id attribute"
            }
        ]
    },
    "messaging.kafka.message.key": {
        brief: "Message keys in Kafka are used for grouping alike messages to ensure they're processed on the same partition. They differ from messaging.message.id in that they're not unique. If the key is null, the attribute MUST NOT be set.",
        type: "string",
        keys: [
            "messaging.kafka.message.key"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    474
                ],
                description: "Added messaging.kafka.message.key attribute"
            }
        ]
    },
    "messaging.kafka.message.tombstone": {
        brief: "A boolean that is true if the message is a tombstone.",
        type: "boolean",
        keys: [
            "messaging.kafka.message.tombstone"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    474
                ],
                description: "Added messaging.kafka.message.tombstone attribute"
            }
        ]
    },
    "messaging.kafka.offset": {
        brief: "The offset of a record in the corresponding Kafka partition.",
        type: "integer",
        keys: [
            "messaging.kafka.offset"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 42,
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    474
                ],
                description: "Added messaging.kafka.offset attribute"
            }
        ]
    },
    "messaging.message.body.size": {
        brief: "The size of the message body in bytes.",
        type: "integer",
        keys: [
            "messaging.message.body.size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 839,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "messaging.message.body.size",
            type: "byte"
        }
    },
    "messaging.message.conversation_id": {
        brief: 'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
        type: "string",
        keys: [
            "messaging.message.conversation_id",
            "messaging.conversation_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "MyConversationId",
        aliases: [
            "messaging.conversation_id"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.conversation_id as an alias"
            },
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.message.conversation_id attribute"
            }
        ]
    },
    "messaging.message.envelope.size": {
        brief: "The size of the message body and metadata in bytes.",
        type: "integer",
        keys: [
            "messaging.message.envelope.size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1045,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message.id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        keys: [
            "messaging.message.id",
            "messaging.message_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "f47ac10b58cc4372a5670e02b2c3d479",
        aliases: [
            "messaging.message_id"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.message_id as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.message_id": {
        brief: "A value used by the messaging system as an identifier for the message, represented as a string.",
        type: "string",
        keys: [
            "messaging.message.id",
            "messaging.message_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "452a7c7c7c7048c2f887f0e7",
        examples: [
            "452a7c7c7c7048c2f887f0e7"
        ],
        deprecation: {
            replacement: "messaging.message.id",
            reason: "This attribute is being deprecated in favor of messaging.message.id.",
            status: "backfill"
        },
        aliases: [
            "messaging.message.id"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.message_id attribute"
            }
        ]
    },
    "messaging.message.receive.latency": {
        brief: "The latency between when the message was published and received.",
        type: "integer",
        keys: [
            "messaging.message.receive.latency"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1732847252,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "messaging.message.receive.latency",
            type: "millisecond"
        }
    },
    "messaging.message.retry.count": {
        brief: "The amount of attempts to send the message.",
        type: "integer",
        keys: [
            "messaging.message.retry.count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.operation": {
        brief: "The name of the messaging operation being performed.",
        type: "string",
        keys: [
            "messaging.operation.name",
            "messaging.operation"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "publish",
        examples: [
            "publish"
        ],
        deprecation: {
            replacement: "messaging.operation.name",
            reason: "This attribute is being deprecated in favor of messaging.operation.name.",
            status: "backfill"
        },
        aliases: [
            "messaging.operation.name"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.operation attribute"
            }
        ]
    },
    "messaging.operation.name": {
        brief: "The name of the messaging operation being performed",
        type: "string",
        keys: [
            "messaging.operation.name",
            "messaging.operation"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "send",
        aliases: [
            "messaging.operation"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.operation as an alias"
            },
            {
                version: "0.11.0",
                prs: [
                    392
                ],
                description: "Added messaging.operation.name attribute"
            }
        ]
    },
    "messaging.operation.type": {
        brief: "A string identifying the type of the messaging operation",
        type: "string",
        keys: [
            "messaging.operation.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "create",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    51,
                    127
                ]
            }
        ]
    },
    "messaging.protocol": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        keys: [
            "network.protocol.name",
            "mcp.resource.protocol",
            "messaging.protocol",
            "net.protocol.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AMQP",
        examples: [
            "AMQP"
        ],
        deprecation: {
            replacement: "network.protocol.name",
            reason: "This attribute is being deprecated in favor of network.protocol.name.",
            status: "backfill"
        },
        aliases: [
            "network.protocol.name",
            "net.protocol.name",
            "mcp.resource.protocol"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.protocol attribute"
            }
        ]
    },
    "messaging.protocol_version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        keys: [
            "network.protocol.version",
            "http.flavor",
            "messaging.protocol_version",
            "net.protocol.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "0.9.1",
        examples: [
            "0.9.1"
        ],
        deprecation: {
            replacement: "network.protocol.version",
            reason: "This attribute is being deprecated in favor of network.protocol.version.",
            status: "backfill"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor",
            "net.protocol.version"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.protocol_version attribute"
            }
        ]
    },
    "messaging.rabbitmq.destination.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        keys: [
            "messaging.rabbitmq.destination.routing_key",
            "messaging.rabbitmq.routing_key"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myKey",
        aliases: [
            "messaging.rabbitmq.routing_key"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.rabbitmq.routing_key as an alias"
            },
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added messaging.rabbitmq.destination.routing_key attribute"
            }
        ]
    },
    "messaging.rabbitmq.routing_key": {
        brief: "RabbitMQ message routing key.",
        type: "string",
        keys: [
            "messaging.rabbitmq.destination.routing_key",
            "messaging.rabbitmq.routing_key"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "myKey",
        examples: [
            "myKey"
        ],
        deprecation: {
            replacement: "messaging.rabbitmq.destination.routing_key",
            reason: "This attribute is being deprecated in favor of messaging.rabbitmq.destination.routing_key.",
            status: "backfill"
        },
        aliases: [
            "messaging.rabbitmq.destination.routing_key"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.rabbitmq.routing_key attribute"
            }
        ]
    },
    "messaging.system": {
        brief: "The messaging system as identified by the client instrumentation.",
        type: "string",
        keys: [
            "messaging.system"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "activemq",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "messaging.url": {
        brief: "The connection string of the messaging broker.",
        type: "string",
        keys: [
            "url.full",
            "aws.request.url",
            "http.url",
            "messaging.url",
            "url"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "amqp://guest:guest@localhost:5672",
        examples: [
            "amqp://guest:guest@localhost:5672"
        ],
        deprecation: {
            replacement: "url.full",
            reason: "This attribute is being deprecated in favor of url.full.",
            status: "backfill"
        },
        aliases: [
            "url.full",
            "http.url",
            "url",
            "aws.request.url"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.url attribute"
            }
        ]
    },
    method: {
        brief: "The HTTP method used.",
        type: "string",
        keys: [
            "http.request.method",
            "http.method",
            "http.request_method",
            "method"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        deprecation: {
            replacement: "http.request.method",
            status: "normalize"
        },
        aliases: [
            "http.request.method",
            "http.request_method",
            "http.method"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    497
                ],
                description: "Configured normalization"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "middleware.name": {
        brief: "The name of the middleware.",
        type: "string",
        keys: [
            "middleware.name",
            "django.middleware_name",
            "litestar.middleware_name",
            "starlette.middleware_name",
            "starlite.middleware_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        aliases: [
            "django.middleware_name",
            "starlite.middleware_name",
            "litestar.middleware_name",
            "starlette.middleware_name"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    485,
                    486,
                    519,
                    520
                ],
                description: "Added django.middleware_name, starlite.middleware_name, litestar.middleware_name and starlette.middleware_name as aliases"
            },
            {
                version: "0.6.0",
                prs: [
                    336
                ],
                description: "Added middleware.name attribute"
            }
        ]
    },
    "navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        keys: [
            "router.navigation.origin",
            "navigation.origin",
            "sentry.sveltekit.navigation.from"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            replacement: "router.navigation.origin",
            reason: "Moved to the router.* namespace to separate client-side router navigations from browser navigations.",
            status: "backfill"
        },
        aliases: [
            "router.navigation.origin",
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    600
                ],
                description: "Deprecated in favor of router.navigation.origin"
            },
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added navigation.origin attribute"
            }
        ]
    },
    "navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        keys: [
            "router.navigation.route.id",
            "navigation.route.id"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        deprecation: {
            replacement: "router.navigation.route.id",
            reason: "Moved to the router.* namespace to separate client-side router navigations from browser navigations.",
            status: "backfill"
        },
        aliases: [
            "router.navigation.route.id"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    600
                ],
                description: "Deprecated in favor of router.navigation.route.id"
            },
            {
                version: "0.16.0",
                prs: [
                    468
                ],
                description: "Added navigation.route.id attribute"
            }
        ]
    },
    "navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        keys: [
            "router.navigation.type",
            "navigation.type",
            "sentry.sveltekit.navigation.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        deprecation: {
            replacement: "router.navigation.type",
            reason: "Moved to the router.* namespace to separate client-side router navigations from browser navigations.",
            status: "backfill"
        },
        aliases: [
            "router.navigation.type",
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    600
                ],
                description: "Deprecated in favor of router.navigation.type"
            },
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added new deprecated alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "nel.elapsed_time": {
        brief: "The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.",
        type: "integer",
        keys: [
            "nel.elapsed_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.phase": {
        brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
        type: "string",
        keys: [
            "nel.phase"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "application",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.referrer": {
        brief: "request's referrer, as determined by the referrer policy associated with its client.",
        type: "string",
        keys: [
            "nel.referrer"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/foo?bar=baz",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "nel.sampling_function": {
        brief: "The sampling function used to determine if the request should be sampled.",
        type: "double",
        keys: [
            "nel.sampling_function"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            }
        ]
    },
    "nel.type": {
        brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
        type: "string",
        keys: [
            "nel.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dns.unreachable",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68,
                    127
                ]
            }
        ]
    },
    "network.connection.effective_type": {
        brief: "Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).",
        type: "string",
        keys: [
            "network.connection.effective_type",
            "effectiveConnectionType"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "4g",
        aliases: [
            "effectiveConnectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.effective_type to be used instead of effectiveConnectionType"
            }
        ]
    },
    "network.connection.rtt": {
        brief: "Specifies the estimated effective round-trip time of the current connection, in milliseconds.",
        type: "integer",
        keys: [
            "network.connection.rtt",
            "connection.rtt"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 100,
        aliases: [
            "connection.rtt"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.rtt to be used instead of connection.rtt"
            }
        ]
    },
    "network.connection.type": {
        brief: "Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).",
        type: "string",
        keys: [
            "network.connection.type",
            "connectionType",
            "device.connection_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "wifi",
        aliases: [
            "device.connection_type",
            "connectionType"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    279
                ],
                description: "Added attribute network.connection.type to be used instead of connectionType"
            }
        ]
    },
    "network.local.address": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        keys: [
            "network.local.address",
            "net.host.ip",
            "net.sock.host.addr"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        examples: [
            "10.1.2.80",
            "/var/run/my.sock"
        ],
        aliases: [
            "net.host.ip",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.local.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        keys: [
            "network.local.port",
            "net.sock.host.port"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.host.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.address": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        keys: [
            "network.peer.address",
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "10.1.2.80",
        aliases: [
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        keys: [
            "network.peer.port",
            "net.sock.peer.port"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 65400,
        aliases: [
            "net.sock.peer.port"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    588
                ],
                description: "Added net.sock.peer.port as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        keys: [
            "network.protocol.name",
            "mcp.resource.protocol",
            "messaging.protocol",
            "net.protocol.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        aliases: [
            "net.protocol.name",
            "mcp.resource.protocol",
            "messaging.protocol"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.protocol as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        keys: [
            "network.protocol.version",
            "http.flavor",
            "messaging.protocol_version",
            "net.protocol.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        aliases: [
            "http.flavor",
            "net.protocol.version",
            "messaging.protocol_version"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.protocol_version as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        keys: [
            "network.transport",
            "mcp.transport"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        aliases: [
            "net.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "network.type": {
        brief: "OSI network layer or non-OSI equivalent.",
        type: "string",
        keys: [
            "network.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "ipv4",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.ip": {
        brief: "Local address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        keys: [
            "network.local.address",
            "net.host.ip",
            "net.sock.host.addr"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.local.address",
            status: "backfill"
        },
        aliases: [
            "network.local.address",
            "net.sock.host.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        keys: [
            "server.address",
            "address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            status: "backfill"
        },
        aliases: [
            "address",
            "server.address",
            "http.server_name",
            "http.host",
            "server_name",
            "net.peer.name"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    647
                ],
                description: "Added server_name as an alias"
            },
            {
                version: "0.21.0",
                prs: [
                    588,
                    602
                ],
                description: "Added net.peer.name as an alias"
            },
            {
                version: "0.19.0",
                prs: [
                    534
                ],
                description: "Added address as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.host.port": {
        brief: "Server port number.",
        type: "integer",
        keys: [
            "server.port",
            "net.host.port",
            "port"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            status: "backfill"
        },
        aliases: [
            "server.port",
            "port"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    532
                ],
                description: "Added port as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.ip": {
        brief: "Peer address of the network connection - IP address or Unix domain socket name.",
        type: "string",
        keys: [
            "network.peer.address",
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address",
            status: "backfill"
        },
        aliases: [
            "network.peer.address",
            "net.sock.peer.addr"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.name": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        keys: [
            "net.peer.name"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "Deprecated, use server.address on client spans and client.address on server spans."
        },
        aliases: [
            "address",
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    647
                ],
                description: "Added server_name as an alias"
            },
            {
                version: "0.21.0",
                prs: [
                    588,
                    602
                ],
                description: "Added the server.address alias group to net.peer.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.peer.port": {
        brief: "Peer port number.",
        type: "integer",
        keys: [
            "net.peer.port"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        deprecation: {
            replacement: "server.port",
            reason: "Deprecated, use server.port on client spans and client.port on server spans."
        },
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.name": {
        brief: "OSI application layer or non-OSI equivalent.",
        type: "string",
        keys: [
            "network.protocol.name",
            "mcp.resource.protocol",
            "messaging.protocol",
            "net.protocol.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "http",
        deprecation: {
            replacement: "network.protocol.name",
            status: "backfill"
        },
        aliases: [
            "network.protocol.name",
            "mcp.resource.protocol",
            "messaging.protocol"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.protocol as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.protocol.version": {
        brief: "The actual version of the protocol used for network communication.",
        type: "string",
        keys: [
            "network.protocol.version",
            "http.flavor",
            "messaging.protocol_version",
            "net.protocol.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1.1",
        deprecation: {
            replacement: "network.protocol.version",
            status: "backfill"
        },
        aliases: [
            "network.protocol.version",
            "http.flavor",
            "messaging.protocol_version"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.protocol_version as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.family": {
        brief: "OSI transport and network layer",
        type: "string",
        keys: [
            "net.sock.family"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "inet",
        deprecation: {
            replacement: "network.transport",
            reason: "Deprecated, use network.transport and network.type."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.addr": {
        brief: "Local address of the network connection mapping to Unix domain socket name.",
        type: "string",
        keys: [
            "network.local.address",
            "net.host.ip",
            "net.sock.host.addr"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            replacement: "network.local.address",
            status: "backfill"
        },
        aliases: [
            "network.local.address",
            "net.host.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.host.port": {
        brief: "Local port number of the network connection.",
        type: "integer",
        keys: [
            "network.local.port",
            "net.sock.host.port"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.local.port",
            status: "backfill"
        },
        aliases: [
            "network.local.port"
        ],
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.addr": {
        brief: "Peer address of the network connection - IP address",
        type: "string",
        keys: [
            "network.peer.address",
            "net.peer.ip",
            "net.sock.peer.addr"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "192.168.0.1",
        deprecation: {
            replacement: "network.peer.address",
            status: "backfill"
        },
        aliases: [
            "network.peer.address",
            "net.peer.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.name": {
        brief: "Peer address of the network connection - Unix domain socket name",
        type: "string",
        keys: [
            "net.sock.peer.name"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/var/my.sock",
        deprecation: {
            reason: "Deprecated from OTEL, no replacement at this time"
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    119,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.sock.peer.port": {
        brief: "Peer port number of the network connection.",
        type: "integer",
        keys: [
            "network.peer.port",
            "net.sock.peer.port"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 8080,
        deprecation: {
            replacement: "network.peer.port",
            status: "backfill"
        },
        aliases: [
            "network.peer.port"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    588
                ],
                description: "Added network.peer.port as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "net.transport": {
        brief: "OSI transport layer or inter-process communication method.",
        type: "string",
        keys: [
            "net.transport"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "tcp",
        deprecation: {
            replacement: "network.transport",
            reason: "This attribute is being deprecated in favor of network.transport. The values change from ip_tcp and ip_udp to tcp and udp, so the old value cannot be copied over."
        },
        aliases: [
            "network.transport",
            "mcp.transport"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    588
                ],
                description: "Set net.transport to _status null, because its values change on the replacement"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.build": {
        brief: "The build ID of the operating system.",
        type: "string",
        keys: [
            "os.build_id",
            "os.build"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1234567890",
        deprecation: {
            replacement: "os.build_id",
            status: "backfill"
        },
        aliases: [
            "os.build_id"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build attribute, deprecated in favor of os.build_id"
            }
        ]
    },
    "os.build_id": {
        brief: "The build ID of the operating system.",
        type: "string",
        keys: [
            "os.build_id",
            "os.build"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "1234567890",
        aliases: [
            "os.build"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.build as alias"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.description": {
        brief: "Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.",
        type: "string",
        keys: [
            "os.description"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu 18.04.1 LTS",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.kernel_version": {
        brief: "An independent kernel version string. Typically the entire output of the `uname` syscall.",
        type: "string",
        keys: [
            "os.kernel_version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "20.2.0",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.kernel_version attribute"
            }
        ]
    },
    "os.name": {
        brief: "Human readable operating system name.",
        type: "string",
        keys: [
            "os.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Ubuntu",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.raw_description": {
        brief: "An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.",
        type: "string",
        keys: [
            "os.raw_description"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ubuntu 22.04.4 LTS (Jammy Jellyfish)",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.raw_description attribute"
            }
        ]
    },
    "os.rooted": {
        brief: "Whether the operating system has been jailbroken or rooted.",
        type: "boolean",
        keys: [
            "os.rooted"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.rooted attribute"
            }
        ]
    },
    "os.theme": {
        brief: "Whether the OS runs in dark mode or light mode.",
        type: "string",
        keys: [
            "os.theme"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dark",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    301
                ],
                description: "Added os.theme attribute"
            }
        ]
    },
    "os.type": {
        brief: "The operating system type.",
        type: "string",
        keys: [
            "os.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "linux",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "os.version": {
        brief: "The version of the operating system.",
        type: "string",
        keys: [
            "os.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.kind": {
        brief: "The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.",
        type: "string",
        keys: [
            "sentry.kind",
            "span.kind",
            "otel.kind"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SERVER",
        deprecation: {
            replacement: "sentry.kind",
            reason: "Deprecated in favor of sentry.kind",
            status: "backfill"
        },
        aliases: [
            "sentry.kind"
        ],
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    440
                ],
                description: "Added otel.kind attribute"
            }
        ]
    },
    "otel.scope.name": {
        brief: "The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).",
        type: "string",
        keys: [
            "otel.scope.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "io.opentelemetry.contrib.mongodb",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.scope.version": {
        brief: "The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).",
        type: "string",
        keys: [
            "otel.scope.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "2.4.5",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_code": {
        brief: "Name of the code, either \u201COK\u201D or \u201CERROR\u201D. MUST NOT be set if the status code is UNSET.",
        type: "string",
        keys: [
            "otel.status_code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "OK",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "otel.status_description": {
        brief: "Description of the Status if it has a value, otherwise not set.",
        type: "string",
        keys: [
            "otel.status_description"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "resource not found",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        keys: [
            "params.<key>",
            "url.path.parameter.<key>",
            "url.path.params.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "params.id='123'",
        aliases: [
            "url.path.parameter.<key>",
            "url.path.params.<key>"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    586
                ],
                description: "Added url.path.params.<key> as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "performance.activationStart": {
        brief: "The time between initiating a navigation to a page and the browser activating the page",
        type: "double",
        keys: [
            "browser.performance.navigation.activation_start",
            "performance.activationStart"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1.983,
        deprecation: {
            replacement: "browser.performance.navigation.activation_start",
            reason: "The activationStart is now recorded as the browser.performance.navigation.activation_start attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.performance.navigation.activation_start"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.activationStart attribute"
            }
        ]
    },
    "performance.timeOrigin": {
        brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
        type: "double",
        keys: [
            "browser.performance.time_origin",
            "performance.timeOrigin"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1776185678886e-3,
        deprecation: {
            replacement: "browser.performance.time_origin",
            reason: "The timeOrigin is now recorded as the browser.performance.time_origin attribute.",
            status: "backfill"
        },
        aliases: [
            "browser.performance.time_origin"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    321
                ],
                description: "Added performance.timeOrigin attribute"
            }
        ]
    },
    port: {
        brief: "The destination port for a TCP connection.",
        type: "integer",
        keys: [
            "server.port",
            "net.host.port",
            "port"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1337,
        examples: [
            1337
        ],
        deprecation: {
            replacement: "server.port",
            reason: "Old namespace-less attribute, to be replaced with server.port for span-first future",
            status: "backfill"
        },
        aliases: [
            "server.port",
            "net.host.port"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    532
                ],
                description: "Added port attribute"
            }
        ]
    },
    previous_route: {
        brief: "Also used by mobile SDKs to indicate the previous route in the application.",
        type: "string",
        keys: [
            "previous_route"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeScreen",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.command_args": {
        brief: "All the command arguments (including the command/executable itself) as received by the process.",
        type: "string[]",
        keys: [
            "process.command_args"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "cmd/otecol",
            "--config=config.yaml"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    327
                ],
                description: "Added process.command_args attribute"
            }
        ]
    },
    "process.executable.name": {
        brief: "The name of the executable that started the process.",
        type: "string",
        keys: [
            "process.executable.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "getsentry",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.pid": {
        brief: "The process ID of the running process.",
        type: "integer",
        keys: [
            "process.pid",
            "subprocess.pid"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 12345,
        aliases: [
            "subprocess.pid"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    487
                ],
                description: "Added subprocess.pid as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.description": {
        brief: "An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.",
        type: "string",
        keys: [
            "process.runtime.description",
            "runtime.raw_description"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        aliases: [
            "runtime.raw_description"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.name": {
        brief: "The name of the runtime engine.",
        type: "string",
        keys: [
            "process.runtime.engine.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "v8",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.engine.version": {
        brief: "The version of the runtime engine.",
        type: "string",
        keys: [
            "process.runtime.engine.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "12.9.202.13-rusty",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.name": {
        brief: "The name of the runtime. Equivalent to `name` in the Sentry runtime context.",
        type: "string",
        keys: [
            "process.runtime.name",
            "runtime.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "node",
        aliases: [
            "runtime.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "process.runtime.version": {
        brief: "The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.",
        type: "string",
        keys: [
            "process.runtime.version",
            "runtime.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "18.04.2",
        aliases: [
            "runtime.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    profile_id: {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        keys: [
            "sentry.profile_id",
            "profile.id",
            "profile_id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.profile_id",
            status: "normalize"
        },
        aliases: [
            "sentry.profile_id"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    497
                ],
                description: "Added profile_id attribute"
            }
        ]
    },
    query: {
        brief: "The database query being executed.",
        type: "string",
        keys: [
            "db.query.text",
            "db.statement",
            "query"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT * FROM users WHERE id = $1",
        examples: [
            "SELECT * FROM users WHERE id = $1"
        ],
        deprecation: {
            replacement: "db.query.text",
            reason: "While this attribute never specifically required parameterization, the replacement, db.query.text, does.",
            status: "backfill"
        },
        aliases: [
            "db.query.text",
            "db.statement"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    530
                ],
                description: "Added query attribute"
            }
        ]
    },
    "query.<key>": {
        brief: "An item in a query string. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        keys: [
            "query.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "query.id='123'",
        deprecation: {
            replacement: "url.query",
            reason: "Instead of sending items individually in query.<key>, they should be sent all together with url.query."
        },
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "react_native.architecture": {
        brief: "The React Native architecture the app is running on. `new` for the New Architecture, where native modules are resolved as TurboModules through `TurboModuleRegistry`, `legacy` for the Old Architecture bridge.",
        type: "string",
        keys: [
            "react_native.architecture",
            "turbo_module.arch"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "new",
        examples: [
            "new",
            "legacy"
        ],
        aliases: [
            "turbo_module.arch"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.architecture attribute"
            }
        ]
    },
    "react_native.module.call.count": {
        brief: "The number of native module calls observed during the lifetime of the span.",
        type: "integer",
        keys: [
            "react_native.module.call.count",
            "turbo_module.total_call_count",
            "turbo_modules.total_call_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 42,
        examples: [
            42
        ],
        aliases: [
            "turbo_module.total_call_count",
            "turbo_modules.total_call_count"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.module.call.count attribute"
            }
        ]
    },
    "react_native.module.call.distinct_count": {
        brief: "The number of distinct native module and method pairs called during the lifetime of the span. Useful as a cardinality signal when the per-method breakdown has been truncated.",
        type: "integer",
        keys: [
            "react_native.module.call.distinct_count",
            "turbo_module.unique_methods",
            "turbo_modules.unique_methods"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7,
        examples: [
            7
        ],
        aliases: [
            "turbo_module.unique_methods",
            "turbo_modules.unique_methods"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.module.call.distinct_count attribute"
            }
        ]
    },
    "react_native.module.duration.max": {
        brief: "The duration of the slowest single native module call observed during the lifetime of the span, in milliseconds.",
        type: "double",
        keys: [
            "react_native.module.duration.max"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512.5,
        examples: [
            512.5
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.module.duration.max attribute"
            }
        ]
    },
    "react_native.module.duration.total": {
        brief: "The combined wall-clock duration of all native module calls observed during the lifetime of the span, in milliseconds. Calls overlap, so this can exceed the span duration.",
        type: "double",
        keys: [
            "react_native.module.duration.total",
            "turbo_module.total_duration_ms",
            "turbo_modules.total_duration_ms"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128.45,
        examples: [
            128.45
        ],
        aliases: [
            "turbo_module.total_duration_ms",
            "turbo_modules.total_duration_ms"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.module.duration.total attribute"
            }
        ]
    },
    "react_native.module.error.count": {
        brief: "The number of native module calls that failed during the lifetime of the span. A call counts as failed when it threw, rejected, or \u2014 on the Old Architecture bridge only \u2014 invoked its failure callback.",
        type: "integer",
        keys: [
            "react_native.module.error.count",
            "turbo_module.total_error_count",
            "turbo_modules.total_error_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        examples: [
            2
        ],
        aliases: [
            "turbo_module.total_error_count",
            "turbo_modules.total_error_count"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.module.error.count attribute"
            }
        ]
    },
    "react_native.module.kind": {
        brief: "Whether the native module call completed synchronously or reported completion later through a Promise or a callback. One of `sync` or `async`.",
        type: "string",
        keys: [
            "react_native.module.kind"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sync",
        examples: [
            "sync",
            "async"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.module.kind attribute"
            }
        ]
    },
    "react_native.module.method": {
        brief: "The name of the native module method that was called.",
        type: "string",
        keys: [
            "react_native.module.method",
            "turbo_module.method"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUniqueId",
        examples: [
            "getUniqueId"
        ],
        aliases: [
            "turbo_module.method"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.module.method attribute"
            }
        ]
    },
    "react_native.module.name": {
        brief: "The name of the native module the call was dispatched to. On the New Architecture this is the TurboModule name, on the Old Architecture the `NativeModules` key.",
        type: "string",
        keys: [
            "react_native.module.name",
            "turbo_module.name"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable"
        },
        isInOtel: !1,
        visibility: "public",
        example: "RNDeviceInfo",
        examples: [
            "RNDeviceInfo"
        ],
        aliases: [
            "turbo_module.name"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.module.name attribute"
            }
        ]
    },
    "react_native.module.top.duration": {
        brief: "The total duration attributed to `react_native.module.top.name`, in milliseconds.",
        type: "double",
        keys: [
            "react_native.module.top.duration",
            "turbo_module.top_module_duration_ms"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 87.25,
        examples: [
            87.25
        ],
        aliases: [
            "turbo_module.top_module_duration_ms"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.module.top.duration attribute"
            }
        ]
    },
    "react_native.module.top.name": {
        brief: "The native module and method that accounted for the most total duration during the lifetime of the span, formatted as `<module>.<method>`.",
        type: "string",
        keys: [
            "react_native.module.top.name",
            "turbo_module.top_module"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable"
        },
        isInOtel: !1,
        visibility: "public",
        example: "RNDeviceInfo.getUniqueId",
        examples: [
            "RNDeviceInfo.getUniqueId"
        ],
        aliases: [
            "turbo_module.top_module"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added react_native.module.top.name attribute"
            }
        ]
    },
    "react.version": {
        brief: "The version of the React framework",
        type: "string",
        keys: [
            "react.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.2.0",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    368
                ],
                description: "Added react.version attribute"
            }
        ]
    },
    "redis.command": {
        brief: "The name of the Redis operation being executed.",
        type: "string",
        keys: [
            "db.operation.name",
            "cloudflare.d1.query_type",
            "db.operation",
            "redis.command"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        examples: [
            "SELECT"
        ],
        deprecation: {
            replacement: "db.operation.name",
            status: "backfill"
        },
        aliases: [
            "cloudflare.d1.query_type",
            "db.operation.name",
            "db.operation"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    531
                ],
                description: "Added redis.command attribute"
            }
        ]
    },
    "redis.key": {
        brief: "The key the Redis command is operating on.",
        type: "string",
        keys: [
            "db.redis.key",
            "redis.key"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user:2047:city",
        deprecation: {
            replacement: "db.redis.key",
            reason: "This attribute is being deprecated in favor of db.redis.key, which is the preferred replacement.",
            status: "backfill"
        },
        aliases: [
            "db.redis.key"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    484
                ],
                description: "Added redis.key attribute, deprecated in favor of db.redis.key"
            }
        ]
    },
    release: {
        brief: "The sentry release.",
        type: "string",
        keys: [
            "sentry.release",
            "release",
            "service.version"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.release",
            status: "normalize"
        },
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    497
                ],
                description: "Configured normalization"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "remix.action_form_data.<key>": {
        brief: "Remix form data, <key> being the form data key, the value being the form data value.",
        type: "string",
        keys: [
            "remix.action_form_data.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "http.response.header.text='test'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    replayId: {
        brief: "The id of the sentry replay.",
        type: "string",
        keys: [
            "replayId"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    401
                ]
            }
        ]
    },
    replay_id: {
        brief: "The id of the sentry replay.",
        type: "string",
        keys: [
            "sentry.replay_id",
            "replay.id",
            "replay_id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        deprecation: {
            replacement: "sentry.replay_id",
            status: "normalize"
        },
        aliases: [
            "sentry.replay_id"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    497
                ],
                description: "Configured normalization"
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "resource.deployment.environment": {
        brief: "The software deployment environment name.",
        type: "string",
        keys: [
            "sentry.environment",
            "environment",
            "resource.deployment.environment",
            "resource.deployment.environment.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment",
            status: "backfill"
        },
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    266
                ]
            }
        ]
    },
    "resource.deployment.environment.name": {
        brief: "The software deployment environment name.",
        type: "string",
        keys: [
            "sentry.environment",
            "environment",
            "resource.deployment.environment",
            "resource.deployment.environment.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "production",
        deprecation: {
            replacement: "sentry.environment",
            status: "backfill"
        },
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    196
                ]
            }
        ]
    },
    "resource.render_blocking_status": {
        brief: "The render blocking status of the resource.",
        type: "string",
        keys: [
            "resource.render_blocking_status"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "non-blocking",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    route: {
        brief: "The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.",
        type: "string",
        keys: [
            "route"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "App\\Controller::indexAction",
        deprecation: {
            replacement: "http.route"
        },
        aliases: [
            "http.route"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    61,
                    74
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "router.navigation.origin": {
        brief: "The origin of the navigation (usually client side router navigations). Should preferably be a parameterized template (like url.template) or a URL path otherwise.",
        type: "string",
        keys: [
            "router.navigation.origin",
            "navigation.origin",
            "sentry.sveltekit.navigation.from"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        aliases: [
            "navigation.origin",
            "sentry.sveltekit.navigation.from"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    600
                ],
                description: "Added router.navigation.origin attribute, replacing navigation.origin"
            }
        ]
    },
    "router.navigation.route.id": {
        brief: "The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).",
        type: "string",
        keys: [
            "router.navigation.route.id",
            "navigation.route.id"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AboutView",
        aliases: [
            "navigation.route.id"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    600
                ],
                description: "Added router.navigation.route.id attribute, replacing navigation.route.id"
            }
        ]
    },
    "router.navigation.type": {
        brief: "The type of navigation done by a client-side router.",
        type: "string",
        keys: [
            "router.navigation.type",
            "navigation.type",
            "sentry.sveltekit.navigation.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "router.push",
        aliases: [
            "navigation.type",
            "sentry.sveltekit.navigation.type"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    600
                ],
                description: "Added router.navigation.type attribute, replacing navigation.type"
            }
        ]
    },
    "rpc.grpc.status_code": {
        brief: "The numeric status code of the gRPC request.",
        type: "integer",
        keys: [
            "rpc.grpc.status_code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 2,
        deprecation: {
            replacement: "rpc.response.status_code",
            reason: "Cannot be automatically backfilled due to type mismatch (integer vs string); rpc.grpc.status_code is a numeric gRPC status code while rpc.response.status_code is the string status name."
        },
        aliases: [
            "code",
            "rpc.response.status_code"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    494,
                    533
                ],
                description: "Deprecated rpc.grpc.status_code in favor of rpc.response.status_code"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.method": {
        brief: "The fully-qualified logical name of the method from the RPC interface perspective.",
        type: "string",
        keys: [
            "rpc.method",
            "aws.operation_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "com.example.ExampleService/exampleMethod",
        aliases: [
            "aws.operation_name"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    536
                ],
                description: "Added aws.operation_name as an alias"
            },
            {
                version: "0.7.0",
                prs: [
                    351
                ],
                description: "Added rpc.method attribute"
            }
        ]
    },
    "rpc.response.status_code": {
        brief: "Status code of the RPC returned by the RPC server or generated by the client.",
        type: "string",
        keys: [
            "rpc.response.status_code",
            "code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "DEADLINE_EXCEEDED",
        aliases: [
            "code",
            "rpc.grpc.status_code"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    494,
                    533
                ],
                description: "Added code and rpc.grpc.status_code as aliases"
            },
            {
                version: "0.7.0",
                prs: [
                    352
                ],
                description: "Added rpc.response.status_code attribute"
            }
        ]
    },
    "rpc.service": {
        brief: "The full (logical) name of the service being called, including its package name, if applicable.",
        type: "string",
        keys: [
            "rpc.service"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "myService.BestService",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "rpc.system": {
        brief: "A string identifying the remoting system.",
        type: "string",
        keys: [
            "rpc.system.name",
            "rpc.system"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        deprecation: {
            replacement: "rpc.system.name",
            reason: "This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement.",
            status: "backfill"
        },
        aliases: [
            "rpc.system.name"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system attribute, deprecated in favor of rpc.system.name"
            }
        ]
    },
    "rpc.system.name": {
        brief: "A string identifying the remoting system.",
        type: "string",
        keys: [
            "rpc.system.name",
            "rpc.system"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "aws-api",
        aliases: [
            "rpc.system"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    482
                ],
                description: "Added rpc.system.name attribute"
            }
        ]
    },
    "runtime.build": {
        brief: "The application build string, when it is separate from the version.",
        type: "string",
        keys: [
            "runtime.build"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stable",
        deprecation: {
            reason: "The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute."
        },
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.build attribute"
            }
        ]
    },
    "runtime.name": {
        brief: "The name of the runtime. For example node, CPython, or rustc.",
        type: "string",
        keys: [
            "process.runtime.name",
            "runtime.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "node",
        deprecation: {
            replacement: "process.runtime.name",
            reason: "Prefer OTel-aligned process.runtime.name",
            status: "backfill"
        },
        aliases: [
            "process.runtime.name"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.name attribute in favor of process.runtime.name"
            }
        ]
    },
    "runtime.raw_description": {
        brief: "Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.",
        type: "string",
        keys: [
            "process.runtime.description",
            "runtime.raw_description"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Eclipse OpenJ9 VM openj9-0.21.0",
        deprecation: {
            replacement: "process.runtime.description",
            reason: "Prefer OTel-aligned process.runtime.description",
            status: "backfill"
        },
        aliases: [
            "process.runtime.description"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.raw_description attribute in favor of process.runtime.description"
            }
        ]
    },
    "runtime.version": {
        brief: "The version of the runtime.",
        type: "string",
        keys: [
            "process.runtime.version",
            "runtime.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18.04.2",
        deprecation: {
            replacement: "process.runtime.version",
            reason: "Prefer OTel-aligned process.runtime.version",
            status: "backfill"
        },
        aliases: [
            "process.runtime.version"
        ],
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    383
                ],
                description: "Added and deprecated runtime.version attribute in favor of process.runtime.version"
            }
        ]
    },
    "score.<key>": {
        brief: "The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.",
        type: "double",
        keys: [
            "score.<key>"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.cls=0.1723",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.<key> attribute"
            }
        ]
    },
    "score.ratio.<key>": {
        brief: "The score for a web vital, normalized to a number between 0 and 1.",
        type: "double",
        keys: [
            "score.ratio.<key>"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.ratio.inp=0.7748",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.ratio.<key> attribute"
            }
        ]
    },
    "score.total": {
        brief: "The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).",
        type: "double",
        keys: [
            "score.total"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.total attribute"
            }
        ]
    },
    "score.weight.<key>": {
        brief: "The relative weight of a web vital in a span's performance score.",
        type: "double",
        keys: [
            "score.weight.<key>"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "score.weight.fcp=0.25",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    355
                ],
                description: "Added score.weight.<key> attribute"
            }
        ]
    },
    "sentry.action": {
        brief: "Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.",
        type: "string",
        keys: [
            "sentry.action",
            "span.action"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ],
        searchAlias: {
            name: "span.action"
        }
    },
    "sentry.browser.name": {
        brief: "The name of the browser.",
        type: "string",
        keys: [
            "browser.name",
            "sentry.browser.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Chrome",
        deprecation: {
            replacement: "browser.name",
            status: "backfill"
        },
        aliases: [
            "browser.name"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ],
        searchAlias: {
            name: "browser.name"
        }
    },
    "sentry.browser.version": {
        brief: "The version of the browser.",
        type: "string",
        keys: [
            "browser.version",
            "sentry.browser.version"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.0.6099.130",
        deprecation: {
            replacement: "browser.version",
            status: "backfill"
        },
        aliases: [
            "browser.version"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    139
                ]
            }
        ]
    },
    "sentry.cancellation_reason": {
        brief: "The reason why a span ended early.",
        type: "string",
        keys: [
            "sentry.cancellation_reason"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "document.hidden",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.category": {
        brief: "The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). Known values include: 'ai', 'ai.pipeline', 'app', 'browser', 'cache', 'console', 'db', 'event', 'file', 'function.aws', 'function.azure', 'function.gcp', 'function.nextjs', 'function.remix', 'graphql', 'grpc', 'http', 'measure', 'middleware', 'navigation', 'pageload', 'queue', 'resource', 'rpc', 'serialize', 'subprocess', 'template', 'topic', 'ui', 'ui.angular', 'ui.ember', 'ui.react', 'ui.svelte', 'ui.vue', 'view', 'websocket'.",
        type: "string",
        keys: [
            "sentry.category",
            "span.category"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "db",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    218
                ]
            }
        ],
        searchAlias: {
            name: "span.category"
        }
    },
    "sentry.client_sample_rate": {
        brief: "Rate at which a span was sampled in the SDK.",
        type: "double",
        keys: [
            "sentry.client_sample_rate",
            "client_sample_rate"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ],
        searchAlias: {
            name: "client_sample_rate"
        }
    },
    "sentry.description": {
        brief: "The human-readable description of a span.",
        type: "string",
        keys: [
            "sentry.description"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "index view query",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    135
                ]
            }
        ]
    },
    "sentry.dist": {
        brief: "The sentry dist.",
        type: "string",
        keys: [
            "sentry.dist",
            "dist"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1.0",
        aliases: [
            "dist"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    489
                ],
                description: "Added dist as an alias"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.domain": {
        brief: "Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.",
        type: "string",
        keys: [
            "sentry.domain",
            "span.domain"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ],
        searchAlias: {
            name: "span.domain"
        }
    },
    "sentry.dsc.environment": {
        brief: "The environment from the dynamic sampling context.",
        type: "string",
        keys: [
            "sentry.dsc.environment"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "prod",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.project_id": {
        brief: "The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.",
        type: "string",
        keys: [
            "sentry.dsc.project_id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "12345",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    358
                ],
                description: "Add sentry.dsc.project_id as an attribute"
            }
        ]
    },
    "sentry.dsc.public_key": {
        brief: "The public key from the dynamic sampling context.",
        type: "string",
        keys: [
            "sentry.dsc.public_key"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "c51734c603c4430eb57cb0a5728a479d",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.release": {
        brief: "The release identifier from the dynamic sampling context.",
        type: "string",
        keys: [
            "sentry.dsc.release"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "frontend@e8211be71b214afab5b85de4b4c54be3714952bb",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sampled": {
        brief: "Whether the event was sampled according to the dynamic sampling context.",
        type: "boolean",
        keys: [
            "sentry.dsc.sampled"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.sample_rate": {
        brief: "The sample rate from the dynamic sampling context.",
        type: "string",
        keys: [
            "sentry.dsc.sample_rate"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "1.0",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.trace_id": {
        brief: "The trace ID from the dynamic sampling context.",
        type: "string",
        keys: [
            "sentry.dsc.trace_id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "047372980460430cbc78d9779df33a46",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.dsc.transaction": {
        brief: "The transaction name from the dynamic sampling context.",
        type: "string",
        keys: [
            "sentry.dsc.transaction"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "/issues/errors-outages/",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.environment": {
        brief: "The sentry environment.",
        type: "string",
        keys: [
            "sentry.environment",
            "environment",
            "resource.deployment.environment",
            "resource.deployment.environment.name"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "production",
        aliases: [
            "environment"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "environment"
        }
    },
    "sentry.event.serialized_breadcrumbs": {
        brief: "JSON-serialized `breadcrumbs` property from a Sentry event.",
        type: "string",
        keys: [
            "sentry.event.serialized_breadcrumbs"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    556
                ]
            }
        ]
    },
    "sentry.event.serialized_contexts": {
        brief: "JSON-serialized `contexts` property from a Sentry event.",
        type: "string",
        keys: [
            "sentry.event.serialized_contexts"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    556
                ]
            }
        ]
    },
    "sentry.event.serialized_extra": {
        brief: "JSON-serialized `extra` property from a Sentry event.",
        type: "string",
        keys: [
            "sentry.event.serialized_extra"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    556
                ]
            }
        ]
    },
    "sentry.event.serialized_meta": {
        brief: "JSON-serialized `_meta` for the `sentry.event.serialized_*` properties from a Sentry event.",
        type: "string",
        keys: [
            "sentry.event.serialized_meta"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "internal",
        changelog: [
            {
                version: "0.20.0",
                prs: [
                    566
                ]
            }
        ]
    },
    "sentry.exclusive_time": {
        brief: "The exclusive time duration of the span in milliseconds.",
        type: "double",
        keys: [
            "sentry.exclusive_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.3.0",
                prs: [
                    160
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.frames.frozen": {
        brief: "The number of frozen frames rendered during the lifetime of the span.",
        type: "integer",
        keys: [
            "app.vitals.frames.frozen.count",
            "frames.frozen",
            "mobile.frozen_frames",
            "sentry.frames.frozen"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 3,
        deprecation: {
            replacement: "app.vitals.frames.frozen.count",
            reason: "Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.frames.frozen.count",
            "frames.frozen"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    500
                ],
                description: "Added sentry.frames.frozen attribute"
            }
        ]
    },
    "sentry.frames.slow": {
        brief: "The number of slow frames rendered during the lifetime of the span.",
        type: "integer",
        keys: [
            "app.vitals.frames.slow.count",
            "frames.slow",
            "mobile.slow_frames",
            "sentry.frames.slow"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1,
        deprecation: {
            replacement: "app.vitals.frames.slow.count",
            reason: "Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.frames.slow.count",
            "frames.slow"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    500
                ],
                description: "Added sentry.frames.slow attribute"
            }
        ]
    },
    "sentry.frames.total": {
        brief: "The number of total frames rendered during the lifetime of the span.",
        type: "integer",
        keys: [
            "app.vitals.frames.total.count",
            "frames.total",
            "mobile.total_frames",
            "sentry.frames.total"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 60,
        deprecation: {
            replacement: "app.vitals.frames.total.count",
            reason: "Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.frames.total.count",
            "frames.total"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    500
                ],
                description: "Added sentry.frames.total attribute"
            }
        ]
    },
    "sentry.graphql.operation": {
        brief: "Indicates the type of graphql operation, emitted by the Javascript SDK.",
        type: "string",
        keys: [
            "sentry.graphql.operation"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUserById",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.group": {
        brief: "Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.",
        type: "string",
        keys: [
            "sentry.group",
            "span.group"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ],
        searchAlias: {
            name: "span.group"
        }
    },
    "sentry.http.prefetch": {
        brief: "If an http request was a prefetch request.",
        type: "boolean",
        keys: [
            "sentry.http.prefetch"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.idle_span_finish_reason": {
        brief: "The reason why an idle span ended early.",
        type: "string",
        keys: [
            "sentry.idle_span_finish_reason"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "idleTimeout",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.is_localhost": {
        brief: "Indicates whether a telemetry item was sent on a host, device or browser on a localhost URL or IP address.",
        type: "boolean",
        keys: [
            "sentry.is_localhost"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: !0,
        examples: [
            !0,
            !1
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    646
                ],
                description: "Added sentry.is_localhost attribute"
            }
        ],
        additionalContext: [
            'This attribute is used for the Sentry "Filter telemetry from localhost" inbound filter feature.',
            "SDKs must set this attribute on every span, as well as every other telemetry item supporting attribuztes."
        ]
    },
    "sentry.is_remote": {
        brief: "Indicates whether a span's parent is remote.",
        type: "boolean",
        keys: [
            "sentry.is_remote"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ]
    },
    "sentry.kind": {
        brief: "Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.",
        type: "string",
        keys: [
            "sentry.kind",
            "span.kind",
            "otel.kind"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "client",
        examples: [
            "client",
            "server",
            "producer",
            "consumer",
            "internal"
        ],
        aliases: [
            "otel.kind"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    517
                ],
                description: "Added more examples and additional_context to the attribute"
            },
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ],
        additionalContext: [
            'Valid attribute values are: "client", "server", "producer", "consumer" and "internal"'
        ],
        searchAlias: {
            name: "span.kind"
        }
    },
    "sentry.link.type": {
        brief: "Set on a span link. Describes the relationship between the span and the linked span.",
        type: "string",
        keys: [
            "sentry.link.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "previous_trace",
        examples: [
            "previous_trace",
            "next_trace",
            "cache_origin"
        ],
        changelog: [
            {
                version: "0.25.0",
                prs: [
                    656
                ],
                description: "Added sentry.link.type attribute"
            }
        ],
        additionalContext: [
            "This attribute is exclusively set on span links.",
            "Sentry instrumentation setting span links, sets it to describe the relationship between the span and the linked span.",
            "For known values, see Examples. Add new values to Examples."
        ]
    },
    "sentry.main_thread": {
        brief: "Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        keys: [
            "sentry.main_thread"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.message.parameter.<key>": {
        brief: "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
        type: "string",
        keys: [
            "sentry.message.parameter.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sentry.message.parameter.0='123'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.message.template": {
        brief: "The parameterized template string.",
        type: "string",
        keys: [
            "sentry.message.template"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Hello, {name}!",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.metric.source": {
        brief: "The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.",
        type: "string",
        keys: [
            "sentry.metric.source"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "span",
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    476
                ],
                description: "Added sentry.metric.source attribute"
            }
        ]
    },
    "sentry.mobile": {
        brief: "Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.",
        type: "boolean",
        keys: [
            "sentry.mobile"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.module.<key>": {
        brief: "A module that was loaded in the process. The key is the name of the module.",
        type: "string",
        keys: [
            "sentry.module.<key>"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "sentry.module.brianium/paratest='v7.7.0'",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.route": {
        brief: "A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.",
        type: "string",
        keys: [
            "sentry.nextjs.ssr.function.route"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/posts/[id]/layout",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.nextjs.ssr.function.type": {
        brief: "A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.",
        type: "string",
        keys: [
            "sentry.nextjs.ssr.function.type"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "generateMetadata",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    54,
                    106
                ]
            }
        ]
    },
    "sentry.normalized_db_query": {
        brief: "The normalized version of `db.query.text`.",
        type: "string",
        keys: [
            "sentry.normalized_db_query"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    194
                ]
            }
        ]
    },
    "sentry.normalized_db_query.hash": {
        brief: "The hash of `sentry.normalized_db_query`.",
        type: "string",
        keys: [
            "sentry.normalized_db_query.hash"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    200
                ]
            }
        ]
    },
    "sentry.normalized_description": {
        brief: "Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).",
        type: "string",
        keys: [
            "sentry.normalized_description"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "SELECT .. FROM sentry_project WHERE (project_id = %s)",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    212
                ]
            }
        ]
    },
    "sentry.observed_timestamp_nanos": {
        brief: "The timestamp at which an envelope was received by Relay, in nanoseconds.",
        type: "string",
        keys: [
            "sentry.observed_timestamp_nanos"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1544712660300000000",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    174
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    137
                ]
            }
        ]
    },
    "sentry.op": {
        brief: "The operation of a span.",
        type: "string",
        keys: [
            "sentry.op",
            "span.op"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "http.client",
        changelog: [
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "span.op"
        }
    },
    "sentry.origin": {
        brief: "The origin of the instrumentation (e.g. span, log, etc.)",
        type: "string",
        keys: [
            "sentry.origin",
            "origin"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "auto.http.otel.fastify",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    68
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "origin"
        }
    },
    "sentry.pageload.span_id": {
        brief: "The id of the pageload span, set by web vital spans and metrics",
        type: "string",
        keys: [
            "sentry.pageload.span_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bf2c8d3df84524de",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    495
                ],
                description: "Added sentry.pageload.span_id attribute"
            }
        ]
    },
    "sentry.platform": {
        brief: "The sdk platform that generated the event.",
        type: "string",
        keys: [
            "sentry.platform",
            "platform"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "php",
        changelog: [
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "platform"
        }
    },
    "sentry.profiler_id": {
        brief: "The id of the currently running profiler (continuous profiling)",
        type: "string",
        keys: [
            "sentry.profiler_id",
            "profiler.id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "18779b64dd35d1a538e7ce2dd2d3fad3",
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    242
                ]
            }
        ],
        searchAlias: {
            name: "profiler.id"
        }
    },
    "sentry.profile_id": {
        brief: "The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.",
        type: "string",
        keys: [
            "sentry.profile_id",
            "profile.id",
            "profile_id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "profile_id"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    497
                ],
                description: "Added profile_id as an alias"
            },
            {
                version: "0.6.0",
                prs: [
                    344
                ],
                description: "Added sentry.profile_id attribute"
            }
        ],
        searchAlias: {
            name: "profile.id"
        }
    },
    "sentry.relay.ingress": {
        brief: "How an item (span, log, &c.) entered Relay.",
        type: "string",
        keys: [
            "sentry.relay.ingress"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "OTEL",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    491
                ],
                description: "Added sentry.relay.ingress attribute"
            }
        ]
    },
    "sentry.relay.pipeline": {
        brief: "An internal descriptor of which processing pipeline an item went through in Relay.",
        type: "string",
        keys: [
            "sentry.relay.pipeline"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "span v2",
        changelog: [
            {
                version: "0.17.0",
                prs: [
                    491
                ],
                description: "Added sentry.relay.pipeline attribute"
            }
        ]
    },
    "sentry.release": {
        brief: "The sentry release.",
        type: "string",
        keys: [
            "sentry.release",
            "release",
            "service.version"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        aliases: [
            "service.version",
            "release"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "release"
        }
    },
    "sentry.replay_id": {
        brief: "The id of the sentry replay.",
        type: "string",
        keys: [
            "sentry.replay_id",
            "replay.id",
            "replay_id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "123e4567e89b12d3a456426614174000",
        aliases: [
            "replay_id",
            "replayId"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "replay.id",
            deprecatedAliases: [
                "replay_id"
            ]
        }
    },
    "sentry.replay_is_buffering": {
        brief: "A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).",
        type: "boolean",
        keys: [
            "sentry.replay_is_buffering"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    185
                ]
            }
        ]
    },
    "sentry.report_event": {
        brief: "(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)",
        type: "string",
        keys: [
            "sentry.report_event"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pagehide",
        deprecation: {
            reason: "The report event moved to browser.web_vital.lcp.report_event and browser.web_vital.cls.report_event, which are themselves deprecated without a replacement. No backfill required."
        },
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    642
                ],
                description: "Updated the deprecation reason now that the browser.web_vital.*.report_event attributes are deprecated"
            },
            {
                version: "0.5.0",
                prs: [
                    320
                ],
                description: "Added sentry.report_event attribute"
            }
        ]
    },
    "sentry.sdk.integrations": {
        brief: "A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.",
        type: "string[]",
        keys: [
            "sentry.sdk.integrations"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "InboundFilters",
            "FunctionToString",
            "BrowserApiErrors",
            "Breadcrumbs"
        ],
        changelog: [
            {
                version: "0.0.0",
                prs: [
                    42
                ]
            }
        ]
    },
    "sentry.sdk.name": {
        brief: "The sentry sdk name.",
        type: "string",
        keys: [
            "sentry.sdk.name",
            "sdk.name"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "@sentry/react",
        changelog: [
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "sdk.name"
        }
    },
    "sentry.sdk.version": {
        brief: "The sentry sdk version.",
        type: "string",
        keys: [
            "sentry.sdk.version",
            "sdk.version"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "7.0.0",
        changelog: [
            {
                version: "0.0.0"
            }
        ],
        searchAlias: {
            name: "sdk.version"
        }
    },
    "sentry.segment.id": {
        brief: "The segment ID of a span",
        type: "string",
        keys: [
            "sentry.segment.id",
            "sentry.segment_id",
            "transaction.span_id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        aliases: [
            "sentry.segment_id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    107,
                    124
                ]
            }
        ]
    },
    "sentry.segment_id": {
        brief: "The segment ID of a span",
        type: "string",
        keys: [
            "sentry.segment.id",
            "sentry.segment_id",
            "transaction.span_id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "051581bf3cb55c13",
        deprecation: {
            replacement: "sentry.segment.id",
            status: "backfill"
        },
        aliases: [
            "sentry.segment.id"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    124
                ]
            }
        ],
        searchAlias: {
            name: "transaction.span_id"
        }
    },
    "sentry.segment.name": {
        brief: "The segment name of a span",
        type: "string",
        keys: [
            "sentry.segment.name",
            "transaction",
            "sentry.transaction"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /user",
        aliases: [
            "sentry.transaction",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Added sentry.transaction and transaction aliases"
            },
            {
                version: "0.1.0",
                prs: [
                    104
                ]
            }
        ],
        searchAlias: {
            name: "transaction"
        }
    },
    "sentry.segment.name.source": {
        brief: "The source of the segment span name. Should only be set on segment spans. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`.",
        type: "string",
        keys: [
            "sentry.segment.name.source"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "internal",
        example: "route",
        examples: [
            "route",
            "component",
            "view",
            "task",
            "custom",
            "url"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    466
                ],
                description: "Added sentry.segment.name.source"
            }
        ],
        additionalContext: [
            "This attribute is the replacement for `transaction_info.source` on transactions.",
            "Should we bring back clustering for segment names (like we do for transaction names), this attribute will be used to determine if a segment name should be clustered."
        ]
    },
    "sentry.server_sample_rate": {
        brief: "Rate at which a span was sampled in Relay.",
        type: "double",
        keys: [
            "sentry.server_sample_rate",
            "server_sample_rate"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: .5,
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    102
                ]
            }
        ],
        searchAlias: {
            name: "server_sample_rate"
        }
    },
    "sentry.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        keys: [
            "sentry.source"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            reason: "This attribute is superseded by sentry.segment.name.source, which only needs to be set on segment spans."
        },
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    510
                ],
                description: "Removed the sentry.span.source replacement"
            },
            {
                version: "0.5.0"
            }
        ]
    },
    "sentry.span.source": {
        brief: "The source of a span, also referred to as transaction source. Known values are:  `'custom'`, `'url'`, `'route'`, `'component'`, `'view'`, `'task'`. '`source`' describes a parametrized route, while `'url'` describes the full URL, potentially containing identifiers.",
        type: "string",
        keys: [
            "sentry.span.source"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "route",
        deprecation: {
            reason: "This attribute is superseded by sentry.segment.name.source, which only needs to be set on segment spans."
        },
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    510
                ],
                description: "Deprecated; superseded by sentry.segment.name.source on segment spans"
            },
            {
                version: "0.4.0",
                prs: [
                    214
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.status": {
        brief: `The span's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        keys: [
            "sentry.status",
            "span.status"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ],
        searchAlias: {
            name: "span.status"
        }
    },
    "sentry.status_code": {
        brief: "The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.",
        type: "integer",
        keys: [
            "sentry.status_code",
            "span.status_code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    223,
                    228
                ]
            }
        ],
        searchAlias: {
            name: "span.status_code"
        }
    },
    "sentry.status.message": {
        brief: "The from OTLP extracted status message.",
        type: "string",
        keys: [
            "sentry.status.message",
            "span.status.message"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "foobar",
        changelog: [
            {
                version: "0.3.1",
                prs: [
                    190
                ]
            }
        ],
        searchAlias: {
            name: "span.status.message"
        }
    },
    "sentry.sveltekit.navigation.from": {
        brief: "the navigation origin (sveltekit router)",
        type: "string",
        keys: [
            "router.navigation.origin",
            "navigation.origin",
            "sentry.sveltekit.navigation.from"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/home",
        deprecation: {
            replacement: "router.navigation.origin",
            reason: "Use the more generic attribute instead",
            status: "backfill"
        },
        aliases: [
            "navigation.origin",
            "router.navigation.origin"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    600
                ],
                description: "Re-pointed deprecation from navigation.origin to router.navigation.origin"
            },
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.from attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.to": {
        brief: "the navigation destination",
        type: "string",
        keys: [
            "sentry.sveltekit.navigation.to"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/users/:id",
        deprecation: {
            reason: "the navigation destination is already covered by url.* attributes"
        },
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.to attribute"
            }
        ]
    },
    "sentry.sveltekit.navigation.type": {
        brief: "The type of navigation event emitted from the sveltekit client router",
        type: "string",
        keys: [
            "router.navigation.type",
            "navigation.type",
            "sentry.sveltekit.navigation.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "link",
        deprecation: {
            replacement: "router.navigation.type",
            reason: "Use the more generic attribute instead",
            status: "backfill"
        },
        aliases: [
            "navigation.type",
            "router.navigation.type"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    600
                ],
                description: "Re-pointed deprecation from navigation.type to router.navigation.type"
            },
            {
                version: "0.16.0",
                prs: [
                    467
                ],
                description: "Added sentry.sveltekit.navigation.type attribute"
            }
        ]
    },
    "sentry.thread.id": {
        brief: 'Current "managed" thread ID.',
        type: "integer",
        keys: [
            "thread.id",
            "sentry.thread.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 56,
        deprecation: {
            replacement: "thread.id",
            reason: "This attribute is being deprecated in favor of the OTel-standard thread.id",
            status: "backfill"
        },
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    451
                ]
            }
        ],
        searchAlias: {
            name: "thread.id"
        }
    },
    "sentry.timestamp.sequence": {
        brief: "A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.",
        type: "integer",
        keys: [
            "sentry.timestamp.sequence"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: 0,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    262
                ]
            }
        ]
    },
    "sentry.trace_lifecycle": {
        brief: "Indicates the chosen trace lifecycle mode of the SDK (stream or static)",
        type: "string",
        keys: [
            "sentry.trace_lifecycle",
            "trace_lifecycle"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stream",
        changelog: [
            {
                version: "0.13.0",
                prs: [
                    442
                ],
                description: "Added sentry.trace_lifecycle attribute"
            }
        ],
        searchAlias: {
            name: "trace_lifecycle"
        }
    },
    "sentry.trace.parent_span_id": {
        brief: "The span id of the span that was active when the log was collected. This should not be set if there was no active span.",
        type: "string",
        keys: [
            "sentry.trace.parent_span_id"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "b0e6f15b45c36b12",
        deprecation: {},
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    287
                ],
                description: "Deprecate `sentry.trace.parent_span_id`"
            },
            {
                version: "0.1.0",
                prs: [
                    116
                ]
            }
        ]
    },
    "sentry.trace.status": {
        brief: `The segment's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.`,
        type: "string",
        keys: [
            "sentry.trace.status",
            "trace.status"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "ok",
        changelog: [
            {
                version: "0.14.0",
                prs: [
                    453
                ]
            }
        ],
        searchAlias: {
            name: "trace.status"
        }
    },
    "sentry.transaction": {
        brief: "The sentry transaction (segment name).",
        type: "string",
        keys: [
            "sentry.segment.name",
            "transaction",
            "sentry.transaction"
        ],
        applyScrubbing: {
            key: "never"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            reason: "This attribute is being deprecated in favor of sentry.segment.name",
            status: "backfill"
        },
        aliases: [
            "sentry.segment.name",
            "transaction"
        ],
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Deprecated sentry.transaction in favor of sentry.segment.name"
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "sentry.user.email": {
        brief: "User email address.",
        type: "string",
        keys: [
            "user.email",
            "sentry.user.email"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.email",
            status: "backfill"
        },
        aliases: [
            "user.email"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ],
        searchAlias: {
            name: "user.email"
        }
    },
    "sentry.user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        keys: [
            "user.geo.city",
            "sentry.user.geo.city"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.city",
            status: "backfill"
        },
        aliases: [
            "user.geo.city"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ],
        searchAlias: {
            name: "user.geo.city"
        }
    },
    "sentry.user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        keys: [
            "user.geo.country_code",
            "sentry.user.geo.country_code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.country_code",
            status: "backfill"
        },
        aliases: [
            "user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ],
        searchAlias: {
            name: "user.geo.country_code"
        }
    },
    "sentry.user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        keys: [
            "user.geo.region",
            "sentry.user.geo.region"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.region",
            status: "backfill"
        },
        aliases: [
            "user.geo.region"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ],
        searchAlias: {
            name: "user.geo.region"
        }
    },
    "sentry.user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        keys: [
            "user.geo.subdivision",
            "sentry.user.geo.subdivision"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.geo.subdivision",
            status: "backfill"
        },
        aliases: [
            "user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ],
        searchAlias: {
            name: "user.geo.subdivision"
        }
    },
    "sentry.user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        keys: [
            "user.id",
            "sentry.user.id"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.id",
            status: "backfill"
        },
        aliases: [
            "user.id"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ],
        searchAlias: {
            name: "user.id"
        }
    },
    "sentry.user.ip": {
        brief: "The IP address of the user.",
        type: "string",
        keys: [
            "user.ip_address",
            "sentry.user.ip",
            "user.ip"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.ip_address",
            status: "backfill"
        },
        aliases: [
            "user.ip_address"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ],
        searchAlias: {
            name: "user.ip"
        }
    },
    "sentry.user.username": {
        brief: "Short name or login/username of the user.",
        type: "string",
        keys: [
            "user.name",
            "sentry.user.username",
            "user.username"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "user.name",
            status: "backfill"
        },
        aliases: [
            "user.name"
        ],
        changelog: [
            {
                version: "0.10.0",
                prs: [
                    406
                ]
            }
        ],
        searchAlias: {
            name: "user.username"
        }
    },
    "server.address": {
        brief: "Preferably the server domain name if available without reverse DNS lookup, or an IP address or Unix domain socket name. For compatibility, it may contain what the hostname command returns on UNIX systems, the fully qualified hostname, or another name specified by the user.",
        type: "string",
        keys: [
            "server.address",
            "address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        aliases: [
            "address",
            "http.server_name",
            "net.host.name",
            "http.host",
            "server_name",
            "net.peer.name"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    645,
                    647
                ],
                description: "Broaden brief to allow hostnames"
            },
            {
                version: "0.21.0",
                prs: [
                    588,
                    602
                ],
                description: "Added net.peer.name as an alias"
            },
            {
                version: "0.19.0",
                prs: [
                    534
                ],
                description: "Added address as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    108,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    server_name: {
        brief: "The name of the device. On servers and desktops, this is typically the hostname.",
        type: "string",
        keys: [
            "server.address",
            "address",
            "http.server_name",
            "net.host.name",
            "server_name"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "example.com",
        deprecation: {
            replacement: "server.address",
            reason: "This attribute is being deprecated in favor of server.address.",
            status: "backfill"
        },
        aliases: [
            "address",
            "server.address",
            "http.server_name",
            "net.host.name",
            "http.host",
            "net.peer.name"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    647
                ],
                description: "Alias the server.address alias group"
            },
            {
                version: "0.21.0",
                prs: [
                    588,
                    602
                ],
                description: "Alias device.name instead of the server.address alias group"
            },
            {
                version: "0.19.0",
                prs: [
                    534
                ],
                description: "Added address as an alias"
            },
            {
                version: "0.16.0",
                prs: [
                    477
                ],
                description: "Added server_name attribute, deprecated in favor of server.address"
            }
        ]
    },
    "server.port": {
        brief: "Server port number.",
        type: "integer",
        keys: [
            "server.port",
            "net.host.port",
            "port"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        aliases: [
            "net.host.port",
            "port"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    532
                ],
                description: "Added port as an alias"
            },
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.name": {
        brief: "Logical name of the service.",
        type: "string",
        keys: [
            "service.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "omegastar",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "service.version": {
        brief: "The version string of the service API or implementation. The format is not defined by these conventions.",
        type: "string",
        keys: [
            "service.version",
            "sentry.release",
            "release"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "5.0.0",
        aliases: [
            "sentry.release"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "session.id": {
        brief: "A unique id identifying the active session at the time of setting this attribute",
        type: "string",
        keys: [
            "session.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "00112233-4455-6677-8899-aabbccddeeff",
        changelog: [
            {
                version: "0.11.0",
                prs: [
                    412
                ],
                description: "Added session.id attribute"
            }
        ]
    },
    stall_percentage: {
        brief: "The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.",
        type: "double",
        keys: [
            "app.vitals.stall.percentage",
            "stall_percentage"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "app.vitals.stall.percentage",
            reason: "Replaced by app.vitals.stall.percentage to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.stall.percentage"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    493
                ],
                description: "Deprecated in favor of app.vitals.stall.percentage"
            },
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_percentage attribute"
            }
        ]
    },
    stall_total_time: {
        brief: "The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.",
        type: "double",
        keys: [
            "app.vitals.stall.duration",
            "stall_total_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        deprecation: {
            replacement: "app.vitals.stall.duration",
            reason: "Replaced by app.vitals.stall.duration to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.stall.duration"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    493
                ],
                description: "Deprecated in favor of app.vitals.stall.duration"
            },
            {
                version: "0.7.0",
                prs: [
                    362
                ],
                description: "Added stall_total_time attribute"
            }
        ]
    },
    "starlette.middleware_name": {
        brief: "The name of the Starlette middleware.",
        type: "string",
        keys: [
            "middleware.name",
            "django.middleware_name",
            "litestar.middleware_name",
            "starlette.middleware_name",
            "starlite.middleware_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        deprecation: {
            replacement: "middleware.name",
            reason: "This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.",
            status: "backfill"
        },
        aliases: [
            "middleware.name"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    485
                ],
                description: "Added starlette.middleware_name attribute, deprecated in favor of middleware.name"
            }
        ]
    },
    "starlite.middleware_name": {
        brief: "The name of the Starlite middleware.",
        type: "string",
        keys: [
            "middleware.name",
            "django.middleware_name",
            "litestar.middleware_name",
            "starlette.middleware_name",
            "starlite.middleware_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "AuthenticationMiddleware",
        examples: [
            "AuthenticationMiddleware"
        ],
        deprecation: {
            replacement: "middleware.name",
            reason: "This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.",
            status: "backfill"
        },
        aliases: [
            "middleware.name"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    519
                ],
                description: "Added starlite.middleware_name attribute"
            }
        ]
    },
    "state.type": {
        brief: "The type of state management library",
        type: "string",
        keys: [
            "state.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "redux",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    365
                ],
                description: "Added state.type attribute"
            }
        ]
    },
    "subprocess.pid": {
        brief: "The process ID of a subprocess.",
        type: "integer",
        keys: [
            "process.pid",
            "subprocess.pid"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 12345,
        deprecation: {
            replacement: "process.pid",
            reason: "This attribute is being deprecated in favor of process.pid, which is the OTel-aligned replacement.",
            status: "backfill"
        },
        aliases: [
            "process.pid"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    487
                ],
                description: "Added subprocess.pid attribute, deprecated in favor of process.pid"
            }
        ]
    },
    "sveltekit.load.environment": {
        brief: "The runtime environment in which the SvelteKit load function was executed. Known values are `'server'` and `'client'`.",
        type: "string",
        keys: [
            "sveltekit.load.environment"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "server",
        examples: [
            "server",
            "client"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    611
                ],
                description: "Added sveltekit.load.environment attribute"
            }
        ],
        additionalContext: [
            "Added by the SvelteKit framework itself. The Sentry SDK only forwards the attribute to Sentry."
        ]
    },
    "sveltekit.load.node_id": {
        brief: "The path to the SvelteKit load function.",
        type: "string",
        keys: [
            "sveltekit.load.node_id",
            "code.file.path",
            "code.filepath"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "src/routes/users/:id/+page.server.ts",
        examples: [
            "src/routes/users/:id/+page.server.ts"
        ],
        aliases: [
            "code.file.path",
            "code.filepath"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    611
                ],
                description: "Added sveltekit.load.node_id attribute"
            }
        ],
        additionalContext: [
            "Added by the SvelteKit framework itself. The Sentry SDK only forwards the attribute to Sentry."
        ]
    },
    "sveltekit.load.node_type": {
        brief: "The kind of SvelteKit load function that was executed, distinguishing page from layout and universal from server load functions.",
        type: "string",
        keys: [
            "sveltekit.load.node_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "+page.server",
        examples: [
            "+page.server",
            "+layout",
            "+layout.server"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    611
                ],
                description: "Added sveltekit.load.node_type attribute"
            }
        ],
        additionalContext: [
            "Added by the SvelteKit framework itself. The Sentry SDK only forwards the attribute to Sentry."
        ]
    },
    "sveltekit.tracing.original_name": {
        brief: "The original span name as emitted by SvelteKit.",
        type: "string",
        keys: [
            "sveltekit.tracing.original_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sveltekit.handle.root",
        examples: [
            "sveltekit.handle.root"
        ],
        changelog: [
            {
                version: "0.22.0",
                prs: [
                    611
                ],
                description: "Added sveltekit.tracing.original_name attribute"
            }
        ],
        additionalContext: [
            "The Sentry SDK renames SvelteKit-emitted spans to match Sentry's span name semantics, and preserves the name SvelteKit originally set in this attribute."
        ]
    },
    "thread.id": {
        brief: "Current \u201Cmanaged\u201D thread ID.",
        type: "integer",
        keys: [
            "thread.id",
            "sentry.thread.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 56,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "thread.name": {
        brief: "Current thread name.",
        type: "string",
        keys: [
            "thread.name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "timber.tag": {
        brief: "The log tag provided by the timber logging framework.",
        type: "string",
        keys: [
            "timber.tag"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "MyTag",
        changelog: [
            {
                version: "0.3.0",
                prs: [
                    183
                ]
            }
        ]
    },
    time_to_full_display: {
        brief: "The duration of time to full display in milliseconds",
        type: "double",
        keys: [
            "app.vitals.ttfd.value",
            "time_to_full_display"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttfd.value",
            reason: "Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.ttfd.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttfd.value"
            }
        ]
    },
    time_to_initial_display: {
        brief: "The duration of time to initial display in milliseconds",
        type: "double",
        keys: [
            "app.vitals.ttid.value",
            "time_to_initial_display"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1234.56,
        deprecation: {
            replacement: "app.vitals.ttid.value",
            reason: "Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes",
            status: "backfill"
        },
        aliases: [
            "app.vitals.ttid.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    313
                ],
                description: "Added and deprecated in favor of app.vitals.ttid.value"
            }
        ]
    },
    transaction: {
        brief: "The sentry transaction (segment name).",
        type: "string",
        keys: [
            "sentry.segment.name",
            "transaction",
            "sentry.transaction"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET /",
        deprecation: {
            replacement: "sentry.segment.name",
            status: "normalize"
        },
        aliases: [
            "sentry.segment.name",
            "sentry.transaction"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    497
                ],
                description: "Change deprecation from backfill to normalize"
            },
            {
                version: "0.6.0",
                prs: [
                    345
                ],
                description: "Updated transaction deprecation replacement to sentry.segment.name"
            },
            {
                version: "0.1.0",
                prs: [
                    61,
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "trpc.procedure_path": {
        brief: "The path of the tRPC procedure being called",
        type: "string",
        keys: [
            "trpc.procedure_path"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "user.getById",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_path attribute"
            }
        ]
    },
    "trpc.procedure_type": {
        brief: "The type of the tRPC procedure",
        type: "string",
        keys: [
            "trpc.procedure_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "query",
        changelog: [
            {
                version: "0.7.0",
                prs: [
                    370
                ],
                description: "Added trpc.procedure_type attribute"
            }
        ]
    },
    ttfb: {
        brief: "The value of the recorded Time To First Byte (TTFB) web vital in milliseconds",
        type: "double",
        keys: [
            "browser.web_vital.ttfb.value",
            "ttfb"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 194,
        deprecation: {
            replacement: "browser.web_vital.ttfb.value",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.value",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.ttfb.value"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "ttfb.requestTime": {
        brief: "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
        type: "double",
        keys: [
            "browser.web_vital.ttfb.request_time",
            "ttfb.requestTime"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1554.5814,
        deprecation: {
            replacement: "browser.web_vital.ttfb.request_time",
            reason: "This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time",
            status: "backfill"
        },
        aliases: [
            "browser.web_vital.ttfb.request_time"
        ],
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    235
                ]
            }
        ]
    },
    "turbo_modules.total_call_count": {
        brief: "The number of native module calls in the flushed call aggregate. Only applies to React Native.",
        type: "integer",
        keys: [
            "react_native.module.call.count",
            "turbo_module.total_call_count",
            "turbo_modules.total_call_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 42,
        examples: [
            42
        ],
        deprecation: {
            replacement: "react_native.module.call.count",
            reason: "Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix",
            status: "backfill"
        },
        aliases: [
            "react_native.module.call.count",
            "turbo_module.total_call_count"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_modules.total_call_count and deprecated it in favor of react_native.module.call.count"
            }
        ]
    },
    "turbo_modules.total_duration_ms": {
        brief: "The combined duration of all native module calls in the flushed call aggregate, in milliseconds. Only applies to React Native.",
        type: "double",
        keys: [
            "react_native.module.duration.total",
            "turbo_module.total_duration_ms",
            "turbo_modules.total_duration_ms"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128.45,
        examples: [
            128.45
        ],
        deprecation: {
            replacement: "react_native.module.duration.total",
            reason: "Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix",
            status: "backfill"
        },
        aliases: [
            "react_native.module.duration.total",
            "turbo_module.total_duration_ms"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_modules.total_duration_ms and deprecated it in favor of react_native.module.duration.total"
            }
        ]
    },
    "turbo_modules.total_error_count": {
        brief: "The number of failed native module calls in the flushed call aggregate. Only applies to React Native.",
        type: "integer",
        keys: [
            "react_native.module.error.count",
            "turbo_module.total_error_count",
            "turbo_modules.total_error_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        examples: [
            2
        ],
        deprecation: {
            replacement: "react_native.module.error.count",
            reason: "Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix",
            status: "backfill"
        },
        aliases: [
            "react_native.module.error.count",
            "turbo_module.total_error_count"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_modules.total_error_count and deprecated it in favor of react_native.module.error.count"
            }
        ]
    },
    "turbo_modules.unique_methods": {
        brief: "The number of distinct native module and method pairs in the flushed call aggregate. Only applies to React Native.",
        type: "integer",
        keys: [
            "react_native.module.call.distinct_count",
            "turbo_module.unique_methods",
            "turbo_modules.unique_methods"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7,
        examples: [
            7
        ],
        deprecation: {
            replacement: "react_native.module.call.distinct_count",
            reason: "Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix",
            status: "backfill"
        },
        aliases: [
            "react_native.module.call.distinct_count",
            "turbo_module.unique_methods"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_modules.unique_methods and deprecated it in favor of react_native.module.call.distinct_count"
            }
        ]
    },
    "turbo_module.arch": {
        brief: "The React Native architecture the call was observed on. `new` for a TurboModule resolved through `TurboModuleRegistry`, `legacy` for a module reached over the Old Architecture bridge. Only applies to React Native.",
        type: "string",
        keys: [
            "react_native.architecture",
            "turbo_module.arch"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "new",
        examples: [
            "new",
            "legacy"
        ],
        deprecation: {
            replacement: "react_native.architecture",
            reason: "Replaced by the `react_native.*` namespace, which also covers native module calls made over the Old Architecture bridge, which are not TurboModules",
            status: "backfill"
        },
        aliases: [
            "react_native.architecture"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_module.arch and deprecated it in favor of react_native.architecture"
            }
        ]
    },
    "turbo_module.method": {
        brief: "The name of the native module method that was called. Only applies to React Native.",
        type: "string",
        keys: [
            "react_native.module.method",
            "turbo_module.method"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable"
        },
        isInOtel: !1,
        visibility: "public",
        example: "getUniqueId",
        examples: [
            "getUniqueId"
        ],
        deprecation: {
            replacement: "react_native.module.method",
            reason: "Replaced by the `react_native.*` namespace, which also covers native module calls made over the Old Architecture bridge, which are not TurboModules",
            status: "backfill"
        },
        aliases: [
            "react_native.module.method"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_module.method and deprecated it in favor of react_native.module.method"
            }
        ]
    },
    "turbo_module.name": {
        brief: "The name of the native module the call was dispatched to. On the New Architecture this is the TurboModule name, on the Old Architecture the `NativeModules` key. Only applies to React Native.",
        type: "string",
        keys: [
            "react_native.module.name",
            "turbo_module.name"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable"
        },
        isInOtel: !1,
        visibility: "public",
        example: "RNDeviceInfo",
        examples: [
            "RNDeviceInfo"
        ],
        deprecation: {
            replacement: "react_native.module.name",
            reason: "Replaced by the `react_native.*` namespace, which also covers native module calls made over the Old Architecture bridge, which are not TurboModules",
            status: "backfill"
        },
        aliases: [
            "react_native.module.name"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_module.name and deprecated it in favor of react_native.module.name"
            }
        ]
    },
    "turbo_module.top_module": {
        brief: "The native module and method that accounted for the most total duration during the lifetime of the span. Only applies to React Native.",
        type: "string",
        keys: [
            "react_native.module.top.name",
            "turbo_module.top_module"
        ],
        applyScrubbing: {
            key: "manual",
            reason: "Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable"
        },
        isInOtel: !1,
        visibility: "public",
        example: "RNDeviceInfo.getUniqueId",
        examples: [
            "RNDeviceInfo.getUniqueId"
        ],
        deprecation: {
            replacement: "react_native.module.top.name",
            reason: "Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping",
            status: "backfill"
        },
        aliases: [
            "react_native.module.top.name"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_module.top_module and deprecated it in favor of react_native.module.top.name"
            }
        ]
    },
    "turbo_module.top_module_duration_ms": {
        brief: "The total duration attributed to the top native module method, in milliseconds. Only applies to React Native.",
        type: "double",
        keys: [
            "react_native.module.top.duration",
            "turbo_module.top_module_duration_ms"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 87.25,
        examples: [
            87.25
        ],
        deprecation: {
            replacement: "react_native.module.top.duration",
            reason: "Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping",
            status: "backfill"
        },
        aliases: [
            "react_native.module.top.duration"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_module.top_module_duration_ms and deprecated it in favor of react_native.module.top.duration"
            }
        ]
    },
    "turbo_module.total_call_count": {
        brief: "The number of native module calls observed during the lifetime of the span. Only applies to React Native.",
        type: "integer",
        keys: [
            "react_native.module.call.count",
            "turbo_module.total_call_count",
            "turbo_modules.total_call_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 42,
        examples: [
            42
        ],
        deprecation: {
            replacement: "react_native.module.call.count",
            reason: "Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping",
            status: "backfill"
        },
        aliases: [
            "react_native.module.call.count",
            "turbo_modules.total_call_count"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_module.total_call_count and deprecated it in favor of react_native.module.call.count"
            }
        ]
    },
    "turbo_module.total_duration_ms": {
        brief: "The combined duration of all native module calls observed during the lifetime of the span, in milliseconds. Only applies to React Native.",
        type: "double",
        keys: [
            "react_native.module.duration.total",
            "turbo_module.total_duration_ms",
            "turbo_modules.total_duration_ms"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 128.45,
        examples: [
            128.45
        ],
        deprecation: {
            replacement: "react_native.module.duration.total",
            reason: "Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping",
            status: "backfill"
        },
        aliases: [
            "react_native.module.duration.total",
            "turbo_modules.total_duration_ms"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_module.total_duration_ms and deprecated it in favor of react_native.module.duration.total"
            }
        ]
    },
    "turbo_module.total_error_count": {
        brief: "The number of native module calls that failed during the lifetime of the span. Only applies to React Native.",
        type: "integer",
        keys: [
            "react_native.module.error.count",
            "turbo_module.total_error_count",
            "turbo_modules.total_error_count"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 2,
        examples: [
            2
        ],
        deprecation: {
            replacement: "react_native.module.error.count",
            reason: "Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping",
            status: "backfill"
        },
        aliases: [
            "react_native.module.error.count",
            "turbo_modules.total_error_count"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_module.total_error_count and deprecated it in favor of react_native.module.error.count"
            }
        ]
    },
    "turbo_module.unique_methods": {
        brief: "The number of distinct native module and method pairs called during the lifetime of the span. Only applies to React Native.",
        type: "integer",
        keys: [
            "react_native.module.call.distinct_count",
            "turbo_module.unique_methods",
            "turbo_modules.unique_methods"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 7,
        examples: [
            7
        ],
        deprecation: {
            replacement: "react_native.module.call.distinct_count",
            reason: "Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping",
            status: "backfill"
        },
        aliases: [
            "react_native.module.call.distinct_count",
            "turbo_modules.unique_methods"
        ],
        changelog: [
            {
                version: "0.24.0",
                prs: [
                    564
                ],
                description: "Added turbo_module.unique_methods and deprecated it in favor of react_native.module.call.distinct_count"
            }
        ]
    },
    type: {
        brief: "More granular type of the operation happening.",
        type: "string",
        keys: [
            "type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "fetch",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.component_name": {
        brief: "The name of the associated component.",
        type: "string",
        keys: [
            "ui.component_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "HomeButton",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttfd": {
        brief: "Whether the span execution contributed to the TTFD (time to fully drawn) metric.",
        type: "boolean",
        keys: [
            "ui.contributes_to_ttfd"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.contributes_to_ttid": {
        brief: "Whether the span execution contributed to the TTID (time to initial display) metric.",
        type: "boolean",
        keys: [
            "ui.contributes_to_ttid"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "ui.element.height": {
        brief: "The height of the UI element (for Html in pixels)",
        type: "integer",
        keys: [
            "ui.element.height"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 256,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.height attribute"
            }
        ]
    },
    "ui.element.id": {
        brief: "The id of the UI element",
        type: "string",
        keys: [
            "ui.element.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "btn-login",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.id attribute"
            }
        ]
    },
    "ui.element.identifier": {
        brief: "The identifier used to measure the UI element timing",
        type: "string",
        keys: [
            "ui.element.identifier"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "heroImage",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.identifier attribute"
            }
        ]
    },
    "ui.element.load_time": {
        brief: "The loading time of a UI element (from time origin to finished loading)",
        type: "double",
        keys: [
            "ui.element.load_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 998.2234,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.load_time attribute"
            }
        ]
    },
    "ui.element.paint_type": {
        brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
        type: "string",
        keys: [
            "ui.element.paint_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "image-paint",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.paint_type attribute"
            }
        ]
    },
    "ui.element.render_time": {
        brief: "The rendering time of the UI element (from time origin to finished rendering)",
        type: "double",
        keys: [
            "ui.element.render_time"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1023.1124,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.render_time attribute"
            }
        ]
    },
    "ui.element.type": {
        brief: "type of the UI element",
        type: "string",
        keys: [
            "ui.element.type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "img",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.type attribute"
            }
        ]
    },
    "ui.element.url": {
        brief: "The URL of the UI element (e.g. an img src)",
        type: "string",
        keys: [
            "ui.element.url"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://assets.myapp.com/hero.png",
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.url attribute"
            }
        ]
    },
    "ui.element.width": {
        brief: "The width of the UI element (for HTML in pixels)",
        type: "integer",
        keys: [
            "ui.element.width"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 512,
        changelog: [
            {
                version: "0.5.0",
                prs: [
                    284
                ],
                description: "Added ui.element.width attribute"
            }
        ]
    },
    url: {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        keys: [
            "url.full",
            "aws.request.url",
            "http.url",
            "messaging.url",
            "url"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        deprecation: {
            replacement: "url.full",
            status: "backfill"
        },
        aliases: [
            "url.full",
            "http.url",
            "aws.request.url",
            "messaging.url"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.url as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    61
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.domain": {
        brief: "Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.",
        type: "string",
        keys: [
            "url.domain"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "example.com",
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.fragment": {
        brief: "The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.",
        type: "string",
        keys: [
            "url.fragment"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "details",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.full": {
        brief: "The URL of the resource that was fetched.",
        type: "string",
        keys: [
            "url.full",
            "aws.request.url",
            "http.url",
            "messaging.url",
            "url"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https://example.com/test?foo=bar#buzz",
        aliases: [
            "http.url",
            "url",
            "aws.request.url",
            "messaging.url"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    581
                ],
                description: "Added messaging.url as an alias"
            },
            {
                version: "0.19.0",
                prs: [
                    488
                ],
                description: "Added aws.request.url as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    108
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path": {
        brief: "The URI path component.",
        type: "string",
        keys: [
            "url.path"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/foo",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.path.parameter.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        keys: [
            "url.path.parameter.<key>",
            "params.<key>",
            "url.path.params.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.parameter.id='123'",
        aliases: [
            "params.<key>",
            "url.path.params.<key>"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    586
                ],
                description: "Added url.path.params.<key> as an alias"
            },
            {
                version: "0.1.0",
                prs: [
                    103
                ]
            }
        ]
    },
    "url.path.params.<key>": {
        brief: "Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.",
        type: "string",
        keys: [
            "url.path.parameter.<key>",
            "params.<key>",
            "url.path.params.<key>"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        hasDynamicSuffix: !0,
        example: "url.path.params.id='123'",
        examples: [
            "url.path.params.id='123'"
        ],
        deprecation: {
            replacement: "url.path.parameter.<key>",
            reason: "This attribute is being deprecated in favor of url.path.parameter.<key>.",
            status: "backfill"
        },
        aliases: [
            "url.path.parameter.<key>",
            "params.<key>"
        ],
        changelog: [
            {
                version: "0.21.0",
                prs: [
                    586
                ],
                description: "Added url.path.params.<key> attribute"
            }
        ]
    },
    "url.port": {
        brief: "Server port number.",
        type: "integer",
        keys: [
            "url.port"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: 1337,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.query": {
        brief: "The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.",
        type: "string",
        keys: [
            "url.query"
        ],
        applyScrubbing: {
            key: "auto",
            reason: "Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information."
        },
        isInOtel: !0,
        visibility: "public",
        example: "foo=bar&bar=baz",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "url.same_origin": {
        brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
        type: "boolean",
        keys: [
            "http.request.same_origin",
            "url.same_origin"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: !0,
        deprecation: {
            replacement: "http.request.same_origin",
            reason: "This attribute is being deprecated in favor of http.request.same_origin.",
            status: "backfill"
        },
        aliases: [
            "http.request.same_origin"
        ],
        changelog: [
            {
                version: "0.16.0",
                prs: [
                    456
                ],
                description: "Added url.same_origin attribute, deprecated in favor of http.request.same_origin"
            }
        ]
    },
    "url.scheme": {
        brief: "The URI scheme component identifying the used protocol.",
        type: "string",
        keys: [
            "url.scheme",
            "http.scheme"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "https",
        aliases: [
            "http.scheme"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "url.template": {
        brief: "The low-cardinality template of an absolute URL path reference.",
        type: "string",
        keys: [
            "url.template"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "/users/{id}",
        examples: [
            "/users/{id}",
            "/users/:id",
            "/about"
        ],
        changelog: [
            {
                version: "0.19.0",
                prs: [
                    505,
                    521
                ],
                description: "Added multiple examples, removed alias to `http.route`, added additional context"
            },
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ],
        additionalContext: [
            "This attribute should primarily be set by client-side routing instrumentation, or `http.client` spans (if applicable).",
            "Use `http.route` for server-side instrumentation that captures the framework route of an incoming request."
        ]
    },
    "user_agent.original": {
        brief: "Value of the HTTP User-Agent header sent by the client.",
        type: "string",
        keys: [
            "user_agent.original",
            "http.user_agent"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !0,
        visibility: "public",
        example: "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1",
        aliases: [
            "http.user_agent"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    127
                ]
            },
            {
                version: "0.0.0"
            }
        ]
    },
    "user.email": {
        brief: "User email address.",
        type: "string",
        keys: [
            "user.email",
            "sentry.user.email"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "test@example.com",
        aliases: [
            "sentry.user.email"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.full_name": {
        brief: "User's full name.",
        type: "string",
        keys: [
            "user.full_name"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "John Smith",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.city": {
        brief: "Human readable city name.",
        type: "string",
        keys: [
            "user.geo.city",
            "sentry.user.geo.city"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Toronto",
        aliases: [
            "sentry.user.geo.city"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.country_code": {
        brief: "Two-letter country code (ISO 3166-1 alpha-2).",
        type: "string",
        keys: [
            "user.geo.country_code",
            "sentry.user.geo.country_code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "CA",
        aliases: [
            "sentry.user.geo.country_code"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.region": {
        brief: "Human readable region name or code.",
        type: "string",
        keys: [
            "user.geo.region",
            "sentry.user.geo.region"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Canada",
        aliases: [
            "sentry.user.geo.region"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.geo.subdivision": {
        brief: "Human readable subdivision name.",
        type: "string",
        keys: [
            "user.geo.subdivision",
            "sentry.user.geo.subdivision"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "Ontario",
        aliases: [
            "sentry.user.geo.subdivision"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.hash": {
        brief: "Unique user hash to correlate information for a user in anonymized form.",
        type: "string",
        keys: [
            "user.hash"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d",
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.id": {
        brief: "Unique identifier of the user.",
        type: "string",
        keys: [
            "user.id",
            "sentry.user.id"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "S-1-5-21-202424912787-2692429404-2351956786-1000",
        aliases: [
            "sentry.user.id"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.ip_address": {
        brief: "The IP address of the user.",
        type: "string",
        keys: [
            "user.ip_address",
            "sentry.user.ip",
            "user.ip"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "192.168.1.1",
        aliases: [
            "sentry.user.ip"
        ],
        changelog: [
            {
                version: "0.1.0",
                prs: [
                    75
                ]
            }
        ]
    },
    "user.name": {
        brief: "Short name or login/username of the user.",
        type: "string",
        keys: [
            "user.name",
            "sentry.user.username",
            "user.username"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: "j.smith",
        aliases: [
            "sentry.user.username"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "user.roles": {
        brief: "Array of user roles at the time of the event.",
        type: "string[]",
        keys: [
            "user.roles"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !0,
        visibility: "public",
        example: [
            "admin",
            "editor"
        ],
        changelog: [
            {
                version: "0.0.0"
            }
        ]
    },
    "vercel.branch": {
        brief: "Git branch name for Vercel project",
        type: "string",
        keys: [
            "vercel.branch"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "main",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.build_id": {
        brief: "Identifier for the Vercel build (only present on build logs)",
        type: "string",
        keys: [
            "vercel.build_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "bld_cotnkcr76",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.deployment_id": {
        brief: "Identifier for the Vercel deployment",
        type: "string",
        keys: [
            "vercel.deployment_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "dpl_233NRGRjVZX1caZrXWtz5g1TAksD",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.destination": {
        brief: "Origin of the external content in Vercel (only on external logs)",
        type: "string",
        keys: [
            "vercel.destination"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https://vitals.vercel-insights.com/v1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.edge_type": {
        brief: "Type of edge runtime in Vercel",
        type: "string",
        keys: [
            "vercel.edge_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "edge-function",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.entrypoint": {
        brief: "Entrypoint for the request in Vercel",
        type: "string",
        keys: [
            "vercel.entrypoint"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api/index.js",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.execution_region": {
        brief: "Region where the request is executed",
        type: "string",
        keys: [
            "vercel.execution_region"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.id": {
        brief: "Unique identifier for the log entry in Vercel",
        type: "string",
        keys: [
            "vercel.id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "1573817187330377061717300000",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja3_digest": {
        brief: "JA3 fingerprint digest of Vercel request",
        type: "string",
        keys: [
            "vercel.ja3_digest"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.ja4_digest": {
        brief: "JA4 fingerprint digest",
        type: "string",
        keys: [
            "vercel.ja4_digest"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "t13d1516h2_8daaf6152771_02713d6af862",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.log_type": {
        brief: "Vercel log output type",
        type: "string",
        keys: [
            "vercel.log_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "stdout",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.path": {
        brief: "Function or dynamic path of the request in Vercel.",
        type: "string",
        keys: [
            "vercel.path"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/[route].json",
        changelog: [
            {
                version: "0.6.0",
                prs: [
                    349
                ],
                description: "Added vercel.path attribute"
            }
        ]
    },
    "vercel.project_id": {
        brief: "Identifier for the Vercel project",
        type: "string",
        keys: [
            "vercel.project_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "gdufoJxB6b9b1fEqr1jUtFkyavUU",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.project_name": {
        brief: "Name of the Vercel project",
        type: "string",
        keys: [
            "vercel.project_name"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "my-app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.cache_id": {
        brief: "Original request ID when request is served from cache",
        type: "string",
        keys: [
            "vercel.proxy.cache_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "pdx1::v8g4b-1744143786684-93dafbc0f70d",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.client_ip": {
        brief: "Client IP address",
        type: "string",
        keys: [
            "vercel.proxy.client_ip"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "120.75.16.101",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.host": {
        brief: "Hostname of the request",
        type: "string",
        keys: [
            "vercel.proxy.host"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "test.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.lambda_region": {
        brief: "Region where lambda function executed",
        type: "string",
        keys: [
            "vercel.proxy.lambda_region"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.method": {
        brief: "HTTP method of the request",
        type: "string",
        keys: [
            "vercel.proxy.method"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "GET",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path": {
        brief: "Request path with query parameters",
        type: "string",
        keys: [
            "vercel.proxy.path"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "/dynamic/some-value.json?route=some-value",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type": {
        brief: "How the request was served based on its path and project configuration",
        type: "string",
        keys: [
            "vercel.proxy.path_type"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "func",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.path_type_variant": {
        brief: "Variant of the path type",
        type: "string",
        keys: [
            "vercel.proxy.path_type_variant"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "api",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.referer": {
        brief: "Referer of the request",
        type: "string",
        keys: [
            "vercel.proxy.referer"
        ],
        applyScrubbing: {
            key: "auto"
        },
        isInOtel: !1,
        visibility: "public",
        example: "*.vercel.app",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.region": {
        brief: "Region where the request is processed",
        type: "string",
        keys: [
            "vercel.proxy.region"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.response_byte_size": {
        brief: "Size of the response in bytes",
        type: "integer",
        keys: [
            "vercel.proxy.response_byte_size"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1024,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.scheme": {
        brief: "Protocol of the request",
        type: "string",
        keys: [
            "vercel.proxy.scheme"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "https",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.status_code": {
        brief: "HTTP status code of the proxy request",
        type: "integer",
        keys: [
            "vercel.proxy.status_code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.timestamp": {
        brief: "Unix timestamp when the proxy request was made",
        type: "integer",
        keys: [
            "vercel.proxy.timestamp"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 1573817250172,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.user_agent": {
        brief: "User agent strings of the request",
        type: "string[]",
        keys: [
            "vercel.proxy.user_agent"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: [
            "Mozilla/5.0..."
        ],
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_cache": {
        brief: "Cache status sent to the browser",
        type: "string",
        keys: [
            "vercel.proxy.vercel_cache"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "REVALIDATED",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.vercel_id": {
        brief: "Vercel-specific identifier",
        type: "string",
        keys: [
            "vercel.proxy.vercel_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "sfo1::abc123",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_action": {
        brief: "Action taken by firewall rules",
        type: "string",
        keys: [
            "vercel.proxy.waf_action"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "deny",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.proxy.waf_rule_id": {
        brief: "ID of the firewall rule that matched",
        type: "string",
        keys: [
            "vercel.proxy.waf_rule_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "rule_gAHz8jtSB1Gy",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.request_id": {
        brief: "Identifier of the Vercel request",
        type: "string",
        keys: [
            "vercel.request_id"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "643af4e3-975a-4cc7-9e7a-1eda11539d90",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.source": {
        brief: "Origin of the Vercel log (build, edge, lambda, static, external, or firewall)",
        type: "string",
        keys: [
            "vercel.source"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: "build",
        changelog: [
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    },
    "vercel.status_code": {
        brief: "HTTP status code of the request (-1 means no response returned and the lambda crashed)",
        type: "integer",
        keys: [
            "vercel.status_code"
        ],
        applyScrubbing: {
            key: "manual"
        },
        isInOtel: !1,
        visibility: "public",
        example: 200,
        changelog: [
            {
                version: "0.4.0",
                prs: [
                    228
                ]
            },
            {
                version: "0.2.0",
                prs: [
                    163
                ]
            }
        ]
    }
};
$68aec2772563966a$export$13e35b21ad6ab4fe = $68aec2772563966a$var$ADDRESS, $68aec2772563966a$export$b60c5e9f9b7b58bd = $68aec2772563966a$var$AI_CITATIONS, $68aec2772563966a$export$cc06afd6de7f2c10 = $68aec2772563966a$var$AI_COMPLETION_TOKENS_USED, $68aec2772563966a$export$ced6746028fe2cc = $68aec2772563966a$var$AI_DOCUMENTS, $68aec2772563966a$export$e6f4aa4f4fcb6da8 = $68aec2772563966a$var$AI_FINISH_REASON, $68aec2772563966a$export$f02d892201cd8d36 = $68aec2772563966a$var$AI_FREQUENCY_PENALTY, $68aec2772563966a$export$f277a7ef9e273960 = $68aec2772563966a$var$AI_FUNCTION_CALL, $68aec2772563966a$export$1a8c212c3becaa80 = $68aec2772563966a$var$AI_GENERATION_ID, $68aec2772563966a$export$721b137086c68a47 = $68aec2772563966a$var$AI_INPUT_MESSAGES, $68aec2772563966a$export$6afde2bb69d9aa86 = $68aec2772563966a$var$AI_IS_SEARCH_REQUIRED, $68aec2772563966a$export$eadb4b562c974031 = $68aec2772563966a$var$AI_METADATA, $68aec2772563966a$export$22a90f0ac1eee843 = $68aec2772563966a$var$AI_MODEL_ID, $68aec2772563966a$export$a727f215a0be1dad = $68aec2772563966a$var$AI_MODEL_PROVIDER, $68aec2772563966a$export$536bc61b34d995e5 = $68aec2772563966a$var$AI_PIPELINE_NAME, $68aec2772563966a$export$c43ea6115b380e62 = $68aec2772563966a$var$AI_PREAMBLE, $68aec2772563966a$export$d2a16e26bada7cf1 = $68aec2772563966a$var$AI_PRESENCE_PENALTY, $68aec2772563966a$export$877414c19c336240 = $68aec2772563966a$var$AI_PROMPT, $68aec2772563966a$export$1498f8372e4fee19 = $68aec2772563966a$var$AI_PROMPT_MESSAGES, $68aec2772563966a$export$604eb1bd2278163b = $68aec2772563966a$var$AI_PROMPT_TOKENS_USED, $68aec2772563966a$export$c6fb15d10a4d52fb = $68aec2772563966a$var$AI_PROMPT_TOOLS, $68aec2772563966a$export$2f8568696c5aa352 = $68aec2772563966a$var$AI_RAW_PROMPTING, $68aec2772563966a$export$ccc8efd7dd31d3a9 = $68aec2772563966a$var$AI_RESPONSES, $68aec2772563966a$export$e176bf5dc45e40df = $68aec2772563966a$var$AI_RESPONSE_FORMAT, $68aec2772563966a$export$2d16fe6a423eac16 = $68aec2772563966a$var$AI_RESPONSE_ID, $68aec2772563966a$export$40c10cc901ec8391 = $68aec2772563966a$var$AI_RESPONSE_MODEL, $68aec2772563966a$export$e1b5b90d002f47d3 = $68aec2772563966a$var$AI_RESPONSE_OBJECT, $68aec2772563966a$export$8028cf93afd5c238 = $68aec2772563966a$var$AI_RESPONSE_TEXT, $68aec2772563966a$export$5cd566e59be6c821 = $68aec2772563966a$var$AI_RESPONSE_TIMESTAMP, $68aec2772563966a$export$388cc595db1f932c = $68aec2772563966a$var$AI_RESPONSE_TOOLCALLS, $68aec2772563966a$export$a936650e1567c02b = $68aec2772563966a$var$AI_SCHEMA, $68aec2772563966a$export$c4ea01fd53f64e16 = $68aec2772563966a$var$AI_SEARCH_QUERIES, $68aec2772563966a$export$bb5e6f2f31a15da9 = $68aec2772563966a$var$AI_SEARCH_RESULTS, $68aec2772563966a$export$1762c11b666b026a = $68aec2772563966a$var$AI_SEED, $68aec2772563966a$export$14ddd4b729910100 = $68aec2772563966a$var$AI_STREAMING, $68aec2772563966a$export$5311d7c8e1f8eabb = $68aec2772563966a$var$AI_TAGS, $68aec2772563966a$export$2b748b9eca00828b = $68aec2772563966a$var$AI_TEMPERATURE, $68aec2772563966a$export$5af25308c11addea = $68aec2772563966a$var$AI_TEXTS, $68aec2772563966a$export$a51938f8e97cb2e = $68aec2772563966a$var$AI_TOOLCALL_ARGS, $68aec2772563966a$export$6fe9e1ed3c313f24 = $68aec2772563966a$var$AI_TOOLCALL_RESULT, $68aec2772563966a$export$28f78b3b1663cb92 = $68aec2772563966a$var$AI_TOOLS, $68aec2772563966a$export$a1d3f09f0f1f066f = $68aec2772563966a$var$AI_TOOL_CALLS, $68aec2772563966a$export$322bd4ea9f163663 = $68aec2772563966a$var$AI_TOP_K, $68aec2772563966a$export$95711b9e669edad8 = $68aec2772563966a$var$AI_TOP_P, $68aec2772563966a$export$5924d7d72384626a = $68aec2772563966a$var$AI_TOTAL_COST, $68aec2772563966a$export$db3b1b877a4ce4db = $68aec2772563966a$var$AI_TOTAL_TOKENS_USED, $68aec2772563966a$export$8fbf006bb94d3322 = $68aec2772563966a$var$AI_USAGE_TOKENS, $68aec2772563966a$export$32ce2b08edad22f = $68aec2772563966a$var$AI_VALUES, $68aec2772563966a$export$a434a3e8afec2879 = $68aec2772563966a$var$AI_WARNINGS, $68aec2772563966a$export$fe00bb20636d42af = $68aec2772563966a$var$ANGULAR_VERSION, $68aec2772563966a$export$712aa698b7ee271e = $68aec2772563966a$var$APP_APP_BUILD, $68aec2772563966a$export$1fac638b11ec16d9 = $68aec2772563966a$var$APP_APP_IDENTIFIER, $68aec2772563966a$export$d132016ea64058e3 = $68aec2772563966a$var$APP_APP_NAME, $68aec2772563966a$export$53f2f47ec3b2f9ed = $68aec2772563966a$var$APP_APP_START_TIME, $68aec2772563966a$export$9f80c4b11053cef1 = $68aec2772563966a$var$APP_APP_VERSION, $68aec2772563966a$export$5f7a08466d84e877 = $68aec2772563966a$var$APP_BUILD, $68aec2772563966a$export$2cea7f14750b8c19 = $68aec2772563966a$var$APP_IDENTIFIER, $68aec2772563966a$export$34c59270f032a6c6 = $68aec2772563966a$var$APP_IN_FOREGROUND, $68aec2772563966a$export$5b6c28c7dca07ad7 = $68aec2772563966a$var$APP_NAME, $68aec2772563966a$export$1dc8ae58b58d6c50 = $68aec2772563966a$var$APP_START_COLD, $68aec2772563966a$export$ba267414e3c0d822 = $68aec2772563966a$var$APP_START_TIME, $68aec2772563966a$export$71b176005902b99e = $68aec2772563966a$var$APP_START_TYPE, $68aec2772563966a$export$5c5b5a3c245a0079 = $68aec2772563966a$var$APP_START_WARM, $68aec2772563966a$export$8ee1df3c6367a60 = $68aec2772563966a$var$APP_VERSION, $68aec2772563966a$export$e8c7802ae95beccf = $68aec2772563966a$var$APP_VITALS_FRAMES_DELAY_VALUE, $68aec2772563966a$export$bb237734da4d464 = $68aec2772563966a$var$APP_VITALS_FRAMES_FROZEN_COUNT, $68aec2772563966a$export$e8f43f7d235efa53 = $68aec2772563966a$var$APP_VITALS_FRAMES_FROZEN_RATE, $68aec2772563966a$export$cdaaf6d1fdcba0b6 = $68aec2772563966a$var$APP_VITALS_FRAMES_SLOW_COUNT, $68aec2772563966a$export$be392f76344cb225 = $68aec2772563966a$var$APP_VITALS_FRAMES_SLOW_RATE, $68aec2772563966a$export$36223ebd4a30e9f5 = $68aec2772563966a$var$APP_VITALS_FRAMES_TOTAL_COUNT, $68aec2772563966a$export$d4496a3605a4ce4a = $68aec2772563966a$var$APP_VITALS_STALL_DURATION, $68aec2772563966a$export$daee97894fa9844 = $68aec2772563966a$var$APP_VITALS_STALL_PERCENTAGE, $68aec2772563966a$export$8feaa177bb7941e2 = $68aec2772563966a$var$APP_VITALS_START_COLD_VALUE, $68aec2772563966a$export$e1ca25240db91d68 = $68aec2772563966a$var$APP_VITALS_START_PREWARMED, $68aec2772563966a$export$404a223fd1ada08b = $68aec2772563966a$var$APP_VITALS_START_REASON, $68aec2772563966a$export$53362079310c68 = $68aec2772563966a$var$APP_VITALS_START_SCREEN, $68aec2772563966a$export$3efb5af0ac379f77 = $68aec2772563966a$var$APP_VITALS_START_TYPE, $68aec2772563966a$export$2c10c1ca0612c46d = $68aec2772563966a$var$APP_VITALS_START_WARM_VALUE, $68aec2772563966a$export$bbb86ad4d6654da6 = $68aec2772563966a$var$APP_VITALS_TTFD_VALUE, $68aec2772563966a$export$ad6896f00a2b1076 = $68aec2772563966a$var$APP_VITALS_TTID_VALUE, $68aec2772563966a$export$300f39d8506a273d = $68aec2772563966a$var$ART_GC_BLOCKING_COUNT, $68aec2772563966a$export$ecaa0e7f4773ddc7 = $68aec2772563966a$var$ART_GC_BLOCKING_TIME, $68aec2772563966a$export$74b78acb4c54c06b = $68aec2772563966a$var$ART_GC_PRE_OOME_COUNT, $68aec2772563966a$export$b15b2c133bc50e33 = $68aec2772563966a$var$ART_GC_TOTAL_COUNT, $68aec2772563966a$export$5f1381d9ae1b1c95 = $68aec2772563966a$var$ART_GC_TOTAL_TIME, $68aec2772563966a$export$c170b7ff277132ea = $68aec2772563966a$var$ART_GC_WAITING_TIME, $68aec2772563966a$export$9459a5df93695e45 = $68aec2772563966a$var$ART_MEMORY_FREE, $68aec2772563966a$export$a7902bd57492ebe8 = $68aec2772563966a$var$ART_MEMORY_FREE_UNTIL_GC, $68aec2772563966a$export$d2ace0da59da09b7 = $68aec2772563966a$var$ART_MEMORY_FREE_UNTIL_OOME, $68aec2772563966a$export$c15dd8d2461e0aeb = $68aec2772563966a$var$ART_MEMORY_MAX, $68aec2772563966a$export$5405b0a98e00e538 = $68aec2772563966a$var$ART_MEMORY_TOTAL, $68aec2772563966a$export$bd393bbb84b309d3 = $68aec2772563966a$var$ATTRIBUTE_METADATA, $68aec2772563966a$export$96f586f8837b86ae = $68aec2772563966a$var$ATTRIBUTE_TYPE, $68aec2772563966a$export$5d9f28f388f552d2 = $68aec2772563966a$var$AWS_CLOUDWATCH_LOGS_LOG_GROUP, $68aec2772563966a$export$b3d2f68e0e769504 = $68aec2772563966a$var$AWS_CLOUDWATCH_LOGS_LOG_STREAM, $68aec2772563966a$export$2c98412ed43013e8 = $68aec2772563966a$var$AWS_CLOUDWATCH_LOGS_URL, $68aec2772563966a$export$a7bd794d11c19f1b = $68aec2772563966a$var$AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS, $68aec2772563966a$export$df4227832b83fdd0 = $68aec2772563966a$var$AWS_DYNAMODB_CONSISTENT_READ, $68aec2772563966a$export$f131a6d8fbc0534f = $68aec2772563966a$var$AWS_DYNAMODB_CONSUMED_CAPACITY, $68aec2772563966a$export$9bdc66d4a70e7e3a = $68aec2772563966a$var$AWS_DYNAMODB_COUNT, $68aec2772563966a$export$bfbbc3cbcaa90e98 = $68aec2772563966a$var$AWS_DYNAMODB_EXCLUSIVE_START_TABLE, $68aec2772563966a$export$3565fa72459aa4d6 = $68aec2772563966a$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES, $68aec2772563966a$export$bb67a834ae4bffdc = $68aec2772563966a$var$AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES, $68aec2772563966a$export$4a06c859a283f06 = $68aec2772563966a$var$AWS_DYNAMODB_INDEX_NAME, $68aec2772563966a$export$68324fac2038d0f2 = $68aec2772563966a$var$AWS_DYNAMODB_ITEM_COLLECTION_METRICS, $68aec2772563966a$export$5e1bd62ffd2786fb = $68aec2772563966a$var$AWS_DYNAMODB_LIMIT, $68aec2772563966a$export$bfdf2261058f56b = $68aec2772563966a$var$AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES, $68aec2772563966a$export$23bf57842d9d53df = $68aec2772563966a$var$AWS_DYNAMODB_PROJECTION, $68aec2772563966a$export$bfbd7e060eeb4d35 = $68aec2772563966a$var$AWS_DYNAMODB_PROVISIONED_READ_CAPACITY, $68aec2772563966a$export$82eb6cccda27c3ff = $68aec2772563966a$var$AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY, $68aec2772563966a$export$8ea68734d455808f = $68aec2772563966a$var$AWS_DYNAMODB_SCANNED_COUNT, $68aec2772563966a$export$40050e29324d44ee = $68aec2772563966a$var$AWS_DYNAMODB_SCAN_FORWARD, $68aec2772563966a$export$5cd7541006d9f467 = $68aec2772563966a$var$AWS_DYNAMODB_SEGMENT, $68aec2772563966a$export$81c017edd95d692e = $68aec2772563966a$var$AWS_DYNAMODB_SELECT, $68aec2772563966a$export$120b3897a58cf903 = $68aec2772563966a$var$AWS_DYNAMODB_TABLE_COUNT, $68aec2772563966a$export$d4a9de43b4b1076c = $68aec2772563966a$var$AWS_DYNAMODB_TABLE_NAMES, $68aec2772563966a$export$f37f4f9022f1ab17 = $68aec2772563966a$var$AWS_DYNAMODB_TOTAL_SEGMENTS, $68aec2772563966a$export$66ac18da14747cfb = $68aec2772563966a$var$AWS_EXTENDED_REQUEST_ID, $68aec2772563966a$export$9e49b833525ca49d = $68aec2772563966a$var$AWS_KINESIS_STREAM_NAME, $68aec2772563966a$export$b084fea5b3097227 = $68aec2772563966a$var$AWS_LAMBDA_AWS_REQUEST_ID, $68aec2772563966a$export$e09cd8615652e8d0 = $68aec2772563966a$var$AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS, $68aec2772563966a$export$a43a60ec723a90ee = $68aec2772563966a$var$AWS_LAMBDA_FUNCTION_NAME, $68aec2772563966a$export$34cc955357266287 = $68aec2772563966a$var$AWS_LAMBDA_FUNCTION_VERSION, $68aec2772563966a$export$d9dd218693ea9bba = $68aec2772563966a$var$AWS_LAMBDA_INVOKED_ARN, $68aec2772563966a$export$c9649b7156282a2f = $68aec2772563966a$var$AWS_LAMBDA_INVOKED_FUNCTION_ARN, $68aec2772563966a$export$daa8ce1f8adc553e = $68aec2772563966a$var$AWS_LAMBDA_REMAINING_TIME_IN_MILLIS, $68aec2772563966a$export$cb93c7b05db202cf = $68aec2772563966a$var$AWS_LOG_GROUP_NAMES, $68aec2772563966a$export$930f9bd3cc2e5b3d = $68aec2772563966a$var$AWS_LOG_STREAM_NAMES, $68aec2772563966a$export$510ec6f90a56eedb = $68aec2772563966a$var$AWS_OPERATION_NAME, $68aec2772563966a$export$e3cc872f2ecbbd04 = $68aec2772563966a$var$AWS_REGION, $68aec2772563966a$export$48c6d4c44afdc0b = $68aec2772563966a$var$AWS_REQUEST_EXTENDED_ID, $68aec2772563966a$export$c78d41789fe4b1e4 = $68aec2772563966a$var$AWS_REQUEST_ID, $68aec2772563966a$export$953d105334798b18 = $68aec2772563966a$var$AWS_REQUEST_URL, $68aec2772563966a$export$f462d9921f1f7332 = $68aec2772563966a$var$AWS_S3_BUCKET, $68aec2772563966a$export$bc71f8df9a45e243 = $68aec2772563966a$var$AWS_SECRETSMANAGER_SECRET_ARN, $68aec2772563966a$export$ed840ec4a5f5d053 = $68aec2772563966a$var$AWS_SNS_TOPIC_ARN, $68aec2772563966a$export$c1a559a4f74a5e8e = $68aec2772563966a$var$AWS_STEP_FUNCTIONS_ACTIVITY_ARN, $68aec2772563966a$export$d1c007424092e3f5 = $68aec2772563966a$var$AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN, $68aec2772563966a$export$9ebb466ce954c49c = $68aec2772563966a$var$BLOCKED_MAIN_THREAD, $68aec2772563966a$export$d117453007717d8f = $68aec2772563966a$var$BROWSER_BFCACHE_FRAME, $68aec2772563966a$export$19cec2ad2bf22a37 = $68aec2772563966a$var$BROWSER_BFCACHE_NOT_RESTORED_REASON_COUNT, $68aec2772563966a$export$dc6e464b9f2085c2 = $68aec2772563966a$var$BROWSER_BFCACHE_OUTCOME, $68aec2772563966a$export$316882140da7c633 = $68aec2772563966a$var$BROWSER_BFCACHE_REASON, $68aec2772563966a$export$e9aafc7348984403 = $68aec2772563966a$var$BROWSER_NAME, $68aec2772563966a$export$40f2351e1d598630 = $68aec2772563966a$var$BROWSER_NAVIGATION_ID, $68aec2772563966a$export$ccbaf9e1e7d48f46 = $68aec2772563966a$var$BROWSER_NAVIGATION_TYPE, $68aec2772563966a$export$5655f37b28bcd3e = $68aec2772563966a$var$BROWSER_PAINT_TYPE, $68aec2772563966a$export$faaa46964f075237 = $68aec2772563966a$var$BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START, $68aec2772563966a$export$d28c4b3cc4431a87 = $68aec2772563966a$var$BROWSER_PERFORMANCE_TIME_ORIGIN, $68aec2772563966a$export$734b017b330c8fe6 = $68aec2772563966a$var$BROWSER_REPORT_TYPE, $68aec2772563966a$export$683ebdc48ba3758d = $68aec2772563966a$var$BROWSER_SCRIPT_INVOKER, $68aec2772563966a$export$be0263971250ef44 = $68aec2772563966a$var$BROWSER_SCRIPT_INVOKER_TYPE, $68aec2772563966a$export$36a0cbc35c405232 = $68aec2772563966a$var$BROWSER_SCRIPT_SOURCE_CHAR_POSITION, $68aec2772563966a$export$469f7765ba335497 = $68aec2772563966a$var$BROWSER_VERSION, $68aec2772563966a$export$fe6fe2b7af051610 = $68aec2772563966a$var$BROWSER_WEB_VITAL_CLS_REPORT_EVENT, $68aec2772563966a$export$8345821877c4dfad = $68aec2772563966a$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY, $68aec2772563966a$export$f6c188a7e02335cf = $68aec2772563966a$var$BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE, $68aec2772563966a$export$aaf709a8971e825f = $68aec2772563966a$var$BROWSER_WEB_VITAL_CLS_VALUE, $68aec2772563966a$export$def01b82f8c092f7 = $68aec2772563966a$var$BROWSER_WEB_VITAL_FCP_VALUE, $68aec2772563966a$export$23d4264c606a73a6 = $68aec2772563966a$var$BROWSER_WEB_VITAL_FP_VALUE, $68aec2772563966a$export$269a5d262a851975 = $68aec2772563966a$var$BROWSER_WEB_VITAL_INP_INTERACTION_TYPE, $68aec2772563966a$export$4635c18f8b9bf9fa = $68aec2772563966a$var$BROWSER_WEB_VITAL_INP_TARGET, $68aec2772563966a$export$af9ece53bb92f66b = $68aec2772563966a$var$BROWSER_WEB_VITAL_INP_VALUE, $68aec2772563966a$export$25421625a565b69 = $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_ELEMENT, $68aec2772563966a$export$ab0c90d873e69ccb = $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_ID, $68aec2772563966a$export$538c05cc8cb2a2bb = $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_LOAD_TIME, $68aec2772563966a$export$f86df4de196e1a7c = $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_RENDER_TIME, $68aec2772563966a$export$51e8aa8c0d65e7b8 = $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_REPORT_EVENT, $68aec2772563966a$export$99023486ecc470bd = $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_SIZE, $68aec2772563966a$export$2f6c85eaf382e81 = $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_URL, $68aec2772563966a$export$1158d57c0aed42be = $68aec2772563966a$var$BROWSER_WEB_VITAL_LCP_VALUE, $68aec2772563966a$export$d85c4f947ab776e3 = $68aec2772563966a$var$BROWSER_WEB_VITAL_TTFB_REQUEST_TIME, $68aec2772563966a$export$813ef8386d874918 = $68aec2772563966a$var$BROWSER_WEB_VITAL_TTFB_VALUE, $68aec2772563966a$export$7c2f74ff9251f64 = $68aec2772563966a$var$CACHE_HIT, $68aec2772563966a$export$85d6623900ff3afa = $68aec2772563966a$var$CACHE_ITEM_AGE, $68aec2772563966a$export$993f84dab107b880 = $68aec2772563966a$var$CACHE_ITEM_SIZE, $68aec2772563966a$export$7b9c2315e94d8d2f = $68aec2772563966a$var$CACHE_KEY, $68aec2772563966a$export$f01e5cd42b9ec146 = $68aec2772563966a$var$CACHE_OPERATION, $68aec2772563966a$export$edfab5e0feeeee5a = $68aec2772563966a$var$CACHE_TAGS, $68aec2772563966a$export$987f6b4367434b55 = $68aec2772563966a$var$CACHE_TTL, $68aec2772563966a$export$d9d145585d5022bb = $68aec2772563966a$var$CACHE_WRITE, $68aec2772563966a$export$44ffba16bd48dac6 = $68aec2772563966a$var$CHANNEL, $68aec2772563966a$export$3134892c5d2e251a = $68aec2772563966a$var$CLIENT_ADDRESS, $68aec2772563966a$export$8495028d10296058 = $68aec2772563966a$var$CLIENT_PORT, $68aec2772563966a$export$d6d0e4fcf46d490c = $68aec2772563966a$var$CLOUDFLARE_D1_DURATION, $68aec2772563966a$export$658dced473c19301 = $68aec2772563966a$var$CLOUDFLARE_D1_QUERY_TYPE, $68aec2772563966a$export$97b0f9c3fbe64076 = $68aec2772563966a$var$CLOUDFLARE_D1_ROWS_READ, $68aec2772563966a$export$cf2c95ed5efbe9eb = $68aec2772563966a$var$CLOUDFLARE_D1_ROWS_WRITTEN, $68aec2772563966a$export$880007904f61a388 = $68aec2772563966a$var$CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS, $68aec2772563966a$export$3e903b72d4d9e07d = $68aec2772563966a$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ, $68aec2772563966a$export$34da07180e0e56af = $68aec2772563966a$var$CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN, $68aec2772563966a$export$c49aafdaeb061953 = $68aec2772563966a$var$CLOUDFLARE_R2_BUCKET, $68aec2772563966a$export$ceb762c61de2f17f = $68aec2772563966a$var$CLOUDFLARE_R2_OPERATION, $68aec2772563966a$export$a5f54ccfb28c0caf = $68aec2772563966a$var$CLOUDFLARE_R2_REQUEST_DELIMITER, $68aec2772563966a$export$1c86a56857b024db = $68aec2772563966a$var$CLOUDFLARE_R2_REQUEST_KEY, $68aec2772563966a$export$7598f3464be47440 = $68aec2772563966a$var$CLOUDFLARE_R2_REQUEST_PART_NUMBER, $68aec2772563966a$export$b673289c971fc0ae = $68aec2772563966a$var$CLOUDFLARE_R2_REQUEST_PREFIX, $68aec2772563966a$export$98b23f3e6f0c2a6f = $68aec2772563966a$var$CLOUDFLARE_WORKFLOW_ATTEMPT, $68aec2772563966a$export$6ddeaf0498614ebb = $68aec2772563966a$var$CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF, $68aec2772563966a$export$97b78f78d64a7232 = $68aec2772563966a$var$CLOUDFLARE_WORKFLOW_RETRIES_DELAY, $68aec2772563966a$export$5147715be870fff7 = $68aec2772563966a$var$CLOUDFLARE_WORKFLOW_RETRIES_LIMIT, $68aec2772563966a$export$5276bb46e6096fba = $68aec2772563966a$var$CLOUDFLARE_WORKFLOW_TIMEOUT, $68aec2772563966a$export$cbcbc1f67a937cf3 = $68aec2772563966a$var$CLOUD_ACCOUNT_ID, $68aec2772563966a$export$226a2381b8f0cf78 = $68aec2772563966a$var$CLOUD_AVAILABILITY_ZONE, $68aec2772563966a$export$fd35512cae286064 = $68aec2772563966a$var$CLOUD_PLATFORM, $68aec2772563966a$export$de9bbf95ab1d81e = $68aec2772563966a$var$CLOUD_PROVIDER, $68aec2772563966a$export$47fb20e8d18d7d15 = $68aec2772563966a$var$CLOUD_REGION, $68aec2772563966a$export$9db7964e4b8cb849 = $68aec2772563966a$var$CLOUD_RESOURCE_ID, $68aec2772563966a$export$7139adf9d3bace41 = "cls", $68aec2772563966a$export$8ac3d09060e7f25d = $68aec2772563966a$var$CLS_SOURCE_KEY, $68aec2772563966a$export$dad0e4778ea23971 = $68aec2772563966a$var$CLS_SOURCE_KEY_BASE, $68aec2772563966a$export$ec5856072852bd7f = $68aec2772563966a$var$CODE, $68aec2772563966a$export$c14d903ccf9385a8 = $68aec2772563966a$var$CODE_FILEPATH, $68aec2772563966a$export$934cded0041affd7 = $68aec2772563966a$var$CODE_FILE_PATH, $68aec2772563966a$export$6386da1dcba88c9d = $68aec2772563966a$var$CODE_FUNCTION, $68aec2772563966a$export$a3371797e606e2 = $68aec2772563966a$var$CODE_FUNCTION_NAME, $68aec2772563966a$export$a5bbef0af83b23e5 = $68aec2772563966a$var$CODE_LINENO, $68aec2772563966a$export$91ed1f55874222a6 = $68aec2772563966a$var$CODE_LINE_NUMBER, $68aec2772563966a$export$23de81068d2aed1b = $68aec2772563966a$var$CODE_NAMESPACE, $68aec2772563966a$export$d738320e1fba9e9d = $68aec2772563966a$var$CONNECTIONTYPE, $68aec2772563966a$export$2eacdea75497e8a5 = $68aec2772563966a$var$CONNECTION_RTT, $68aec2772563966a$export$2bc3ea101f86c1d2 = $68aec2772563966a$var$CULTURE_CALENDAR, $68aec2772563966a$export$c54e27e8d90ee081 = $68aec2772563966a$var$CULTURE_DISPLAY_NAME, $68aec2772563966a$export$4943adcec371c2a6 = $68aec2772563966a$var$CULTURE_IS_24_HOUR_FORMAT, $68aec2772563966a$export$f000a5900d0480c2 = $68aec2772563966a$var$CULTURE_LOCALE, $68aec2772563966a$export$8f5234893868273b = $68aec2772563966a$var$CULTURE_TIMEZONE, $68aec2772563966a$export$1a35518f6e81e8c7 = $68aec2772563966a$var$DB_COLLECTION_NAME, $68aec2772563966a$export$5ee62d9d393aab9d = $68aec2772563966a$var$DB_CONNECTION_STRING, $68aec2772563966a$export$a2d90911eaae60fc = $68aec2772563966a$var$DB_DRIVER_NAME, $68aec2772563966a$export$879058fdeee47603 = $68aec2772563966a$var$DB_MONGODB_COLLECTION, $68aec2772563966a$export$3c22ff8b64b8f565 = $68aec2772563966a$var$DB_NAME, $68aec2772563966a$export$b8019c0e2a5b5f0f = $68aec2772563966a$var$DB_NAMESPACE, $68aec2772563966a$export$8c11477e471467c8 = $68aec2772563966a$var$DB_OPERATION, $68aec2772563966a$export$92a96f6363488aee = $68aec2772563966a$var$DB_OPERATION_BATCH_SIZE, $68aec2772563966a$export$f91beb6088f9ded9 = $68aec2772563966a$var$DB_OPERATION_NAME, $68aec2772563966a$export$24bf9bb5ba9c544 = $68aec2772563966a$var$DB_PARAMS, $68aec2772563966a$export$78bc7224576bf289 = $68aec2772563966a$var$DB_QUERY_PARAMETER_KEY, $68aec2772563966a$export$a8027e0ea0d93ca = $68aec2772563966a$var$DB_QUERY_PARAMETER_KEY_BASE, $68aec2772563966a$export$5e59d3aea52e5037 = $68aec2772563966a$var$DB_QUERY_SUMMARY, $68aec2772563966a$export$47e408be0da7933f = $68aec2772563966a$var$DB_QUERY_TEXT, $68aec2772563966a$export$d5772b934ca13e57 = $68aec2772563966a$var$DB_REDIS_CONNECTION, $68aec2772563966a$export$36e47f6a5777561d = $68aec2772563966a$var$DB_REDIS_KEY, $68aec2772563966a$export$e768cbc99cd68acf = $68aec2772563966a$var$DB_REDIS_PARAMETERS, $68aec2772563966a$export$dfcc6c69df1343f2 = $68aec2772563966a$var$DB_RESPONSE_STATUS_CODE, $68aec2772563966a$export$69b0a5d9226b5211 = $68aec2772563966a$var$DB_SQL_BINDINGS, $68aec2772563966a$export$da010a4f4fc971ae = $68aec2772563966a$var$DB_STATEMENT, $68aec2772563966a$export$5d515b35be0601a0 = $68aec2772563966a$var$DB_STORED_PROCEDURE_NAME, $68aec2772563966a$export$3e1b1037a315c5ca = $68aec2772563966a$var$DB_SYSTEM, $68aec2772563966a$export$847fdd494825f0fb = $68aec2772563966a$var$DB_SYSTEM_NAME, $68aec2772563966a$export$a9d76f26c6c730a9 = $68aec2772563966a$var$DB_USER, $68aec2772563966a$export$de03f86d1c9866ca = $68aec2772563966a$var$DEVICEMEMORY, $68aec2772563966a$export$65798ecab7eef8c = $68aec2772563966a$var$DEVICE_ARCHS, $68aec2772563966a$export$22aa61f48b9c79a0 = $68aec2772563966a$var$DEVICE_BATTERY_LEVEL, $68aec2772563966a$export$69f5fb98f5aed812 = $68aec2772563966a$var$DEVICE_BATTERY_TEMPERATURE, $68aec2772563966a$export$bdea5d1006fd280a = $68aec2772563966a$var$DEVICE_BOOT_TIME, $68aec2772563966a$export$f63a7230c5b1d609 = $68aec2772563966a$var$DEVICE_BRAND, $68aec2772563966a$export$6f25e59b05bb8e17 = $68aec2772563966a$var$DEVICE_CHARGING, $68aec2772563966a$export$a56ad13c4afc7421 = $68aec2772563966a$var$DEVICE_CHIPSET, $68aec2772563966a$export$d9ce89ce8912bf12 = $68aec2772563966a$var$DEVICE_CLASS, $68aec2772563966a$export$17094e5f380e4162 = $68aec2772563966a$var$DEVICE_CONNECTION_TYPE, $68aec2772563966a$export$28a0ffdf747973a0 = $68aec2772563966a$var$DEVICE_CPU_DESCRIPTION, $68aec2772563966a$export$5480ae1ba5d50bb9 = $68aec2772563966a$var$DEVICE_EXTERNAL_FREE_STORAGE, $68aec2772563966a$export$edc72ee4a17f5152 = $68aec2772563966a$var$DEVICE_EXTERNAL_STORAGE_SIZE, $68aec2772563966a$export$19e4df138d354f8b = $68aec2772563966a$var$DEVICE_FAMILY, $68aec2772563966a$export$92b0d20fa482b4b2 = $68aec2772563966a$var$DEVICE_FREE_MEMORY, $68aec2772563966a$export$3f638a793d61933f = $68aec2772563966a$var$DEVICE_FREE_STORAGE, $68aec2772563966a$export$3f511731cc3687d4 = $68aec2772563966a$var$DEVICE_ID, $68aec2772563966a$export$692b08741d6b6265 = $68aec2772563966a$var$DEVICE_LOCALE, $68aec2772563966a$export$cf67f8cb2324428e = $68aec2772563966a$var$DEVICE_LOW_MEMORY, $68aec2772563966a$export$9d4197c1ffc5f359 = $68aec2772563966a$var$DEVICE_LOW_POWER_MODE, $68aec2772563966a$export$509634fbff540e75 = $68aec2772563966a$var$DEVICE_MANUFACTURER, $68aec2772563966a$export$ccbc4fdff4b5eff5 = $68aec2772563966a$var$DEVICE_MEMORY_ESTIMATED_CAPACITY, $68aec2772563966a$export$e0cb371ca548b1d6 = $68aec2772563966a$var$DEVICE_MEMORY_SIZE, $68aec2772563966a$export$3c39026d09026bc2 = $68aec2772563966a$var$DEVICE_MODEL, $68aec2772563966a$export$bf9e8248cb72cf00 = $68aec2772563966a$var$DEVICE_MODEL_ID, $68aec2772563966a$export$1054f22a72121d0f = $68aec2772563966a$var$DEVICE_NAME, $68aec2772563966a$export$723b8a59dad2e467 = $68aec2772563966a$var$DEVICE_ONLINE, $68aec2772563966a$export$160081ff141bac8e = $68aec2772563966a$var$DEVICE_ORIENTATION, $68aec2772563966a$export$194f62c84d27310 = $68aec2772563966a$var$DEVICE_PROCESSOR_COUNT, $68aec2772563966a$export$7ed866d57b018d09 = $68aec2772563966a$var$DEVICE_PROCESSOR_FREQUENCY, $68aec2772563966a$export$d50bae4562e03e5 = $68aec2772563966a$var$DEVICE_SCREEN_DENSITY, $68aec2772563966a$export$649ea67a18fe8e8b = $68aec2772563966a$var$DEVICE_SCREEN_DPI, $68aec2772563966a$export$136a5c1b43caaccd = $68aec2772563966a$var$DEVICE_SCREEN_HEIGHT_PIXELS, $68aec2772563966a$export$e33a28ea554b6ddc = $68aec2772563966a$var$DEVICE_SCREEN_WIDTH_PIXELS, $68aec2772563966a$export$acbe2d25ac76ea64 = $68aec2772563966a$var$DEVICE_SIMULATOR, $68aec2772563966a$export$793c13e17d7e5e2b = $68aec2772563966a$var$DEVICE_STORAGE_SIZE, $68aec2772563966a$export$a5617e33b89fd956 = $68aec2772563966a$var$DEVICE_THERMAL_STATE, $68aec2772563966a$export$b51f82164fa31e07 = $68aec2772563966a$var$DEVICE_TIMEZONE, $68aec2772563966a$export$f2ef55183c04d202 = $68aec2772563966a$var$DEVICE_USABLE_MEMORY, $68aec2772563966a$export$7c98fc0c48a16b1c = $68aec2772563966a$var$DIST, $68aec2772563966a$export$f5ebee1eec7be08f = $68aec2772563966a$var$DJANGO_FUNCTION_NAME, $68aec2772563966a$export$9ba827a5872de47f = $68aec2772563966a$var$DJANGO_MIDDLEWARE_NAME, $68aec2772563966a$export$f0511e328234ae83 = $68aec2772563966a$var$EFFECTIVECONNECTIONTYPE, $68aec2772563966a$export$be46596bc6608f3b = $68aec2772563966a$var$ENVIRONMENT, $68aec2772563966a$export$f215947b3d76a6b7 = $68aec2772563966a$var$ERROR_TYPE, $68aec2772563966a$export$89bbc91416db6670 = $68aec2772563966a$var$EVENT_ID, $68aec2772563966a$export$b4b5eff8a8712c89 = $68aec2772563966a$var$EVENT_NAME, $68aec2772563966a$export$f455969a57ab8a03 = $68aec2772563966a$var$EXCEPTION_ESCAPED, $68aec2772563966a$export$13f2f8f42af49cec = $68aec2772563966a$var$EXCEPTION_MESSAGE, $68aec2772563966a$export$cd357afe2ffdd2c3 = $68aec2772563966a$var$EXCEPTION_STACKTRACE, $68aec2772563966a$export$d9ca2a279a11be5e = $68aec2772563966a$var$EXCEPTION_TYPE, $68aec2772563966a$export$bbd59a8c7efad4c9 = $68aec2772563966a$var$FAAS_COLDSTART, $68aec2772563966a$export$8413282a17f1cda5 = $68aec2772563966a$var$FAAS_CRON, $68aec2772563966a$export$30d19ddc7705e7e8 = $68aec2772563966a$var$FAAS_DURATION_IN_MS, $68aec2772563966a$export$64a4f09e2444b3d = $68aec2772563966a$var$FAAS_ENTRY_POINT, $68aec2772563966a$export$645b039fe163809e = $68aec2772563966a$var$FAAS_EXECUTION, $68aec2772563966a$export$b23ef8b8ffa607e1 = $68aec2772563966a$var$FAAS_ID, $68aec2772563966a$export$8bf64516740c1369 = $68aec2772563966a$var$FAAS_IDENTITY, $68aec2772563966a$export$9a0dc8e612f3e10b = $68aec2772563966a$var$FAAS_INVOCATION_ID, $68aec2772563966a$export$abe90fedb3dddda2 = $68aec2772563966a$var$FAAS_INVOKED_NAME, $68aec2772563966a$export$4a19da9c85ed2ade = $68aec2772563966a$var$FAAS_INVOKED_PROVIDER, $68aec2772563966a$export$5e091479f094bdbc = $68aec2772563966a$var$FAAS_INVOKED_REGION, $68aec2772563966a$export$d70909b5aa96a79a = $68aec2772563966a$var$FAAS_NAME, $68aec2772563966a$export$651d142a8017d83d = $68aec2772563966a$var$FAAS_TIME, $68aec2772563966a$export$44382a010a9f7fcf = $68aec2772563966a$var$FAAS_TRIGGER, $68aec2772563966a$export$807abfdc6b7b9338 = $68aec2772563966a$var$FAAS_VERSION, $68aec2772563966a$export$31881d07f2569218 = "fcp", $68aec2772563966a$export$510aede74636c2c4 = $68aec2772563966a$var$FILE_PATH, $68aec2772563966a$export$c347ed9cee998637 = $68aec2772563966a$var$FILE_SIZE, $68aec2772563966a$export$e5bbf306deb709a6 = $68aec2772563966a$var$FLAG_EVALUATION_KEY, $68aec2772563966a$export$aa8721167c5c8d2d = $68aec2772563966a$var$FLAG_EVALUATION_KEY_BASE, $68aec2772563966a$export$757b93e5b3adc7cb = "fp", $68aec2772563966a$export$f869eaa92db1dc9b = $68aec2772563966a$var$FRAMES_DELAY, $68aec2772563966a$export$5d1d761e41c32d9e = $68aec2772563966a$var$FRAMES_FROZEN, $68aec2772563966a$export$8aec72d9491f9399 = $68aec2772563966a$var$FRAMES_FROZEN_RATE, $68aec2772563966a$export$5562635d2be2ab25 = $68aec2772563966a$var$FRAMES_SLOW, $68aec2772563966a$export$2dc31837ce6f7a3d = $68aec2772563966a$var$FRAMES_SLOW_RATE, $68aec2772563966a$export$b561df15f64d32e3 = $68aec2772563966a$var$FRAMES_TOTAL, $68aec2772563966a$export$181f78b28f2ffa57 = $68aec2772563966a$var$FS_ERROR, $68aec2772563966a$export$6c97c77b89571c75 = $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_EVENT_ID, $68aec2772563966a$export$51e431eaf1f9bf58 = $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_EVENT_TYPE, $68aec2772563966a$export$71429c7ef7cb7063 = $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_ID, $68aec2772563966a$export$99905d7583a6e8ac = $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_RESOURCE, $68aec2772563966a$export$b6c4be74fd0c06bd = $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_SOURCE, $68aec2772563966a$export$fd23e5b8d261a89 = $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_SPECVERSION, $68aec2772563966a$export$25fabc9b3d1dd567 = $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_TIME, $68aec2772563966a$export$41507f7b07dad151 = $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_TIMESTAMP, $68aec2772563966a$export$1352f3699c35dd73 = $68aec2772563966a$var$GCP_FUNCTION_CONTEXT_TYPE, $68aec2772563966a$export$fd6c9d5c74d943ac = $68aec2772563966a$var$GCP_PROJECT_ID, $68aec2772563966a$export$895d41bed174c591 = $68aec2772563966a$var$GCP_REGION, $68aec2772563966a$export$c29634e3cf41e479 = $68aec2772563966a$var$GEN_AI_AGENT_NAME, $68aec2772563966a$export$e6a60882cce7a085 = $68aec2772563966a$var$GEN_AI_CONTEXT_UTILIZATION, $68aec2772563966a$export$6773c9098ba5e194 = $68aec2772563966a$var$GEN_AI_CONTEXT_WINDOW_SIZE, $68aec2772563966a$export$6ee6b62f50047686 = $68aec2772563966a$var$GEN_AI_CONVERSATION_ID, $68aec2772563966a$export$efac052bb3661242 = $68aec2772563966a$var$GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS, $68aec2772563966a$export$7ccd63b9ca955862 = $68aec2772563966a$var$GEN_AI_COST_CACHE_READ_INPUT_TOKENS, $68aec2772563966a$export$50921df5a58cb3ef = $68aec2772563966a$var$GEN_AI_COST_INPUT_TOKENS, $68aec2772563966a$export$8e48efc7acb57a97 = $68aec2772563966a$var$GEN_AI_COST_OUTPUT_TOKENS, $68aec2772563966a$export$cea9121727113f77 = $68aec2772563966a$var$GEN_AI_COST_REASONING_OUTPUT_TOKENS, $68aec2772563966a$export$bed35ff7f9af3aaa = $68aec2772563966a$var$GEN_AI_COST_TOTAL_TOKENS, $68aec2772563966a$export$6b729e898b9067ce = $68aec2772563966a$var$GEN_AI_EMBEDDINGS_INPUT, $68aec2772563966a$export$984fbab9b52f7e24 = $68aec2772563966a$var$GEN_AI_FUNCTION_ID, $68aec2772563966a$export$9ea17906a87ada6f = $68aec2772563966a$var$GEN_AI_INPUT_MESSAGES, $68aec2772563966a$export$394b443aaff3ef92 = $68aec2772563966a$var$GEN_AI_OPERATION_NAME, $68aec2772563966a$export$6ddc374adbc06720 = $68aec2772563966a$var$GEN_AI_OPERATION_TYPE, $68aec2772563966a$export$ab8c7ebc9add56b2 = $68aec2772563966a$var$GEN_AI_OUTPUT_MESSAGES, $68aec2772563966a$export$40ecc5bcd633d1ee = $68aec2772563966a$var$GEN_AI_PIPELINE_NAME, $68aec2772563966a$export$86a8df7fff52fc69 = $68aec2772563966a$var$GEN_AI_PROMPT, $68aec2772563966a$export$cf2115d46768f4c5 = $68aec2772563966a$var$GEN_AI_PROMPT_NAME, $68aec2772563966a$export$3d7e036e195764db = $68aec2772563966a$var$GEN_AI_PROVIDER_NAME, $68aec2772563966a$export$60c1d11221608cee = $68aec2772563966a$var$GEN_AI_REQUEST_AVAILABLE_TOOLS, $68aec2772563966a$export$bc3cef164abbc42c = $68aec2772563966a$var$GEN_AI_REQUEST_FREQUENCY_PENALTY, $68aec2772563966a$export$43f9afb62cd79dec = $68aec2772563966a$var$GEN_AI_REQUEST_MAX_TOKENS, $68aec2772563966a$export$a5ab4ffc4765f75f = $68aec2772563966a$var$GEN_AI_REQUEST_MESSAGES, $68aec2772563966a$export$ccf46db9ab1743ec = $68aec2772563966a$var$GEN_AI_REQUEST_MODEL, $68aec2772563966a$export$76c1c247342d776 = $68aec2772563966a$var$GEN_AI_REQUEST_PRESENCE_PENALTY, $68aec2772563966a$export$3457b85c8f1a517d = $68aec2772563966a$var$GEN_AI_REQUEST_REASONING_LEVEL, $68aec2772563966a$export$2a1d912384377602 = $68aec2772563966a$var$GEN_AI_REQUEST_SCHEMA, $68aec2772563966a$export$867eeefcb1c95b27 = $68aec2772563966a$var$GEN_AI_REQUEST_SEED, $68aec2772563966a$export$5ada4697ae6aa17e = $68aec2772563966a$var$GEN_AI_REQUEST_STOP_SEQUENCES, $68aec2772563966a$export$427122300e8d54d0 = $68aec2772563966a$var$GEN_AI_REQUEST_TEMPERATURE, $68aec2772563966a$export$bcea8881375c352f = $68aec2772563966a$var$GEN_AI_REQUEST_TOP_K, $68aec2772563966a$export$b867715f9a0c04e9 = $68aec2772563966a$var$GEN_AI_REQUEST_TOP_P, $68aec2772563966a$export$2046c054eed58818 = $68aec2772563966a$var$GEN_AI_RESPONSE_FINISH_REASON, $68aec2772563966a$export$69878a39cbdbe097 = $68aec2772563966a$var$GEN_AI_RESPONSE_FINISH_REASONS, $68aec2772563966a$export$584c61a1b769552d = $68aec2772563966a$var$GEN_AI_RESPONSE_ID, $68aec2772563966a$export$8169ebcb0b0331dd = $68aec2772563966a$var$GEN_AI_RESPONSE_MODEL, $68aec2772563966a$export$ef5889590e2b6760 = $68aec2772563966a$var$GEN_AI_RESPONSE_OBJECT, $68aec2772563966a$export$2c9713b624877853 = $68aec2772563966a$var$GEN_AI_RESPONSE_STREAMING, $68aec2772563966a$export$45942692aeb454e0 = $68aec2772563966a$var$GEN_AI_RESPONSE_TEXT, $68aec2772563966a$export$8e5efeaa031210cd = $68aec2772563966a$var$GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK, $68aec2772563966a$export$35a62769ee05a05a = $68aec2772563966a$var$GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN, $68aec2772563966a$export$8ea4f7e986ca4b06 = $68aec2772563966a$var$GEN_AI_RESPONSE_TOKENS_PER_SECOND, $68aec2772563966a$export$d2fd9ecaff0285a4 = $68aec2772563966a$var$GEN_AI_RESPONSE_TOOL_CALLS, $68aec2772563966a$export$a6c8e656a4f9bb67 = $68aec2772563966a$var$GEN_AI_SYSTEM, $68aec2772563966a$export$352a8075b163d53 = $68aec2772563966a$var$GEN_AI_SYSTEM_INSTRUCTIONS, $68aec2772563966a$export$426d7b90ba5d79db = $68aec2772563966a$var$GEN_AI_SYSTEM_MESSAGE, $68aec2772563966a$export$f5a1ee40934d19ce = $68aec2772563966a$var$GEN_AI_TOOL_CALL_ARGUMENTS, $68aec2772563966a$export$1ba812a9756622ce = $68aec2772563966a$var$GEN_AI_TOOL_CALL_RESULT, $68aec2772563966a$export$351120039c36e03 = $68aec2772563966a$var$GEN_AI_TOOL_DEFINITIONS, $68aec2772563966a$export$d42aa25ca09e17c4 = $68aec2772563966a$var$GEN_AI_TOOL_DESCRIPTION, $68aec2772563966a$export$d268db29b88a4286 = $68aec2772563966a$var$GEN_AI_TOOL_INPUT, $68aec2772563966a$export$c5deb6018f2d6251 = $68aec2772563966a$var$GEN_AI_TOOL_MESSAGE, $68aec2772563966a$export$e06baa3034409453 = $68aec2772563966a$var$GEN_AI_TOOL_NAME, $68aec2772563966a$export$646fdb5910ce3931 = $68aec2772563966a$var$GEN_AI_TOOL_OUTPUT, $68aec2772563966a$export$662e3d2d4361e29b = $68aec2772563966a$var$GEN_AI_TOOL_TYPE, $68aec2772563966a$export$1de3962f221ba441 = $68aec2772563966a$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS, $68aec2772563966a$export$a4b3f0f5499c8738 = $68aec2772563966a$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS, $68aec2772563966a$export$1aecdac6cecbdc5b = $68aec2772563966a$var$GEN_AI_USAGE_COMPLETION_TOKENS, $68aec2772563966a$export$2eb2ab35b317a103 = $68aec2772563966a$var$GEN_AI_USAGE_INPUT_TOKENS, $68aec2772563966a$export$c7e14ea195ede241 = $68aec2772563966a$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED, $68aec2772563966a$export$41ac034e7b9725a2 = $68aec2772563966a$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE, $68aec2772563966a$export$9e521119d7751e37 = $68aec2772563966a$var$GEN_AI_USAGE_OUTPUT_TOKENS, $68aec2772563966a$export$cbac8f541a64a150 = $68aec2772563966a$var$GEN_AI_USAGE_OUTPUT_TOKENS_REASONING, $68aec2772563966a$export$93dd08efa94c9dd4 = $68aec2772563966a$var$GEN_AI_USAGE_PROMPT_TOKENS, $68aec2772563966a$export$183e3523dac20bca = $68aec2772563966a$var$GEN_AI_USAGE_REASONING_OUTPUT_TOKENS, $68aec2772563966a$export$3867ca1d8381d4e3 = $68aec2772563966a$var$GEN_AI_USAGE_TOTAL_TOKENS, $68aec2772563966a$export$11febcf9917c0057 = $68aec2772563966a$var$GRAPHQL_DOCUMENT, $68aec2772563966a$export$88ae1ee0c0a63398 = $68aec2772563966a$var$GRAPHQL_OPERATION_NAME, $68aec2772563966a$export$d5bd986d1f283f29 = $68aec2772563966a$var$GRAPHQL_OPERATION_TYPE, $68aec2772563966a$export$d10568582907d32c = $68aec2772563966a$var$GRAPHQL_PROCESSING_TYPE, $68aec2772563966a$export$f306d94737657647 = $68aec2772563966a$var$GRAPHQL_SOURCE, $68aec2772563966a$export$5e55cad605e5c9d3 = $68aec2772563966a$var$GRPC_ERROR_BAD_REQUEST_FIELD_VIOLATIONS, $68aec2772563966a$export$1a214c5a0346737a = $68aec2772563966a$var$GRPC_ERROR_DEBUG_INFO_DETAIL, $68aec2772563966a$export$1ecae877f91f3d38 = $68aec2772563966a$var$GRPC_ERROR_DEBUG_INFO_STACK_ENTRIES, $68aec2772563966a$export$a27521f0d3067ccc = $68aec2772563966a$var$GRPC_ERROR_ERROR_INFO_DOMAIN, $68aec2772563966a$export$ac46bca5cbddbad1 = $68aec2772563966a$var$GRPC_ERROR_ERROR_INFO_METADATA_KEY, $68aec2772563966a$export$11b038c76920b660 = $68aec2772563966a$var$GRPC_ERROR_ERROR_INFO_METADATA_KEY_BASE, $68aec2772563966a$export$671c5889f3e8218e = $68aec2772563966a$var$GRPC_ERROR_ERROR_INFO_REASON, $68aec2772563966a$export$726fdf83f7b4fcc8 = $68aec2772563966a$var$GRPC_ERROR_PRECONDITION_FAILURE_VIOLATIONS, $68aec2772563966a$export$2400f140f6ca38e0 = $68aec2772563966a$var$GRPC_ERROR_QUOTA_FAILURE_VIOLATIONS, $68aec2772563966a$export$a6c909cc1981ed53 = $68aec2772563966a$var$GRPC_ERROR_RESOURCE_INFO_DESCRIPTION, $68aec2772563966a$export$2a0ab3b6818597b1 = $68aec2772563966a$var$GRPC_ERROR_RESOURCE_INFO_OWNER, $68aec2772563966a$export$fc9dbcf37c263217 = $68aec2772563966a$var$GRPC_ERROR_RESOURCE_INFO_RESOURCE_NAME, $68aec2772563966a$export$dfbfbd03169bd3bd = $68aec2772563966a$var$GRPC_ERROR_RESOURCE_INFO_RESOURCE_TYPE, $68aec2772563966a$export$e36e93a941cb8163 = $68aec2772563966a$var$GRPC_ERROR_RETRY_INFO_RETRY_DELAY_MS, $68aec2772563966a$export$fc4a2d238535d998 = $68aec2772563966a$var$HARDWARECONCURRENCY, $68aec2772563966a$export$57e53a60bf563f41 = $68aec2772563966a$var$HTTP_CLIENT_IP, $68aec2772563966a$export$ffdb1464deb0eedb = $68aec2772563966a$var$HTTP_DECODED_RESPONSE_CONTENT_LENGTH, $68aec2772563966a$export$b52670c950fd640 = $68aec2772563966a$var$HTTP_FLAVOR, $68aec2772563966a$export$c499fd8f1db3d18e = $68aec2772563966a$var$HTTP_FRAGMENT, $68aec2772563966a$export$b2ee2242301eff05 = $68aec2772563966a$var$HTTP_HOST, $68aec2772563966a$export$2ebf9f7586f16841 = $68aec2772563966a$var$HTTP_METHOD, $68aec2772563966a$export$6e9ffd608b3e828b = $68aec2772563966a$var$HTTP_QUERY, $68aec2772563966a$export$b960c5a73a722e6c = $68aec2772563966a$var$HTTP_REQUEST_BODY_DATA, $68aec2772563966a$export$d0bc6823da166f19 = $68aec2772563966a$var$HTTP_REQUEST_BODY_DECODED_SIZE, $68aec2772563966a$export$d7a5fcd63410985d = $68aec2772563966a$var$HTTP_REQUEST_BODY_SIZE, $68aec2772563966a$export$a7a850351369c77e = $68aec2772563966a$var$HTTP_REQUEST_CONNECTION_END, $68aec2772563966a$export$b18bca78f4736a94 = $68aec2772563966a$var$HTTP_REQUEST_CONNECT_START, $68aec2772563966a$export$dc4aa1d1f29d5e34 = $68aec2772563966a$var$HTTP_REQUEST_CONTENT_LENGTH, $68aec2772563966a$export$d66b1fd3d23a853e = $68aec2772563966a$var$HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED, $68aec2772563966a$export$61a0059f562fb6c2 = $68aec2772563966a$var$HTTP_REQUEST_DOMAIN_LOOKUP_END, $68aec2772563966a$export$7dc0d5aefb816d91 = $68aec2772563966a$var$HTTP_REQUEST_DOMAIN_LOOKUP_START, $68aec2772563966a$export$58f6db56c841bef6 = $68aec2772563966a$var$HTTP_REQUEST_FETCH_START, $68aec2772563966a$export$97a3da679f509d5 = $68aec2772563966a$var$HTTP_REQUEST_HEADER_KEY, $68aec2772563966a$export$c387ec65fd1c2638 = $68aec2772563966a$var$HTTP_REQUEST_HEADER_KEY_BASE, $68aec2772563966a$export$4d9db82211f308a4 = $68aec2772563966a$var$HTTP_REQUEST_METHOD, $68aec2772563966a$export$ee4948a3be025123 = $68aec2772563966a$var$HTTP_REQUEST_REDIRECT_END, $68aec2772563966a$export$e0021eb2979cddaa = $68aec2772563966a$var$HTTP_REQUEST_REDIRECT_START, $68aec2772563966a$export$7c0ac0c19a45beac = $68aec2772563966a$var$HTTP_REQUEST_REQUEST_START, $68aec2772563966a$export$6c32e9d84f534ee = $68aec2772563966a$var$HTTP_REQUEST_RESEND_COUNT, $68aec2772563966a$export$d1f9fbdb211dd29b = $68aec2772563966a$var$HTTP_REQUEST_RESPONSE_END, $68aec2772563966a$export$45e7eea99a17d6e4 = $68aec2772563966a$var$HTTP_REQUEST_RESPONSE_START, $68aec2772563966a$export$20ea34e16c0aa64f = $68aec2772563966a$var$HTTP_REQUEST_SAME_ORIGIN, $68aec2772563966a$export$8365b0f03557fae9 = $68aec2772563966a$var$HTTP_REQUEST_SECURE_CONNECTION_START, $68aec2772563966a$export$49ebbb9621675650 = $68aec2772563966a$var$HTTP_REQUEST_TIME_TO_FIRST_BYTE, $68aec2772563966a$export$842be66a901f093 = $68aec2772563966a$var$HTTP_REQUEST_WORKER_START, $68aec2772563966a$export$3142c82fef74558f = $68aec2772563966a$var$HTTP_RESPONSE_BODY_DECODED_SIZE, $68aec2772563966a$export$a9f5a6cb28adccb1 = $68aec2772563966a$var$HTTP_RESPONSE_BODY_SIZE, $68aec2772563966a$export$57b055d4bc586d67 = $68aec2772563966a$var$HTTP_RESPONSE_CONTENT_LENGTH, $68aec2772563966a$export$13d631b1be16538f = $68aec2772563966a$var$HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED, $68aec2772563966a$export$3ddfd660caa7bf7a = $68aec2772563966a$var$HTTP_RESPONSE_HEADER_CONTENT_LENGTH, $68aec2772563966a$export$fa7e1f5305153b3d = $68aec2772563966a$var$HTTP_RESPONSE_HEADER_KEY, $68aec2772563966a$export$5674ce9d013eb7bd = $68aec2772563966a$var$HTTP_RESPONSE_HEADER_KEY_BASE, $68aec2772563966a$export$6e8dc14cff6ccf72 = $68aec2772563966a$var$HTTP_RESPONSE_SIZE, $68aec2772563966a$export$afd59480458e1b57 = $68aec2772563966a$var$HTTP_RESPONSE_STATUS_CODE, $68aec2772563966a$export$97952cf4731766f5 = $68aec2772563966a$var$HTTP_RESPONSE_STATUS_TEXT, $68aec2772563966a$export$48e61fb9bccccba9 = $68aec2772563966a$var$HTTP_RESPONSE_TRANSFER_SIZE, $68aec2772563966a$export$d3e674514dd3a3e1 = $68aec2772563966a$var$HTTP_ROUTE, $68aec2772563966a$export$97ad02b50c60ef68 = $68aec2772563966a$var$HTTP_SCHEME, $68aec2772563966a$export$61d053b1b63e82c4 = $68aec2772563966a$var$HTTP_SERVER_NAME, $68aec2772563966a$export$54256cce0d674dea = $68aec2772563966a$var$HTTP_SERVER_REQUEST_TIME_IN_QUEUE, $68aec2772563966a$export$8c01f0f407bcc5ca = $68aec2772563966a$var$HTTP_STATUS_CODE, $68aec2772563966a$export$97cccd427e0a295b = $68aec2772563966a$var$HTTP_STATUS_TEXT, $68aec2772563966a$export$be3f46982f6c7160 = $68aec2772563966a$var$HTTP_TARGET, $68aec2772563966a$export$778e4213e2788579 = $68aec2772563966a$var$HTTP_URL, $68aec2772563966a$export$8b48ca3594d2b172 = $68aec2772563966a$var$HTTP_USER_AGENT, $68aec2772563966a$export$8be180ec26319f9f = "id", $68aec2772563966a$export$60eccaddefa8fc1c = "inp", $68aec2772563966a$export$c99ce4fe37484d84 = $68aec2772563966a$var$JSONRPC_PROTOCOL_VERSION, $68aec2772563966a$export$fdf432fcac7d8f37 = $68aec2772563966a$var$JSONRPC_REQUEST_ID, $68aec2772563966a$export$4c21cc9cdf2f5dbd = $68aec2772563966a$var$JVM_GC_ACTION, $68aec2772563966a$export$dcc1eab7f3f31816 = $68aec2772563966a$var$JVM_GC_NAME, $68aec2772563966a$export$dcb7f1379b2b8f86 = $68aec2772563966a$var$JVM_MEMORY_POOL_NAME, $68aec2772563966a$export$53416edeea4c2d74 = $68aec2772563966a$var$JVM_MEMORY_TYPE, $68aec2772563966a$export$69f7e5d2b74c5c9e = $68aec2772563966a$var$JVM_THREAD_DAEMON, $68aec2772563966a$export$8e104aed582a26bc = $68aec2772563966a$var$JVM_THREAD_STATE, $68aec2772563966a$export$577047501949be9 = $68aec2772563966a$var$KOA_NAME, $68aec2772563966a$export$c4c45b599a2c15e = $68aec2772563966a$var$KOA_TYPE, $68aec2772563966a$export$8caf7173a3020ef1 = $68aec2772563966a$var$LANGCHAIN_CHAIN_NAME, $68aec2772563966a$export$361cb541700d648e = "lcp", $68aec2772563966a$export$974f160e11f25731 = $68aec2772563966a$var$LCP_ELEMENT, $68aec2772563966a$export$7162f5c702b95903 = $68aec2772563966a$var$LCP_ID, $68aec2772563966a$export$a034d066a9090500 = $68aec2772563966a$var$LCP_LOADTIME, $68aec2772563966a$export$70938021e43e047c = $68aec2772563966a$var$LCP_RENDERTIME, $68aec2772563966a$export$5f6ac460012a73bb = $68aec2772563966a$var$LCP_SIZE, $68aec2772563966a$export$d8e498c1c670bcbf = $68aec2772563966a$var$LCP_URL, $68aec2772563966a$export$a46886a44f756f1e = $68aec2772563966a$var$LITESTAR_MIDDLEWARE_NAME, $68aec2772563966a$export$cc1a78a24d947903 = $68aec2772563966a$var$LOGGER_NAME, $68aec2772563966a$export$d29b927e0bb0ffea = $68aec2772563966a$var$MCP_CANCELLED_REASON, $68aec2772563966a$export$b3999cacef245779 = $68aec2772563966a$var$MCP_CANCELLED_REQUEST_ID, $68aec2772563966a$export$ff168b5f9cf9dcf6 = $68aec2772563966a$var$MCP_CLIENT_NAME, $68aec2772563966a$export$2ab876a45bd6e64 = $68aec2772563966a$var$MCP_CLIENT_TITLE, $68aec2772563966a$export$cb8027e4395c6c0e = $68aec2772563966a$var$MCP_CLIENT_VERSION, $68aec2772563966a$export$f5303d1bac3c2660 = $68aec2772563966a$var$MCP_LIFECYCLE_PHASE, $68aec2772563966a$export$6c463c5f3b00f64 = $68aec2772563966a$var$MCP_LOGGING_DATA_TYPE, $68aec2772563966a$export$e25d553065457cab = $68aec2772563966a$var$MCP_LOGGING_LEVEL, $68aec2772563966a$export$15d24c154ea8a56f = $68aec2772563966a$var$MCP_LOGGING_LOGGER, $68aec2772563966a$export$e5065789a6c415d0 = $68aec2772563966a$var$MCP_LOGGING_MESSAGE, $68aec2772563966a$export$62662c561d7c7835 = $68aec2772563966a$var$MCP_METHOD_NAME, $68aec2772563966a$export$218f394557fb0a5a = $68aec2772563966a$var$MCP_PROGRESS_CURRENT, $68aec2772563966a$export$2a5ff6de5448ecdf = $68aec2772563966a$var$MCP_PROGRESS_MESSAGE, $68aec2772563966a$export$9d23f3030ed2597e = $68aec2772563966a$var$MCP_PROGRESS_PERCENTAGE, $68aec2772563966a$export$a26ff217a6124160 = $68aec2772563966a$var$MCP_PROGRESS_TOKEN, $68aec2772563966a$export$c8072f5fcfdb5b77 = $68aec2772563966a$var$MCP_PROGRESS_TOTAL, $68aec2772563966a$export$c4e4b74f1ccf3d96 = $68aec2772563966a$var$MCP_PROMPT_NAME, $68aec2772563966a$export$328519d02a26ac41 = $68aec2772563966a$var$MCP_PROMPT_RESULT_DESCRIPTION, $68aec2772563966a$export$d2061b291c43d045 = $68aec2772563966a$var$MCP_PROMPT_RESULT_MESSAGE_CONTENT, $68aec2772563966a$export$d1f04dfd3d695286 = $68aec2772563966a$var$MCP_PROMPT_RESULT_MESSAGE_COUNT, $68aec2772563966a$export$234fbd86ea0f0bd8 = $68aec2772563966a$var$MCP_PROMPT_RESULT_MESSAGE_ROLE, $68aec2772563966a$export$e795000978a75b12 = $68aec2772563966a$var$MCP_PROTOCOL_READY, $68aec2772563966a$export$9f4683b4d1018ace = $68aec2772563966a$var$MCP_PROTOCOL_VERSION, $68aec2772563966a$export$e431b042fcdb1d63 = $68aec2772563966a$var$MCP_REQUEST_ARGUMENT_KEY, $68aec2772563966a$export$a453239171ac9a23 = $68aec2772563966a$var$MCP_REQUEST_ARGUMENT_KEY_BASE, $68aec2772563966a$export$3a7726a976c18d5f = $68aec2772563966a$var$MCP_REQUEST_ARGUMENT_NAME, $68aec2772563966a$export$7eca7a6c06843b93 = $68aec2772563966a$var$MCP_REQUEST_ARGUMENT_URI, $68aec2772563966a$export$f25c55f83e5b0672 = $68aec2772563966a$var$MCP_REQUEST_ID, $68aec2772563966a$export$9562bfac4eb079cb = $68aec2772563966a$var$MCP_RESOURCE_PROTOCOL, $68aec2772563966a$export$c276d164ff91d2f7 = $68aec2772563966a$var$MCP_RESOURCE_URI, $68aec2772563966a$export$2f3e0574f1a99754 = $68aec2772563966a$var$MCP_SERVER_NAME, $68aec2772563966a$export$15eecaab68167880 = $68aec2772563966a$var$MCP_SERVER_TITLE, $68aec2772563966a$export$513c47f6e194086a = $68aec2772563966a$var$MCP_SERVER_VERSION, $68aec2772563966a$export$a3f464c4d5cd9096 = $68aec2772563966a$var$MCP_SESSION_ID, $68aec2772563966a$export$ed366a03a2330b03 = $68aec2772563966a$var$MCP_TOOL_NAME, $68aec2772563966a$export$9b802c784f235e1d = $68aec2772563966a$var$MCP_TOOL_RESULT_CONTENT, $68aec2772563966a$export$add0fc8b8c5726a4 = $68aec2772563966a$var$MCP_TOOL_RESULT_CONTENT_COUNT, $68aec2772563966a$export$e7f32463f5bfd554 = $68aec2772563966a$var$MCP_TOOL_RESULT_IS_ERROR, $68aec2772563966a$export$f9346f394edf26a = $68aec2772563966a$var$MCP_TRANSPORT, $68aec2772563966a$export$16b917774e73ef92 = $68aec2772563966a$var$MDC_KEY, $68aec2772563966a$export$15d2b60bf3b65454 = "mdc", $68aec2772563966a$export$db55eca5af256142 = $68aec2772563966a$var$MESSAGING_BATCH_MESSAGE_COUNT, $68aec2772563966a$export$59329ea9f3dc6610 = $68aec2772563966a$var$MESSAGING_CONVERSATION_ID, $68aec2772563966a$export$967c74f8b1f3d35 = $68aec2772563966a$var$MESSAGING_DESTINATION, $68aec2772563966a$export$7c33ae67962515d1 = $68aec2772563966a$var$MESSAGING_DESTINATION_CONNECTION, $68aec2772563966a$export$730c61462081bd77 = $68aec2772563966a$var$MESSAGING_DESTINATION_KIND, $68aec2772563966a$export$9c69839b2d93489b = $68aec2772563966a$var$MESSAGING_DESTINATION_NAME, $68aec2772563966a$export$f38631e70fb37f7c = $68aec2772563966a$var$MESSAGING_DESTINATION_PARTITION_ID, $68aec2772563966a$export$7001e6237c0936f7 = $68aec2772563966a$var$MESSAGING_KAFKA_MESSAGE_KEY, $68aec2772563966a$export$c2190d261e83de8b = $68aec2772563966a$var$MESSAGING_KAFKA_MESSAGE_TOMBSTONE, $68aec2772563966a$export$5a958d07aea838e0 = $68aec2772563966a$var$MESSAGING_KAFKA_OFFSET, $68aec2772563966a$export$be22d22d4b6cf5d8 = $68aec2772563966a$var$MESSAGING_MESSAGE_BODY_SIZE, $68aec2772563966a$export$c529961b911626ac = $68aec2772563966a$var$MESSAGING_MESSAGE_CONVERSATION_ID, $68aec2772563966a$export$e39c4b15d2881f5 = $68aec2772563966a$var$MESSAGING_MESSAGE_ENVELOPE_SIZE, $68aec2772563966a$export$a8ca145161313e7 = $68aec2772563966a$var$MESSAGING_MESSAGE_ID, $68aec2772563966a$export$3c1204d03918d076 = $68aec2772563966a$var$MESSAGING_MESSAGE_RECEIVE_LATENCY, $68aec2772563966a$export$eaac3f141165e288 = $68aec2772563966a$var$MESSAGING_MESSAGE_RETRY_COUNT, $68aec2772563966a$export$691d17eaa731c6a8 = $68aec2772563966a$var$MESSAGING_OPERATION, $68aec2772563966a$export$4c7e6934714150e6 = $68aec2772563966a$var$MESSAGING_OPERATION_NAME, $68aec2772563966a$export$6f71f9711d666eb4 = $68aec2772563966a$var$MESSAGING_OPERATION_TYPE, $68aec2772563966a$export$2e2181bea33963d2 = $68aec2772563966a$var$MESSAGING_PROTOCOL, $68aec2772563966a$export$77b390a335f31601 = $68aec2772563966a$var$MESSAGING_PROTOCOL_VERSION, $68aec2772563966a$export$2a3cd2bb71fb63a4 = $68aec2772563966a$var$MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY, $68aec2772563966a$export$4696f9a8a1b6f07c = $68aec2772563966a$var$MESSAGING_RABBITMQ_ROUTING_KEY, $68aec2772563966a$export$55478a0b7d2ae98f = $68aec2772563966a$var$MESSAGING_SYSTEM, $68aec2772563966a$export$536e79776026daed = $68aec2772563966a$var$MESSAGING_URL, $68aec2772563966a$export$bed10c4da9b8eb0a = $68aec2772563966a$var$METHOD, $68aec2772563966a$export$a82607b6424c06c8 = $68aec2772563966a$var$MIDDLEWARE_NAME, $68aec2772563966a$export$6b081f3484c7f4e5 = $68aec2772563966a$var$NAVIGATION_ORIGIN, $68aec2772563966a$export$b7754d85fd39406c = $68aec2772563966a$var$NAVIGATION_ROUTE_ID, $68aec2772563966a$export$492856c046eb4728 = $68aec2772563966a$var$NAVIGATION_TYPE, $68aec2772563966a$export$c1678a2059fbe906 = $68aec2772563966a$var$NEL_ELAPSED_TIME, $68aec2772563966a$export$6d384a0bc1011c34 = $68aec2772563966a$var$NEL_PHASE, $68aec2772563966a$export$1499a7dbfc01e7d4 = $68aec2772563966a$var$NEL_REFERRER, $68aec2772563966a$export$cfcbff40019f0ff1 = $68aec2772563966a$var$NEL_SAMPLING_FUNCTION, $68aec2772563966a$export$27157b5f68e583af = $68aec2772563966a$var$NEL_TYPE, $68aec2772563966a$export$54bf5ed61532925d = $68aec2772563966a$var$NETWORK_CONNECTION_EFFECTIVE_TYPE, $68aec2772563966a$export$60ed0786292ace08 = $68aec2772563966a$var$NETWORK_CONNECTION_RTT, $68aec2772563966a$export$d770bfb8345e146 = $68aec2772563966a$var$NETWORK_CONNECTION_TYPE, $68aec2772563966a$export$bb73817f1290ad28 = $68aec2772563966a$var$NETWORK_LOCAL_ADDRESS, $68aec2772563966a$export$f201c980f2b75802 = $68aec2772563966a$var$NETWORK_LOCAL_PORT, $68aec2772563966a$export$b40e970572afd0ee = $68aec2772563966a$var$NETWORK_PEER_ADDRESS, $68aec2772563966a$export$8850630a3d343488 = $68aec2772563966a$var$NETWORK_PEER_PORT, $68aec2772563966a$export$fd0a39a918d6516f = $68aec2772563966a$var$NETWORK_PROTOCOL_NAME, $68aec2772563966a$export$e68ef41f8e0335bf = $68aec2772563966a$var$NETWORK_PROTOCOL_VERSION, $68aec2772563966a$export$5bff09650e762829 = $68aec2772563966a$var$NETWORK_TRANSPORT, $68aec2772563966a$export$21c1adce0e067f37 = $68aec2772563966a$var$NETWORK_TYPE, $68aec2772563966a$export$fed6ce86f48c84bc = $68aec2772563966a$var$NET_HOST_IP, $68aec2772563966a$export$500c2675137ac16e = $68aec2772563966a$var$NET_HOST_NAME, $68aec2772563966a$export$402c7728623fd8df = $68aec2772563966a$var$NET_HOST_PORT, $68aec2772563966a$export$15417259f4c0fe6b = $68aec2772563966a$var$NET_PEER_IP, $68aec2772563966a$export$2b3b7f579a727f45 = $68aec2772563966a$var$NET_PEER_NAME, $68aec2772563966a$export$514832a0b029734b = $68aec2772563966a$var$NET_PEER_PORT, $68aec2772563966a$export$b0522e6a14dec1a4 = $68aec2772563966a$var$NET_PROTOCOL_NAME, $68aec2772563966a$export$659ea19f71a7ee0b = $68aec2772563966a$var$NET_PROTOCOL_VERSION, $68aec2772563966a$export$1b61d972db315e73 = $68aec2772563966a$var$NET_SOCK_FAMILY, $68aec2772563966a$export$fb2970ee11a479ee = $68aec2772563966a$var$NET_SOCK_HOST_ADDR, $68aec2772563966a$export$920aceb2a8fad77e = $68aec2772563966a$var$NET_SOCK_HOST_PORT, $68aec2772563966a$export$48f8f6fbc999d187 = $68aec2772563966a$var$NET_SOCK_PEER_ADDR, $68aec2772563966a$export$eed590fa00a8223b = $68aec2772563966a$var$NET_SOCK_PEER_NAME, $68aec2772563966a$export$f2e5bb5cd4a130da = $68aec2772563966a$var$NET_SOCK_PEER_PORT, $68aec2772563966a$export$779ef03d633a9086 = $68aec2772563966a$var$NET_TRANSPORT, $68aec2772563966a$export$d98b87c8d53d0dbc = $68aec2772563966a$var$OS_BUILD, $68aec2772563966a$export$ca719aa57653a0a7 = $68aec2772563966a$var$OS_BUILD_ID, $68aec2772563966a$export$74b19c5f48270c05 = $68aec2772563966a$var$OS_DESCRIPTION, $68aec2772563966a$export$c351affe7e8098cb = $68aec2772563966a$var$OS_KERNEL_VERSION, $68aec2772563966a$export$be7cd6b3ae3ae765 = $68aec2772563966a$var$OS_NAME, $68aec2772563966a$export$ec182524c4c57275 = $68aec2772563966a$var$OS_RAW_DESCRIPTION, $68aec2772563966a$export$9e45758246a85b07 = $68aec2772563966a$var$OS_ROOTED, $68aec2772563966a$export$9fa5d5f0144954cb = $68aec2772563966a$var$OS_THEME, $68aec2772563966a$export$e66ba5bc4b978023 = $68aec2772563966a$var$OS_TYPE, $68aec2772563966a$export$2306e23cc611a36d = $68aec2772563966a$var$OS_VERSION, $68aec2772563966a$export$144f8c1fe01428db = $68aec2772563966a$var$OTEL_KIND, $68aec2772563966a$export$f303b2744d52121c = $68aec2772563966a$var$OTEL_SCOPE_NAME, $68aec2772563966a$export$866b2dbc7bf18ce6 = $68aec2772563966a$var$OTEL_SCOPE_VERSION, $68aec2772563966a$export$b4c85774878b4841 = $68aec2772563966a$var$OTEL_STATUS_CODE, $68aec2772563966a$export$1c967a71bc9a3077 = $68aec2772563966a$var$OTEL_STATUS_DESCRIPTION, $68aec2772563966a$export$5e3884a35a19eb90 = $68aec2772563966a$var$PARAMS_KEY, $68aec2772563966a$export$6e7ff99bb3259573 = $68aec2772563966a$var$PARAMS_KEY_BASE, $68aec2772563966a$export$7c932cba2d9e7a7 = $68aec2772563966a$var$PERFORMANCE_ACTIVATIONSTART, $68aec2772563966a$export$94091942edce0667 = $68aec2772563966a$var$PERFORMANCE_TIMEORIGIN, $68aec2772563966a$export$a08202ba4c331865 = $68aec2772563966a$var$PORT, $68aec2772563966a$export$3671a8a524706a9d = $68aec2772563966a$var$PREVIOUS_ROUTE, $68aec2772563966a$export$c288888dc82d233f = $68aec2772563966a$var$PROCESS_COMMAND_ARGS, $68aec2772563966a$export$8ff188536cebc35 = $68aec2772563966a$var$PROCESS_EXECUTABLE_NAME, $68aec2772563966a$export$6407d78968c0eabe = $68aec2772563966a$var$PROCESS_PID, $68aec2772563966a$export$43e9fb9ec28d9743 = $68aec2772563966a$var$PROCESS_RUNTIME_DESCRIPTION, $68aec2772563966a$export$26f31d5c5c201739 = $68aec2772563966a$var$PROCESS_RUNTIME_ENGINE_NAME, $68aec2772563966a$export$bff85124d2d35b93 = $68aec2772563966a$var$PROCESS_RUNTIME_ENGINE_VERSION, $68aec2772563966a$export$495c671ed5a6408c = $68aec2772563966a$var$PROCESS_RUNTIME_NAME, $68aec2772563966a$export$54b3d4d5548c35c3 = $68aec2772563966a$var$PROCESS_RUNTIME_VERSION, $68aec2772563966a$export$71aa6d7b25b5b4be = $68aec2772563966a$var$PROFILE_ID, $68aec2772563966a$export$2b91517d6d5b4365 = $68aec2772563966a$var$QUERY, $68aec2772563966a$export$2954db6444fe1fa8 = $68aec2772563966a$var$QUERY_KEY, $68aec2772563966a$export$15c1c974d16dd678 = $68aec2772563966a$var$QUERY_KEY_BASE, $68aec2772563966a$export$81c87eb7885d0bfe = $68aec2772563966a$var$REACT_NATIVE_ARCHITECTURE, $68aec2772563966a$export$da39a8d77ac07c5b = $68aec2772563966a$var$REACT_NATIVE_MODULE_CALL_COUNT, $68aec2772563966a$export$8e637b1057fe6fb6 = $68aec2772563966a$var$REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT, $68aec2772563966a$export$b9218817a14d08d5 = $68aec2772563966a$var$REACT_NATIVE_MODULE_DURATION_MAX, $68aec2772563966a$export$96066c6fa0d06464 = $68aec2772563966a$var$REACT_NATIVE_MODULE_DURATION_TOTAL, $68aec2772563966a$export$a78cfb50aa50bca4 = $68aec2772563966a$var$REACT_NATIVE_MODULE_ERROR_COUNT, $68aec2772563966a$export$79b15960e18053b9 = $68aec2772563966a$var$REACT_NATIVE_MODULE_KIND, $68aec2772563966a$export$8e8a40d1629c4be = $68aec2772563966a$var$REACT_NATIVE_MODULE_METHOD, $68aec2772563966a$export$668dbefe39a14e9 = $68aec2772563966a$var$REACT_NATIVE_MODULE_NAME, $68aec2772563966a$export$ee766f53806dcc0a = $68aec2772563966a$var$REACT_NATIVE_MODULE_TOP_DURATION, $68aec2772563966a$export$6670b5eb4860054b = $68aec2772563966a$var$REACT_NATIVE_MODULE_TOP_NAME, $68aec2772563966a$export$9be2ae89a1eac217 = $68aec2772563966a$var$REACT_VERSION, $68aec2772563966a$export$51231929dd279b6d = $68aec2772563966a$var$REDIS_COMMAND, $68aec2772563966a$export$5c83e6b57d4562ef = $68aec2772563966a$var$REDIS_KEY, $68aec2772563966a$export$5c698591c0e586a2 = $68aec2772563966a$var$RELEASE, $68aec2772563966a$export$b711f2bb9c9a848a = $68aec2772563966a$var$REMIX_ACTION_FORM_DATA_KEY, $68aec2772563966a$export$1d3a8501efd30213 = $68aec2772563966a$var$REMIX_ACTION_FORM_DATA_KEY_BASE, $68aec2772563966a$export$e0df0d58e945a144 = $68aec2772563966a$var$REPLAYID, $68aec2772563966a$export$cebaf684ced5a2c9 = $68aec2772563966a$var$REPLAY_ID, $68aec2772563966a$export$d4c658ecdcb7c78c = $68aec2772563966a$var$RESOURCE_DEPLOYMENT_ENVIRONMENT, $68aec2772563966a$export$b1b162b01baeb044 = $68aec2772563966a$var$RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME, $68aec2772563966a$export$8be2d593d7f88ed8 = $68aec2772563966a$var$RESOURCE_RENDER_BLOCKING_STATUS, $68aec2772563966a$export$dbd0a3528a97ccc0 = $68aec2772563966a$var$ROUTE, $68aec2772563966a$export$b506afe31324afa3 = $68aec2772563966a$var$ROUTER_NAVIGATION_ORIGIN, $68aec2772563966a$export$953df8d049a11237 = $68aec2772563966a$var$ROUTER_NAVIGATION_ROUTE_ID, $68aec2772563966a$export$db0d98a58164f739 = $68aec2772563966a$var$ROUTER_NAVIGATION_TYPE, $68aec2772563966a$export$66581dc6d3d083d1 = $68aec2772563966a$var$RPC_GRPC_STATUS_CODE, $68aec2772563966a$export$e545f99e7abcc499 = $68aec2772563966a$var$RPC_METHOD, $68aec2772563966a$export$7e1af5787f8c4aaa = $68aec2772563966a$var$RPC_RESPONSE_STATUS_CODE, $68aec2772563966a$export$186c94c351c54768 = $68aec2772563966a$var$RPC_SERVICE, $68aec2772563966a$export$2e3fd8dfcb16fe0c = $68aec2772563966a$var$RPC_SYSTEM, $68aec2772563966a$export$7eeeceaa1dbd7cd5 = $68aec2772563966a$var$RPC_SYSTEM_NAME, $68aec2772563966a$export$9d5bffdff936d554 = $68aec2772563966a$var$RUNTIME_BUILD, $68aec2772563966a$export$dc3a801c9a2c5b79 = $68aec2772563966a$var$RUNTIME_NAME, $68aec2772563966a$export$27933a9557f87e98 = $68aec2772563966a$var$RUNTIME_RAW_DESCRIPTION, $68aec2772563966a$export$eefa737b40a0d535 = $68aec2772563966a$var$RUNTIME_VERSION, $68aec2772563966a$export$92740ffbcb02553b = $68aec2772563966a$var$SCORE_KEY, $68aec2772563966a$export$500e89753f9f1008 = $68aec2772563966a$var$SCORE_KEY_BASE, $68aec2772563966a$export$d91a18e47fdddefd = $68aec2772563966a$var$SCORE_RATIO_KEY, $68aec2772563966a$export$eccbe6f20884ea7f = $68aec2772563966a$var$SCORE_RATIO_KEY_BASE, $68aec2772563966a$export$9e24f11d79141afb = $68aec2772563966a$var$SCORE_TOTAL, $68aec2772563966a$export$f0b96ad9586f8887 = $68aec2772563966a$var$SCORE_WEIGHT_KEY, $68aec2772563966a$export$8a92ed5d436a85c6 = $68aec2772563966a$var$SCORE_WEIGHT_KEY_BASE, $68aec2772563966a$export$edd59acdf7e86a71 = $68aec2772563966a$var$SENTRY_ACTION, $68aec2772563966a$export$ae81a1ae71952d50 = $68aec2772563966a$var$SENTRY_BROWSER_NAME, $68aec2772563966a$export$6101470cd57eac1b = $68aec2772563966a$var$SENTRY_BROWSER_VERSION, $68aec2772563966a$export$452c0aee9673fe67 = $68aec2772563966a$var$SENTRY_CANCELLATION_REASON, $68aec2772563966a$export$773dddd1e8667756 = $68aec2772563966a$var$SENTRY_CATEGORY, $68aec2772563966a$export$98815f8579a64a90 = $68aec2772563966a$var$SENTRY_CLIENT_SAMPLE_RATE, $68aec2772563966a$export$7bc4e27428665019 = $68aec2772563966a$var$SENTRY_DESCRIPTION, $68aec2772563966a$export$e7d7477fa9057ee2 = $68aec2772563966a$var$SENTRY_DIST, $68aec2772563966a$export$1f4267a3fc018448 = $68aec2772563966a$var$SENTRY_DOMAIN, $68aec2772563966a$export$c171cae150389952 = $68aec2772563966a$var$SENTRY_DSC_ENVIRONMENT, $68aec2772563966a$export$d9bb35e957b22c72 = $68aec2772563966a$var$SENTRY_DSC_PROJECT_ID, $68aec2772563966a$export$b3508a2c95f74e3d = $68aec2772563966a$var$SENTRY_DSC_PUBLIC_KEY, $68aec2772563966a$export$20bb272f4d21532d = $68aec2772563966a$var$SENTRY_DSC_RELEASE, $68aec2772563966a$export$d7e64fbd0102ce90 = $68aec2772563966a$var$SENTRY_DSC_SAMPLED, $68aec2772563966a$export$c17eae7e86dbba3c = $68aec2772563966a$var$SENTRY_DSC_SAMPLE_RATE, $68aec2772563966a$export$349603c0a9165744 = $68aec2772563966a$var$SENTRY_DSC_TRACE_ID, $68aec2772563966a$export$4dadf693741f0283 = $68aec2772563966a$var$SENTRY_DSC_TRANSACTION, $68aec2772563966a$export$6377864d12f7eeb3 = $68aec2772563966a$var$SENTRY_ENVIRONMENT, $68aec2772563966a$export$6b892e5faf9c65ec = $68aec2772563966a$var$SENTRY_EVENT_SERIALIZED_BREADCRUMBS, $68aec2772563966a$export$b93169be52dcfc1 = $68aec2772563966a$var$SENTRY_EVENT_SERIALIZED_CONTEXTS, $68aec2772563966a$export$69ffc9f31c260bb4 = $68aec2772563966a$var$SENTRY_EVENT_SERIALIZED_EXTRA, $68aec2772563966a$export$1679f9582e34ea8d = $68aec2772563966a$var$SENTRY_EVENT_SERIALIZED_META, $68aec2772563966a$export$ba081af9585ed4 = $68aec2772563966a$var$SENTRY_EXCLUSIVE_TIME, $68aec2772563966a$export$13514311f5ad8904 = $68aec2772563966a$var$SENTRY_FRAMES_FROZEN, $68aec2772563966a$export$eaca45a91e334bc3 = $68aec2772563966a$var$SENTRY_FRAMES_SLOW, $68aec2772563966a$export$6d155392d40c193e = $68aec2772563966a$var$SENTRY_FRAMES_TOTAL, $68aec2772563966a$export$7841dacb241485d0 = $68aec2772563966a$var$SENTRY_GRAPHQL_OPERATION, $68aec2772563966a$export$52c7044cf6301362 = $68aec2772563966a$var$SENTRY_GROUP, $68aec2772563966a$export$56ea1c9e44590e20 = $68aec2772563966a$var$SENTRY_HTTP_PREFETCH, $68aec2772563966a$export$7626e389d05f4c36 = $68aec2772563966a$var$SENTRY_IDLE_SPAN_FINISH_REASON, $68aec2772563966a$export$fd6d8217c43d52a0 = $68aec2772563966a$var$SENTRY_IS_LOCALHOST, $68aec2772563966a$export$5e0a48187329b2e7 = $68aec2772563966a$var$SENTRY_IS_REMOTE, $68aec2772563966a$export$c322b150d7667841 = $68aec2772563966a$var$SENTRY_KIND, $68aec2772563966a$export$79ef102ff6c2276c = $68aec2772563966a$var$SENTRY_LINK_TYPE, $68aec2772563966a$export$4a4797d3c962f753 = $68aec2772563966a$var$SENTRY_MAIN_THREAD, $68aec2772563966a$export$767524d5e72e2645 = $68aec2772563966a$var$SENTRY_MESSAGE_PARAMETER_KEY, $68aec2772563966a$export$497354ca7b0ee666 = $68aec2772563966a$var$SENTRY_MESSAGE_TEMPLATE, $68aec2772563966a$export$cbdc4ad11118116a = $68aec2772563966a$var$SENTRY_METRIC_SOURCE, $68aec2772563966a$export$5b890de778c4c2fe = $68aec2772563966a$var$SENTRY_MOBILE, $68aec2772563966a$export$a78d9803b5e0a83e = $68aec2772563966a$var$SENTRY_MODULE_KEY, $68aec2772563966a$export$df1b536467b3992a = $68aec2772563966a$var$SENTRY_MODULE_KEY_BASE, $68aec2772563966a$export$73104a329e205998 = $68aec2772563966a$var$SENTRY_NEXTJS_SSR_FUNCTION_ROUTE, $68aec2772563966a$export$5740e3da55330b0a = $68aec2772563966a$var$SENTRY_NEXTJS_SSR_FUNCTION_TYPE, $68aec2772563966a$export$8dcc2d92ff6d65da = $68aec2772563966a$var$SENTRY_NORMALIZED_DB_QUERY, $68aec2772563966a$export$e5f1321e53e24810 = $68aec2772563966a$var$SENTRY_NORMALIZED_DB_QUERY_HASH, $68aec2772563966a$export$56dd3098cbca7c8a = $68aec2772563966a$var$SENTRY_NORMALIZED_DESCRIPTION, $68aec2772563966a$export$aa7aff70e4380665 = $68aec2772563966a$var$SENTRY_OBSERVED_TIMESTAMP_NANOS, $68aec2772563966a$export$dacb7d452aa6bcaf = $68aec2772563966a$var$SENTRY_OP, $68aec2772563966a$export$15dfc6c5e8f9baf6 = $68aec2772563966a$var$SENTRY_ORIGIN, $68aec2772563966a$export$e9a5de183fd08f2d = $68aec2772563966a$var$SENTRY_PAGELOAD_SPAN_ID, $68aec2772563966a$export$91ad03bba7909fb5 = $68aec2772563966a$var$SENTRY_PLATFORM, $68aec2772563966a$export$86128e6c0ab71d64 = $68aec2772563966a$var$SENTRY_PROFILER_ID, $68aec2772563966a$export$745b60c4819aec1d = $68aec2772563966a$var$SENTRY_PROFILE_ID, $68aec2772563966a$export$f83a3ef33e3015f5 = $68aec2772563966a$var$SENTRY_RELAY_INGRESS, $68aec2772563966a$export$4f324e8aab67771d = $68aec2772563966a$var$SENTRY_RELAY_PIPELINE, $68aec2772563966a$export$d2c893bfac1da9a1 = $68aec2772563966a$var$SENTRY_RELEASE, $68aec2772563966a$export$1c14ad02f9534b19 = $68aec2772563966a$var$SENTRY_REPLAY_ID, $68aec2772563966a$export$db3cb63e0594d014 = $68aec2772563966a$var$SENTRY_REPLAY_IS_BUFFERING, $68aec2772563966a$export$a65c9a0eba2c222d = $68aec2772563966a$var$SENTRY_REPORT_EVENT, $68aec2772563966a$export$68dbcca9c0e339ec = $68aec2772563966a$var$SENTRY_SDK_INTEGRATIONS, $68aec2772563966a$export$d59b669d4bb3f006 = $68aec2772563966a$var$SENTRY_SDK_NAME, $68aec2772563966a$export$4d88d347aa9667fc = $68aec2772563966a$var$SENTRY_SDK_VERSION, $68aec2772563966a$export$9943ffdcaa4bc506 = $68aec2772563966a$var$SENTRY_SEGMENT_ID, $68aec2772563966a$export$d4f25b923533dbba = $68aec2772563966a$var$SENTRY_SEGMENT_NAME, $68aec2772563966a$export$221a33f26f7c0739 = $68aec2772563966a$var$SENTRY_SEGMENT_NAME_SOURCE, $68aec2772563966a$export$35f3396a1cdeea45 = $68aec2772563966a$var$SENTRY_SERVER_SAMPLE_RATE, $68aec2772563966a$export$80e399da474bc98d = $68aec2772563966a$var$SENTRY_SOURCE, $68aec2772563966a$export$e01809e2dbceac35 = $68aec2772563966a$var$SENTRY_SPAN_SOURCE, $68aec2772563966a$export$41900d5c4e8a9c68 = $68aec2772563966a$var$SENTRY_STATUS, $68aec2772563966a$export$362bb1cb0bb5ca03 = $68aec2772563966a$var$SENTRY_STATUS_CODE, $68aec2772563966a$export$6803ac54f919d9cc = $68aec2772563966a$var$SENTRY_STATUS_MESSAGE, $68aec2772563966a$export$72f5b47540331169 = $68aec2772563966a$var$SENTRY_SVELTEKIT_NAVIGATION_FROM, $68aec2772563966a$export$6c61a8c9aa5305cb = $68aec2772563966a$var$SENTRY_SVELTEKIT_NAVIGATION_TO, $68aec2772563966a$export$6b5244c457b68e65 = $68aec2772563966a$var$SENTRY_SVELTEKIT_NAVIGATION_TYPE, $68aec2772563966a$export$b7bd0c9a886f3414 = $68aec2772563966a$var$SENTRY_THREAD_ID, $68aec2772563966a$export$6b77f2bacac7c93d = $68aec2772563966a$var$SENTRY_TIMESTAMP_SEQUENCE, $68aec2772563966a$export$ddbc15c0e8e8a7ea = $68aec2772563966a$var$SENTRY_TRACE_LIFECYCLE, $68aec2772563966a$export$feb4fe753df28a82 = $68aec2772563966a$var$SENTRY_TRACE_PARENT_SPAN_ID, $68aec2772563966a$export$d6267756132e2175 = $68aec2772563966a$var$SENTRY_TRACE_STATUS, $68aec2772563966a$export$570ac5a3fd7e6cc6 = $68aec2772563966a$var$SENTRY_TRANSACTION, $68aec2772563966a$export$5b9a0015e1c530ed = $68aec2772563966a$var$SENTRY_USER_EMAIL, $68aec2772563966a$export$8bbff71c84508218 = $68aec2772563966a$var$SENTRY_USER_GEO_CITY, $68aec2772563966a$export$b55aa07a514a2430 = $68aec2772563966a$var$SENTRY_USER_GEO_COUNTRY_CODE, $68aec2772563966a$export$9927ad09f7c084dc = $68aec2772563966a$var$SENTRY_USER_GEO_REGION, $68aec2772563966a$export$52a07a35ff8ec6b6 = $68aec2772563966a$var$SENTRY_USER_GEO_SUBDIVISION, $68aec2772563966a$export$a10d277c42e6cae3 = $68aec2772563966a$var$SENTRY_USER_ID, $68aec2772563966a$export$cdc0ce5c66182801 = $68aec2772563966a$var$SENTRY_USER_IP, $68aec2772563966a$export$2504d4bd698dd962 = $68aec2772563966a$var$SENTRY_USER_USERNAME, $68aec2772563966a$export$9dc86f3b876e96ef = $68aec2772563966a$var$SERVER_ADDRESS, $68aec2772563966a$export$70ff7865f52549ae = $68aec2772563966a$var$SERVER_NAME, $68aec2772563966a$export$f77b53a42be6e6fd = $68aec2772563966a$var$SERVER_PORT, $68aec2772563966a$export$818eb7ab11414506 = $68aec2772563966a$var$SERVICE_NAME, $68aec2772563966a$export$829ef6b2e59d984d = $68aec2772563966a$var$SERVICE_VERSION, $68aec2772563966a$export$b30f4cb52c088a26 = $68aec2772563966a$var$SESSION_ID, $68aec2772563966a$export$335eace0ff1771cd = $68aec2772563966a$var$STALL_PERCENTAGE, $68aec2772563966a$export$374d88a2025416ac = $68aec2772563966a$var$STALL_TOTAL_TIME, $68aec2772563966a$export$8c1c09aad940c209 = $68aec2772563966a$var$STARLETTE_MIDDLEWARE_NAME, $68aec2772563966a$export$73086897ee87592 = $68aec2772563966a$var$STARLITE_MIDDLEWARE_NAME, $68aec2772563966a$export$bb7a91303551eb37 = $68aec2772563966a$var$STATE_TYPE, $68aec2772563966a$export$d7c235242f462725 = $68aec2772563966a$var$SUBPROCESS_PID, $68aec2772563966a$export$66bace8969e2e3d5 = $68aec2772563966a$var$SVELTEKIT_LOAD_ENVIRONMENT, $68aec2772563966a$export$ace44ef9ab757803 = $68aec2772563966a$var$SVELTEKIT_LOAD_NODE_ID, $68aec2772563966a$export$73e8c5f1140c4791 = $68aec2772563966a$var$SVELTEKIT_LOAD_NODE_TYPE, $68aec2772563966a$export$77af2faf6df02a72 = $68aec2772563966a$var$SVELTEKIT_TRACING_ORIGINAL_NAME, $68aec2772563966a$export$f132ea291a7db56b = $68aec2772563966a$var$THREAD_ID, $68aec2772563966a$export$f0abd4170bbd2468 = $68aec2772563966a$var$THREAD_NAME, $68aec2772563966a$export$50d00a157dc08581 = $68aec2772563966a$var$TIMBER_TAG, $68aec2772563966a$export$484576567a98833f = $68aec2772563966a$var$TIME_TO_FULL_DISPLAY, $68aec2772563966a$export$ec9e491e475d0c97 = $68aec2772563966a$var$TIME_TO_INITIAL_DISPLAY, $68aec2772563966a$export$a86c59c10992220f = $68aec2772563966a$var$TRANSACTION, $68aec2772563966a$export$e12f06597e992fde = $68aec2772563966a$var$TRPC_PROCEDURE_PATH, $68aec2772563966a$export$7ec54678ba28ea59 = $68aec2772563966a$var$TRPC_PROCEDURE_TYPE, $68aec2772563966a$export$433ba14c16717110 = $68aec2772563966a$var$TTFB, $68aec2772563966a$export$309ee349b8a537f = $68aec2772563966a$var$TTFB_REQUESTTIME, $68aec2772563966a$export$a344421384e4626b = $68aec2772563966a$var$TURBO_MODULES_TOTAL_CALL_COUNT, $68aec2772563966a$export$e43f29da852027e9 = $68aec2772563966a$var$TURBO_MODULES_TOTAL_DURATION_MS, $68aec2772563966a$export$f4e00a7a768abc8 = $68aec2772563966a$var$TURBO_MODULES_TOTAL_ERROR_COUNT, $68aec2772563966a$export$7a5e4e7104ab3b9a = $68aec2772563966a$var$TURBO_MODULES_UNIQUE_METHODS, $68aec2772563966a$export$905bea62c04473b4 = $68aec2772563966a$var$TURBO_MODULE_ARCH, $68aec2772563966a$export$94549a3d156ca6e3 = $68aec2772563966a$var$TURBO_MODULE_METHOD, $68aec2772563966a$export$c64c67f496c0a458 = $68aec2772563966a$var$TURBO_MODULE_NAME, $68aec2772563966a$export$9559a80e6d3976cf = $68aec2772563966a$var$TURBO_MODULE_TOP_MODULE, $68aec2772563966a$export$ad5635d1786f4dce = $68aec2772563966a$var$TURBO_MODULE_TOP_MODULE_DURATION_MS, $68aec2772563966a$export$281536c6742b39c8 = $68aec2772563966a$var$TURBO_MODULE_TOTAL_CALL_COUNT, $68aec2772563966a$export$e28d8f7876943c30 = $68aec2772563966a$var$TURBO_MODULE_TOTAL_DURATION_MS, $68aec2772563966a$export$ff74fcec9c21ca2b = $68aec2772563966a$var$TURBO_MODULE_TOTAL_ERROR_COUNT, $68aec2772563966a$export$190fe5bf513bf32b = $68aec2772563966a$var$TURBO_MODULE_UNIQUE_METHODS, $68aec2772563966a$export$b87f371cbc396fcf = $68aec2772563966a$var$TYPE, $68aec2772563966a$export$60050fc49fe0e7e2 = $68aec2772563966a$var$UI_COMPONENT_NAME, $68aec2772563966a$export$348c8e2b37f276cd = $68aec2772563966a$var$UI_CONTRIBUTES_TO_TTFD, $68aec2772563966a$export$7f47e8a8b2d97cb2 = $68aec2772563966a$var$UI_CONTRIBUTES_TO_TTID, $68aec2772563966a$export$50d5adc4b543ce95 = $68aec2772563966a$var$UI_ELEMENT_HEIGHT, $68aec2772563966a$export$9221f1d2c934d9f = $68aec2772563966a$var$UI_ELEMENT_ID, $68aec2772563966a$export$3a56578b3ae09a02 = $68aec2772563966a$var$UI_ELEMENT_IDENTIFIER, $68aec2772563966a$export$e47b8dab9466c895 = $68aec2772563966a$var$UI_ELEMENT_LOAD_TIME, $68aec2772563966a$export$4ca52f75cf4889c5 = $68aec2772563966a$var$UI_ELEMENT_PAINT_TYPE, $68aec2772563966a$export$7343d7d72195067f = $68aec2772563966a$var$UI_ELEMENT_RENDER_TIME, $68aec2772563966a$export$f334f32f8d4d8063 = $68aec2772563966a$var$UI_ELEMENT_TYPE, $68aec2772563966a$export$c7bf2089e89a217c = $68aec2772563966a$var$UI_ELEMENT_URL, $68aec2772563966a$export$f514f97553a434b2 = $68aec2772563966a$var$UI_ELEMENT_WIDTH, $68aec2772563966a$export$61abde59b50deb8e = "url", $68aec2772563966a$export$5a5ce44f9fb51f93 = $68aec2772563966a$var$URL_DOMAIN, $68aec2772563966a$export$7044ea8d89b6f59d = $68aec2772563966a$var$URL_FRAGMENT, $68aec2772563966a$export$40eacf1a072c9dbd = $68aec2772563966a$var$URL_FULL, $68aec2772563966a$export$4c1fa0ac0eff2ac = $68aec2772563966a$var$URL_PATH, $68aec2772563966a$export$5bee9450fe31dde1 = $68aec2772563966a$var$URL_PATH_PARAMETER_KEY, $68aec2772563966a$export$d0b571fb4406d953 = $68aec2772563966a$var$URL_PATH_PARAMETER_KEY_BASE, $68aec2772563966a$export$d51317816423085d = $68aec2772563966a$var$URL_PATH_PARAMS_KEY, $68aec2772563966a$export$96a83d41c14e5647 = $68aec2772563966a$var$URL_PATH_PARAMS_KEY_BASE, $68aec2772563966a$export$258b370e6c2b85d5 = $68aec2772563966a$var$URL_PORT, $68aec2772563966a$export$dc5e5523da291a4b = $68aec2772563966a$var$URL_QUERY, $68aec2772563966a$export$fd5a8904ab5abfe0 = $68aec2772563966a$var$URL_SAME_ORIGIN, $68aec2772563966a$export$1350d8937b0f26fb = $68aec2772563966a$var$URL_SCHEME, $68aec2772563966a$export$2a045f777fb349a8 = $68aec2772563966a$var$URL_TEMPLATE, $68aec2772563966a$export$8bb874585539a88f = $68aec2772563966a$var$USER_AGENT_ORIGINAL, $68aec2772563966a$export$17d3a50785727199 = $68aec2772563966a$var$USER_EMAIL, $68aec2772563966a$export$2931c570009689e = $68aec2772563966a$var$USER_FULL_NAME, $68aec2772563966a$export$199cbcedee735a43 = $68aec2772563966a$var$USER_GEO_CITY, $68aec2772563966a$export$4ba5bf9d4e3ed862 = $68aec2772563966a$var$USER_GEO_COUNTRY_CODE, $68aec2772563966a$export$674c01ec2f0b89c3 = $68aec2772563966a$var$USER_GEO_REGION, $68aec2772563966a$export$bda1686739fd61c7 = $68aec2772563966a$var$USER_GEO_SUBDIVISION, $68aec2772563966a$export$8d804148f485d54c = $68aec2772563966a$var$USER_HASH, $68aec2772563966a$export$212a8f1ea37518bd = $68aec2772563966a$var$USER_ID, $68aec2772563966a$export$c9ac0fee28245883 = $68aec2772563966a$var$USER_IP_ADDRESS, $68aec2772563966a$export$77078610759fe5f6 = $68aec2772563966a$var$USER_NAME, $68aec2772563966a$export$7c6317deeec7a6c1 = $68aec2772563966a$var$USER_ROLES, $68aec2772563966a$export$877ebf2e4ad81f03 = $68aec2772563966a$var$VERCEL_BRANCH, $68aec2772563966a$export$70b2343945496e1f = $68aec2772563966a$var$VERCEL_BUILD_ID, $68aec2772563966a$export$8415b56d2c6d2b1d = $68aec2772563966a$var$VERCEL_DEPLOYMENT_ID, $68aec2772563966a$export$cc81114a03caab18 = $68aec2772563966a$var$VERCEL_DESTINATION, $68aec2772563966a$export$bc14eb892daceb23 = $68aec2772563966a$var$VERCEL_EDGE_TYPE, $68aec2772563966a$export$3c973217450c3e9d = $68aec2772563966a$var$VERCEL_ENTRYPOINT, $68aec2772563966a$export$582c0b730ff1ddb9 = $68aec2772563966a$var$VERCEL_EXECUTION_REGION, $68aec2772563966a$export$b3edfb545b65f1c5 = $68aec2772563966a$var$VERCEL_ID, $68aec2772563966a$export$2593317d8731841c = $68aec2772563966a$var$VERCEL_JA3_DIGEST, $68aec2772563966a$export$8bb5bc1732aa41f = $68aec2772563966a$var$VERCEL_JA4_DIGEST, $68aec2772563966a$export$74a79c98b110b5b9 = $68aec2772563966a$var$VERCEL_LOG_TYPE, $68aec2772563966a$export$26461b03281b4db4 = $68aec2772563966a$var$VERCEL_PATH, $68aec2772563966a$export$eaea590d6d3dd93c = $68aec2772563966a$var$VERCEL_PROJECT_ID, $68aec2772563966a$export$af45365f70099379 = $68aec2772563966a$var$VERCEL_PROJECT_NAME, $68aec2772563966a$export$a49e732d34d5ba9b = $68aec2772563966a$var$VERCEL_PROXY_CACHE_ID, $68aec2772563966a$export$7c147fe246bc8bd3 = $68aec2772563966a$var$VERCEL_PROXY_CLIENT_IP, $68aec2772563966a$export$e5111b6070e1ee9e = $68aec2772563966a$var$VERCEL_PROXY_HOST, $68aec2772563966a$export$591cbfd403f8c8d = $68aec2772563966a$var$VERCEL_PROXY_LAMBDA_REGION, $68aec2772563966a$export$b1388db955bbb885 = $68aec2772563966a$var$VERCEL_PROXY_METHOD, $68aec2772563966a$export$e898d0e9e211abd9 = $68aec2772563966a$var$VERCEL_PROXY_PATH, $68aec2772563966a$export$ab6fee0e8a6ee069 = $68aec2772563966a$var$VERCEL_PROXY_PATH_TYPE, $68aec2772563966a$export$9786ad94c199ffbb = $68aec2772563966a$var$VERCEL_PROXY_PATH_TYPE_VARIANT, $68aec2772563966a$export$269890524eed693b = $68aec2772563966a$var$VERCEL_PROXY_REFERER, $68aec2772563966a$export$2ec623a8212d6b64 = $68aec2772563966a$var$VERCEL_PROXY_REGION, $68aec2772563966a$export$30e7673b01ff994e = $68aec2772563966a$var$VERCEL_PROXY_RESPONSE_BYTE_SIZE, $68aec2772563966a$export$9ea93477840812bf = $68aec2772563966a$var$VERCEL_PROXY_SCHEME, $68aec2772563966a$export$a6da0c365670c430 = $68aec2772563966a$var$VERCEL_PROXY_STATUS_CODE, $68aec2772563966a$export$7986b22da43f2885 = $68aec2772563966a$var$VERCEL_PROXY_TIMESTAMP, $68aec2772563966a$export$a9f943c7ceb3b42f = $68aec2772563966a$var$VERCEL_PROXY_USER_AGENT, $68aec2772563966a$export$dfe49501efcdffce = $68aec2772563966a$var$VERCEL_PROXY_VERCEL_CACHE, $68aec2772563966a$export$be465f50c92eb01d = $68aec2772563966a$var$VERCEL_PROXY_VERCEL_ID, $68aec2772563966a$export$c138d1796bb34999 = $68aec2772563966a$var$VERCEL_PROXY_WAF_ACTION, $68aec2772563966a$export$85a0016690a0ccf2 = $68aec2772563966a$var$VERCEL_PROXY_WAF_RULE_ID, $68aec2772563966a$export$883acab36ede4bfa = $68aec2772563966a$var$VERCEL_REQUEST_ID, $68aec2772563966a$export$9cfc88d203f9cdf1 = $68aec2772563966a$var$VERCEL_SOURCE, $68aec2772563966a$export$b3c6c599110d7bab = $68aec2772563966a$var$VERCEL_STATUS_CODE, $68aec2772563966a$export$700a3f96cb39930 = $68aec2772563966a$var$_AI_MODEL_ID, $68aec2772563966a$export$247839c65766758 = $68aec2772563966a$var$_AWS_KINESIS_STREAM_NAME, $68aec2772563966a$export$f4d52b02df927d54 = $68aec2772563966a$var$_AWS_REQUEST_ID, $68aec2772563966a$export$8baf9330c244c0ee = $68aec2772563966a$var$_GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS, $68aec2772563966a$export$7d0cb6c474a8d8dd = $68aec2772563966a$var$_GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS, $68aec2772563966a$export$df30ee8c5b5f1989 = $68aec2772563966a$var$_HTTP_REQUEST_METHOD, $68aec2772563966a$export$ae4fc52420ecd4bc = $68aec2772563966a$var$_MESSAGING_MESSAGE_ID, $68aec2772563966a$export$268a117c860fca6d = $68aec2772563966a$var$_SENTRY_SEGMENT_ID; //# sourceMappingURL=attributes.cjs.map

});

parcelRegister("ilhFV", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $g64OG = parcelRequire("g64OG");
function isNodeEnv() {
    return !(0, $g64OG.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}

});
parcelRegister("g64OG", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $bb80f155363963cc$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $bb80f155363963cc$export$8ad33f488b1ab046; });
function $bb80f155363963cc$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $bb80f155363963cc$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});


const $d8189db5678eaa24$export$31499a9cd224b78c = "11.4.0";


const $ac5f383786409d8e$export$f1a6cdb1459e81d1 = globalThis;


function $4d3ec8641bdc53a2$export$19eade501500c6c1() {
    $4d3ec8641bdc53a2$export$c8bfa33e4e8ae492((0, $ac5f383786409d8e$export$f1a6cdb1459e81d1));
    return 0, $ac5f383786409d8e$export$f1a6cdb1459e81d1;
}
function $4d3ec8641bdc53a2$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.version = __SENTRY__.version || (0, $d8189db5678eaa24$export$31499a9cd224b78c);
    return __SENTRY__[0, $d8189db5678eaa24$export$31499a9cd224b78c] = __SENTRY__[0, $d8189db5678eaa24$export$31499a9cd224b78c] || {};
}
function $4d3ec8641bdc53a2$export$7e223ec222791509(name, creator, obj = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $d8189db5678eaa24$export$31499a9cd224b78c] = __SENTRY__[0, $d8189db5678eaa24$export$31499a9cd224b78c] || {};
    return carrier[name] || (carrier[name] = creator());
}



const $7d7ee71e9314e5f0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






const $fc0ca994ab4632cd$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
const $fc0ca994ab4632cd$var$PREFIX = "Sentry Logger ";
const $fc0ca994ab4632cd$export$77c4ce905194557b = {};
function $fc0ca994ab4632cd$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($fc0ca994ab4632cd$export$77c4ce905194557b);
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $fc0ca994ab4632cd$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $fc0ca994ab4632cd$var$enable() {
    $fc0ca994ab4632cd$var$_getLoggerSettings().enabled = true;
}
function $fc0ca994ab4632cd$var$disable() {
    $fc0ca994ab4632cd$var$_getLoggerSettings().enabled = false;
}
function $fc0ca994ab4632cd$var$isEnabled() {
    return $fc0ca994ab4632cd$var$_getLoggerSettings().enabled;
}
function $fc0ca994ab4632cd$var$log(...args) {
    $fc0ca994ab4632cd$var$_maybeLog("log", ...args);
}
function $fc0ca994ab4632cd$var$warn(...args) {
    $fc0ca994ab4632cd$var$_maybeLog("warn", ...args);
}
function $fc0ca994ab4632cd$var$error(...args) {
    $fc0ca994ab4632cd$var$_maybeLog("error", ...args);
}
function $fc0ca994ab4632cd$var$_maybeLog(level, ...args) {
    if (!(0, $7d7ee71e9314e5f0$export$16a28057038b10ef)) return;
    if ($fc0ca994ab4632cd$var$isEnabled()) $fc0ca994ab4632cd$export$cda52e2a8927a2ca(()=>{
        (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).console[level](`${$fc0ca994ab4632cd$var$PREFIX}[${level}]:`, ...args);
    });
}
function $fc0ca994ab4632cd$var$_getLoggerSettings() {
    if (!(0, $7d7ee71e9314e5f0$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $4d3ec8641bdc53a2$export$7e223ec222791509)("loggerSettings", ()=>({
            enabled: false
        }));
}
const $fc0ca994ab4632cd$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $fc0ca994ab4632cd$var$enable,
    disable: /** Disable logging. */ $fc0ca994ab4632cd$var$disable,
    isEnabled: /** Check if logging is enabled. */ $fc0ca994ab4632cd$var$isEnabled,
    log: /** Log a message. */ $fc0ca994ab4632cd$var$log,
    warn: /** Log a warning. */ $fc0ca994ab4632cd$var$warn,
    error: /** Log an error. */ $fc0ca994ab4632cd$var$error
};


const $1ae1983cb9bdf286$var$objectToString = Object.prototype.toString;
function $1ae1983cb9bdf286$export$e6127cc7fe7395c3(wat) {
    switch($1ae1983cb9bdf286$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $1ae1983cb9bdf286$export$49034edbe6b62415(wat, Error);
    }
}
function $1ae1983cb9bdf286$var$isBuiltin(wat, className) {
    return $1ae1983cb9bdf286$var$objectToString.call(wat) === `[object ${className}]`;
}
function $1ae1983cb9bdf286$export$9f9636d330b71954(wat) {
    return $1ae1983cb9bdf286$var$isBuiltin(wat, "ErrorEvent");
}
function $1ae1983cb9bdf286$export$ef9e2056653f0c8e(wat) {
    return $1ae1983cb9bdf286$var$isBuiltin(wat, "DOMError");
}
function $1ae1983cb9bdf286$export$12e869b2a583f783(wat) {
    return $1ae1983cb9bdf286$var$isBuiltin(wat, "DOMException");
}
function $1ae1983cb9bdf286$export$844ec244b1367d54(wat) {
    return $1ae1983cb9bdf286$var$isBuiltin(wat, "String");
}
function $1ae1983cb9bdf286$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function $1ae1983cb9bdf286$export$c3825b437cbdea5c(wat) {
    return wat === null || $1ae1983cb9bdf286$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function $1ae1983cb9bdf286$export$53b83ca8eaab0383(wat) {
    return $1ae1983cb9bdf286$var$isBuiltin(wat, "Object");
}
function $1ae1983cb9bdf286$export$c10d0b04eaa80a43(wat) {
    return typeof wat === "object" && wat !== null;
}
function $1ae1983cb9bdf286$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $1ae1983cb9bdf286$export$49034edbe6b62415(wat, Event);
}
function $1ae1983cb9bdf286$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $1ae1983cb9bdf286$export$49034edbe6b62415(wat, Element);
}
function $1ae1983cb9bdf286$export$49841c62b9eff15(wat) {
    return $1ae1983cb9bdf286$var$isBuiltin(wat, "RegExp");
}
function $1ae1983cb9bdf286$export$f5b060c2914b97c8(wat) {
    return Boolean(wat?.then && typeof wat.then === "function");
}
function $1ae1983cb9bdf286$export$bc2894c7158efbac(wat) {
    return $1ae1983cb9bdf286$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $1ae1983cb9bdf286$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
function $1ae1983cb9bdf286$export$7916fad0ebc23f48(wat) {
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function $1ae1983cb9bdf286$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $1ae1983cb9bdf286$export$49034edbe6b62415(request, Request);
}


function $984d7f4f9d559811$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    if (typeof wrapped === "function") $984d7f4f9d559811$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
function $984d7f4f9d559811$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
function $984d7f4f9d559811$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $984d7f4f9d559811$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch  {}
}
function $984d7f4f9d559811$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== "function") throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($984d7f4f9d559811$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $984d7f4f9d559811$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
function $984d7f4f9d559811$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $984d7f4f9d559811$export$62ff257738bf57f5(value) {
    if ((0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$984d7f4f9d559811$var$getOwnProperties(value)
    };
    if ((0, $1ae1983cb9bdf286$export$9671ea99bd126ace)(value)) {
        const { type: type, target: target, currentTarget: currentTarget, detail: detail } = value;
        return {
            type: type,
            target: target,
            currentTarget: currentTarget,
            ...detail ? {
                detail: detail
            } : {},
            ...$984d7f4f9d559811$var$getOwnProperties(value)
        };
    }
    return value;
}
function $984d7f4f9d559811$var$getOwnProperties(obj) {
    if ((0, $1ae1983cb9bdf286$export$c10d0b04eaa80a43)(obj)) return Object.fromEntries(Object.entries(obj));
    return {};
}
function $984d7f4f9d559811$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($984d7f4f9d559811$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function $984d7f4f9d559811$export$d25f2688db1bb433(inputValue) {
    const memoizationMap = /* @__PURE__ */ new Map();
    return $984d7f4f9d559811$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $984d7f4f9d559811$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) return memoVal;
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($984d7f4f9d559811$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($984d7f4f9d559811$var$isPojo(inputValue)) {
        const returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== void 0) returnValue[key] = $984d7f4f9d559811$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    return inputValue;
}
function $984d7f4f9d559811$var$isPojo(input) {
    const constructor = input.constructor;
    return constructor === Object || constructor === void 0;
}
function $984d7f4f9d559811$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == void 0:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $1ae1983cb9bdf286$export$c3825b437cbdea5c)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



let $a53c09ef0441e640$var$RESOLVED_RUNNER;
function $a53c09ef0441e640$export$ff239213cb80e2da(cb) {
    if ($a53c09ef0441e640$var$RESOLVED_RUNNER !== void 0) return $a53c09ef0441e640$var$RESOLVED_RUNNER ? $a53c09ef0441e640$var$RESOLVED_RUNNER(cb) : cb();
    const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
    const globalWithSymbol = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
        $a53c09ef0441e640$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $a53c09ef0441e640$var$RESOLVED_RUNNER(cb);
    }
    $a53c09ef0441e640$var$RESOLVED_RUNNER = null;
    return cb();
}
function $a53c09ef0441e640$export$9869d72de32a3917() {
    return $a53c09ef0441e640$export$ff239213cb80e2da(()=>Math.random());
}
function $a53c09ef0441e640$export$65b1bada40c91b34() {
    return $a53c09ef0441e640$export$ff239213cb80e2da(()=>Date.now());
}




const $9e2df984025255a3$var$SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const $9e2df984025255a3$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function $9e2df984025255a3$export$280812de8e91ea53(obj) {
    (0, $984d7f4f9d559811$export$e73679ffaf56810e)(obj, $9e2df984025255a3$var$SENTRY_SKIP_NORMALIZATION, true);
}
function $9e2df984025255a3$export$610d1422c4bdc4c1(obj, depth) {
    (0, $984d7f4f9d559811$export$e73679ffaf56810e)(obj, $9e2df984025255a3$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function $9e2df984025255a3$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$9e2df984025255a3$var$SENTRY_SKIP_NORMALIZATION]);
}
function $9e2df984025255a3$export$fe95a19841c4b155(value) {
    const v = value[$9e2df984025255a3$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === "number" ? v : void 0;
}



const $3a6ba34e83b7a312$var$STACKTRACE_FRAME_LIMIT = 50;
const $3a6ba34e83b7a312$export$27c7e15d453fc0ac = "?";
const $3a6ba34e83b7a312$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $3a6ba34e83b7a312$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function $3a6ba34e83b7a312$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            if (line.length > 1024) line = line.slice(0, 1024);
            const cleanedLine = $3a6ba34e83b7a312$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($3a6ba34e83b7a312$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            if (cleanedLine.includes("Error: ")) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $3a6ba34e83b7a312$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $3a6ba34e83b7a312$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
function $3a6ba34e83b7a312$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $3a6ba34e83b7a312$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
function $3a6ba34e83b7a312$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    if (/sentryWrapped/.test($3a6ba34e83b7a312$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    localStack.reverse();
    if ($3a6ba34e83b7a312$var$STRIP_FRAME_REGEXP.test($3a6ba34e83b7a312$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        if ($3a6ba34e83b7a312$var$STRIP_FRAME_REGEXP.test($3a6ba34e83b7a312$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $3a6ba34e83b7a312$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $3a6ba34e83b7a312$var$getLastStackFrame(localStack).filename,
            function: frame.function || $3a6ba34e83b7a312$export$27c7e15d453fc0ac
        }));
}
function $3a6ba34e83b7a312$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $3a6ba34e83b7a312$var$defaultFunctionName = "<anonymous>";
function $3a6ba34e83b7a312$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $3a6ba34e83b7a312$var$defaultFunctionName;
        return fn.name || $3a6ba34e83b7a312$var$defaultFunctionName;
    } catch  {
        return $3a6ba34e83b7a312$var$defaultFunctionName;
    }
}
function $3a6ba34e83b7a312$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            exception.values.forEach((value)=>{
                if (value.stacktrace.frames) frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return void 0;
        }
    }
    return void 0;
}
function $3a6ba34e83b7a312$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith("file://") ? path.slice(7) : path;
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


let $fce87edf3ea2bc99$var$stringifier;
function $fce87edf3ea2bc99$export$575c40989754ba4d(newStringifier) {
    $fce87edf3ea2bc99$var$stringifier = newStringifier;
}
function $fce87edf3ea2bc99$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        return $fce87edf3ea2bc99$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
function $fce87edf3ea2bc99$export$23fbbb20bed71033(object, depth = 3, maxSize = 102400) {
    const normalized = $fce87edf3ea2bc99$export$a3295358bff77e(object, depth);
    if ($fce87edf3ea2bc99$var$jsonSize(normalized) > maxSize) return $fce87edf3ea2bc99$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
function $fce87edf3ea2bc99$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $fce87edf3ea2bc99$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $fce87edf3ea2bc99$export$a110e5bc79f44a84(key, value);
    if (!stringified.startsWith("[object ")) return stringified;
    if ((0, $9e2df984025255a3$export$c8d26b7b28f926c7)(value)) return value;
    const overrideDepth = (0, $9e2df984025255a3$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
    if (remainingDepth === 0) return stringified.replace("object ", "");
    if (memoize(value)) return "[Circular ~]";
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        return $fce87edf3ea2bc99$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {}
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    const visitable = (0, $984d7f4f9d559811$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $fce87edf3ea2bc99$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function $fce87edf3ea2bc99$export$a110e5bc79f44a84(key, value) {
    try {
        if ($fce87edf3ea2bc99$var$stringifier) {
            const stringified = $fce87edf3ea2bc99$var$stringifier(value);
            if (stringified) return stringified;
        }
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $3a6ba34e83b7a312$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        const objName = $fce87edf3ea2bc99$var$getConstructorName(value);
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $fce87edf3ea2bc99$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function $fce87edf3ea2bc99$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function $fce87edf3ea2bc99$var$jsonSize(value) {
    return $fce87edf3ea2bc99$var$utf8Length(JSON.stringify(value));
}
function $fce87edf3ea2bc99$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {}
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function $fce87edf3ea2bc99$var$memoBuilder() {
    const inner = /* @__PURE__ */ new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}


function $2daf90cbbc571ec6$export$fac44ee5b035f737(value, fallback = "[unserializable]") {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch  {
        return typeof fallback === "function" ? fallback(value) : fallback;
    }
}
function $2daf90cbbc571ec6$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function $2daf90cbbc571ec6$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $2daf90cbbc571ec6$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if ((0, $1ae1983cb9bdf286$export$c3825b437cbdea5c)(value)) output.push(String(value));
        else if (value instanceof Error) output.push(value.message ? `${value.name}: ${value.message}` : value.name);
        else output.push((0, $fce87edf3ea2bc99$export$a110e5bc79f44a84)(void 0, value));
    }
    return output.join(delimiter);
}
function $2daf90cbbc571ec6$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $1ae1983cb9bdf286$export$844ec244b1367d54)(value)) return false;
    if ((0, $1ae1983cb9bdf286$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $1ae1983cb9bdf286$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === "function") return pattern(value);
    return false;
}
function $2daf90cbbc571ec6$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($2daf90cbbc571ec6$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $2a3bde5300b2c383$var$getCrypto() {
    const gbl = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $2a3bde5300b2c383$var$emptyUuid;
function $2a3bde5300b2c383$var$getRandomByte() {
    return (0, $a53c09ef0441e640$export$9869d72de32a3917)() * 16;
}
function $2a3bde5300b2c383$export$19f53698e68b2496(crypto = $2a3bde5300b2c383$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) return (0, $a53c09ef0441e640$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, "");
    } catch  {}
    if (!$2a3bde5300b2c383$var$emptyUuid) $2a3bde5300b2c383$var$emptyUuid = "10000000100040008000100000000000";
    return $2a3bde5300b2c383$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($2a3bde5300b2c383$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $2a3bde5300b2c383$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
function $2a3bde5300b2c383$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $2a3bde5300b2c383$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $2a3bde5300b2c383$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $2a3bde5300b2c383$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $2a3bde5300b2c383$var$getFirstException(event);
    if (!firstException) return;
    $2a3bde5300b2c383$var$applyExceptionMechanism(firstException, newMechanism);
}
function $2a3bde5300b2c383$export$b84d26f4cd61a104(event, newMechanism) {
    const exceptions = event.exception?.values;
    const capturedException = exceptions?.find((exception)=>exception.mechanism?.exception_id === 0) ?? exceptions?.[0];
    if (!capturedException) return;
    $2a3bde5300b2c383$var$applyExceptionMechanism(capturedException, newMechanism);
}
function $2a3bde5300b2c383$var$applyExceptionMechanism(exception, newMechanism) {
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = exception.mechanism;
    exception.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) exception.mechanism.data = {
        ...currentMechanism?.data,
        ...newMechanism.data
    };
}
const $2a3bde5300b2c383$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $2a3bde5300b2c383$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
function $2a3bde5300b2c383$export$d364f2020ab30578(input) {
    const match = input.match($2a3bde5300b2c383$var$SEMVER_REGEXP) || [];
    const major = $2a3bde5300b2c383$var$_parseInt(match[1]);
    const minor = $2a3bde5300b2c383$var$_parseInt(match[2]);
    const patch = $2a3bde5300b2c383$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? void 0 : major,
        minor: isNaN(minor) ? void 0 : minor,
        patch: isNaN(patch) ? void 0 : patch,
        prerelease: match[4]
    };
}
function $2a3bde5300b2c383$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    if (frame.lineno === void 0) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $2daf90cbbc571ec6$export$4215662d762d6f9d)(line, 0));
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    frame.context_line = (0, $2daf90cbbc571ec6$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $2daf90cbbc571ec6$export$4215662d762d6f9d)(line, 0));
}
function $2a3bde5300b2c383$export$6de4ffac6a2f1098(exception) {
    if ($2a3bde5300b2c383$export$4a38e013f66150b(exception)) return true;
    try {
        (0, $984d7f4f9d559811$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch  {}
    return false;
}
function $2a3bde5300b2c383$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {}
}




const $81000fbf661a21ed$var$ONE_SECOND_IN_MS = 1e3;
function $81000fbf661a21ed$export$7740643b9eeaf0c4() {
    return (0, $a53c09ef0441e640$export$65b1bada40c91b34)() / $81000fbf661a21ed$var$ONE_SECOND_IN_MS;
}
function $81000fbf661a21ed$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1);
    if (!performance?.now || !performance.timeOrigin) return $81000fbf661a21ed$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    return ()=>{
        return (timeOrigin + (0, $a53c09ef0441e640$export$ff239213cb80e2da)(()=>performance.now())) / $81000fbf661a21ed$var$ONE_SECOND_IN_MS;
    };
}
let $81000fbf661a21ed$var$_cachedTimestampInSeconds;
function $81000fbf661a21ed$export$ee52dced521e3e18() {
    const func = $81000fbf661a21ed$var$_cachedTimestampInSeconds ?? ($81000fbf661a21ed$var$_cachedTimestampInSeconds = $81000fbf661a21ed$var$createUnixTimestampInSecondsFunc());
    return func();
}
let $81000fbf661a21ed$var$cachedTimeOrigin = null;
function $81000fbf661a21ed$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1);
    if (!performance?.now) return void 0;
    const threshold = 3e5;
    const performanceNow = (0, $a53c09ef0441e640$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $a53c09ef0441e640$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === "number") {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    return dateNow - performanceNow;
}
function $81000fbf661a21ed$export$baf075a948ffc0bf() {
    if ($81000fbf661a21ed$var$cachedTimeOrigin === null) $81000fbf661a21ed$var$cachedTimeOrigin = $81000fbf661a21ed$var$getBrowserTimeOrigin();
    return $81000fbf661a21ed$var$cachedTimeOrigin;
}


function $08100e97513aa8d3$export$14a186326edbb264(context) {
    const startingTime = (0, $81000fbf661a21ed$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $2a3bde5300b2c383$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$08100e97513aa8d3$var$sessionToJSON(session)
    };
    if (context) $08100e97513aa8d3$export$531818e825e774db(session, context);
    return session;
}
function $08100e97513aa8d3$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $81000fbf661a21ed$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $2a3bde5300b2c383$export$19f53698e68b2496)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $08100e97513aa8d3$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $08100e97513aa8d3$export$531818e825e774db(session, context);
}
function $08100e97513aa8d3$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}





function $58b2a0935e7deba4$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $58b2a0935e7deba4$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




function $9462dad4273cdb86$export$dc6d7ea554bcce10() {
    return (0, $2a3bde5300b2c383$export$19f53698e68b2496)();
}
function $9462dad4273cdb86$export$295213bc4d0c54ad() {
    return (0, $2a3bde5300b2c383$export$19f53698e68b2496)().substring(16);
}





const $949194bd893febb8$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $949194bd893febb8$export$775b6bb06e53a214 {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        (0, $984d7f4f9d559811$export$e73679ffaf56810e)(this, "refs", {});
        this._propagationContext = {
            traceId: (0, $9462dad4273cdb86$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $a53c09ef0441e640$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $949194bd893febb8$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        newScope.refs = {
            ...this.refs
        };
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $08100e97513aa8d3$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $949194bd893febb8$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $1ae1983cb9bdf286$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $949194bd893febb8$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $81000fbf661a21ed$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $2daf90cbbc571ec6$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $58b2a0935e7deba4$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $2a3bde5300b2c383$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $2a3bde5300b2c383$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $2a3bde5300b2c383$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


function $4aacdbe66e943d85$export$6f1b9191db9c4d5() {
    return (0, $4d3ec8641bdc53a2$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $949194bd893febb8$export$775b6bb06e53a214)());
}
function $4aacdbe66e943d85$export$de9862929b76bf57() {
    return (0, $4d3ec8641bdc53a2$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $949194bd893febb8$export$775b6bb06e53a214)());
}



const $e9cc6781075c01e1$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";


const $734c68c63b5fb6c5$var$isActualPromise = (p)=>p instanceof Promise && !p[$734c68c63b5fb6c5$var$kChainedCopy];
const $734c68c63b5fb6c5$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $734c68c63b5fb6c5$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $734c68c63b5fb6c5$var$isActualPromise(chained) && $734c68c63b5fb6c5$var$isActualPromise(original) ? chained : $734c68c63b5fb6c5$var$copyProps(original, chained);
};
const $734c68c63b5fb6c5$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$734c68c63b5fb6c5$var$kChainedCopy]: true
    });
    return chained;
};




class $7f3927035490d1d9$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $949194bd893febb8$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $949194bd893febb8$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $1ae1983cb9bdf286$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $734c68c63b5fb6c5$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $7f3927035490d1d9$var$getAsyncContextStack() {
    const registry = (0, $4d3ec8641bdc53a2$export$19eade501500c6c1)();
    const sentry = (0, $4d3ec8641bdc53a2$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $7f3927035490d1d9$export$d36ec451f120cfba((0, $4aacdbe66e943d85$export$6f1b9191db9c4d5)(), (0, $4aacdbe66e943d85$export$de9862929b76bf57)());
}
function $7f3927035490d1d9$var$withScope(callback) {
    return $7f3927035490d1d9$var$getAsyncContextStack().withScope(callback);
}
function $7f3927035490d1d9$var$withSetScope(scope, callback) {
    const stack = $7f3927035490d1d9$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $7f3927035490d1d9$var$withIsolationScope(callback) {
    return $7f3927035490d1d9$var$getAsyncContextStack().withScope(()=>{
        return callback($7f3927035490d1d9$var$getAsyncContextStack().getIsolationScope());
    });
}
function $7f3927035490d1d9$export$329d4d4d54e42710() {
    return {
        suppressTracing: $7f3927035490d1d9$var$suppressTracingInStack,
        withIsolationScope: $7f3927035490d1d9$var$withIsolationScope,
        withScope: $7f3927035490d1d9$var$withScope,
        withSetScope: $7f3927035490d1d9$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $7f3927035490d1d9$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$7f3927035490d1d9$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$7f3927035490d1d9$var$getAsyncContextStack().getIsolationScope()
    };
}
function $7f3927035490d1d9$var$suppressTracingInStack(callback) {
    return $7f3927035490d1d9$var$withScope((scope)=>{
        scope.setSDKProcessingMetadata({
            [(0, $e9cc6781075c01e1$export$61ab4e30f2201736)]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [(0, $e9cc6781075c01e1$export$61ab4e30f2201736)]: void 0
        });
        return res;
    });
}


function $26a480180ec922aa$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $4d3ec8641bdc53a2$export$19eade501500c6c1)();
    const sentry = (0, $4d3ec8641bdc53a2$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
function $26a480180ec922aa$export$f639b0c2752203be(carrier) {
    const sentry = (0, $4d3ec8641bdc53a2$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $7f3927035490d1d9$export$329d4d4d54e42710)();
}





function $6a0e69fdf33e8459$export$b5defb3466e9689b(fn) {
    (0, $4d3ec8641bdc53a2$export$c8bfa33e4e8ae492)((0, $4d3ec8641bdc53a2$export$19eade501500c6c1)()).externalPropagationContextProvider = fn;
}
function $6a0e69fdf33e8459$export$92547f779c920a71() {
    return (0, $4d3ec8641bdc53a2$export$c8bfa33e4e8ae492)((0, $4d3ec8641bdc53a2$export$19eade501500c6c1)()).externalPropagationContextProvider?.();
}
function $6a0e69fdf33e8459$export$53f0ae651a1c4298() {
    return (0, $4d3ec8641bdc53a2$export$c8bfa33e4e8ae492)((0, $4d3ec8641bdc53a2$export$19eade501500c6c1)()).externalPropagationContextProvider !== void 0;
}
function $6a0e69fdf33e8459$export$c7be4b0125a10cba() {
    const carrier = (0, $4d3ec8641bdc53a2$export$19eade501500c6c1)();
    const acs = (0, $26a480180ec922aa$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $6a0e69fdf33e8459$export$68f3af03034c9e90() {
    const carrier = (0, $4d3ec8641bdc53a2$export$19eade501500c6c1)();
    const acs = (0, $26a480180ec922aa$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $6a0e69fdf33e8459$export$aa55d5ab8e05984f() {
    return (0, $4d3ec8641bdc53a2$export$7e223ec222791509)("globalScope", ()=>new (0, $949194bd893febb8$export$775b6bb06e53a214)());
}
function $6a0e69fdf33e8459$export$ec58d9285c204497(...rest) {
    const carrier = (0, $4d3ec8641bdc53a2$export$19eade501500c6c1)();
    const acs = (0, $26a480180ec922aa$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $6a0e69fdf33e8459$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $4d3ec8641bdc53a2$export$19eade501500c6c1)();
    const acs = (0, $26a480180ec922aa$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $6a0e69fdf33e8459$export$6bb76d6eba7e258c() {
    return $6a0e69fdf33e8459$export$c7be4b0125a10cba().getClient();
}
function $6a0e69fdf33e8459$export$1e83db7ee4876dc4(scope) {
    const externalContext = $6a0e69fdf33e8459$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $9462dad4273cdb86$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}







const $26d85213e847db5d$export$afe9d811094f080b = /* @__PURE__ */ Symbol.for("SentryCallbackError");
function $26d85213e847db5d$export$6671884dec007c51(message, fn, fallback) {
    let result;
    try {
        result = fn();
    } catch (error) {
        return $26d85213e847db5d$var$recover(message, error, fallback);
    }
    if ((0, $1ae1983cb9bdf286$export$f5b060c2914b97c8)(result)) return result.then(void 0, (error)=>$26d85213e847db5d$var$recover(message, error, fallback));
    return result;
}
function $26d85213e847db5d$var$recover(message, error, fallback) {
    (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error(message, error);
    return fallback(error);
}



const $7035b569e51f49e8$var$DEFAULT_BREADCRUMBS = 100;
function $7035b569e51f49e8$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $7035b569e51f49e8$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $81000fbf661a21ed$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $26d85213e847db5d$export$6671884dec007c51)((0, $7d7ee71e9314e5f0$export$16a28057038b10ef) ? "The `beforeBreadcrumb` callback threw an error, dropping the breadcrumb:" : "", ()=>(0, $fc0ca994ab4632cd$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)), ()=>null) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}











const $a745ef85d447d054$var$handlers = {};
const $a745ef85d447d054$var$instrumented = {};
function $a745ef85d447d054$export$a4e09611e30da72e(type, handler) {
    $a745ef85d447d054$var$handlers[type] = $a745ef85d447d054$var$handlers[type] || [];
    $a745ef85d447d054$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $a745ef85d447d054$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
function $a745ef85d447d054$export$b17eab759a1cb5fe() {
    Object.keys($a745ef85d447d054$var$handlers).forEach((key)=>{
        $a745ef85d447d054$var$handlers[key] = void 0;
    });
}
function $a745ef85d447d054$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$a745ef85d447d054$var$instrumented[type]) {
        $a745ef85d447d054$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
function $a745ef85d447d054$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $a745ef85d447d054$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $3a6ba34e83b7a312$export$aad197c7121a6651)(handler)}
Error:`, e);
    }
}


const $f7096be499948b9f$var$_filter = /* @__PURE__ */ new Set([]);
function $f7096be499948b9f$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    const removeHandler = (0, $a745ef85d447d054$export$a4e09611e30da72e)(type, handler);
    (0, $a745ef85d447d054$export$e18d6c5462c01368)(type, $f7096be499948b9f$export$b80c01837473f7bc);
    return removeHandler;
}
function $f7096be499948b9f$export$7444162f8bcc9c91(filter) {
    for (const f of filter)$f7096be499948b9f$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$f7096be499948b9f$var$_filter.delete(f);
    };
}
const $f7096be499948b9f$var$instrumentedLevels = /* @__PURE__ */ new Set();
function $f7096be499948b9f$export$b80c01837473f7bc() {
    if (!("console" in (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1))) return;
    (0, $fc0ca994ab4632cd$export$2a2b1d2252a69ecb).forEach(function(level) {
        if ($f7096be499948b9f$var$instrumentedLevels.has(level) || !(level in (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).console)) return;
        $f7096be499948b9f$var$instrumentedLevels.add(level);
        (0, $984d7f4f9d559811$export$9563e054e6f787fb)((0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $fc0ca994ab4632cd$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = (0, $fc0ca994ab4632cd$export$77c4ce905194557b)[level];
                const isFiltered = $f7096be499948b9f$var$_filter.size && typeof firstArg === "string" && (0, $2daf90cbbc571ec6$export$a7a5ec66062ea5d)(firstArg, $f7096be499948b9f$var$_filter);
                if (!isFiltered) (0, $a745ef85d447d054$export$b18c893e424d3127)("console", {
                    args: args,
                    level: level
                });
                if (!isFiltered || (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).isEnabled()) log?.apply((0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}





const $44faf1ffd3373da7$export$b14a8888f80a0b3e = [];
function $44faf1ffd3373da7$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $44faf1ffd3373da7$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $44faf1ffd3373da7$var$filterDuplicates(integrations);
}
function $44faf1ffd3373da7$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $44faf1ffd3373da7$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $44faf1ffd3373da7$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $44faf1ffd3373da7$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$44faf1ffd3373da7$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $44faf1ffd3373da7$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
function $44faf1ffd3373da7$export$2d8f5188773bcddd(integration) {
    const client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $44faf1ffd3373da7$export$2323046b9414659f(fn) {
    return fn;
}
function $44faf1ffd3373da7$export$92d0786473d2c0a1(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}



function $bb2a0743e42959d1$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}




const $4d30674a292df795$var$INTEGRATION_NAME = "Console";
const $4d30674a292df795$export$d79e728262dba9d2 = (0, $44faf1ffd3373da7$export$2323046b9414659f)((options = {})=>{
    const levels = new Set(options.levels || (0, $fc0ca994ab4632cd$export$2a2b1d2252a69ecb));
    return {
        name: $4d30674a292df795$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = (0, $f7096be499948b9f$export$1d6e0d073f9e6723)(({ args: args, level: level })=>{
                if ((0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)() !== client || !levels.has(level)) return;
                $4d30674a292df795$export$ab7688db3040206a(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe2 = (0, $f7096be499948b9f$export$7444162f8bcc9c91)(options.filter);
                client.registerCleanup(unsubscribe2);
            }
        }
    };
});
function $4d30674a292df795$export$ab7688db3040206a(level, args) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: args,
            logger: "console"
        },
        level: (0, $bb2a0743e42959d1$export$d771ef054122c30a)(level),
        message: $4d30674a292df795$var$formatConsoleArgs(args)
    };
    if (level === "assert") {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$4d30674a292df795$var$formatConsoleArgs(assertionArgs)}` : "Assertion failed";
            breadcrumb.data.arguments = assertionArgs;
        } else return;
    }
    (0, $7035b569e51f49e8$export$efda9a273d7a036d)(breadcrumb, {
        input: args,
        level: level
    });
}
function $4d30674a292df795$var$formatConsoleArgs(values) {
    return "util" in (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1) && typeof (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).util.format === "function" ? (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).util.format(...values) : (0, $2daf90cbbc571ec6$export$465e9d514283d4fd)(values, " ");
}

var $4e79bc9bf7524846$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$4e79bc9bf7524846$exports = (parcelRequire("2sN1e"));






function $136e6f9d05dd2c20$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $136e6f9d05dd2c20$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $136e6f9d05dd2c20$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $136e6f9d05dd2c20$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $136e6f9d05dd2c20$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $136e6f9d05dd2c20$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $136e6f9d05dd2c20$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $136e6f9d05dd2c20$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $1ae1983cb9bdf286$export$c3825b437cbdea5c)(val)) weight += $136e6f9d05dd2c20$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $136e6f9d05dd2c20$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $136e6f9d05dd2c20$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}





const $6e2fe664af4a7693$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $6e2fe664af4a7693$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $6e2fe664af4a7693$export$1a413bd9a88fdb09 = "sentry.op";
const $6e2fe664af4a7693$export$cca8dd30f57f805e = "sentry.origin";
const $6e2fe664af4a7693$export$d9e02c0285078f88 = "sentry.status.message";
const $6e2fe664af4a7693$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $6e2fe664af4a7693$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $6e2fe664af4a7693$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $6e2fe664af4a7693$export$f5cefb258679b29e = "sentry.release";
const $6e2fe664af4a7693$export$d1b1dbb47f5ba57c = "sentry.environment";
const $6e2fe664af4a7693$export$4626f2be16112c1c = "sentry.segment.name";
const $6e2fe664af4a7693$export$25fa4a1832d3736a = "sentry.segment.id";
const $6e2fe664af4a7693$export$87a4807042e1f1bb = "sentry.sdk.name";
const $6e2fe664af4a7693$export$301ebe936458e291 = "sentry.sdk.version";
const $6e2fe664af4a7693$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $6e2fe664af4a7693$export$1f9cc1d34ea098a0 = "user.id";
const $6e2fe664af4a7693$export$b7466609ef46c07e = "user.email";
const $6e2fe664af4a7693$export$8d592bdaea63b930 = "user.ip_address";
const $6e2fe664af4a7693$export$c05ee933d3f74b2b = "user.name";
const $6e2fe664af4a7693$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $6e2fe664af4a7693$export$1efec95406bbe327 = "sentry.profile_id";
const $6e2fe664af4a7693$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $6e2fe664af4a7693$export$b016f89ac1066ec = "cache.hit";
const $6e2fe664af4a7693$export$3110e4c3f4386399 = "cache.key";
const $6e2fe664af4a7693$export$86be76deee227ff2 = "cache.item_size";
const $6e2fe664af4a7693$export$be7a251980e7e946 = "http.request.method";
const $6e2fe664af4a7693$export$25dfd73e0e32c6e1 = "url.full";
const $6e2fe664af4a7693$export$ff77b5fd5b2d627b = "sentry.link.type";
const $6e2fe664af4a7693$export$71a4a707257f2774 = "gen_ai.conversation.id";


const $2e9332be9806297c$export$535be0e2ad921430 = [
    /** The operation completed successfully. */ "ok",
    /** Deadline expired before operation could complete. */ "deadline_exceeded",
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ "unauthenticated",
    /** 403 Forbidden */ "permission_denied",
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ "not_found",
    /** 429 Too Many Requests */ "resource_exhausted",
    /** Client specified an invalid argument. 4xx. */ "invalid_argument",
    /** 501 Not Implemented */ "unimplemented",
    /** 503 Service Unavailable */ "unavailable",
    /** Other/generic 5xx. */ "internal_error",
    /** Unknown. Any non-standard HTTP status code. */ "unknown_error",
    /** The operation was cancelled (typically by the user). */ "cancelled",
    /** Already exists (409) */ "already_exists",
    /** Operation was rejected because the system is not in a state required for the operation's */ "failed_precondition",
    /** The operation was aborted, typically due to a concurrency issue. */ "aborted",
    /** Operation was attempted past the valid range. */ "out_of_range",
    /** Unrecoverable data loss or corruption */ "data_loss"
];


const $91e1d4594ffd7cad$export$136e25984ba4a383 = 0;
const $91e1d4594ffd7cad$export$58f7963109c806fc = 1;
const $91e1d4594ffd7cad$export$f966a0446ece71e = 2;
function $91e1d4594ffd7cad$export$d2a33fbcfc5998aa(message) {
    return message !== "ok" && (0, $2e9332be9806297c$export$535be0e2ad921430).includes(message);
}
function $91e1d4594ffd7cad$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $91e1d4594ffd7cad$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $91e1d4594ffd7cad$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $91e1d4594ffd7cad$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $91e1d4594ffd7cad$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $91e1d4594ffd7cad$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}




function $199d7f5ef6aecb28$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $199d7f5ef6aecb28$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}


const $ede25f0577eb9341$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $ede25f0577eb9341$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $ede25f0577eb9341$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $ede25f0577eb9341$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $984d7f4f9d559811$export$e73679ffaf56810e)(span, $ede25f0577eb9341$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $199d7f5ef6aecb28$export$f0b98edec95fcb33)(isolationScope));
        (0, $984d7f4f9d559811$export$e73679ffaf56810e)(span, $ede25f0577eb9341$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $ede25f0577eb9341$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$ede25f0577eb9341$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $199d7f5ef6aecb28$export$a0592ad8c3586cf)(spanWithScopes[$ede25f0577eb9341$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $ede25f0577eb9341$export$6ba79447c0a2d852(span) {
    (0, $984d7f4f9d559811$export$e73679ffaf56810e)(span, $ede25f0577eb9341$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $ede25f0577eb9341$export$a9ba2a501dbf6a56(span) {
    return span[$ede25f0577eb9341$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}









const $8afb25e073bbebf6$export$6e69537d67fa20f = "sentry-";
const $8afb25e073bbebf6$export$eb0401070c617ea5 = /^sentry-/;
const $8afb25e073bbebf6$export$bdd844ddb2def819 = 8192;
function $8afb25e073bbebf6$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $8afb25e073bbebf6$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($8afb25e073bbebf6$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($8afb25e073bbebf6$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $8afb25e073bbebf6$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$8afb25e073bbebf6$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $8afb25e073bbebf6$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $8afb25e073bbebf6$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $1ae1983cb9bdf286$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $8afb25e073bbebf6$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $8afb25e073bbebf6$var$baggageHeaderToObject(baggageHeader);
}
function $8afb25e073bbebf6$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $8afb25e073bbebf6$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $8afb25e073bbebf6$export$bdd844ddb2def819) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $8afb25e073bbebf6$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $8afb25e073bbebf6$export$397de414d189db00(existing);
    const incomingEntries = $8afb25e073bbebf6$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($8afb25e073bbebf6$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($8afb25e073bbebf6$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $8afb25e073bbebf6$export$12a7349a29a6e3c2(merged);
}




const $587fc376b57159be$var$ORG_ID_REGEX = /^o(\d+)\./;
const $587fc376b57159be$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $587fc376b57159be$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $587fc376b57159be$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $587fc376b57159be$export$b892860177f70a30(str) {
    const match = $587fc376b57159be$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $fc0ca994ab4632cd$export$cda52e2a8927a2ca)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $587fc376b57159be$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $587fc376b57159be$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $587fc376b57159be$var$validateDsn(dsn) {
    if (!(0, $7d7ee71e9314e5f0$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$587fc376b57159be$var$isValidProtocol(protocol)) {
        (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $587fc376b57159be$export$5914f4e7748c29c9(host) {
    const match = host.match($587fc376b57159be$var$ORG_ID_REGEX);
    return match?.[1];
}
function $587fc376b57159be$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $587fc376b57159be$export$5914f4e7748c29c9(host);
    return org_id;
}
function $587fc376b57159be$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $587fc376b57159be$export$b892860177f70a30(from) : $587fc376b57159be$var$dsnFromComponents(from);
    if (!components || !$587fc376b57159be$var$validateDsn(components)) return void 0;
    return components;
}


function $a5f687bfe070f998$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}




const $40920a36c62b4ac8$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $40920a36c62b4ac8$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($40920a36c62b4ac8$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $40920a36c62b4ac8$export$d6559160aa7f14fa(propagationContext) {
    return !!propagationContext.parentSpanId || !!propagationContext.dsc;
}
function $40920a36c62b4ac8$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $40920a36c62b4ac8$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $8afb25e073bbebf6$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $9462dad4273cdb86$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $a53c09ef0441e640$export$9869d72de32a3917)()
    };
    const sampleRand = $40920a36c62b4ac8$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $40920a36c62b4ac8$export$f35d907436da45cf(traceId = (0, $9462dad4273cdb86$export$dc6d7ea554bcce10)(), spanId = (0, $9462dad4273cdb86$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $40920a36c62b4ac8$export$1aff3752542747dd(traceId = (0, $9462dad4273cdb86$export$dc6d7ea554bcce10)(), spanId = (0, $9462dad4273cdb86$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $40920a36c62b4ac8$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $a5f687bfe070f998$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $a5f687bfe070f998$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $a53c09ef0441e640$export$9869d72de32a3917)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $a53c09ef0441e640$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else return (0, $a53c09ef0441e640$export$9869d72de32a3917)();
}
function $40920a36c62b4ac8$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $587fc376b57159be$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}



const $b083f34fb8527170$var$SCOPE_SPAN_FIELD = "span";
function $b083f34fb8527170$export$3f25fa50c18e20ca(scope, span) {
    if (span) scope.refs[$b083f34fb8527170$var$SCOPE_SPAN_FIELD] = (0, $199d7f5ef6aecb28$export$f0b98edec95fcb33)(span);
    else delete scope.refs[$b083f34fb8527170$var$SCOPE_SPAN_FIELD];
}
function $b083f34fb8527170$export$91f063ebb8eff307(scope) {
    return (0, $199d7f5ef6aecb28$export$a0592ad8c3586cf)(scope.refs[$b083f34fb8527170$var$SCOPE_SPAN_FIELD]);
}


const $1c045c464121271a$export$208d5b368507fb8b = 0;
const $1c045c464121271a$export$eb571cd9b5d98de8 = 1;
function $1c045c464121271a$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $1c045c464121271a$export$1d09902424677504(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $1c045c464121271a$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $1c045c464121271a$export$1d09902424677504(span).parent_span_id;
    const scope = (0, $ede25f0577eb9341$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $9462dad4273cdb86$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $1c045c464121271a$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $1c045c464121271a$export$5caecac1caaf3a71(span);
    return (0, $40920a36c62b4ac8$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $1c045c464121271a$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $1c045c464121271a$export$5caecac1caaf3a71(span);
    return (0, $40920a36c62b4ac8$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $1c045c464121271a$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $1c045c464121271a$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $1c045c464121271a$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $1c045c464121271a$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $1c045c464121271a$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $1c045c464121271a$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $1c045c464121271a$var$ensureTimestampInSeconds(input.getTime());
    return (0, $81000fbf661a21ed$export$ee52dced521e3e18)();
}
function $1c045c464121271a$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $1c045c464121271a$export$1d09902424677504(span) {
    if ($1c045c464121271a$export$50882270da12d911(span)) return span.getStaticSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($1c045c464121271a$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $1c045c464121271a$var$getOtelParentSpanId(span),
            start_timestamp: $1c045c464121271a$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $1c045c464121271a$export$3f7581298f56c6d7(endTime) || void 0,
            status: $1c045c464121271a$export$e238a77ea3a8cd66(status),
            op: attributes[0, $6e2fe664af4a7693$export$1a413bd9a88fdb09],
            origin: attributes[0, $6e2fe664af4a7693$export$cca8dd30f57f805e],
            links: $1c045c464121271a$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        status: "ok",
        data: {}
    };
}
function $1c045c464121271a$export$92d8c23565496537(span) {
    if ($1c045c464121271a$export$50882270da12d911(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($1c045c464121271a$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $1c045c464121271a$var$getOtelParentSpanId(span),
            start_timestamp: $1c045c464121271a$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            end_timestamp: $1c045c464121271a$export$3f7581298f56c6d7(endTime) || void 0,
            is_segment: $1c045c464121271a$export$7ca4411336e328a2(span),
            status: $1c045c464121271a$export$d3856a3187d34821(status),
            attributes: $1c045c464121271a$export$1464a9cb828ba99f(attributes, status),
            links: $1c045c464121271a$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        status: "ok",
        is_segment: $1c045c464121271a$export$7ca4411336e328a2(span),
        attributes: {}
    };
}
function $1c045c464121271a$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $1c045c464121271a$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        // We only ever send ended spans, but fall back to the start time (i.e. duration 0) so that
        // sent spans always carry an end timestamp.
        end_timestamp: spanJson.end_timestamp ?? spanJson.start_timestamp,
        attributes: (0, $136e6f9d05dd2c20$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $136e6f9d05dd2c20$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $1c045c464121271a$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $1c045c464121271a$export$50882270da12d911(span) {
    return typeof span.getSpanJSON === "function";
}
function $1c045c464121271a$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $1c045c464121271a$export$eb571cd9b5d98de8;
}
function $1c045c464121271a$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $91e1d4594ffd7cad$export$136e25984ba4a383)) return "ok";
    if (status.code === (0, $91e1d4594ffd7cad$export$58f7963109c806fc)) return "ok";
    return status.message && (0, $91e1d4594ffd7cad$export$d2a33fbcfc5998aa)(status.message) ? status.message : "internal_error";
}
function $1c045c464121271a$export$d3856a3187d34821(status) {
    return !status || status.code === (0, $91e1d4594ffd7cad$export$58f7963109c806fc) || status.code === (0, $91e1d4594ffd7cad$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
function $1c045c464121271a$export$1464a9cb828ba99f(attributes, status) {
    const statusMessage = $1c045c464121271a$export$d3856a3187d34821(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [(0, $4e79bc9bf7524846$exports.SENTRY_STATUS_MESSAGE)]: statusMessage
        },
        ...attributes
    };
}
const $1c045c464121271a$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $1c045c464121271a$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $1c045c464121271a$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$1c045c464121271a$var$ROOT_SPAN_FIELD] || span;
    (0, $984d7f4f9d559811$export$e73679ffaf56810e)(childSpan, $1c045c464121271a$var$ROOT_SPAN_FIELD, rootSpan);
    childSpan.setAttribute((0, $4e79bc9bf7524846$exports.SENTRY_SEGMENT_NAME_SOURCE), void 0);
    if (!$1c045c464121271a$export$5caecac1caaf3a71(span)) return;
    if (!span.isRecording() && !rootSpan.isRecording()) return;
    if (span[$1c045c464121271a$var$CHILD_SPANS_FIELD]) span[$1c045c464121271a$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $984d7f4f9d559811$export$e73679ffaf56810e)(span, $1c045c464121271a$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $1c045c464121271a$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$1c045c464121271a$var$CHILD_SPANS_FIELD]) span[$1c045c464121271a$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $1c045c464121271a$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($1c045c464121271a$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$1c045c464121271a$var$CHILD_SPANS_FIELD] ? Array.from(span2[$1c045c464121271a$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $1c045c464121271a$export$c4c6a79b1260ca1b = $1c045c464121271a$export$7a3106f345d83bb6;
function $1c045c464121271a$export$7a3106f345d83bb6(span) {
    return span[$1c045c464121271a$var$ROOT_SPAN_FIELD] || span;
}
function $1c045c464121271a$export$7ca4411336e328a2(span) {
    return span === $1c045c464121271a$export$7a3106f345d83bb6(span);
}
function $1c045c464121271a$export$1be426a8e585c83e(scope) {
    const carrier = (0, $4d3ec8641bdc53a2$export$19eade501500c6c1)();
    const acs = (0, $26a480180ec922aa$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan(scope);
    return (0, $b083f34fb8527170$export$91f063ebb8eff307)(scope || (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)());
}
function $1c045c464121271a$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $6e2fe664af4a7693$export$165ce9a229f6f050)]: name
    });
    $1c045c464121271a$export$82411d06d95c96cb(span, "custom");
}
function $1c045c464121271a$export$82411d06d95c96cb(span, source) {
    if ($1c045c464121271a$export$7ca4411336e328a2(span)) span.setAttribute((0, $4e79bc9bf7524846$exports.SENTRY_SEGMENT_NAME_SOURCE), source);
}


const $2a4e0e692d2cde1b$var$INTEGRATION_NAME = "ConversationId";
const $2a4e0e692d2cde1b$var$_conversationIdIntegration = ()=>{
    return {
        name: $2a4e0e692d2cde1b$var$INTEGRATION_NAME,
        setup (client) {
            client.on("spanStart", (span)=>{
                const scopeData = (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)().getScopeData();
                const isolationScopeData = (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = (0, $1c045c464121271a$export$1d09902424677504)(span);
                    if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) return;
                    span.setAttribute((0, $4e79bc9bf7524846$exports.GEN_AI_CONVERSATION_ID), conversationId);
                }
            });
        }
    };
};
const $2a4e0e692d2cde1b$export$97457a453081a5b3 = (0, $44faf1ffd3373da7$export$2323046b9414659f)($2a4e0e692d2cde1b$var$_conversationIdIntegration);





const $887e0571fdd7fb58$var$INTEGRATION_NAME = "Dedupe";
const $887e0571fdd7fb58$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $887e0571fdd7fb58$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            if (currentEvent.type) return currentEvent;
            try {
                if ($887e0571fdd7fb58$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch  {}
            return previousEvent = currentEvent;
        }
    };
};
const $887e0571fdd7fb58$export$6d39aa44cd0c7567 = (0, $44faf1ffd3373da7$export$2323046b9414659f)($887e0571fdd7fb58$var$_dedupeIntegration);
function $887e0571fdd7fb58$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($887e0571fdd7fb58$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($887e0571fdd7fb58$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $887e0571fdd7fb58$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) return false;
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$887e0571fdd7fb58$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$887e0571fdd7fb58$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $887e0571fdd7fb58$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $887e0571fdd7fb58$var$_getExceptionFromEvent(previousEvent);
    const currentException = $887e0571fdd7fb58$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$887e0571fdd7fb58$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$887e0571fdd7fb58$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $887e0571fdd7fb58$var$_isSameStacktrace(currentEvent, previousEvent) {
    const currentFrames = (0, $3a6ba34e83b7a312$export$91d8ca51bd9f6a47)(currentEvent);
    const previousFrames = (0, $3a6ba34e83b7a312$export$91d8ca51bd9f6a47)(previousEvent);
    if (!currentFrames || !previousFrames) return !currentFrames && !previousFrames;
    if (previousFrames.length !== currentFrames.length) return false;
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $887e0571fdd7fb58$var$_isSameFingerprint(currentEvent, previousEvent) {
    const currentFingerprint = currentEvent.fingerprint;
    const previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint || !previousFingerprint) return !currentFingerprint && !previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch  {
        return false;
    }
}
function $887e0571fdd7fb58$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}




function $8d5e751708f95974$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {}
    return possibleMessages;
}




const $6ea27b6ce1465afc$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    /^Can't find variable: gmo$/,
    // Error from Google Search App https://issuetracker.google.com/issues/396043331
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    // Random error that happens but not actionable or noticeable to end-users.
    /can't redefine non-configurable property "solana"/,
    // Probably a browser extension or custom browser (Brave) throwing this error
    /vv\(\)\.getRestrictions is not a function/,
    // Error thrown by GTM, seemingly not affecting end-users
    /Can't find variable: _AutofillCallbackHandler/,
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
    /Java exception was raised during method invocation$/,
    // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065, https://github.com/getsentry/sentry-javascript/issues/23733)
    /Java object is gone$/
];
const $6ea27b6ce1465afc$var$INTEGRATION_NAME = "EventFilters";
const $6ea27b6ce1465afc$export$9a84f518c163c552 = (0, $44faf1ffd3373da7$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $6ea27b6ce1465afc$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $6ea27b6ce1465afc$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $6ea27b6ce1465afc$var$_mergeOptions(options, clientOptions);
            }
            return $6ea27b6ce1465afc$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
function $6ea27b6ce1465afc$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $6ea27b6ce1465afc$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $6ea27b6ce1465afc$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        if ($6ea27b6ce1465afc$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${(0, $2a3bde5300b2c383$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($6ea27b6ce1465afc$var$_isUselessError(event)) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${(0, $2a3bde5300b2c383$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($6ea27b6ce1465afc$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${(0, $2a3bde5300b2c383$export$4157119e2b157127)(event)}.
Url: ${$6ea27b6ce1465afc$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$6ea27b6ce1465afc$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${(0, $2a3bde5300b2c383$export$4157119e2b157127)(event)}.
Url: ${$6ea27b6ce1465afc$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") {
        if ($6ea27b6ce1465afc$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${(0, $2a3bde5300b2c383$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $6ea27b6ce1465afc$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $8d5e751708f95974$export$d55a97c329cacfcc)(event).some((message)=>(0, $2daf90cbbc571ec6$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $6ea27b6ce1465afc$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $2daf90cbbc571ec6$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $6ea27b6ce1465afc$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $6ea27b6ce1465afc$var$_getEventFilterUrl(event);
    return !url ? false : (0, $2daf90cbbc571ec6$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $6ea27b6ce1465afc$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $6ea27b6ce1465afc$var$_getEventFilterUrl(event);
    return !url ? true : (0, $2daf90cbbc571ec6$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $6ea27b6ce1465afc$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $6ea27b6ce1465afc$var$_getEventFilterUrl(event) {
    try {
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $6ea27b6ce1465afc$var$_getLastValidUrl(frames) : null;
    } catch  {
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error(`Cannot extract url for event ${(0, $2a3bde5300b2c383$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $6ea27b6ce1465afc$var$_isUselessError(event) {
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}




const $fa0087c0bbbdfdd7$var$INTEGRATION_NAME = "FunctionToString";
const $fa0087c0bbbdfdd7$var$SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const $fa0087c0bbbdfdd7$var$_functionToStringIntegration = ()=>{
    return {
        name: $fa0087c0bbbdfdd7$var$INTEGRATION_NAME,
        setupOnce () {
            const originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $984d7f4f9d559811$export$e6cc1e135e2092e5)(this);
                    let unwrappedFunction;
                    try {
                        if ($fa0087c0bbbdfdd7$var$SETUP_CLIENTS.has((0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)()) && originalFunction !== void 0) unwrappedFunction = originalFunction;
                    } catch  {}
                    return originalFunctionToString.apply(unwrappedFunction ?? this, args);
                };
            } catch  {}
        },
        setup (client) {
            $fa0087c0bbbdfdd7$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
const $fa0087c0bbbdfdd7$export$7918117e9202e4fb = (0, $44faf1ffd3373da7$export$2323046b9414659f)($fa0087c0bbbdfdd7$var$_functionToStringIntegration);




function $ea5a1e95298af243$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) (0, $fc0ca994ab4632cd$export$1c9f709888824e05).enable();
        else (0, $fc0ca994ab4632cd$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $ea5a1e95298af243$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
function $ea5a1e95298af243$export$ecb76f41d43c0e43(client) {
    (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)().setClient(client);
}


class $1faf54aa90579c0e$export$d3735b5b644680e5 {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = /* @__PURE__ */ new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === void 0) return void 0;
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        this._cache.delete(key);
        if (this._cache.size >= this._maxSize) {
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}




const $351f5d6283f61aff$export$59adc876c1ebd512 = "[Filtered]";
const $351f5d6283f61aff$export$cdee6254fbd57505 = [
    "auth",
    "token",
    "secret",
    "session",
    // for the user_session cookie
    "password",
    "passwd",
    "pwd",
    "key",
    "jwt",
    "bearer",
    "sso",
    "saml",
    "csrf",
    "xsrf",
    "credentials",
    "sid",
    "identity",
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    "set-cookie",
    "cookie"
];
const $351f5d6283f61aff$export$6f34743829a9a6fb = [
    // Express / Connect default session cookie
    ".sid",
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    "sessid",
    // Laravel etc. "remember me" tokens
    "remember",
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    "oidc",
    "pkce",
    "nonce",
    // RFC 6265bis high-security cookie name prefixes
    "__secure-",
    "__host-",
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    "awsalb",
    "awselb",
    "akamai",
    // BaaS / IdP session cookies (names often omit "session")
    "__stripe",
    "cognito",
    "firebase",
    "supabase",
    "sb-",
    // Step-up / MFA cookies
    "mfa",
    "2fa"
];



function $4a3a3e482dd801e0$var$isSensitiveKey(lower, denySnippets) {
    return denySnippets.some((snippet)=>lower.includes(snippet));
}
function $4a3a3e482dd801e0$export$1a2b255c1788eeeb(key, behavior, additionalDenyTerms) {
    if (behavior === false) return true;
    const lowerKey = key.toLowerCase();
    const denySnippets = additionalDenyTerms != null ? [
        ...(0, $351f5d6283f61aff$export$cdee6254fbd57505),
        ...additionalDenyTerms
    ] : (0, $351f5d6283f61aff$export$cdee6254fbd57505);
    if ($4a3a3e482dd801e0$var$isSensitiveKey(lowerKey, denySnippets)) return true;
    if (behavior === true) return false;
    const terms = "deny" in behavior ? behavior.deny : behavior.allow;
    const matchesConfiguredTerm = terms.some((term)=>lowerKey.includes(term.toLowerCase()));
    return "deny" in behavior ? matchesConfiguredTerm : !matchesConfiguredTerm;
}
function $4a3a3e482dd801e0$export$73acb6f35c15da01(data, behavior, additionalDenyTerms) {
    if (behavior === false) return {};
    const result = {};
    for (const key of Object.keys(data))result[key] = $4a3a3e482dd801e0$export$1a2b255c1788eeeb(key, behavior, additionalDenyTerms) ? (0, $351f5d6283f61aff$export$59adc876c1ebd512) : data[key];
    return result;
}


function $ab2ec7ef55de9e0f$export$7e88e8c4177d6404(queryString, behavior) {
    if (!queryString || behavior === false) return void 0;
    return queryString.split("&").map((pair)=>{
        const separatorIndex = pair.indexOf("=");
        const encodedKey = separatorIndex === -1 ? pair : pair.slice(0, separatorIndex);
        const key = new URLSearchParams(`${encodedKey}=`).keys().next().value;
        return key !== void 0 && (0, $4a3a3e482dd801e0$export$1a2b255c1788eeeb)(key, behavior) ? `${encodedKey}=${0, $351f5d6283f61aff$export$59adc876c1ebd512}` : pair;
    }).join("&");
}



function $01cf00339bc114c4$export$55957a65a66aa868(url, behavior) {
    const fragmentStart = url.indexOf("#");
    const queryEnd = fragmentStart === -1 ? url.length : fragmentStart;
    const queryStart = url.indexOf("?");
    if (queryStart === -1 || queryStart > queryEnd) return url;
    const prefix = url.slice(0, queryStart);
    const query = url.slice(queryStart + 1, queryEnd);
    const suffix = url.slice(queryEnd);
    const filtered = (0, $ab2ec7ef55de9e0f$export$7e88e8c4177d6404)(query, behavior);
    return filtered ? `${prefix}?${filtered}${suffix}` : `${prefix}${suffix}`;
}


function $add1a9ee134dfbbc$var$urlQueryParamsBehavior(client) {
    return (client ?? (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)())?.getDataCollectionOptions().urlQueryParams ?? true;
}
function $add1a9ee134dfbbc$export$9dbd5b9f0d1db392(url, client) {
    return url === void 0 ? void 0 : (0, $01cf00339bc114c4$export$55957a65a66aa868)(url, $add1a9ee134dfbbc$var$urlQueryParamsBehavior(client));
}
function $add1a9ee134dfbbc$export$8cbd6331b69d8fe6(query, client) {
    return query ? (0, $ab2ec7ef55de9e0f$export$7e88e8c4177d6404)(query, $add1a9ee134dfbbc$var$urlQueryParamsBehavior(client)) : void 0;
}


const $1dcf8ba856755e63$var$DEFAULT_BASE_URL = "thismessage:/";
function $1dcf8ba856755e63$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $1dcf8ba856755e63$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $1dcf8ba856755e63$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $1dcf8ba856755e63$export$5339fcdc8e2a427c(url) {
    if ($1dcf8ba856755e63$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $1dcf8ba856755e63$export$da21ff0ec5c026bc(query) {
    return query?.replace(/^\?/, "") || void 0;
}
function $1dcf8ba856755e63$export$fe56b54aadafe8d9(fragment) {
    return fragment?.replace(/^#/, "") || void 0;
}
function $1dcf8ba856755e63$export$64d8ecce7e5d84dc(url, base) {
    try {
        return new URL(url, base).hostname || void 0;
    } catch  {
        return void 0;
    }
}
function $1dcf8ba856755e63$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $1dcf8ba856755e63$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $1dcf8ba856755e63$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName, client) {
    const attributes = {
        [(0, $6e2fe664af4a7693$export$cca8dd30f57f805e)]: spanOrigin
    };
    let nameSource = "url";
    if (routeName) {
        attributes[kind === "server" ? (0, $4e79bc9bf7524846$exports.HTTP_ROUTE) : (0, $4e79bc9bf7524846$exports.URL_TEMPLATE)] = routeName;
        nameSource = "route";
    }
    if (request?.method) attributes[0, $4e79bc9bf7524846$exports.HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        attributes[0, $4e79bc9bf7524846$exports.URL_FULL] = (0, $add1a9ee134dfbbc$export$9dbd5b9f0d1db392)($1dcf8ba856755e63$export$e258e13805402ba7(urlObject) ? $1dcf8ba856755e63$export$5339fcdc8e2a427c(urlObject) : urlObject.href, client);
        attributes[0, $4e79bc9bf7524846$exports.URL_QUERY] = (0, $add1a9ee134dfbbc$export$8cbd6331b69d8fe6)($1dcf8ba856755e63$export$da21ff0ec5c026bc(urlObject.search), client);
        attributes[0, $4e79bc9bf7524846$exports.URL_FRAGMENT] = $1dcf8ba856755e63$export$fe56b54aadafe8d9(urlObject.hash);
        if (urlObject.pathname) {
            attributes[0, $4e79bc9bf7524846$exports.URL_PATH] = urlObject.pathname;
            if (urlObject.pathname === "/") nameSource = "route";
        }
        if (!$1dcf8ba856755e63$export$e258e13805402ba7(urlObject)) {
            if (urlObject.port) attributes[0, $4e79bc9bf7524846$exports.URL_PORT] = urlObject.port;
            if (urlObject.protocol) attributes[0, $4e79bc9bf7524846$exports.URL_SCHEME] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? (0, $4e79bc9bf7524846$exports.SERVER_ADDRESS) : (0, $4e79bc9bf7524846$exports.URL_DOMAIN)] = urlObject.hostname;
        }
    }
    if (kind === "server") attributes[0, $4e79bc9bf7524846$exports.SENTRY_SEGMENT_NAME_SOURCE] = nameSource;
    return [
        $1dcf8ba856755e63$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $1dcf8ba856755e63$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $1dcf8ba856755e63$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $1dcf8ba856755e63$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path || ""}`;
}
function $1dcf8ba856755e63$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}


const $b5d72063b53488fc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $d88a8c943753376d$export$56d8a8a25bd48b81 = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1);


function $af60478d30a53662$export$1cfafeee2987818b() {
    try {
        return (0, $d88a8c943753376d$export$56d8a8a25bd48b81).document?.location.href ?? "";
    } catch  {
        return "";
    }
}


const $2733035151347e6c$var$CLIENT_ROUTE_PROVIDERS = /* @__PURE__ */ new WeakMap();
function $2733035151347e6c$export$62397efcb3dc8911(provider, client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)()) {
    if (!client) {
        (0, $b5d72063b53488fc$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("Cannot set a route provider without a client.");
        return;
    }
    if ((0, $b5d72063b53488fc$export$16a28057038b10ef) && $2733035151347e6c$export$a46443494ebb9477(client)) (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("A route provider is already registered for this client and will be replaced. Routes only the previous provider knows about will no longer resolve.");
    $2733035151347e6c$var$CLIENT_ROUTE_PROVIDERS.set(client, provider);
}
function $2733035151347e6c$export$a46443494ebb9477(client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)()) {
    return client && $2733035151347e6c$var$CLIENT_ROUTE_PROVIDERS.get(client);
}
function $2733035151347e6c$export$b7654b4155f1192a(url, client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)()) {
    const provider = $2733035151347e6c$export$a46443494ebb9477(client);
    if (!provider) return void 0;
    const urlObject = typeof url === "string" ? $2733035151347e6c$var$parseLocation(url) : url;
    if (!urlObject) return void 0;
    return (0, $26d85213e847db5d$export$6671884dec007c51)((0, $b5d72063b53488fc$export$16a28057038b10ef) ? "Route provider threw while resolving a route:" : "", ()=>provider.resolveRoute(urlObject) || void 0, ()=>void 0);
}
function $2733035151347e6c$export$bb371194713ec10c(client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)()) {
    const provider = $2733035151347e6c$export$a46443494ebb9477(client);
    return (0, $26d85213e847db5d$export$6671884dec007c51)((0, $b5d72063b53488fc$export$16a28057038b10ef) ? "Route provider threw while resolving a route:" : "", ()=>provider?.resolveCurrentRoute() || void 0, ()=>void 0);
}
function $2733035151347e6c$export$8014330b3583e2ac(resolveRouteFromUrl) {
    return {
        resolveRoute: resolveRouteFromUrl,
        resolveCurrentRoute: ()=>{
            const urlObject = $2733035151347e6c$var$parseLocation((0, $af60478d30a53662$export$1cfafeee2987818b)());
            return urlObject && resolveRouteFromUrl(urlObject);
        }
    };
}
function $2733035151347e6c$export$350de57586f46a2c(maxEntries = 50) {
    const routeNames = new (0, $1faf54aa90579c0e$export$d3735b5b644680e5)(maxEntries);
    return {
        ...$2733035151347e6c$export$8014330b3583e2ac((url)=>routeNames.get(url.pathname)),
        record (pathname, routeName) {
            if (pathname && routeName) routeNames.set(pathname, routeName);
        }
    };
}
function $2733035151347e6c$var$parseLocation(url) {
    return url ? (0, $1dcf8ba856755e63$export$2004d912a9ead694)(url, (0, $af60478d30a53662$export$1cfafeee2987818b)() || void 0) : void 0;
}


function $0727c608597ea33d$export$e8e2d07ba63e2b6c(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === void 0) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === void 0) session.ipAddress = "{{auto}}";
}


function $bcf849c00e94ac24$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name2)=>({
                name: `${source}:@sentry/${name2}`,
                version: (0, $d8189db5678eaa24$export$31499a9cd224b78c)
            }));
        sdk.version = (0, $d8189db5678eaa24$export$31499a9cd224b78c);
    }
}


const $fdd98a74771d35c6$export$9207631ea4ce5c48 = "7";
function $fdd98a74771d35c6$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function $fdd98a74771d35c6$var$_getIngestEndpoint(dsn) {
    return `${$fdd98a74771d35c6$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function $fdd98a74771d35c6$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $fdd98a74771d35c6$export$9207631ea4ce5c48
    };
    if (dsn.publicKey) params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
function $fdd98a74771d35c6$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$fdd98a74771d35c6$var$_getIngestEndpoint(dsn)}?${$fdd98a74771d35c6$var$_encodedAuth(dsn, sdkInfo)}`;
}
function $fdd98a74771d35c6$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $587fc376b57159be$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$fdd98a74771d35c6$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $587fc376b57159be$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose" || key === "onError") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


const $e3d2412e82cb94c3$export$849dbeeeda01ae98 = "production";
const $e3d2412e82cb94c3$export$6829f580e78306fa = "development";










function $d37001b466b61c2b$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $d37001b466b61c2b$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $d37001b466b61c2b$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $d37001b466b61c2b$export$604a45d95a155e2b(envelope, types) {
    return $d37001b466b61c2b$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $d37001b466b61c2b$var$encodeUTF8(input) {
    const carrier = (0, $4d3ec8641bdc53a2$export$c8bfa33e4e8ae492)((0, $ac5f383786409d8e$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $d37001b466b61c2b$var$decodeUTF8(input) {
    const carrier = (0, $4d3ec8641bdc53a2$export$c8bfa33e4e8ae492)((0, $ac5f383786409d8e$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $d37001b466b61c2b$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $d37001b466b61c2b$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $d37001b466b61c2b$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify((0, $fce87edf3ea2bc99$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $d37001b466b61c2b$var$concatBuffers(parts);
}
function $d37001b466b61c2b$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $d37001b466b61c2b$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $d37001b466b61c2b$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($d37001b466b61c2b$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $d37001b466b61c2b$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $d37001b466b61c2b$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $d37001b466b61c2b$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $d37001b466b61c2b$var$_isOverriddenType(type) {
    return type in $d37001b466b61c2b$var$DATA_CATEGORY_OVERRIDES;
}
function $d37001b466b61c2b$export$b11169581eeaf237(type) {
    return $d37001b466b61c2b$var$_isOverriddenType(type) ? $d37001b466b61c2b$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $d37001b466b61c2b$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $d37001b466b61c2b$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date((0, $a53c09ef0441e640$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $587fc376b57159be$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
function $d37001b466b61c2b$export$bfe733a7b260af30(type) {
    return type === "replay_event" ? "replay" : type || "error";
}



function $7ccf7c2faf253f32$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $7ccf7c2faf253f32$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $d37001b466b61c2b$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date((0, $a53c09ef0441e640$export$65b1bada40c91b34)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $587fc376b57159be$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $d37001b466b61c2b$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $7ccf7c2faf253f32$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $d37001b466b61c2b$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $7ccf7c2faf253f32$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $d37001b466b61c2b$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $d37001b466b61c2b$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}


















function $529daa5d2b623c2b$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}







const $f9fbba8b96fe159e$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $f9fbba8b96fe159e$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $9462dad4273cdb86$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $9462dad4273cdb86$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
        (0, $984d7f4f9d559811$export$e73679ffaf56810e)(this, $f9fbba8b96fe159e$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $1c045c464121271a$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $f9fbba8b96fe159e$export$61cc547d99783aa7(span) {
    return !!span && span[$f9fbba8b96fe159e$var$NON_RECORDING_SPAN_FIELD] === true;
}



const $35176bd1eda76558$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $35176bd1eda76558$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $984d7f4f9d559811$export$e73679ffaf56810e)(spanWithMaybeDsc, $35176bd1eda76558$var$FROZEN_DSC_FIELD, dsc);
}
function $35176bd1eda76558$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $e3d2412e82cb94c3$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $587fc376b57159be$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $35176bd1eda76558$export$89ef1736f08c6b2b(client, scope) {
    if ((0, $6a0e69fdf33e8459$export$92547f779c920a71)()) return void 0;
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $35176bd1eda76558$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $35176bd1eda76558$export$a117f995597e25df(span) {
    const client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $1c045c464121271a$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $1c045c464121271a$export$1d09902424677504)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $6e2fe664af4a7693$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $6e2fe664af4a7693$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$35176bd1eda76558$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = (0, $f9fbba8b96fe159e$export$61cc547d99783aa7)(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!(0, $529daa5d2b623c2b$export$1f70765132c3c225)(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = (0, $ede25f0577eb9341$export$c08fbc656a245d03)(rootSpan).scope;
        const scopeDsc = capturedScope && $35176bd1eda76558$export$89ef1736f08c6b2b(client, capturedScope);
        if (scopeDsc) {
            const dsc2 = {
                ...scopeDsc
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $8afb25e073bbebf6$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $35176bd1eda76558$export$366bad00d6815eed(span.spanContext().traceId, client);
    const source = rootSpanAttributes[0, $4e79bc9bf7524846$exports.SENTRY_SEGMENT_NAME_SOURCE];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $529daa5d2b623c2b$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $1c045c464121271a$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $ede25f0577eb9341$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $35176bd1eda76558$export$95cf936fdacaff7b(span) {
    const dsc = $35176bd1eda76558$export$a117f995597e25df(span);
    return (0, $8afb25e073bbebf6$export$56766feef403f365)(dsc);
}




function $68fbe3379b72d8cf$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    $68fbe3379b72d8cf$var$applyDataToEvent(event, data);
    $68fbe3379b72d8cf$var$applyFingerprintToEvent(event, fingerprint);
    $68fbe3379b72d8cf$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $68fbe3379b72d8cf$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function $68fbe3379b72d8cf$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName } = mergeData;
    $68fbe3379b72d8cf$export$b1a120a2871faa46(data, "extra", extra);
    $68fbe3379b72d8cf$export$b1a120a2871faa46(data, "tags", tags);
    $68fbe3379b72d8cf$export$b1a120a2871faa46(data, "attributes", attributes);
    $68fbe3379b72d8cf$export$b1a120a2871faa46(data, "user", user);
    $68fbe3379b72d8cf$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $58b2a0935e7deba4$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
function $68fbe3379b72d8cf$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $58b2a0935e7deba4$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $68fbe3379b72d8cf$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $6a0e69fdf33e8459$export$aa55d5ab8e05984f)().getScopeData();
    isolationScope && $68fbe3379b72d8cf$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $68fbe3379b72d8cf$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $68fbe3379b72d8cf$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $68fbe3379b72d8cf$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function $68fbe3379b72d8cf$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $68fbe3379b72d8cf$export$1329c3b5e978b6e(event, span) {
    event.contexts = {
        trace: (0, $1c045c464121271a$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $35176bd1eda76558$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $1c045c464121271a$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $1c045c464121271a$export$1d09902424677504)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
function $68fbe3379b72d8cf$var$applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    if (!event.fingerprint.length) delete event.fingerprint;
}




const $4e9ee18ecfa52eed$var$SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let $4e9ee18ecfa52eed$var$_sequenceNumber = 0;
let $4e9ee18ecfa52eed$var$_previousTimestampMs;
function $4e9ee18ecfa52eed$export$63ada7b125d23ef9(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1e3);
    if ($4e9ee18ecfa52eed$var$_previousTimestampMs !== void 0 && nowMs !== $4e9ee18ecfa52eed$var$_previousTimestampMs) $4e9ee18ecfa52eed$var$_sequenceNumber = 0;
    const value = $4e9ee18ecfa52eed$var$_sequenceNumber;
    $4e9ee18ecfa52eed$var$_sequenceNumber++;
    $4e9ee18ecfa52eed$var$_previousTimestampMs = nowMs;
    return {
        key: $4e9ee18ecfa52eed$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: "integer"
        }
    };
}





function $27bec9d797facc67$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        void 0,
        void 0
    ];
    return (0, $6a0e69fdf33e8459$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $1c045c464121271a$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $1c045c464121271a$export$46c6fbd1d265ebf0)(span) : (0, $6a0e69fdf33e8459$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $35176bd1eda76558$export$a117f995597e25df)(span) : (0, $35176bd1eda76558$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}


const $a3337edeef614ade$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};





var $ilhFV = parcelRequire("ilhFV");

function $832e22c23ada9808$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $ilhFV.isNodeEnv)() || $832e22c23ada9808$var$isElectronNodeRenderer());
}
function $832e22c23ada9808$var$isElectronNodeRenderer() {
    const process = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).process;
    return process?.type === "renderer";
}


function $36ccdbc0b48407d8$export$efdf3b13edb1118e(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "log",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.log+json"
        },
        {
            version: 2,
            ...(0, $832e22c23ada9808$export$4e09c449d6c407f7)() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $36ccdbc0b48407d8$export$cdcd668e6516443f(logs, metadata, tunnel, dsn, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $587fc376b57159be$export$44d472fbb931a776)(dsn);
    return (0, $d37001b466b61c2b$export$f93f7f385160c44e)(headers, [
        $36ccdbc0b48407d8$export$efdf3b13edb1118e(logs, inferUserData)
    ]);
}


const $8ae1c5cc1f4d57c2$var$MAX_LOG_BUFFER_SIZE = 100;
function $8ae1c5cc1f4d57c2$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
function $8ae1c5cc1f4d57c2$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $8ae1c5cc1f4d57c2$var$_getBufferMap();
    const logBuffer = $8ae1c5cc1f4d57c2$export$5365c9902fb9e770(client);
    if (logBuffer === void 0) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $8ae1c5cc1f4d57c2$var$MAX_LOG_BUFFER_SIZE) {
        $8ae1c5cc1f4d57c2$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
function $8ae1c5cc1f4d57c2$export$3ab3d16b9eebd986(beforeLog, currentScope = (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)(), captureSerializedLog = $8ae1c5cc1f4d57c2$export$743ba6f7ec19225f) {
    const client = currentScope?.getClient() ?? (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("No client available to capture log.");
        return;
    }
    const { release: release, environment: environment, beforeSendLog: beforeSendLog } = client.getOptions();
    const [, traceContext] = (0, $27bec9d797facc67$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes } = (0, $68fbe3379b72d8cf$export$cc422922fcbb91c6)((0, $6a0e69fdf33e8459$export$68f3af03034c9e90)(), currentScope);
    $8ae1c5cc1f4d57c2$var$setLogAttribute(processedLogAttributes, "user.id", id, false);
    $8ae1c5cc1f4d57c2$var$setLogAttribute(processedLogAttributes, "user.email", email, false);
    $8ae1c5cc1f4d57c2$var$setLogAttribute(processedLogAttributes, "user.name", username, false);
    $8ae1c5cc1f4d57c2$var$setLogAttribute(processedLogAttributes, "sentry.release", release);
    $8ae1c5cc1f4d57c2$var$setLogAttribute(processedLogAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $8ae1c5cc1f4d57c2$var$setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
    $8ae1c5cc1f4d57c2$var$setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $8ae1c5cc1f4d57c2$var$setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $8ae1c5cc1f4d57c2$var$setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
    const beforeLogMessage = beforeLog.message;
    if ((0, $1ae1983cb9bdf286$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $1c045c464121271a$export$1be426a8e585c83e)(currentScope);
    $8ae1c5cc1f4d57c2$var$setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? (0, $26d85213e847db5d$export$6671884dec007c51)((0, $7d7ee71e9314e5f0$export$16a28057038b10ef) ? "The `beforeSendLog` callback threw an error, dropping the log:" : "", // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    ()=>(0, $fc0ca994ab4632cd$export$cda52e2a8927a2ca)(()=>beforeSendLog(processedLog)), ()=>(0, $26d85213e847db5d$export$afe9d811094f080b)) : processedLog;
    if (log === (0, $26d85213e847db5d$export$afe9d811094f080b)) {
        client.recordDroppedEvent("callback_error", "log_item", 1);
        return;
    }
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = (0, $81000fbf661a21ed$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $4e9ee18ecfa52eed$export$63ada7b125d23ef9)(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: $8ae1c5cc1f4d57c2$export$b879a166f5ac57c8(String(message)),
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $a3337edeef614ade$export$4fb50c0840d636d1)[level],
        attributes: $8ae1c5cc1f4d57c2$var$sanitizeLogAttributes({
            ...(0, $136e6f9d05dd2c20$export$4954cae66e755861)(scopeAttributes),
            ...(0, $136e6f9d05dd2c20$export$4954cae66e755861)(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        })
    };
    captureSerializedLog(client, serializedLog);
    client.emit("afterCaptureLog", log);
}
function $8ae1c5cc1f4d57c2$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $8ae1c5cc1f4d57c2$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $36ccdbc0b48407d8$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $8ae1c5cc1f4d57c2$var$_getBufferMap().set(client, []);
    client.emit("flushLogs");
    client.sendEnvelope(envelope);
}
function $8ae1c5cc1f4d57c2$export$5365c9902fb9e770(client) {
    return $8ae1c5cc1f4d57c2$var$_getBufferMap().get(client);
}
function $8ae1c5cc1f4d57c2$var$_getBufferMap() {
    return (0, $4d3ec8641bdc53a2$export$7e223ec222791509)("clientToLogBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}
function $8ae1c5cc1f4d57c2$var$sanitizeLogAttributes(attributes) {
    const sanitized = {};
    for (const [key, attr] of Object.entries(attributes)){
        const sanitizedKey = $8ae1c5cc1f4d57c2$export$b879a166f5ac57c8(key);
        if (attr.type === "string") sanitized[sanitizedKey] = {
            ...attr,
            value: $8ae1c5cc1f4d57c2$export$b879a166f5ac57c8(attr.value)
        };
        else sanitized[sanitizedKey] = attr;
    }
    return sanitized;
}
function $8ae1c5cc1f4d57c2$export$b879a166f5ac57c8(str) {
    const strObj = Object(str);
    const isWellFormed = strObj["isWellFormed"];
    const toWellFormed = strObj["toWellFormed"];
    if (typeof isWellFormed === "function" && typeof toWellFormed === "function") return isWellFormed.call(str) ? str : toWellFormed.call(str);
    return str;
}
















function $bbdbf195dfe21a8e$export$58e45eb52ad1077d(items, inferUserData) {
    const inferSetting = inferUserData ? "auto" : "never";
    return [
        {
            type: "trace_metric",
            item_count: items.length,
            content_type: "application/vnd.sentry.items.trace-metric+json"
        },
        {
            version: 2,
            ...(0, $832e22c23ada9808$export$4e09c449d6c407f7)() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
function $bbdbf195dfe21a8e$export$f23eb96e33154901(metrics, metadata, tunnel, dsn, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $587fc376b57159be$export$44d472fbb931a776)(dsn);
    return (0, $d37001b466b61c2b$export$f93f7f385160c44e)(headers, [
        $bbdbf195dfe21a8e$export$58e45eb52ad1077d(metrics, inferUserData)
    ]);
}


const $0defd9ad083f8302$var$MAX_METRIC_BUFFER_SIZE = 1e3;
function $0defd9ad083f8302$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
function $0defd9ad083f8302$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $0defd9ad083f8302$var$_getBufferMap();
    const metricBuffer = $0defd9ad083f8302$export$49385134251b08ff(client);
    if (metricBuffer === void 0) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $0defd9ad083f8302$var$MAX_METRIC_BUFFER_SIZE) {
        $0defd9ad083f8302$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
function $0defd9ad083f8302$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    $0defd9ad083f8302$var$setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
    $0defd9ad083f8302$var$setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
    $0defd9ad083f8302$var$setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
    $0defd9ad083f8302$var$setMetricAttribute(processedMetricAttributes, "sentry.release", release);
    $0defd9ad083f8302$var$setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $0defd9ad083f8302$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
    $0defd9ad083f8302$var$setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId(true);
    $0defd9ad083f8302$var$setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
    if (replayId && replay?.getRecordingMode() === "buffer") $0defd9ad083f8302$var$setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
function $0defd9ad083f8302$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    const [, traceContext] = (0, $27bec9d797facc67$export$fb7d833b3fdedf5f)(client, currentScope);
    const span = (0, $1c045c464121271a$export$1be426a8e585c83e)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : void 0;
    const timestamp = (0, $81000fbf661a21ed$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $4e9ee18ecfa52eed$export$63ada7b125d23ef9)(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? "",
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...(0, $136e6f9d05dd2c20$export$4954cae66e755861)(scopeAttributes),
            ...(0, $136e6f9d05dd2c20$export$4954cae66e755861)(metric.attributes, "skip-undefined"),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
function $0defd9ad083f8302$export$288d896e6652e0c4(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $0defd9ad083f8302$export$84661fd26e6cac96;
    const client = currentScope?.getClient() ?? (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("No client available to capture metric.");
        return;
    }
    const { beforeSendMetric: beforeSendMetric } = client.getOptions();
    const { user: user, attributes: scopeAttributes } = (0, $68fbe3379b72d8cf$export$cc422922fcbb91c6)((0, $6a0e69fdf33e8459$export$68f3af03034c9e90)(), currentScope);
    const enrichedMetric = $0defd9ad083f8302$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit("processMetric", enrichedMetric);
    const processedMetric = beforeSendMetric ? (0, $26d85213e847db5d$export$6671884dec007c51)((0, $7d7ee71e9314e5f0$export$16a28057038b10ef) ? "The `beforeSendMetric` callback threw an error, dropping the metric:" : "", ()=>beforeSendMetric(enrichedMetric), ()=>(0, $26d85213e847db5d$export$afe9d811094f080b)) : enrichedMetric;
    if (processedMetric === (0, $26d85213e847db5d$export$afe9d811094f080b)) {
        client.recordDroppedEvent("callback_error", "metric", 1);
        return;
    }
    if (!processedMetric) {
        client.recordDroppedEvent("before_send", "metric", 1);
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log("`beforeSendMetric` returned `null`, will not send metric.");
        return;
    }
    const serializedMetric = $0defd9ad083f8302$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log("[Metric]", serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit("afterCaptureMetric", processedMetric);
}
function $0defd9ad083f8302$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $0defd9ad083f8302$export$49385134251b08ff(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $bbdbf195dfe21a8e$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), client.getDataCollectionOptions().userInfo);
    $0defd9ad083f8302$var$_getBufferMap().set(client, []);
    client.emit("flushMetrics");
    client.sendEnvelope(envelope);
}
function $0defd9ad083f8302$export$49385134251b08ff(client) {
    return $0defd9ad083f8302$var$_getBufferMap().get(client);
}
function $0defd9ad083f8302$var$_getBufferMap() {
    return (0, $4d3ec8641bdc53a2$export$7e223ec222791509)("clientToMetricBufferMap", ()=>/* @__PURE__ */ new WeakMap());
}








function $e40f8aba80c53550$export$d2260045801a90f0(callback) {
    (0, $984d7f4f9d559811$export$e73679ffaf56810e)(callback, "_static", true);
    return callback;
}
function $e40f8aba80c53550$export$d3f49b33a1f44720(callback) {
    return callback;
}
function $e40f8aba80c53550$export$b34b07e89ddc4dd2(callback) {
    return !!callback && typeof callback === "function" && "_static" in callback && !!callback._static;
}
let $e40f8aba80c53550$var$hasShownSpanDropWarning = false;
function $e40f8aba80c53550$export$d38dd0f511e8d9ba(span, beforeSendSpan) {
    const modifiedSpan = (0, $26d85213e847db5d$export$6671884dec007c51)((0, $7d7ee71e9314e5f0$export$16a28057038b10ef) ? "The `beforeSendSpan` callback threw an error, sending the span unmodified:" : "", ()=>beforeSendSpan(span), ()=>span);
    if (modifiedSpan) return modifiedSpan;
    if (!$e40f8aba80c53550$var$hasShownSpanDropWarning) {
        (0, $fc0ca994ab4632cd$export$cda52e2a8927a2ca)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $e40f8aba80c53550$var$hasShownSpanDropWarning = true;
    }
    return span;
}






function $90c67749de5d3e38$export$50ed9406a6387d5(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = (0, $d37001b466b61c2b$export$d369f3b2758f6743)(options._metadata);
    const headers = {
        sent_at: new Date((0, $a53c09ef0441e640$export$65b1bada40c91b34)()).toISOString(),
        ...$90c67749de5d3e38$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn && {
            dsn: (0, $587fc376b57159be$export$44d472fbb931a776)(dsn)
        }
    };
    return (0, $d37001b466b61c2b$export$f93f7f385160c44e)(headers, [
        $90c67749de5d3e38$export$5374f90578c435fe(serializedSpans, client)
    ]);
}
function $90c67749de5d3e38$export$5374f90578c435fe(serializedSpans, client) {
    const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
    return [
        {
            type: "span",
            item_count: serializedSpans.length,
            content_type: "application/vnd.sentry.items.span.v2+json"
        },
        {
            version: 2,
            ingest_settings: (0, $832e22c23ada9808$export$4e09c449d6c407f7)() ? {
                infer_ip: inferSetting,
                infer_user_agent: inferSetting
            } : void 0,
            items: serializedSpans
        }
    ];
}
function $90c67749de5d3e38$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}


function $da0a1178a3977355$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}



function $a87042d090900a38$export$f6f6d4b2a7942521(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || "",
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp,
        status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return (0, $1c045c464121271a$export$5402aa553bcf35f3)(streamedSpan);
}


function $5302ff4f40eb3b2b$export$9aeb9a2b899f8587(event, client) {
    if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || (0, $da0a1178a3977355$export$6ea47215d699c04a)(client)) return void 0;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith("gen_ai.")) genAiSpans.push((0, $a87042d090900a38$export$f6f6d4b2a7942521)(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return void 0;
    event.spans = remainingSpans;
    return (0, $90c67749de5d3e38$export$5374f90578c435fe)(genAiSpans, client);
}






const $c46e828452abe2e6$var$STATE_PENDING = 0;
const $c46e828452abe2e6$var$STATE_RESOLVED = 1;
const $c46e828452abe2e6$var$STATE_REJECTED = 2;
function $c46e828452abe2e6$export$1fda8aa4d135f8aa(value) {
    return new $c46e828452abe2e6$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
function $c46e828452abe2e6$export$78e43115b553f358(reason) {
    return new $c46e828452abe2e6$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
class $c46e828452abe2e6$export$6f292d4960313241 {
    constructor(executor){
        this._state = $c46e828452abe2e6$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $c46e828452abe2e6$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $c46e828452abe2e6$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $c46e828452abe2e6$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $c46e828452abe2e6$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $c46e828452abe2e6$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $c46e828452abe2e6$var$STATE_PENDING) return;
            if ((0, $1ae1983cb9bdf286$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($c46e828452abe2e6$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($c46e828452abe2e6$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


function $8070a4bf8812bc92$export$630056cb83d87863(timer) {
    if (typeof timer === "object" && typeof timer.unref === "function") timer.unref();
    return timer;
}


const $0abfd478ccd42977$export$c8667f1887a128dc = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function $0abfd478ccd42977$export$85a4f67f852183e6(limit = 100) {
    const buffer = /* @__PURE__ */ new Set();
    function isReady() {
        return buffer.size < limit;
    }
    function remove(task) {
        buffer.delete(task);
    }
    function add(taskProducer) {
        if (!isReady()) return (0, $c46e828452abe2e6$export$78e43115b553f358)($0abfd478ccd42977$export$c8667f1887a128dc);
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    function drain(timeout) {
        if (!buffer.size) return (0, $c46e828452abe2e6$export$1fda8aa4d135f8aa)(true);
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>(0, $8070a4bf8812bc92$export$630056cb83d87863)(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}



const $44c280f95b23ff10$export$b09ce39faaeb1e7c = 60000;
function $44c280f95b23ff10$export$615352e17ed7741(header, now = (0, $a53c09ef0441e640$export$65b1bada40c91b34)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1e3;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $44c280f95b23ff10$export$b09ce39faaeb1e7c;
}
function $44c280f95b23ff10$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
function $44c280f95b23ff10$export$6c91fec22056810a(limits, dataCategory, now = (0, $a53c09ef0441e640$export$65b1bada40c91b34)()) {
    return $44c280f95b23ff10$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
function $44c280f95b23ff10$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $a53c09ef0441e640$export$65b1bada40c91b34)()) {
    const updatedRateLimits = {
        ...limits
    };
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $44c280f95b23ff10$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $ee849985480e73fd$export$e515cf6dfd2f98b8 = 64;
function $ee849985480e73fd$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $0abfd478ccd42977$export$85a4f67f852183e6)(options.bufferSize || $ee849985480e73fd$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        (0, $d37001b466b61c2b$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $d37001b466b61c2b$export$b11169581eeaf237)(type);
            if ((0, $44c280f95b23ff10$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, $d37001b466b61c2b$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        const recordEnvelopeLoss = (reason)=>{
            if ((0, $d37001b466b61c2b$export$604a45d95a155e2b)(filteredEnvelope, [
                "client_report"
            ])) {
                (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            (0, $d37001b466b61c2b$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $d37001b466b61c2b$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $d37001b466b61c2b$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                if (response.statusCode === 413) {
                    (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error("Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.");
                    recordEnvelopeLoss("send_error");
                    return response;
                }
                if ((0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $44c280f95b23ff10$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $0abfd478ccd42977$export$c8667f1887a128dc)) {
                (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}




function $b5c5b626d654c56c$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $81000fbf661a21ed$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $d37001b466b61c2b$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
















function $d909fff324ab2e6a$export$bf2a096c3e883e79(processors, event, hint, index = 0, onDrop) {
    try {
        const result = $d909fff324ab2e6a$var$_notifyEventProcessors(event, hint, processors, index, onDrop);
        return (0, $1ae1983cb9bdf286$export$f5b060c2914b97c8)(result) ? result : (0, $c46e828452abe2e6$export$1fda8aa4d135f8aa)(result);
    } catch (error) {
        return (0, $c46e828452abe2e6$export$78e43115b553f358)(error);
    }
}
function $d909fff324ab2e6a$var$_notifyEventProcessors(event, hint, processors, index, onDrop) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const processorName = `Event processor "${processor.id || "?"}"`;
    let callbackError = false;
    const result = (0, $26d85213e847db5d$export$6671884dec007c51)((0, $7d7ee71e9314e5f0$export$16a28057038b10ef) ? `${processorName} threw an error, dropping event:` : "", ()=>processor({
            ...event
        }, hint), ()=>{
        callbackError = true;
        return null;
    });
    (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && result === null && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`${processorName} dropped event`);
    if ((0, $1ae1983cb9bdf286$export$f5b060c2914b97c8)(result)) return result.then((final)=>{
        if (!final) {
            onDrop?.(callbackError ? "callback_error" : "event_processor");
            return null;
        }
        return $d909fff324ab2e6a$var$_notifyEventProcessors(final, hint, processors, index + 1, onDrop);
    });
    if (!result) {
        onDrop?.(callbackError ? "callback_error" : "event_processor");
        return null;
    }
    return $d909fff324ab2e6a$var$_notifyEventProcessors(result, hint, processors, index + 1, onDrop);
}





let $920d71964db53bf8$var$parsedStackResults;
let $920d71964db53bf8$var$lastSentryKeysCount;
let $920d71964db53bf8$var$lastNativeKeysCount;
let $920d71964db53bf8$var$cachedFilenameDebugIds;
function $920d71964db53bf8$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1)._sentryDebugIds;
    const nativeDebugIdMap = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    if ($920d71964db53bf8$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $920d71964db53bf8$var$lastSentryKeysCount && nativeDebugIdKeys.length === $920d71964db53bf8$var$lastNativeKeysCount) return $920d71964db53bf8$var$cachedFilenameDebugIds;
    $920d71964db53bf8$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $920d71964db53bf8$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    $920d71964db53bf8$var$cachedFilenameDebugIds = {};
    if (!$920d71964db53bf8$var$parsedStackResults) $920d71964db53bf8$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $920d71964db53bf8$var$parsedStackResults?.[key];
            if (result && $920d71964db53bf8$var$cachedFilenameDebugIds && debugId) {
                $920d71964db53bf8$var$cachedFilenameDebugIds[result[0]] = debugId;
                if ($920d71964db53bf8$var$parsedStackResults) $920d71964db53bf8$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $920d71964db53bf8$var$cachedFilenameDebugIds && $920d71964db53bf8$var$parsedStackResults) {
                        $920d71964db53bf8$var$cachedFilenameDebugIds[filename] = debugId;
                        $920d71964db53bf8$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $920d71964db53bf8$var$cachedFilenameDebugIds;
}
function $920d71964db53bf8$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $920d71964db53bf8$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $3a6ba34e83b7a312$export$60c0d6c8e038267a)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: "sourcemap",
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}






const $f394ed113bf895cc$var$escapedSpanTraceContexts = /* @__PURE__ */ new WeakMap();
function $f394ed113bf895cc$var$toWeakMapKey(error) {
    return (0, $1ae1983cb9bdf286$export$c3825b437cbdea5c)(error) ? void 0 : error;
}
function $f394ed113bf895cc$export$2924f5e84d26b5fb(error, span) {
    const key = $f394ed113bf895cc$var$toWeakMapKey(error);
    if (!key || !(0, $1c045c464121271a$export$5caecac1caaf3a71)(span) || $f394ed113bf895cc$var$escapedSpanTraceContexts.has(key)) return;
    $f394ed113bf895cc$var$escapedSpanTraceContexts.set(key, (0, $1c045c464121271a$export$46c6fbd1d265ebf0)(span));
}
function $f394ed113bf895cc$export$325fe410237288d9(event, hint, scope) {
    const key = $f394ed113bf895cc$var$toWeakMapKey(hint.originalException);
    const traceContext = key && $f394ed113bf895cc$var$escapedSpanTraceContexts.get(key);
    if (!traceContext) return;
    const eventTraceContext = event.contexts?.trace;
    const eventTraceId = eventTraceContext?.trace_id ?? (scope && (0, $6a0e69fdf33e8459$export$1e83db7ee4876dc4)(scope).trace_id);
    if (eventTraceId !== traceContext.trace_id) return;
    event.contexts = {
        ...event.contexts,
        trace: {
            ...eventTraceContext,
            ...traceContext
        }
    };
}









function $00d22111e1af0b33$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1e3 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $2a3bde5300b2c383$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $81000fbf661a21ed$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $00d22111e1af0b33$export$d7e04067a6fbc882(prepared, options);
    $00d22111e1af0b33$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    if (event.type === void 0) $00d22111e1af0b33$export$63042efc86f043e7(prepared, options.stackParser);
    const finalScope = $00d22111e1af0b33$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $2a3bde5300b2c383$export$b84d26f4cd61a104)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    const data = (0, $68fbe3379b72d8cf$export$cc422922fcbb91c6)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $68fbe3379b72d8cf$export$43988bc651a80216)(prepared, data);
    const span = (0, $1c045c464121271a$export$1be426a8e585c83e)(finalScope);
    if (span) (0, $68fbe3379b72d8cf$export$1329c3b5e978b6e)(prepared, span);
    (0, $f394ed113bf895cc$export$325fe410237288d9)(prepared, hint, finalScope);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? (0, $c46e828452abe2e6$export$1fda8aa4d135f8aa)(prepared) : (0, $d909fff324ab2e6a$export$bf2a096c3e883e79)(eventProcessors, prepared, hint, 0, (reason)=>{
        if (!client) return;
        client.recordDroppedEvent(reason, (0, $d37001b466b61c2b$export$bfe733a7b260af30)(event.type));
        if (event.type === "transaction") client.recordDroppedEvent(reason, "span", 1 + (event.spans || []).length);
    });
    return result.then((evt)=>{
        if (!evt) return null;
        $00d22111e1af0b33$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $00d22111e1af0b33$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
function $00d22111e1af0b33$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    event.environment = event.environment || environment || (0, $e3d2412e82cb94c3$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, $2daf90cbbc571ec6$export$6a506b36fdea397d)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) exception.value = (0, $2daf90cbbc571ec6$export$6a506b36fdea397d)(exception.value, maxValueLength);
    });
}
function $00d22111e1af0b33$export$63042efc86f043e7(event, stackParser) {
    const filenameDebugIdMap = (0, $920d71964db53bf8$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
function $00d22111e1af0b33$export$1be657ba8ef44ff0(event) {
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
function $00d22111e1af0b33$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
function $00d22111e1af0b33$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $fce87edf3ea2bc99$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $fce87edf3ea2bc99$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $fce87edf3ea2bc99$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $fce87edf3ea2bc99$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $fce87edf3ea2bc99$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $fce87edf3ea2bc99$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $fce87edf3ea2bc99$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $00d22111e1af0b33$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $949194bd893febb8$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
function $00d22111e1af0b33$export$76b5f966996d1653(hint) {
    if (!hint) return void 0;
    if ($00d22111e1af0b33$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($00d22111e1af0b33$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $00d22111e1af0b33$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $949194bd893febb8$export$775b6bb06e53a214) || typeof hint === "function";
}
const $00d22111e1af0b33$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $00d22111e1af0b33$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$00d22111e1af0b33$var$captureContextKeys.includes(key));
}








function $866ee124b997f5ad$var$logIgnoredSpan(droppedSpan) {
    (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $866ee124b997f5ad$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($866ee124b997f5ad$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $2daf90cbbc571ec6$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && $866ee124b997f5ad$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $2daf90cbbc571ec6$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $2daf90cbbc571ec6$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$866ee124b997f5ad$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && $866ee124b997f5ad$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $866ee124b997f5ad$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $2daf90cbbc571ec6$export$cdded5b28a5f8c6d)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $866ee124b997f5ad$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $866ee124b997f5ad$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}




function $e32c957a748527f5$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status ?? "ok",
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[0, $4e79bc9bf7524846$exports.SENTRY_PROFILE_ID],
        exclusive_time: data?.[0, $4e79bc9bf7524846$exports.SENTRY_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
function $e32c957a748527f5$export$f2d8fce5ae150e92(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $4e79bc9bf7524846$exports.SENTRY_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $4e79bc9bf7524846$exports.SENTRY_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}



function $67d227e87266891e$export$e9591149a0c8acb5(options) {
    if (options.traceLifecycle !== "stream" || // oxlint-disable-next-line typescript/no-deprecated
    !(options.beforeSendTransaction || options.ignoreTransactions?.length)) return;
    (0, $fc0ca994ab4632cd$export$cda52e2a8927a2ca)(()=>{
        console.warn("[Sentry] `beforeSendTransaction` and `ignoreTransactions` are ignored with `traceLifecycle: 'stream'` (enabled by default). Use `beforeSendSpan` and `ignoreSpans` instead, or set `traceLifecycle: 'static'`.");
    });
}


const $79decb00619c1a03$var$DEFAULTS = {
    userInfo: true,
    cookies: true,
    httpHeaders: {
        request: true,
        response: true
    },
    httpBodies: [
        "incomingRequest",
        "outgoingRequest",
        "incomingResponse",
        "outgoingResponse"
    ],
    urlQueryParams: true,
    graphQL: {
        document: true,
        variables: true
    },
    genAI: {
        inputs: true,
        outputs: true
    },
    databaseQueryData: true,
    queues: true,
    stackFrameVariables: true,
    frameContextLines: 5
};
function $79decb00619c1a03$var$isCollectBehavior(value) {
    return typeof value === "boolean" || "allow" in value || "deny" in value;
}
function $79decb00619c1a03$var$resolveHttpHeaders(httpHeaders) {
    if (httpHeaders === void 0) return {
        ...$79decb00619c1a03$var$DEFAULTS.httpHeaders
    };
    if ($79decb00619c1a03$var$isCollectBehavior(httpHeaders)) return {
        request: httpHeaders,
        response: httpHeaders
    };
    return {
        request: httpHeaders.request ?? $79decb00619c1a03$var$DEFAULTS.httpHeaders.request,
        response: httpHeaders.response ?? $79decb00619c1a03$var$DEFAULTS.httpHeaders.response
    };
}
function $79decb00619c1a03$export$e0e409941f20a4c(options) {
    const dc = options.dataCollection ?? {};
    return {
        userInfo: dc.userInfo ?? $79decb00619c1a03$var$DEFAULTS.userInfo,
        cookies: dc.cookies ?? $79decb00619c1a03$var$DEFAULTS.cookies,
        httpHeaders: $79decb00619c1a03$var$resolveHttpHeaders(dc.httpHeaders),
        httpBodies: dc.httpBodies ?? $79decb00619c1a03$var$DEFAULTS.httpBodies,
        urlQueryParams: dc.urlQueryParams ?? $79decb00619c1a03$var$DEFAULTS.urlQueryParams,
        graphQL: {
            document: dc.graphQL?.document ?? $79decb00619c1a03$var$DEFAULTS.graphQL.document,
            variables: dc.graphQL?.variables ?? $79decb00619c1a03$var$DEFAULTS.graphQL.variables
        },
        genAI: {
            inputs: dc.genAI?.inputs ?? $79decb00619c1a03$var$DEFAULTS.genAI.inputs,
            outputs: dc.genAI?.outputs ?? $79decb00619c1a03$var$DEFAULTS.genAI.outputs
        },
        databaseQueryData: dc.databaseQueryData ?? $79decb00619c1a03$var$DEFAULTS.databaseQueryData,
        queues: dc.queues ?? $79decb00619c1a03$var$DEFAULTS.queues,
        stackFrameVariables: dc.stackFrameVariables ?? $79decb00619c1a03$var$DEFAULTS.stackFrameVariables,
        frameContextLines: dc.frameContextLines ?? $79decb00619c1a03$var$DEFAULTS.frameContextLines
    };
}


const $fd9b989242abbc71$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $fd9b989242abbc71$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $fd9b989242abbc71$var$INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const $fd9b989242abbc71$var$DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const $fd9b989242abbc71$var$DEFAULT_FLUSH_INTERVAL = 5e3;
function $fd9b989242abbc71$var$_makeInternalError(message) {
    return {
        message: message,
        [$fd9b989242abbc71$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $fd9b989242abbc71$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$fd9b989242abbc71$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $fd9b989242abbc71$var$_isInternalError(error) {
    return (0, $1ae1983cb9bdf286$export$c10d0b04eaa80a43)(error) && $fd9b989242abbc71$var$INTERNAL_ERROR_SYMBOL in error;
}
function $fd9b989242abbc71$var$_isDoNotSendEventError(error) {
    return (0, $1ae1983cb9bdf286$export$c10d0b04eaa80a43)(error) && $fd9b989242abbc71$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
function $fd9b989242abbc71$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        if (weight >= 8e5) flushFn(client);
        else if (!isTimerActive) {
            const flushInterval = client.getOptions()._flushInterval ?? $fd9b989242abbc71$var$DEFAULT_FLUSH_INTERVAL;
            if (flushInterval > 0) {
                isTimerActive = true;
                flushTimeout = (0, $8070a4bf8812bc92$export$630056cb83d87863)(setTimeout(()=>{
                    flushFn(client);
                }, flushInterval));
            }
        }
    });
    client.on("flush", ()=>{
        flushFn(client);
    });
}
class $fd9b989242abbc71$export$1f2bb630327ac4b6 {
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = {
            attachStacktrace: true,
            ...options,
            traceLifecycle: options.traceLifecycle === "static" ? "static" : "stream"
        };
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = (0, $0abfd478ccd42977$export$85a4f67f852183e6)(options.transportOptions?.bufferSize ?? (0, $ee849985480e73fd$export$e515cf6dfd2f98b8));
        this._dataCollection = (0, $79decb00619c1a03$export$e0e409941f20a4c)(options);
        this._unhandledSessionStatus = "crashed";
        if (options.dsn) this._dsn = (0, $587fc376b57159be$export$128827c3562ec0cb)(options.dsn);
        else (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("No DSN provided, client will not send events.");
        const { beforeSendSpan: beforeSendSpan, traceLifecycle: traceLifecycle } = this._options;
        if ((0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && beforeSendSpan && (0, $e40f8aba80c53550$export$b34b07e89ddc4dd2)(beforeSendSpan) !== (traceLifecycle === "static")) (0, $fc0ca994ab4632cd$export$cda52e2a8927a2ca)(()=>{
            console.warn(`Ignoring \`beforeSendSpan\`: ${traceLifecycle === "static" ? "wrap it with" : "remove"} \`Sentry.withStaticSpan\` to use it with \`traceLifecycle: "${traceLifecycle}"\`.`);
        });
        if (this._dsn) {
            const url = (0, $fdd98a74771d35c6$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : void 0);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        $fd9b989242abbc71$var$setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", $fd9b989242abbc71$var$estimateLogSizeInBytes, (0, $8ae1c5cc1f4d57c2$export$f8ed83d3b6a0b504));
        $fd9b989242abbc71$var$setupWeightBasedFlushing(this, "afterCaptureMetric", "flushMetrics", $fd9b989242abbc71$var$estimateMetricSizeInBytes, (0, $0defd9ad083f8302$export$91c9ef254b7d0f67));
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $2a3bde5300b2c383$export$19f53698e68b2496)();
        if ((0, $2a3bde5300b2c383$export$6de4ffac6a2f1098)(exception)) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log($fd9b989242abbc71$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $2a3bde5300b2c383$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $1ae1983cb9bdf286$export$dbcbffa59149b824)(message) ? message : String(message);
        const isMessage = (0, $1ae1983cb9bdf286$export$c3825b437cbdea5c)(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? "unknown" : "error");
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $2a3bde5300b2c383$export$19f53698e68b2496)();
        if (hint?.originalException && (0, $2a3bde5300b2c383$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log($fd9b989242abbc71$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = (0, $d37001b466b61c2b$export$bfe733a7b260af30)(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        (0, $08100e97513aa8d3$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the resolved data collection configuration.
   */ getDataCollectionOptions() {
        return this._dataCollection;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        this.emit("flush");
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit("close");
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) {
            this._setupIntegrations();
            (0, $67d227e87266891e$export$e9591149a0c8acb5)(this._options);
        }
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the names of all installed integrations.
   */ getIntegrationNames() {
        return Object.keys(this._integrations);
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        if (!isAlreadyInstalled && integration.beforeSetup) integration.beforeSetup(this);
        (0, $44faf1ffd3373da7$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        if (!isAlreadyInstalled) (0, $44faf1ffd3373da7$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        const genAiSpanItem = (0, $5302ff4f40eb3b2b$export$9aeb9a2b899f8587)(event, this);
        let env = (0, $7ccf7c2faf253f32$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $d37001b466b61c2b$export$d650323442802f6f)(env, (0, $d37001b466b61c2b$export$d8fc80952cc31fa4)(attachment));
        if (genAiSpanItem) env = (0, $d37001b466b61c2b$export$d650323442802f6f)(env, genAiSpanItem);
        this.sendEnvelope(env).then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $e3d2412e82cb94c3$export$849dbeeeda01ae98) } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn($fd9b989242abbc71$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn($fd9b989242abbc71$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = (0, $7ccf7c2faf253f32$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            const key = `${reason}:${category}`;
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) try {
            const result = await this._transport.send(envelope);
            this.emit("afterEnvelope", envelope);
            return result;
        } catch (reason) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error("Error while sending envelope:", reason);
            return {};
        }
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).error("Transport disabled");
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {}
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {}
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $44faf1ffd3373da7$export$51abed9797baa598)(this, integrations);
        (0, $44faf1ffd3373da7$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let unhandled = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            unhandled = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                unhandled = true;
                break;
            }
        }
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && unhandled;
        if (shouldUpdateAndSend) {
            (0, $08100e97513aa8d3$export$531818e825e774db)(session, {
                ...unhandled && {
                    status: this._unhandledSessionStatus
                },
                errors: session.errors || Number(errored || unhandled)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== void 0;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = this.getIntegrationNames();
        if (!hint.integrations && integrations.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $00d22111e1af0b33$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...(0, $6a0e69fdf33e8459$export$1e83db7ee4876dc4)(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $35176bd1eda76558$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)(), isolationScope = (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)()) {
        if ((0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && $fd9b989242abbc71$var$isErrorEvent(event)) (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`Captured error event \`${(0, $8d5e751708f95974$export$d55a97c329cacfcc)(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) {
                if ($fd9b989242abbc71$var$_isDoNotSendEventError(reason)) (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(reason.message);
                else if ($fd9b989242abbc71$var$_isInternalError(reason)) (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(reason.message);
                else (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(reason);
            }
            return void 0;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $fd9b989242abbc71$var$isTransactionEvent(event);
        const isError = $fd9b989242abbc71$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        let beforeSendDropReason = "before_send";
        const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : (0, $a5f687bfe070f998$export$a5bd2d81656d9546)(sampleRate);
        const dataCategory = (0, $d37001b466b61c2b$export$bfe733a7b260af30)(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) throw $fd9b989242abbc71$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $fd9b989242abbc71$var$processBeforeSend(this, options, prepared, hint, ()=>{
                beforeSendDropReason = "callback_error";
            });
            return $fd9b989242abbc71$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent(beforeSendDropReason, dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    this.recordDroppedEvent(beforeSendDropReason, "span", 1 + spans.length);
                }
                const dropMessage = beforeSendDropReason === "callback_error" ? "threw an error" : "returned `null`";
                throw $fd9b989242abbc71$var$_makeDoNotSendEventError(`${beforeSendLabel} ${dropMessage}, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isError && typeof parsedSampleRate === "number" && (0, $a53c09ef0441e640$export$9869d72de32a3917)() > parsedSampleRate) {
                this.recordDroppedEvent("sample_rate", "error");
                throw $fd9b989242abbc71$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`);
            }
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($fd9b989242abbc71$var$_isDoNotSendEventError(reason) || $fd9b989242abbc71$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: "internal"
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $fd9b989242abbc71$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === (0, $0abfd478ccd42977$export$c8667f1887a128dc)) this.recordDroppedEvent("queue_overflow", dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log("Sending outcomes:", outcomes);
        const envelope = (0, $b5c5b626d654c56c$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $587fc376b57159be$export$44d472fbb931a776)(this._dsn));
        this.sendEnvelope(envelope);
    }
}
function $fd9b989242abbc71$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $1ae1983cb9bdf286$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $1ae1983cb9bdf286$export$53b83ca8eaab0383)(event) && event !== null) throw $fd9b989242abbc71$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $fd9b989242abbc71$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $1ae1983cb9bdf286$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $fd9b989242abbc71$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
function $fd9b989242abbc71$var$processBeforeSend(client, options, event, hint, onCallbackError) {
    const { beforeSend: beforeSend, ignoreSpans: ignoreSpans, beforeSendTransaction: // oxlint-disable-next-line typescript/no-deprecated
    beforeSendTransaction } = options;
    const beforeSendSpan = (0, $e40f8aba80c53550$export$b34b07e89ddc4dd2)(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($fd9b989242abbc71$var$isErrorEvent(processedEvent) && beforeSend) {
        const errorEvent = processedEvent;
        return (0, $26d85213e847db5d$export$6671884dec007c51)((0, $7d7ee71e9314e5f0$export$16a28057038b10ef) ? "The `beforeSend` callback threw an error, dropping the event:" : "", ()=>beforeSend(errorEvent, hint), ()=>{
            onCallbackError();
            return null;
        });
    }
    if ($fd9b989242abbc71$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan || ignoreSpans) {
            const rootSpanJson = (0, $e32c957a748527f5$export$d9c6b2464b0a687e)(processedEvent);
            if (ignoreSpans?.length && (0, $866ee124b997f5ad$export$5d569ac97c389400)({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) return null;
            if (beforeSendSpan) {
                const processedRootSpanJson = (0, $e40f8aba80c53550$export$d38dd0f511e8d9ba)(rootSpanJson, beforeSendSpan);
                processedEvent = (0, $58b2a0935e7deba4$export$4950aa0f605343fb)(event, (0, $e32c957a748527f5$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    if (ignoreSpans?.length && (0, $866ee124b997f5ad$export$5d569ac97c389400)({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        (0, $866ee124b997f5ad$export$ddf57376e818b444)(initialSpans, span);
                        continue;
                    }
                    if (beforeSendSpan) processedSpans.push((0, $e40f8aba80c53550$export$d38dd0f511e8d9ba)(span, beforeSendSpan));
                    else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent("before_send", "span", droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return (0, $26d85213e847db5d$export$6671884dec007c51)((0, $7d7ee71e9314e5f0$export$16a28057038b10ef) ? "The `beforeSendTransaction` callback threw an error, dropping the event:" : "", ()=>beforeSendTransaction(processedEvent, hint), ()=>{
                onCallbackError();
                return null;
            });
        }
    }
    return processedEvent;
}
function $fd9b989242abbc71$var$isErrorEvent(event) {
    return event.type === void 0;
}
function $fd9b989242abbc71$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
function $fd9b989242abbc71$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    if (metric.name) weight += metric.name.length * 2;
    weight += 8;
    return weight + $fd9b989242abbc71$var$estimateAttributesSizeInBytes(metric.attributes);
}
function $fd9b989242abbc71$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    if (log.message) weight += log.message.length * 2;
    return weight + $fd9b989242abbc71$var$estimateAttributesSizeInBytes(log.attributes);
}
function $fd9b989242abbc71$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $fd9b989242abbc71$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $1ae1983cb9bdf286$export$c3825b437cbdea5c)(value)) weight += $fd9b989242abbc71$var$estimatePrimitiveSizeInBytes(value);
        else weight += 100;
    });
    return weight;
}
function $fd9b989242abbc71$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "number") return 8;
    else if (typeof value === "boolean") return 4;
    return 0;
}


var $g64OG = parcelRequire("g64OG");




function $6243a1d3d188c860$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function $6243a1d3d188c860$var$hasSentryFetchUrlHost(error) {
    return (0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3)(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function $6243a1d3d188c860$export$35a730c8874c1024(error) {
    if ($6243a1d3d188c860$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
function $6243a1d3d188c860$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $6243a1d3d188c860$export$35a730c8874c1024(error)
    };
    const frames = $6243a1d3d188c860$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $6243a1d3d188c860$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if ((0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3)(value)) return value;
    }
    return void 0;
}
function $6243a1d3d188c860$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    const keys = (0, $984d7f4f9d559811$export$b0244d5063c0b61b)(exception);
    if ((0, $1ae1983cb9bdf286$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $6243a1d3d188c860$var$getObjectClassName(exception);
    return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function $6243a1d3d188c860$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $6243a1d3d188c860$var$getException(client, mechanism, exception, hint) {
    if ((0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3)(exception)) return [
        exception,
        void 0
    ];
    mechanism.synthetic = true;
    if ((0, $1ae1983cb9bdf286$export$53b83ca8eaab0383)(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ["__serialized__"]: (0, $fce87edf3ea2bc99$export$23fbbb20bed71033)(exception, normalizeDepth)
        };
        const errorFromProp = $6243a1d3d188c860$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $6243a1d3d188c860$var$getMessageForObject(exception);
        const ex2 = hint?.syntheticException || new Error(message);
        ex2.message = message;
        return [
            ex2,
            extras
        ];
    }
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        void 0
    ];
}
function $6243a1d3d188c860$export$9dd56ed1ef0c3420(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    const [ex, extras] = $6243a1d3d188c860$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $6243a1d3d188c860$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $2a3bde5300b2c383$export$f26508487bf83ee7)(event, void 0, void 0);
    (0, $2a3bde5300b2c383$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
function $6243a1d3d188c860$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $6243a1d3d188c860$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, $2a3bde5300b2c383$export$c69a9a0313b03bb1)(event, {
                synthetic: true
            });
        }
    }
    if ((0, $1ae1983cb9bdf286$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}


function $0e74257171b8d252$export$a6c2d27607295951(stackParser, ex) {
    const frames = $0e74257171b8d252$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $0e74257171b8d252$export$2e9ae379995d99e3(ex),
        value: $0e74257171b8d252$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === void 0 && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $0e74257171b8d252$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const errorFromProp = $0e74257171b8d252$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $fce87edf3ea2bc99$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $0e74257171b8d252$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const exceptionValue = {
        type: (0, $1ae1983cb9bdf286$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
        value: $0e74257171b8d252$var$getNonErrorObjectExceptionValue(exception, {
            isUnhandledRejection: isUnhandledRejection
        })
    };
    const event = {
        exception: {
            values: [
                exceptionValue
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $0e74257171b8d252$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $0e74257171b8d252$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $0e74257171b8d252$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
function $0e74257171b8d252$var$parseStackFrames(stackParser, ex) {
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $0e74257171b8d252$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $0e74257171b8d252$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {}
    return [];
}
const $0e74257171b8d252$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $0e74257171b8d252$var$getSkipFirstStackStringLines(ex) {
    if (ex && $0e74257171b8d252$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
function $0e74257171b8d252$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
function $0e74257171b8d252$var$isWebAssemblyException(exception) {
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") return exception instanceof WebAssembly.Exception;
    else return false;
}
function $0e74257171b8d252$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    if (!name && $0e74257171b8d252$var$isWebAssemblyException(ex)) {
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
function $0e74257171b8d252$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($0e74257171b8d252$var$isWebAssemblyException(ex)) {
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return (0, $6243a1d3d188c860$export$35a730c8874c1024)(message.error);
    return (0, $6243a1d3d188c860$export$35a730c8874c1024)(ex);
}
function $0e74257171b8d252$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $0e74257171b8d252$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $2a3bde5300b2c383$export$c69a9a0313b03bb1)(event);
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $c46e828452abe2e6$export$1fda8aa4d135f8aa)(event);
}
function $0e74257171b8d252$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || void 0;
    const event = $0e74257171b8d252$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $c46e828452abe2e6$export$1fda8aa4d135f8aa)(event);
}
function $0e74257171b8d252$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $1ae1983cb9bdf286$export$9f9636d330b71954)(exception) && exception.error) {
        const errorEvent = exception;
        return $0e74257171b8d252$var$eventFromError(stackParser, errorEvent.error);
    }
    if ((0, $1ae1983cb9bdf286$export$ef9e2056653f0c8e)(exception) || (0, $1ae1983cb9bdf286$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) {
            event = $0e74257171b8d252$var$eventFromError(stackParser, exception);
            const firstException = event.exception?.values?.[0];
            if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
                const frames = $0e74257171b8d252$var$parseStackFrames(stackParser, syntheticException);
                if (frames.length) {
                    firstException.stacktrace = {
                        frames: frames
                    };
                    (0, $2a3bde5300b2c383$export$c69a9a0313b03bb1)(event, {
                        synthetic: true
                    });
                }
            }
        } else {
            const name = domException.name || ((0, $1ae1983cb9bdf286$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $0e74257171b8d252$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $2a3bde5300b2c383$export$f26508487bf83ee7)(event, message);
        }
        return event;
    }
    if ((0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3)(exception)) return $0e74257171b8d252$var$eventFromError(stackParser, exception);
    if ((0, $1ae1983cb9bdf286$export$53b83ca8eaab0383)(exception) || (0, $1ae1983cb9bdf286$export$9671ea99bd126ace)(exception)) {
        const objectException = exception;
        event = $0e74257171b8d252$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $2a3bde5300b2c383$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    const stringifiedException = String(exception);
    event = $0e74257171b8d252$var$eventFromString(stackParser, stringifiedException, syntheticException, attachStacktrace);
    (0, $2a3bde5300b2c383$export$f26508487bf83ee7)(event, stringifiedException, void 0);
    (0, $2a3bde5300b2c383$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $0e74257171b8d252$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $0e74257171b8d252$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $2a3bde5300b2c383$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $1ae1983cb9bdf286$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $0e74257171b8d252$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $984d7f4f9d559811$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if ((0, $1ae1983cb9bdf286$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $1ae1983cb9bdf286$export$9671ea99bd126ace)(exception)) {
        const className = $0e74257171b8d252$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $0e74257171b8d252$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch  {}
}
function $0e74257171b8d252$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3));
}









function $ce30dc40979b2af6$export$f5282963edea4a68(exception, hint) {
    return (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)().captureException(exception, (0, $00d22111e1af0b33$export$76b5f966996d1653)(hint));
}
function $ce30dc40979b2af6$export$45654777c133ae80(message, captureContext) {
    const level = typeof captureContext === "string" ? captureContext : void 0;
    const hint = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : void 0;
    return (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)().captureMessage(message, level, hint);
}
function $ce30dc40979b2af6$export$1462b974fdcf6ba2(event, hint) {
    return (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
function $ce30dc40979b2af6$export$2f04de43fe27971a(name, context) {
    (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().setContext(name, context);
}
function $ce30dc40979b2af6$export$bb4922da0dd51b92(extras) {
    (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().setExtras(extras);
}
function $ce30dc40979b2af6$export$8e8e7789d42ed61d(key, extra) {
    (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().setExtra(key, extra);
}
function $ce30dc40979b2af6$export$74a8fb34822092e6(tags) {
    (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().setTags(tags);
}
function $ce30dc40979b2af6$export$a37d07ee78eb4569(key, value) {
    (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().setTag(key, value);
}
function $ce30dc40979b2af6$export$74da2cba014bdc09(attributes) {
    (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().setAttributes(attributes);
}
function $ce30dc40979b2af6$export$9fec4d97f1922e0b(key, value) {
    (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().setAttribute(key, value);
}
function $ce30dc40979b2af6$export$8b6bb3dd62a01be2(user) {
    (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().setUser(user);
}
function $ce30dc40979b2af6$export$58213391a19e392(conversationId) {
    (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().setConversationId(conversationId);
}
function $ce30dc40979b2af6$export$5d4e9fd7fac8e617() {
    return (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().lastEventId();
}
async function $ce30dc40979b2af6$export$4909b86c8034bf73(timeout) {
    const client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
async function $ce30dc40979b2af6$export$8360e631d277ea4d(timeout) {
    const client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
function $ce30dc40979b2af6$export$3f95c6f800b78024() {
    return !!(0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
}
function $ce30dc40979b2af6$export$3b029eb57ac4d562() {
    const client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function $ce30dc40979b2af6$export$9aac0b9f77928fbf(callback) {
    (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)().addEventProcessor(callback);
}
function $ce30dc40979b2af6$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)();
    const { user: user } = (0, $68fbe3379b72d8cf$export$cc422922fcbb91c6)(isolationScope, (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)());
    const { userAgent: userAgent } = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $08100e97513aa8d3$export$14a186326edbb264)({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, $08100e97513aa8d3$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $ce30dc40979b2af6$export$17a5be43989a0bc1();
    isolationScope.setSession(session);
    return session;
}
function $ce30dc40979b2af6$export$17a5be43989a0bc1() {
    const isolationScope = (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)();
    const currentScope = (0, $6a0e69fdf33e8459$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $08100e97513aa8d3$export$56521d9ba90f62ee)(session);
    $ce30dc40979b2af6$var$_sendSessionUpdate();
    isolationScope.setSession();
}
function $ce30dc40979b2af6$var$_sendSessionUpdate() {
    const isolationScope = (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)();
    const client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
function $ce30dc40979b2af6$export$667e7b4d445d566b(end = false) {
    if (end) {
        $ce30dc40979b2af6$export$17a5be43989a0bc1();
        return;
    }
    $ce30dc40979b2af6$var$_sendSessionUpdate();
}



const $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81 = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1);
let $aec2a0b3eeccf6ea$var$ignoreOnError = 0;
const $aec2a0b3eeccf6ea$var$ignoredErrorReports = [];
function $aec2a0b3eeccf6ea$export$b79738ab10c590b2(data) {
    if ($aec2a0b3eeccf6ea$var$ignoreOnError > 0) return true;
    const index = data ? $aec2a0b3eeccf6ea$var$ignoredErrorReports.findIndex((report)=>$aec2a0b3eeccf6ea$var$isSameErrorReport(report, data)) : -1;
    if (index === -1) return false;
    $aec2a0b3eeccf6ea$var$ignoredErrorReports.splice(index, 1);
    return true;
}
function $aec2a0b3eeccf6ea$export$d2798d8918c93d86(report) {
    $aec2a0b3eeccf6ea$var$ignoredErrorReports.push(report);
    setTimeout(()=>{
        const index = $aec2a0b3eeccf6ea$var$ignoredErrorReports.indexOf(report);
        if (index !== -1) $aec2a0b3eeccf6ea$var$ignoredErrorReports.splice(index, 1);
    });
}
function $aec2a0b3eeccf6ea$var$isSameErrorReport(a, b) {
    return a.msg === b.msg && a.url === b.url && a.line === b.line && a.column === b.column;
}
function $aec2a0b3eeccf6ea$export$1265a142ff5ba165() {
    $aec2a0b3eeccf6ea$var$ignoreOnError++;
    setTimeout(()=>{
        $aec2a0b3eeccf6ea$var$ignoreOnError--;
    });
}
function $aec2a0b3eeccf6ea$export$4997ffc0176396a6(fn, options = {}) {
    function isFunction(fn2) {
        return typeof fn2 === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
        if (hasOwnWrapper) {
            const wrapper = fn.__sentry_wrapped__;
            if (typeof wrapper === "function") return wrapper;
            else return fn;
        }
        if ((0, $984d7f4f9d559811$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch  {
        return fn;
    }
    const sentryWrapped = function(...args) {
        (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1)._sentryWrappedDepth = ((0, $ac5f383786409d8e$export$f1a6cdb1459e81d1)._sentryWrappedDepth || 0) + 1;
        try {
            const wrappedArguments = args.map((arg)=>$aec2a0b3eeccf6ea$export$4997ffc0176396a6(arg, options));
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $aec2a0b3eeccf6ea$export$1265a142ff5ba165();
            (0, $6a0e69fdf33e8459$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $2a3bde5300b2c383$export$f26508487bf83ee7)(event, void 0, void 0);
                        (0, $2a3bde5300b2c383$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $ce30dc40979b2af6$export$f5282963edea4a68)(ex);
            });
            throw ex;
        } finally{
            (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1)._sentryWrappedDepth = ((0, $ac5f383786409d8e$export$f1a6cdb1459e81d1)._sentryWrappedDepth || 0) - 1;
        }
    };
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {}
    (0, $984d7f4f9d559811$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $984d7f4f9d559811$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {}
    return sentryWrapped;
}
function $aec2a0b3eeccf6ea$export$a3c4a8453e8936f0() {
    const url = (0, $af60478d30a53662$export$1cfafeee2987818b)();
    const { referrer: referrer } = $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            "User-Agent": userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


class $bb5a332145f5b7ca$export$1df9218a526d318d extends (0, $fd9b989242abbc71$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $bb5a332145f5b7ca$export$4e107b20a7f977(options);
        const sdkSource = (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $g64OG.getSDKSource)();
        (0, $bcf849c00e94ac24$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        if (opts.routeProvider) (0, $2733035151347e6c$export$62397efcb3dc8911)(opts.routeProvider, this);
        this._unhandledSessionStatus = "unhandled";
        const { userInfo: userInfo } = this.getDataCollectionOptions();
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            // Only allow IP inferral by Relay if the user opted in via dataCollection
            infer_ip: userInfo ? "auto" : "never",
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        const { sendClientReports: sendClientReports } = this._options;
        if ((0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).document) (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                if (sendClientReports) this._flushOutcomes();
                queueMicrotask(()=>{
                    this.flush();
                });
            }
        });
        if (userInfo) this.on("beforeSendSession", (0, $0727c608597ea33d$export$e8e2d07ba63e2b6c));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $0e74257171b8d252$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $0e74257171b8d252$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
function $bb5a332145f5b7ca$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        // This supports the variable that sentry-webpack-plugin injects
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}









const $a1809f0d8bb21343$var$WINDOW = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1);
function $a1809f0d8bb21343$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch  {
        return false;
    }
}
function $a1809f0d8bb21343$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch  {
        return false;
    }
}
const $a1809f0d8bb21343$export$edf3cb81fd7d2a3e = $a1809f0d8bb21343$var$_isFetchSupported;
function $a1809f0d8bb21343$var$_isFetchSupported() {
    if (!("fetch" in $a1809f0d8bb21343$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("data:,");
        new Response();
        return true;
    } catch  {
        return false;
    }
}
function $a1809f0d8bb21343$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $a1809f0d8bb21343$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$a1809f0d8bb21343$var$_isFetchSupported()) return false;
    if ($a1809f0d8bb21343$export$d5f608b368e73f38($a1809f0d8bb21343$var$WINDOW.fetch)) return true;
    let result = false;
    const doc = $a1809f0d8bb21343$var$WINDOW.document;
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) result = $a1809f0d8bb21343$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $7d7ee71e9314e5f0$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $a1809f0d8bb21343$export$2d308b428295192f() {
    if (!$a1809f0d8bb21343$var$_isFetchSupported()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch  {
        return false;
    }
}





function $038aec1e4557ba88$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    const removeHandler = (0, $a745ef85d447d054$export$a4e09611e30da72e)(type, handler);
    (0, $a745ef85d447d054$export$e18d6c5462c01368)(type, ()=>$038aec1e4557ba88$var$instrumentFetch());
    return removeHandler;
}
function $038aec1e4557ba88$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $a745ef85d447d054$export$a4e09611e30da72e)(type, handler);
    (0, $a745ef85d447d054$export$e18d6c5462c01368)(type, ()=>$038aec1e4557ba88$var$instrumentFetch($038aec1e4557ba88$var$streamHandler));
    return removeHandler;
}
function $038aec1e4557ba88$var$instrumentFetch(onFetchResolved) {
    if ((0, $832e22c23ada9808$export$4e09c449d6c407f7)() && !(0, $a1809f0d8bb21343$export$c82d238e23c40b21)()) return;
    (0, $984d7f4f9d559811$export$9563e054e6f787fb)((0, $ac5f383786409d8e$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return new Proxy(originalFetch, {
            apply (target, _thisArg, args) {
                const virtualError = new Error();
                const { method: method, url: url } = $038aec1e4557ba88$export$f7a71163cc309d9a(args);
                const handlerData = {
                    args: args,
                    fetchData: {
                        method: method,
                        url: url
                    },
                    startTimestamp: (0, $81000fbf661a21ed$export$ee52dced521e3e18)() * 1e3,
                    virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                    virtualError,
                    headers: $038aec1e4557ba88$var$getHeadersFromFetchArgs(args)
                };
                if (!onFetchResolved) (0, $a745ef85d447d054$export$b18c893e424d3127)("fetch", {
                    ...handlerData
                });
                return Reflect.apply(target, (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                    if (onFetchResolved) onFetchResolved(response);
                    else (0, $a745ef85d447d054$export$b18c893e424d3127)("fetch", {
                        ...handlerData,
                        endTimestamp: (0, $81000fbf661a21ed$export$ee52dced521e3e18)() * 1e3,
                        response: response
                    });
                    return response;
                }, (error)=>{
                    (0, $a745ef85d447d054$export$b18c893e424d3127)("fetch", {
                        ...handlerData,
                        endTimestamp: (0, $81000fbf661a21ed$export$ee52dced521e3e18)() * 1e3,
                        error: error
                    });
                    if ((0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3)(error) && error.stack === void 0) {
                        error.stack = virtualError.stack;
                        (0, $984d7f4f9d559811$export$e73679ffaf56810e)(error, "framesToPop", 1);
                    }
                    const client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
                    const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                    const shouldEnhance = enhanceOption !== false;
                    if (shouldEnhance && (0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3)(error) && error.name === "TypeError" && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                        const url2 = new URL(handlerData.fetchData.url);
                        const hostname = url2.host;
                        if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                        else (0, $984d7f4f9d559811$export$e73679ffaf56810e)(error, "__sentry_fetch_url_host__", hostname);
                    } catch  {}
                    throw error;
                });
            }
        });
    });
}
async function $038aec1e4557ba88$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $038aec1e4557ba88$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $038aec1e4557ba88$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $a745ef85d447d054$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $81000fbf661a21ed$export$ee52dced521e3e18)() * 1e3,
            response: response
        });
    });
}
function $038aec1e4557ba88$var$hasProp(obj, prop) {
    return (0, $1ae1983cb9bdf286$export$c10d0b04eaa80a43)(obj) && !!obj[prop];
}
function $038aec1e4557ba88$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($038aec1e4557ba88$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $038aec1e4557ba88$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $038aec1e4557ba88$var$getUrlFromResource(resource),
            method: $038aec1e4557ba88$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $1ae1983cb9bdf286$export$6d3d1f317d7cda57)(resource) && $038aec1e4557ba88$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $038aec1e4557ba88$var$getUrlFromResource(arg),
        method: $038aec1e4557ba88$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $038aec1e4557ba88$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $1ae1983cb9bdf286$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}

function $c83976d257c67927$export$b8cfcc4175694bcc(statusCode) {
    if (statusCode === void 0) return void 0;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return void 0;
}




const $57de11b328303551$var$DEBOUNCE_DURATION = 1e3;
let $57de11b328303551$var$debounceTimerID;
let $57de11b328303551$var$lastCapturedEventType;
let $57de11b328303551$var$lastCapturedEventTargetId;
function $57de11b328303551$var$getCapture(options) {
    return typeof options === "boolean" ? options : !!options?.capture;
}
function $57de11b328303551$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $a745ef85d447d054$export$a4e09611e30da72e)(type, handler);
    (0, $a745ef85d447d054$export$e18d6c5462c01368)(type, $57de11b328303551$export$3014bbf0af0e1d4a);
}
function $57de11b328303551$export$3014bbf0af0e1d4a() {
    if (!(0, $d88a8c943753376d$export$56d8a8a25bd48b81).document) return;
    const triggerDOMHandler = (0, $a745ef85d447d054$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $57de11b328303551$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $d88a8c943753376d$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $d88a8c943753376d$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $d88a8c943753376d$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $984d7f4f9d559811$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if ((type === "click" || type == "keypress") && listener) try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        captureListeners: /* @__PURE__ */ new WeakSet(),
                        bubbleListeners: /* @__PURE__ */ new WeakSet(),
                        listenerCount: 0
                    };
                    const capture = $57de11b328303551$var$getCapture(options);
                    if (!handlerForType.handler) {
                        const handler = $57de11b328303551$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        handlerForType.capture = capture;
                        originalAddEventListener.call(this, type, handler, handlerForType.capture);
                    }
                    const listeners = handlerForType[capture ? "captureListeners" : "bubbleListeners"];
                    if (!listeners.has(listener)) {
                        if (typeof options === "object" && (options?.once || options?.signal)) handlerForType.sticky = true;
                        else {
                            listeners.add(listener);
                            handlerForType.listenerCount++;
                        }
                    }
                } catch  {}
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $984d7f4f9d559811$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if ((type === "click" || type == "keypress") && listener) try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType?.[$57de11b328303551$var$getCapture(options) ? "captureListeners" : "bubbleListeners"].delete(listener)) {
                        if (!--handlerForType.listenerCount && !handlerForType.sticky) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, handlerForType.capture);
                            handlerForType.handler = void 0;
                            delete handlers[type];
                        }
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {}
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function $57de11b328303551$var$isSimilarToLastCapturedEvent(event) {
    if (event.type !== $57de11b328303551$var$lastCapturedEventType) return false;
    try {
        if (!event.target || event.target._sentryId !== $57de11b328303551$var$lastCapturedEventTargetId) return false;
    } catch  {}
    return true;
}
function $57de11b328303551$var$shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
function $57de11b328303551$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        if (!event || event["_sentryCaptured"]) return;
        const target = $57de11b328303551$var$getEventTarget(event);
        if ($57de11b328303551$var$shouldSkipDOMEvent(event.type, target)) return;
        (0, $984d7f4f9d559811$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) (0, $984d7f4f9d559811$export$e73679ffaf56810e)(target, "_sentryId", (0, $2a3bde5300b2c383$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        if (!$57de11b328303551$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $57de11b328303551$var$lastCapturedEventType = event.type;
            $57de11b328303551$var$lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout($57de11b328303551$var$debounceTimerID);
        $57de11b328303551$var$debounceTimerID = (0, $d88a8c943753376d$export$56d8a8a25bd48b81).setTimeout(()=>{
            $57de11b328303551$var$lastCapturedEventTargetId = void 0;
            $57de11b328303551$var$lastCapturedEventType = void 0;
        }, $57de11b328303551$var$DEBOUNCE_DURATION);
    };
}
function $57de11b328303551$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        return null;
    }
}



let $4e8069af4b5f32dc$var$lastHref;
function $4e8069af4b5f32dc$export$67fc34576016d6ec() {
    return "history" in (0, $d88a8c943753376d$export$56d8a8a25bd48b81) && !!(0, $d88a8c943753376d$export$56d8a8a25bd48b81).history;
}
function $4e8069af4b5f32dc$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $a745ef85d447d054$export$a4e09611e30da72e)(type, handler);
    (0, $a745ef85d447d054$export$e18d6c5462c01368)(type, $4e8069af4b5f32dc$export$d9b613a6254a184e);
}
function $4e8069af4b5f32dc$export$d9b613a6254a184e() {
    (0, $d88a8c943753376d$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $d88a8c943753376d$export$56d8a8a25bd48b81).location.href;
        const from = $4e8069af4b5f32dc$var$lastHref;
        $4e8069af4b5f32dc$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $a745ef85d447d054$export$b18c893e424d3127)("history", handlerData);
    });
    if (!$4e8069af4b5f32dc$export$67fc34576016d6ec()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : void 0;
            if (url) {
                const from = $4e8069af4b5f32dc$var$lastHref;
                const to = $4e8069af4b5f32dc$var$getAbsoluteUrl(String(url));
                $4e8069af4b5f32dc$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $a745ef85d447d054$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $984d7f4f9d559811$export$9563e054e6f787fb)((0, $d88a8c943753376d$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $984d7f4f9d559811$export$9563e054e6f787fb)((0, $d88a8c943753376d$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}
function $4e8069af4b5f32dc$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $d88a8c943753376d$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        return urlOrPath;
    }
}



const $ccf678854579f53e$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
function $ccf678854579f53e$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $a745ef85d447d054$export$a4e09611e30da72e)(type, handler);
    (0, $a745ef85d447d054$export$e18d6c5462c01368)(type, $ccf678854579f53e$export$c67d533bf77cbf54);
}
function $ccf678854579f53e$export$c67d533bf77cbf54() {
    if (!(0, $d88a8c943753376d$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            let virtualError = new Error();
            const startTimestamp = (0, $81000fbf661a21ed$export$ee52dced521e3e18)() * 1e3;
            const method = (0, $1ae1983cb9bdf286$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
            const url = $ccf678854579f53e$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$ccf678854579f53e$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                const xhrInfo = xhrOpenThisArg[$ccf678854579f53e$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {}
                    const handlerData = {
                        endTimestamp: (0, $81000fbf661a21ed$export$ee52dced521e3e18)() * 1e3,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $a745ef85d447d054$export$b18c893e424d3127)("xhr", handlerData);
                    virtualError = void 0;
                    xhrOpenThisArg.removeEventListener("readystatechange", onreadystatechangeHandler);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$ccf678854579f53e$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $1ae1983cb9bdf286$export$844ec244b1367d54)(header) && (0, $1ae1983cb9bdf286$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$ccf678854579f53e$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== void 0) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $81000fbf661a21ed$export$ee52dced521e3e18)() * 1e3,
                xhr: sendThisArg
            };
            (0, $a745ef85d447d054$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $ccf678854579f53e$var$parseXhrUrlArg(url) {
    if ((0, $1ae1983cb9bdf286$export$844ec244b1367d54)(url)) return url;
    try {
        return url.toString();
    } catch  {}
    return void 0;
}


function $67c25229c8c62cbd$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!(0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


const $164ae31694abc3f3$var$DEFAULT_MAX_STRING_LENGTH = 80;
const $164ae31694abc3f3$var$accessors = {};
try {
    if (typeof Node !== "undefined") $164ae31694abc3f3$var$accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
    if (typeof Element !== "undefined") {
        $164ae31694abc3f3$var$accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
        $164ae31694abc3f3$var$accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
        $164ae31694abc3f3$var$accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
        $164ae31694abc3f3$var$accessors.getAttribute = Element.prototype.getAttribute;
    }
    if (typeof HTMLElement !== "undefined") $164ae31694abc3f3$var$accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
} catch  {}
function $164ae31694abc3f3$var$_safeRead(el, prop, arg) {
    const fn = $164ae31694abc3f3$var$accessors[prop];
    if (fn) try {
        return fn.call(el, arg);
    } catch  {}
    const val = el[prop];
    return typeof val === "function" ? val.call(el, arg) : val;
}
function $164ae31694abc3f3$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $164ae31694abc3f3$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $164ae31694abc3f3$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = $164ae31694abc3f3$var$_safeRead(currentElem, "parentNode");
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $164ae31694abc3f3$var$_htmlElementAsString(el, keyAttrs) {
    const out = [];
    const tagName = $164ae31694abc3f3$var$_safeRead(el, "tagName");
    if (!tagName) return "";
    if (typeof HTMLElement !== "undefined") {
        if (el instanceof HTMLElement) {
            const dataset = $164ae31694abc3f3$var$_safeRead(el, "dataset");
            if (dataset) {
                if (dataset["sentryComponent"]) return dataset["sentryComponent"];
                if (dataset["sentryElement"]) return dataset["sentryElement"];
            }
        }
    }
    out.push(tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>$164ae31694abc3f3$var$_safeRead(el, "getAttribute", keyAttr)).map((keyAttr)=>[
            keyAttr,
            $164ae31694abc3f3$var$_safeRead(el, "getAttribute", keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        const id = $164ae31694abc3f3$var$_safeRead(el, "id");
        if (id) out.push(`#${id}`);
        const className = $164ae31694abc3f3$var$_safeRead(el, "className");
        if (className && (0, $1ae1983cb9bdf286$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = $164ae31694abc3f3$var$_safeRead(el, "getAttribute", k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}


const $2972797b2fabef14$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $19aa2e0368e59496$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $19aa2e0368e59496$var$INTEGRATION_NAME = "Breadcrumbs";
const $19aa2e0368e59496$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $19aa2e0368e59496$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.dom) (0, $57de11b328303551$export$5aeffd3db2cf9df7)($19aa2e0368e59496$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $ccf678854579f53e$export$26ace48dd54c9aea)($19aa2e0368e59496$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $038aec1e4557ba88$export$f75d3c772c923df0)($19aa2e0368e59496$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $4e8069af4b5f32dc$export$3f18c56c58114e75)($19aa2e0368e59496$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $19aa2e0368e59496$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $19aa2e0368e59496$export$c079d904b326663a = (0, $44faf1ffd3373da7$export$2323046b9414659f)($19aa2e0368e59496$var$_breadcrumbsIntegration);
function $19aa2e0368e59496$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)() !== client) return;
        (0, $7035b569e51f49e8$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $2a3bde5300b2c383$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
function $19aa2e0368e59496$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > $19aa2e0368e59496$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $2972797b2fabef14$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`\`dom.maxStringLength\` cannot exceed ${$19aa2e0368e59496$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$19aa2e0368e59496$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $19aa2e0368e59496$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        try {
            const event = handlerData.event;
            const element = $19aa2e0368e59496$var$_isEvent(event) ? event.target : event;
            target = (0, $164ae31694abc3f3$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $67c25229c8c62cbd$export$26727cfcc4d7e0fc)(element);
        } catch  {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $7035b569e51f49e8$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function $19aa2e0368e59496$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $ccf678854579f53e$export$55b6bb1e45c6cf59];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $c83976d257c67927$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $7035b569e51f49e8$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
function $19aa2e0368e59496$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: handlerData.fetchData,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $7035b569e51f49e8$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $c83976d257c67927$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $7035b569e51f49e8$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
function $19aa2e0368e59496$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $1dcf8ba856755e63$export$7a5253c0f62e0150)((0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $1dcf8ba856755e63$export$7a5253c0f62e0150)(from) : void 0;
        const parsedTo = (0, $1dcf8ba856755e63$export$7a5253c0f62e0150)(to);
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $7035b569e51f49e8$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $19aa2e0368e59496$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $e0c3f6c99707ea26$var$DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
const $e0c3f6c99707ea26$var$INTEGRATION_NAME = "BrowserApiErrors";
const $e0c3f6c99707ea26$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $e0c3f6c99707ea26$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $984d7f4f9d559811$export$9563e054e6f787fb)((0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81), "setTimeout", $e0c3f6c99707ea26$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $984d7f4f9d559811$export$9563e054e6f787fb)((0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81), "setInterval", $e0c3f6c99707ea26$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $984d7f4f9d559811$export$9563e054e6f787fb)((0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81), "requestAnimationFrame", $e0c3f6c99707ea26$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81)) (0, $984d7f4f9d559811$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $e0c3f6c99707ea26$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $e0c3f6c99707ea26$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$e0c3f6c99707ea26$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
const $e0c3f6c99707ea26$export$59bfe9f1c76150e = (0, $44faf1ffd3373da7$export$2323046b9414659f)($e0c3f6c99707ea26$var$_browserApiErrorsIntegration);
function $e0c3f6c99707ea26$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $aec2a0b3eeccf6ea$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $3a6ba34e83b7a312$export$aad197c7121a6651)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $e0c3f6c99707ea26$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $aec2a0b3eeccf6ea$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $3a6ba34e83b7a312$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "auto.browser.browserapierrors.requestAnimationFrame"
                }
            })
        ]);
    };
}
function $e0c3f6c99707ea26$var$_wrapXHR(originalSend) {
    return function(...args) {
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $984d7f4f9d559811$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $3a6ba34e83b7a312$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                const originalFunction = (0, $984d7f4f9d559811$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $3a6ba34e83b7a312$export$aad197c7121a6651)(originalFunction);
                return (0, $aec2a0b3eeccf6ea$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $e0c3f6c99707ea26$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $984d7f4f9d559811$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($e0c3f6c99707ea26$var$isEventListenerObject(fn)) fn.handleEvent = (0, $aec2a0b3eeccf6ea$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $3a6ba34e83b7a312$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.handleEvent"
                    }
                });
            } catch  {}
            if (integrationOptions.unregisterOriginalCallbacks) $e0c3f6c99707ea26$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $aec2a0b3eeccf6ea$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $3a6ba34e83b7a312$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "auto.browser.browserapierrors.addEventListener"
                    }
                }),
                options
            ]);
        };
    });
    (0, $984d7f4f9d559811$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            try {
                if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
                    const originalEventHandler = fn.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch  {}
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $e0c3f6c99707ea26$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}
function $e0c3f6c99707ea26$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") target.removeEventListener(eventName, fn);
}




function $d8687fd0602ceca3$export$26d3d892edc56833(type, listener, options) {
    if ((0, $d88a8c943753376d$export$56d8a8a25bd48b81).document) (0, $d88a8c943753376d$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
function $d8687fd0602ceca3$export$324d7b4b46528191(type, listener, options) {
    if ((0, $d88a8c943753376d$export$56d8a8a25bd48b81).document) (0, $d88a8c943753376d$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}
const $d8687fd0602ceca3$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $d88a8c943753376d$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};
const $d8687fd0602ceca3$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = $d8687fd0602ceca3$export$6431553786c94949();
    return navEntry?.activationStart ?? 0;
};
const $d8687fd0602ceca3$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenCallback = (event)=>{
        if ((0, $d88a8c943753376d$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb(event);
    };
    $d8687fd0602ceca3$export$26d3d892edc56833("visibilitychange", onHiddenCallback, {
        capture: true
    });
};
let $d8687fd0602ceca3$var$firstHiddenTime = -1;
const $d8687fd0602ceca3$var$onHiddenFunctions = /* @__PURE__ */ new Set();
const $d8687fd0602ceca3$var$initHiddenTime = ()=>{
    return (0, $d88a8c943753376d$export$56d8a8a25bd48b81).document?.visibilityState === "hidden" && !(0, $d88a8c943753376d$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $d8687fd0602ceca3$var$onVisibilityUpdate = (event)=>{
    if ((0, $d88a8c943753376d$export$56d8a8a25bd48b81).document?.visibilityState === "hidden" && $d8687fd0602ceca3$var$firstHiddenTime > -1) {
        if (event.type === "visibilitychange") for (const onHiddenFunction of $d8687fd0602ceca3$var$onHiddenFunctions)onHiddenFunction();
        if (!isFinite($d8687fd0602ceca3$var$firstHiddenTime)) {
            $d8687fd0602ceca3$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            $d8687fd0602ceca3$export$324d7b4b46528191("prerenderingchange", $d8687fd0602ceca3$var$onVisibilityUpdate, true);
        }
    }
};
const $d8687fd0602ceca3$export$443f86b2c77012c4 = ()=>{
    if ((0, $d88a8c943753376d$export$56d8a8a25bd48b81).document && $d8687fd0602ceca3$var$firstHiddenTime < 0) {
        const activationStart = $d8687fd0602ceca3$export$d3e828b3c7b5b845();
        const firstVisibilityStateHiddenTime = !(0, $d88a8c943753376d$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
        $d8687fd0602ceca3$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $d8687fd0602ceca3$var$initHiddenTime();
        $d8687fd0602ceca3$export$26d3d892edc56833("visibilitychange", $d8687fd0602ceca3$var$onVisibilityUpdate, true);
        $d8687fd0602ceca3$export$26d3d892edc56833("prerenderingchange", $d8687fd0602ceca3$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $d8687fd0602ceca3$var$firstHiddenTime;
        },
        onHidden (cb) {
            $d8687fd0602ceca3$var$onHiddenFunctions.add(cb);
        }
    };
};
const $d8687fd0602ceca3$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $d88a8c943753376d$export$56d8a8a25bd48b81).requestIdleCallback || (0, $d88a8c943753376d$export$56d8a8a25bd48b81).setTimeout;
    if ((0, $d88a8c943753376d$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        let called = false;
        const runOnce = ()=>{
            if (!called) {
                cb();
                called = true;
            }
        };
        $d8687fd0602ceca3$export$26d3d892edc56833("visibilitychange", runOnce, {
            once: true,
            capture: true
        });
        rIC(()=>{
            runOnce();
            $d8687fd0602ceca3$export$324d7b4b46528191("visibilitychange", runOnce, {
                capture: true
            });
        });
    }
};




const $2156d656bc5cf961$export$1baa7880e357371c = (0, $44faf1ffd3373da7$export$2323046b9414659f)((options = {})=>{
    const lifecycle = options.lifecycle ?? "page";
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $2972797b2fabef14$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            (0, $ce30dc40979b2af6$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            let initialSessionSent = false;
            (0, $d8687fd0602ceca3$export$d3314d5863fc1fef)(()=>{
                if (!initialSessionSent) {
                    (0, $ce30dc40979b2af6$export$667e7b4d445d566b)();
                    initialSessionSent = true;
                }
            });
            const isolationScope = (0, $6a0e69fdf33e8459$export$68f3af03034c9e90)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    previousUser = maybeNewUser;
                    if (initialSessionSent) (0, $ce30dc40979b2af6$export$667e7b4d445d566b)();
                }
            });
            if (lifecycle === "route") (0, $4e8069af4b5f32dc$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                if (from !== to) {
                    (0, $ce30dc40979b2af6$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $ce30dc40979b2af6$export$667e7b4d445d566b)();
                    initialSessionSent = true;
                }
            });
        }
    };
});







function $10f36ed136ba89b8$export$3f58558cf4af9c09(contexts) {
    const attrs = {};
    const { response: response, profile: profile, cloud_resource: cloud_resource, culture: culture, state: state } = contexts;
    if (response) {
        if (response.status_code != null) attrs["http.response.status_code"] = response.status_code;
        if (response.body_size != null) attrs["http.response.body.size"] = response.body_size;
    }
    if (profile) {
        if (profile.profile_id) attrs["sentry.profile_id"] = profile.profile_id;
        if (profile.profiler_id) attrs["sentry.profiler_id"] = profile.profiler_id;
    }
    if (cloud_resource) {
        for (const [key, value] of Object.entries(cloud_resource))if (value != null) attrs[key] = value;
    }
    if (culture) {
        if (culture.locale) attrs["culture.locale"] = culture.locale;
        if (culture.timezone) attrs["culture.timezone"] = culture.timezone;
    }
    if (state?.state && typeof state.state.type === "string") attrs["state.type"] = state.state.type;
    const angular = contexts["angular"];
    if (angular) {
        const version = angular["version"];
        if (typeof version === "string" || typeof version === "number") attrs["angular.version"] = version;
    }
    const react = contexts["react"];
    if (react) {
        const version = react["version"];
        if (typeof version === "string" || typeof version === "number") attrs["react.version"] = version;
    }
    return attrs;
}




function $241611824fe64f96$export$b1e72a433efdc918(span, client) {
    const spanJSON = (0, $1c045c464121271a$export$92d8c23565496537)(span);
    const segmentSpan = (0, $1c045c464121271a$export$7a3106f345d83bb6)(span);
    const serializedSegmentSpan = (0, $1c045c464121271a$export$92d8c23565496537)(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = (0, $ede25f0577eb9341$export$c08fbc656a245d03)(span);
    const finalScopeData = (0, $68fbe3379b72d8cf$export$cc422922fcbb91c6)(spanIsolationScope, spanScope);
    $241611824fe64f96$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    client.emit("preprocessSpan", spanJSON);
    if (spanJSON.is_segment) {
        $241611824fe64f96$var$applyScopeToSegmentSpan(spanJSON, finalScopeData);
        $241611824fe64f96$var$applySdkMetadataToSegmentSpan(spanJSON, client);
        client.emit("processSegmentSpan", spanJSON);
    }
    client.emit("processSpan", spanJSON);
    const { beforeSendSpan: beforeSendSpan, traceLifecycle: traceLifecycle } = client.getOptions();
    const processedSpan = // check for traceLifecycle here because in static lifecycle,
    // captureSpan is called for INP spans. If an unmigrated beforeSendSpan
    // callback is run on these spans, it will throw an error.
    traceLifecycle !== "static" && beforeSendSpan && !(0, $e40f8aba80c53550$export$b34b07e89ddc4dd2)(beforeSendSpan) ? (0, $e40f8aba80c53550$export$d38dd0f511e8d9ba)(spanJSON, beforeSendSpan) : spanJSON;
    return {
        ...(0, $1c045c464121271a$export$5402aa553bcf35f3)(processedSpan),
        _segmentSpan: segmentSpan
    };
}
function $241611824fe64f96$var$applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
    const contextAttributes = (0, $10f36ed136ba89b8$export$3f58558cf4af9c09)(scopeData.contexts);
    $241611824fe64f96$export$146fcadff0eefcf3(segmentSpanJSON, contextAttributes);
}
function $241611824fe64f96$export$146fcadff0eefcf3(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $241611824fe64f96$var$applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
    const integrationNames = client.getIntegrationNames();
    if (!integrationNames.length) return;
    $241611824fe64f96$export$146fcadff0eefcf3(segmentSpanJSON, {
        [(0, $4e79bc9bf7524846$exports.SENTRY_SDK_INTEGRATIONS)]: integrationNames
    });
}
function $241611824fe64f96$var$commonSpanAttributes(serializedSegmentSpan, client, scopeData, includeScopeAttributes = true) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    return {
        [(0, $4e79bc9bf7524846$exports.SENTRY_TRACE_LIFECYCLE)]: "stream",
        [(0, $4e79bc9bf7524846$exports.SENTRY_SEGMENT_NAME)]: serializedSegmentSpan.name,
        [(0, $4e79bc9bf7524846$exports.SENTRY_SEGMENT_ID)]: serializedSegmentSpan.span_id,
        [(0, $4e79bc9bf7524846$exports.SENTRY_SDK_NAME)]: sdk?.sdk?.name,
        [(0, $4e79bc9bf7524846$exports.SENTRY_SDK_VERSION)]: sdk?.sdk?.version,
        [(0, $4e79bc9bf7524846$exports.SENTRY_RELEASE)]: release,
        [(0, $4e79bc9bf7524846$exports.SENTRY_ENVIRONMENT)]: environment || (0, $e3d2412e82cb94c3$export$849dbeeeda01ae98),
        [(0, $4e79bc9bf7524846$exports.USER_ID)]: scopeData.user?.id,
        [(0, $4e79bc9bf7524846$exports.USER_EMAIL)]: scopeData.user?.email,
        [(0, $4e79bc9bf7524846$exports.USER_IP_ADDRESS)]: scopeData.user?.ip_address,
        [(0, $4e79bc9bf7524846$exports.USER_NAME)]: scopeData.user?.username,
        ...includeScopeAttributes ? scopeData.attributes : void 0
    };
}
function $241611824fe64f96$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    $241611824fe64f96$export$146fcadff0eefcf3(spanJSON, $241611824fe64f96$var$commonSpanAttributes(serializedSegmentSpan, client, scopeData));
}
function $241611824fe64f96$export$8e81c3e49f77d712(span, client, beforeSendSpan) {
    const spanJSON = (0, $1c045c464121271a$export$1d09902424677504)(span);
    const segmentSpan = (0, $1c045c464121271a$export$7a3106f345d83bb6)(span);
    const serializedSegmentSpan = (0, $1c045c464121271a$export$92d8c23565496537)(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = (0, $ede25f0577eb9341$export$c08fbc656a245d03)(span);
    const finalScopeData = (0, $68fbe3379b72d8cf$export$cc422922fcbb91c6)(spanIsolationScope, spanScope);
    const commonAttributes = $241611824fe64f96$var$commonSpanAttributes(serializedSegmentSpan, client, finalScopeData, false);
    Object.entries(commonAttributes).forEach(([key, value])=>{
        if (value != null && !(key in spanJSON.data)) spanJSON.data[key] = value;
    });
    const processedSpan = (0, $e40f8aba80c53550$export$d38dd0f511e8d9ba)(spanJSON, beforeSendSpan);
    return (0, $a87042d090900a38$export$f6f6d4b2a7942521)(processedSpan);
}



const $5b2665e3ca77cefa$var$INTEGRATION_NAME = "CultureContext";
const $5b2665e3ca77cefa$var$_cultureContextIntegration = ()=>{
    return {
        name: $5b2665e3ca77cefa$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $5b2665e3ca77cefa$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $5b2665e3ca77cefa$var$getCultureContext();
            if (culture) (0, $241611824fe64f96$export$146fcadff0eefcf3)(span, {
                "culture.locale": culture.locale,
                "culture.timezone": culture.timezone,
                "culture.calendar": culture.calendar
            });
        }
    };
};
const $5b2665e3ca77cefa$export$ec5976aacdc85985 = (0, $44faf1ffd3373da7$export$2323046b9414659f)($5b2665e3ca77cefa$var$_cultureContextIntegration);
function $5b2665e3ca77cefa$var$getCultureContext() {
    try {
        const intl = (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).Intl;
        if (!intl) return void 0;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        return void 0;
    }
}




let $ee10e46ca16708cf$var$_oldOnErrorHandler = null;
function $ee10e46ca16708cf$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $a745ef85d447d054$export$a4e09611e30da72e)(type, handler);
    (0, $a745ef85d447d054$export$e18d6c5462c01368)(type, $ee10e46ca16708cf$var$instrumentError);
}
function $ee10e46ca16708cf$var$instrumentError() {
    $ee10e46ca16708cf$var$_oldOnErrorHandler = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).onerror;
    (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $a745ef85d447d054$export$b18c893e424d3127)("error", handlerData);
        if ($ee10e46ca16708cf$var$_oldOnErrorHandler) return $ee10e46ca16708cf$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $5ae47ebf57055da2$var$_oldOnUnhandledRejectionHandler = null;
function $5ae47ebf57055da2$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $a745ef85d447d054$export$a4e09611e30da72e)(type, handler);
    (0, $a745ef85d447d054$export$e18d6c5462c01368)(type, $5ae47ebf57055da2$var$instrumentUnhandledRejection);
}
function $5ae47ebf57055da2$var$instrumentUnhandledRejection() {
    $5ae47ebf57055da2$var$_oldOnUnhandledRejectionHandler = (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $a745ef85d447d054$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($5ae47ebf57055da2$var$_oldOnUnhandledRejectionHandler) return $5ae47ebf57055da2$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $ac5f383786409d8e$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}






const $c10e7899fa4749e3$var$INTEGRATION_NAME = "GlobalHandlers";
const $c10e7899fa4749e3$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $c10e7899fa4749e3$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $c10e7899fa4749e3$var$_installGlobalOnErrorHandler(client);
                $c10e7899fa4749e3$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $c10e7899fa4749e3$var$_installGlobalOnUnhandledRejectionHandler(client);
                $c10e7899fa4749e3$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $c10e7899fa4749e3$export$66acc70e8cf2b71a = (0, $44faf1ffd3373da7$export$2323046b9414659f)($c10e7899fa4749e3$var$_globalHandlersIntegration);
function $c10e7899fa4749e3$var$_installGlobalOnErrorHandler(client) {
    (0, $ee10e46ca16708cf$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c10e7899fa4749e3$var$getOptions();
        if ((0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)() !== client || (0, $aec2a0b3eeccf6ea$export$b79738ab10c590b2)(data)) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $c10e7899fa4749e3$export$a9640bbdaad80((0, $0e74257171b8d252$export$9dd56ed1ef0c3420)(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $ce30dc40979b2af6$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onerror"
            }
        });
    });
}
function $c10e7899fa4749e3$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $5ae47ebf57055da2$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c10e7899fa4749e3$var$getOptions();
        if ((0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)() !== client || (0, $aec2a0b3eeccf6ea$export$b79738ab10c590b2)()) return;
        const error = $c10e7899fa4749e3$export$b2cc40fa8241780(e);
        const event = (0, $1ae1983cb9bdf286$export$c3825b437cbdea5c)(error) ? $c10e7899fa4749e3$export$1353b5b36844a9ed(error) : (0, $0e74257171b8d252$export$9dd56ed1ef0c3420)(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        (0, $ce30dc40979b2af6$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "auto.browser.global_handlers.onunhandledrejection"
            }
        });
    });
}
function $c10e7899fa4749e3$export$b2cc40fa8241780(error) {
    if ((0, $1ae1983cb9bdf286$export$c3825b437cbdea5c)(error)) return error;
    try {
        if ("reason" in error) return error.reason;
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {}
    return error;
}
function $c10e7899fa4749e3$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $c10e7899fa4749e3$export$a9640bbdaad80(event, url, lineno, colno) {
    const e = event.exception = event.exception || {};
    const ev = e.values = e.values || [];
    const ev0 = ev[0] = ev[0] || {};
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $c10e7899fa4749e3$var$getFilenameFromUrl(url) ?? (0, $af60478d30a53662$export$1cfafeee2987818b)(),
        function: (0, $3a6ba34e83b7a312$export$27c7e15d453fc0ac),
        in_app: true
    });
    return event;
}
function $c10e7899fa4749e3$var$globalHandlerLog(type) {
    (0, $2972797b2fabef14$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).log(`Global Handler attached: ${type}`);
}
function $c10e7899fa4749e3$var$getOptions() {
    const client = (0, $6a0e69fdf33e8459$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $c10e7899fa4749e3$var$getFilenameFromUrl(url) {
    if (!(0, $1ae1983cb9bdf286$export$844ec244b1367d54)(url) || url.length === 0) return void 0;
    if (url.startsWith("data:")) return `<${(0, $1dcf8ba856755e63$export$8abd806fcaf234fa)(url, false)}>`;
    return url;
}





const $9fb8881afa927e5f$export$1378794447170364 = (0, $44faf1ffd3373da7$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event, _hint, client) {
            if (!(0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).navigator && !(0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).location && !(0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).document) return;
            const { url: url, headers: collectedHeaders } = (0, $aec2a0b3eeccf6ea$export$a3c4a8453e8936f0)();
            const behavior = client.getDataCollectionOptions().httpHeaders.request;
            const userHeaders = Object.entries(event.request?.headers ?? {}).filter(([key])=>!(key in collectedHeaders));
            const headers = {
                ...(0, $4a3a3e482dd801e0$export$73acb6f35c15da01)(collectedHeaders, behavior),
                ...Object.fromEntries(userHeaders)
            };
            event.request = {
                url: // The URL isn't gated by `dataCollection`, same as on the server.
                url,
                ...event.request,
                ...Object.keys(headers).length > 0 ? {
                    headers: headers
                } : {
                    headers: void 0
                }
            };
        },
        processSpan (span, client) {
            if (!(0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).navigator && !(0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).location && !(0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $aec2a0b3eeccf6ea$export$a3c4a8453e8936f0)();
            const headers = (0, $4a3a3e482dd801e0$export$73acb6f35c15da01)(reqData.headers, client.getDataCollectionOptions().httpHeaders.request);
            const referer = headers["Referer"];
            const { hostname: hostname, protocol: protocol } = (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).location || {};
            (0, $241611824fe64f96$export$146fcadff0eefcf3)(span, {
                // This attribute is used by the "Filter out events from legacy browsers and crawlers" features on the Sentry backend.
                // Therefore, it's set on every span.
                [(0, $4e79bc9bf7524846$exports.USER_AGENT_ORIGINAL)]: headers["User-Agent"],
                // Likewise for the "Filter out localhost events" feature. Deliberately inlined rather than
                // sharing the server-side helper, which costs bundle size for request headers and IPs that
                // don't exist here. Mirrors Relay's localhost filter (relay-filter/src/localhost.rs).
                [(0, $4e79bc9bf7524846$exports.SENTRY_IS_LOCALHOST)]: protocol === "file:" || hostname === "localhost" || hostname === "127.0.0.1" || // `location.hostname` keeps the brackets for IPv6 hosts, so this is `[::1]`, not `::1`.
                hostname === "[::1]" || !!hostname?.endsWith(".localhost"),
                // These attributes, we only need on the segment span (analogous to the `request` context for events)
                ...span.is_segment && {
                    // Coerce empty string to undefined so the helper's nullish check drops it,
                    // rather than writing an empty `url.full` attribute onto the span.
                    [(0, $4e79bc9bf7524846$exports.URL_FULL)]: span.attributes?.[0, $4e79bc9bf7524846$exports.SENTRY_OP] !== "http.client" ? (0, $add1a9ee134dfbbc$export$9dbd5b9f0d1db392)(reqData.url) : void 0,
                    [`${0, $4e79bc9bf7524846$exports.HTTP_REQUEST_HEADER_KEY_BASE}.referer`]: referer ? [
                        referer
                    ] : void 0
                }
            });
        }
    };
});



function $0b37be98e5af4891$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3)(hint.originalException)) return;
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) event.exception.values = $0b37be98e5af4891$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $0b37be98e5af4891$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ((0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3)(error[key])) {
        $0b37be98e5af4891$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $0b37be98e5af4891$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $0b37be98e5af4891$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    if ($0b37be98e5af4891$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ((0, $1ae1983cb9bdf286$export$e6127cc7fe7395c3)(childError)) {
            $0b37be98e5af4891$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $0b37be98e5af4891$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $0b37be98e5af4891$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $0b37be98e5af4891$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $0b37be98e5af4891$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: "auto.core.linked_errors",
        ...$0b37be98e5af4891$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $0b37be98e5af4891$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $c8e2f88a417dbbd0$var$DEFAULT_KEY = "cause";
const $c8e2f88a417dbbd0$var$DEFAULT_LIMIT = 5;
const $c8e2f88a417dbbd0$var$INTEGRATION_NAME = "LinkedErrors";
const $c8e2f88a417dbbd0$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $c8e2f88a417dbbd0$var$DEFAULT_LIMIT;
    const key = options.key || $c8e2f88a417dbbd0$var$DEFAULT_KEY;
    return {
        name: $c8e2f88a417dbbd0$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options2 = client.getOptions();
            (0, $0b37be98e5af4891$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $0e74257171b8d252$export$a6c2d27607295951), options2.stackParser, key, limit, event, hint);
        }
    };
};
const $c8e2f88a417dbbd0$export$ebabb00eb7f3a395 = (0, $44faf1ffd3373da7$export$2323046b9414659f)($c8e2f88a417dbbd0$var$_linkedErrorsIntegration);



const $2ae28e417f20fe75$var$OPERA10_PRIORITY = 10;
const $2ae28e417f20fe75$var$OPERA11_PRIORITY = 20;
const $2ae28e417f20fe75$var$CHROME_PRIORITY = 30;
const $2ae28e417f20fe75$var$WINJS_PRIORITY = 40;
const $2ae28e417f20fe75$var$GECKO_PRIORITY = 50;
function $2ae28e417f20fe75$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $3a6ba34e83b7a312$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== void 0) frame.lineno = lineno;
    if (colno !== void 0) frame.colno = colno;
    return frame;
}
const $2ae28e417f20fe75$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const $2ae28e417f20fe75$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $2ae28e417f20fe75$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $2ae28e417f20fe75$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const $2ae28e417f20fe75$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($2ae28e417f20fe75$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    const noFnParts = $2ae28e417f20fe75$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line2, col] = noFnParts;
        return $2ae28e417f20fe75$var$createFrame(filename, (0, $3a6ba34e83b7a312$export$27c7e15d453fc0ac), +line2, +col);
    }
    const parts = $2ae28e417f20fe75$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf("eval") === 0;
        if (isEval) {
            const subMatch = $2ae28e417f20fe75$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                parts[2] = subMatch[1];
                parts[3] = subMatch[2];
                parts[4] = subMatch[3];
            }
        }
        const [func, filename] = $2ae28e417f20fe75$var$extractSafariExtensionDetails(parts[1] || (0, $3a6ba34e83b7a312$export$27c7e15d453fc0ac), parts[2]);
        return $2ae28e417f20fe75$var$createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
    }
    return;
};
const $2ae28e417f20fe75$export$263a749fff749872 = [
    $2ae28e417f20fe75$var$CHROME_PRIORITY,
    $2ae28e417f20fe75$var$chromeStackParserFn
];
const $2ae28e417f20fe75$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $2ae28e417f20fe75$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $2ae28e417f20fe75$var$gecko = (line)=>{
    const parts = $2ae28e417f20fe75$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $2ae28e417f20fe75$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = "";
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $3a6ba34e83b7a312$export$27c7e15d453fc0ac);
        [func, filename] = $2ae28e417f20fe75$var$extractSafariExtensionDetails(func, filename);
        return $2ae28e417f20fe75$var$createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
    }
    return;
};
const $2ae28e417f20fe75$export$cdba47a5dd2804d = [
    $2ae28e417f20fe75$var$GECKO_PRIORITY,
    $2ae28e417f20fe75$var$gecko
];
const $2ae28e417f20fe75$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $2ae28e417f20fe75$var$winjs = (line)=>{
    const parts = $2ae28e417f20fe75$var$winjsRegex.exec(line);
    return parts ? $2ae28e417f20fe75$var$createFrame(parts[2], parts[1] || (0, $3a6ba34e83b7a312$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const $2ae28e417f20fe75$export$179460296da408e8 = [
    $2ae28e417f20fe75$var$WINJS_PRIORITY,
    $2ae28e417f20fe75$var$winjs
];
const $2ae28e417f20fe75$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $2ae28e417f20fe75$var$opera10 = (line)=>{
    const parts = $2ae28e417f20fe75$var$opera10Regex.exec(line);
    return parts ? $2ae28e417f20fe75$var$createFrame(parts[2], parts[3] || (0, $3a6ba34e83b7a312$export$27c7e15d453fc0ac), +parts[1]) : void 0;
};
const $2ae28e417f20fe75$export$f892b52c880ffc7a = [
    $2ae28e417f20fe75$var$OPERA10_PRIORITY,
    $2ae28e417f20fe75$var$opera10
];
const $2ae28e417f20fe75$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $2ae28e417f20fe75$var$opera11 = (line)=>{
    const parts = $2ae28e417f20fe75$var$opera11Regex.exec(line);
    return parts ? $2ae28e417f20fe75$var$createFrame(parts[5], parts[3] || parts[4] || (0, $3a6ba34e83b7a312$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : void 0;
};
const $2ae28e417f20fe75$export$af11af13f09fb0dc = [
    $2ae28e417f20fe75$var$OPERA11_PRIORITY,
    $2ae28e417f20fe75$var$opera11
];
const $2ae28e417f20fe75$export$7197c0fe6554c079 = [
    $2ae28e417f20fe75$export$263a749fff749872,
    $2ae28e417f20fe75$export$cdba47a5dd2804d
];
const $2ae28e417f20fe75$export$2b2b997d81bf3907 = (0, $3a6ba34e83b7a312$export$a5739666fb2d03d4)(...$2ae28e417f20fe75$export$7197c0fe6554c079);
const $2ae28e417f20fe75$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $3a6ba34e83b7a312$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};






const $286df0c4eecbe9e3$var$cachedImplementations = {};
function $286df0c4eecbe9e3$export$e464f4a514ac28a8(name) {
    const cached = $286df0c4eecbe9e3$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $d88a8c943753376d$export$56d8a8a25bd48b81)[name];
    if ((0, $a1809f0d8bb21343$export$d5f608b368e73f38)(impl)) return $286df0c4eecbe9e3$var$cachedImplementations[name] = impl.bind((0, $d88a8c943753376d$export$56d8a8a25bd48b81));
    const document = (0, $d88a8c943753376d$export$56d8a8a25bd48b81).document;
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $b5d72063b53488fc$export$16a28057038b10ef) && (0, $fc0ca994ab4632cd$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    if (!impl) return impl;
    return $286df0c4eecbe9e3$var$cachedImplementations[name] = impl.bind((0, $d88a8c943753376d$export$56d8a8a25bd48b81));
}
function $286df0c4eecbe9e3$export$8aa36702e8c8978(name) {
    $286df0c4eecbe9e3$var$cachedImplementations[name] = void 0;
}
function $286df0c4eecbe9e3$export$e7aa7bc5c1b3cfb3(...rest) {
    return $286df0c4eecbe9e3$export$e464f4a514ac28a8("fetch")(...rest);
}
function $286df0c4eecbe9e3$export$831dc9f2ab0a617b(...rest) {
    return $286df0c4eecbe9e3$export$e464f4a514ac28a8("setTimeout")(...rest);
}


const $a10505d7dc0cec1e$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function $a10505d7dc0cec1e$export$b2311068c46d7cc8(options, nativeFetch = (0, $286df0c4eecbe9e3$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            };
        } catch (e) {
            (0, $286df0c4eecbe9e3$export$8aa36702e8c8978)("fetch");
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $ee849985480e73fd$export$d09f50d9ab7f7b69)(options, makeRequest, (0, $0abfd478ccd42977$export$85a4f67f852183e6)(options.bufferSize || $a10505d7dc0cec1e$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}


function $665d1ed9877a9965$export$45a5e7f76e0caa8d(wat) {
    if (typeof Element === "undefined") return false;
    try {
        return wat instanceof Element;
    } catch  {
        return false;
    }
}


const $93572b6dc627bc21$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function $93572b6dc627bc21$export$4c88c355e6072df5(value) {
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    if ((0, $665d1ed9877a9965$export$45a5e7f76e0caa8d)(value)) {
        const objName = $93572b6dc627bc21$var$getConstructorName(value);
        if ($93572b6dc627bc21$var$HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) return `[HTMLElement: ${(0, $164ae31694abc3f3$export$5647df6b7814ac86)(value)}]`;
    }
    return void 0;
}
function $93572b6dc627bc21$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}






function $426ec8f1635c7643$export$dc236a86065879fc() {
    if ($426ec8f1635c7643$var$_isEmbeddedBrowserExtension()) {
        if (0, $2972797b2fabef14$export$16a28057038b10ef) (0, $fc0ca994ab4632cd$export$cda52e2a8927a2ca)(()=>{
            console.error("[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return true;
    }
    return false;
}
function $426ec8f1635c7643$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).window === "undefined") return false;
    const _window = (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81);
    if (_window.nw) return false;
    const extensionObject = _window["chrome"] || _window["browser"];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $af60478d30a53662$export$1cfafeee2987818b)();
    const isDedicatedExtensionPage = (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81) === (0, $aec2a0b3eeccf6ea$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


function $339c970efe92f91e$export$5783b2920b1d62b9(_options) {
    return [
        (0, $6ea27b6ce1465afc$export$9a84f518c163c552)(),
        (0, $fa0087c0bbbdfdd7$export$7918117e9202e4fb)(),
        (0, $2a4e0e692d2cde1b$export$97457a453081a5b3)(),
        (0, $e0c3f6c99707ea26$export$59bfe9f1c76150e)(),
        (0, $19aa2e0368e59496$export$c079d904b326663a)(),
        (0, $4d30674a292df795$export$d79e728262dba9d2)(),
        (0, $c10e7899fa4749e3$export$66acc70e8cf2b71a)(),
        (0, $c8e2f88a417dbbd0$export$ebabb00eb7f3a395)(),
        (0, $887e0571fdd7fb58$export$6d39aa44cd0c7567)(),
        (0, $9fb8881afa927e5f$export$1378794447170364)(),
        (0, $5b2665e3ca77cefa$export$ec5976aacdc85985)(),
        (0, $2156d656bc5cf961$export$1baa7880e357371c)()
    ];
}
function $339c970efe92f91e$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $426ec8f1635c7643$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $339c970efe92f91e$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const integrations = (0, $44faf1ffd3373da7$export$68bc4c01ab8ae766)({
        integrations: options.integrations,
        defaultIntegrations: defaultIntegrations
    });
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $3a6ba34e83b7a312$export$1d5cf88b347146d4)(options.stackParser || (0, $2ae28e417f20fe75$export$2b2b997d81bf3907)),
        integrations: integrations,
        transport: options.transport || (0, $a10505d7dc0cec1e$export$b2311068c46d7cc8)
    };
    (0, $fce87edf3ea2bc99$export$575c40989754ba4d)((0, $93572b6dc627bc21$export$4c88c355e6072df5));
    return (0, $ea5a1e95298af243$export$5333c3f1c58d9bc1)((0, $bb5a332145f5b7ca$export$1df9218a526d318d), clientOptions);
}
function $339c970efe92f91e$export$a3f323d81eede727() {}
function $339c970efe92f91e$export$4e4d8b287d028b6b(callback) {
    callback();
}


$339c970efe92f91e$export$2cd8252107eb640b({
    dsn: "https://c601338ddab3402dbdaf443fae295af4@gt.kubikill.dev/1",
    tracesSampleRate: 0.01
});


//# sourceMappingURL=repo.0df2f9a6.js.map
